import React from "react";

import { Svg } from "./svg";

export const BigQuery = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="BigQuery">
        <circle fill="#E6F3FF" cx="20" cy="20" r="20"></circle>
        <g transform="translate(8.000000, 9.000000)" fillRule="nonzero">
          <path
            d="M5.43,20.6985 L0.20925,11.65575 C-0.06975,11.17275 -0.06975,10.57725 0.20925,10.09425 L5.43,1.051875 C5.708625,0.56925 6.223125,0.271875 6.78,0.271125 L17.226375,0.271125 C17.781375,0.27375 18.29325,0.571125 18.57075,1.051875 L23.79075,10.09425 C24.06975,10.57725 24.06975,11.17275 23.79075,11.65575 L18.57,20.6985 C18.291375,21.181125 17.776875,21.4785 17.22,21.47925 L6.77625,21.47925 C6.220125,21.477375 5.7075,21.18 5.428875,20.6985 L5.43,20.6985 Z"
            fill="#4386FA"
          ></path>
          <path
            d="M15.261375,7.963125 C15.261375,7.963125 16.712625,11.44425 14.734125,13.4175 C12.755625,15.39075 9.153,14.12775 9.153,14.12775 L16.48125,21.47625 L17.22525,21.47625 C17.7825,21.4755 18.297,21.17775 18.57525,20.6955 L22.03125,14.71125 L15.261375,7.963125 Z"
            fill="#000000"
            opacity="0.1"
          ></path>
          <path
            d="M16.975125,15.08625 L15.375,13.482375 C15.3575927,13.4645177 15.3376238,13.4493514 15.31575,13.437375 C16.728471,11.6176812 16.4822814,9.01306993 14.7536286,7.49030087 C13.0249758,5.9675318 10.4101143,6.0518452 8.78315037,7.68281253 C7.1561864,9.31377986 7.07829955,11.9288406 8.60531235,13.6537459 C10.1323252,15.3786511 12.7375336,15.6184388 14.55375,14.20125 C14.5651641,14.2218964 14.5794292,14.2408324 14.596125,14.2575 L16.2,15.861375 C16.2980967,15.9593635 16.4570283,15.9593635 16.555125,15.861375 L16.975125,15.441375 C17.0731135,15.3432783 17.0731135,15.1843467 16.975125,15.08625 L16.975125,15.08625 Z M11.865,14.049 C10.53779,14.0491517 9.3411884,13.2497564 8.83321706,12.0236032 C8.32524572,10.7974501 8.60595171,9.38603508 9.5444309,8.4475559 C10.4829101,7.50907671 11.8943251,7.22837072 13.1204782,7.73634206 C14.3466314,8.2443134 15.1460267,9.44091502 15.145875,10.768125 C15.1456679,12.5800165 13.6768915,14.0487929 11.865,14.049 L11.865,14.049 Z M9.767625,10.593 L9.767625,11.949 C9.9765,12.317625 10.27875,12.625125 10.644375,12.839625 L10.644375,10.58475 L9.767625,10.593 Z M11.40825,9.46875 L11.40825,13.13325 C11.6980598,13.1866597 11.9951902,13.1866597 12.285,13.13325 L12.285,9.46875 L11.40825,9.46875 Z M13.94475,11.946 L13.94475,11.14275 L13.06875,11.14275 L13.06875,12.83025 C13.4338581,12.6163123 13.7362345,12.310056 13.9455,11.94225 L13.94475,11.946 Z"
            fill="#FFFFFF"
          ></path>
        </g>
      </g>
    </g>
  </Svg>
);

export const Campfire = ({ ...props }) => (
  <Svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="30" cy="30" r="30" fill="#F7F7F7" />
    <path
      d="M32.404 33.1295L40.7686 24.5696L42.3299 26.1674L33.9528 34.7403H46V37H31.3L34.9802 36.9999C34.1498 36.9999 33.5734 36.5186 33.0154 36.0527C32.4921 35.6157 31.985 35.1922 31.3 35.1922C30.615 35.1922 30.1079 35.6157 29.5846 36.0527C29.0266 36.5186 28.4502 37 27.6198 37H31.3H17V34.7403H28.6472L20.27 26.1674L21.8314 24.5696L30.196 33.1295V21H32.404V33.1295Z"
      fill="#FF862F"
    />
  </Svg>
);

export const Chargebee = ({ ...props }) => (
  <Svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="30" cy="30" r="30" fill="#F5F5F5" />
    <path d="M23.7839 30.0021L47.5635 24.331V12H35.2325L23.7839 30.0021Z" fill="#FF3300" />
    <path
      d="M12 29.7862C12 31.2613 12.1798 32.6933 12.5195 34.0652L23.7849 30.0026L12.4263 25.9033C12.1498 27.1521 12 28.4508 12 29.7829V29.7862Z"
      fill="#FF3300"
    />
    <path
      d="M16.1893 18.3206L23.7818 30.0023L27.2816 12.1768C22.8494 12.7995 18.9432 15.0573 16.1893 18.3206Z"
      fill="#FF3300"
    />
    <path d="M23.7839 30.0015L47.5635 35.6691V48.0001H35.2325L23.7839 30.0015Z" fill="#FF3300" />
    <path
      d="M16.1889 41.6812L23.7813 29.9995L27.2778 47.8218C22.8456 47.199 18.9394 44.9413 16.1855 41.6779L16.1889 41.6812Z"
      fill="#FF3300"
    />
  </Svg>
);

export const Chargify = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g id="Icon/Chargify" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#E6F3FF" x="0" y="0" width="40" height="40" rx="20"></rect>
      <g id="Group" transform="translate(13.000000, 6.000000)">
        <path
          d="M11.7473751,12.638089 C12.3261665,12.638089 12.7908644,12.1733912 12.7908644,11.5945997 L12.7908644,0.613499019 C12.7908644,0.173264285 12.2609992,-0.144654827 11.8696907,0.0672912477 L0.921173672,6.0103079 C0.350502776,6.31198593 -6.62137012e-13,6.90711996 -6.62137012e-13,7.55107872 L-6.62137012e-13,12.6706727 C-6.62137012e-13,13.1353705 0.505402062,12.7195989 0.904831086,12.4914118 L6.32610309,9.00221908 C6.61955908,8.83919926 6.98650595,8.93695025 7.14952577,9.2222857 C7.19845202,9.31191615 7.23103569,9.41799069 7.23103569,9.52396373 L7.23103569,11.5945997 C7.23103569,12.1733912 7.69563204,12.638089 8.27452498,12.638089 L11.7473751,12.638089 Z"
          id="Fill-1"
          fill="#2CA760"
        ></path>
        <path
          d="M1.05159968,13.3392164 C0.472808247,13.3392164 0.00811038859,13.8039142 0.00811038859,14.3827057 L0.00811038859,25.3556859 C0.00811038859,25.7959206 0.537975575,26.1138397 0.92928406,25.9018936 L11.8778011,19.958877 C12.44025,19.6490784 12.7908542,19.0620649 12.7989748,18.4181062 L12.7989748,14.643578 C12.7908542,13.3147533 12.2283039,13.5022362 11.8207543,13.7386454 L6.47287169,16.9750863 C6.1794157,17.1381062 5.81246883,17.0403552 5.64944901,16.7550197 C5.60052276,16.6653893 5.5679391,16.5593147 5.5679391,16.4533417 L5.5679391,14.3827057 C5.5679391,13.8039142 5.10324124,13.3392164 4.5244498,13.3392164 L1.05159968,13.3392164 Z"
          id="Fill-3"
          fill="#0077FF"
        ></path>
      </g>
    </g>
  </Svg>
);

export const CoefficientIcon = ({
  fill = "#3053FF",
  ...props
}: { fill?: string } & React.SVGProps<SVGSVGElement>) => (
  <svg width="26" height="30" viewBox="-1 0 27 30" fill="none" {...props}>
    <path
      d="M23.9126 6.15989C23.5544 5.85356 23.2286 5.56506 22.8915 5.28791C21.0487 3.77409 18.9433 2.86483 16.5769 2.56984C13.8443 2.22948 11.2445 2.68168 8.85548 4.05449C5.50855 5.97998 3.39504 8.84392 2.64137 12.6512C2.11948 15.2898 2.41608 17.8588 3.5636 20.2916C4.9591 23.2527 7.17958 25.3873 10.2137 26.6548C12.4909 27.6046 14.8556 27.8217 17.2641 27.3874C19.6532 26.9562 21.7472 25.8849 23.5285 24.222C23.8818 23.893 23.8834 23.8962 24.2222 24.2285C24.6695 24.6677 25.1169 25.1053 25.6323 25.6094C24.971 26.1572 24.3826 26.705 23.7343 27.1686C20.9693 29.1443 17.8768 30.0876 14.478 29.9936C7.47457 29.7991 1.51168 24.6563 0.247464 17.7275C-0.938955 11.22 2.21348 4.6558 8.14071 1.72055C13.4601 -0.913235 18.671 -0.503175 23.6176 2.81296C24.206 3.20681 24.723 3.70764 25.2789 4.15011C25.5318 4.35109 25.5853 4.50831 25.3081 4.75953C24.8284 5.19714 24.3875 5.67852 23.9126 6.15827V6.15989Z"
      fill={fill}
    />
    <path
      d="M22.7004 11.9447C22.2806 11.2705 21.9354 10.6173 21.501 10.0322C18.9952 6.65287 14.1961 5.74685 10.6044 7.95274C7.55571 9.82475 6.00137 13.3905 6.78908 16.8282C7.34987 19.2788 8.72754 21.1476 10.9561 22.3535C13.1361 23.5334 15.402 23.6744 17.7294 22.8608C17.9985 22.7668 18.1087 22.817 18.2027 23.0698C18.4004 23.6031 18.6046 24.1363 18.8397 24.655C18.9645 24.9305 18.8786 25.0245 18.6257 25.1153C16.3874 25.9192 14.1296 26.0132 11.8492 25.3195C9.14246 24.4961 7.02085 22.8883 5.63507 20.4231C3.71606 17.0049 3.60909 13.4732 5.47624 10.0176C7.51357 6.24767 10.7908 4.38538 15.0632 4.34C19.1346 4.29624 23.1672 7.00944 24.7328 10.7697C24.7928 10.9139 24.882 11.0549 24.6567 11.1457C23.9986 11.4115 23.3422 11.6822 22.7036 11.9431L22.7004 11.9447Z"
      fill={fill}
    />
    <path
      d="M17.8769 12.2282C17.2901 11.6982 16.6953 11.3254 15.9919 11.1358C13.525 10.4648 11.0128 12.3433 10.9707 14.9074C10.9431 16.6173 11.7146 17.8977 13.2333 18.6336C14.7828 19.384 16.2771 19.1636 17.6143 18.0517C17.7391 17.948 17.8331 17.8313 17.9984 17.9999C18.496 18.5055 19.0017 19.0031 19.5349 19.5347C19.4215 19.6547 19.3372 19.7665 19.2318 19.8524C17.3274 21.4278 15.1782 21.906 12.8427 21.081C10.525 20.2625 9.09218 18.5866 8.66105 16.1505C8.01111 12.4746 10.4893 9.12927 14.1685 8.66086C16.0907 8.41612 17.7747 8.97206 19.2497 10.2136C19.496 10.421 19.5268 10.5539 19.274 10.7938C18.7926 11.246 18.3485 11.7387 17.8769 12.2298V12.2282Z"
      fill={fill}
    />
    <path
      d="M15.017 17.2081C16.1746 17.2081 17.113 16.2697 17.113 15.1121C17.113 13.9545 16.1746 13.0161 15.017 13.0161C13.8594 13.0161 12.921 13.9545 12.921 15.1121C12.921 16.2697 13.8594 17.2081 15.017 17.2081Z"
      fill={fill}
    />
  </svg>
);

export const CoeLogo = ({ ...props }) => (
  <Svg width="141" height="38" viewBox="0 0 120 30" style={{ fill: "none" }} {...props}>
    <g clipPath="url(#clip0_205_3613)">
      <path
        d="M23.9126 6.15989C23.5544 5.85356 23.2286 5.56506 22.8915 5.28791C21.0487 3.77409 18.9433 2.86483 16.5769 2.56984C13.8443 2.22948 11.2445 2.68168 8.85548 4.05449C5.50855 5.97998 3.39504 8.84392 2.64137 12.6512C2.11948 15.2898 2.41608 17.8588 3.5636 20.2916C4.9591 23.2527 7.17958 25.3873 10.2137 26.6548C12.4909 27.6046 14.8556 27.8217 17.2641 27.3874C19.6532 26.9562 21.7472 25.8849 23.5285 24.222C23.8818 23.893 23.8834 23.8962 24.2222 24.2285C24.6695 24.6677 25.1169 25.1053 25.6323 25.6094C24.971 26.1572 24.3826 26.705 23.7343 27.1686C20.9693 29.1443 17.8768 30.0876 14.478 29.9936C7.47457 29.7991 1.51168 24.6563 0.247464 17.7275C-0.938955 11.22 2.21348 4.6558 8.14071 1.72055C13.4601 -0.913235 18.671 -0.503175 23.6176 2.81296C24.206 3.20681 24.723 3.70764 25.2789 4.15011C25.5318 4.35109 25.5853 4.50831 25.3081 4.75953C24.8284 5.19714 24.3875 5.67852 23.9126 6.15827V6.15989Z"
        fill="#3053FF"
      />
      <path
        d="M22.7004 11.9447C22.2806 11.2705 21.9354 10.6173 21.501 10.0322C18.9952 6.65287 14.1961 5.74685 10.6044 7.95274C7.55571 9.82475 6.00137 13.3905 6.78908 16.8282C7.34987 19.2788 8.72754 21.1476 10.9561 22.3535C13.1361 23.5334 15.402 23.6744 17.7294 22.8608C17.9985 22.7668 18.1087 22.817 18.2027 23.0698C18.4004 23.6031 18.6046 24.1363 18.8397 24.655C18.9645 24.9305 18.8786 25.0245 18.6257 25.1153C16.3874 25.9192 14.1296 26.0132 11.8492 25.3195C9.14246 24.4961 7.02085 22.8883 5.63507 20.4231C3.71606 17.0049 3.60909 13.4732 5.47624 10.0176C7.51357 6.24767 10.7908 4.38538 15.0632 4.34C19.1346 4.29624 23.1672 7.00944 24.7328 10.7697C24.7928 10.9139 24.882 11.0549 24.6567 11.1457C23.9986 11.4115 23.3422 11.6822 22.7036 11.9431L22.7004 11.9447Z"
        fill="#3053FF"
      />
      <path
        d="M17.8769 12.2282C17.2901 11.6982 16.6953 11.3254 15.9919 11.1358C13.525 10.4648 11.0128 12.3433 10.9707 14.9074C10.9431 16.6173 11.7146 17.8977 13.2333 18.6336C14.7828 19.384 16.2771 19.1636 17.6143 18.0517C17.7391 17.948 17.8331 17.8313 17.9984 17.9999C18.496 18.5055 19.0017 19.0031 19.5349 19.5347C19.4215 19.6547 19.3372 19.7665 19.2318 19.8524C17.3274 21.4278 15.1782 21.906 12.8427 21.081C10.525 20.2625 9.09218 18.5866 8.66105 16.1505C8.01111 12.4746 10.4893 9.12927 14.1685 8.66086C16.0907 8.41612 17.7747 8.97206 19.2497 10.2136C19.496 10.421 19.5268 10.5539 19.274 10.7938C18.7926 11.246 18.3485 11.7387 17.8769 12.2298V12.2282Z"
        fill="#3053FF"
      />
      <path
        d="M15.017 17.2081C16.1746 17.2081 17.113 16.2697 17.113 15.1121C17.113 13.9545 16.1746 13.0161 15.017 13.0161C13.8594 13.0161 12.921 13.9545 12.921 15.1121C12.921 16.2697 13.8594 17.2081 15.017 17.2081Z"
        fill="#3053FF"
      />
      <path
        d="M36.3756 21.3794C34.5738 21.3794 33.0607 20.7753 31.8364 19.5671C30.6121 18.347 30 16.7716 30 14.8407C30 12.9218 30.6179 11.3463 31.8538 10.1144C33.0896 8.87064 34.5853 8.24875 36.3409 8.24875C37.2187 8.24875 38.0099 8.38498 38.7145 8.65742C39.4306 8.91802 40.0081 9.26746 40.447 9.70575C40.8859 10.144 41.2381 10.5942 41.5038 11.0561C41.7694 11.5181 41.9542 11.9978 42.0582 12.4953L39.4768 13.3305C39.419 13.0817 39.3266 12.8389 39.1996 12.602C39.0725 12.3532 38.8935 12.1044 38.6625 11.8557C38.4315 11.5951 38.1139 11.3878 37.7096 11.2338C37.3054 11.068 36.8491 10.9851 36.3409 10.9851C35.4169 10.9851 34.6027 11.3226 33.8981 11.9978C33.1936 12.6612 32.8413 13.6088 32.8413 14.8407C32.8413 15.9779 33.1878 16.8841 33.8808 17.5593C34.5738 18.2345 35.4054 18.5721 36.3756 18.5721C37.3227 18.5721 38.0561 18.3292 38.5759 17.8436C39.0956 17.3579 39.4363 16.813 39.598 16.2089L42.2141 16.9729C42.0986 17.4586 41.908 17.9383 41.6424 18.4121C41.3883 18.886 41.036 19.3539 40.5856 19.8158C40.1467 20.2778 39.5576 20.6569 38.8184 20.953C38.0908 21.2373 37.2765 21.3794 36.3756 21.3794Z"
        fill="#111215"
      />
      <path
        d="M47.5993 18.8919C48.1422 18.8919 48.5984 18.7024 48.968 18.3233C49.3492 17.9443 49.5397 17.3994 49.5397 16.6886C49.5397 15.9779 49.3492 15.4389 48.968 15.0717C48.5984 14.6927 48.1422 14.5032 47.5993 14.5032C47.068 14.5032 46.6118 14.6927 46.2307 15.0717C45.8495 15.4508 45.6589 15.9898 45.6589 16.6886C45.6589 17.3875 45.8495 17.9324 46.2307 18.3233C46.6118 18.7024 47.068 18.8919 47.5993 18.8919ZM47.5993 12.0156C48.9045 12.0156 49.9902 12.4539 50.8564 13.3305C51.7342 14.207 52.1731 15.3264 52.1731 16.6886C52.1731 18.0509 51.7342 19.1762 50.8564 20.0646C49.9902 20.9412 48.9045 21.3794 47.5993 21.3794C46.3057 21.3794 45.22 20.9352 44.3422 20.0468C43.4644 19.1584 43.0255 18.039 43.0255 16.6886C43.0255 15.3383 43.4644 14.2248 44.3422 13.3482C45.22 12.4598 46.3057 12.0156 47.5993 12.0156Z"
        fill="#111215"
      />
      <path
        d="M55.8606 15.6403H59.3083C59.2852 15.2376 59.1293 14.8881 58.8405 14.592C58.5633 14.2959 58.1418 14.1478 57.5758 14.1478C57.0676 14.1478 56.6634 14.3018 56.3631 14.6098C56.0628 14.9177 55.8953 15.2613 55.8606 15.6403ZM59.4989 17.9324L61.6992 18.5721C61.4797 19.3894 61.0235 20.0646 60.3305 20.5976C59.6375 21.1188 58.7712 21.3794 57.7317 21.3794C56.4843 21.3794 55.4217 20.953 54.5439 20.1001C53.6777 19.2473 53.2446 18.1042 53.2446 16.6709C53.2446 15.2968 53.6661 14.1774 54.5093 13.3127C55.364 12.448 56.3746 12.0156 57.5412 12.0156C58.881 12.0156 59.932 12.4184 60.6943 13.2238C61.4682 14.0175 61.8551 15.125 61.8551 16.5465C61.8551 16.9966 61.8378 17.275 61.8031 17.3816H55.8087C55.8318 17.8673 56.0339 18.2759 56.415 18.6076C56.7962 18.9274 57.2466 19.0873 57.7664 19.0873C58.6557 19.0873 59.2332 18.7024 59.4989 17.9324Z"
        fill="#111215"
      />
      <path
        d="M67.2361 8.10661C67.7905 8.10661 68.2063 8.17768 68.4835 8.31983V10.5053C68.2525 10.4461 67.9926 10.4165 67.7039 10.4165C66.9531 10.4165 66.5778 10.7837 66.5778 11.5181V12.2821H69.6096V11.5181C69.6096 10.4875 69.8984 9.66429 70.4759 9.04832C71.0534 8.42051 71.8561 8.10661 72.884 8.10661C73.4731 8.10661 73.8947 8.17176 74.1488 8.30206V10.5053C73.9178 10.4461 73.6579 10.4165 73.3691 10.4165C73.0688 10.4165 72.8032 10.4994 72.5722 10.6652C72.3527 10.8311 72.243 11.1154 72.243 11.5181V12.2821H78.1162V21.1129H75.4655V14.5565H72.243V21.1129H69.6096V14.5565H66.5778V21.1129H63.9444V14.5565H62.5757V12.2821H63.9444V11.5181C63.9444 10.4875 64.2331 9.66429 64.8106 9.04832C65.3997 8.42051 66.2082 8.10661 67.2361 8.10661ZM75.6907 10.7008C75.3904 10.3928 75.2402 10.0196 75.2402 9.58137C75.2402 9.14309 75.3904 8.76995 75.6907 8.46197C75.991 8.15399 76.3548 8 76.7822 8C77.2095 8 77.5733 8.15399 77.8736 8.46197C78.1739 8.76995 78.3241 9.14309 78.3241 9.58137C78.3241 10.0196 78.1739 10.3928 77.8736 10.7008C77.5733 11.0087 77.2095 11.1627 76.7822 11.1627C76.3548 11.1627 75.991 11.0087 75.6907 10.7008Z"
        fill="#111215"
      />
      <path
        d="M84.3646 14.5032C83.7986 14.5032 83.3251 14.6986 82.9439 15.0895C82.5743 15.4804 82.3895 16.0194 82.3895 16.7064C82.3895 17.3816 82.5801 17.9146 82.9612 18.3055C83.3539 18.6964 83.8333 18.8919 84.3992 18.8919C84.8727 18.8919 85.2597 18.7675 85.56 18.5188C85.8718 18.2582 86.0797 17.9443 86.1837 17.577L88.5052 18.3055C88.2973 19.1466 87.8295 19.8691 87.1019 20.4733C86.3858 21.0774 85.4849 21.3794 84.3992 21.3794C83.1056 21.3794 82.0084 20.9412 81.1075 20.0646C80.2181 19.1762 79.7734 18.0568 79.7734 16.7064C79.7734 15.3442 80.2066 14.2248 81.0728 13.3482C81.9506 12.4598 83.0305 12.0156 84.3126 12.0156C85.4329 12.0156 86.3511 12.3117 87.0672 12.904C87.7833 13.4963 88.2453 14.2248 88.4532 15.0895L86.097 15.818C85.9931 15.4389 85.7967 15.125 85.508 14.8763C85.2192 14.6275 84.8381 14.5032 84.3646 14.5032Z"
        fill="#111215"
      />
      <path
        d="M92.742 21.1129H90.1086V12.2821H92.742V21.1129ZM90.3338 10.7008C90.0335 10.3928 89.8834 10.0196 89.8834 9.58137C89.8834 9.14309 90.0335 8.76995 90.3338 8.46197C90.6341 8.15399 90.9922 8 91.408 8C91.8353 8 92.1991 8.15399 92.4994 8.46197C92.8113 8.76995 92.9672 9.14309 92.9672 9.58137C92.9672 10.0196 92.8113 10.3928 92.4994 10.7008C92.1991 11.0087 91.8353 11.1627 91.408 11.1627C90.9922 11.1627 90.6341 11.0087 90.3338 10.7008Z"
        fill="#111215"
      />
      <path
        d="M97.0413 15.6403H100.489C100.466 15.2376 100.31 14.8881 100.021 14.592C99.744 14.2959 99.3224 14.1478 98.7565 14.1478C98.2483 14.1478 97.844 14.3018 97.5437 14.6098C97.2434 14.9177 97.0759 15.2613 97.0413 15.6403ZM100.68 17.9324L102.88 18.5721C102.66 19.3894 102.204 20.0646 101.511 20.5976C100.818 21.1188 99.9519 21.3794 98.9124 21.3794C97.665 21.3794 96.6024 20.953 95.7246 20.1001C94.8583 19.2473 94.4252 18.1042 94.4252 16.6709C94.4252 15.2968 94.8468 14.1774 95.6899 13.3127C96.5446 12.448 97.5553 12.0156 98.7218 12.0156C100.062 12.0156 101.113 12.4184 101.875 13.2238C102.649 14.0175 103.036 15.125 103.036 16.5465C103.036 16.9966 103.018 17.275 102.984 17.3816H96.9893C97.0124 17.8673 97.2145 18.2759 97.5957 18.6076C97.9768 18.9274 98.4273 19.0873 98.947 19.0873C99.8364 19.0873 100.414 18.7024 100.68 17.9324Z"
        fill="#111215"
      />
      <path
        d="M107.36 16.049V21.1129H104.727V12.2821H107.273V13.2949C107.493 12.904 107.828 12.602 108.278 12.3887C108.74 12.1637 109.208 12.0511 109.681 12.0511C110.709 12.0511 111.489 12.3828 112.02 13.0462C112.552 13.6977 112.817 14.5387 112.817 15.5692V21.1129H110.184V16.0312C110.184 15.5692 110.063 15.202 109.82 14.9296C109.589 14.6453 109.243 14.5032 108.781 14.5032C108.353 14.5032 108.007 14.6512 107.741 14.9474C107.487 15.2316 107.36 15.5989 107.36 16.049Z"
        fill="#111215"
      />
      <path
        d="M118.183 9.70575V12.2821H119.864V14.6453H118.183V17.9502C118.183 18.5661 118.501 18.8741 119.136 18.8741C119.344 18.8741 119.575 18.8445 119.829 18.7853V21.0241C119.506 21.1899 119.05 21.2728 118.461 21.2728C117.571 21.2728 116.867 21.0181 116.347 20.5088C115.839 19.9994 115.585 19.3065 115.585 18.4299V14.6453H114.06V12.2821H114.493C114.932 12.2821 115.261 12.1518 115.481 11.8912C115.712 11.6188 115.827 11.2693 115.827 10.8429V9.70575H118.183Z"
        fill="#111215"
      />
    </g>
    <defs>
      <clipPath id="clip0_205_3613">
        <rect width="120" height="30" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);

export const CoeLogoWhiteText = ({ ...props }) => (
  <Svg width="141" height="38" viewBox="0 0 120 30" style={{ fill: "none" }} {...props}>
    <g clipPath="url(#clip0_205_3613)">
      <path
        d="M23.9126 6.15989C23.5544 5.85356 23.2286 5.56506 22.8915 5.28791C21.0487 3.77409 18.9433 2.86483 16.5769 2.56984C13.8443 2.22948 11.2445 2.68168 8.85548 4.05449C5.50855 5.97998 3.39504 8.84392 2.64137 12.6512C2.11948 15.2898 2.41608 17.8588 3.5636 20.2916C4.9591 23.2527 7.17958 25.3873 10.2137 26.6548C12.4909 27.6046 14.8556 27.8217 17.2641 27.3874C19.6532 26.9562 21.7472 25.8849 23.5285 24.222C23.8818 23.893 23.8834 23.8962 24.2222 24.2285C24.6695 24.6677 25.1169 25.1053 25.6323 25.6094C24.971 26.1572 24.3826 26.705 23.7343 27.1686C20.9693 29.1443 17.8768 30.0876 14.478 29.9936C7.47457 29.7991 1.51168 24.6563 0.247464 17.7275C-0.938955 11.22 2.21348 4.6558 8.14071 1.72055C13.4601 -0.913235 18.671 -0.503175 23.6176 2.81296C24.206 3.20681 24.723 3.70764 25.2789 4.15011C25.5318 4.35109 25.5853 4.50831 25.3081 4.75953C24.8284 5.19714 24.3875 5.67852 23.9126 6.15827V6.15989Z"
        fill="#3053FF"
      />
      <path
        d="M22.7004 11.9447C22.2806 11.2705 21.9354 10.6173 21.501 10.0322C18.9952 6.65287 14.1961 5.74685 10.6044 7.95274C7.55571 9.82475 6.00137 13.3905 6.78908 16.8282C7.34987 19.2788 8.72754 21.1476 10.9561 22.3535C13.1361 23.5334 15.402 23.6744 17.7294 22.8608C17.9985 22.7668 18.1087 22.817 18.2027 23.0698C18.4004 23.6031 18.6046 24.1363 18.8397 24.655C18.9645 24.9305 18.8786 25.0245 18.6257 25.1153C16.3874 25.9192 14.1296 26.0132 11.8492 25.3195C9.14246 24.4961 7.02085 22.8883 5.63507 20.4231C3.71606 17.0049 3.60909 13.4732 5.47624 10.0176C7.51357 6.24767 10.7908 4.38538 15.0632 4.34C19.1346 4.29624 23.1672 7.00944 24.7328 10.7697C24.7928 10.9139 24.882 11.0549 24.6567 11.1457C23.9986 11.4115 23.3422 11.6822 22.7036 11.9431L22.7004 11.9447Z"
        fill="#3053FF"
      />
      <path
        d="M17.8769 12.2282C17.2901 11.6982 16.6953 11.3254 15.9919 11.1358C13.525 10.4648 11.0128 12.3433 10.9707 14.9074C10.9431 16.6173 11.7146 17.8977 13.2333 18.6336C14.7828 19.384 16.2771 19.1636 17.6143 18.0517C17.7391 17.948 17.8331 17.8313 17.9984 17.9999C18.496 18.5055 19.0017 19.0031 19.5349 19.5347C19.4215 19.6547 19.3372 19.7665 19.2318 19.8524C17.3274 21.4278 15.1782 21.906 12.8427 21.081C10.525 20.2625 9.09218 18.5866 8.66105 16.1505C8.01111 12.4746 10.4893 9.12927 14.1685 8.66086C16.0907 8.41612 17.7747 8.97206 19.2497 10.2136C19.496 10.421 19.5268 10.5539 19.274 10.7938C18.7926 11.246 18.3485 11.7387 17.8769 12.2298V12.2282Z"
        fill="#3053FF"
      />
      <path
        d="M15.017 17.2081C16.1746 17.2081 17.113 16.2697 17.113 15.1121C17.113 13.9545 16.1746 13.0161 15.017 13.0161C13.8594 13.0161 12.921 13.9545 12.921 15.1121C12.921 16.2697 13.8594 17.2081 15.017 17.2081Z"
        fill="#3053FF"
      />
      <path
        d="M36.3756 21.3794C34.5738 21.3794 33.0607 20.7753 31.8364 19.5671C30.6121 18.347 30 16.7716 30 14.8407C30 12.9218 30.6179 11.3463 31.8538 10.1144C33.0896 8.87064 34.5853 8.24875 36.3409 8.24875C37.2187 8.24875 38.0099 8.38498 38.7145 8.65742C39.4306 8.91802 40.0081 9.26746 40.447 9.70575C40.8859 10.144 41.2381 10.5942 41.5038 11.0561C41.7694 11.5181 41.9542 11.9978 42.0582 12.4953L39.4768 13.3305C39.419 13.0817 39.3266 12.8389 39.1996 12.602C39.0725 12.3532 38.8935 12.1044 38.6625 11.8557C38.4315 11.5951 38.1139 11.3878 37.7096 11.2338C37.3054 11.068 36.8491 10.9851 36.3409 10.9851C35.4169 10.9851 34.6027 11.3226 33.8981 11.9978C33.1936 12.6612 32.8413 13.6088 32.8413 14.8407C32.8413 15.9779 33.1878 16.8841 33.8808 17.5593C34.5738 18.2345 35.4054 18.5721 36.3756 18.5721C37.3227 18.5721 38.0561 18.3292 38.5759 17.8436C39.0956 17.3579 39.4363 16.813 39.598 16.2089L42.2141 16.9729C42.0986 17.4586 41.908 17.9383 41.6424 18.4121C41.3883 18.886 41.036 19.3539 40.5856 19.8158C40.1467 20.2778 39.5576 20.6569 38.8184 20.953C38.0908 21.2373 37.2765 21.3794 36.3756 21.3794Z"
        fill="#FFFFFF"
      />
      <path
        d="M47.5993 18.8919C48.1422 18.8919 48.5984 18.7024 48.968 18.3233C49.3492 17.9443 49.5397 17.3994 49.5397 16.6886C49.5397 15.9779 49.3492 15.4389 48.968 15.0717C48.5984 14.6927 48.1422 14.5032 47.5993 14.5032C47.068 14.5032 46.6118 14.6927 46.2307 15.0717C45.8495 15.4508 45.6589 15.9898 45.6589 16.6886C45.6589 17.3875 45.8495 17.9324 46.2307 18.3233C46.6118 18.7024 47.068 18.8919 47.5993 18.8919ZM47.5993 12.0156C48.9045 12.0156 49.9902 12.4539 50.8564 13.3305C51.7342 14.207 52.1731 15.3264 52.1731 16.6886C52.1731 18.0509 51.7342 19.1762 50.8564 20.0646C49.9902 20.9412 48.9045 21.3794 47.5993 21.3794C46.3057 21.3794 45.22 20.9352 44.3422 20.0468C43.4644 19.1584 43.0255 18.039 43.0255 16.6886C43.0255 15.3383 43.4644 14.2248 44.3422 13.3482C45.22 12.4598 46.3057 12.0156 47.5993 12.0156Z"
        fill="#FFFFFF"
      />
      <path
        d="M55.8606 15.6403H59.3083C59.2852 15.2376 59.1293 14.8881 58.8405 14.592C58.5633 14.2959 58.1418 14.1478 57.5758 14.1478C57.0676 14.1478 56.6634 14.3018 56.3631 14.6098C56.0628 14.9177 55.8953 15.2613 55.8606 15.6403ZM59.4989 17.9324L61.6992 18.5721C61.4797 19.3894 61.0235 20.0646 60.3305 20.5976C59.6375 21.1188 58.7712 21.3794 57.7317 21.3794C56.4843 21.3794 55.4217 20.953 54.5439 20.1001C53.6777 19.2473 53.2446 18.1042 53.2446 16.6709C53.2446 15.2968 53.6661 14.1774 54.5093 13.3127C55.364 12.448 56.3746 12.0156 57.5412 12.0156C58.881 12.0156 59.932 12.4184 60.6943 13.2238C61.4682 14.0175 61.8551 15.125 61.8551 16.5465C61.8551 16.9966 61.8378 17.275 61.8031 17.3816H55.8087C55.8318 17.8673 56.0339 18.2759 56.415 18.6076C56.7962 18.9274 57.2466 19.0873 57.7664 19.0873C58.6557 19.0873 59.2332 18.7024 59.4989 17.9324Z"
        fill="#FFFFFF"
      />
      <path
        d="M67.2361 8.10661C67.7905 8.10661 68.2063 8.17768 68.4835 8.31983V10.5053C68.2525 10.4461 67.9926 10.4165 67.7039 10.4165C66.9531 10.4165 66.5778 10.7837 66.5778 11.5181V12.2821H69.6096V11.5181C69.6096 10.4875 69.8984 9.66429 70.4759 9.04832C71.0534 8.42051 71.8561 8.10661 72.884 8.10661C73.4731 8.10661 73.8947 8.17176 74.1488 8.30206V10.5053C73.9178 10.4461 73.6579 10.4165 73.3691 10.4165C73.0688 10.4165 72.8032 10.4994 72.5722 10.6652C72.3527 10.8311 72.243 11.1154 72.243 11.5181V12.2821H78.1162V21.1129H75.4655V14.5565H72.243V21.1129H69.6096V14.5565H66.5778V21.1129H63.9444V14.5565H62.5757V12.2821H63.9444V11.5181C63.9444 10.4875 64.2331 9.66429 64.8106 9.04832C65.3997 8.42051 66.2082 8.10661 67.2361 8.10661ZM75.6907 10.7008C75.3904 10.3928 75.2402 10.0196 75.2402 9.58137C75.2402 9.14309 75.3904 8.76995 75.6907 8.46197C75.991 8.15399 76.3548 8 76.7822 8C77.2095 8 77.5733 8.15399 77.8736 8.46197C78.1739 8.76995 78.3241 9.14309 78.3241 9.58137C78.3241 10.0196 78.1739 10.3928 77.8736 10.7008C77.5733 11.0087 77.2095 11.1627 76.7822 11.1627C76.3548 11.1627 75.991 11.0087 75.6907 10.7008Z"
        fill="#FFFFFF"
      />
      <path
        d="M84.3646 14.5032C83.7986 14.5032 83.3251 14.6986 82.9439 15.0895C82.5743 15.4804 82.3895 16.0194 82.3895 16.7064C82.3895 17.3816 82.5801 17.9146 82.9612 18.3055C83.3539 18.6964 83.8333 18.8919 84.3992 18.8919C84.8727 18.8919 85.2597 18.7675 85.56 18.5188C85.8718 18.2582 86.0797 17.9443 86.1837 17.577L88.5052 18.3055C88.2973 19.1466 87.8295 19.8691 87.1019 20.4733C86.3858 21.0774 85.4849 21.3794 84.3992 21.3794C83.1056 21.3794 82.0084 20.9412 81.1075 20.0646C80.2181 19.1762 79.7734 18.0568 79.7734 16.7064C79.7734 15.3442 80.2066 14.2248 81.0728 13.3482C81.9506 12.4598 83.0305 12.0156 84.3126 12.0156C85.4329 12.0156 86.3511 12.3117 87.0672 12.904C87.7833 13.4963 88.2453 14.2248 88.4532 15.0895L86.097 15.818C85.9931 15.4389 85.7967 15.125 85.508 14.8763C85.2192 14.6275 84.8381 14.5032 84.3646 14.5032Z"
        fill="#FFFFFF"
      />
      <path
        d="M92.742 21.1129H90.1086V12.2821H92.742V21.1129ZM90.3338 10.7008C90.0335 10.3928 89.8834 10.0196 89.8834 9.58137C89.8834 9.14309 90.0335 8.76995 90.3338 8.46197C90.6341 8.15399 90.9922 8 91.408 8C91.8353 8 92.1991 8.15399 92.4994 8.46197C92.8113 8.76995 92.9672 9.14309 92.9672 9.58137C92.9672 10.0196 92.8113 10.3928 92.4994 10.7008C92.1991 11.0087 91.8353 11.1627 91.408 11.1627C90.9922 11.1627 90.6341 11.0087 90.3338 10.7008Z"
        fill="#FFFFFF"
      />
      <path
        d="M97.0413 15.6403H100.489C100.466 15.2376 100.31 14.8881 100.021 14.592C99.744 14.2959 99.3224 14.1478 98.7565 14.1478C98.2483 14.1478 97.844 14.3018 97.5437 14.6098C97.2434 14.9177 97.0759 15.2613 97.0413 15.6403ZM100.68 17.9324L102.88 18.5721C102.66 19.3894 102.204 20.0646 101.511 20.5976C100.818 21.1188 99.9519 21.3794 98.9124 21.3794C97.665 21.3794 96.6024 20.953 95.7246 20.1001C94.8583 19.2473 94.4252 18.1042 94.4252 16.6709C94.4252 15.2968 94.8468 14.1774 95.6899 13.3127C96.5446 12.448 97.5553 12.0156 98.7218 12.0156C100.062 12.0156 101.113 12.4184 101.875 13.2238C102.649 14.0175 103.036 15.125 103.036 16.5465C103.036 16.9966 103.018 17.275 102.984 17.3816H96.9893C97.0124 17.8673 97.2145 18.2759 97.5957 18.6076C97.9768 18.9274 98.4273 19.0873 98.947 19.0873C99.8364 19.0873 100.414 18.7024 100.68 17.9324Z"
        fill="#FFFFFF"
      />
      <path
        d="M107.36 16.049V21.1129H104.727V12.2821H107.273V13.2949C107.493 12.904 107.828 12.602 108.278 12.3887C108.74 12.1637 109.208 12.0511 109.681 12.0511C110.709 12.0511 111.489 12.3828 112.02 13.0462C112.552 13.6977 112.817 14.5387 112.817 15.5692V21.1129H110.184V16.0312C110.184 15.5692 110.063 15.202 109.82 14.9296C109.589 14.6453 109.243 14.5032 108.781 14.5032C108.353 14.5032 108.007 14.6512 107.741 14.9474C107.487 15.2316 107.36 15.5989 107.36 16.049Z"
        fill="#FFFFFF"
      />
      <path
        d="M118.183 9.70575V12.2821H119.864V14.6453H118.183V17.9502C118.183 18.5661 118.501 18.8741 119.136 18.8741C119.344 18.8741 119.575 18.8445 119.829 18.7853V21.0241C119.506 21.1899 119.05 21.2728 118.461 21.2728C117.571 21.2728 116.867 21.0181 116.347 20.5088C115.839 19.9994 115.585 19.3065 115.585 18.4299V14.6453H114.06V12.2821H114.493C114.932 12.2821 115.261 12.1518 115.481 11.8912C115.712 11.6188 115.827 11.2693 115.827 10.8429V9.70575H118.183Z"
        fill="#FFFFFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_205_3613">
        <rect width="120" height="30" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);

export const CoeLogoWhiteLogoAndText = ({ ...props }) => (
  <Svg width="141" height="38" viewBox="0 0 120 30" style={{ fill: "none" }} {...props}>
    <g clipPath="url(#clip0_205_3613)">
      <path
        d="M23.9126 6.15989C23.5544 5.85356 23.2286 5.56506 22.8915 5.28791C21.0487 3.77409 18.9433 2.86483 16.5769 2.56984C13.8443 2.22948 11.2445 2.68168 8.85548 4.05449C5.50855 5.97998 3.39504 8.84392 2.64137 12.6512C2.11948 15.2898 2.41608 17.8588 3.5636 20.2916C4.9591 23.2527 7.17958 25.3873 10.2137 26.6548C12.4909 27.6046 14.8556 27.8217 17.2641 27.3874C19.6532 26.9562 21.7472 25.8849 23.5285 24.222C23.8818 23.893 23.8834 23.8962 24.2222 24.2285C24.6695 24.6677 25.1169 25.1053 25.6323 25.6094C24.971 26.1572 24.3826 26.705 23.7343 27.1686C20.9693 29.1443 17.8768 30.0876 14.478 29.9936C7.47457 29.7991 1.51168 24.6563 0.247464 17.7275C-0.938955 11.22 2.21348 4.6558 8.14071 1.72055C13.4601 -0.913235 18.671 -0.503175 23.6176 2.81296C24.206 3.20681 24.723 3.70764 25.2789 4.15011C25.5318 4.35109 25.5853 4.50831 25.3081 4.75953C24.8284 5.19714 24.3875 5.67852 23.9126 6.15827V6.15989Z"
        fill="#FFFFFF"
      />
      <path
        d="M22.7004 11.9447C22.2806 11.2705 21.9354 10.6173 21.501 10.0322C18.9952 6.65287 14.1961 5.74685 10.6044 7.95274C7.55571 9.82475 6.00137 13.3905 6.78908 16.8282C7.34987 19.2788 8.72754 21.1476 10.9561 22.3535C13.1361 23.5334 15.402 23.6744 17.7294 22.8608C17.9985 22.7668 18.1087 22.817 18.2027 23.0698C18.4004 23.6031 18.6046 24.1363 18.8397 24.655C18.9645 24.9305 18.8786 25.0245 18.6257 25.1153C16.3874 25.9192 14.1296 26.0132 11.8492 25.3195C9.14246 24.4961 7.02085 22.8883 5.63507 20.4231C3.71606 17.0049 3.60909 13.4732 5.47624 10.0176C7.51357 6.24767 10.7908 4.38538 15.0632 4.34C19.1346 4.29624 23.1672 7.00944 24.7328 10.7697C24.7928 10.9139 24.882 11.0549 24.6567 11.1457C23.9986 11.4115 23.3422 11.6822 22.7036 11.9431L22.7004 11.9447Z"
        fill="#FFFFFF"
      />
      <path
        d="M17.8769 12.2282C17.2901 11.6982 16.6953 11.3254 15.9919 11.1358C13.525 10.4648 11.0128 12.3433 10.9707 14.9074C10.9431 16.6173 11.7146 17.8977 13.2333 18.6336C14.7828 19.384 16.2771 19.1636 17.6143 18.0517C17.7391 17.948 17.8331 17.8313 17.9984 17.9999C18.496 18.5055 19.0017 19.0031 19.5349 19.5347C19.4215 19.6547 19.3372 19.7665 19.2318 19.8524C17.3274 21.4278 15.1782 21.906 12.8427 21.081C10.525 20.2625 9.09218 18.5866 8.66105 16.1505C8.01111 12.4746 10.4893 9.12927 14.1685 8.66086C16.0907 8.41612 17.7747 8.97206 19.2497 10.2136C19.496 10.421 19.5268 10.5539 19.274 10.7938C18.7926 11.246 18.3485 11.7387 17.8769 12.2298V12.2282Z"
        fill="#FFFFFF"
      />
      <path
        d="M15.017 17.2081C16.1746 17.2081 17.113 16.2697 17.113 15.1121C17.113 13.9545 16.1746 13.0161 15.017 13.0161C13.8594 13.0161 12.921 13.9545 12.921 15.1121C12.921 16.2697 13.8594 17.2081 15.017 17.2081Z"
        fill="#FFFFFF"
      />
      <path
        d="M36.3756 21.3794C34.5738 21.3794 33.0607 20.7753 31.8364 19.5671C30.6121 18.347 30 16.7716 30 14.8407C30 12.9218 30.6179 11.3463 31.8538 10.1144C33.0896 8.87064 34.5853 8.24875 36.3409 8.24875C37.2187 8.24875 38.0099 8.38498 38.7145 8.65742C39.4306 8.91802 40.0081 9.26746 40.447 9.70575C40.8859 10.144 41.2381 10.5942 41.5038 11.0561C41.7694 11.5181 41.9542 11.9978 42.0582 12.4953L39.4768 13.3305C39.419 13.0817 39.3266 12.8389 39.1996 12.602C39.0725 12.3532 38.8935 12.1044 38.6625 11.8557C38.4315 11.5951 38.1139 11.3878 37.7096 11.2338C37.3054 11.068 36.8491 10.9851 36.3409 10.9851C35.4169 10.9851 34.6027 11.3226 33.8981 11.9978C33.1936 12.6612 32.8413 13.6088 32.8413 14.8407C32.8413 15.9779 33.1878 16.8841 33.8808 17.5593C34.5738 18.2345 35.4054 18.5721 36.3756 18.5721C37.3227 18.5721 38.0561 18.3292 38.5759 17.8436C39.0956 17.3579 39.4363 16.813 39.598 16.2089L42.2141 16.9729C42.0986 17.4586 41.908 17.9383 41.6424 18.4121C41.3883 18.886 41.036 19.3539 40.5856 19.8158C40.1467 20.2778 39.5576 20.6569 38.8184 20.953C38.0908 21.2373 37.2765 21.3794 36.3756 21.3794Z"
        fill="#FFFFFF"
      />
      <path
        d="M47.5993 18.8919C48.1422 18.8919 48.5984 18.7024 48.968 18.3233C49.3492 17.9443 49.5397 17.3994 49.5397 16.6886C49.5397 15.9779 49.3492 15.4389 48.968 15.0717C48.5984 14.6927 48.1422 14.5032 47.5993 14.5032C47.068 14.5032 46.6118 14.6927 46.2307 15.0717C45.8495 15.4508 45.6589 15.9898 45.6589 16.6886C45.6589 17.3875 45.8495 17.9324 46.2307 18.3233C46.6118 18.7024 47.068 18.8919 47.5993 18.8919ZM47.5993 12.0156C48.9045 12.0156 49.9902 12.4539 50.8564 13.3305C51.7342 14.207 52.1731 15.3264 52.1731 16.6886C52.1731 18.0509 51.7342 19.1762 50.8564 20.0646C49.9902 20.9412 48.9045 21.3794 47.5993 21.3794C46.3057 21.3794 45.22 20.9352 44.3422 20.0468C43.4644 19.1584 43.0255 18.039 43.0255 16.6886C43.0255 15.3383 43.4644 14.2248 44.3422 13.3482C45.22 12.4598 46.3057 12.0156 47.5993 12.0156Z"
        fill="#FFFFFF"
      />
      <path
        d="M55.8606 15.6403H59.3083C59.2852 15.2376 59.1293 14.8881 58.8405 14.592C58.5633 14.2959 58.1418 14.1478 57.5758 14.1478C57.0676 14.1478 56.6634 14.3018 56.3631 14.6098C56.0628 14.9177 55.8953 15.2613 55.8606 15.6403ZM59.4989 17.9324L61.6992 18.5721C61.4797 19.3894 61.0235 20.0646 60.3305 20.5976C59.6375 21.1188 58.7712 21.3794 57.7317 21.3794C56.4843 21.3794 55.4217 20.953 54.5439 20.1001C53.6777 19.2473 53.2446 18.1042 53.2446 16.6709C53.2446 15.2968 53.6661 14.1774 54.5093 13.3127C55.364 12.448 56.3746 12.0156 57.5412 12.0156C58.881 12.0156 59.932 12.4184 60.6943 13.2238C61.4682 14.0175 61.8551 15.125 61.8551 16.5465C61.8551 16.9966 61.8378 17.275 61.8031 17.3816H55.8087C55.8318 17.8673 56.0339 18.2759 56.415 18.6076C56.7962 18.9274 57.2466 19.0873 57.7664 19.0873C58.6557 19.0873 59.2332 18.7024 59.4989 17.9324Z"
        fill="#FFFFFF"
      />
      <path
        d="M67.2361 8.10661C67.7905 8.10661 68.2063 8.17768 68.4835 8.31983V10.5053C68.2525 10.4461 67.9926 10.4165 67.7039 10.4165C66.9531 10.4165 66.5778 10.7837 66.5778 11.5181V12.2821H69.6096V11.5181C69.6096 10.4875 69.8984 9.66429 70.4759 9.04832C71.0534 8.42051 71.8561 8.10661 72.884 8.10661C73.4731 8.10661 73.8947 8.17176 74.1488 8.30206V10.5053C73.9178 10.4461 73.6579 10.4165 73.3691 10.4165C73.0688 10.4165 72.8032 10.4994 72.5722 10.6652C72.3527 10.8311 72.243 11.1154 72.243 11.5181V12.2821H78.1162V21.1129H75.4655V14.5565H72.243V21.1129H69.6096V14.5565H66.5778V21.1129H63.9444V14.5565H62.5757V12.2821H63.9444V11.5181C63.9444 10.4875 64.2331 9.66429 64.8106 9.04832C65.3997 8.42051 66.2082 8.10661 67.2361 8.10661ZM75.6907 10.7008C75.3904 10.3928 75.2402 10.0196 75.2402 9.58137C75.2402 9.14309 75.3904 8.76995 75.6907 8.46197C75.991 8.15399 76.3548 8 76.7822 8C77.2095 8 77.5733 8.15399 77.8736 8.46197C78.1739 8.76995 78.3241 9.14309 78.3241 9.58137C78.3241 10.0196 78.1739 10.3928 77.8736 10.7008C77.5733 11.0087 77.2095 11.1627 76.7822 11.1627C76.3548 11.1627 75.991 11.0087 75.6907 10.7008Z"
        fill="#FFFFFF"
      />
      <path
        d="M84.3646 14.5032C83.7986 14.5032 83.3251 14.6986 82.9439 15.0895C82.5743 15.4804 82.3895 16.0194 82.3895 16.7064C82.3895 17.3816 82.5801 17.9146 82.9612 18.3055C83.3539 18.6964 83.8333 18.8919 84.3992 18.8919C84.8727 18.8919 85.2597 18.7675 85.56 18.5188C85.8718 18.2582 86.0797 17.9443 86.1837 17.577L88.5052 18.3055C88.2973 19.1466 87.8295 19.8691 87.1019 20.4733C86.3858 21.0774 85.4849 21.3794 84.3992 21.3794C83.1056 21.3794 82.0084 20.9412 81.1075 20.0646C80.2181 19.1762 79.7734 18.0568 79.7734 16.7064C79.7734 15.3442 80.2066 14.2248 81.0728 13.3482C81.9506 12.4598 83.0305 12.0156 84.3126 12.0156C85.4329 12.0156 86.3511 12.3117 87.0672 12.904C87.7833 13.4963 88.2453 14.2248 88.4532 15.0895L86.097 15.818C85.9931 15.4389 85.7967 15.125 85.508 14.8763C85.2192 14.6275 84.8381 14.5032 84.3646 14.5032Z"
        fill="#FFFFFF"
      />
      <path
        d="M92.742 21.1129H90.1086V12.2821H92.742V21.1129ZM90.3338 10.7008C90.0335 10.3928 89.8834 10.0196 89.8834 9.58137C89.8834 9.14309 90.0335 8.76995 90.3338 8.46197C90.6341 8.15399 90.9922 8 91.408 8C91.8353 8 92.1991 8.15399 92.4994 8.46197C92.8113 8.76995 92.9672 9.14309 92.9672 9.58137C92.9672 10.0196 92.8113 10.3928 92.4994 10.7008C92.1991 11.0087 91.8353 11.1627 91.408 11.1627C90.9922 11.1627 90.6341 11.0087 90.3338 10.7008Z"
        fill="#FFFFFF"
      />
      <path
        d="M97.0413 15.6403H100.489C100.466 15.2376 100.31 14.8881 100.021 14.592C99.744 14.2959 99.3224 14.1478 98.7565 14.1478C98.2483 14.1478 97.844 14.3018 97.5437 14.6098C97.2434 14.9177 97.0759 15.2613 97.0413 15.6403ZM100.68 17.9324L102.88 18.5721C102.66 19.3894 102.204 20.0646 101.511 20.5976C100.818 21.1188 99.9519 21.3794 98.9124 21.3794C97.665 21.3794 96.6024 20.953 95.7246 20.1001C94.8583 19.2473 94.4252 18.1042 94.4252 16.6709C94.4252 15.2968 94.8468 14.1774 95.6899 13.3127C96.5446 12.448 97.5553 12.0156 98.7218 12.0156C100.062 12.0156 101.113 12.4184 101.875 13.2238C102.649 14.0175 103.036 15.125 103.036 16.5465C103.036 16.9966 103.018 17.275 102.984 17.3816H96.9893C97.0124 17.8673 97.2145 18.2759 97.5957 18.6076C97.9768 18.9274 98.4273 19.0873 98.947 19.0873C99.8364 19.0873 100.414 18.7024 100.68 17.9324Z"
        fill="#FFFFFF"
      />
      <path
        d="M107.36 16.049V21.1129H104.727V12.2821H107.273V13.2949C107.493 12.904 107.828 12.602 108.278 12.3887C108.74 12.1637 109.208 12.0511 109.681 12.0511C110.709 12.0511 111.489 12.3828 112.02 13.0462C112.552 13.6977 112.817 14.5387 112.817 15.5692V21.1129H110.184V16.0312C110.184 15.5692 110.063 15.202 109.82 14.9296C109.589 14.6453 109.243 14.5032 108.781 14.5032C108.353 14.5032 108.007 14.6512 107.741 14.9474C107.487 15.2316 107.36 15.5989 107.36 16.049Z"
        fill="#FFFFFF"
      />
      <path
        d="M118.183 9.70575V12.2821H119.864V14.6453H118.183V17.9502C118.183 18.5661 118.501 18.8741 119.136 18.8741C119.344 18.8741 119.575 18.8445 119.829 18.7853V21.0241C119.506 21.1899 119.05 21.2728 118.461 21.2728C117.571 21.2728 116.867 21.0181 116.347 20.5088C115.839 19.9994 115.585 19.3065 115.585 18.4299V14.6453H114.06V12.2821H114.493C114.932 12.2821 115.261 12.1518 115.481 11.8912C115.712 11.6188 115.827 11.2693 115.827 10.8429V9.70575H118.183Z"
        fill="#FFFFFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_205_3613">
        <rect width="120" height="30" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);
export const CSV = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g id="Spec-Sheet" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Notes" transform="translate(-486.000000, -4278.000000)">
        <g id="csv" transform="translate(486.000000, 4278.000000)">
          <rect id="Rectangle" fill="#FEEDCB" x="0" y="0" width="40" height="40" rx="20"></rect>
          <path
            d="M13.852,24.168 C14.268,24.168 14.674,24.116 15.07,24.012 C15.466,23.908 15.792,23.764 16.048,23.58 L16.048,23.58 L16.048,21.18 L14.728,21.18 L14.728,22.632 C14.48,22.68 14.224,22.704 13.96,22.704 C13.592,22.704 13.264,22.634 12.976,22.494 C12.688,22.354 12.444,22.156 12.244,21.9 C12.044,21.644 11.892,21.338 11.788,20.982 C11.684,20.626 11.632,20.232 11.632,19.8 C11.632,19.304 11.688,18.874 11.8,18.51 C11.912,18.146 12.068,17.844 12.268,17.604 C12.468,17.364 12.702,17.186 12.97,17.07 C13.238,16.954 13.528,16.896 13.84,16.896 C14.104,16.896 14.36,16.916 14.608,16.956 L14.608,16.956 L14.608,18.324 L15.928,18.324 L15.928,15.828 C15.712,15.724 15.438,15.632 15.106,15.552 C14.774,15.472 14.368,15.432 13.888,15.432 C13.432,15.432 12.968,15.506 12.496,15.654 C12.024,15.802 11.596,16.046 11.212,16.386 C10.828,16.726 10.514,17.174 10.27,17.73 C10.026,18.286 9.904,18.976 9.904,19.8 C9.904,20.592 10.012,21.266 10.228,21.822 C10.444,22.378 10.732,22.83 11.092,23.178 C11.452,23.526 11.87,23.778 12.346,23.934 C12.822,24.09 13.324,24.168 13.852,24.168 Z M19.936,24.168 C20.392,24.168 20.816,24.114 21.208,24.006 C21.6,23.898 21.94,23.734 22.228,23.514 C22.516,23.294 22.74,23.022 22.9,22.698 C23.06,22.374 23.14,21.996 23.14,21.564 C23.14,21.116 23.038,20.744 22.834,20.448 C22.63,20.152 22.378,19.906 22.078,19.71 C21.778,19.514 21.45,19.348 21.094,19.212 C20.738,19.076 20.41,18.94 20.11,18.804 C19.81,18.668 19.558,18.516 19.354,18.348 C19.15,18.18 19.048,17.964 19.048,17.7 C19.048,17.444 19.158,17.24 19.378,17.088 C19.598,16.936 19.9,16.86 20.284,16.86 C20.484,16.86 20.686,16.874 20.89,16.902 C21.094,16.93 21.284,16.968 21.46,17.016 C21.484,17.024 21.508,17.028 21.532,17.028 L21.532,17.028 L21.532,18.36 L22.852,18.36 L22.852,15.924 C22.572,15.772 22.196,15.652 21.724,15.564 C21.252,15.476 20.772,15.432 20.284,15.432 C19.852,15.432 19.46,15.492 19.108,15.612 C18.756,15.732 18.454,15.9 18.202,16.116 C17.95,16.332 17.754,16.59 17.614,16.89 C17.474,17.19 17.404,17.52 17.404,17.88 C17.404,18.352 17.506,18.736 17.71,19.032 C17.914,19.328 18.166,19.574 18.466,19.77 C18.766,19.966 19.094,20.128 19.45,20.256 C19.806,20.384 20.134,20.512 20.434,20.64 C20.734,20.768 20.986,20.916 21.19,21.084 C21.394,21.252 21.496,21.472 21.496,21.744 C21.496,22.048 21.372,22.29 21.124,22.47 C20.876,22.65 20.528,22.74 20.08,22.74 C19.832,22.74 19.598,22.714 19.378,22.662 C19.158,22.61 18.956,22.544 18.772,22.464 C18.748,22.456 18.724,22.448 18.7,22.44 L18.7,22.44 L18.7,21.252 L17.38,21.252 L17.38,23.484 C17.484,23.54 17.62,23.608 17.788,23.688 C17.956,23.768 18.15,23.844 18.37,23.916 C18.59,23.988 18.83,24.048 19.09,24.096 C19.35,24.144 19.632,24.168 19.936,24.168 Z M28.372,24 L30.892,15.6 L29.188,15.6 L27.532,21.756 L27.472,21.756 L25.744,15.6 L23.908,15.6 L26.5,24 L28.372,24 Z"
            id="CSV"
            fill="#FA8C16"
            fillRule="nonzero"
          ></path>
        </g>
      </g>
    </g>
  </Svg>
);

export const EmailIconCircle = ({ ...props }) => (
  <Svg width="32px" height="32px" viewBox="0 0 32 32" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Alerts-Onboarding-with-UI-Updates" transform="translate(-784.000000, -554.000000)">
        <g transform="translate(772.000000, 542.000000)">
          <g transform="translate(12.000000, 12.000000)">
            <g fill="#FEEDCB">
              <circle id="Oval" cx="16" cy="16" r="16"></circle>
            </g>
            <g transform="translate(6.400000, 9.600000)" fill="#FAAD14" fillRule="nonzero">
              <path d="M1.4357202,0.130079475 C1.26099212,0.130079475 1.09513195,0.166528302 0.942472467,0.226665554 L8.68159882,6.76692736 C9.02032191,7.05346239 9.3980424,7.05366108 9.7375658,6.76692736 L17.4836393,0.21975551 C17.3331874,0.161627248 17.1689878,0.130079475 16.9973387,0.130079475 L1.4357202,0.130079475 Z M0.115761483,1.26151641 C0.10671796,1.32403796 0.101867181,1.38960611 0.101867181,1.45468857 L0.101867181,10.2854203 C0.101867181,11.0192316 0.696778965,11.6100294 1.4357202,11.6100294 L16.9973387,11.6100294 C17.73628,11.6100294 18.3311917,11.0192316 18.3311917,10.2854203 L18.3311917,1.45468857 C18.3311917,1.38960611 18.3263454,1.32403796 18.3172974,1.26151641 L10.6059597,7.77418219 C9.80658157,8.44924714 8.61253858,8.45032891 7.81320493,7.77418219 L0.115761483,1.26151641 Z"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const GoogleAnalytics = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <defs>
      <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
        <stop stopColor="#FFFFFF" stopOpacity="0.1" offset="0%"></stop>
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%"></stop>
      </linearGradient>
      <linearGradient
        x1="25.1920303%"
        y1="25.2403846%"
        x2="60.7533192%"
        y2="96.5%"
        id="linearGradient-2"
      >
        <stop stopColor="#BF360C" stopOpacity="0.2" offset="0%"></stop>
        <stop stopColor="#BF360C" stopOpacity="0.02" offset="100%"></stop>
      </linearGradient>
      <linearGradient
        x1="33.5322368%"
        y1="33.5730263%"
        x2="98.2203947%"
        y2="98.2611842%"
        id="linearGradient-3"
      >
        <stop stopColor="#FFFFFF" stopOpacity="0.1" offset="0%"></stop>
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g id="Icon/Google-Analytics" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#FEEDCB" x="0" y="0" width="40" height="40" rx="20"></rect>
      <g id="google-analytics-3" transform="translate(9.000000, 9.000000)" fillRule="nonzero">
        <path
          d="M20.2209073,0 L16.2143327,0 C15.2452334,0 14.4497041,0.795529257 14.4497041,1.76462853 L14.4497041,6.94280079 L8.64957265,6.94280079 C7.70940171,6.94280079 6.94280079,7.70940171 6.94280079,8.66403682 L6.94280079,14.4641683 L1.72123603,14.4641683 C0.76660092,14.4641683 0,15.2307692 0,16.1854043 L0,20.2353715 C0,21.1900066 0.76660092,21.9566075 1.72123603,21.9855358 L20.2353715,21.9855358 C21.2044707,21.9855358 22,21.1900066 22,20.2209073 L22,1.76462853 C21.9855358,0.795529257 21.1900066,0 20.2209073,0 Z"
          id="Path"
          fill="url(#linearGradient-1)"
        ></path>
        <path
          d="M20.2209073,0 L16.2143327,0 C15.2452334,0 14.4497041,0.795529257 14.4497041,1.76462853 L14.4497041,6.94280079 L8.64957265,6.94280079 C7.70940171,6.94280079 6.94280079,7.70940171 6.94280079,8.66403682 L6.94280079,14.4641683 L1.72123603,14.4641683 C0.76660092,14.4641683 0,15.2307692 0,16.1854043 L0,20.2353715 C0,21.1900066 0.76660092,21.9566075 1.72123603,21.9855358 L20.2353715,21.9855358 C21.2044707,21.9855358 22,21.1900066 22,20.2209073 L22,1.76462853 C21.9855358,0.795529257 21.1900066,0 20.2209073,0 Z"
          id="Path"
          fill="url(#linearGradient-1)"
        ></path>
        <g id="Group">
          <path
            d="M20.2209073,0 L16.243261,0 C15.2741617,0 14.4786325,0.795529257 14.4786325,1.76462853 L14.4786325,21.9855358 L20.2209073,21.9855358 C21.1900066,21.9855358 21.9855358,21.1900066 21.9855358,20.2209073 L21.9855358,1.76462853 C21.9855358,0.795529257 21.1900066,0 20.2209073,0 Z"
            id="Path"
            fill="#F57C00"
          ></path>
          <path
            d="M6.94280079,8.67850099 L6.94280079,14.4641683 L1.7357002,14.4641683 C0.781065089,14.4641683 0,15.2452334 0,16.1998685 L0,20.2498356 C0,21.2044707 0.781065089,21.9855358 1.7357002,21.9855358 L14.4641683,21.9855358 L14.4641683,6.94280079 L8.67850099,6.94280079 C7.72386588,6.94280079 6.94280079,7.72386588 6.94280079,8.67850099 Z"
            id="Path"
            fill="#FFC107"
          ></path>
        </g>
        <path
          d="M14.4641683,6.94280079 L14.4641683,21.9855358 L20.2064431,21.9855358 C21.1755424,21.9855358 21.9710717,21.1900066 21.9710717,20.2209073 L21.9710717,14.4641683 L14.4641683,6.94280079 Z"
          id="Path"
          fill="url(#linearGradient-2)"
        ></path>
        <path
          d="M8.67850099,7.08744247 L14.4641683,7.08744247 L14.4641683,6.94280079 L8.67850099,6.94280079 C7.72386588,6.94280079 6.94280079,7.72386588 6.94280079,8.67850099 L6.94280079,8.82314267 C6.94280079,7.86850756 7.72386588,7.08744247 8.67850099,7.08744247 Z"
          id="Path"
          fill="#FFFFFF"
          opacity="0.2"
        ></path>
        <path
          d="M1.7357002,14.60881 L6.94280079,14.60881 L6.94280079,14.4641683 L1.7357002,14.4641683 C0.781065089,14.4641683 0,15.2452334 0,16.1998685 L0,16.3445102 C0,15.3898751 0.781065089,14.60881 1.7357002,14.60881 Z"
          id="Path"
          fill="#FFFFFF"
          opacity="0.2"
        ></path>
        <path
          d="M20.2209073,0 L16.243261,0 C15.2741617,0 14.4786325,0.795529257 14.4786325,1.76462853 L14.4786325,1.90927022 C14.4786325,0.94017094 15.2741617,0.144641683 16.243261,0.144641683 L20.2209073,0.144641683 C21.1900066,0.144641683 21.9855358,0.94017094 21.9855358,1.90927022 L21.9855358,1.76462853 C21.9855358,0.795529257 21.1900066,0 20.2209073,0 Z"
          id="Path"
          fill="#FFFFFF"
          opacity="0.2"
        ></path>
        <path
          d="M20.2209073,21.8408941 L1.7357002,21.8408941 C0.781065089,21.8408941 0,21.0598291 0,20.105194 L0,20.2498356 C0,21.2044707 0.781065089,21.9855358 1.7357002,21.9855358 L20.2064431,21.9855358 C21.1755424,21.9855358 21.9712658,21.1900066 21.9712658,20.2209073 L21.9712658,20.0762656 C21.9855358,21.0453649 21.1900066,21.8408941 20.2209073,21.8408941 Z"
          id="Path"
          fill="#BF360C"
          opacity="0.2"
        ></path>
        <path
          d="M20.2209073,0 L16.243261,0 C15.2741617,0 14.4786325,0.795529257 14.4786325,1.76462853 L14.4786325,6.94280079 L8.69296515,6.94280079 C7.73833005,6.94280079 6.95726496,7.72386588 6.95726496,8.67850099 L6.95726496,14.4641683 L1.7357002,14.4641683 C0.781065089,14.4641683 0,15.2452334 0,16.1998685 L0,20.2498356 C0,21.2044707 0.781065089,21.9855358 1.7357002,21.9855358 L20.2209073,21.9855358 C21.1900066,21.9855358 21.9855358,21.1900066 21.9855358,20.2209073 L21.9855358,1.76462853 C21.9855358,0.795529257 21.1900066,0 20.2209073,0 Z"
          id="Path"
          fill="url(#linearGradient-3)"
        ></path>
      </g>
    </g>
  </Svg>
);

export const GoogleDrive = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="googledrive">
        <circle id="Oval" fill="#E6F3FF" cx="20" cy="20" r="20"></circle>
        <g id="Group-4" transform="translate(7.000000, 9.000000)">
          <polygon
            id="Fill-1"
            fill="#3777E3"
            points="8.64474657 14.5639619 4.50260991 21.8459429 21.0720911 21.8459429 25.2146155 14.5639619"
          ></polygon>
          <polygon
            id="Fill-2"
            fill="#FFCF63"
            points="8.10469783 0 16.659939 14.5639619 25.2146155 14.5639619 16.659939 0"
          ></polygon>
          <polygon
            id="Fill-3"
            fill="#11A861"
            points="8.40480123 0 0 14.563972 4.20268806 21.8459429 12.6073077 7.28199104"
          ></polygon>
        </g>
      </g>
    </g>
  </Svg>
);

export const GoogleSheet = ({ ...props }) => (
  <Svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20" cy="20" r="20" fill="#DCF3D1" />
    <path d="M14.4971 16.1987H29.7017V31.4034H14.4971V16.1987Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7958 32.9995H28.3616C29.3539 32.9995 30.1577 32.2062 30.1577 31.2268V13.4995L23.6577 6.99951H12.7958C11.8035 6.99951 10.9998 7.79281 10.9998 8.77224V31.2268C10.9998 32.2062 11.8035 32.9995 12.7958 32.9995ZM21.3484 17.2627H26.7366V26.1574H14.4208V17.2627H21.3484ZM19.8945 18.6311H15.7892V21.0258H19.8945V18.6311ZM15.7892 22.3943V24.789H19.8945V22.3943H15.7892ZM21.2629 24.789H25.3682V22.3943H21.2629V24.789ZM21.2629 21.0258H25.3682V18.6311H21.2629V21.0258Z"
      fill="#00AC47"
    />
    <path d="M23.6584 6.99951L30.1584 13.4995H23.6584V6.99951Z" fill="#00832D" />
  </Svg>
);

export const GoogleSheetPush = ({ ...props }) => (
  <Svg width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <g id="Export-to-SF" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Push-to-SF-with-Imports" transform="translate(-1245.000000, -275.000000)">
        <g id="source-data" transform="translate(1245.000000, 275.000000)">
          <rect id="Rectangle" fill="#2E9D58" x="0" y="0" width="16" height="16" rx="1"></rect>
          <polygon
            id="Line-11"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="7 2 7 14 6 14 6 2"
          ></polygon>
          <polygon
            id="Line-11"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="13.5 4.5 13.5 5.5 1.5 5.5 1.5 4.5"
          ></polygon>
        </g>
      </g>
    </g>
  </Svg>
);

export const ExcelPush = ({ ...props }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <rect width="16" height="16" rx="2" fill="#0E8345" />
    <path
      d="M4 12L6.89775 7.98883L4.24358 4H6.37945L7.82832 6.54941C7.96144 6.79133 8.05302 6.97181 8.10304 7.09074H8.12179C8.2174 6.89746 8.31744 6.70953 8.42165 6.52719L9.9703 4H11.9314L9.20841 7.96649L12 12H9.91403L8.24033 9.19948C8.16152 9.08044 8.0947 8.95523 8.04051 8.82572H8.01563C7.96665 8.95267 7.90178 9.07427 7.82193 9.18819L6.09835 12H4Z"
      fill="white"
    />
  </svg>
);

export const HubSpot = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g id="Icon/Hubspot" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#FEEDCB" x="0" y="0" width="40" height="40" rx="20"></rect>
      <path
        d="M29.8154221,19.4003366 C29.283845,18.4857497 28.5361107,17.7525456 27.6012795,17.2005609 C26.9026867,16.7938783 26.1782986,16.535763 25.3619947,16.424909 L25.3619947,13.5188672 C26.1782986,13.1722646 26.6848968,12.4051022 26.6848968,11.5101066 C26.6848968,10.2902221 25.7066382,9.30167815 24.4877333,9.30167815 C23.2678488,9.30167815 22.2724479,10.2902221 22.2724479,11.5101066 C22.2724479,12.4051022 22.7498224,13.1722646 23.5661262,13.5188672 L23.5661262,16.426215 C22.9130831,16.5205798 22.2358774,16.724166 21.6174456,17.0369736 C20.354297,16.0776533 16.2123712,12.9304754 13.7894181,11.0923223 C13.8468858,10.8851444 13.8911295,10.6715993 13.8911295,10.4462994 C13.8911295,9.09515327 12.7969558,8 11.4453199,8 C10.0936839,8 9,9.09515327 9,10.4462994 C9,11.7972823 10.0948267,12.8927621 11.4464627,12.8927621 C11.9075111,12.8927621 12.3339483,12.7579087 12.701938,12.5362006 L13.2132708,12.9241082 L20.2393614,17.9864983 C19.8679432,18.32755 19.5219936,18.7154576 19.2452666,19.1507108 C18.6844658,20.0380331 18.3417815,21.0143326 18.3417815,22.0792826 L18.3417815,22.3014805 C18.3417815,23.0490516 18.4838183,23.7548279 18.7257708,24.4178299 C18.9388261,24.9967526 19.2503277,25.5231054 19.6361129,25.9990105 L17.3042593,28.3365783 C16.6140527,28.0796834 15.8373903,28.2500052 15.3180287,28.772158 C14.9623921,29.1260439 14.7632021,29.607557 14.7649012,30.1092637 C14.7650644,30.6142293 14.9617937,31.0888284 15.3190082,31.4458797 C15.6726631,31.8017796 16.1540558,32.0013211 16.6557875,32 C17.1576528,32.0012699 17.6391786,31.8017462 17.9930565,31.4458797 C18.3484607,31.0920124 18.5477192,30.6107942 18.5465105,30.1092637 C18.5465105,29.9138406 18.5163072,29.723152 18.4594925,29.5419326 L20.8697113,27.1313872 C21.2001511,27.3596258 21.5570391,27.5517837 21.940702,27.7174934 C22.6974156,28.044668 23.5326578,28.2440094 24.4467548,28.2440094 L24.6142604,28.2440094 C25.6248446,28.2440094 26.5781242,28.0066282 27.4742626,27.5210907 C28.4185629,27.0079621 29.1576445,26.3062673 29.7159963,25.4104554 C30.2772868,24.5121946 30.5863395,23.5197324 30.5863395,22.4278443 L30.5863395,22.3733152 C30.5863395,21.2992226 30.3376933,20.3082297 29.8154221,19.4003366 L29.8154221,19.4003366 Z M26.8705243,24.4570125 C26.2163384,25.1840127 25.4643592,25.631837 24.6142604,25.631837 L24.4741826,25.631837 C23.9886451,25.631837 23.5137195,25.4976367 23.0487528,25.2535618 C22.5246857,24.9848346 22.1263295,24.6014983 21.8002977,24.116124 C21.4633275,23.6397291 21.2804754,23.1195802 21.2804754,22.5680854 L21.2804754,22.4005798 C21.2804754,21.8583908 21.3844725,21.3442826 21.6466693,20.8587451 C21.9269881,20.3279843 22.3055898,19.915261 22.809086,19.5871069 C23.3034396,19.2612384 23.831425,19.1014061 24.4194903,19.1014061 L24.4741826,19.1014061 C25.0073923,19.1014061 25.5121946,19.206546 25.9885896,19.4502944 C26.4739639,19.7102055 26.8705243,20.0652977 27.1779443,20.5323868 C27.4765483,20.9996391 27.654176,21.5036251 27.7113173,22.0526711 C27.7202966,22.1667904 27.7248679,22.2836851 27.7248679,22.3953555 C27.7248679,23.1404776 27.4401411,23.8305809 26.8705243,24.4570125 Z"
        id="Shape"
        fill="#F8761F"
        fillRule="nonzero"
      ></path>
    </g>
  </Svg>
);

export const Instagram = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#F5F5F5" />
    <path
      d="M20.0036 9C15.4112 9 14.0681 9.00474 13.807 9.0264C12.8646 9.10476 12.2781 9.25319 11.6392 9.57137C11.1469 9.81593 10.7586 10.0994 10.3753 10.4968C9.67738 11.2215 9.25438 12.1131 9.10126 13.1729C9.02681 13.6874 9.00515 13.7923 9.00075 16.4204C8.99906 17.2964 9.00075 18.4493 9.00075 19.9957C9.00075 24.5856 9.00583 25.9277 9.02782 26.1884C9.10396 27.1057 9.24778 27.6828 9.55234 28.3141C10.1344 29.5225 11.246 30.4296 12.5556 30.7681C13.0091 30.8849 13.5099 30.9492 14.1529 30.9797C14.4253 30.9915 17.2018 31 19.9801 31C22.7583 31 25.5366 30.9966 25.8022 30.9831C26.5467 30.948 26.979 30.89 27.457 30.7664C28.775 30.4263 29.8664 29.5326 30.4603 28.3073C30.7589 27.6913 30.9103 27.0921 30.9789 26.2227C30.9937 26.0332 31 23.011 31 19.9928C31 16.9742 30.9932 13.9575 30.9783 13.768C30.909 12.8845 30.7575 12.2905 30.4493 11.6626C30.1963 11.1486 29.9154 10.7647 29.5077 10.3722C28.7799 9.67698 27.89 9.25387 26.8294 9.10087C26.3156 9.02657 26.2132 9.00457 23.5838 9H20.0036Z"
      fill="url(#paint0_radial_1621_5878)"
    />
    <path
      d="M20.0036 9C15.4112 9 14.0681 9.00474 13.807 9.0264C12.8646 9.10476 12.2781 9.25319 11.6392 9.57137C11.1469 9.81593 10.7586 10.0994 10.3753 10.4968C9.67738 11.2215 9.25438 12.1131 9.10126 13.1729C9.02681 13.6874 9.00515 13.7923 9.00075 16.4204C8.99906 17.2964 9.00075 18.4493 9.00075 19.9957C9.00075 24.5856 9.00583 25.9277 9.02782 26.1884C9.10396 27.1057 9.24778 27.6828 9.55234 28.3141C10.1344 29.5225 11.246 30.4296 12.5556 30.7681C13.0091 30.8849 13.5099 30.9492 14.1529 30.9797C14.4253 30.9915 17.2018 31 19.9801 31C22.7583 31 25.5366 30.9966 25.8022 30.9831C26.5467 30.948 26.979 30.89 27.457 30.7664C28.775 30.4263 29.8664 29.5326 30.4603 28.3073C30.7589 27.6913 30.9103 27.0921 30.9789 26.2227C30.9937 26.0332 31 23.011 31 19.9928C31 16.9742 30.9932 13.9575 30.9783 13.768C30.909 12.8845 30.7575 12.2905 30.4493 11.6626C30.1963 11.1486 29.9154 10.7647 29.5077 10.3722C28.7799 9.67698 27.89 9.25387 26.8294 9.10087C26.3156 9.02657 26.2132 9.00457 23.5838 9H20.0036Z"
      fill="url(#paint1_radial_1621_5878)"
    />
    <path
      d="M19.9985 11.8772C17.7928 11.8772 17.516 11.8868 16.6497 11.9263C15.7851 11.9659 15.195 12.1028 14.6786 12.3037C14.1444 12.5112 13.6913 12.7888 13.2399 13.2405C12.7881 13.692 12.5106 14.1453 12.3025 14.6794C12.1011 15.1961 11.9641 15.7866 11.9252 16.6511C11.8864 17.5176 11.8763 17.7947 11.8763 20.001C11.8763 22.2072 11.8861 22.4833 11.9253 23.3498C11.9651 24.2147 12.102 24.805 12.3027 25.3215C12.5103 25.8558 12.7878 26.3091 13.2393 26.7606C13.6906 27.2125 14.1437 27.4907 14.6775 27.6982C15.1943 27.8991 15.7846 28.036 16.649 28.0756C17.5153 28.1151 17.792 28.1247 19.9975 28.1247C22.2033 28.1247 22.4793 28.1151 23.3456 28.0756C24.2102 28.036 24.8011 27.8991 25.3178 27.6982C25.8518 27.4907 26.3042 27.2125 26.7555 26.7606C27.2072 26.3091 27.4847 25.8558 27.6928 25.3217C27.8925 24.805 28.0295 24.2145 28.0701 23.35C28.1091 22.4834 28.1192 22.2072 28.1192 20.001C28.1192 17.7947 28.1091 17.5178 28.0701 16.6513C28.0295 15.7864 27.8925 15.1961 27.6928 14.6796C27.4847 14.1453 27.2072 13.692 26.7555 13.2405C26.3037 12.7886 25.8519 12.511 25.3173 12.3037C24.7995 12.1028 24.209 11.9659 23.3444 11.9263C22.4781 11.8868 22.2023 11.8772 19.996 11.8772H19.9985ZM19.2699 13.3412C19.4862 13.3408 19.7275 13.3412 19.9985 13.3412C22.167 13.3412 22.424 13.349 23.2803 13.3879C24.0721 13.4241 24.5019 13.5564 24.7882 13.6676C25.1672 13.8149 25.4374 13.9909 25.7215 14.2752C26.0057 14.5596 26.1817 14.8304 26.3293 15.2095C26.4404 15.4955 26.5729 15.9254 26.6089 16.7174C26.6479 17.5738 26.6563 17.8311 26.6563 19.9991C26.6563 22.1671 26.6479 22.4244 26.6089 23.2808C26.5727 24.0728 26.4404 24.5027 26.3293 24.7887C26.1821 25.1678 26.0057 25.4378 25.7215 25.722C25.4372 26.0063 25.1674 26.1823 24.7882 26.3295C24.5022 26.4412 24.0721 26.5733 23.2803 26.6095C22.4241 26.6484 22.167 26.6569 19.9985 26.6569C17.8299 26.6569 17.5729 26.6484 16.7167 26.6095C15.9249 26.5729 15.4951 26.4406 15.2087 26.3294C14.8296 26.1821 14.5589 26.0061 14.2747 25.7218C13.9904 25.4375 13.8145 25.1673 13.6669 24.7881C13.5558 24.502 13.4233 24.0722 13.3872 23.2801C13.3483 22.4237 13.3405 22.1665 13.3405 19.9971C13.3405 17.8277 13.3483 17.5718 13.3872 16.7154C13.4234 15.9233 13.5558 15.4935 13.6669 15.2071C13.8141 14.828 13.9904 14.5572 14.2747 14.2729C14.5589 13.9885 14.8296 13.8125 15.2087 13.6649C15.4949 13.5532 15.9249 13.4212 16.7167 13.3848C17.4659 13.351 17.7563 13.3408 19.2699 13.3391V13.3412ZM24.3337 14.6901C23.7957 14.6901 23.3591 15.1262 23.3591 15.6646C23.3591 16.2028 23.7957 16.6394 24.3337 16.6394C24.8718 16.6394 25.3083 16.2028 25.3083 15.6646C25.3083 15.1264 24.8718 14.6897 24.3337 14.6897V14.6901ZM19.9985 15.8291C17.6952 15.8291 15.8278 17.697 15.8278 20.001C15.8278 22.3049 17.6952 24.172 19.9985 24.172C22.3018 24.172 24.1686 22.3049 24.1686 20.001C24.1686 17.697 22.3018 15.8291 19.9985 15.8291ZM19.9985 17.293C21.4936 17.293 22.7057 18.5053 22.7057 20.001C22.7057 21.4964 21.4936 22.7089 19.9985 22.7089C18.5033 22.7089 17.2913 21.4964 17.2913 20.001C17.2913 18.5053 18.5033 17.293 19.9985 17.293Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_1621_5878"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.8438 32.6945) rotate(-90) scale(21.8036 20.2791)"
      >
        <stop stopColor="#FFDD55" />
        <stop offset="0.1" stopColor="#FFDD55" />
        <stop offset="0.5" stopColor="#FF543E" />
        <stop offset="1" stopColor="#C837AB" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_1621_5878"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.31488 10.5848) rotate(78.6806) scale(9.74631 40.1747)"
      >
        <stop stopColor="#3771C8" />
        <stop offset="0.128" stopColor="#3771C8" />
        <stop offset="1" stopColor="#6600FF" stopOpacity="0" />
      </radialGradient>
    </defs>
  </Svg>
);

export const Jira = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <defs>
      <linearGradient
        x1="62.8448182%"
        y1="47.770202%"
        x2="40.8230957%"
        y2="81.6533975%"
        id="jira-linearGradient-1"
      >
        <stop stopColor="#0052CC" offset="0%"></stop>
        <stop stopColor="#2684FF" offset="100%"></stop>
      </linearGradient>
      <linearGradient
        x1="37.4650545%"
        y1="51.7569855%"
        x2="59.3456016%"
        y2="17.9948239%"
        id="jira-linearGradient-2"
      >
        <stop stopColor="#0052CC" offset="0%"></stop>
        <stop stopColor="#2684FF" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <circle fill="#E6F3FF" cx="20" cy="20" r="20"></circle>
        <g transform="translate(8.000000, 8.000000)" fillRule="nonzero">
          <path
            d="M22.9151961,11.3184857 L12.5960693,0.999358864 L11.5959644,0 L0.277498867,11.3184857 C-0.0924996225,11.6894923 -0.0924996225,12.2900997 0.277498867,12.6603603 L7.37425137,19.7568709 L11.5959644,23.979592 L22.9151961,12.6603603 C23.2854567,12.2900997 23.2854567,11.6894923 22.9151961,11.3184857 Z M11.5959644,15.5341497 L8.05149984,11.9899271 L11.5959644,8.4444342 L15.1411952,11.9899271 L11.5959644,15.5341497 Z"
            id="path8005"
            fill="#2684FF"
          ></path>
          <path
            d="M11.5959644,8.4444342 C9.27541855,6.12288019 9.26356246,2.36290916 11.5712642,0.0277246825 L3.81315201,7.78283254 L8.0358732,12.0055537 L11.5959644,8.4444342 Z"
            id="path8015"
            fill="url(#jira-linearGradient-1)"
          ></path>
          <path
            d="M15.1510349,11.9798454 L11.5959644,15.5341497 C12.7163037,16.6534606 13.3464101,18.1727732 13.3464101,19.7568709 C13.3464101,21.3409483 12.7163037,22.8592528 11.5959644,23.979592 L19.3727479,16.2025666 L15.1510349,11.9798454 Z"
            id="path8025"
            fill="url(#jira-linearGradient-2)"
          ></path>
        </g>
      </g>
    </g>
  </Svg>
);

export const LinkedIn = ({ ...props }) => (
  <Svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20" cy="20" r="20" fill="#F5F5F5" />
    <path
      d="M9.77539 11.2364C9.77539 10.4298 10.4459 9.7755 11.273 9.7755H28.5436C29.3707 9.7755 30.0412 10.4298 30.0412 11.2364V28.709C30.0412 29.5159 29.3707 30.1699 28.5436 30.1699H11.273C10.4459 30.1699 9.77539 29.5159 9.77539 28.709V11.2364Z"
      fill="#006699"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9187 26.8477V17.6384H12.8577V26.8477H15.9187ZM14.3882 16.3811C15.4556 16.3811 16.12 15.6739 16.12 14.7902C16.1001 13.8865 15.4556 13.199 14.4084 13.199C13.3614 13.199 12.6768 13.8865 12.6768 14.7902C12.6768 15.6739 13.341 16.3811 14.3682 16.3811H14.3882Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.6123 26.8477H20.6732V21.7048C20.6732 21.4296 20.6931 21.1546 20.774 20.9579C20.9952 20.408 21.4989 19.8384 22.3445 19.8384C23.4521 19.8384 23.8952 20.6829 23.8952 21.9209V26.8477H26.9559V21.5672C26.9559 18.7386 25.4458 17.4223 23.4319 17.4223C21.7806 17.4223 21.0557 18.3453 20.6529 18.974H20.6733V17.6384H17.6124C17.6526 18.5026 17.6123 26.8477 17.6123 26.8477Z"
      fill="white"
    />
  </Svg>
);

export const YouTubeAnalytics = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20" cy="20" r="20" fill="#F5F5F5" />
    <path
      d="M30.5728 14.7243C30.3176 13.7765 29.5703 13.0292 28.6224 12.774C26.8908 12.3 19.9642 12.3 19.9642 12.3C19.9642 12.3 13.0377 12.3 11.3061 12.7557C10.3764 13.0109 9.61088 13.7765 9.35569 14.7243C8.89999 16.456 8.89999 20.0468 8.89999 20.0468C8.89999 20.0468 8.89999 23.6559 9.35569 25.3693C9.61088 26.3172 10.3582 27.0645 11.3061 27.3197C13.0559 27.7936 19.9642 27.7936 19.9642 27.7936C19.9642 27.7936 26.8908 27.7936 28.6224 27.3379C29.5703 27.0827 30.3176 26.3354 30.5728 25.3876C31.0285 23.6559 31.0285 20.0651 31.0285 20.0651C31.0285 20.0651 31.0467 16.456 30.5728 14.7243Z"
      fill="#FF0000"
    />
    <path d="M17.7587 16.7295V23.3644L23.5186 20.0469L17.7587 16.7295Z" fill="white" />
  </svg>
);

export const Looker = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g id="Coeff-Spec-Sheet" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Looker-resized" transform="translate(-2991.000000, -7177.000000)">
        <g id="looker" transform="translate(2991.000000, 7177.000000)">
          <g id="Icon/Looker">
            <rect id="Rectangle" fill="#E6F3FF" x="0" y="0" width="40" height="40" rx="20"></rect>
            <g id="looker" transform="translate(13.000000, 8.000000)" fillRule="nonzero">
              <path
                d="M7.49871418,0 C6.72312656,0.00034045716 6.01089325,0.428546683 5.64636431,1.11366468 C5.28183537,1.79878268 5.32438899,2.62921346 5.75703618,3.27341812 L6.6538043,2.37721599 C6.62416514,2.28781492 6.60921453,2.19419381 6.60953507,2.10000093 C6.60953507,1.61063491 7.00593526,1.21392538 7.49491968,1.21392538 C7.9839041,1.21392538 8.38030429,1.61063491 8.38030429,2.10000093 C8.38030429,2.58936694 7.9839041,2.98607647 7.49491968,2.98607647 C7.40122269,2.98628282 7.30810909,2.97132172 7.21918562,2.9417727 L6.32368233,3.83797482 C7.06941919,4.34414902 8.05481071,4.31733458 8.77196096,3.77135235 C9.48911122,3.22537012 9.77789379,2.28212786 9.48946278,1.42779668 C9.20103178,0.573465501 8.3997885,-0.00119821178 7.49871418,0 Z"
                id="Path"
                fill="#34A853"
              ></path>
              <path
                d="M6.6,6.19817841 C6.60153539,5.47758254 6.34364924,4.77614114 5.86535935,4.2 L4.55808068,5.38167694 C4.96691356,6.05833447 4.81978963,6.89939787 4.2,7.42871685 L4.91047754,9 C5.96316728,8.38650319 6.59950652,7.33122495 6.6,6.19817841 Z"
                id="Path"
                fill="#FBBC04"
              ></path>
              <path
                d="M3.34104979,7.9779891 L3.31039545,7.9779891 C2.58963451,7.97805135 1.94854771,7.52176375 1.71512458,6.84256981 C1.48170145,6.16337586 1.70757371,5.41150897 2.27718175,4.9716354 C2.84678978,4.53176182 3.63413992,4.50117881 4.23641214,4.89553308 L5.4,3.73659068 C4.26854996,2.82297189 2.67072931,2.75249591 1.46262497,3.56292266 C0.254520638,4.3733494 -0.280489276,5.87458173 0.144245046,7.26228318 C0.568979369,8.64998464 1.85383044,9.59865007 3.31039545,9.6 C3.5351415,9.60010973 3.75934107,9.57794975 3.97968199,9.53384701 L3.34104979,7.9779891 Z"
                id="Path"
                fill="#EA4335"
              ></path>
              <path
                d="M7.4936607,9.0012739 C6.76018931,9.00053084 6.03057668,9.10740223 5.32812864,9.31847431 L6.25675975,11.5872853 C6.66098869,11.4871064 7.07593053,11.4366268 7.49238686,11.4369655 C9.9055075,11.4376691 11.9821241,13.1428767 12.4523665,15.5098381 C12.9226088,17.8767996 11.6555222,20.2463553 9.42594179,21.1695001 C7.19636138,22.0926449 4.62518835,21.3122982 3.28471879,19.3056493 C1.94424922,17.2990003 2.20778167,14.6248676 3.91416359,12.918508 C4.27022433,12.5635446 4.6767118,12.2630658 5.12049234,12.0267799 L4.20205197,9.76433836 C0.778525011,11.4410683 -0.842402213,15.4195135 0.434507924,19.0114948 C1.71141806,22.6034761 5.47981233,24.6659114 9.19343996,23.8052422 C12.9070676,22.944573 15.3841347,19.4346915 14.950922,15.6471751 C14.5177094,11.8596587 11.3120789,8.99981504 7.50002992,9 L7.4936607,9.0012739 Z"
                id="Path"
                fill="#4285F4"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const Marketo = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g id="Icon/Marketo" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#F0EAFA" x="0" y="0" width="40" height="40" rx="20"></rect>
      <g id="Group" transform="translate(10.000000, 8.000000)" fill="#563E94">
        <polygon
          id="Fill-29"
          points="14.1714286 -2.30926389e-14 14.1714286 23.5701029 20.1874286 18.7611429 20.1874286 3.27314286"
        ></polygon>
        <polygon
          id="Fill-31"
          points="11.3737509 18.4319634 6.49146514 20.5531063 6.49146514 2.02967771 11.3737509 3.47424914"
        ></polygon>
        <polygon
          id="Fill-33"
          points="6.01629857e-13 17.883392 3.69371429 16.9142491 3.69371429 5.083392 6.01629857e-13 4.49824914"
        ></polygon>
      </g>
    </g>
  </Svg>
);

export const Microsoft = ({ ...props }) => (
  <Svg width="40" height="40" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#F5F5F5" />
    <path d="M8.30444 8.30444H19.588V19.588H8.30444V8.30444Z" fill="#F35325" />
    <path d="M20.7164 8.30444H32V19.588H20.7164V8.30444Z" fill="#81BC06" />
    <path d="M8.30444 20.7163H19.588V31.9999H8.30444V20.7163Z" fill="#05A6F0" />
    <path d="M20.7164 20.7163H32V31.9999H20.7164V20.7163Z" fill="#FFBA08" />
  </Svg>
);

export const MSSQL = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <defs>
      <radialGradient
        cx="50%"
        cy="53.4106445%"
        fx="50%"
        fy="53.4106445%"
        r="43.0615234%"
        id="mssql-radialGradient-1"
      >
        <stop stopColor="#FFFFFF" offset="0%"></stop>
        <stop stopColor="#F5F5F5" offset="100%"></stop>
      </radialGradient>
      <linearGradient
        x1="25.8951071%"
        y1="76.4064363%"
        x2="38.3411716%"
        y2="69.6673405%"
        id="mssql-linearGradient-2"
      >
        <stop stopColor="#909CA9" offset="0%"></stop>
        <stop stopColor="#EDEDEE" offset="100%"></stop>
      </linearGradient>
      <linearGradient
        x1="0.167947727%"
        y1="49.8457052%"
        x2="18.5944843%"
        y2="49.8457052%"
        id="mssql-linearGradient-3"
      >
        <stop stopColor="#939FAB" offset="0%"></stop>
        <stop stopColor="#DCDEE1" offset="100%"></stop>
      </linearGradient>
      <radialGradient
        cx="44.3461988%"
        cy="43.8808738%"
        fx="44.3461988%"
        fy="43.8808738%"
        r="12.8105072%"
        gradientTransform="translate(0.443462,0.438809),scale(0.698399,1.000000),rotate(-171.457413),translate(-0.443462,-0.438809)"
        id="mssql-radialGradient-4"
      >
        <stop stopColor="#EE352C" offset="0%"></stop>
        <stop stopColor="#A91D22" offset="100%"></stop>
      </radialGradient>
    </defs>
    <g id="Icon/MicrosoftSQL" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle id="Oval" fill="url(#mssql-radialGradient-1)" cx="20" cy="20" r="20"></circle>
      <g id="Group" transform="translate(9.000000, 7.000000)" fillRule="nonzero">
        <path
          d="M15.1546449,12.26626 L9.89580407,13.9834576 L5.32068585,16.0026949 L4.04072908,16.3406061 C3.7147506,16.6506743 3.37295344,16.96472 3.00327654,17.2827066 C2.59783805,17.6324773 2.22022432,17.9505189 1.93000742,18.1810171 C1.60806152,18.4354358 1.13106321,18.9124157 0.888613962,19.2144554 C0.526873899,19.6675882 0.240689576,20.1485458 0.117457833,20.5182593 C-0.101180905,21.1860716 0.00619549742,21.8617841 0.427525981,22.485898 C0.968110626,23.2808463 2.04533899,24.0917049 3.30137528,24.6442223 C3.94138116,24.9265024 5.01857287,25.2881875 5.8294315,25.4908792 C7.1768972,25.8327497 9.78448675,26.2024266 11.2194043,26.2581127 C11.5095295,26.2700272 11.8991127,26.2700272 11.914968,26.2581127 C11.946807,26.2381698 12.169405,25.8128984 12.4278195,25.2842649 C13.3102563,23.4835747 13.9462297,21.7942202 14.2920227,20.3513475 C14.4987104,19.4769025 14.661663,18.3122223 14.7689477,16.9329726 C14.7968275,16.5473854 14.8087052,15.2555326 14.784858,14.8182551 C14.7490598,14.1027851 14.6854551,13.5224796 14.5861622,12.9540519 C14.5702519,12.8705593 14.5662193,12.7950219 14.5742111,12.7910627 C14.5900665,12.7791482 14.6377608,12.7632562 15.2856852,12.5763832 L15.1545716,12.26626 L15.1545716,12.26626 L15.1546449,12.26626 L15.1546449,12.26626 Z M13.9542215,12.9698706 C14.0019158,12.9698706 14.1290701,14.1901453 14.1608541,14.9613381 C14.168846,15.1242907 14.1648134,15.2316121 14.1568949,15.2316121 C14.1251292,15.2316121 13.4851233,14.854035 13.0280863,14.5678507 C12.6305663,14.3174096 11.8753571,13.8165458 11.7561213,13.7211571 C11.7162905,13.6933507 11.7202498,13.6893915 12.0462466,13.5780558 C12.598709,13.3912011 13.9105047,12.9698706 13.9542215,12.9698706 L13.9542215,12.9698706 Z M11.2751088,13.8523257 C11.310907,13.8523257 11.4022631,13.9039426 11.6209018,14.0391255 C12.4397156,14.5518853 13.5527422,15.1720033 14.0297222,15.3787276 C14.1767645,15.442314 14.1926198,15.4184301 13.8548186,15.64902 C13.1313751,16.1418919 12.2290137,16.6268088 11.123979,17.1157398 C10.9292424,17.2031916 10.7662898,17.2707372 10.7623305,17.2707372 C10.754412,17.2707372 10.7781859,17.171426 10.8099515,17.0521535 C11.0762846,16.062322 11.2273594,15.0606677 11.2353513,14.2577275 C11.2393105,13.8602076 11.2393105,13.8602076 11.2751088,13.8483481 C11.2671169,13.8523257 11.2710762,13.8523257 11.2751088,13.8523257 L11.2751088,13.8523257 Z M10.7226097,14.0629726 C10.7463835,14.0867831 10.7305282,14.9772117 10.6987075,15.219661 C10.627166,15.8000215 10.5158671,16.3405878 10.3330815,16.9488097 C10.2893465,17.0957786 10.249534,17.2190836 10.2416705,17.2270022 C10.2256868,17.2468534 9.68112459,16.7142239 9.50226168,16.5075363 C9.19219353,16.1497738 8.94978095,15.7920296 8.7708997,15.442259 C8.67947029,15.2633777 8.53640563,14.9136254 8.54830171,14.9016743 C8.61188805,14.8579576 10.7066994,14.0470989 10.7226097,14.0629726 Z M8.12295699,15.0845148 C8.12691624,15.0845148 8.13087549,15.0845148 8.13490807,15.0884741 C8.14282657,15.0964292 8.17070631,15.1600522 8.19455348,15.2315754 C8.32170781,15.5774051 8.60785548,16.0861875 8.85437395,16.4121476 C9.12466627,16.7699101 9.4784695,17.1514647 9.77253567,17.4018875 C9.86797932,17.4813841 9.95537616,17.5568849 9.96727225,17.568836 C9.99117441,17.5927015 9.99911124,17.5886872 9.35116853,17.835169 C8.59999196,18.1213534 7.78110484,18.4075377 6.84300022,18.709614 C6.61890774,18.7818614 6.39501965,18.8547413 6.17133864,18.9282527 C6.13550374,18.9402038 6.14745482,18.9202976 6.25079865,18.7573633 C6.71584588,18.029924 7.42336069,16.6029433 7.82088066,15.5932971 C7.88846291,15.4183935 7.95602683,15.2435265 7.9679779,15.203769 C7.98388823,15.1480828 8.00372116,15.1282316 8.05537474,15.1003885 C8.08319949,15.0925067 8.1110609,15.0845148 8.12295699,15.0845148 Z M7.32804534,15.4144342 C7.33994143,15.4224261 7.13721302,15.8476975 6.9384622,16.2372439 C6.55287497,16.9884938 6.13154449,17.7278843 5.56711268,18.6261948 C5.47172401,18.7811922 5.38033126,18.9243302 5.36838018,18.9402222 C5.34852893,18.9680652 5.3405371,18.9600734 5.27695077,18.8368783 C5.14180461,18.5705453 5.03046895,18.2286748 4.9708602,17.9146474 C4.91121479,17.6045792 4.92316587,17.0640312 4.99076645,16.7301526 C5.04238337,16.4837258 5.03846078,16.4877033 5.15769661,16.4280579 C5.66647892,16.1696984 7.31213501,15.3985422 7.32804534,15.4144342 L7.32804534,15.4144342 Z M14.1847563,15.6927184 L14.1847563,15.8596485 C14.1847563,16.7460629 14.0893676,17.9623784 13.9501889,18.8488294 C13.9263417,19.0038268 13.9063988,19.1309812 13.9024946,19.1350137 C13.9024946,19.1350137 13.7872363,19.1032481 13.6520902,19.0634356 C13.0558744,18.8765992 12.40795,18.6023293 11.8236119,18.28042 C11.437988,18.0697364 10.8775705,17.72387 10.8934991,17.7079597 C10.8974034,17.7040188 11.0643885,17.616567 11.2591251,17.5132048 C12.0383097,17.1077847 12.785527,16.6705438 13.4334514,16.2372806 C13.6759373,16.0742914 14.0415633,15.8119909 14.1211516,15.7404127 L14.1847563,15.6927184 Z M4.3269134,16.8692213 C4.3428054,16.8692213 4.33882782,16.9010237 4.31498065,17.044125 C4.29907032,17.1475055 4.27921907,17.3383011 4.27131889,17.4694147 C4.23944324,18.0497752 4.33490522,18.4790975 4.62108955,19.0673582 C4.70058621,19.2303474 4.76422753,19.3654936 4.76019496,19.3694345 C4.73235188,19.3933183 2.10100682,20.1644928 1.27416453,20.3910317 C1.02773771,20.4585773 0.813131541,20.5182227 0.797147891,20.5221453 C0.769378132,20.5301371 0.765382219,20.5261778 0.777296637,20.4585406 C0.868707719,19.8742759 1.31392203,19.1110749 1.93398501,18.4671098 C2.34739699,18.0378425 2.67733472,17.7874381 3.24176653,17.4654188 C3.64720501,17.2349207 4.2712639,16.8891459 4.31895823,16.8731989 C4.31899489,16.8692213 4.32295415,16.8692213 4.3269134,16.8692213 L4.3269134,16.8692213 Z M10.5278181,17.9782337 C10.5317774,17.9742745 10.627166,18.025983 10.7424243,18.0935286 C11.5930771,18.5864373 12.7775902,19.043566 13.787163,19.2780601 L13.8786474,19.2979663 L13.7514198,19.3694345 C13.2227862,19.6636106 11.4857373,20.3870174 9.708986,21.0508705 C9.45057143,21.1462225 9.19620777,21.2416661 9.14844012,21.2615174 C9.10074579,21.2813687 9.05701071,21.2933197 9.05701071,21.2893605 C9.05701071,21.2853279 9.1286072,21.1462225 9.21996329,20.9753331 C9.71683118,20.045202 10.2177133,18.9123607 10.4720953,18.1253126 C10.503971,18.0497935 10.5237856,17.982248 10.5278181,17.9782337 L10.5278181,17.9782337 Z M9.89580407,18.184958 C9.89983665,18.1890089 9.86799765,18.2724099 9.82822183,18.3677985 C9.48242875,19.2065002 9.02922262,20.1207944 8.44891714,21.1462958 C8.30187489,21.4086696 8.17862482,21.6193532 8.17459224,21.6193532 C8.17068798,21.6193532 8.05139716,21.5477567 7.90831416,21.4603232 C7.06557988,20.9435674 6.3183259,20.3075941 5.82944983,19.691472 L5.75787167,19.6040202 L6.11955675,19.5046356 C7.41540552,19.1509057 8.51640773,18.7693144 9.60956476,18.3002896 C9.76461716,18.2366666 9.89184482,18.184958 9.89580407,18.184958 L9.89580407,18.184958 Z M13.8230346,19.5563076 C13.8230346,19.5563076 13.8270122,19.5602851 13.8230346,19.5563076 C13.8269938,19.647737 13.6242654,20.4665874 13.4572986,21.058789 C13.3181932,21.5556569 13.198884,21.94524 12.9803186,22.6328486 C12.8849299,22.9350166 12.8015107,23.185366 12.7974781,23.185366 C12.7935189,23.185366 12.7696717,23.1814067 12.7458245,23.1735066 C11.565289,22.9587904 10.5079485,22.6606917 9.51421276,22.2632267 C9.23592861,22.151891 8.83846362,21.9730098 8.81461645,21.9531585 C8.80669795,21.9451301 9.04520627,21.8339044 9.34728259,21.7027175 C11.1558729,20.9117101 13.0320272,20.013363 13.6759373,19.6278491 C13.7514381,19.5801364 13.8110835,19.5563076 13.8230346,19.5563076 L13.8230346,19.5563076 Z M4.75623571,19.8663757 C4.76419087,19.8742942 4.25936781,20.6017336 3.55179802,21.5914735 C3.30537119,21.9373032 3.01918687,22.3427234 2.91188379,22.4937615 C2.80454404,22.644818 2.64159146,22.8833263 2.55016205,23.0264277 L2.38314024,23.2848056 L2.204259,23.1337674 C1.99357543,22.9588271 1.6279311,22.5852093 1.46496019,22.3785033 C1.12308971,21.9532319 0.892591545,21.5040583 0.801162133,21.0946789 C0.757427054,20.9038466 0.757427054,20.8084029 0.797129561,20.7965435 C0.856738311,20.7806515 1.91805635,20.5302104 2.91184713,20.2996206 C3.46436452,20.1724663 4.10427875,20.0214281 4.33483191,19.9657786 C4.56540339,19.9100375 4.75227646,19.8663757 4.75623571,19.8663757 L4.75623571,19.8663757 Z M5.26499969,20.0611489 L5.39215403,20.2042319 C5.96461432,20.8442012 6.54891572,21.3172952 7.25644885,21.7305972 C7.38367651,21.8021937 7.47904684,21.8657434 7.47105502,21.8697943 C7.44330359,21.8896455 5.01455862,22.7521211 3.88967258,23.1416859 C3.25769519,23.3642656 2.73694347,23.5431285 2.73302088,23.5431285 C2.72906162,23.5431285 2.69326338,23.519318 2.65345089,23.4914749 L2.58194605,23.4397846 L2.6972043,23.2728728 C3.07082212,22.7322698 3.53993859,22.1400316 4.5614808,20.9078058 L5.26499969,20.0611489 Z M8.43703938,22.3307906 C8.44094364,22.3268497 8.6158473,22.3903994 8.8304718,22.4699877 C9.34728259,22.6647242 9.75662534,22.7879193 10.3052201,22.9270614 C10.9809693,23.0980058 11.9587764,23.2649543 12.5351776,23.3126303 C12.6226295,23.3205488 12.6703238,23.3285406 12.6544135,23.3404734 C12.6265337,23.3563837 12.0422873,23.551157 11.6129833,23.6863031 C10.9292424,23.9009093 8.8424412,24.517013 7.14119061,25.0059624 C6.8271632,25.0973735 6.55685255,25.1729109 6.54096055,25.1768518 C6.50125804,25.1848436 6.37003448,25.1490087 6.37003448,25.1331167 C6.37003448,25.1252166 6.46542314,25.0020031 6.58071805,24.8668387 C7.15306836,24.1831344 7.72153275,23.41997 8.19455348,22.6965266 C8.32568539,22.4977208 8.43703938,22.3347682 8.43703938,22.3307906 Z M7.7374292,22.3507152 C7.74134734,22.3546744 7.45915893,22.8077889 6.96632361,23.5868635 C6.75560338,23.916783 6.52107264,24.2904191 6.43758006,24.421606 C6.3580834,24.548797 6.23884757,24.7475845 6.17130198,24.8588468 L6.05600708,25.0615936 L5.99639832,25.0456832 C5.85326034,25.0059257 4.84762846,24.6521225 4.58129539,24.5448194 C4.25135766,24.4136325 3.90952384,24.2546758 3.65510519,24.1195297 C3.33715519,23.9485853 2.9396902,23.6941666 2.97145588,23.6862665 C2.97939271,23.6823072 3.52397327,23.5351733 4.17979783,23.3563471 C5.92084258,22.8832713 6.88671697,22.6090381 7.51878601,22.4103056 C7.63408092,22.3745257 7.73342884,22.3466826 7.7374292,22.3507152 Z M12.6861791,23.5113261 L12.6901384,23.5113261 C12.7060487,23.5511203 12.0621569,25.3398227 11.8275345,25.9042362 C11.7759359,26.0314272 11.7561213,26.0632845 11.7282416,26.0592336 C11.6606593,26.0553294 10.7265873,25.9241424 10.1581046,25.8406499 C9.16840135,25.6896117 7.50685326,25.3993948 7.08951869,25.3040428 L6.99413003,25.2841916 L7.58631327,25.1489537 C8.8583332,24.8627694 9.47045935,24.707772 10.0905223,24.5169763 C10.8736112,24.2784864 11.6487632,23.980351 12.4317788,23.6146883 C12.5549922,23.5590205 12.6583544,23.5153037 12.6861791,23.5113261 Z"
          id="Shape"
          fill="url(#mssql-linearGradient-2)"
        ></path>
        <path
          d="M9.73285149,0.00758856784 C9.64539966,-0.00427086064 8.23425598,0.504511452 7.3240311,0.874133362 C6.09574624,1.37503383 5.14182294,1.85205047 4.5535073,2.26535247 C4.33492355,2.42044153 4.06059866,2.69467478 4.0169369,2.80197786 C4.0010449,2.84173536 3.99305307,2.88942969 3.99305307,2.93712402 L4.52571921,3.44194708 L5.79368825,3.84738557 L8.81067553,4.38798854 L12.2608711,4.98026343 L12.2966693,4.68214636 C12.2847732,4.68214636 12.2767814,4.67818711 12.2649586,4.67818711 L11.8116975,4.60660895 L11.7203414,4.44365637 C11.2512799,3.61685074 10.7345424,2.59131262 10.4324661,1.89967148 C10.197972,1.36304609 9.97535573,0.743019773 9.85210565,0.297805463 C9.78452341,0.0275131409 9.7766049,0.0116211401 9.73294314,0.00766188734 L9.73294314,0.00757023797 L9.73285149,0.00757023797 L9.73285149,0.00758856784 Z M9.66917351,0.210371964 L9.67326107,0.210371964 C9.67716534,0.214294557 9.69307567,0.325666872 9.70900433,0.456762131 C9.77651325,1.01333043 9.89983665,1.54986417 10.0945732,2.13022464 C10.2416155,2.56748378 10.2416155,2.54365495 10.0707261,2.49194637 C9.66528758,2.38068404 7.8487604,2.06665664 6.53306038,1.88381614 C6.3223768,1.85597306 6.14349556,1.82816664 6.14349556,1.82420739 C6.12760356,1.80831539 7.09347794,1.30345567 7.51880434,1.10475984 C8.06336657,0.854282108 9.55792951,0.230223218 9.66917351,0.210371964 L9.66917351,0.210371964 Z M5.83736834,1.99111922 L5.9924574,2.04273615 C6.83508171,2.32897546 8.95366688,2.73443228 10.1223613,2.82982094 C10.2534932,2.84175369 10.3648472,2.85370477 10.3687515,2.85370477 C10.3727107,2.85766402 10.2614851,2.9172911 10.1183471,2.98483668 C9.55397025,3.26706175 8.93385228,3.61289149 8.50454831,3.87922456 C8.37739397,3.95868456 8.2620624,4.02232588 8.24620706,4.02232588 C8.23029673,4.02232588 8.14685914,4.00641555 8.05940731,3.9944828 L7.90041399,3.97059898 L7.50296733,3.58103417 C6.80337103,2.90136244 6.25481289,2.37668812 6.04412932,2.17790064 L5.83736834,1.99111922 L5.83736834,1.99111922 Z M5.67843,2.11431431 L6.23888423,2.81392894 C6.5449198,3.19949784 6.85496962,3.57709324 6.92260686,3.66053083 C6.99011578,3.74406007 7.04580194,3.81166064 7.04184269,3.81561989 C7.02593236,3.82753431 6.23100238,3.67248191 5.80959858,3.5771299 C5.37633535,3.477727 5.19747244,3.43003266 4.9311577,3.34659508 L4.71251896,3.27501692 L4.71251896,3.21933076 C4.71647821,2.95299769 5.05438944,2.5555327 5.62675809,2.15013088 L5.67843,2.11431431 Z M10.4403663,3.06831093 C10.456295,3.06831093 10.4761096,3.10407251 10.5238039,3.21139393 C10.65895,3.50949267 11.0803722,4.31246946 11.1836244,4.46746687 C11.2155183,4.51919378 11.2710762,4.52315303 10.710677,4.43172362 C9.36321125,4.21304822 8.92989303,4.14158004 8.92989303,4.13362488 C8.92989303,4.12966563 8.96965053,4.10182255 9.02132244,4.07397947 C9.438712,3.8434813 9.86002416,3.54930515 10.233697,3.23527775 C10.3251264,3.15974034 10.4086006,3.08819884 10.424456,3.07624777 C10.4284152,3.06831093 10.436407,3.06435168 10.4403663,3.06831093 Z"
          id="Shape"
          fill="url(#mssql-linearGradient-3)"
        ></path>
        <path
          d="M4.04467,2.74632836 C4.04467,2.74632836 3.95727316,2.8855071 4.04072908,3.09221309 C4.09245598,3.21936742 4.24347581,3.37436484 4.41436523,3.53339482 C4.41436523,3.53339482 6.18319807,5.25849259 6.39785923,5.5049744 C7.37564802,6.63381969 7.80099275,7.74680964 7.84075025,9.28114841 C7.86459741,10.266929 7.67772435,11.1334555 7.21269544,12.139124 C6.38590815,13.9437551 4.64088581,15.9352043 1.94987701,18.1452739 L2.34345606,18.0140869 C2.59783805,17.8232546 2.94366779,17.6205995 3.75452642,17.1753852 C5.62668477,16.1497921 7.73341051,15.2077466 10.3171346,14.2378763 C14.0375674,12.8386653 20.1550529,11.2009644 23.6370141,10.6683899 L23.9987908,10.6127038 L23.9431047,10.5252519 C23.625173,10.0323433 23.4064793,9.72630773 23.1441054,9.40036591 C22.3809778,8.45432445 21.4548792,7.68720089 20.3219647,7.05119092 C18.7637971,6.18072354 16.7484458,5.50101515 14.1966157,4.99619209 C13.7156582,4.90074844 12.6583177,4.71792627 11.7997464,4.58675769 C9.979205,4.30460594 8.80262872,4.10979604 7.50683493,3.88719805 C7.04180603,3.80766473 6.34613232,3.68844723 5.88504434,3.58909931 C5.64655435,3.53737241 5.18948061,3.43006932 4.83173646,3.30685591 C4.54555214,3.19550193 4.13212183,3.08420293 4.04467,2.74632836 L4.04467,2.74632836 Z M5.07026311,3.74010081 C5.0741857,3.73617822 5.13777204,3.75995207 5.22130127,3.78779515 C5.37233943,3.83941207 5.56709435,3.89905748 5.79770249,3.9626988 C5.97216093,4.0106853 6.14705987,4.05705576 6.3223768,4.10180422 C6.56086679,4.16139464 6.75958096,4.21706246 6.76354021,4.21706246 C6.79141995,4.24490554 7.19289918,5.52871159 7.32804534,6.02162023 C7.37964394,6.2084933 7.41947475,6.36744996 7.41549717,6.36744996 C7.41140961,6.37148254 7.36774785,6.30386363 7.31609426,6.21245255 C6.85101037,5.39360209 6.11565249,4.56285554 5.26499969,3.89504324 C5.15375569,3.81561989 5.07026311,3.74406007 5.07026311,3.74010081 L5.07026311,3.74010081 Z M7.02591403,4.28068546 C7.04580194,4.28068546 7.13325377,4.29261821 7.24052019,4.31644704 C7.91626933,4.4674852 9.12864386,4.69803836 9.90372258,4.82922527 C10.0349095,4.84907652 10.13829,4.87297868 10.13829,4.88087885 C10.13829,4.88887068 10.0905407,4.91664044 10.0308952,4.94847943 C9.89978166,5.01602501 9.37107477,5.33001575 9.1962261,5.44928825 C8.75497104,5.74342773 8.35752439,6.06141439 8.0713034,6.34759871 C7.95604516,6.46289362 7.85662392,6.55828228 7.85662392,6.55828228 C7.85662392,6.55828228 7.83285007,6.4907367 7.81288884,6.40720746 C7.66987916,5.85469007 7.3717071,5.03583961 7.10141478,4.45951171 C7.0576797,4.36811896 7.02188146,4.28462638 7.02188146,4.27670787 C7.02188146,4.28464471 7.02188146,4.28068546 7.02591403,4.28068546 L7.02591403,4.28068546 Z M10.4681727,4.93654668 C10.4920199,4.94446519 10.5317774,5.07962968 10.6112557,5.37772842 C10.758353,5.95412964 10.8259352,6.59805811 10.802088,7.19826983 C10.7940962,7.36521833 10.7861777,7.52021574 10.7781859,7.54014031 L10.7662898,7.57984282 L10.5596021,7.51229724 C10.1342757,7.37715107 9.44267126,7.17438601 8.85043303,7.00747418 C8.51250347,6.91604476 8.23830689,6.83257052 8.23830689,6.82463368 C8.23830689,6.80074986 8.73121553,6.30787787 8.94186244,6.12107813 C9.34325002,5.76725657 10.4323745,4.9245956 10.4681727,4.93654668 L10.4681727,4.93654668 Z M10.7424426,4.97624919 C10.7543937,4.96438976 12.3880804,5.24654151 13.1313934,5.38966117 C13.6839475,5.49696425 14.486851,5.66393107 14.534527,5.68383731 C14.5583741,5.69175582 14.4748815,5.73945015 14.2085485,5.85868598 C13.1591999,6.33174337 12.3800702,6.75699645 11.6050465,7.27378891 C11.4023181,7.40893508 11.2313737,7.52021574 11.2274144,7.52021574 C11.2234552,7.52021574 11.2194776,7.40497582 11.2194776,7.26583375 C11.2194776,6.51062461 11.0684211,5.74742365 10.7901186,5.10349517 C10.7623122,5.03989051 10.738465,4.98028176 10.7424426,4.97624919 L10.7424426,4.97624919 Z M14.9677719,5.81102831 C14.9797229,5.82294273 14.9280144,6.14494362 14.88032,6.33570262 C14.737237,6.92797751 14.3516865,7.80649171 13.8787207,8.63322402 C13.7951732,8.78030293 13.7196724,8.89955709 13.7116623,8.90351634 C13.7037987,8.9074756 13.596459,8.84783019 13.4732089,8.77628869 C13.0121393,8.50599637 12.487465,8.25161437 11.9150413,8.01308772 C11.756103,7.94554214 11.6169426,7.88985598 11.612965,7.88197413 C11.5850853,7.85809031 12.865042,7.01143343 13.5407912,6.60599494 C14.0774166,6.28007145 14.9518615,5.79509965 14.9677719,5.81102831 L14.9677719,5.81102831 Z M15.2698482,5.85870431 C15.3056464,5.85870431 16.0290899,6.05747346 16.4066486,6.16877246 C17.340794,6.44703828 18.4139898,6.84052568 19.1135861,7.15851234 L19.4037114,7.28973591 L19.2010563,7.33739358 C17.4918872,7.73088098 16.0290899,8.18408712 14.6179645,8.75645576 C14.502688,8.8041501 14.3993258,8.84390759 14.3914623,8.84390759 C14.3834705,8.84390759 14.423228,8.75249651 14.4748999,8.64116086 C14.9002263,7.73887281 15.1744962,6.79680893 15.2420051,5.99383214 C15.246056,5.91829473 15.2578971,5.85870431 15.2698482,5.85870431 L15.2698482,5.85870431 Z M8.06734415,7.51229724 C8.07924024,7.50034616 8.63177596,7.6315514 8.92989303,7.71495232 C9.38302585,7.84219831 10.3449226,8.16412589 10.3449226,8.18800971 C10.3449226,8.19196896 10.2376379,8.28339838 10.1104836,8.39473403 C9.5897685,8.82799726 9.08888636,9.28505267 8.48863797,9.86541314 C8.30975673,10.0363942 8.15875523,10.1754996 8.15083673,10.1754996 C8.1428449,10.1754996 8.13894064,10.1515975 8.1428449,10.1198135 C8.23425598,9.45200116 8.21444139,8.59344819 8.08723206,7.72294415 C8.07526266,7.61160849 8.06336657,7.51625649 8.06734415,7.51229724 L8.06734415,7.51229724 Z M19.6780912,7.52424831 C19.6859548,7.53214849 19.4236543,7.94554214 19.2567241,8.18003622 C19.0182708,8.52187004 18.6683718,8.9750945 17.8773644,9.96881196 C17.4600848,10.4934496 16.9909684,11.0857612 16.8360076,11.2844937 C16.676941,11.4832262 16.5458274,11.650138 16.5417948,11.650138 C16.5378355,11.650138 16.486237,11.5786331 16.4305508,11.4911996 C15.9853365,10.8233873 15.4526703,10.2390676 14.8206563,9.71439331 C14.7014205,9.6149904 14.5703069,9.50766899 14.5265718,9.47586666 C14.4828367,9.44408266 14.4470385,9.41228033 14.4470385,9.40832107 C14.4470385,9.39642499 15.1227143,9.10618976 15.6355658,8.89953876 C16.533913,8.53382111 17.7580553,8.09659863 18.6763453,7.81435523 C19.1573212,7.6633354 19.6700994,7.51625649 19.6780912,7.52424831 L19.6780912,7.52424831 Z M19.9841268,7.60368999 C19.9999822,7.59974906 20.0954258,7.6474434 20.2107024,7.71495232 C21.1766318,8.26746971 22.1225999,8.97901709 22.8699455,9.71041573 C23.0805924,9.91714005 23.6013075,10.4577247 23.5933157,10.4616839 C23.5933157,10.4616839 23.4104752,10.4775759 23.195869,10.4934496 C21.5224248,10.6206956 19.3799925,10.9744072 17.3209428,11.4712567 C17.1818373,11.5030224 17.0586423,11.5308655 17.0506504,11.5308655 C17.0427869,11.5308655 17.1977477,11.3758681 17.3925576,11.1890683 C18.6008995,10.0244248 19.1534536,9.28906691 19.8052822,7.97730781 C19.896675,7.78258956 19.9762083,7.61564107 19.9841268,7.60368999 C19.9801676,7.60368999 19.9801676,7.60368999 19.9841268,7.60368999 L19.9841268,7.60368999 Z M11.1319708,8.51002894 C11.1876569,8.52188837 11.7043944,8.76444759 12.0939226,8.95916584 C12.4516667,9.13797376 12.9883104,9.4242314 13.0161169,9.44804191 C13.0200761,9.45200116 12.8292438,9.55138574 12.594823,9.66668065 C11.8474774,10.0403168 11.2075448,10.3940467 10.5397142,10.7995035 C10.3489369,10.9147984 10.1899436,11.0102421 10.1859843,11.0102421 C10.170074,11.0102421 10.1740332,10.9942584 10.281373,10.7995035 C10.6391355,10.1476749 10.9252831,9.36858191 11.088309,8.6093402 C11.104146,8.54973144 11.1200747,8.51002894 11.1319708,8.51002894 L11.1319708,8.51002894 Z M10.615215,8.60538094 C10.627166,8.61733202 10.4920199,9.10620809 10.4085823,9.37254116 C10.2455564,9.87736422 9.97130482,10.5093599 9.70502674,10.9863583 C9.64134876,11.0976023 9.54597843,11.2605915 9.49430651,11.3520026 L9.3949586,11.5109959 L9.17236061,11.2964081 C8.91401936,11.045967 8.70329913,10.8909513 8.4330618,10.7517909 C8.32566706,10.6961964 8.24222948,10.648447 8.24222948,10.6405469 C8.24222948,10.6087445 8.92193787,9.9926408 9.44265293,9.54744482 C9.81627075,9.22546225 10.6033189,8.59346652 10.615215,8.60538094 L10.615215,8.60538094 Z M13.7753586,9.9052073 L13.9701501,10.0323616 C14.4152361,10.3225785 14.9399105,10.7081108 15.341463,11.045967 C15.5679653,11.2327484 16.0051877,11.6263275 16.0927129,11.7217161 L16.1403339,11.773443 L15.818443,11.8648358 C13.9979016,12.3696039 12.5907905,12.8187774 10.9491303,13.4230034 C10.7662898,13.490549 10.6112557,13.5461985 10.5993046,13.5461985 C10.5755308,13.5461985 10.5555879,13.5660497 10.9650589,13.1884177 C12.0144626,12.2225983 12.9445387,11.1572477 13.6361982,10.1197951 L13.7753586,9.9052073 L13.7753586,9.9052073 Z M12.9445754,10.111895 C12.9524939,10.1198135 12.40795,10.8869554 12.0819715,11.3202369 C11.6924433,11.8369927 11.0007839,12.7035009 10.5238039,13.267896 C10.3251081,13.5024634 10.1542186,13.6972183 10.1462268,13.7012142 C10.1342757,13.7051735 10.1303165,13.6455647 10.1303165,13.5541353 C10.1303165,13.0731228 10.0071214,12.5603629 9.79244191,12.1231587 C9.7010125,11.9403182 9.68510217,11.8965831 9.70504507,11.8767319 C9.78054582,11.8091313 10.9372342,11.1492925 11.6685962,10.7558051 C12.1614865,10.4934679 12.932551,10.1039398 12.9445754,10.111895 L12.9445754,10.111895 Z M7.92022858,11.3441207 C7.93217966,11.3441207 8.02360907,11.3917784 8.12697123,11.4474646 C8.38135322,11.58657 8.60792879,11.7415857 8.81063887,11.9085709 C8.81855738,11.9164894 8.71525021,12.0000003 8.58010405,12.0993115 C8.20247198,12.3696039 7.63010334,12.8029038 7.29626134,13.0692368 C6.94638071,13.3474843 6.93453961,13.3554212 6.97424211,13.2958124 C7.23661593,12.8943332 7.36772952,12.6677576 7.50690825,12.377614 C7.63010334,12.1192728 7.75329842,11.8131822 7.84075025,11.5468491 C7.87253425,11.4315726 7.91231008,11.3441207 7.92022858,11.3441207 Z M9.25983076,12.3934694 C9.27964536,12.3895468 9.30356584,12.4252717 9.41083227,12.5843017 C9.63740784,12.9221029 9.8123115,13.3753091 9.85610157,13.7409901 L9.86396508,13.8205234 L9.31947617,14.0312069 C8.34555498,14.408784 7.44728117,14.7824568 6.83904096,15.0606493 C6.66816988,15.1401827 6.37003448,15.2832473 6.1752979,15.3787093 C5.98050632,15.4780206 5.821513,15.553558 5.821513,15.5495987 C5.821513,15.5456395 5.94470808,15.4542101 6.09574624,15.3428744 C7.28432859,14.4803622 8.31378931,13.5342841 9.08490878,12.5882793 C9.16840135,12.4888764 9.24395709,12.3974469 9.25183894,12.3934877 L9.25983076,12.3934694 Z M8.64372704,12.5445442 C8.65963737,12.5604362 8.20650455,13.0731778 7.89645473,13.3871868 C7.12929452,14.170294 6.37007114,14.7824568 5.42798893,15.3787093 C5.3087531,15.4542101 5.20145002,15.5217556 5.18949894,15.5297475 C5.16165586,15.5456395 5.19741745,15.5058636 5.61082942,15.0566901 C5.87320324,14.774465 6.07191741,14.535975 6.29849298,14.2418722 C6.44953114,14.0471356 6.47737422,14.0192925 6.69603129,13.8642035 C7.28035101,13.4428547 8.62781671,12.5286155 8.64372704,12.5445442 Z"
          id="Shape"
          fill="url(#mssql-radialGradient-4)"
        ></path>
      </g>
    </g>
  </Svg>
);

export const MySQL = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g id="Icon/MySQL">
      <circle id="Oval" cx="20" cy="20" r="20" fill="#F5F5F5" />
      <g id="Group 17">
        <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6536 27.2871H11.5858C11.5481 25.4849 11.444 23.7901 11.2739 22.2023H11.2645L9.63868 27.2871H8.82569L7.2096 22.2023H7.20021C7.08031 23.7272 7.00487 25.422 6.97358 27.2871H6C6.06275 25.0188 6.22021 22.8921 6.47238 20.9073H7.79579L9.33628 25.5951H9.34584L10.8959 20.9073H12.1623C12.4395 23.2321 12.6032 25.3591 12.6536 27.2871Z"
          fill="#00758F"
        />
        <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2854 22.5802C16.8506 24.9394 16.2771 26.654 15.5652 27.7238C15.0103 28.5478 14.4027 28.9599 13.7409 28.9599C13.5645 28.9599 13.3471 28.9067 13.0889 28.8013V28.2324C13.215 28.251 13.3631 28.2607 13.5332 28.2607C13.8419 28.2607 14.0908 28.1756 14.28 28.0053C14.5067 27.7977 14.62 27.5645 14.62 27.3059C14.62 27.1293 14.5315 26.7673 14.3555 26.2193L13.1836 22.5802H14.2326L15.0736 25.3018C15.2627 25.9197 15.3414 26.3513 15.3099 26.5972C15.7699 25.3685 16.0913 24.0294 16.2741 22.5802H17.2854Z"
          fill="#00758F"
        />
        <path
          id="Fill 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.4997 27.2871H28.4658V20.9073H29.4867V26.5023H31.4997V27.2871Z"
          fill="#F29111"
        />
        <path
          id="Fill 7"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.8724 26.0109C23.614 25.5951 23.4847 24.9277 23.4847 24.0075C23.4847 22.4008 23.9731 21.5971 24.9496 21.5971C25.4602 21.5971 25.8349 21.7893 26.0746 22.1734C26.3328 22.5896 26.4621 23.251 26.4621 24.1584C26.4621 25.7778 25.9736 26.5878 24.9971 26.5878C24.4866 26.5878 24.1118 26.3959 23.8724 26.0109ZM27.6719 27.4412L26.4992 26.8629C26.6036 26.7771 26.7029 26.6848 26.7925 26.5778C27.2904 25.9926 27.5396 25.1261 27.5396 23.979C27.5396 21.8685 26.711 20.8124 25.0539 20.8124C24.2411 20.8124 23.6078 21.0801 23.154 21.6162C22.6559 22.2022 22.4072 23.0653 22.4072 24.2058C22.4072 25.3275 22.6276 26.1502 23.0687 26.6728C23.4721 27.1452 24.0801 27.3815 24.8931 27.3815C25.1967 27.3815 25.4752 27.3443 25.7285 27.2695L27.2555 28.1581L27.6719 27.4412Z"
          fill="#F29111"
        />
        <path
          id="Fill 9"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9625 25.5188C21.9625 26.0599 21.7637 26.5039 21.3674 26.8516C20.9708 27.1975 20.438 27.3711 19.7706 27.3711C19.1467 27.3711 18.5417 27.1715 17.9561 26.7754L18.2301 26.2274C18.7341 26.4794 19.1905 26.6052 19.6001 26.6052C19.9844 26.6052 20.285 26.5197 20.5027 26.3508C20.7198 26.1806 20.8499 25.9433 20.8499 25.6422C20.8499 25.2632 20.5857 24.9394 20.101 24.668C19.6533 24.4224 18.7592 23.9095 18.7592 23.9095C18.2744 23.5562 18.0317 23.1767 18.0317 22.5518C18.0317 22.0351 18.2127 21.6174 18.5747 21.2996C18.9374 20.981 19.4053 20.8217 19.9783 20.8217C20.5706 20.8217 21.109 20.9799 21.5942 21.2948L21.3478 21.8424C20.9328 21.6664 20.5235 21.5781 20.1198 21.5781C19.7925 21.5781 19.5402 21.6568 19.3643 21.8149C19.1872 21.9717 19.078 22.1733 19.078 22.4194C19.078 22.7972 19.348 23.125 19.8462 23.4017C20.2995 23.6476 21.2157 24.1702 21.2157 24.1702C21.7141 24.523 21.9625 24.899 21.9625 25.5188Z"
          fill="#F29111"
        />
        <g id="Group 13">
          <mask
            id="mask0_0_174184"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="22"
            y="10"
            width="12"
            height="12"
          >
            <path
              id="Clip 12"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.3408 10.1647H33.6748V21.2907H22.3408V10.1647Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_0_174184)">
            <path
              id="Fill 11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.7808 18.77C32.1638 18.7546 31.6861 18.8162 31.2852 18.986C31.1696 19.0321 30.985 19.0321 30.969 19.1785C31.0311 19.2401 31.0385 19.3403 31.0929 19.4254C31.1851 19.5796 31.3467 19.7874 31.4936 19.8956C31.6553 20.019 31.8172 20.1419 31.9872 20.2498C32.2875 20.4355 32.6268 20.5431 32.9193 20.7282C33.0894 20.8359 33.2584 20.9746 33.4287 21.0906C33.513 21.1522 33.5666 21.2525 33.6749 21.2907V21.2673C33.6208 21.1981 33.6054 21.098 33.5519 21.0204C33.4748 20.9438 33.3976 20.874 33.3203 20.7974C33.0967 20.4967 32.8188 20.2349 32.5189 20.019C32.272 19.849 31.7321 19.6176 31.6323 19.3333C31.6323 19.3333 31.6244 19.3251 31.6168 19.3175C31.7863 19.3019 31.9872 19.2401 32.1488 19.1933C32.4105 19.1242 32.6495 19.1398 32.9193 19.0706C33.0428 19.0397 33.1662 19.0008 33.29 18.9629V18.8931C33.1505 18.7546 33.0509 18.5693 32.9043 18.4383C32.5115 18.0994 32.0793 17.7681 31.6323 17.4901C31.393 17.3359 31.0846 17.2361 30.8301 17.1049C30.7382 17.0584 30.5841 17.0357 30.5299 16.9581C30.391 16.7886 30.3136 16.5653 30.2137 16.3647C29.9905 15.9411 29.7741 15.4711 29.5817 15.0231C29.443 14.7227 29.3582 14.4225 29.1885 14.1446C28.3941 12.8339 27.5311 12.0405 26.2052 11.2618C25.9199 11.0995 25.5808 11.0302 25.2188 10.9455C25.0257 10.9373 24.8332 10.9225 24.6405 10.9149C24.517 10.8607 24.3934 10.7139 24.2857 10.6446C23.8461 10.3672 22.7134 9.76606 22.3895 10.5599C22.1813 11.0613 22.6978 11.5544 22.8752 11.8089C23.0061 11.9861 23.1761 12.1867 23.268 12.387C23.322 12.5181 23.3375 12.657 23.3917 12.7957C23.5149 13.1348 23.6304 13.5126 23.7926 13.8289C23.8771 13.9906 23.9695 14.1606 24.0774 14.3062C24.1396 14.3917 24.2472 14.4295 24.2704 14.5689C24.1629 14.7227 24.1545 14.9541 24.0929 15.1468C23.8155 16.0181 23.9234 17.0973 24.3165 17.737C24.4396 17.9295 24.7329 18.3538 25.1261 18.1914C25.4729 18.0529 25.3958 17.6136 25.496 17.2284C25.519 17.1352 25.5036 17.0741 25.5498 17.0125V17.0281C25.6576 17.2435 25.7658 17.4512 25.8661 17.6678C26.1052 18.0452 26.5211 18.4383 26.8685 18.7002C27.0529 18.8395 27.1994 19.078 27.4308 19.1632V19.1398H27.4155C27.3692 19.0706 27.3 19.0397 27.2382 18.986C27.0994 18.8471 26.9456 18.6775 26.8372 18.5233C26.5135 18.0918 26.2279 17.6136 25.9741 17.1202C25.8504 16.8807 25.7429 16.6188 25.6424 16.38C25.5963 16.2881 25.5963 16.1487 25.519 16.1028C25.4031 16.2721 25.2341 16.4189 25.1493 16.6262C25.0027 16.9581 24.9875 17.3666 24.9332 17.7909C24.9024 17.7989 24.9179 17.7909 24.9024 17.806C24.656 17.7444 24.5712 17.4901 24.4784 17.275C24.2472 16.727 24.2083 15.8482 24.4091 15.216C24.4628 15.0544 24.6947 14.5458 24.6018 14.3917C24.5553 14.2444 24.4012 14.1606 24.3165 14.0445C24.2165 13.8979 24.108 13.7132 24.0393 13.551C23.8542 13.1195 23.7611 12.6415 23.5613 12.2098C23.4688 12.0092 23.3067 11.8008 23.1761 11.6162C23.0292 11.408 22.8674 11.2618 22.7517 11.0152C22.7134 10.9302 22.6594 10.7915 22.7209 10.6993C22.7362 10.6375 22.7673 10.6141 22.8291 10.5987C22.9289 10.514 23.2143 10.6215 23.3143 10.668C23.5997 10.7831 23.8387 10.8917 24.0774 11.0532C24.1854 11.1307 24.3012 11.2769 24.4396 11.3159H24.6018C24.8484 11.3693 25.1261 11.3308 25.3576 11.4004C25.7658 11.5314 26.1357 11.7243 26.4674 11.9323C27.4769 12.5723 28.3097 13.4822 28.8721 14.5689C28.9647 14.7458 29.0036 14.9079 29.0882 15.0925C29.2501 15.4711 29.4507 15.8566 29.6123 16.2262C29.7741 16.5885 29.9287 16.9581 30.1601 17.2592C30.2754 17.4209 30.7382 17.5056 30.9463 17.5906C31.1001 17.6598 31.3394 17.7215 31.4783 17.806C31.7405 17.9678 32.0019 18.1531 32.2489 18.3306C32.3721 18.4232 32.7575 18.6157 32.7808 18.77Z"
              fill="#00758F"
            />
          </g>
        </g>
        <g id="Group 16">
          <mask
            id="mask1_0_174184"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="31"
            y="26"
            width="3"
            height="2"
          >
            <path
              id="Clip 15"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M31.998 26.5048H33.6744V27.2865H31.998V26.5048Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_0_174184)">
            <path
              id="Fill 14"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.228 27.5048H32.397V26.6746H32.6185V26.5048H31.998V26.6746H32.228V27.5048ZM33.515 27.5048H33.6744V26.5048H33.4348L33.2396 27.1864L33.0271 26.5048H32.7959V27.5048H32.9468V26.744H32.9555L33.178 27.5048H33.293L33.515 26.744V27.5048Z"
              fill="#F29111"
            />
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const NetflixQuiver = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#F5F5F5" />
    {/* Netflix's 26x40 artwork, scaled to 24px tall and centered in the circle. */}
    <g transform="translate(12.2 8) scale(0.6)" fill="none">
      <defs>
        <linearGradient
          id="netflixQuiver_paint0_linear"
          gradientUnits="userSpaceOnUse"
          x1="17.1999"
          x2="19.4539"
          y1="26.3958"
          y2="25.7552"
        >
          <stop offset="0.354167" stopColor="#7C020D" />
          <stop offset="1" stopColor="#B20710" />
        </linearGradient>
        <linearGradient
          id="netflixQuiver_paint1_linear"
          gradientUnits="userSpaceOnUse"
          x1="9.4"
          x2="6.79079"
          y1="12.7986"
          y2="13.552"
        >
          <stop offset="0.489583" stopColor="#7C020D" />
          <stop offset="1" stopColor="#B20710" />
        </linearGradient>
      </defs>
      <path
        d="M25.25 0.75V38.0799C25.2039 38.0709 25.1561 38.0618 25.1068 38.0524C24.4325 37.924 23.4612 37.7533 22.2668 37.5828C19.8797 37.242 16.5929 36.9005 13 36.9005C9.40712 36.9005 6.12027 37.242 3.73323 37.5828C2.53883 37.7533 1.56751 37.924 0.893176 38.0524C0.843856 38.0618 0.796121 38.0709 0.75 38.0799V0.75H25.25Z"
        stroke="#E50914"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2572 6V11.3261V18.239V19.5319C15.4177 19.9736 16.0965 21.8486 16.2702 22.3208V22.3208C16.5948 23.2212 18.4425 28.304 18.5902 28.7107V28.7107C18.7226 29.0755 19.0914 30.0897 19.2086 30.4142V30.4142C19.2772 30.602 19.456 31.0934 19.5511 31.3555V31.3555C19.6254 31.5604 19.6188 31.5436 19.6648 31.6704V31.6704C19.7308 31.6962 20.3646 31.9464 20.4556 31.9825V31.9825C20.4581 31.9834 20.4634 31.9856 20.4699 31.9882V31.9882C20.4803 31.9922 20.4762 31.9904 20.4813 31.9925V31.9925C20.4922 31.9967 20.4958 31.9982 20.4997 31.9998V31.9998C20.4998 31.8056 20.4999 31.5183 20.5 31.2109V31.2109V6H15.2572Z"
        fill="url(#netflixQuiver_paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 7.80666V9.61582V16.4022V31.9998C7.5826 31.7561 8.62418 31.6614 10.7427 31.5675V26.6735V19.7608V18.4679C10.5823 18.0262 6.54387 6.90635 6.44881 6.64422C6.37444 6.43932 6.38114 6.4562 6.33508 6.32944C6.26912 6.30353 5.63527 6.05334 5.54435 6.01723C5.51961 6.00757 5.52367 6.00931 5.51868 6.00729C5.5077 6.00306 5.50414 6.00153 5.50021 6C5.50014 6.19406 5.50007 6.48148 5.5 6.78883V7.80666Z"
        fill="url(#netflixQuiver_paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8558 6H5.5L14.9839 31.5676C17.649 31.6317 20.5 32 20.5 32L10.8558 6Z"
        fill="#E50914"
      />
    </g>
  </Svg>
);

export const Netsuite = ({ ...props }) => (
  <Svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="30" cy="30" r="30" fill="#F5F5F5" />
    <path d="M15 13.5H46.5V45H15V13.5Z" fill="black" />
    <path
      d="M22.3501 37.2999V21.2H28.1251L35.3001 32.05V21.2H39.1501V37.2999H33.3751L26.2001 26.45V37.2999H22.3501Z"
      fill="white"
    />
  </Svg>
);

export const Quickbooks = ({ ...props }) => (
  <Svg
    width="400"
    height="400"
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_2)">
      <path
        d="M197.217 293.5C270.532 293.5 329.967 234.066 329.967 160.75C329.967 87.4342 270.532 28 197.217 28C123.901 28 64.4666 87.4342 64.4666 160.75C64.4666 234.066 123.901 293.5 197.217 293.5Z"
        fill="#2CA01C"
      />
      <path
        d="M101.982 161.4C101.982 189.912 125.095 213.025 153.607 213.025H160.982V193.85H153.607C135.685 193.85 121.157 179.322 121.157 161.4C121.157 143.478 135.685 128.95 153.607 128.95H171.307V229.25C171.307 239.84 179.892 248.425 190.482 248.425V109.775H153.607C125.095 109.775 101.982 132.888 101.982 161.4ZM242.107 109.775H234.732V128.95H242.107C260.028 128.95 274.557 143.478 274.557 161.4C274.557 179.322 260.028 193.85 242.107 193.85H224.407V93.55C224.407 82.9599 215.822 74.375 205.232 74.375V213.025H242.107C270.618 213.025 293.732 189.912 293.732 161.4C293.732 132.888 270.618 109.775 242.107 109.775Z"
        fill="white"
      />
      <path
        d="M106.614 350.047C105.595 350.674 104.497 351.171 103.322 351.536C102.146 351.876 100.892 352.046 99.5595 352.046C97.5216 352.046 95.6667 351.641 93.9946 350.831C92.3487 350.021 90.9248 348.963 89.723 347.657C88.5473 346.351 87.6329 344.848 86.9797 343.15C86.3266 341.452 86 339.714 86 337.938C86 336.083 86.3396 334.307 87.0189 332.608C87.7243 330.91 88.6779 329.408 89.8797 328.101C91.1077 326.795 92.5577 325.763 94.2297 325.005C95.9018 324.221 97.7176 323.829 99.677 323.829C101.689 323.829 103.518 324.248 105.164 325.084C106.836 325.894 108.259 326.965 109.435 328.298C110.611 329.63 111.525 331.145 112.178 332.843C112.832 334.541 113.158 336.266 113.158 338.016C113.158 339.819 112.832 341.543 112.178 343.19C111.551 344.835 110.663 346.298 109.514 347.578L113.315 351.85H108.22L106.614 350.047ZM99.5986 347.265C100.304 347.265 100.957 347.186 101.558 347.03C102.185 346.847 102.76 346.612 103.282 346.325L99.05 341.543H104.145L106.065 343.698C106.587 342.863 106.992 341.948 107.28 340.955C107.567 339.963 107.711 338.957 107.711 337.938C107.711 336.736 107.515 335.573 107.123 334.45C106.757 333.327 106.222 332.333 105.516 331.472C104.837 330.609 103.988 329.917 102.969 329.395C101.976 328.872 100.853 328.611 99.5986 328.611C98.2923 328.611 97.1297 328.885 96.1108 329.434C95.0919 329.956 94.2428 330.662 93.5635 331.55C92.8842 332.438 92.3617 333.444 91.9959 334.568C91.6563 335.665 91.4865 336.789 91.4865 337.938C91.4865 339.14 91.6694 340.302 92.0351 341.426C92.4009 342.549 92.9234 343.542 93.6027 344.404C94.3081 345.266 95.1572 345.959 96.15 346.481C97.1689 347.004 98.3185 347.265 99.5986 347.265ZM123.029 352.242C120.913 352.242 119.307 351.563 118.209 350.204C117.112 348.846 116.563 346.833 116.563 344.169V331.315H121.814V343.032C121.814 346.194 122.951 347.775 125.224 347.775C126.243 347.775 127.222 347.474 128.163 346.873C129.13 346.246 129.914 345.306 130.514 344.051V331.315H135.766V345.815C135.766 346.364 135.857 346.756 136.04 346.991C136.249 347.225 136.576 347.356 137.02 347.383V351.85C136.497 351.955 136.053 352.02 135.687 352.046C135.347 352.072 135.034 352.085 134.747 352.085C133.807 352.085 133.036 351.876 132.434 351.458C131.86 351.014 131.52 350.413 131.415 349.655L131.298 348.009C130.383 349.42 129.208 350.478 127.771 351.184C126.334 351.889 124.753 352.242 123.029 352.242ZM140.984 351.85V331.315H146.236V351.85H140.984ZM140.984 328.454V323.242H146.236V328.454H140.984ZM149.679 341.582C149.679 340.145 149.928 338.787 150.424 337.507C150.921 336.226 151.639 335.103 152.58 334.136C153.52 333.17 154.657 332.399 155.989 331.825C157.322 331.249 158.823 330.962 160.496 330.962C162.742 330.962 164.65 331.446 166.218 332.412C167.811 333.378 169 334.646 169.783 336.213L164.65 337.781C164.206 337.023 163.618 336.449 162.887 336.057C162.155 335.639 161.345 335.43 160.457 335.43C159.699 335.43 158.994 335.586 158.341 335.9C157.688 336.187 157.112 336.605 156.617 337.154C156.146 337.676 155.767 338.316 155.48 339.074C155.219 339.832 155.088 340.668 155.088 341.582C155.088 342.497 155.232 343.333 155.519 344.09C155.806 344.848 156.185 345.501 156.656 346.05C157.152 346.599 157.727 347.03 158.38 347.343C159.033 347.631 159.725 347.775 160.457 347.775C161.397 347.775 162.26 347.539 163.043 347.069C163.853 346.599 164.415 346.024 164.729 345.345L169.862 346.912C169.157 348.48 167.994 349.76 166.374 350.752C164.755 351.745 162.808 352.242 160.535 352.242C158.863 352.242 157.361 351.955 156.028 351.38C154.696 350.805 153.559 350.034 152.619 349.068C151.679 348.075 150.947 346.938 150.424 345.658C149.928 344.351 149.679 342.993 149.679 341.582ZM187.123 351.85L181.166 342.954L178.345 345.736V351.85H173.093V323.242H178.345V340.603L186.575 331.354H192.178L184.537 340.054L192.727 351.85H187.123ZM217.872 344.678C217.872 345.854 217.636 346.886 217.166 347.775C216.696 348.662 216.043 349.407 215.206 350.008C214.397 350.609 213.443 351.066 212.346 351.38C211.275 351.694 210.125 351.85 208.897 351.85H195.455V324.026H210.347C211.314 324.026 212.189 324.234 212.973 324.653C213.757 325.071 214.423 325.619 214.972 326.298C215.52 326.952 215.938 327.709 216.226 328.572C216.54 329.408 216.696 330.257 216.696 331.119C216.696 332.478 216.356 333.757 215.677 334.96C214.998 336.135 214.005 337.01 212.698 337.585C214.292 338.055 215.546 338.905 216.461 340.132C217.401 341.334 217.872 342.85 217.872 344.678ZM212.424 343.659C212.424 343.163 212.333 342.693 212.15 342.248C211.993 341.779 211.771 341.374 211.484 341.034C211.197 340.694 210.857 340.433 210.465 340.25C210.073 340.041 209.642 339.937 209.171 339.937H200.864V347.265H208.897C209.394 347.265 209.851 347.173 210.269 346.991C210.713 346.807 211.092 346.559 211.405 346.246C211.719 345.906 211.967 345.514 212.15 345.07C212.333 344.626 212.424 344.156 212.424 343.659ZM200.864 328.65V335.665H208.074C208.989 335.665 209.76 335.352 210.386 334.725C211.039 334.097 211.366 333.235 211.366 332.138C211.366 331.067 211.066 330.217 210.465 329.59C209.89 328.964 209.171 328.65 208.31 328.65H200.864ZM231.066 352.242C229.394 352.242 227.892 351.955 226.559 351.38C225.227 350.805 224.09 350.034 223.15 349.068C222.235 348.075 221.53 346.938 221.034 345.658C220.537 344.378 220.289 343.032 220.289 341.622C220.289 340.185 220.537 338.826 221.034 337.546C221.53 336.266 222.235 335.142 223.15 334.176C224.09 333.183 225.227 332.399 226.559 331.825C227.892 331.249 229.394 330.962 231.066 330.962C232.739 330.962 234.227 331.249 235.534 331.825C236.866 332.399 237.99 333.183 238.904 334.176C239.845 335.142 240.563 336.266 241.059 337.546C241.556 338.826 241.804 340.185 241.804 341.622C241.804 343.032 241.556 344.378 241.059 345.658C240.563 346.938 239.857 348.075 238.943 349.068C238.029 350.034 236.906 350.805 235.573 351.38C234.24 351.955 232.739 352.242 231.066 352.242ZM225.697 341.622C225.697 342.536 225.828 343.372 226.089 344.13C226.377 344.861 226.755 345.501 227.225 346.05C227.722 346.599 228.297 347.03 228.95 347.343C229.603 347.631 230.308 347.775 231.066 347.775C231.824 347.775 232.529 347.631 233.182 347.343C233.835 347.03 234.397 346.599 234.868 346.05C235.364 345.501 235.743 344.848 236.004 344.09C236.292 343.333 236.435 342.497 236.435 341.582C236.435 340.694 236.292 339.871 236.004 339.113C235.743 338.356 235.364 337.703 234.868 337.154C234.397 336.605 233.835 336.187 233.182 335.9C232.529 335.586 231.824 335.43 231.066 335.43C230.308 335.43 229.603 335.586 228.95 335.9C228.297 336.213 227.722 336.644 227.225 337.194C226.755 337.742 226.377 338.395 226.089 339.153C225.828 339.91 225.697 340.734 225.697 341.622ZM254.832 352.242C253.16 352.242 251.658 351.955 250.326 351.38C248.993 350.805 247.857 350.034 246.916 349.068C246.002 348.075 245.296 346.938 244.8 345.658C244.304 344.378 244.056 343.032 244.056 341.622C244.056 340.185 244.304 338.826 244.8 337.546C245.296 336.266 246.002 335.142 246.916 334.176C247.857 333.183 248.993 332.399 250.326 331.825C251.658 331.249 253.16 330.962 254.832 330.962C256.504 330.962 257.993 331.249 259.3 331.825C260.633 332.399 261.756 333.183 262.67 334.176C263.61 335.142 264.329 336.266 264.826 337.546C265.322 338.826 265.57 340.185 265.57 341.622C265.57 343.032 265.322 344.378 264.826 345.658C264.329 346.938 263.623 348.075 262.709 349.068C261.795 350.034 260.672 350.805 259.339 351.38C258.006 351.955 256.504 352.242 254.832 352.242ZM249.463 341.622C249.463 342.536 249.594 343.372 249.855 344.13C250.142 344.861 250.521 345.501 250.992 346.05C251.488 346.599 252.063 347.03 252.716 347.343C253.369 347.631 254.074 347.775 254.832 347.775C255.59 347.775 256.295 347.631 256.948 347.343C257.601 347.03 258.164 346.599 258.633 346.05C259.13 345.501 259.509 344.848 259.77 344.09C260.057 343.333 260.201 342.497 260.201 341.582C260.201 340.694 260.057 339.871 259.77 339.113C259.509 338.356 259.13 337.703 258.633 337.154C258.164 336.605 257.601 336.187 256.948 335.9C256.295 335.586 255.59 335.43 254.832 335.43C254.074 335.43 253.369 335.586 252.716 335.9C252.063 336.213 251.488 336.644 250.992 337.194C250.521 337.742 250.142 338.395 249.855 339.153C249.594 339.91 249.463 340.734 249.463 341.622ZM283.144 351.85L277.188 342.954L274.366 345.736V351.85H269.115V323.242H274.366V340.603L282.596 331.354H288.2L280.557 340.054L288.748 351.85H283.144ZM298.726 352.242C297.002 352.242 295.317 351.968 293.671 351.419C292.025 350.87 290.614 350.086 289.439 349.068L291.398 345.775C292.653 346.664 293.867 347.343 295.043 347.814C296.245 348.257 297.433 348.48 298.609 348.48C299.654 348.48 300.477 348.284 301.078 347.892C301.679 347.5 301.979 346.938 301.979 346.207C301.979 345.475 301.626 344.94 300.921 344.6C300.216 344.261 299.066 343.869 297.473 343.424C296.14 343.059 295.004 342.706 294.063 342.366C293.122 342.027 292.365 341.648 291.79 341.23C291.216 340.785 290.797 340.289 290.536 339.74C290.274 339.166 290.144 338.487 290.144 337.703C290.144 336.658 290.34 335.717 290.732 334.881C291.15 334.045 291.725 333.34 292.456 332.765C293.188 332.164 294.037 331.707 295.004 331.393C295.996 331.08 297.067 330.923 298.217 330.923C299.759 330.923 301.195 331.145 302.528 331.589C303.887 332.033 305.127 332.752 306.251 333.744L304.135 336.919C303.09 336.135 302.071 335.56 301.078 335.194C300.111 334.829 299.144 334.646 298.178 334.646C297.29 334.646 296.545 334.829 295.944 335.194C295.343 335.56 295.043 336.148 295.043 336.958C295.043 337.324 295.108 337.624 295.238 337.86C295.396 338.095 295.63 338.303 295.944 338.487C296.257 338.669 296.662 338.852 297.159 339.035C297.681 339.192 298.322 339.361 299.079 339.545C300.49 339.91 301.692 340.276 302.684 340.642C303.703 341.008 304.527 341.426 305.153 341.896C305.806 342.366 306.277 342.914 306.564 343.542C306.878 344.143 307.035 344.874 307.035 345.736C307.035 347.748 306.29 349.342 304.801 350.518C303.312 351.667 301.287 352.242 298.726 352.242Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_2">
        <rect width="400" height="400" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);

export const Redshift = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g id="Icon/Redshift" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#E6F3FF" x="0" y="0" width="40" height="40" rx="20"></rect>
      <g id="amazon-redshift-logo" transform="translate(9.000000, 8.000000)">
        <polygon
          id="Path"
          fill="#205B98"
          fillRule="nonzero"
          points="10.9087839 18.3325025 20.0346332 20.5405025 20.0346332 3.40926633 10.9087839 5.61726633"
        ></polygon>
        <polygon
          id="Path"
          fill="#5294CF"
          fillRule="nonzero"
          points="20.0310151 3.40926633 21.7857889 4.28665327 21.7857889 19.6667337 20.0310151 20.5441809"
        ></polygon>
        <polygon
          id="Path"
          fill="#5294CF"
          fillRule="nonzero"
          points="10.9087839 18.3325025 1.78661307 20.5405025 1.78661307 3.40926633 10.9087839 5.61726633"
        ></polygon>
        <polygon
          id="Path"
          fill="#205B98"
          fillRule="nonzero"
          points="1.78661307 3.40926633 0.0317788945 4.28665327 0.0317788945 19.6667337 1.78661307 20.5441809"
        ></polygon>
        <polygon
          id="Path"
          fill="#5294CF"
          fillRule="nonzero"
          points="13.2437186 23.9848643 16.7098492 22.2553568 16.7098492 1.74868342 13.2437186 0.0156180905 12.156 11.4146533"
        ></polygon>
        <polygon
          id="Path"
          fill="#205B98"
          fillRule="nonzero"
          points="8.57384925 23.9848643 5.10771859 22.2553568 5.10771859 1.74868342 8.57384925 0.0156180905 9.66156784 11.374794"
        ></polygon>
        <rect
          id="Rectangle"
          fill="#2D72B8"
          x="8.57384925"
          y="0.0156180905"
          width="4.67348744"
          height="23.9692462"
        ></rect>
      </g>
    </g>
  </Svg>
);

export const Salesforce = ({ ...props }) => {
  return (
    <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
      <defs>
        <polygon
          id="sf-path-1"
          points="1.61434978e-05 0.047398378 23.995496 0.047398378 23.995496 16.8205021 1.61434978e-05 16.8205021"
        ></polygon>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-394.000000, -4278.000000)">
          <g transform="translate(394.000000, 4278.000000)">
            <rect
              fill="#E6F3FF"
              fillRule="nonzero"
              x="0"
              y="0"
              width="40"
              height="40"
              rx="20"
            ></rect>
            <g transform="translate(8.000000, 12.000000)">
              <g>
                <mask id="sf-mask-2" fill="white">
                  <use xlinkHref="#sf-path-1"></use>
                </mask>
                <g id="Clip-2"></g>
                <path
                  d="M9.98530762,1.87668557 C10.7590117,1.07161176 11.8364287,0.572209126 13.0280879,0.572209126 C14.6121955,0.572209126 15.9939713,1.45407691 16.7300072,2.7634974 C17.3697202,2.4782473 18.0775049,2.31939287 18.8223659,2.31939287 C21.6792807,2.31939287 23.995496,4.65266133 23.995496,7.53074243 C23.995496,10.4092534 21.6792807,12.7424682 18.8223659,12.7424682 C18.4735587,12.7424682 18.1328771,12.7072687 17.8031193,12.6410614 C17.1552807,13.7951743 15.9202493,14.5753129 14.5025274,14.5753129 C13.9094152,14.5753129 13.3482673,14.438653 12.8481955,14.1949436 C12.1915857,15.7381854 10.6606439,16.8205021 8.87689507,16.8205021 C7.01904753,16.8205021 5.43558565,15.6466667 4.82794439,14.0001911 C4.56238386,14.0561878 4.28697578,14.0857446 4.00484126,14.0857446 C1.792913,14.0857446 1.61434978e-05,12.2765453 1.61434978e-05,10.0446836 C1.61434978e-05,8.54862528 0.805146188,7.24269786 2.00240179,6.54392109 C1.75589058,5.97723641 1.61904753,5.35245915 1.61904753,4.69527687 C1.61904753,2.12850961 3.70580987,0.04738763 6.2795139,0.04738763 C7.79065291,0.04738763 9.13363049,0.764812059 9.98530762,1.87668557"
                  id="Fill-1"
                  fill="#129CD7"
                  mask="url(#sf-mask-2)"
                ></path>
              </g>
              <path
                d="M3.49260031,8.82441427 C3.47767343,8.8637896 3.49778767,8.87188997 3.50265743,8.87859558 C3.54706754,8.9112653 3.59179524,8.93481539 3.637264,8.96120867 C3.87799962,9.09054643 4.10555513,9.12820513 4.34316775,9.12820513 C4.8274444,9.12820513 5.12820513,8.86733016 5.12820513,8.44718358 L5.12820513,8.43908321 C5.12820513,8.05064075 4.78859217,7.90928654 4.47052261,7.80736129 L4.42886497,7.79400372 C4.18881747,7.71487755 3.98169379,7.64664128 3.98169379,7.48635043 L3.98169379,7.47825006 C3.98169379,7.34113378 4.10280265,7.2402278 4.29044728,7.2402278 C4.4989472,7.2402278 4.74629934,7.31055621 4.90551938,7.39987491 C4.90551938,7.39987491 4.95268197,7.43045248 4.9696732,7.38442519 C4.9790422,7.35942668 5.05955207,7.13969732 5.06823295,7.11577171 C5.07723142,7.09012947 5.0612459,7.07081732 5.04462519,7.06062479 C4.86248551,6.94845338 4.61100465,6.87179487 4.35078998,6.87179487 L4.30262169,6.87217039 C3.85926162,6.87217039 3.54982001,7.14355975 3.54982001,7.53243137 L3.54982001,7.5404781 C3.54982001,7.95005663 3.89117974,8.08331047 4.21099606,8.17579422 L4.26234029,8.19194132 C4.49545367,8.26441553 4.69633135,8.32696544 4.69633135,8.49288901 L4.69633135,8.5013649 C4.69633135,8.65323351 4.5655359,8.76642417 4.35534215,8.76642417 C4.27345605,8.76642417 4.01292378,8.7650294 3.73158917,8.58467537 C3.6976067,8.56423668 3.67818059,8.54985985 3.65182035,8.53371275 C3.63795212,8.52491499 3.6032286,8.50978714 3.58798413,8.55581443 L3.49260031,8.82441427 Z"
                id="Fill-4"
                fill="#FEFEFE"
              ></path>
              <path
                d="M10.6720875,8.82441427 C10.6571606,8.8637896 10.6772748,8.87188997 10.6821446,8.87859558 C10.7265547,8.9112653 10.7712824,8.93481539 10.8166982,8.96120867 C11.0574868,9.09054643 11.2850423,9.12820513 11.5226549,9.12820513 C12.0069316,9.12820513 12.3076923,8.86733016 12.3076923,8.44718358 L12.3076923,8.43908321 C12.3076923,8.05064075 11.9680793,7.90928654 11.6500098,7.80736129 L11.6083522,7.79400372 C11.3683046,7.71487755 11.161181,7.64664128 11.161181,7.48635043 L11.161181,7.47825006 C11.161181,7.34113378 11.2822898,7.2402278 11.4699345,7.2402278 C11.6784344,7.2402278 11.9257865,7.31055621 12.0850066,7.39987491 C12.0850066,7.39987491 12.1321691,7.43045248 12.1491604,7.38442519 C12.1585294,7.35942668 12.2390393,7.13969732 12.2477201,7.11577171 C12.2567186,7.09012947 12.2407331,7.07081732 12.2241124,7.06062479 C12.0419727,6.94845338 11.7908094,6.87179487 11.5302772,6.87179487 L11.4821089,6.87217039 C11.0387488,6.87217039 10.7293072,7.14355975 10.7293072,7.53243137 L10.7293072,7.5404781 C10.7293072,7.95005663 11.0710374,8.08331047 11.3904832,8.17579422 L11.4418275,8.19194132 C11.6749409,8.26441553 11.8761891,8.32696544 11.8761891,8.49288901 L11.8761891,8.5013649 C11.8761891,8.65323351 11.7453936,8.76642417 11.5348293,8.76642417 C11.4529432,8.76642417 11.1927815,8.7650294 10.9110763,8.58467537 C10.8770939,8.56423668 10.8569796,8.55055724 10.8313075,8.53371275 C10.8226267,8.52808004 10.7817101,8.51187929 10.7678418,8.55581443 L10.6720875,8.82441427 Z"
                id="Fill-6"
                fill="#FEFEFE"
              ></path>
              <path
                d="M15.6206665,7.8995682 C15.6206665,8.13838633 15.5752377,8.32694685 15.485865,8.45995948 C15.3972073,8.59156856 15.2634508,8.65596956 15.0771156,8.65596956 C14.8903954,8.65596956 14.7574088,8.59156856 14.6701811,8.45995948 C14.5818534,8.32694685 14.5371945,8.13838633 14.5371945,7.8995682 C14.5371945,7.66112795 14.5818534,7.47289133 14.6697961,7.34133622 C14.7574088,7.21113068 14.8903954,7.14775534 15.0771156,7.14775534 C15.2634508,7.14775534 15.3972073,7.21113068 15.485865,7.34133622 C15.5752377,7.47289133 15.6206665,7.66112795 15.6206665,7.8995682 M16.0405807,7.45664263 C15.9994968,7.31974326 15.9349834,7.1990926 15.8495156,7.09863136 C15.7641028,6.99779224 15.6556456,6.91676466 15.526949,6.85803181 C15.3986373,6.79929896 15.2472262,6.76923077 15.0771156,6.76923077 C14.90662,6.76923077 14.7548789,6.79929896 14.6265672,6.85803181 C14.4982555,6.91676466 14.3897433,6.99779224 14.3042755,7.09895526 C14.2185327,7.19947048 14.1544044,7.32006716 14.1133204,7.45664263 C14.0722365,7.59284022 14.0512821,7.74177765 14.0512821,7.8995682 C14.0512821,8.05735875 14.0722365,8.20662008 14.1133204,8.34249378 C14.1544044,8.47906925 14.2185327,8.5997199 14.3042755,8.70050504 C14.3897433,8.80134416 14.4986405,8.88204785 14.6269522,8.93932317 C14.7552639,8.99665248 14.90662,9.02564103 15.0771156,9.02564103 C15.2472262,9.02564103 15.3982523,8.99665248 15.526949,8.93932317 C15.6552606,8.88204785 15.7637728,8.80134416 15.8495156,8.70050504 C15.9349834,8.60009778 15.9994968,8.47944712 16.0405807,8.34249378 C16.0816646,8.20629619 16.1025641,8.05735875 16.1025641,7.8995682 C16.1025641,7.74177765 16.0816646,7.59284022 16.0405807,7.45664263"
                id="Fill-8"
                fill="#FEFEFE"
              ></path>
              <path
                d="M19.3857959,8.59306301 C19.3727557,8.55312941 19.3346299,8.56834735 19.3346299,8.56834735 C19.2766557,8.59133615 19.2148584,8.61216638 19.1486621,8.62279735 C19.0820467,8.63375211 19.0086232,8.63904061 18.9296484,8.63904061 C18.7364534,8.63904061 18.5823268,8.57962589 18.4721392,8.46257727 C18.3619515,8.34515091 18.2998924,8.15557424 18.3005208,7.89918974 C18.3012016,7.66611782 18.3557718,7.49073377 18.4539666,7.35668639 C18.5514282,7.2237183 18.7000558,7.15545343 18.8977547,7.15545343 C19.0624601,7.15545343 19.1884113,7.17525834 19.320228,7.2176743 C19.320228,7.2176743 19.3518598,7.23181295 19.366576,7.18939699 C19.4019261,7.08891542 19.4276924,7.01784441 19.465085,6.90786512 C19.4757162,6.87640392 19.4496357,6.86329059 19.4399995,6.85940515 C19.388205,6.83852096 19.2660245,6.80425362 19.1733286,6.78973721 C19.087179,6.7763001 18.9859467,6.76923077 18.8734024,6.76923077 C18.7055547,6.76923077 18.5558797,6.79891115 18.427886,6.85762433 C18.2998924,6.91601373 18.1917472,6.99701418 18.1055976,7.09781953 C18.0197623,7.19857093 17.9545609,7.31918119 17.9113552,7.45571093 C17.8677305,7.59186292 17.8461538,7.74107427 17.8461538,7.89951352 C17.8461538,8.24116166 17.9353933,8.51740503 18.1121439,8.71933953 C18.2892088,8.9226771 18.5548846,9.02564103 18.9015254,9.02564103 C19.106399,9.02564103 19.3164573,8.98284732 19.4678082,8.92159781 C19.4678082,8.92159781 19.4966644,8.90713537 19.4839384,8.87249028 L19.3857959,8.59306301 Z"
                id="Fill-10"
                fill="#FEFEFE"
              ></path>
              <path
                d="M20.0819374,7.67029987 C20.1019413,7.53761188 20.1387332,7.42727248 20.1959105,7.34127901 C20.2819763,7.21075031 20.413446,7.13857625 20.5984956,7.13857625 C20.7834907,7.13857625 20.9053128,7.21075031 20.9932318,7.34127901 C21.0514447,7.42759638 21.0767902,7.54220036 21.0868194,7.67067774 L20.0819374,7.67029987 Z M21.4829728,7.37879656 C21.447598,7.24643247 21.3600606,7.1130967 21.3028833,7.05225888 C21.2121844,6.95530704 21.1232298,6.88772146 21.0353653,6.85025789 C20.9206836,6.8014041 20.7827821,6.76923077 20.6316901,6.76923077 C20.4559611,6.76923077 20.2963115,6.79859703 20.1666405,6.85873308 C20.0369695,6.91886913 19.928011,7.00129979 19.8422723,7.10391975 C19.7568606,7.20616183 19.6925429,7.32783747 19.651554,7.46619357 C19.6104561,7.60341605 19.5897436,7.75305442 19.5897436,7.91122195 C19.5897436,8.07219655 19.6111101,8.22221279 19.6536797,8.3566282 C19.6965218,8.49282502 19.7651455,8.61207146 19.8576431,8.71150648 C19.9505222,8.81126539 20.0694554,8.88905358 20.2119899,8.94389939 C20.3537614,8.99804343 20.5259474,9.02633005 20.7235335,9.02564103 C21.1303701,9.02454864 21.3446897,8.93472243 21.4329358,8.88624651 C21.4486337,8.87739345 21.4632959,8.86254838 21.4450907,8.81941668 L21.3525932,8.56391944 C21.3386395,8.52607799 21.2997219,8.5398974 21.2997219,8.5398974 C21.1986123,8.57703708 21.0556962,8.64354302 20.7213533,8.64284126 C20.5027822,8.64251736 20.3409523,8.57881849 20.2395157,8.47868171 C20.1355173,8.37676352 20.0840631,8.22680126 20.0755056,8.01486757 L21.4840629,8.01594721 C21.4840629,8.01594721 21.5211818,8.01556933 21.5251063,7.9795093 C21.5265235,7.96466422 21.5732901,7.69291836 21.4829728,7.37879656 L21.4829728,7.37879656 Z"
                id="Fill-12"
                fill="#FEFEFE"
              ></path>
              <path
                d="M9.00504976,7.67029987 C9.02505288,7.53761188 9.06184335,7.42727248 9.11863694,7.34127901 C9.20546245,7.21075031 9.33654554,7.13857625 9.52158798,7.13857625 C9.70663042,7.13857625 9.82877479,7.21075031 9.91663588,7.34127901 C9.97451956,7.42759638 9.9998641,7.54220036 10.0098929,7.67067774 L9.00504976,7.67029987 Z M10.4060309,7.37879656 C10.3706575,7.24643247 10.2831235,7.1130967 10.2259484,7.05225888 C10.135253,6.95530704 10.0466834,6.88772146 9.95844076,6.85025789 C9.84338197,6.8014041 9.70586736,6.76923077 9.55516269,6.76923077 C9.37905897,6.76923077 9.21941558,6.79859703 9.0896951,6.85873308 C8.96002913,6.91886913 8.85107483,7.00129979 8.76539391,7.10391975 C8.67998551,7.20616183 8.61572482,7.32783747 8.5746285,7.46619357 C8.53353219,7.60341605 8.51282051,7.75305442 8.51282051,7.91122195 C8.51282051,8.07219655 8.53424074,8.22221279 8.57680868,8.3566282 C8.61964914,8.49282502 8.68821568,8.61207146 8.78070965,8.71150648 C8.87358515,8.81126539 8.99256826,8.88905358 9.13509727,8.94389939 C9.27686322,8.99804343 9.44904262,9.02633005 9.64662108,9.02564103 C10.0534419,9.02454864 10.2677532,8.93472243 10.3559959,8.88624651 C10.3716931,8.87739345 10.3863548,8.86254838 10.3681503,8.81941668 L10.2756564,8.56391944 C10.2617032,8.52607799 10.2227871,8.5398974 10.2227871,8.5398974 C10.1216814,8.57703708 9.9787709,8.64354302 9.6444409,8.64284126 C9.42620528,8.64251736 9.26400018,8.57881849 9.16256749,8.47868171 C9.05862759,8.37676352 9.00722994,8.22680126 8.99861824,8.01486757 L10.4070665,8.01594721 C10.4070665,8.01594721 10.4442385,8.01556933 10.4481628,7.9795093 C10.4495799,7.96466422 10.4963992,7.69291836 10.4060309,7.37879656 L10.4060309,7.37879656 Z"
                id="Fill-14"
                fill="#FEFEFE"
              ></path>
              <path
                d="M5.92119174,8.58423744 C5.86507371,8.5407765 5.85750661,8.52983038 5.83900313,8.50157537 C5.81044701,8.45881541 5.7959204,8.39799166 5.7959204,8.32029039 C5.7959204,8.19799583 5.83756704,8.10967197 5.92334587,8.05062764 C5.92262783,8.05062764 6.04646307,7.94607333 6.33749248,7.94990178 C6.54196977,7.95238218 6.72518186,7.98209307 6.72518186,7.98209307 L6.72518186,8.61567383 C6.72518186,8.61567383 6.5437925,8.65352691 6.33964661,8.66555147 C6.04933526,8.68286035 5.92008705,8.58391391 5.92119174,8.58423744 M6.4891658,7.60501816 C6.43122504,7.60081226 6.35627213,7.59865539 6.26651643,7.59865539 C6.14417251,7.59865539 6.02580545,7.61353779 5.91467409,7.64287124 C5.80315609,7.67215076 5.70290588,7.71739112 5.6167404,7.77745997 C5.52991212,7.83828372 5.46037217,7.91566145 5.40972234,8.00754415 C5.35901727,8.09942684 5.33333333,8.20753998 5.33333333,8.32837866 C5.33333333,8.45207519 5.3550404,8.55916382 5.39884118,8.64678669 C5.44231056,8.73478702 5.504891,8.80828238 5.58492546,8.86484632 C5.66418665,8.92135633 5.76228272,8.96276825 5.87556822,8.98778795 C5.98780427,9.01291549 6.11484311,9.02564103 6.25386778,9.02564103 C6.40045955,9.02564103 6.54600187,9.01361647 6.68751208,8.99026835 C6.82758621,8.96697414 6.9991991,8.93305735 7.04697675,8.92211123 C7.09436776,8.91148865 7.14684032,8.89736114 7.14684032,8.89736114 C7.18235596,8.88851797 7.17942855,8.85174333 7.17942855,8.85174333 L7.17876574,7.57746413 C7.17876574,7.29755624 7.1023215,7.09049666 6.9521395,6.96189324 C6.80228891,6.83393689 6.58146227,6.76923077 6.29623247,6.76923077 C6.18907797,6.76923077 6.01713367,6.78341219 5.91356941,6.80357893 C5.91356941,6.80357893 5.60193762,6.86256935 5.47373886,6.96081481 C5.47373886,6.96081481 5.44556938,6.97780016 5.46075881,7.01630031 L5.56172707,7.28132579 C5.57443095,7.31562003 5.60878667,7.30391901 5.60878667,7.30391901 C5.60878667,7.30391901 5.61966782,7.29971311 5.63231647,7.29227191 C5.90672035,7.14668314 6.25419919,7.15088904 6.25419919,7.15088904 C6.40841329,7.15088904 6.52716698,7.18167836 6.60714621,7.24104623 C6.68497131,7.29971311 6.72440858,7.38733598 6.72440858,7.57320431 L6.72440858,7.63224865 C6.60206466,7.61488584 6.4891658,7.60501816 6.4891658,7.60501816"
                id="Fill-16"
                fill="#FEFEFE"
              ></path>
              <path
                d="M17.7407102,6.96277435 C17.7516384,6.93178697 17.7286111,6.91679821 17.7191325,6.91329021 C17.6946556,6.90457335 17.5718805,6.87985785 17.4775968,6.87395803 C17.2963335,6.86348716 17.1959166,6.89240163 17.1059819,6.93109599 C17.0164375,6.9694183 16.9174146,7.03176512 16.8626062,7.10245675 L16.8622159,6.93492291 C16.8622159,6.91190827 16.8450988,6.89346466 16.8209564,6.89346466 L16.451516,6.89346466 C16.4273736,6.89346466 16.4102564,6.91190827 16.4102564,6.93492291 L16.4102564,8.98418278 C16.4102564,9.00714427 16.4296038,9.02564103 16.4540808,9.02564103 L16.8326652,9.02564103 C16.8567518,9.02564103 16.8760992,9.00714427 16.8760992,8.98418278 L16.8760992,7.96042985 C16.8760992,7.82282036 16.8922128,7.68590184 16.9240495,7.59990255 C16.95505,7.51454109 16.9974804,7.44661335 17.0500585,7.39787333 C17.1026923,7.34908016 17.1626302,7.31495684 17.2284225,7.29582226 C17.2952741,7.27626247 17.3694298,7.26967168 17.4212831,7.26967168 C17.4969442,7.26967168 17.5795191,7.28848734 17.5795191,7.28848734 C17.607676,7.29125122 17.6230647,7.27488053 17.6325432,7.25117492 C17.6570202,7.18850918 17.7275517,7.00003362 17.7407102,6.96277435"
                id="Fill-18"
                fill="#FEFEFE"
              ></path>
              <path
                d="M14.3305707,5.99605854 C14.2855632,5.98230928 14.244811,5.97314311 14.1911294,5.96354558 C14.1367931,5.95367847 14.0724733,5.94871795 13.999534,5.94871795 C13.7446008,5.94871795 13.5436766,6.02010627 13.402435,6.16072618 C13.2622845,6.30032162 13.1668142,6.5130308 13.1189153,6.7925452 L13.1017852,6.88690288 L12.7817686,6.88690288 C12.7817686,6.88690288 12.7424348,6.885501 12.7345789,6.92755756 L12.6819884,7.21731652 C12.6780605,7.24486896 12.6902261,7.26217686 12.7277596,7.26217686 L13.0395385,7.26217686 L12.7231225,9.00639206 C12.6984638,9.14668845 12.6702046,9.26223617 12.6387267,9.34985402 C12.6080125,9.43644741 12.5776256,9.5010959 12.540474,9.54805906 C12.5043044,9.59335075 12.4703169,9.6272656 12.4113435,9.64667632 C12.3627355,9.66258233 12.3065989,9.6700231 12.2454433,9.6700231 C12.2115104,9.6700231 12.1661211,9.66436164 12.132461,9.65767573 C12.0988554,9.65131332 12.0813434,9.64387255 12.0563029,9.63357408 C12.0563029,9.63357408 12.0198605,9.61982482 12.0051853,9.65584249 C11.9937834,9.68555168 11.910806,9.91136309 11.900768,9.93929296 C11.8907845,9.96684541 11.9047505,9.98835896 11.9225898,9.99477528 C11.9641058,10.0092255 11.99482,10.0187691 12.0513384,10.0318713 C12.130006,10.0502037 12.1961261,10.0512821 12.2579908,10.0512821 C12.387776,10.0512821 12.5061047,10.0332732 12.6040846,9.99827999 C12.7027191,9.96296326 12.7885333,9.90144205 12.8646914,9.81878473 C12.9465777,9.72901013 12.9984045,9.63502988 13.0477217,9.50675736 C13.0967662,9.37988672 13.1382276,9.22228243 13.1718332,9.03852759 L13.4892858,7.26217686 L13.9537628,7.26217686 C13.9537628,7.26217686 13.993042,7.26357874 14.0009524,7.2215761 L14.0534884,6.93176322 C14.0570344,6.90421078 14.0453052,6.88690288 14.0077172,6.88690288 L13.5568788,6.88690288 C13.5590064,6.87703577 13.5794098,6.72013242 13.6312911,6.57277269 C13.6534403,6.50947216 13.6949017,6.45900428 13.7303076,6.42401106 C13.7646223,6.38971879 13.8046653,6.36534755 13.8482544,6.35116693 C13.8929891,6.33709416 13.9437247,6.3299769 13.999534,6.3299769 C14.0420865,6.3299769 14.0835479,6.33493741 14.1153532,6.34129982 C14.1589422,6.35051991 14.1761269,6.35548043 14.1875833,6.35860771 C14.2333546,6.37278832 14.2394101,6.35930865 14.2486844,6.33741767 L14.3563204,6.04485495 C14.3674495,6.01336644 14.3406087,5.99999461 14.3305707,5.99605854"
                id="Fill-20"
                fill="#FEFEFE"
              ></path>
              <path
                d="M8.1025641,8.98295495 C8.1025641,9.00644043 8.08740588,9.02564103 8.06609577,9.02564103 L7.72872681,9.02564103 C7.70746592,9.02564103 7.69230769,9.00644043 7.69230769,8.98295495 L7.69230769,5.99102435 C7.69230769,5.96753887 7.70746592,5.94871795 7.72872681,5.94871795 L8.06609577,5.94871795 C8.08740588,5.94871795 8.1025641,5.96753887 8.1025641,5.99102435 L8.1025641,8.98295495 Z"
                id="Fill-22"
                fill="#FEFEFE"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </Svg>
  );
};

export const SalesforceCloud = ({ ...props }) => (
  <Svg width="16px" height="12px" viewBox="0 0 16 12" {...props}>
    <g id="Export-to-SF" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Push-to-SF-with-Imports"
        transform="translate(-1576.000000, -278.000000)"
        fill="#129CD7"
      >
        <path
          d="M1582.65811,279.308736 C1583.17401,278.732761 1583.89243,278.375473 1584.68702,278.375473 C1585.74329,278.375473 1586.66465,279.006389 1587.15543,279.943188 C1587.58198,279.739111 1588.05393,279.625462 1588.5506,279.625462 C1590.45557,279.625462 1592,281.294754 1592,283.353821 C1592,285.413196 1590.45557,287.08245 1588.5506,287.08245 C1588.31802,287.08245 1588.09085,287.057267 1587.87097,287.0099 C1587.439,287.835588 1586.61549,288.393723 1585.67016,288.393723 C1585.27468,288.393723 1584.90051,288.295952 1584.56707,288.121595 C1584.12924,289.225677 1583.10842,290 1581.91903,290 C1580.68024,290 1579.6244,289.160202 1579.21923,287.982263 C1579.04215,288.022325 1578.85851,288.043471 1578.67039,288.043471 C1577.19549,288.043471 1576,286.749114 1576,285.152372 C1576,284.082046 1576.53685,283.147745 1577.33518,282.647819 C1577.1708,282.242396 1577.07956,281.795411 1577.07956,281.325242 C1577.07956,279.488898 1578.47099,278 1580.18712,278 C1581.19474,278 1582.09022,278.513267 1582.65811,279.308736"
          id="Fill-1"
        ></path>
      </g>
    </g>
  </Svg>
);

export const SalesforcePush = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g id="SF-Writebacks" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Salesforce-Writebacks" transform="translate(-447.000000, -419.000000)">
        <g id="Item/Default" transform="translate(431.000000, 408.000000)">
          <g id="Icon/SF-Push" transform="translate(16.000000, 11.000000)">
            <circle id="Oval" fill="#E6F3FF" cx="20" cy="20" r="20"></circle>
            <g id="Group-24" transform="translate(8.000000, 11.000000)">
              <g id="Icon/CSVFolder" fill="#129CD7">
                <path
                  d="M10.9271549,2.44371089 C11.7010047,1.62774706 12.7786247,1.12158913 13.9705084,1.12158913 C15.5549144,1.12158913 16.9369505,2.01538571 17.673125,3.34251839 C18.3129585,3.05340979 19.0208766,2.89240658 19.7658779,2.89240658 C22.6233309,2.89240658 24.9399824,5.25723654 24.9399824,8.1742487 C24.9399824,11.0916966 22.6233309,13.4564721 19.7658779,13.4564721 C19.417005,13.4564721 19.0762592,13.4207965 18.7464392,13.3536937 C18.0984786,14.5234179 16.8632146,15.3141093 15.4452256,15.3141093 C14.8520017,15.3141093 14.290748,15.1756008 13.7905821,14.9285948 C13.1338485,16.4927116 11.6026184,17.5896685 9.81853354,17.5896685 C7.96033604,17.5896685 6.37657587,16.399955 5.76882015,14.7312079 C5.50320958,14.7879621 5.22774963,14.8179187 4.94556195,14.8179187 C2.73321703,14.8179187 0.939982427,12.9842468 0.939982427,10.7221953 C0.939982427,9.20590019 1.74526414,7.88230783 2.94274528,7.17407889 C2.69618763,6.59972881 2.5593188,5.96650035 2.5593188,5.30042854 C2.5593188,2.69894128 4.64647423,0.589668509 7.22066309,0.589668509 C8.73208677,0.589668509 10.0753173,1.31679735 10.9271549,2.44371089"
                  id="Fill-1"
                ></path>
              </g>
              <polygon
                id="Triangle"
                fill="#F5F5F5"
                transform="translate(15.500000, 8.142857) rotate(-270.000000) translate(-15.500000, -8.142857) "
                points="15.5 6 20 10.2857143 11 10.2857143"
              ></polygon>
              <rect id="Rectangle" fill="#F5F5F5" x="9" y="7" width="5" height="2"></rect>
              <rect id="Rectangle" fill="#F5F5F5" x="5" y="7" width="4" height="2"></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const Shopify = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle fill="#DCF3D1" cx="20" cy="20" r="20"></circle>
      <g transform="translate(8.000000, 6.000000)" fillRule="nonzero">
        <path
          d="M20.9236364,5.43272727 C20.9018182,5.30181818 20.7927273,5.21454545 20.6836364,5.21454545 C20.5745455,5.21454545 18.6545455,5.17090909 18.6545455,5.17090909 C18.6545455,5.17090909 17.04,3.6 16.8872727,3.44727273 C16.7345455,3.29454545 16.4072727,3.33818182 16.2981818,3.38181818 C16.2981818,3.38181818 15.9927273,3.46909091 15.4909091,3.62181818 C15.4036364,3.33818182 15.2727273,3.01090909 15.0981818,2.66181818 C14.5309091,1.57090909 13.68,0.981818182 12.6763636,0.981818182 C12.6763636,0.981818182 12.6763636,0.981818182 12.6763636,0.981818182 C12.6109091,0.981818182 12.5454545,0.981818182 12.4581818,1.00363636 C12.4363636,0.96 12.3927273,0.938181818 12.3709091,0.894545455 C11.9345455,0.414545455 11.3672727,0.196363636 10.6909091,0.218181818 C9.38181818,0.261818182 8.07272727,1.2 7.02545455,2.88 C6.28363636,4.05818182 5.71636364,5.54181818 5.54181818,6.69818182 C4.03636364,7.15636364 2.98909091,7.48363636 2.96727273,7.50545455 C2.20363636,7.74545455 2.18181818,7.76727273 2.09454545,8.48727273 C2.02909091,9.03272727 0.0218181818,24.4145455 0.0218181818,24.4145455 L16.6909091,27.2945455 L23.9127273,25.5054545 C23.8909091,25.4836364 20.9454545,5.56363636 20.9236364,5.43272727 Z M14.6618182,3.88363636 C14.2690909,3.99272727 13.8327273,4.14545455 13.3745455,4.27636364 C13.3745455,3.62181818 13.2872727,2.68363636 12.9818182,1.89818182 C13.9636364,2.09454545 14.4436364,3.20727273 14.6618182,3.88363636 Z M12.48,4.56 C11.6072727,4.82181818 10.6472727,5.12727273 9.68727273,5.41090909 C9.94909091,4.38545455 10.4727273,3.36 11.0836364,2.68363636 C11.3236364,2.44363636 11.6509091,2.16 12.0218182,1.98545455 C12.4145455,2.74909091 12.5018182,3.81818182 12.48,4.56 Z M10.7127273,1.09090909 C11.0181818,1.09090909 11.28,1.15636364 11.4981818,1.28727273 C11.1490909,1.48363636 10.8,1.74545455 10.4727273,2.09454545 C9.64363636,2.98909091 9.01090909,4.38545455 8.74909091,5.71636364 C7.96363636,5.95636364 7.17818182,6.19636364 6.45818182,6.41454545 C6.91636364,4.32 8.68363636,1.15636364 10.7127273,1.09090909 Z"
          fill="#95BF47"
        ></path>
        <g transform="translate(4.363636, 3.272727)">
          <path
            d="M16.32,1.94181818 C16.2109091,1.94181818 14.2909091,1.89818182 14.2909091,1.89818182 C14.2909091,1.89818182 12.6763636,0.327272727 12.5236364,0.174545455 C12.4581818,0.109090909 12.3927273,0.0872727273 12.3054545,0.0654545455 L12.3054545,24 L19.5272727,22.2109091 C19.5272727,22.2109091 16.5818182,2.29090909 16.56,2.13818182 C16.5381818,2.02909091 16.4290909,1.94181818 16.32,1.94181818 Z"
            fill="#5E8E3E"
          ></path>
          <path
            d="M8.29090909,5.65090909 L7.46181818,8.79272727 C7.46181818,8.79272727 6.52363636,8.35636364 5.41090909,8.44363636 C3.77454545,8.55272727 3.77454545,9.57818182 3.77454545,9.84 C3.86181818,11.2363636 7.54909091,11.5418182 7.76727273,14.8363636 C7.92,17.4327273 6.39272727,19.2 4.18909091,19.3309091 C1.52727273,19.5054545 0.0654545455,17.9345455 0.0654545455,17.9345455 L0.632727273,15.5345455 C0.632727273,15.5345455 2.09454545,16.6472727 3.27272727,16.56 C4.03636364,16.5163636 4.32,15.8836364 4.29818182,15.4472727 C4.18909091,13.6145455 1.17818182,13.7236364 0.981818182,10.7127273 C0.829090909,8.18181818 2.48727273,5.60727273 6.15272727,5.38909091 C7.57090909,5.28 8.29090909,5.65090909 8.29090909,5.65090909 Z"
            fill="#FFFFFF"
          ></path>
        </g>
      </g>
    </g>
  </Svg>
);

export const SlackEmail = ({ ...props }) => (
  <Svg width="50px" height="30px" viewBox="0 0 50 30" {...props}>
    <g id="WIP" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Alert-to-Notifications-Update" transform="translate(-313.000000, -263.000000)">
        <g id="Group-3" transform="translate(313.000000, 263.000000)">
          <g id="Icon/CSVFolder" transform="translate(20.000000, 0.000000)">
            <g id="AlertType/SpecifiedCells" fill="#FFFFFF">
              <circle id="Oval" cx="15" cy="15" r="15"></circle>
            </g>
            <g
              id="Email"
              transform="translate(6.000000, 9.000000)"
              fill="#FAAD14"
              fillRule="nonzero"
            >
              <path
                d="M1.34598769,0.121949508 C1.18218011,0.121949508 1.0266862,0.156120283 0.883567938,0.212498957 L8.1389989,6.3439944 C8.45655179,6.61262099 8.81066475,6.61280726 9.12896793,6.3439944 L16.3909118,0.206020791 C16.2498631,0.151525545 16.0959261,0.121949508 15.9350051,0.121949508 L1.34598769,0.121949508 Z M0.10852639,1.18267163 C0.100048087,1.24128558 0.0955004821,1.30275573 0.0955004821,1.36377053 L0.0955004821,9.6425815 C0.0955004821,10.3305296 0.65323028,10.8844025 1.34598769,10.8844025 L15.9350051,10.8844025 C16.6277625,10.8844025 17.1854923,10.3305296 17.1854923,9.6425815 L17.1854923,1.36377053 C17.1854923,1.30275573 17.1809488,1.24128558 17.1724663,1.18267163 L9.94308721,7.28829581 C9.19367023,7.9211692 8.07425492,7.92218335 7.32487962,7.28829581 L0.10852639,1.18267163 Z"
                id="Shape"
              ></path>
            </g>
          </g>
          <g id="Group-2">
            <g id="AlertType/SpecifiedCells" fill="#FFFFFF">
              <circle id="Oval" cx="15" cy="15" r="15"></circle>
            </g>
            <g id="Slack_Mark" transform="translate(6.000000, 6.000000)" fillRule="nonzero">
              <g id="Group" transform="translate(0.000000, 8.712459)" fill="#E01E5A">
                <path
                  d="M3.56103874,1.78679236 C3.56103874,2.74787007 2.77868932,3.5329758 1.82098572,3.5329758 C0.863282119,3.5329758 0.0809326986,2.74787007 0.0809326986,1.78679236 C0.0809326986,0.825714651 0.863282119,0.0406089173 1.82098572,0.0406089173 L3.56103874,0.0406089173 L3.56103874,1.78679236 Z"
                  id="Path"
                ></path>
                <path
                  d="M4.43780964,1.78679236 C4.43780964,0.825714651 5.22015906,0.0406089173 6.17786266,0.0406089173 C7.13556626,0.0406089173 7.91791568,0.825714651 7.91791568,1.78679236 L7.91791568,6.15901912 C7.91791568,7.12009683 7.13556626,7.90520256 6.17786266,7.90520256 C5.22015906,7.90520256 4.43780964,7.12009683 4.43780964,6.15901912 L4.43780964,1.78679236 Z"
                  id="Path"
                ></path>
              </g>
              <g id="Group" fill="#36C5F0">
                <path
                  d="M6.17786266,3.57358472 C5.22015906,3.57358472 4.43780964,2.78847899 4.43780964,1.82740128 C4.43780964,0.866323568 5.22015906,0.0812178345 6.17786266,0.0812178345 C7.13556626,0.0812178345 7.91791568,0.866323568 7.91791568,1.82740128 L7.91791568,3.57358472 L6.17786266,3.57358472 Z"
                  id="Path"
                ></path>
                <path
                  d="M6.17786266,4.45344459 C7.13556626,4.45344459 7.91791568,5.23855033 7.91791568,6.19962804 C7.91791568,7.16070575 7.13556626,7.94581148 6.17786266,7.94581148 L1.82098572,7.94581148 C0.863282119,7.94581148 0.0809326986,7.16070575 0.0809326986,6.19962804 C0.0809326986,5.23855033 0.863282119,4.45344459 1.82098572,4.45344459 L6.17786266,4.45344459 Z"
                  id="Path"
                ></path>
              </g>
              <g id="Group" transform="translate(8.681871, 0.000000)" fill="#2EB67D">
                <path
                  d="M4.36650638,6.15615238 C4.36650638,5.20181435 5.14336948,4.42221427 6.09435707,4.42221427 C7.04534465,4.42221427 7.82220775,5.20181435 7.82220775,6.15615238 C7.82220775,7.11049042 7.04534465,7.8900905 6.09435707,7.8900905 L4.36650638,7.8900905 L4.36650638,6.15615238 Z"
                  id="Path"
                ></path>
                <path
                  d="M3.49588394,6.15615238 C3.49588394,7.11049042 2.71902085,7.8900905 1.76803326,7.8900905 C0.817045673,7.8900905 0.0401825741,7.11049042 0.0401825741,6.15615238 L0.0401825741,1.8145864 C0.0401825741,0.860248368 0.817045673,0.0806482845 1.76803326,0.0806482845 C2.71902085,0.0806482845 3.49588394,0.860248368 3.49588394,1.8145864 L3.49588394,6.15615238 Z"
                  id="Path"
                ></path>
              </g>
              <g id="Group" transform="translate(8.681871, 8.712459)" fill="#ECB22E">
                <path
                  d="M1.76803326,4.38189012 C2.71902085,4.38189012 3.49588394,5.16149021 3.49588394,6.11582824 C3.49588394,7.07016628 2.71902085,7.84976636 1.76803326,7.84976636 C0.817045673,7.84976636 0.0401825741,7.07016628 0.0401825741,6.11582824 L0.0401825741,4.38189012 L1.76803326,4.38189012 Z"
                  id="Path"
                ></path>
                <path
                  d="M1.76803326,3.50820038 C0.817045673,3.50820038 0.0401825741,2.72860029 0.0401825741,1.77426226 C0.0401825741,0.819924226 0.817045673,0.0403241423 1.76803326,0.0403241423 L6.09435707,0.0403241423 C7.04534465,0.0403241423 7.82220775,0.819924226 7.82220775,1.77426226 C7.82220775,2.72860029 7.04534465,3.50820038 6.09435707,3.50820038 L1.76803326,3.50820038 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const Slack = ({ ...props }) => (
  <Svg width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <g id="Icon/slack" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <g>
            <g>
              <g transform="translate(0.000000, 8.387097)" fill="#E01E5A">
                <path d="M3.40645161,1.70322581 C3.40645161,2.61935484 2.65806452,3.36774194 1.74193548,3.36774194 C0.825806452,3.36774194 0.0774193548,2.61935484 0.0774193548,1.70322581 C0.0774193548,0.787096774 0.825806452,0.0387096774 1.74193548,0.0387096774 L3.40645161,0.0387096774 L3.40645161,1.70322581 Z"></path>
                <path d="M4.24516129,1.70322581 C4.24516129,0.787096774 4.99354839,0.0387096774 5.90967742,0.0387096774 C6.82580645,0.0387096774 7.57419355,0.787096774 7.57419355,1.70322581 L7.57419355,5.87096774 C7.57419355,6.78709677 6.82580645,7.53548387 5.90967742,7.53548387 C4.99354839,7.53548387 4.24516129,6.78709677 4.24516129,5.87096774 L4.24516129,1.70322581 Z"></path>
              </g>
              <g fill="#36C5F0">
                <path d="M5.90967742,3.40645161 C4.99354839,3.40645161 4.24516129,2.65806452 4.24516129,1.74193548 C4.24516129,0.825806452 4.99354839,0.0774193548 5.90967742,0.0774193548 C6.82580645,0.0774193548 7.57419355,0.825806452 7.57419355,1.74193548 L7.57419355,3.40645161 L5.90967742,3.40645161 Z"></path>
                <path d="M5.90967742,4.24516129 C6.82580645,4.24516129 7.57419355,4.99354839 7.57419355,5.90967742 C7.57419355,6.82580645 6.82580645,7.57419355 5.90967742,7.57419355 L1.74193548,7.57419355 C0.825806452,7.57419355 0.0774193548,6.82580645 0.0774193548,5.90967742 C0.0774193548,4.99354839 0.825806452,4.24516129 1.74193548,4.24516129 L5.90967742,4.24516129 Z"></path>
              </g>
              <g transform="translate(8.387097, 0.000000)" fill="#2EB67D">
                <path d="M4.20645161,5.90967742 C4.20645161,4.99354839 4.95483871,4.24516129 5.87096774,4.24516129 C6.78709677,4.24516129 7.53548387,4.99354839 7.53548387,5.90967742 C7.53548387,6.82580645 6.78709677,7.57419355 5.87096774,7.57419355 L4.20645161,7.57419355 L4.20645161,5.90967742 Z"></path>
                <path d="M3.36774194,5.90967742 C3.36774194,6.82580645 2.61935484,7.57419355 1.70322581,7.57419355 C0.787096774,7.57419355 0.0387096774,6.82580645 0.0387096774,5.90967742 L0.0387096774,1.74193548 C0.0387096774,0.825806452 0.787096774,0.0774193548 1.70322581,0.0774193548 C2.61935484,0.0774193548 3.36774194,0.825806452 3.36774194,1.74193548 L3.36774194,5.90967742 Z"></path>
              </g>
              <g transform="translate(8.387097, 8.387097)" fill="#ECB22E">
                <path d="M1.70322581,4.20645161 C2.61935484,4.20645161 3.36774194,4.95483871 3.36774194,5.87096774 C3.36774194,6.78709677 2.61935484,7.53548387 1.70322581,7.53548387 C0.787096774,7.53548387 0.0387096774,6.78709677 0.0387096774,5.87096774 L0.0387096774,4.20645161 L1.70322581,4.20645161 Z"></path>
                <path d="M1.70322581,3.36774194 C0.787096774,3.36774194 0.0387096774,2.61935484 0.0387096774,1.70322581 C0.0387096774,0.787096774 0.787096774,0.0387096774 1.70322581,0.0387096774 L5.87096774,0.0387096774 C6.78709677,0.0387096774 7.53548387,0.787096774 7.53548387,1.70322581 C7.53548387,2.61935484 6.78709677,3.36774194 5.87096774,3.36774194 L1.70322581,3.36774194 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const SlackCircle = ({ ...props }) => (
  <Svg width="32px" height="32px" viewBox="0 0 32 32" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Alerts-Onboarding-with-UI-Updates" transform="translate(-761.000000, -438.000000)">
        <g transform="translate(750.000000, 426.000000)">
          <g transform="translate(11.000000, 12.000000)">
            <g id="AlertType/SpecifiedCells" fill={props.color || "#E6F3FF"}>
              <circle cx="16" cy="16" r="16"></circle>
            </g>
            <g transform="translate(6.400000, 6.400000)" fillRule="nonzero">
              <g transform="translate(0.000000, 9.293289)" fill="#E01E5A">
                <path d="M3.79844132,1.90591185 C3.79844132,2.93106141 2.96393527,3.76850752 1.94238477,3.76850752 C0.92083426,3.76850752 0.0863282119,2.93106141 0.0863282119,1.90591185 C0.0863282119,0.880762295 0.92083426,0.0433161784 1.94238477,0.0433161784 L3.79844132,0.0433161784 L3.79844132,1.90591185 Z"></path>
                <path d="M4.73366362,1.90591185 C4.73366362,0.880762295 5.56816966,0.0433161784 6.58972017,0.0433161784 C7.61127068,0.0433161784 8.44577673,0.880762295 8.44577673,1.90591185 L8.44577673,6.56962039 C8.44577673,7.59476995 7.61127068,8.43221607 6.58972017,8.43221607 C5.56816966,8.43221607 4.73366362,7.59476995 4.73366362,6.56962039 L4.73366362,1.90591185 Z"></path>
              </g>
              <g fill="#36C5F0">
                <path d="M6.58972017,3.8118237 C5.56816966,3.8118237 4.73366362,2.97437758 4.73366362,1.94922803 C4.73366362,0.924078473 5.56816966,0.0866323568 6.58972017,0.0866323568 C7.61127068,0.0866323568 8.44577673,0.924078473 8.44577673,1.94922803 L8.44577673,3.8118237 L6.58972017,3.8118237 Z"></path>
                <path d="M6.58972017,4.7503409 C7.61127068,4.7503409 8.44577673,5.58778702 8.44577673,6.61293657 C8.44577673,7.63808613 7.61127068,8.47553224 6.58972017,8.47553224 L1.94238477,8.47553224 C0.92083426,8.47553224 0.0863282119,7.63808613 0.0863282119,6.61293657 C0.0863282119,5.58778702 0.92083426,4.7503409 1.94238477,4.7503409 L6.58972017,4.7503409 Z"></path>
              </g>
              <g transform="translate(9.260663, 0.000000)" fill="#2EB67D">
                <path d="M4.65760681,6.56656254 C4.65760681,5.54860197 5.48626078,4.71702855 6.50064754,4.71702855 C7.5150343,4.71702855 8.34368827,5.54860197 8.34368827,6.56656254 C8.34368827,7.58452311 7.5150343,8.41609653 6.50064754,8.41609653 L4.65760681,8.41609653 L4.65760681,6.56656254 Z"></path>
                <path d="M3.72894287,6.56656254 C3.72894287,7.58452311 2.9002889,8.41609653 1.88590214,8.41609653 C0.871515384,8.41609653 0.0428614123,7.58452311 0.0428614123,6.56656254 L0.0428614123,1.93555883 C0.0428614123,0.917598259 0.871515384,0.0860248368 1.88590214,0.0860248368 C2.9002889,0.0860248368 3.72894287,0.917598259 3.72894287,1.93555883 L3.72894287,6.56656254 Z"></path>
              </g>
              <g transform="translate(9.260663, 9.293289)" fill="#ECB22E">
                <path d="M1.88590214,4.67401613 C2.9002889,4.67401613 3.72894287,5.50558956 3.72894287,6.52355012 C3.72894287,7.54151069 2.9002889,8.37308412 1.88590214,8.37308412 C0.871515384,8.37308412 0.0428614123,7.54151069 0.0428614123,6.52355012 L0.0428614123,4.67401613 L1.88590214,4.67401613 Z"></path>
                <path d="M1.88590214,3.7420804 C0.871515384,3.7420804 0.0428614123,2.91050698 0.0428614123,1.89254641 C0.0428614123,0.874585841 0.871515384,0.0430124184 1.88590214,0.0430124184 L6.50064754,0.0430124184 C7.5150343,0.0430124184 8.34368827,0.874585841 8.34368827,1.89254641 C8.34368827,2.91050698 7.5150343,3.7420804 6.50064754,3.7420804 L1.88590214,3.7420804 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
);

export const Snowflake = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g id="Icon/Snowflake" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#E6F3FF" x="0" y="0" width="40" height="40" rx="20"></rect>
      <path
        d="M30.0692782,27.336749 L24.1532362,23.9248463 C23.7530119,23.6956364 23.2731976,23.6335223 22.8243097,23.7533763 C22.3754219,23.8732304 21.9974828,24.1645544 21.7782691,24.5595477 C21.596349,24.8753674 21.5181233,25.2366792 21.5535978,25.5962412 L21.5535978,32.2669484 C21.5158493,33.1868498 22.2603574,33.9615267 23.2163476,33.9982703 C23.5515354,34.0109556 23.8830848,33.9300322 24.1709734,33.7651236 C24.7171885,33.4528033 25.0414611,32.8775915 25.0164471,32.2669484 L25.0164471,28.4333695 L28.3305768,30.3449099 C28.730801,30.5732449 29.2101605,30.6366713 29.6595032,30.5198792 C30.1079363,30.403962 30.4863301,30.1087012 30.7055438,29.7132705 C31.1862677,28.882166 30.905656,27.8410982 30.0688234,27.3415607 L30.0692782,27.336749 Z M17.0356118,23.7214444 C16.6272011,23.6457702 16.2042368,23.717945 15.8481282,23.9244089 L9.93208616,27.3363116 C9.09525365,27.8362866 8.81509667,28.8804163 9.29536577,29.7080214 C9.51503431,30.1030147 9.89297334,30.3947761 10.3414064,30.5141927 C10.7902943,30.6340468 11.2701086,30.5719326 11.6703328,30.3427228 L15.0299425,28.404937 L15.0299425,32.2673858 C14.9921941,33.1872873 15.7367022,33.9619641 16.6926924,33.9987077 C17.0278802,34.011393 17.3594296,33.9304697 17.6473181,33.765561 C18.1930785,33.4528033 18.5173511,32.8780289 18.4923371,32.2673858 L18.4923371,25.4238964 C18.5050715,24.5888551 17.8888171,23.8671064 17.0347022,23.7166328 L17.0356118,23.7214444 Z M24.6062173,20.0217171 C24.5957568,20.6406713 24.9259419,21.2193825 25.4748858,21.5426384 L31.3872895,24.9545411 C31.7875137,25.1837509 32.2668732,25.2458651 32.7153063,25.126011 C33.1637394,25.006157 33.5416784,24.714833 33.7613469,24.3198397 C34.24389,23.492672 33.9628234,22.4467926 33.1246265,21.947255 L29.7791157,20.016468 L33.1287197,18.0843688 C33.9655523,17.5843938 34.246164,16.5402641 33.7654401,15.712659 C33.5462264,15.3172282 33.1682874,15.0259042 32.7193995,14.9060502 C32.2705116,14.7861962 31.7906973,14.8474355 31.3913827,15.0810196 L25.478979,18.4929223 C24.9259419,18.8188027 24.5948472,19.4032004 24.6103105,20.0269662 L24.6062173,20.0217171 Z M6.87082547,18.0926798 L10.2204295,20.0247791 L6.87082547,21.9551287 C6.03990535,22.455541 5.76065798,23.4935468 6.23455987,24.3189648 C6.45422841,24.7139582 6.83216744,25.0052822 7.28060052,25.1255736 C7.7290336,25.2454276 8.2093027,25.1837509 8.60952694,24.9541036 L14.525569,21.5422009 C15.0713293,21.2088843 15.3896895,20.6332351 15.3896895,20.0147184 C15.3896895,19.3975139 15.0645073,18.8223021 14.525569,18.4872358 L8.60952694,15.0753331 C8.2093027,14.8469981 7.7299432,14.7835717 7.28060052,14.9003637 C6.83216744,15.0162809 6.45377361,15.3115417 6.23455987,15.7069725 C5.75383598,16.538077 6.03444775,17.5782699 6.87128027,18.0786823 L6.87082547,18.0926798 Z M16.793658,19.7019606 L16.793658,20.3034178 C16.8013896,20.453454 16.8609685,20.5964915 16.9628437,20.7102216 L19.3096132,23.0534989 C19.4201296,23.1541063 19.5643013,23.2140333 19.7166594,23.2223443 L20.3133574,23.2223443 C20.4657155,23.2140333 20.6098872,23.1541063 20.7204036,23.0534989 L23.0671731,20.7102216 C23.1690484,20.5964915 23.2286272,20.453454 23.2363588,20.3034178 L23.2363588,19.7067723 C23.2286272,19.556736 23.1690484,19.4136986 23.0671731,19.2999685 L20.7204036,16.9566912 C20.6098872,16.8560838 20.4657155,16.7961568 20.3133574,16.7878458 L19.7166594,16.7878458 C19.5643013,16.7961568 19.4201296,16.8560838 19.3096132,16.9566912 L16.9628437,19.3043427 C16.8609685,19.4180728 16.8018444,19.5611103 16.793658,19.7111465 L16.793658,19.7019606 Z M18.8875585,19.9862858 C18.8934709,19.87693 18.9366769,19.7675741 19.0112642,19.6888379 L19.7025606,18.9977089 C19.7844247,18.9246592 19.8903931,18.8809168 20.0018192,18.8743555 L20.0277428,18.8743555 C20.1391689,18.8804794 20.2446826,18.9242218 20.3260918,18.9977089 L21.0173882,19.6888379 C21.0924303,19.7719484 21.1356363,19.87693 21.1410939,19.9867233 L21.1410939,20.0129687 C21.1356363,20.1231994 21.0919755,20.228181 21.0173882,20.3117289 L20.3260918,21.0032953 C20.2451374,21.0772198 20.1391689,21.1213996 20.0277428,21.1275235 L20.0018192,21.1275235 C19.8899383,21.1213996 19.7835151,21.0772198 19.7025606,21.0032953 L19.0112642,20.3121663 C18.9366769,20.2286184 18.8930161,20.1236368 18.8875585,20.0134061 L18.8875585,19.9862858 Z M24.1532362,16.1015284 L30.0692782,12.6896257 C30.9061108,12.1896508 31.1871773,11.1442088 30.7059986,10.3170411 C30.2607492,9.51874336 29.2269881,9.21867089 28.3969776,9.646471 C28.3751472,9.65784401 28.3533168,9.66965444 28.3319412,9.68190229 L25.0118991,11.5934426 L25.0118991,7.7266196 C25.0346391,7.11728877 24.7099117,6.54426409 24.1646062,6.23325604 C23.6193006,5.92224799 22.9411934,5.92224799 22.3958879,6.23325604 C21.8505823,6.54426409 21.5258549,7.11728877 21.548595,7.7266196 L21.548595,14.4288213 C21.5131205,14.7879459 21.5913462,15.1488202 21.7732663,15.4642025 C21.99248,15.8591959 22.3708739,16.1509573 22.8193069,16.2708113 C23.2681948,16.3915402 23.7493735,16.3281138 24.1482334,16.0958419 L24.1532362,16.1015284 Z M9.93163136,12.694 L15.8476734,16.1059027 C16.5221422,16.4956469 17.3871724,16.3867285 17.9347519,15.8430112 C18.2935893,15.510132 18.4955207,15.0503999 18.4927919,14.5709839 L18.4927919,7.73274353 C18.5168963,7.12253786 18.1921689,6.54863833 17.6464085,6.23675543 C17.1006482,5.92487253 16.4216314,5.92487253 15.875871,6.23675543 C15.3301107,6.54863833 15.0053833,7.12253786 15.0294877,7.73274353 L15.0294877,11.6240623 L11.669878,9.68627653 C11.2696538,9.4579415 10.7902943,9.39451511 10.3409516,9.51130716 C9.89251854,9.62722437 9.5141247,9.92248518 9.29491097,10.3179159 C8.81418707,11.1490204 9.09479884,12.1900882 9.93163136,12.6896257 L9.93163136,12.694 Z"
        id="Fill-1"
        fill="#3DB5E8"
      ></path>
    </g>
  </Svg>
);

export const Stripe = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <defs>
      <polygon
        id="stripe-path-1"
        points="1.09375e-05 0 28 0 28 11.6511172 1.09375e-05 11.6511172"
      ></polygon>
    </defs>
    <g id="Icon/Stripe" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#EAEAEE" x="0" y="0" width="40" height="40" rx="20"></rect>
      <g id="Group-3" transform="translate(6.000000, 14.000000)">
        <mask id="stripe-mask-2" fill="white">
          <use xlinkHref="#stripe-path-1"></use>
        </mask>
        <g id="Clip-2"></g>
        <path
          d="M24.1577766,5.28111719 C24.1577766,4.40223438 24.694425,4.03670313 25.184425,4.03670313 C25.6588937,4.03670313 26.164425,4.40223438 26.164425,5.28111719 L24.1577766,5.28111719 Z M28.0000109,6.02 C28.0000109,4.02888281 27.0355422,2.45782031 25.1922453,2.45782031 C23.3410734,2.45782031 22.2211281,4.02888281 22.2211281,6.00446875 C22.2211281,8.34558594 23.5433625,9.52782031 25.4411281,9.52782031 C26.3667141,9.52782031 27.0666594,9.31776563 27.5955422,9.02223438 L27.5955422,7.46664844 C27.0666594,7.73111719 26.4600109,7.89446875 25.6900109,7.89446875 C24.9355969,7.89446875 24.2666594,7.63 24.1811281,6.71217969 L27.9844797,6.71217969 C27.9844797,6.61111719 28.0000109,6.20664844 28.0000109,6.02 L28.0000109,6.02 Z M18.7521906,7.81670313 C18.2933625,7.81670313 18.0211281,7.65329688 17.834425,7.45111719 L17.8266594,4.56558594 C18.0288938,4.34 18.3088937,4.18446875 18.7521906,4.18446875 C19.4600109,4.18446875 19.9500109,4.97782031 19.9500109,5.99664844 C19.9500109,7.03888281 19.4677766,7.81670313 18.7521906,7.81670313 L18.7521906,7.81670313 Z M19.2188391,2.45782031 C18.4566594,2.45782031 17.9666594,2.81558594 17.694425,3.06446875 L17.5933625,2.58223437 L15.8822453,2.58223437 L15.8822453,11.6511172 L17.8266594,11.2388828 L17.834425,9.03782031 C18.114425,9.24 18.5266594,9.52782031 19.2111281,9.52782031 C20.6033625,9.52782031 21.8711281,8.40776563 21.8711281,5.94223438 C21.8633625,3.68664844 20.5800109,2.45782031 19.2188391,2.45782031 L19.2188391,2.45782031 Z M13.2066594,1.99888281 L15.1588937,1.57888281 L15.1588937,0 L13.2066594,0.412234375 L13.2066594,1.99888281 Z M13.2066594,9.39558594 L15.1588937,9.39558594 L15.1588937,2.59 L13.2066594,2.59 L13.2066594,9.39558594 Z M11.114425,3.16553125 L10.9900109,2.59 L9.31001094,2.59 L9.31001094,9.39558594 L11.254425,9.39558594 L11.254425,4.78335156 C11.7133078,4.18446875 12.4911281,4.29335156 12.7322453,4.37888281 L12.7322453,2.59 C12.4833078,2.49664844 11.5733078,2.32558594 11.114425,3.16553125 L11.114425,3.16553125 Z M7.22554219,0.902234375 L5.32777656,1.30670313 L5.32001094,7.53670313 C5.32001094,8.68776563 6.1833625,9.53553125 7.33447969,9.53553125 C7.97224531,9.53553125 8.43889375,9.4189375 8.69554219,9.27888281 L8.69554219,7.7 C8.44665938,7.80111719 7.21777656,8.1589375 7.21777656,7.00782031 L7.21777656,4.24664844 L8.69554219,4.24664844 L8.69554219,2.59 L7.21777656,2.59 L7.22554219,0.902234375 Z M1.96777656,4.56558594 C1.96777656,4.26223438 2.21665938,4.14558594 2.62889375,4.14558594 C3.22001094,4.14558594 3.96665938,4.32446875 4.55777656,4.64335156 L4.55777656,2.81558594 C3.91219063,2.55888281 3.274425,2.45782031 2.62889375,2.45782031 C1.05001094,2.45782031 1.09375e-05,3.28223438 1.09375e-05,4.65888281 C1.09375e-05,6.80553125 2.95554219,6.46335156 2.95554219,7.38888281 C2.95554219,7.74664844 2.644425,7.86335156 2.20889375,7.86335156 C1.56330781,7.86335156 0.73889375,7.59888281 0.0855421875,7.24111719 L0.0855421875,9.09223438 C0.80889375,9.40329688 1.54001094,9.53553125 2.20889375,9.53553125 C3.82665938,9.53553125 4.93889375,8.73446875 4.93889375,7.34223438 C4.93112813,5.02446875 1.96777656,5.43664844 1.96777656,4.56558594 L1.96777656,4.56558594 Z"
          id="Fill-1"
          fill="#32325D"
          mask="url(#stripe-mask-2)"
        ></path>
      </g>
    </g>
  </Svg>
);

export const Postgres = ({ ...props }) => (
  <svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <defs>
      <path id="a" d="M0 .035h23.193v23.911H0z"></path>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect width="40" height="40" fill="#F5F5F5" rx="20"></rect>
      <path
        fill="#000"
        d="M25.326 25.462c.152-1.267.107-1.453 1.05-1.248l.24.021c.726.033 1.675-.117 2.233-.376 1.2-.557 1.913-1.487.729-1.242-2.7.557-2.886-.358-2.886-.358 2.851-4.23 4.043-9.602 3.014-10.916-2.806-3.586-7.664-1.89-7.745-1.847l-.026.005a9.631 9.631 0 00-1.802-.188c-1.222-.02-2.149.32-2.852.854 0 0-8.667-3.57-8.263 4.49.085 1.715 2.457 12.975 5.286 9.574 1.035-1.244 2.034-2.295 2.034-2.295.496.33 1.09.498 1.713.437l.048-.04a1.86 1.86 0 00.02.483c-.729.815-.515.958-1.972 1.258-1.474.304-.608.845-.043.986.686.171 2.272.414 3.343-1.086l-.042.171c.286.229.266 1.644.307 2.655.04 1.012.108 1.955.314 2.512.206.556.45 1.989 2.365 1.578 1.6-.343 2.824-.836 2.935-5.428"
      ></path>
      <g transform="translate(8 8.018)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a"></use>
        </mask>
        <path
          fill="#000"
          d="M12.032 15.343c.573.458.622 1.294.666 2.856.005.187.01.37.017.543.02.51.068 1.705.253 2.202.027.074.05.147.076.225.208.638.295.902 1.136.721.743-.159 1.123-.3 1.415-.716.438-.623.682-1.886.728-3.755l1.003.024-.996-.12.027-.229c.087-.748.155-1.34.69-1.72.337-.242.715-.274 1.044-.244a1.405 1.405 0 01-.383-.69l-.084-.412.235-.348c1.244-1.846 2.272-4.116 2.82-6.227.613-2.367.343-3.371.237-3.51-2.231-2.851-6.114-1.687-6.542-1.547l-.075.04-.376.07-.192-.04a8.684 8.684 0 00-1.614-.167c-.904-.016-1.634.197-2.23.65l-.458.347-.53-.219c-1.04-.425-4.09-1.28-5.688-.148-.88.624-1.281 1.855-1.19 3.66.03.624.455 2.97 1.154 5.224.962 3.1 1.81 3.96 2.051 4.03.03-.013.137-.069.307-.272a52.643 52.643 0 012.077-2.345l.581-.611.702.466c.242.16.508.254.78.277l1.667-1.421-.241 2.474a.877.877 0 00.012.233l.072.47-.316.353a1.533 1.533 0 01-.009.01l.779.36.395-.494zm1.735 8.603c-.596 0-1.247-.155-1.785-.663-.52-.49-.724-1.117-.846-1.49l-.051-.151c-.245-.66-.328-1.605-.376-2.82-.007-.18-.013-.371-.018-.567l-.013-.407c-.823.36-1.787.425-2.817.167a2.84 2.84 0 01-.806-.34 1.775 1.775 0 01-.427-.367c-.822.684-1.602.584-2.032.44-.766-.255-1.45-.967-2.087-2.176-.45-.853-.885-1.963-1.293-3.3C.506 9.947.056 7.495.015 6.69c-.127-2.538.56-4.356 2.04-5.402C3.278.424 4.95.158 7.025.5a13.7 13.7 0 012.12.532c.86-.51 1.866-.758 3.005-.74.607.01 1.186.063 1.725.158.578-.18 1.686-.429 2.949-.413 2.366.028 4.328.951 5.673 2.67.508.649.943 2.084.13 5.234-.504 1.948-1.378 4.018-2.453 5.833.285-.008.675-.05 1.201-.158.302-.062.557-.077.78-.043.472.07.837.364.976.786.407 1.232-1.32 2.143-1.86 2.394-.681.316-1.792.509-2.7.468l-.042-.003-.164-.015-.014.124-.022.19c-.061 2.34-.398 3.826-1.09 4.812-.733 1.043-1.746 1.334-2.638 1.526-.25.053-.535.092-.834.092z"
          mask="url(#b)"
        ></path>
      </g>
      <path
        fill="#336791"
        d="M29.578 22.616c-2.7.558-2.886-.357-2.886-.357 2.851-4.231 4.043-9.602 3.015-10.917-2.807-3.586-7.665-1.89-7.746-1.846l-.026.005a9.636 9.636 0 00-1.802-.188c-1.222-.02-2.149.32-2.852.854 0 0-8.667-3.57-8.264 4.49.086 1.715 2.458 12.975 5.287 9.574 1.034-1.244 2.034-2.295 2.034-2.295.496.33 1.09.498 1.713.437l.048-.04a1.87 1.87 0 00.02.484c-.73.814-.515.957-1.972 1.257-1.475.304-.608.845-.043.986.686.171 2.272.414 3.343-1.086l-.043.171c.286.229.487 1.488.453 2.63-.034 1.14-.056 1.924.169 2.537.225.612.45 1.989 2.365 1.578 1.6-.343 2.43-1.231 2.545-2.714.082-1.054.267-.898.279-1.84l.148-.447c.172-1.428.028-1.89 1.014-1.675l.24.021c.725.033 1.675-.117 2.232-.376 1.2-.557 1.913-1.487.729-1.243z"
      ></path>
      <path
        fill="#FFF"
        d="M21.862 31.344c-1.612 0-2.122-1.276-2.33-1.798-.307-.765-.373-3.625-.303-6.12a.335.335 0 01.669.019c-.078 2.778.032 5.294.255 5.852.345.865.87 1.62 2.352 1.303 1.429-.306 1.937-.82 2.175-2.202.182-1.055.543-4.06.587-4.654a.335.335 0 01.668.05c-.047.618-.406 3.621-.595 4.718-.283 1.639-1.013 2.382-2.695 2.743a3.744 3.744 0 01-.783.089m-8.654-6.176c-.156 0-.297-.029-.42-.07-1.045-.348-2.038-2.043-2.951-5.036-.695-2.275-1.135-4.65-1.173-5.422-.115-2.294.477-3.919 1.76-4.827 1.075-.762 2.58-.993 4.476-.688 1.383.223 2.45.655 2.494.673a.335.335 0 11-.253.62c-.05-.02-4.1-1.64-6.331-.058-1.083.768-1.58 2.197-1.478 4.247.033.648.443 2.96 1.145 5.26.81 2.657 1.73 4.332 2.523 4.597.122.04.492.164 1.028-.48a47.774 47.774 0 011.985-2.237.335.335 0 11.483.463c-.01.01-.94.982-1.953 2.202-.487.584-.954.756-1.335.756m13.464-2.608a.334.334 0 01-.277-.521c2.877-4.27 3.891-9.422 3.03-10.524-1.086-1.387-2.618-2.111-4.556-2.154a8.596 8.596 0 00-2.768.4.334.334 0 01-.05.02.335.335 0 01-.285-.604c.125-.075 1.443-.505 3.02-.487 2.162.023 3.948.857 5.165 2.412.302.386.448 1.018.435 1.877-.012.783-.16 1.744-.427 2.778-.583 2.257-1.68 4.683-3.009 6.656a.334.334 0 01-.278.147"
      ></path>
      <path
        fill="#FFF"
        d="M25.934 23.723c.081.067.427.175 1.106.143.615-.03 1.263-.164 1.65-.343.45-.21.767-.442.952-.615l-.015.003c-1.375.283-2.349.244-2.895-.116a1.17 1.17 0 01-.093-.068 2.64 2.64 0 01-.142.042c-.31.087-.601.17-.563.954m.886.816c-.497 0-.943-.07-1.21-.23-.282-.168-.336-.399-.343-.521-.073-1.283.614-1.538.995-1.647a4.6 4.6 0 00-.178-.232c-.214-.268-.508-.635-.735-1.185a7.82 7.82 0 00-.273-.51c-.696-1.25-2.146-3.85-1.209-5.189.43-.615 1.28-.862 2.53-.735-.167-.493-.583-1.408-1.352-2.317-.891-1.053-2.472-2.318-4.937-2.359-1.25-.02-2.277.364-3.048 1.141-1.728 1.743-1.67 4.914-1.669 4.946a.335.335 0 01-.669.018c-.004-.142-.069-3.485 1.86-5.433.905-.913 2.095-1.364 3.537-1.341 2.689.044 4.42 1.41 5.398 2.55 1.066 1.24 1.589 2.612 1.632 3.07.035.368-.248.437-.28.444l-.12.002c-1.527-.244-2.112.082-2.334.398-.696.996.665 3.436 1.246 4.479.15.267.257.46.307.581.19.462.439.772.638 1.022.178.222.332.415.389.643.03.048.4.554 2.497.121.55-.114.882-.013.985.298.199.602-.898 1.294-1.506 1.577-.54.25-1.403.41-2.15.41m-11.101-.03c.097.066.262.146.446.192.893.223 2.136.239 2.99-.956.1-.142.07-.324.042-.42-.058-.203-.201-.387-.348-.448-.182-.076-.282-.117-.501.128-.147.164-.253.3-.347.418-.409.519-.596.695-1.807.944a2.18 2.18 0 00-.475.142zm1.35.98c-.34 0-.696-.046-1.066-.139-.107-.027-1.038-.277-1.026-.872.011-.546.79-.706 1.082-.766 1.03-.212 1.096-.297 1.416-.703.095-.12.213-.27.374-.45.535-.6 1.04-.39 1.256-.3.338.14.62.478.736.882.105.366.054.718-.142.993-.636.891-1.549 1.354-2.63 1.354z"
      ></path>
      <path
        fill="#FFF"
        d="M15.394 15.805l.011.208c.035.577.098 1.652-.074 2.887a2.819 2.819 0 00.738 2.36 2.382 2.382 0 001.71.757c.072-.297.188-.61.314-.947l.05-.133c.064-.172.138-.338.218-.514.384-.855.863-1.919.311-4.471-.106-.493-.363-.78-.784-.876-.922-.211-2.215.482-2.494.73zm2.657 7.299a.335.335 0 01-.33-.284 1.536 1.536 0 01-.015-.135 3.052 3.052 0 01-2.12-.962c-.735-.767-1.07-1.83-.918-2.916.163-1.169.102-2.2.07-2.755a5.184 5.184 0 01-.016-.344c0-.102.002-.373.884-.82.31-.158.933-.432 1.613-.503 1.135-.117 1.883.389 2.108 1.426.598 2.767.047 3.992-.356 4.886a7.854 7.854 0 00-.201.473l-.05.134c-.21.566-.393 1.054-.338 1.414a.335.335 0 01-.33.386z"
      ></path>
      <path
        fill="#FFF"
        d="M17.236 15.662c-.016.11.2.401.482.44.28.04.521-.189.536-.298.016-.11-.2-.23-.482-.27-.28-.039-.521.019-.536.128z"
      ></path>
      <path
        fill="#FFF"
        d="M17.348 15.748c.017.093.177.347.385.383.21.036.383-.17.409-.244-.025-.045-.153-.146-.385-.186-.228-.04-.374.013-.41.047m.432.663a.445.445 0 01-.077-.007c-.177-.03-.355-.168-.477-.369-.044-.07-.114-.208-.1-.332a.278.278 0 01.088-.174c.111-.105.331-.144.575-.102.298.052.606.227.577.49-.024.21-.292.494-.586.494m8.016-.972c.016.109-.2.401-.482.44-.28.04-.521-.189-.537-.298-.015-.11.201-.23.482-.27.282-.039.522.018.537.128z"
      ></path>
      <path
        fill="#FFF"
        d="M25.433 15.403a.844.844 0 00-.167.018c-.294.058-.441.226-.434.296.01.108.222.41.474.36.151-.03.265-.172.32-.254.084-.128.118-.248.114-.288-.005-.055-.115-.132-.307-.132m-.183.84c-.277 0-.51-.317-.529-.504-.023-.24.25-.421.53-.477.28-.056.576.012.6.25.01.108-.047.273-.145.422-.064.097-.2.266-.385.302a.359.359 0 01-.07.007m.949 5.503a.335.335 0 01-.278-.52c.655-.978.535-1.977.419-2.943-.05-.414-.102-.843-.088-1.255.013-.424.067-.773.119-1.11.061-.398.12-.774.095-1.22a.335.335 0 11.668-.035c.028.514-.038.942-.102 1.357-.049.317-.1.646-.111 1.03-.012.36.034.746.083 1.153.125 1.037.266 2.212-.526 3.394a.334.334 0 01-.278.149"
      ></path>
    </g>
  </svg>
);

export const Tableau = ({ ...props }) => {
  return (
    <Svg width="40px" height="40px" viewBox="0 0 60 60" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-216.000000, -259.000000)">
          <g transform="translate(216.000000, 259.000000)">
            <circle fill="#E6F3FF" cx="30" cy="30" r="30"></circle>
            <g transform="translate(12.000000, 12.000000)">
              <polygon
                fill="#E7762C"
                points="23.6561311 16.5234098 18.7654426 16.5234098 18.7654426 11.206623 16.8426885 11.206623 16.8426885 16.5234098 11.9514098 16.5234098 11.9514098 18.4125246 16.8426885 18.4125246 16.8426885 23.7281311 18.7654426 23.7281311 18.7654426 18.4125246 23.6561311 18.4125246"
              ></polygon>
              <polygon
                fill="#C72036"
                points="13.8230557 25.2033049 9.44049836 25.2033049 9.44049836 20.4436328 7.7821377 20.4436328 7.7821377 25.2033049 3.40076066 25.2033049 3.40076066 26.654518 7.7821377 26.654518 7.7821377 31.4153705 9.44049836 31.4153705 9.44049836 26.654518 13.8230557 26.654518"
              ></polygon>
              <polygon
                fill="#5A879A"
                points="32.2074295 8.17642623 27.8260525 8.17642623 27.8260525 3.3937377 26.1659213 3.3937377 26.1659213 8.17642623 21.7845443 8.17642623 21.7845443 9.62645902 26.1659213 9.62645902 26.1659213 14.3648852 27.8260525 14.3648852 27.8260525 9.62645902 32.2074295 9.62645902"
              ></polygon>
              <polygon
                fill="#5B6591"
                points="17.1236656 27.1658361 17.1236656 30.4855082 14.1516 30.4855082 14.1516 31.7673443 17.1236656 31.7673443 17.1236656 35.0876066 18.540059 35.0876066 18.540059 31.7673443 21.5133049 31.7673443 21.5133049 30.4855082 18.540059 30.4855082 18.540059 27.1658361"
              ></polygon>
              <polygon
                fill="#EA9128"
                points="13.8230557 8.17554098 9.3891541 8.17554098 9.3891541 3.39344262 7.8346623 3.39344262 7.8346623 8.17554098 3.40076066 8.17554098 3.40076066 9.58367213 7.8346623 9.58367213 7.8346623 14.3645902 9.3891541 14.3645902 9.3891541 9.58367213 13.8230557 9.58367213"
              ></polygon>
              <polygon
                fill="#5B6591"
                points="31.1842033 13.5079082 31.1842033 16.8269902 28.2115475 16.8269902 28.2115475 18.1094164 31.1842033 18.1094164 31.1842033 21.4290885 32.6011869 21.4290885 32.6011869 18.1094164 35.5738426 18.1094164 35.5738426 16.8269902 32.6011869 16.8269902 32.6011869 13.5079082"
              ></polygon>
              <polygon
                fill="#1F447E"
                points="32.2074295 25.2033049 27.8260525 25.2033049 27.8260525 20.4436328 26.1659213 20.4436328 26.1659213 25.2033049 21.7845443 25.2033049 21.7845443 26.654518 26.1659213 26.654518 26.1659213 31.4153705 27.8260525 31.4153705 27.8260525 26.654518 32.2074295 26.654518"
              ></polygon>
              <polygon
                fill="#7098A5"
                points="17.3031934 -0.000236065574 17.3031934 3.25746885 14.3624066 3.25746885 14.3624066 4.24304262 17.3031934 4.24304262 17.3031934 7.50015738 18.3607672 7.50015738 18.3607672 4.24304262 21.3021443 4.24304262 21.3021443 3.25746885 18.3607672 3.25746885 18.3607672 -0.000236065574"
              ></polygon>
              <polygon
                fill="#7098A5"
                points="2.95211803 13.7612656 2.95211803 16.9546426 0.000118032787 16.9546426 0.000118032787 17.9815279 2.95211803 17.9632328 2.95211803 21.1754951 3.98962623 21.1754951 3.98962623 17.9573311 6.94162623 17.9396262 6.94162623 16.9546426 3.98962623 16.9546426 3.98962623 13.7612656"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </Svg>
  );
};

export const Zendesk = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <circle fill="#D7EEF2" cx="20" cy="20" r="20"></circle>
        <g transform="translate(11.000000, 13.000000)" fill="#03363D" fillRule="nonzero">
          <path d="M8.33731907,3.4408433 L8.33731907,13.032725 L0.393643801,13.032725 L8.33731907,3.4408433 Z M8.33731907,0 C8.33731907,2.19194462 6.56167401,3.96758968 4.36972939,3.96758968 C2.17778477,3.96758968 0.393643801,2.19194462 0.393643801,0 L8.33731907,0 Z M9.64568911,13.032725 C9.64568911,10.8407804 11.4213342,9.06513531 13.6132788,9.06513531 C15.8052234,9.06513531 17.5808685,10.8407804 17.5808685,13.032725 L9.64568911,13.032725 L9.64568911,13.032725 Z M9.64568911,9.59188169 L9.64568911,0 L17.5893644,0 L9.64568911,9.59188169 Z"></path>
        </g>
      </g>
    </g>
  </Svg>
);

export const Airtable = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#E6F3FF" />
    <path
      d="M18.7171 10.2535L9.76917 13.956C9.27158 14.1619 9.27673 14.8688 9.77744 15.0673L18.7627 18.6304C19.5521 18.9435 20.4313 18.9435 21.2208 18.6304L30.2062 15.0671C30.7067 14.8688 30.7122 14.162 30.2143 13.9561L21.2666 10.2533C20.4503 9.91555 19.5333 9.91555 18.717 10.2533"
      fill="#FCB400"
    />
    <path
      d="M20.7888 20.5761V29.4775C20.7888 29.9007 21.2157 30.1908 21.6093 30.0347L31.6216 26.1484C31.7332 26.1042 31.829 26.0274 31.8965 25.928C31.964 25.8286 32.0001 25.7113 32.0001 25.5912V16.6899C32.0001 16.2665 31.5731 15.9766 31.1796 16.1326L21.1673 20.0189C21.0557 20.0632 20.9599 20.14 20.8924 20.2394C20.8249 20.3388 20.7888 20.4561 20.7888 20.5762"
      fill="#18BFFF"
    />
    <path
      d="M18.4507 21.0356L15.4793 22.4703L15.1776 22.6161L8.9051 25.6216C8.50763 25.8134 8 25.5237 8 25.082V16.7274C8 16.5676 8.08194 16.4296 8.19182 16.3259C8.2369 16.281 8.28804 16.2426 8.34375 16.2119C8.49352 16.122 8.70732 16.0979 8.8891 16.1698L18.4008 19.9387C18.8843 20.1305 18.9223 20.808 18.4507 21.0357"
      fill="#F82B60"
    />
    <path
      d="M18.4508 21.0356L15.4794 22.4703L8.19189 16.3257C8.23698 16.2809 8.28812 16.2426 8.34383 16.2119C8.4936 16.122 8.70739 16.0979 8.88917 16.1698L18.4009 19.9387C18.8844 20.1305 18.9224 20.808 18.4508 21.0357"
      fill="black"
      fillOpacity="0.25"
    />
  </Svg>
);

export const Amplitude = ({ ...props }) => (
  <Svg width="60" height="60" viewBox="0 0 60 60" fill="none" {...props}>
    <circle cx="30" cy="30" r="30" fill="#3260E7" />
    <path
      d="M30 0C46.5663 0 60 13.4337 60 30C60 46.5663 46.5663 60 30 60C13.4337 60 0 46.5783 0 30C0 13.4217 13.4337 0 30 0ZM26.0361 9.16867C22.3373 9.18072 18.988 15.1325 16.1084 26.8434C14.0723 26.8193 12.2048 26.7831 10.4578 26.759H10.1928C9.9759 26.747 9.75904 26.759 9.54217 26.7831C8.55422 26.9639 7.84337 27.8313 7.84337 28.8313C7.84337 29.8554 8.60241 30.7349 9.61446 30.8916L9.63855 30.9157H15.1687C14.6506 33.253 14.2048 35.5783 13.8313 37.8072L13.6627 38.7831V38.8313C13.6627 39.3012 13.9036 39.7349 14.3012 39.988C14.9398 40.3976 15.7952 40.2048 16.2048 39.5663L16.241 39.6024L18.9518 30.9157H32.012C33.012 34.6988 34.0482 38.5904 35.4217 42.253C36.1566 44.2169 37.8675 48.7952 40.7349 48.8193H40.7711C45.2048 48.8193 46.9398 41.6506 48.0843 36.9036C48.3373 35.8795 48.5422 35 48.747 34.3494L48.8313 34.0843L48.8434 34.0454C48.9373 33.7067 48.7461 33.3449 48.4096 33.2289C48.0602 33.1084 47.6627 33.2892 47.5422 33.6506L47.4458 33.9157C47.0723 34.9639 46.7229 35.9398 46.4096 36.8193L46.3855 36.8916C44.4578 42.3253 43.5904 44.8072 41.8675 44.8072H41.759C39.5542 44.8072 37.494 35.8675 36.7108 32.506C36.5783 31.9277 36.4578 31.3855 36.3373 30.9157H50.5542C50.8072 30.9157 51.0602 30.8554 51.2892 30.7349L51.3003 30.7259C51.3133 30.7169 51.3313 30.7078 51.3494 30.6988L51.4217 30.6506L51.4578 30.6265C51.494 30.6024 51.5301 30.5783 51.5663 30.5422L51.6195 30.498C51.8806 30.271 52.0655 29.9541 52.1446 29.6265C52.3253 28.7711 51.759 27.9277 50.9036 27.759H50.8313C50.747 27.747 50.6747 27.7349 50.5904 27.7349L50.3735 27.7108C45.3494 27.3494 40.1807 27.2048 35.3253 27.1084L35.3133 27.0723C32.9639 18.2169 30.012 9.16867 26.0361 9.16867ZM25.8795 13.1566C26.0843 13.1566 26.2771 13.2771 26.4458 13.494C26.8554 14.1446 27.5783 15.6024 28.6506 18.8313C29.3855 21.0482 30.1807 23.8072 31.0241 27.012C27.8193 26.9639 24.5904 26.9277 21.4578 26.8916L19.8675 26.8795C21.6626 19.8675 23.8434 14.5542 25.4458 13.3012C25.5783 13.2169 25.7229 13.1566 25.8795 13.1566Z"
      fill="#E6F3FF"
    />
  </Svg>
);

export const Gong = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#E5E4FF" />
    <path
      d="M30.63 18.2669H24.1256C23.818 18.2669 23.5664 18.5278 23.5758 18.8353C23.5758 18.8912 23.5851 18.9471 23.6037 19.003L25.1693 23.0567C25.2252 23.1965 25.1506 23.3549 25.0108 23.4015C24.9736 23.4108 24.9363 23.4201 24.899 23.4201L22.8955 23.299C22.8023 23.2897 22.7184 23.3362 22.6625 23.4108L21.1063 25.6193C21.0224 25.7498 20.8547 25.7871 20.7335 25.7032C20.7335 25.7032 20.7335 25.7032 20.7242 25.7032L18.4225 24.1377C18.3293 24.0724 18.2082 24.0724 18.1243 24.1377L14.9373 26.2996C14.8162 26.3835 14.6484 26.3555 14.5645 26.2344C14.518 26.1691 14.5086 26.0853 14.5273 26.0107L15.4126 22.833C15.4498 22.7026 15.3846 22.5628 15.2541 22.5162L13.5674 21.8266C13.4277 21.7707 13.3624 21.6216 13.4183 21.4818C13.4277 21.4539 13.4463 21.4352 13.4649 21.4073L14.9559 19.5622C15.0305 19.469 15.0305 19.3385 14.9653 19.2453L13.7165 17.4282C13.6327 17.307 13.6606 17.1393 13.7818 17.0554C13.8191 17.0275 13.8656 17.0088 13.9216 17.0088L15.8692 16.8597C16.0183 16.8504 16.1208 16.7293 16.1208 16.5802L15.9717 13.8498C15.9624 13.7007 16.0835 13.5702 16.2326 13.5609C16.2699 13.5609 16.3072 13.5702 16.3444 13.5795L18.758 14.5766C18.8605 14.6232 18.9816 14.5953 19.0562 14.5021L20.7149 12.6383C20.8174 12.5265 20.9852 12.5172 21.097 12.6197C21.1249 12.6477 21.1436 12.6756 21.1622 12.7129L22.1593 15.2849C22.2711 15.5551 22.588 15.6856 22.8582 15.5737C22.8955 15.5551 22.9421 15.5365 22.97 15.5085L26.8839 12.6011C27.1169 12.424 27.1728 12.0979 26.9957 11.8556C26.8839 11.6972 26.6882 11.6133 26.4925 11.6412L23.9112 11.986C23.7901 12.0047 23.6783 11.9301 23.6317 11.8183L22.2711 8.33309C22.1593 8.06285 21.8518 7.93239 21.5816 8.03489C21.507 8.06285 21.4418 8.10944 21.3859 8.17467L18.4411 11.371C18.3666 11.4549 18.2454 11.4735 18.1429 11.4362L14.2663 9.79613C13.9961 9.68431 13.6793 9.80545 13.5581 10.085C13.5302 10.1409 13.5209 10.2062 13.5209 10.2714L13.3811 14.2691C13.3718 14.4089 13.2692 14.5114 13.1295 14.53L9.58835 14.763C9.29015 14.7817 9.07582 15.0333 9.09445 15.3315C9.10377 15.4246 9.13173 15.5178 9.18764 15.5924L11.5453 19.0683C11.6105 19.1708 11.6105 19.3012 11.5266 19.3944L9.13173 22.1434C8.93604 22.3671 8.96399 22.7026 9.17832 22.8889C9.22492 22.9262 9.27151 22.9542 9.3181 22.9821L12.0858 24.1749C12.2069 24.2215 12.2721 24.3613 12.2349 24.4824L10.4829 31.3317C10.4084 31.6206 10.5855 31.9095 10.865 31.984C11.0234 32.0213 11.1818 31.9933 11.3123 31.9002L17.9007 27.1756C17.9938 27.1103 18.115 27.1103 18.2082 27.1756L21.2088 29.2816C21.4511 29.4493 21.7866 29.3934 21.9543 29.1511L21.9636 29.1418L23.8367 26.2623C23.8926 26.1785 23.9951 26.1319 24.0976 26.1505L28.5799 26.691C28.9433 26.7469 29.3068 26.4394 29.1763 26.1039L27.3126 21.2675C27.2567 21.1277 27.3312 20.9693 27.471 20.9134V20.9134L30.8816 19.3012C31.3849 19.0496 31.2078 18.2669 30.63 18.2669Z"
      fill="#8039E9"
    />
  </Svg>
);

export const FacebookAds = ({ ...props }) => (
  <Svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill="#F7F7F7"
    />
    <path
      d="M9.65536 22.8084C9.65536 23.8562 9.88493 24.6573 10.185 25.1431C10.3449 25.4197 10.5751 25.649 10.8524 25.8078C11.1296 25.9665 11.4439 26.0491 11.7634 26.0471C12.5349 26.0471 13.2408 25.8566 14.601 23.9743C15.6908 22.4664 16.9748 20.3546 17.8397 19.021L19.3029 16.773C20.3192 15.2117 21.4938 13.4762 22.8445 12.2959C23.9447 11.3396 25.1325 10.8061 26.328 10.8061C28.335 10.8061 30.2468 11.9692 31.7099 14.1506C33.3112 16.5396 34.0913 19.5487 34.0913 22.6541C34.0913 24.5001 33.7275 25.8566 33.1083 26.9282C32.511 27.9646 31.3413 29 29.38 29V26.0471C31.0593 26.0471 31.4756 24.5039 31.4756 22.7379C31.4756 20.2212 30.8888 17.4283 29.5962 15.4327C28.6789 14.0172 27.4901 13.1523 26.1822 13.1523C24.7677 13.1523 23.6294 14.2192 22.3501 16.1214C21.67 17.1321 20.9718 18.3637 20.1878 19.7535L19.3248 21.2776C17.5911 24.3515 17.152 25.0516 16.2852 26.2071C14.7687 28.2379 13.4713 29 11.7634 29C9.73728 29 8.45609 28.1227 7.66737 26.8005C7.01487 25.7232 6.69672 24.3096 6.69672 22.6988L9.65536 22.8084Z"
      fill="#0081FB"
    />
    <path
      d="M9.02997 14.3592C10.3864 12.2683 12.3439 10.8061 14.5891 10.8061C15.8893 10.8061 17.182 11.1872 18.5317 12.2931C20.0082 13.4981 21.5799 15.4822 23.545 18.7524L24.249 19.9259C25.9484 22.7569 26.9162 24.2124 27.481 24.9002C28.2088 25.7823 28.7193 26.0433 29.3804 26.0433C31.0598 26.0433 31.476 24.5001 31.476 22.7341L34.0861 22.6521C34.0861 24.4982 33.7222 25.8546 33.103 26.9263C32.5115 27.9646 31.3417 29 29.3804 29C28.1611 29 27.0809 28.7352 25.8864 27.6083C24.9682 26.7434 23.8946 25.2069 23.0688 23.8257L20.6121 19.7221C19.3795 17.6626 18.2488 16.1271 17.5944 15.4356C16.8895 14.684 15.9855 13.781 14.5415 13.781C13.3727 13.781 12.3801 14.6011 11.5495 15.8556L9.02997 14.3592Z"
      fill="url(#paint0_linear_4206_60)"
    />
    <path
      d="M14.541 13.781C13.3722 13.781 12.3797 14.6011 11.549 15.8556C10.3745 17.6284 9.65536 20.2688 9.65536 22.8084C9.65536 23.8562 9.88493 24.6573 10.185 25.1431L7.66261 26.8005C7.01487 25.7232 6.69672 24.3096 6.69672 22.6988C6.69672 19.7697 7.50068 16.7168 9.02953 14.3592C10.386 12.2683 12.3435 10.8061 14.5887 10.8061L14.541 13.781Z"
      fill="url(#paint1_linear_4206_60)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4206_60"
        x1="12.6354"
        y1="19.4316"
        x2="31.4961"
        y2="20.3841"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0064E1" />
        <stop offset="0.4" stopColor="#0064E1" />
        <stop offset="0.83" stopColor="#0073EE" />
        <stop offset="1" stopColor="#0082FB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4206_60"
        x1="10.6422"
        y1="24.0467"
        x2="10.6422"
        y2="17.093"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0082FB" />
        <stop offset="1" stopColor="#0064E0" />
      </linearGradient>
    </defs>
  </Svg>
);

export const GoogleAnalytics4 = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20" cy="20" r="20" fill="#FEEDCB" />
    <path
      d="M30.5499 28.9063C30.558 30.4685 29.3332 31.7406 27.8153 31.749C27.7025 31.7499 27.5887 31.7434 27.4768 31.7293C26.0681 31.515 25.0362 30.2542 25.0708 28.7902V11.9586C25.0371 10.4928 26.0718 9.23193 27.4814 9.01945C28.9892 8.83786 30.3551 9.94799 30.5317 11.499C30.5444 11.6132 30.5508 11.7274 30.5499 11.8425V28.9063Z"
      fill="#F9AB00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4412 20.8444C17.405 19.3217 18.6097 18.0466 20.163 17.9628C20.1788 17.9619 20.1955 17.9619 20.2113 17.9619C21.7628 17.9646 23.0177 19.1979 23.0149 20.717V28.9759C23.0159 29.1616 22.9973 29.3464 22.9591 29.5284C22.6515 31.0147 21.1725 31.975 19.6545 31.6737C18.3392 31.4152 17.4412 30.2029 17.4412 28.205V20.8444ZM15.5979 29.0087C15.5979 27.4951 14.3448 26.2682 12.7989 26.2682C11.2531 26.2682 10 27.4951 10 29.0087C10 30.5223 11.2531 31.7492 12.7989 31.7492C14.3448 31.7492 15.5979 30.5223 15.5979 29.0087Z"
      fill="#E37400"
    />
    <path
      d="M13.4708 17.0001V15.5361H14.4428V13.7241H13.4708V8.99609H10.6028L7.56677 13.9281V15.5361H11.3948V17.0001H13.4708ZM11.3948 13.7241H9.57077L11.3948 10.7961V13.7241Z"
      fill="#E37400"
    />
  </svg>
);

export const Klaviyo = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#F5F5F5" />
    <path d="M30 14H10V27H30L26.046 20.5L30 14Z" fill="#232426" />
  </Svg>
);

export const Mailchimp = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#FFF3A8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.5315 19.0275C25.7018 19.0071 25.8649 19.0063 26.0148 19.0275C26.1015 18.8285 26.1165 18.4856 26.0384 18.1121C25.9225 17.557 25.7655 17.2211 25.4411 17.2734C25.1167 17.3257 25.1047 17.7278 25.2207 18.2829C25.2859 18.5952 25.4022 18.8621 25.5315 19.0275Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.7469 19.4669C22.979 19.5687 23.1216 19.6362 23.1774 19.5772C23.2133 19.5404 23.2025 19.4703 23.1471 19.3797C23.0326 19.1928 22.797 19.0031 22.547 18.8966C22.0358 18.6766 21.4261 18.7498 20.9558 19.0877C20.8005 19.2015 20.6533 19.3591 20.6744 19.4548C20.6812 19.4857 20.7044 19.509 20.759 19.5166C20.887 19.5313 21.3343 19.3051 21.8496 19.2736C22.2135 19.2513 22.5148 19.3651 22.7469 19.4669Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.28 19.7332C21.9778 19.781 21.8109 19.8806 21.704 19.9733C21.6126 20.0532 21.5561 20.1414 21.5566 20.2034C21.5569 20.233 21.5697 20.25 21.5798 20.2585C21.5935 20.2706 21.6099 20.2774 21.6295 20.2774C21.6977 20.2774 21.8507 20.2161 21.8507 20.2161C22.2713 20.0655 22.5488 20.0837 22.8239 20.1151C22.9758 20.1321 23.0476 20.1416 23.0809 20.0895C23.0908 20.0746 23.1027 20.0422 23.0723 19.9928C23.0015 19.8779 22.6963 19.6838 22.28 19.7332Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5913 20.7111C24.7965 20.8119 25.0225 20.7724 25.0961 20.6227C25.1696 20.473 25.0629 20.2699 24.8576 20.1691C24.6523 20.0682 24.4264 20.1078 24.3528 20.2575C24.2793 20.4072 24.3861 20.6103 24.5913 20.7111Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9108 19.5581C25.7441 19.5553 25.6058 19.7384 25.6019 19.9671C25.598 20.1957 25.7301 20.3834 25.8968 20.3862C26.0636 20.389 26.2018 20.2059 26.2057 19.9773C26.2096 19.7486 26.0776 19.561 25.9108 19.5581Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7112 23.6811C14.6697 23.6291 14.6016 23.645 14.5357 23.6603C14.4896 23.671 14.4373 23.6832 14.3801 23.6822C14.2575 23.6798 14.1536 23.6274 14.0953 23.5378C14.0194 23.4212 14.0237 23.2473 14.1076 23.0481C14.1189 23.0214 14.1322 22.9915 14.1467 22.959C14.2805 22.659 14.5043 22.1568 14.253 21.6783C14.0638 21.3182 13.7554 21.0939 13.3845 21.0468C13.0284 21.0017 12.6619 21.1337 12.4281 21.3917C12.0593 21.7986 12.0016 22.3523 12.0729 22.548C12.0991 22.6196 12.14 22.6395 12.1697 22.6435C12.2325 22.652 12.3252 22.6063 12.3834 22.45C12.3876 22.4387 12.3931 22.4212 12.4 22.3991C12.4259 22.3164 12.4742 22.1624 12.5531 22.0391C12.6484 21.8902 12.7968 21.7878 12.9709 21.7504C13.1484 21.7125 13.3297 21.7463 13.4815 21.8456C13.7399 22.0148 13.8394 22.3314 13.7291 22.6335C13.6721 22.7897 13.5794 23.0885 13.5999 23.334C13.6411 23.8308 13.9468 24.0303 14.2213 24.0515C14.4883 24.0616 14.6749 23.9118 14.722 23.8022C14.7499 23.7374 14.7264 23.698 14.7112 23.6811Z"
      fill="black"
    />
    <mask id="mask0_320_5431" maskUnits="userSpaceOnUse" x="9" y="8" width="22" height="24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 8.00537H30.9773V31.3303H9V8.00537Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_320_5431)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2491 14.5558C18.1198 13.5497 19.1916 12.6749 20.1517 12.1838C20.1849 12.1668 20.2202 12.2028 20.2021 12.2355C20.1259 12.3736 19.9792 12.6691 19.9326 12.8934C19.9254 12.9283 19.9634 12.9547 19.9929 12.9346C20.5902 12.5274 21.6293 12.0911 22.5407 12.0351C22.5799 12.0326 22.5988 12.0828 22.5676 12.1068C22.429 12.213 22.2774 12.3602 22.1668 12.509C22.1479 12.5343 22.1656 12.5708 22.1972 12.571C22.8372 12.5755 23.7394 12.7995 24.3274 13.1293C24.3672 13.1516 24.3389 13.2287 24.2943 13.2185C23.4046 13.0146 21.9482 12.8599 20.4354 13.2289C19.0849 13.5583 18.054 14.0669 17.302 14.6139C17.264 14.6415 17.2183 14.5913 17.2491 14.5558ZM25.1759 24.7275C25.2017 24.7166 25.2195 24.6872 25.2165 24.6579C25.2128 24.622 25.1808 24.5958 25.1448 24.5995C25.1448 24.5995 23.2867 24.8745 21.5314 24.2319C21.7226 23.6105 22.2311 23.8349 22.9994 23.8969C24.3844 23.9794 25.6258 23.7771 26.5431 23.5139C27.3381 23.2857 28.3822 22.8359 29.1931 22.1959C29.4667 22.7967 29.5633 23.4579 29.5633 23.4579C29.5633 23.4579 29.775 23.42 29.952 23.529C30.1191 23.6318 30.2418 23.8458 30.158 24.3988C29.9875 25.432 29.5483 26.2705 28.8102 27.0419C28.361 27.5255 27.8155 27.946 27.1915 28.2518C26.86 28.4258 26.5071 28.5765 26.1344 28.6982C23.3519 29.607 20.5038 28.6079 19.5857 26.4624C19.5125 26.3011 19.4505 26.1323 19.4016 25.9556C19.0104 24.5418 19.3425 22.8456 20.3809 21.7779C20.3809 21.7778 20.3807 21.7775 20.3808 21.7774C20.4448 21.7094 20.5101 21.6294 20.5101 21.5286C20.5101 21.4443 20.4566 21.3554 20.4101 21.2924C20.0469 20.7655 18.7886 19.8677 19.0412 18.1302C19.2225 16.882 20.3142 16.0029 21.332 16.055C21.4179 16.0595 21.504 16.0647 21.5899 16.0699C22.0309 16.096 22.4157 16.1525 22.7788 16.1677C23.3864 16.1939 23.933 16.1056 24.5801 15.5664C24.7985 15.3844 24.9735 15.2267 25.2697 15.1765C25.3008 15.1712 25.3782 15.1434 25.5331 15.1507C25.6911 15.1592 25.8414 15.2026 25.9766 15.2925C26.4955 15.6378 26.5691 16.474 26.596 17.0858C26.6113 17.435 26.6536 18.2798 26.668 18.5223C26.701 19.0769 26.8467 19.1551 27.1417 19.2522C27.3076 19.3068 27.4615 19.3475 27.6884 19.4112C28.3753 19.604 28.7824 19.7997 29.0392 20.051C29.1923 20.208 29.2634 20.3749 29.2854 20.5341C29.3664 21.1249 28.8267 21.8547 27.398 22.5179C25.8363 23.2428 23.9416 23.4263 22.6325 23.2805C22.5321 23.2693 22.1751 23.2288 22.1739 23.2287C21.1268 23.0876 20.5294 24.4409 21.1579 25.368C21.5629 25.9656 22.6661 26.3545 23.7699 26.3546C26.3007 26.355 28.246 25.2742 28.9695 24.3408C28.9911 24.3129 28.9933 24.3099 29.0274 24.2583C29.063 24.2047 29.0336 24.1751 28.9893 24.2055C28.3981 24.61 25.7722 26.2159 22.9635 25.7328C22.9635 25.7328 22.6222 25.6767 22.3107 25.5554C22.0631 25.4592 21.545 25.2208 21.482 24.6892C23.7487 25.3902 25.1759 24.7275 25.1759 24.7275ZM12.7259 19.3406C11.9376 19.4939 11.2428 19.9407 10.8179 20.5579C10.564 20.3461 10.0909 19.936 10.0073 19.7763C9.32902 18.4883 10.7476 15.9842 11.7386 14.57C14.1876 11.0751 18.0234 8.42979 19.799 8.9097C20.0876 8.9914 21.0437 10.0999 21.0437 10.0999C21.0437 10.0999 19.2688 11.0847 17.6228 12.4575C15.4049 14.1653 13.7295 16.6473 12.7259 19.3406ZM14.0505 25.2509C13.9312 25.2712 13.8095 25.2793 13.6867 25.2764C12.5006 25.2446 11.2195 24.1768 11.0921 22.9104C10.9514 21.5107 11.6666 20.4334 12.9329 20.1781C13.0843 20.1475 13.2673 20.1299 13.4645 20.1402C14.174 20.179 15.2195 20.7238 15.4584 22.2694C15.67 23.6383 15.334 25.032 14.0505 25.2509ZM30.1179 22.7723C30.1077 22.7364 30.0416 22.4945 29.9506 22.2029C29.8597 21.9113 29.7655 21.7061 29.7655 21.7061C30.1303 21.1599 30.1368 20.6714 30.0884 20.3948C30.0365 20.0519 29.8938 19.7597 29.606 19.4577C29.3183 19.1556 28.7299 18.8462 27.9028 18.6141C27.8082 18.5875 27.4963 18.5019 27.4689 18.4936C27.4667 18.4756 27.4461 17.4705 27.4272 17.0391C27.4135 16.7272 27.3868 16.2403 27.2357 15.7606C27.0556 15.1114 26.7419 14.5434 26.3503 14.1799C27.431 13.0597 28.1056 11.8257 28.1039 10.767C28.1008 8.7312 25.6006 8.11518 22.5194 9.39107C22.5161 9.39242 21.8712 9.66587 21.8666 9.66817C21.8637 9.66536 20.6864 8.5102 20.6686 8.49475C17.1557 5.43066 6.17212 17.6392 9.68372 20.6043L10.4512 21.2544C10.2521 21.7701 10.1739 22.3609 10.2378 22.9963C10.3198 23.8123 10.7408 24.5946 11.423 25.199C12.0707 25.7729 12.9222 26.136 13.7486 26.1354C15.1151 29.2845 18.2375 31.2164 21.8985 31.3251C25.8256 31.4418 29.1222 29.5991 30.5035 26.2889C30.5939 26.0566 30.9773 25.0098 30.9773 24.0858C30.9773 23.1572 30.4523 22.7723 30.1179 22.7723Z"
        fill="black"
      />
    </g>
  </Svg>
);

export const MongoDB = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#DCF3D1" />
    <path
      d="M25.5415 17.4139C24.1703 11.4213 21.3124 9.82594 20.5834 8.69822C20.2827 8.20143 20.0164 7.68504 19.7863 7.15259C19.7478 7.68495 19.677 8.02034 19.2202 8.42405C18.3031 9.23413 14.4081 12.3786 14.0803 19.1875C13.7749 25.536 18.7912 29.4506 19.454 29.8552C19.9636 30.1037 20.5843 29.8605 20.887 29.6325C23.3052 27.9884 26.6091 23.6053 25.5442 17.4139"
      fill="#10AA50"
    />
    <path
      d="M19.9944 26.4749C19.8681 28.0462 19.7777 28.9592 19.457 29.8571C19.457 29.8571 19.6675 31.3531 19.8153 32.9377H20.3383C20.4631 31.8218 20.6536 30.7141 20.9088 29.6202C20.2317 29.2902 20.0204 27.8537 19.9944 26.4749Z"
      fill="#B8C4C2"
    />
    <path
      d="M20.9079 29.6211C20.2237 29.3079 20.0257 27.8413 19.9953 26.4749C20.1645 24.2209 20.2138 21.9596 20.143 19.7005C20.1072 18.5151 20.1601 8.72143 19.8484 7.2876C20.0616 7.77322 20.3072 8.24422 20.5837 8.69747C21.3127 9.82608 24.1715 11.4214 25.5418 17.414C26.6094 23.5948 23.3234 27.9664 20.9079 29.6211Z"
      fill="#12924F"
    />
  </Svg>
);

export const OneDrive = ({ ...props }) => (
  <Svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
    <circle cx="20" cy="20" r="20" fill="#DAF1FF" />
    <g clipPath="url(#clip0_512_3830)">
      <path
        d="M16.6772 15.9813L16.6775 15.9803L22.5554 19.5012L26.058 18.0272L26.0582 18.0278C26.7699 17.7201 27.5372 17.5617 28.3126 17.5625C28.4418 17.5625 28.5695 17.5684 28.6965 17.5768C28.2754 15.9348 27.3865 14.4505 26.1377 13.3042C24.8889 12.1578 23.334 11.3989 21.662 11.1196C19.99 10.8403 18.2729 11.0526 16.7193 11.7308C15.1658 12.409 13.8426 13.5238 12.9106 14.9398C12.9406 14.9394 12.9701 14.9375 13.0001 14.9375C14.2992 14.9357 15.5728 15.2973 16.6772 15.9813V15.9813Z"
        fill="#0364B8"
      />
      <path
        d="M16.6774 15.9803L16.6771 15.9813C15.5727 15.2973 14.2991 14.9357 13 14.9375C12.97 14.9375 12.9405 14.9394 12.9105 14.9398C11.6391 14.9555 10.3959 15.3174 9.31473 15.9866C8.2335 16.6558 7.35507 17.607 6.77382 18.7379C6.19258 19.8688 5.9305 21.1368 6.01574 22.4055C6.10099 23.6742 6.53034 24.8957 7.25765 25.9387L12.4412 23.7574L14.7454 22.7877L19.876 20.6287L22.5553 19.5012L16.6774 15.9803Z"
        fill="#0078D4"
      />
      <path
        d="M28.6962 17.5768C28.5692 17.5684 28.4415 17.5625 28.3123 17.5625C27.5369 17.5617 26.7696 17.7201 26.0579 18.0278L26.0577 18.0272L22.5552 19.5012L23.5708 20.1095L26.9002 22.1038L28.3527 22.9738L33.3195 25.9489C33.7708 25.1111 34.0047 24.1734 33.9997 23.2218C33.9948 22.2702 33.7511 21.3351 33.2911 20.502C32.8311 19.669 32.1694 18.9647 31.3666 18.4536C30.5639 17.9426 29.6457 17.6411 28.6962 17.5769V17.5768Z"
        fill="#1490DF"
      />
      <path
        d="M28.3531 22.9739L26.9005 22.1038L23.5712 20.1096L22.5555 19.5012L19.8761 20.6287L14.7456 22.7878L12.4413 23.7574L7.25781 25.9387C7.90196 26.8648 8.76067 27.6213 9.76062 28.1435C10.7606 28.6657 11.8721 28.9381 13.0001 28.9376H28.3126C29.3393 28.9379 30.3469 28.6602 31.2285 28.134C32.1101 27.6078 32.8328 26.8527 33.3199 25.9489L28.3531 22.9739Z"
        fill="#28A8EA"
      />
    </g>
    <defs>
      <clipPath id="clip0_512_3830">
        <rect width="28" height="17.9375" fill="white" transform="translate(6 11)" />
      </clipPath>
    </defs>
  </Svg>
);

export const Outreach = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#F5F5F5" />
    <g clipPath="url(#clip0_360_4260)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8404 10.729C21.798 10.729 26.2669 11.6373 28.3478 13.7186C28.875 14.2461 29.5645 15.279 29.5645 16.7931C29.5645 19.4851 27.3967 23.6148 25.0039 26.0111C23.7669 27.2478 21.798 28.8673 19.1503 28.8673C16.5625 28.8673 14.5859 27.1077 14.0133 26.5348C11.8223 24.3414 10.2522 21.0117 10.2522 17.9082C10.2522 15.9506 10.8103 14.2365 12.2336 12.8132C13.5517 11.4923 15.8238 10.729 18.8404 10.729V10.729ZM22.2432 21.4833C23.2416 20.4832 23.511 19.2512 23.511 18.5749C23.511 18.0831 23.3816 17.3632 22.7675 16.7487C21.8251 15.8066 20.7832 15.5409 19.6486 15.5409C18.2108 15.5409 17.2452 15.995 16.6021 16.6385C16.0971 17.1429 15.6616 17.9198 15.6616 19.0213C15.6616 20.1228 16.2487 21.1876 16.8879 21.8282C17.4798 22.4186 18.4078 22.8573 19.3434 22.8573C20.2801 22.8573 21.2447 22.4824 22.2432 21.4833V21.4833Z"
        fill="#5951FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_360_4260">
        <rect width="19.3123" height="18.3586" fill="white" transform="translate(10.2522 10.729)" />
      </clipPath>
    </defs>
  </Svg>
);

export const Pipedrive = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#F5F5F5" />
    <path
      d="M21.7617 9C19.2358 9 17.7712 10.1607 17.0707 10.9346C16.9858 10.2467 16.5401 9.36542 14.7995 9.36542H11V13.3636H12.5495C12.8042 13.3636 12.8891 13.4495 12.8891 13.7075V32H17.3891V25.1645V24.6486C18.0896 25.2935 19.4268 26.1963 21.5282 26.1963C25.9221 26.1963 28.9999 22.671 28.9999 17.5981C29.0211 12.4607 26.0919 9 21.7617 9V9ZM20.849 22.2196C18.4292 22.2196 17.3254 19.8766 17.3254 17.6841C17.3254 14.2449 19.1721 13.0196 20.9127 13.0196C23.0353 13.0196 24.4787 14.8682 24.4787 17.6411C24.4575 20.8224 22.632 22.2196 20.849 22.2196"
      fill="#333333"
    />
  </Svg>
);

export const Sendgrid = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#E6F3FF" />
    <path d="M10.2522 16.7434H16.7812V23.2724H10.2522V16.7434Z" fill="white" />
    <path d="M10.2522 16.7434H16.7812V23.2724H10.2522V16.7434Z" fill="#99E1F4" />
    <path d="M16.7808 23.2722H23.2726V29.7641H16.7808V23.2722Z" fill="white" />
    <path d="M16.7808 23.2722H23.2726V29.7641H16.7808V23.2722Z" fill="#99E1F4" />
    <path
      d="M10.2522 29.7647H16.7812V29.8025H10.2522V29.7647ZM10.2522 23.2722H16.7812V29.7641H10.2522V23.2722Z"
      fill="#1A82E2"
    />
    <path
      d="M16.7808 10.2522H23.2726V16.744H16.7808V10.2522ZM23.2732 16.7825H29.8022V23.2743H23.2732V16.7825Z"
      fill="#00B3E3"
    />
    <path d="M23.2741 23.2724V16.7434H16.7822V23.2724H23.2741Z" fill="#009DD9" />
    <path d="M23.2742 10.2522H29.8031V16.744H23.2742V10.2522Z" fill="#1A82E2" />
    <path d="M23.2742 16.7434H29.8031V16.7812H23.2742V16.7434Z" fill="#1A82E2" />
  </Svg>
);

export const Excel = ({ ...props }) => (
  <Svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
    <circle cx="20" cy="20" r="20" fill="#DCF3D1" />
    <path
      d="M19.9999 9.5H11.9998C11.4513 9.5 10.9998 9.95153 10.9998 10.4999V14.75L19.9999 20L24.4999 21.8987L28.9999 20V14.75L19.9999 9.5Z"
      fill="#21A366"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9998 14.75H19.9999V20H10.9998V14.75Z"
      fill="#107C41"
    />
    <path d="M28.0001 9.5H20V14.75H29V10.4999C29 9.95153 28.5485 9.5 28.0001 9.5Z" fill="#33C481" />
    <path
      d="M19.9999 20H10.9998V29.5001C10.9998 30.0485 11.4513 30.5 11.9998 30.5H27.9999C28.5483 30.5 28.9999 30.0485 28.9999 29.5001V25.25L19.9999 20Z"
      fill="#185C37"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M20 20H29V25.25H20V20Z" fill="#107C41" />
    <path
      d="M17.5001 13.25H11V27.5H17.5001C18.0479 27.4985 18.4985 27.0479 18.5 26.5001V14.2499C18.4985 13.7021 18.0479 13.2515 17.5001 13.25Z"
      fill="black"
      fillOpacity="0.094118"
    />
    <path
      d="M16.7501 14H11V28.25H16.7501C17.2979 28.2485 17.7485 27.7979 17.75 27.2501V14.9999C17.7485 14.4521 17.2979 14.0015 16.7501 14Z"
      fill="black"
      fillOpacity="0.2"
    />
    <path
      d="M16.7501 14H11V26.75H16.7501C17.2979 26.7485 17.7485 26.2979 17.75 25.7501V14.9999C17.7485 14.4521 17.2979 14.0015 16.7501 14Z"
      fill="black"
      fillOpacity="0.2"
    />
    <path
      d="M16.0001 14H11V26.75H16.0001C16.5479 26.7485 16.9985 26.2979 17 25.7501V14.9999C16.9985 14.4521 16.5479 14.0015 16.0001 14Z"
      fill="black"
      fillOpacity="0.2"
    />
    <path
      d="M5.99993 14H16.0001C16.5485 14 17 14.4515 17 14.9999V25.0001C17 25.5485 16.5486 26 16.0001 26H5.99993C5.45153 26 5 25.5485 5 25.0001V14.9999C5 14.4515 5.45153 14 5.99993 14Z"
      fill="#107C41"
    />
    <path
      d="M7.65009 23.75L10.0769 19.9895L7.85408 16.25H9.64285L10.8563 18.6401C10.9678 18.8669 11.0444 19.0361 11.0863 19.1476H11.102C11.1821 18.9664 11.2659 18.7902 11.3532 18.6192L12.6502 16.25H14.2925L12.0121 19.9686L14.35 23.75H12.603L11.2013 21.1245C11.1353 21.0129 11.0794 20.8955 11.034 20.7741H11.0131C10.9721 20.8931 10.9178 21.0071 10.8509 21.1139L9.40743 23.75H7.65009Z"
      fill="white"
    />
  </Svg>
);

export const Url = ({ ...props }) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M9.93947 16.9409C9.93947 17.1808 10.0395 17.4206 10.2192 17.6011L11.459 18.7214C12.4387 19.7214 13.7386 20.2612 15.0988 20.2612C16.459 20.2612 17.759 19.7214 18.7386 18.7409C19.7183 17.7612 20.2589 16.4613 20.2589 15.1011C20.2589 13.741 19.7191 12.4409 18.7386 11.4613L17.5589 10.2816C17.3792 10.1019 17.1386 10.002 16.8988 10.002C16.6589 10.002 16.4191 10.102 16.2386 10.2816C16.0589 10.4613 15.9589 10.702 15.9589 10.9418C15.9589 11.1816 16.0589 11.4215 16.2386 11.602L17.4183 12.7816C18.0386 13.402 18.3784 14.2215 18.3784 15.1214C18.3784 16.0214 18.0386 16.8418 17.4183 17.4612C16.798 18.0816 15.9784 18.4214 15.0785 18.4214C14.1988 18.4214 13.3582 18.0816 12.7387 17.4612L11.559 16.2816C11.3793 16.1019 11.1387 16.0019 10.8988 16.0019C10.659 16.0019 10.4192 16.1019 10.2387 16.2816C10.0395 16.4605 9.93945 16.6808 9.93945 16.9409L9.93947 16.9409Z"
      fill="black"
    />
    <path
      d="M12.6601 8C12.8398 8.17969 13.0804 8.27968 13.3203 8.27968C13.5601 8.27968 13.7999 8.17968 13.9804 8C14.3406 7.63984 14.3406 7.06016 13.9804 6.7L12.8007 5.52032C11.8195 4.52032 10.5195 4 9.16014 4C7.79998 4 6.49994 4.52032 5.51954 5.5C4.53986 6.48046 4 7.7804 4 9.1406C4 10.5008 4.53984 11.8008 5.52032 12.7804L6.7 13.9601C7.07968 14.3398 7.66016 14.3398 8.02032 13.9601C8.20001 13.7804 8.3 13.5398 8.3 13.2999C8.3 13.0601 8.2 12.8202 8.02032 12.6398L6.84064 11.4601C6.22032 10.8398 5.88048 10.0202 5.88048 9.12028C5.88048 8.22032 6.22032 7.39996 6.84064 6.78048C7.46096 6.16016 8.28048 5.82032 9.18044 5.82032C10.0601 5.82032 10.9008 6.16016 11.5202 6.78048L12.6601 8Z"
      fill="black"
    />
    <path
      d="M9.17969 10.1207C9.17969 10.3605 9.27969 10.6004 9.45937 10.7809L13.439 14.7411C13.8186 15.1207 14.3991 15.1207 14.7593 14.7411C15.1194 14.3809 15.1194 13.8012 14.7593 13.4411L10.7797 9.48085C10.6 9.30116 10.3594 9.20117 10.1195 9.20117C9.87969 9.20117 9.63985 9.30117 9.45937 9.48085C9.29999 9.66054 9.19999 9.88085 9.17969 10.1207Z"
      fill="black"
    />
  </Svg>
);

export const Upload = ({ ...props }) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#clip0_237_3983)">
      <rect width="24" height="24" fill="transparent" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.1779 11.588C4.76026 7.55003 7.96301 4 12.0003 4C16.108 4 19.2403 7.55091 18.8228 11.588C21.1197 11.5184 23 13.2586 23 15.626C23 17.8534 21.1902 19.664 18.962 19.664H5.03798C2.81055 19.664 1 17.8542 1 15.626C1 13.2593 2.8794 11.5183 5.17723 11.588H5.1779Z"
        fill="#C2E8FF"
      />
      <path
        d="M12.0002 20.8797C12.2548 20.8797 12.4989 20.7786 12.679 20.5985C12.859 20.4185 12.9602 20.1743 12.9602 19.9197V13.1181L15.1418 15.2997C15.2979 15.4595 15.504 15.561 15.7259 15.5872C15.9478 15.6134 16.1719 15.5627 16.361 15.4437C16.4812 15.3658 16.5824 15.2621 16.6574 15.14C16.7323 15.0179 16.7789 14.8806 16.7939 14.7382C16.8088 14.5957 16.7917 14.4517 16.7438 14.3168C16.6959 14.1818 16.6184 14.0592 16.517 13.9581L13.9466 11.3877C13.668 11.1029 13.3317 10.8811 12.9602 10.7373C12.4723 10.5499 11.9406 10.508 11.4295 10.6166C10.9183 10.7253 10.4496 10.9798 10.0802 11.3493L7.48095 13.9605C7.38138 14.0599 7.30488 14.18 7.25686 14.3122C7.20884 14.4445 7.19048 14.5857 7.20307 14.7258C7.21567 14.8659 7.25891 15.0016 7.32974 15.1232C7.40057 15.2447 7.49725 15.3492 7.61295 15.4293C7.80819 15.5567 8.04195 15.6116 8.2735 15.5844C8.50506 15.5573 8.71974 15.4497 8.88015 15.2805L11.0402 13.1205V19.9197C11.0402 20.1743 11.1413 20.4185 11.3213 20.5985C11.5014 20.7786 11.7455 20.8797 12.0002 20.8797Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_237_3983">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);

export const Sparkle: React.FC<Record<string, any>> = ({ ...props }) => (
  <svg width="10" height="13" viewBox="0 0 10 13" fill="none" {...props}>
    <path
      d="M1.22578 6.56556C4.80198 7.09706 5.14436 7.52726 5.56785 12.0159C5.99123 7.5273 6.33372 7.09704 9.90991 6.56556C6.33449 6.03405 5.99133 5.60385 5.56785 1.11523C5.14446 5.60382 4.80198 6.03407 1.22578 6.56556Z"
      fill="#262626"
    />
    <path
      d="M0.0897753 2.65757C1.66085 2.89118 1.81129 3.0802 1.99729 5.05196C2.18328 3.08009 2.33374 2.89118 3.90405 2.65757C2.33374 2.42396 2.18254 2.23494 1.99729 0.263184C1.8113 2.23505 1.66085 2.42396 0.0897753 2.65757Z"
      fill="#262626"
    />
  </svg>
);

export const GoogleSearchConsole = ({ ...props }) => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" {...props}>
    <g clipPath="url(#clip0_348_6479)">
      <circle cx="30" cy="30" r="30" fill="#F5F5F5" />
      <path
        d="M44.704 30.3383C44.704 29.2515 44.6065 28.2065 44.4253 27.2032H29.99V33.139H38.2388C37.8765 35.0479 36.7897 36.6643 35.1594 37.7511V41.6107H40.1337C43.032 38.9355 44.704 35.0061 44.704 30.3383Z"
        fill="#4285F4"
      />
      <path
        d="M29.9901 45.3172C34.1284 45.3172 37.5979 43.9517 40.1338 41.6108L35.1595 37.7511C33.794 38.6708 32.0522 39.2281 29.9901 39.2281C26.005 39.2281 22.6191 36.5389 21.4069 32.9161H16.3071V36.8733C18.8291 41.8755 23.9985 45.3172 29.9901 45.3172Z"
        fill="#34A853"
      />
      <path
        d="M21.4068 32.9021C21.1002 31.9825 20.9191 31.0072 20.9191 29.99C20.9191 28.9728 21.1002 27.9975 21.4068 27.0778V23.1207H16.307C15.262 25.1829 14.6628 27.5098 14.6628 29.99C14.6628 32.4702 15.262 34.7971 16.307 36.8593L20.2781 33.766L21.4068 32.9021Z"
        fill="#FBBC05"
      />
      <path
        d="M29.9901 20.7659C32.2473 20.7659 34.2538 21.5462 35.8562 23.051L40.2453 18.6619C37.5839 16.1817 34.1284 14.6629 29.9901 14.6629C23.9985 14.6629 18.8291 18.1045 16.3071 23.1207L21.4069 27.0779C22.6191 23.4551 26.005 20.7659 29.9901 20.7659Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_348_6479">
        <rect width="60" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Gmail = ({ ...props }) => (
  <svg
    fill="none"
    height="60"
    viewBox="0 0 60 60"
    width="60"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="30" cy="30" fill="#f5f5f5" r="30" />
    <path
      d="m17.0455 41.2553h4.7727v-11.5909l-6.8182-5.1136v14.6591c0 1.1318.917 2.0454 2.0455 2.0454z"
      fill="#4285f4"
    />
    <path
      d="m38.1816 41.2553h4.7728c1.1318 0 2.0454-.917 2.0454-2.0454v-14.6591l-6.8182 5.1136"
      fill="#34a853"
    />
    <path
      d="m38.1816 20.8013v8.8636l6.8182-5.1136v-2.7273c0-2.5296-2.8875-3.9716-4.9091-2.4546"
      fill="#fbbc04"
    />
    <path
      d="m21.8184 29.6644v-8.8636l8.1818 6.1363 8.1818-6.1363v8.8636l-8.1818 6.1364"
      fill="#ea4335"
    />
    <path
      d="m15 21.824v2.7273l6.8182 5.1136v-8.8636l-1.9091-1.4319c-2.025-1.517-4.9091-.075-4.9091 2.4546z"
      fill="#c5221f"
    />
  </svg>
);

export const GoogleAds = ({ ...props }) => (
  <svg width="168" height="168" viewBox="0 0 168 168" fill="none" {...props}>
    <circle cx="83.885" cy="83.885" r="83.885" fill="#E6F3FF" />
    <path
      d="M68.6476 51.6995C69.5465 49.3399 70.7825 47.1676 72.6177 45.4072C79.9587 38.2535 92.0938 40.0513 97.0751 49.0402C100.821 55.8569 104.791 62.5236 108.648 69.2653C115.09 80.464 121.607 91.6628 127.975 102.899C133.33 112.3 127.525 124.173 116.888 125.783C110.371 126.757 104.266 123.761 100.895 117.918C95.2399 108.068 89.5469 98.2172 83.8914 88.4043C83.779 88.1795 83.6292 87.9923 83.4794 87.805C82.8801 87.3181 82.6179 86.6065 82.2434 85.9698C79.734 81.5502 77.1497 77.1681 74.6402 72.786C73.0297 69.9395 71.3443 67.1305 69.7338 64.284C68.2731 61.7371 67.5989 58.9655 67.6738 56.0441C67.7862 54.546 67.9735 53.0478 68.6476 51.6995Z"
      fill="#3C8BD9"
    />
    <path
      d="M68.6478 51.6992C68.3107 53.0476 68.011 54.3959 67.9361 55.8191C67.8238 58.9653 68.6103 61.8867 70.1834 64.6208C74.3033 71.6996 78.4232 78.8158 82.5057 85.9321C82.8802 86.5688 83.1799 87.2055 83.5544 87.8048C81.3072 91.7 79.0599 95.5577 76.7753 99.4529C73.6291 104.884 70.483 110.352 67.2994 115.783C67.1496 115.783 67.1122 115.708 67.0747 115.596C67.0372 115.296 67.1496 115.034 67.2245 114.734C68.7601 109.116 67.4867 104.135 63.6289 99.8649C61.2694 97.2806 58.273 95.8199 54.8273 95.333C50.3328 94.6963 46.3627 95.8573 42.8046 98.6664C42.1679 99.1533 41.7559 99.8649 41.0068 100.239C40.857 100.239 40.7821 100.165 40.7446 100.052C42.5424 96.9435 44.3027 93.8348 46.1005 90.7262C53.5164 77.842 60.9323 64.9579 68.3856 52.1112C68.4605 51.9614 68.5729 51.849 68.6478 51.6992Z"
      fill="#FABC04"
    />
    <path
      d="M40.8944 100.165C41.606 99.5281 42.2802 98.854 43.0292 98.2547C52.1305 91.0635 65.8012 96.2696 67.7863 107.656C68.2732 110.39 68.011 113.012 67.187 115.633C67.1495 115.858 67.1121 116.045 67.0372 116.27C66.7001 116.869 66.4005 117.506 66.0259 118.105C62.6925 123.611 57.7861 126.345 51.344 125.933C43.9656 125.409 38.1602 119.866 37.149 112.525C36.6621 108.967 37.3737 105.633 39.2089 102.562C39.5835 101.888 40.0329 101.288 40.4449 100.614C40.6322 100.464 40.5573 100.165 40.8944 100.165Z"
      fill="#34A852"
    />
  </svg>
);

export const Notion = ({ ...props }) => (
  <svg width="168" height="168" viewBox="0 0 168 168" fill="none" {...props}>
    <circle cx="83.885" cy="83.885" r="83.885" fill="#F5F5F5" />
    <path
      d="M42.017 38.3142L97.35 34.2272C104.147 33.6442 105.893 34.0372 110.167 37.1442L127.83 49.5872C130.743 51.7272 131.713 52.3102 131.713 54.6402V122.883C131.713 127.16 130.16 129.69 124.723 130.076L60.467 133.968C56.387 134.161 54.444 133.578 52.307 130.855L39.3 113.941C36.967 110.828 36 108.498 36 105.774V45.1142C36 41.6172 37.553 38.7012 42.017 38.3142Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M97.35 34.2282L42.017 38.3152C37.553 38.7012 36 41.6182 36 45.1142V105.774C36 108.497 36.967 110.827 39.3 113.941L52.307 130.854C54.444 133.577 56.387 134.161 60.467 133.967L124.724 130.077C130.157 129.69 131.714 127.16 131.714 122.884V54.6412C131.714 52.4312 130.841 51.7942 128.271 49.9082L110.167 37.1442C105.894 34.0372 104.147 33.6442 97.35 34.2272V34.2282ZM61.92 53.5242C56.673 53.8772 55.483 53.9572 52.503 51.5342L44.927 45.5082C44.157 44.7282 44.544 43.7552 46.484 43.5612L99.677 39.6742C104.144 39.2842 106.47 40.8412 108.217 42.2012L117.34 48.8112C117.73 49.0082 118.7 50.1712 117.533 50.1712L62.6 53.4782L61.92 53.5242ZM55.803 122.301V64.3682C55.803 61.8382 56.58 60.6712 58.906 60.4752L122 56.7812C124.14 56.5882 125.107 57.9482 125.107 60.4742V118.021C125.107 120.551 124.717 122.691 121.224 122.884L60.847 126.384C57.354 126.577 55.804 125.414 55.804 122.301H55.803ZM115.403 67.4742C115.79 69.2242 115.403 70.9742 113.653 71.1742L110.743 71.7512V114.524C108.216 115.884 105.89 116.661 103.946 116.661C100.839 116.661 100.063 115.688 97.736 112.774L78.706 82.8342V111.801L84.726 113.164C84.726 113.164 84.726 116.664 79.869 116.664L66.479 117.441C66.089 116.661 66.479 114.718 67.836 114.331L71.333 113.361V75.0612L66.48 74.6682C66.09 72.9182 67.06 70.3912 69.78 70.1952L84.147 69.2282L103.947 99.5552V72.7252L98.9 72.1452C98.51 70.0022 100.063 68.4452 102.003 68.2552L115.403 67.4742Z"
      fill="black"
    />
  </svg>
);

export const Greenhouse = ({ ...props }) => (
  <svg width="168" height="168" viewBox="0 0 168 168" fill="none" {...props}>
    <circle cx="83.885" cy="83.885" r="83.885" fill="#DDFBEE" />
    <path
      d="M101.173 64.6708C101.153 66.9149 100.685 69.1324 99.7954 71.1926C98.9057 73.2529 97.6127 75.1143 95.9927 76.6673C92.4107 80.2418 87.2155 81.1077 87.2155 84.179C87.2155 88.3011 93.8761 87.043 100.196 93.4002C103.433 96.5843 105.644 100.663 106.546 105.113C107.448 109.563 107 114.18 105.259 118.373C103.518 122.567 100.563 126.144 96.7746 128.646C92.9861 131.148 88.5362 132.461 83.9962 132.416C79.4577 132.46 75.0098 131.146 71.2229 128.644C67.4359 126.142 64.4827 122.566 62.742 118.375C61.0013 114.183 60.5524 109.567 61.4529 105.119C62.3534 100.67 64.5623 96.5922 67.7962 93.4076C74.1533 87.0504 80.7473 88.3085 80.7473 84.1864C80.7473 81.1447 75.5669 80.2492 71.9775 76.6747C69.545 74.345 67.8672 71.3394 67.1608 68.0461C66.4545 64.7529 66.7521 61.3235 68.0152 58.2012C69.2783 55.0789 71.4488 52.4072 74.2463 50.5314C77.0437 48.6556 80.3395 47.662 83.7076 47.6789C85.4985 47.6789 87.1119 47.9454 88.4514 47.9454C90.864 47.9454 92.1517 46.8723 92.1517 45.1701C92.1517 44.1858 91.7003 42.9499 91.7003 41.5956C91.7238 40.0882 92.3452 38.6519 93.4278 37.6026C93.9638 37.0831 94.5969 36.6742 95.291 36.3994C95.985 36.1245 96.7264 35.989 97.4728 36.0007C98.2192 36.0124 98.956 36.1709 99.6411 36.4673C100.326 36.7637 100.946 37.1922 101.466 37.7282C101.985 38.2642 102.394 38.8973 102.669 39.5914C102.944 40.2854 103.079 41.0268 103.068 41.7732C103.068 45.0813 100.47 46.5984 98.5015 47.3237C96.8955 47.8565 95.6374 48.5744 95.6374 50.1877C95.6374 53.2146 101.188 56.1749 101.188 64.6708H101.173ZM99.397 109.608C99.397 100.727 92.8622 93.5852 84.0036 93.5852C75.145 93.5852 68.6102 100.749 68.6102 109.608C68.6102 118.466 75.145 125.623 84.0036 125.623C92.8622 125.623 99.397 118.363 99.397 109.608ZM94.1129 64.4636C94.0721 62.4721 93.4443 60.5369 92.3081 58.9007C91.172 57.2645 89.5781 56.0001 87.7263 55.266C85.8745 54.532 83.8472 54.361 81.8986 54.7744C79.95 55.1879 78.1668 56.1674 76.7726 57.5901C75.3784 59.0129 74.4353 60.8156 74.0614 62.7721C73.6875 64.7287 73.8996 66.7521 74.6711 68.5887C75.4425 70.4252 76.7389 71.9931 78.3978 73.0959C80.0567 74.1986 82.0042 74.7871 83.9962 74.7875C86.6986 74.7505 89.2772 73.6484 91.1715 71.7208C93.0659 69.7932 94.1229 67.1958 94.1129 64.4932V64.4636Z"
      fill="#008561"
    />
  </svg>
);

export const Xero = ({ ...props }) => (
  <svg width="168" height="168" viewBox="0 0 168 168" fill="none" {...props}>
    <circle cx="83.885" cy="83.885" r="83.885" fill="#1AB4D7" />
    <path
      d="M84.0001 154C122.66 154 154 122.66 154 83.9999C154 45.3401 122.66 14 84.0001 14C45.3401 14 14 45.3401 14 83.9999C14 122.66 45.3401 154 84.0001 154Z"
      fill="#1AB4D7"
    />
    <path
      d="M47.508 83.7979L59.4541 71.8223C59.8501 71.4186 60.0711 70.8842 60.0711 70.3174C60.0711 69.1362 59.1109 68.1769 57.9297 68.1769C57.3543 68.1769 56.8149 68.4024 56.4081 68.8142C56.407 68.8166 44.4728 80.7438 44.4728 80.7438L32.4841 68.7963C32.079 68.397 31.5422 68.1769 30.973 68.1769C29.7932 68.1769 28.8328 69.1357 28.8328 70.3157C28.8328 70.8913 29.0626 71.4315 29.4751 71.8385L41.4195 83.7812L29.4812 95.7418C29.0616 96.155 28.8328 96.6963 28.8328 97.2745C28.8328 98.4555 29.7932 99.4136 30.973 99.4136C31.5431 99.4136 32.0804 99.1924 32.4841 98.7885L44.4542 86.8345L56.3789 98.7449C56.8018 99.1821 57.3474 99.415 57.9297 99.415C59.1097 99.415 60.0699 98.4555 60.0699 97.2745C60.0699 96.7047 59.8492 96.1693 59.4474 95.7656L47.508 83.7979Z"
      fill="white"
    />
    <path
      d="M118.526 83.7941C118.526 85.9389 120.27 87.6836 122.417 87.6836C124.559 87.6836 126.304 85.9389 126.304 83.7941C126.304 81.6489 124.559 79.9044 122.417 79.9044C120.27 79.9044 118.526 81.6489 118.526 83.7941Z"
      fill="white"
    />
    <path
      d="M111.148 83.7964C111.148 77.5854 116.201 72.5319 122.413 72.5319C128.621 72.5319 133.675 77.5854 133.675 83.7964C133.675 90.0059 128.621 95.0573 122.413 95.0573C116.201 95.0573 111.148 90.0059 111.148 83.7964ZM106.717 83.7964C106.717 92.4493 113.758 99.4893 122.413 99.4893C131.067 99.4893 138.111 92.4493 138.111 83.7964C138.111 75.1422 131.067 68.1004 122.413 68.1004C113.758 68.1004 106.717 75.1422 106.717 83.7964Z"
      fill="white"
    />
    <path
      d="M105.603 68.3685L104.945 68.3666C102.968 68.3666 101.061 68.99 99.4687 70.2172C99.2589 69.257 98.4006 68.5345 97.3783 68.5345C96.2016 68.5345 95.2587 69.4773 95.2559 70.6564C95.2559 70.6607 95.263 97.091 95.263 97.091C95.2661 98.268 96.2261 99.2246 97.4035 99.2246C98.5807 99.2246 99.5404 98.268 99.5435 97.0884C99.5435 97.0832 99.5445 80.8344 99.5445 80.8344C99.5445 75.417 100.04 73.2291 104.68 72.6492C105.109 72.5959 105.576 72.6042 105.578 72.6042C106.848 72.5606 107.75 71.688 107.75 70.5087C107.75 69.3287 106.787 68.3685 105.603 68.3685Z"
      fill="white"
    />
    <path
      d="M64.5051 81.2114C64.5051 81.1528 64.5096 81.0918 64.5125 81.0316C65.7552 76.1192 70.204 72.4841 75.5024 72.4841C80.8648 72.4841 85.3544 76.2085 86.5335 81.2114H64.5051ZM90.9167 80.8072C89.9943 76.4403 87.6035 72.8532 83.9629 70.5496C78.6412 67.171 71.6139 67.3579 66.4737 71.0133C62.2808 73.9961 59.8605 78.8756 59.8605 83.902C59.8605 85.1623 60.0124 86.4345 60.3287 87.6867C61.9119 93.9148 67.266 98.6294 73.6494 99.4108C75.5436 99.6401 77.3874 99.5303 79.2966 99.0359C80.9372 98.6368 82.5247 97.9714 83.9874 97.034C85.5056 96.0581 86.774 94.7711 88.0024 93.2305C88.0272 93.2022 88.0522 93.1772 88.077 93.1474C88.9295 92.09 88.7714 90.5864 87.8345 89.8686C87.0443 89.263 85.7178 89.0174 84.674 90.3542C84.4497 90.6738 84.1994 91.0027 83.9239 91.3315C83.0939 92.2487 82.0641 93.1372 80.8303 93.8264C79.2602 94.6652 77.4709 95.1446 75.5688 95.1553C69.3431 95.086 66.0116 90.7402 64.8266 87.6383C64.6197 87.0591 64.4601 86.4583 64.3489 85.8396C64.3344 85.7238 64.3236 85.6121 64.3194 85.5092C65.6066 85.5092 86.6607 85.5057 86.6607 85.5057C89.7235 85.4414 91.372 83.2795 90.9167 80.8072Z"
      fill="white"
    />
  </svg>
);

export const CustomAPI = ({ ...props }) => (
  <svg width="168" height="168" viewBox="0 0 168 168" fill="none" {...props}>
    <circle cx="83.885" cy="83.885" r="83.885" fill="#F5F5F5" />
    <path
      d="M63.362 94.9276H47.97L45.11 102H34.606L50.674 65.5996H60.814L76.934 102H66.222L63.362 94.9276ZM60.346 87.3356L55.666 75.6876L50.986 87.3356H60.346Z"
      fill="#262626"
    />
    <path
      d="M96.4929 65.5996C99.7862 65.5996 102.646 66.1543 105.073 67.2636C107.5 68.3383 109.372 69.8983 110.689 71.9436C112.006 73.9543 112.665 76.3289 112.665 79.0676C112.665 81.8063 112.006 84.1809 110.689 86.1916C109.372 88.2023 107.5 89.7623 105.073 90.8716C102.646 91.9463 99.7862 92.4836 96.4929 92.4836H90.1489V102H79.8529V65.5996H96.4929ZM95.8689 84.3716C97.9835 84.3716 99.5782 83.9209 100.653 83.0196C101.728 82.0836 102.265 80.7663 102.265 79.0676C102.265 77.3689 101.728 76.0516 100.653 75.1156C99.5782 74.1796 97.9835 73.7116 95.8689 73.7116H90.1489V84.3716H95.8689Z"
      fill="#262626"
    />
    <path d="M117.685 65.5996H127.981V102H117.685V65.5996Z" fill="#262626" />
  </svg>
);

export const WebScraper = ({ ...props }) => (
  <svg width="168" height="168" viewBox="0 0 168 168" fill="none" {...props}>
    <circle cx="83.885" cy="83.885" r="83.885" fill="#F5F5F5" />
    <path
      d="M83.725 136.45C54.653 136.45 31 112.797 31 83.725C31 54.653 54.653 31 83.725 31C112.797 31 136.45 54.653 136.45 83.725C136.45 112.797 112.797 136.45 83.725 136.45ZM83.725 37.075C57.9996 37.075 37.075 58.0008 37.075 83.725C37.075 109.449 58.0008 130.375 83.725 130.375C109.449 130.375 130.375 109.449 130.375 83.725C130.375 58.0008 109.449 37.075 83.725 37.075Z"
      fill="black"
    />
    <path
      d="M83.725 61.916C68.7311 61.916 54.6175 60.2944 42.9148 57.2244C41.2932 56.7995 40.3219 55.1389 40.7468 53.5173C41.1717 51.8957 42.8324 50.9287 44.454 51.3493C55.5063 54.2501 69.4512 55.8457 83.7247 55.8457C97.9982 55.8457 111.943 54.2501 122.991 51.3493C124.613 50.9287 126.273 51.8956 126.698 53.5173C127.123 55.1389 126.152 56.7995 124.53 57.2244C112.832 60.2942 98.7189 61.916 83.725 61.916Z"
      fill="black"
    />
    <path
      d="M123.763 116.202C123.507 116.202 123.247 116.167 122.987 116.102C111.913 113.188 97.9594 111.575 83.6981 111.567H83.5637C69.3502 111.567 55.4541 113.154 44.4107 116.041C42.7891 116.466 41.1284 115.495 40.7035 113.869C40.2786 112.248 41.2498 110.587 42.8714 110.162C54.5653 107.105 68.6312 105.492 83.5552 105.492H83.7026C98.6831 105.501 112.806 107.14 124.534 110.231C126.156 110.656 127.122 112.317 126.698 113.939C126.338 115.3 125.111 116.202 123.763 116.202Z"
      fill="black"
    />
    <path
      d="M133.415 86.7598H34.0359C32.3579 86.7598 31.0007 85.3983 31.0007 83.7246C31.0007 82.0466 32.3622 80.6895 34.0359 80.6895H133.411C135.089 80.6895 136.45 82.0466 136.45 83.7246C136.45 85.4026 135.089 86.7598 133.415 86.7598Z"
      fill="black"
    />
    <path
      d="M88.7023 136.207C88.2557 136.207 87.8047 136.107 87.3755 135.899C85.8666 135.167 85.2379 133.35 85.9707 131.841C91.3689 120.745 97.8033 103.384 97.8033 83.7247C97.8033 64.0655 91.3687 46.704 85.9751 35.6084C85.2423 34.0995 85.8711 32.2827 87.3799 31.55C88.8888 30.8173 90.7056 31.446 91.4383 32.9548C97.1097 44.6232 103.878 62.9071 103.878 83.724C103.878 104.541 97.114 122.826 91.4383 134.498C90.9093 135.577 89.8297 136.206 88.7024 136.206L88.7023 136.207Z"
      fill="black"
    />
    <path
      d="M78.7478 136.207C77.6205 136.207 76.5408 135.578 76.0162 134.498C70.3404 122.826 63.572 104.542 63.572 83.7247C63.572 62.9077 70.3361 44.6227 76.0117 32.9511C76.7445 31.4421 78.5613 30.8177 80.0701 31.5462C81.579 32.279 82.2078 34.0958 81.4749 35.6046C76.081 46.7046 69.6468 64.0661 69.6468 83.7253C69.6468 103.385 76.0813 120.746 81.4749 131.846C82.2077 133.355 81.579 135.172 80.0701 135.904C79.6452 136.108 79.1943 136.208 78.7477 136.208L78.7478 136.207Z"
      fill="black"
    />
  </svg>
);

export const YouTube = ({ ...props }) => (
  <Svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" fill="#F5F5F5" />
    <path
      d="M30.5728 14.7243C30.3176 13.7765 29.5703 13.0292 28.6224 12.774C26.8908 12.3 19.9642 12.3 19.9642 12.3C19.9642 12.3 13.0377 12.3 11.3061 12.7557C10.3764 13.0109 9.61088 13.7765 9.35569 14.7243C8.89999 16.456 8.89999 20.0468 8.89999 20.0468C8.89999 20.0468 8.89999 23.6559 9.35569 25.3693C9.61088 26.3172 10.3582 27.0645 11.3061 27.3197C13.0559 27.7936 19.9642 27.7936 19.9642 27.7936C19.9642 27.7936 26.8908 27.7936 28.6224 27.3379C29.5703 27.0827 30.3176 26.3354 30.5728 25.3876C31.0285 23.6559 31.0285 20.0651 31.0285 20.0651C31.0285 20.0651 31.0467 16.456 30.5728 14.7243Z"
      fill="#FF0000"
    />
    <path d="M17.7587 16.7295V23.3644L23.5186 20.0469L17.7587 16.7295Z" fill="white" />
  </Svg>
);

export const Harvest = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_493_253)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_493_253)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6361 22.3978V31H17.2544V18.0602C17.2544 17.2583 17.8921 16.6387 18.6361 16.6387H22.7456V20.9398C22.7456 21.7417 22.1433 22.3978 21.3994 22.3978H18.6361ZM31 8V29.542C31 30.3439 30.3623 31 29.6184 31H28.2721V9.42155C28.2721 8.61965 28.8744 8 29.6184 8H31ZM25.5089 8H26.8551V29.542C26.8551 30.3439 26.2174 31 25.5089 31H24.1272V15.1807C24.1272 14.3788 24.7649 13.7591 25.5089 13.7591V8ZM14.4911 31H13.1449V9.42155C13.1449 8.61965 13.7472 8 14.4911 8H15.8728V23.7829C15.8728 24.5848 15.2351 25.2409 14.4911 25.2409V31ZM9 31V9.42155C9 8.61965 9.63768 8 10.3816 8H11.7279V29.542C11.7279 30.3439 11.1256 31 10.3816 31H9Z"
          fill="#FA5D00"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_493_253">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_493_253">
        <rect width="22" height="23" fill="white" transform="translate(9 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const Asana = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_493_247)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M26.6308 19.605C25.2627 19.605 23.9506 20.1485 22.9832 21.1159C22.0158 22.0833 21.4723 23.3954 21.4723 24.7635C21.4723 26.1316 22.0158 27.4437 22.9832 28.4111C23.9506 29.3785 25.2627 29.922 26.6308 29.922C27.9989 29.922 29.311 29.3785 30.2784 28.4111C31.2458 27.4437 31.7893 26.1316 31.7893 24.7635C31.7893 23.3954 31.2458 22.0833 30.2784 21.1159C29.311 20.1485 27.9989 19.605 26.6308 19.605ZM13.2298 19.606C12.5465 19.5965 11.8681 19.7229 11.234 19.9778C10.5999 20.2327 10.0228 20.6111 9.53622 21.0909C9.04963 21.5708 8.66325 22.1426 8.39953 22.773C8.13581 23.4035 8 24.0801 8 24.7635C8 25.4469 8.13581 26.1235 8.39953 26.754C8.66325 27.3844 9.04963 27.9562 9.53622 28.4361C10.0228 28.9159 10.5999 29.2943 11.234 29.5492C11.8681 29.8041 12.5465 29.9305 13.2298 29.921C14.5852 29.9021 15.8787 29.3504 16.8306 28.3853C17.7824 27.4201 18.316 26.119 18.316 24.7635C18.316 23.408 17.7824 22.1069 16.8306 21.1417C15.8787 20.1766 14.5852 19.6249 13.2298 19.606ZM25.0878 13.158C25.0878 14.526 24.5444 15.8379 23.5771 16.8053C22.6098 17.7726 21.2978 18.316 19.9298 18.316C18.5618 18.316 17.2499 17.7726 16.2826 16.8053C15.3152 15.8379 14.7718 14.526 14.7718 13.158C14.7718 11.79 15.3152 10.4781 16.2826 9.51074C17.2499 8.54343 18.5618 8 19.9298 8C21.2978 8 22.6098 8.54343 23.5771 9.51074C24.5444 10.4781 25.0878 11.79 25.0878 13.158Z"
        fill="#F06A6A"
      />
    </g>
    <defs>
      <clipPath id="clip0_493_247">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Razorpay = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_493_250)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path d="M22.19 18.03L18.94 30.47H11L12.61 24.35L22.19 18.03Z" fill="#072654" />
      <path
        d="M29.4 9L23.76 30.47H19.89L23.7 15.93L17.86 19.78L18.9 15.95L29.4 9Z"
        fill="#3395FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_493_250">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ClickUp = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_493_244)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.49847 26.9942L13.2898 24.0663C15.3169 26.6939 17.4565 27.9327 19.8214 27.9327C22.1863 27.9327 24.2884 26.7315 26.2029 24.1038L30.0693 26.9567C27.2915 30.7105 23.838 32.7 19.8214 32.7C15.8424 32.7 12.3514 30.748 9.49847 26.9942Z"
        fill="url(#paint0_linear_493_244)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8214 14.3439L13.0646 20.1623L9.94893 16.5211L19.859 8L29.6939 16.5211L26.5407 20.1248L19.8214 14.3439Z"
        fill="url(#paint1_linear_493_244)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_493_244"
        x1="9.49656"
        y1="28.3948"
        x2="30.0841"
        y2="28.3948"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8930FD" />
        <stop offset="1" stopColor="#49CCF9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_493_244"
        x1="9.94525"
        y1="14.0865"
        x2="29.6712"
        y2="14.0865"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF02F0" />
        <stop offset="1" stopColor="#FFC800" />
      </linearGradient>
      <clipPath id="clip0_493_244">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Typeform = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_493_227)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15.7535C8 13.2793 9.02615 12 10.7462 12C12.4737 12 13.4998 13.2793 13.4998 15.7535V23.2465C13.4998 25.7207 12.4663 27 10.7462 27C9.02615 27 8 25.7207 8 23.2465V15.7535ZM26.5149 12H20.8305C15.7367 12 15.338 14.0947 15.338 16.8922L15.3307 22.1078C15.3307 25.0178 15.7145 27 20.8527 27H26.5149C31.6235 27 32 24.9124 32 22.1218V16.8993C32 14.0947 31.6087 12 26.5149 12Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_493_227">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Freshdesk = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_493_241)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_493_241)">
        <path
          d="M19.9625 7.99984H28.976C29.3743 7.99663 29.7692 8.07278 30.1378 8.22383C30.5064 8.37487 30.8411 8.5978 31.1226 8.8796C31.4041 9.16141 31.6267 9.49644 31.7773 9.86517C31.9279 10.2339 32.0036 10.6289 32 11.0272V20.0373C32 26.6456 26.6457 31.9998 20.0375 31.9998H19.9692C18.3979 32.0012 16.8417 31.6929 15.3895 31.0925C13.9374 30.4921 12.6178 29.6114 11.5062 28.5008C10.3946 27.3901 9.51282 26.0713 8.9112 24.6197C8.30958 23.168 7.99995 21.6121 8 20.0407C8 13.4137 13.3452 8.06809 19.9625 7.99984Z"
          fill="#25C16F"
        />
        <path
          d="M19.9625 13.3456C16.9276 13.3456 14.4672 15.8056 14.4672 18.8409V22.5774C14.489 23.5775 15.2945 24.383 16.2946 24.4048H17.849V20.1125H15.749V18.9125C15.8765 16.6528 17.7466 14.885 20.0105 14.885C22.2744 14.885 24.14 16.6494 24.2675 18.9125V20.1125H22.1375V24.4078H23.5419V24.476C23.5269 25.4038 22.7787 26.1523 21.8544 26.1635H20.177C20.0405 26.1635 19.8905 26.2318 19.8905 26.3679C19.8938 26.4428 19.925 26.5138 19.9781 26.5668C20.0311 26.6198 20.1021 26.6511 20.177 26.6544H21.8645C23.0664 26.6469 24.0387 25.6745 24.0462 24.4726V24.3361C24.4477 24.2457 24.806 24.0204 25.0616 23.6979C25.3171 23.3754 25.4544 22.975 25.4506 22.5635V18.9125C25.5189 15.8173 23.0641 13.349 19.9554 13.349L19.9625 13.3456Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_493_241">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_493_241">
        <rect width="24" height="24" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const Paymo = ({ ...props }) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 109.8 25.5"
    width="2500"
    height="581"
    {...props}
  >
    <path
      fill="#383838"
      d="M99.7 0c-5.6 0-10.1 4.5-10.1 10.1s4.5 10.1 10.1 10.1 10.1-4.5 10.1-10.1S105.3 0 99.7 0zm0 14.9c-2.7 0-4.8-2.2-4.8-4.8s2.2-4.8 4.8-4.8 4.8 2.2 4.8 4.8-2.1 4.8-4.8 4.8zM41.9 10.1v-.3c-.1-3.7-2.2-6.9-5.3-8.6C35.2.4 33.5 0 31.8 0c-5.6 0-10.1 4.5-10.1 10.1s4.5 10.1 10.1 10.1c1.7 0 3.4-.4 4.8-1.2 0 .7.6 1.2 1.3 1.2h2.8c.7 0 1.3-.6 1.3-1.3v-8.8zm-10.1 4.8c-2.7 0-4.8-2.2-4.8-4.8s2.2-4.8 4.8-4.8c2.7 0 4.8 2.2 4.8 4.8s-2.1 4.8-4.8 4.8zM88.2 18.6V8.8C88.2 4 84.5 0 80 0c-2.1 0-4.1.9-5.5 2.3C73 .9 71 0 68.9 0c-4.5 0-8.2 4-8.2 8.9V19.1c.1.6.6 1.1 1.2 1.1h2.8c.7 0 1.2-.5 1.2-1.1V8.4c0-1.7 1.3-3.1 2.9-3.1 1.6 0 2.9 1.4 2.9 3.1v10.7c.1.6.6 1.1 1.2 1.1h2.8c.7 0 1.2-.5 1.2-1.1V8.4c0-1.7 1.3-3.1 2.9-3.1 1.6 0 2.9 1.4 2.9 3.1v10.7c.1.6.6 1.1 1.2 1.1h2.8c.7 0 1.2-.5 1.2-1.1v-.5z"
    />
    <path
      fill="#4bad28"
      d="M5.3 10c0 .5-.6.9-1.1.5L.3 7.6C.1 7.4 0 7.2 0 7V2.3c0-.4.3-.4.5-.3l1.9 1.4c.3.2.7.2 1-.2C4.5 1.7 6.6.3 8.8 0h.1c.3 0 .7.2.8.7v3.8c0 .6-.3.8-.7.9C6.9 6 5.3 7.8 5.3 10z"
    />
    <path
      fill="#383838"
      d="M11.4.1c-.5 0-.8.3-.8.7v3.9c0 .4.3.6.6.7 2.2.5 3.8 2.4 3.8 4.7 0 2.7-2.2 4.8-4.8 4.8-1.2 0-2.3-.5-3.2-1.1l-6.5-5c-.3-.1-.5 0-.5.2v15.3c0 .7.6 1.3 1.3 1.3H4c.7 0 1.3-.6 1.3-1.3V19c1.4.8 3.1 1.2 4.8 1.2 5.6 0 10.1-4.5 10.1-10.1 0-5.1-3.8-9.4-8.8-10zM60.2 0h-3.3c-.7 0-1.4.5-1.6 1.2l-.2.4-2.3 5.1-1.7 3.8-4.1-9-.1-.4c-.3-.6-1-1.1-1.7-1.1h-3.3c-.7 0-1.1.5-.9 1.2l.1.4v.1c0 .1.1.1.1.1L48.1 17l-3 6.7-.1.1v.1l-.1.4c-.2.7.2 1.2.9 1.2h3.3c.7 0 1.4-.5 1.6-1.2l.2-.4 2.3-5.2 7.7-16.9c0-.1.1-.1.1-.1v-.1l.1-.4c.2-.7-.2-1.2-.9-1.2z"
    />
  </svg>
);

export const GoogleCalender = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_493_256)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_493_256)">
        <path
          d="M25.7895 14.2105L20.5791 13.6315L14.2106 14.2105L13.6316 20L14.2105 25.7895L20 26.5132L25.7895 25.7895L26.3685 19.8553L25.7895 14.2105Z"
          fill="white"
        />
        <path
          d="M16.5857 23.1929C16.153 22.9005 15.8533 22.4736 15.6898 21.9091L16.6943 21.4951C16.7855 21.8425 16.9446 22.1117 17.1719 22.3027C17.3977 22.4938 17.6727 22.5879 17.994 22.5879C18.3226 22.5879 18.6049 22.488 18.8407 22.2882C19.0765 22.0885 19.1953 21.8337 19.1953 21.5255C19.1953 21.21 19.0708 20.9523 18.8219 20.7526C18.573 20.553 18.2603 20.453 17.8869 20.453H17.3065V19.4587H17.8275C18.1488 19.4587 18.4195 19.3719 18.6395 19.1982C18.8595 19.0245 18.9695 18.7871 18.9695 18.4846C18.9695 18.2155 18.8711 18.0012 18.6743 17.8406C18.4775 17.68 18.2284 17.5989 17.9259 17.5989C17.6307 17.5989 17.3962 17.6771 17.2225 17.8349C17.0488 17.9926 16.9229 18.1865 16.8433 18.4152L15.849 18.0013C15.9807 17.6279 16.2225 17.2979 16.577 17.0127C16.9317 16.7276 17.3846 16.5843 17.9346 16.5843C18.3413 16.5843 18.7075 16.6625 19.0318 16.8202C19.3559 16.978 19.6107 17.1965 19.7945 17.4744C19.9783 17.7537 20.0695 18.0664 20.0695 18.4137C20.0695 18.7683 19.9842 19.0679 19.8133 19.3139C19.6425 19.56 19.4326 19.7481 19.1837 19.8799V19.9392C19.5123 20.0767 19.78 20.2866 19.9913 20.5688C20.2012 20.8511 20.3068 21.1883 20.3068 21.582C20.3068 21.9757 20.2069 22.3274 20.0071 22.6357C19.8074 22.944 19.531 23.1871 19.1807 23.3637C18.829 23.5402 18.4339 23.63 17.9954 23.63C17.4874 23.6314 17.0184 23.4852 16.5857 23.1929Z"
          fill="#1A73E8"
        />
        <path
          d="M22.75 18.2082L21.6529 19.0057L21.1014 18.1692L23.08 16.742H23.8385V23.4737H22.75V18.2082Z"
          fill="#1A73E8"
        />
        <path
          d="M25.7895 31L31 25.7895L28.3948 24.6317L25.7895 25.7895L24.6317 28.3948L25.7895 31Z"
          fill="#EA4335"
        />
        <path
          d="M13.0526 28.3948L14.2105 31H25.7894V25.7895H14.2105L13.0526 28.3948Z"
          fill="#34A853"
        />
        <path
          d="M10.7368 9C9.77726 9 9 9.77726 9 10.7368V25.7894L11.6052 26.9473L14.2105 25.7894V14.2105H25.7894L26.9473 11.6052L25.7895 9H10.7368Z"
          fill="#4285F4"
        />
        <path
          d="M9 25.7895V29.2632C9 30.2228 9.77726 31 10.7368 31H14.2105V25.7895H9Z"
          fill="#188038"
        />
        <path
          d="M25.7895 14.2105V25.7894H31V14.2105L28.3948 13.0526L25.7895 14.2105Z"
          fill="#FBBC04"
        />
        <path
          d="M31 14.2105V10.7368C31 9.77715 30.2227 9 29.2632 9H25.7895V14.2105H31Z"
          fill="#1967D2"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_493_256">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_493_256">
        <rect width="22" height="22" fill="white" transform="translate(9 9)" />
      </clipPath>
    </defs>
  </svg>
);

export const Trello = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_493_262)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M28.6071 9H11.6429C10.1786 9 9 10.1786 9 11.6429V28.6429C9 30.1071 10.1786 31.2857 11.6429 31.2857H28.6071C30.0714 31.2857 31.25 30.1071 31.25 28.6429V11.6429C31.25 10.1786 30.0714 9 28.6071 9ZM18.5714 25.0357C18.5714 25.5357 18.1786 25.9286 17.6786 25.9286H13.9643C13.4643 25.9286 13.0714 25.5357 13.0714 25.0357V14C13.0714 13.5 13.4643 13.1071 13.9643 13.1071H17.6786C18.1786 13.1071 18.5714 13.5 18.5714 14V25.0357ZM27.1429 19.9643C27.1429 20.4643 26.75 20.8571 26.2857 20.8571H22.5357C22.0357 20.8571 21.6429 20.4643 21.6429 19.9643V14C21.6429 13.5 22.0357 13.1071 22.5357 13.1071H26.25C26.75 13.1071 27.1429 13.5 27.1429 14V19.9643Z"
        fill="url(#paint0_linear_493_262)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_493_262"
        x1="3479.44"
        y1="2349"
        x2="3479.44"
        y2="9.37429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0052CC" />
        <stop offset="1" stopColor="#2684FF" />
      </linearGradient>
      <clipPath id="clip0_493_262">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Calendly = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_493_259)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M25.137 24.3917C24.2256 25.2006 23.0875 26.207 21.0237 26.207H19.7896C18.2962 26.207 16.9379 25.6642 15.9656 24.6802C15.0159 23.7188 14.4931 22.403 14.4931 20.9747V19.2861C14.4931 17.8578 15.0159 16.542 15.9656 15.5806C16.9379 14.5966 18.2962 14.0546 19.7896 14.0546H21.0237C23.09 14.0546 24.2256 15.0602 25.137 15.8691C26.0834 16.7029 26.8998 17.4317 29.0769 17.4317C29.409 17.4316 29.7405 17.4051 30.0684 17.3525L30.0609 17.3333C29.9304 17.0094 29.7775 16.6951 29.6031 16.3927L28.148 13.872C27.4919 12.7357 26.5482 11.7921 25.4118 11.1361C24.2753 10.48 22.9863 10.1347 21.6741 10.1347H18.7632C17.451 10.1347 16.1619 10.48 15.0255 11.1361C13.8891 11.7921 12.9454 12.7357 12.2892 13.872L10.8342 16.3927C10.1782 17.5292 9.83293 18.8182 9.83293 20.1304C9.83293 21.4426 10.1782 22.7316 10.8342 23.8681L12.2892 26.3888C12.9454 27.5251 13.8891 28.4687 15.0255 29.1247C16.1619 29.7808 17.451 30.1261 18.7632 30.1261H21.6741C22.9863 30.1261 24.2753 29.7808 25.4118 29.1247C26.5482 28.4687 27.4919 27.5251 28.148 26.3888L29.6031 23.8723C29.7775 23.5698 29.9304 23.2555 30.0609 22.9317L30.0684 22.9133C29.7407 22.8589 29.4091 22.831 29.0769 22.83C26.8998 22.83 26.0834 23.5546 25.137 24.3926"
        fill="#006BFF"
      />
      <path
        d="M21.0237 15.5847H19.7896C17.5166 15.5847 16.0232 17.2082 16.0232 19.2861V20.9747C16.0232 23.0526 17.5166 24.6761 19.7896 24.6761H21.0237C24.3357 24.6761 24.0756 21.299 29.0769 21.299C29.5508 21.2985 30.0237 21.342 30.4894 21.4291C30.6412 20.5699 30.6412 19.6908 30.4894 18.8317C30.0236 18.9183 29.5508 18.9619 29.0769 18.9618C24.0739 18.9618 24.3357 15.5847 21.0237 15.5847Z"
        fill="#006BFF"
      />
      <path
        d="M33.3629 22.6632C32.5112 22.0394 31.529 21.6171 30.4903 21.4283C30.4903 21.4374 30.4903 21.4449 30.4903 21.4533C30.4009 21.9512 30.2612 22.4387 30.0734 22.9083C30.9314 23.0412 31.7454 23.3765 32.4481 23.8864C32.4481 23.8931 32.444 23.9014 32.4415 23.9089C31.537 26.8375 29.6121 29.3446 27.0164 30.9747C24.4208 32.6047 21.3265 33.2497 18.2957 32.7923C15.2649 32.335 12.4987 30.8057 10.4996 28.4823C8.50051 26.1589 7.40109 23.1955 7.40109 20.1304C7.40109 17.0653 8.50051 14.1019 10.4996 11.7785C12.4987 9.45508 15.2649 7.9258 18.2957 7.46847C21.3265 7.01113 24.4208 7.65607 27.0164 9.28614C29.6121 10.9162 31.537 13.4232 32.4415 16.3519C32.4415 16.3594 32.4456 16.3677 32.4481 16.3744C31.7455 16.8844 30.9314 17.2194 30.0734 17.3516C30.261 17.8219 30.4006 18.31 30.4903 18.8083C30.4898 18.8161 30.4898 18.8239 30.4903 18.8317C31.5289 18.6431 32.5111 18.2212 33.3629 17.5976C34.1817 16.9914 34.0233 16.3068 33.899 15.9016C32.8866 12.618 30.7299 9.8066 27.8206 7.9782C24.9114 6.14981 21.4427 5.42578 18.045 5.93769C14.6472 6.44959 11.5459 8.16345 9.30447 10.7678C7.06307 13.3722 5.83037 16.6943 5.83037 20.1304C5.83037 23.5665 7.06307 26.8886 9.30447 29.493C11.5459 32.0973 14.6472 33.8112 18.045 34.3231C21.4427 34.835 24.9114 34.111 27.8206 32.2826C30.7299 30.4542 32.8866 27.6428 33.899 24.3592C34.0233 23.954 34.1817 23.2694 33.3629 22.6632Z"
        fill="#006BFF"
      />
      <path
        d="M30.0684 17.3516C29.7407 17.4061 29.4091 17.434 29.0769 17.435C26.8998 17.435 26.0834 16.7104 25.1379 15.8724C24.2257 15.0636 23.09 14.0571 21.0237 14.0571H19.7896C18.2954 14.0571 16.9379 14.6 15.9656 15.5839C15.0159 16.5453 14.4931 17.8611 14.4931 19.2895V20.978C14.4931 22.4064 15.0159 23.7222 15.9656 24.6836C16.9379 25.6675 18.2954 26.2095 19.7896 26.2095H21.0237C23.09 26.2095 24.2257 25.2039 25.1379 24.3951C26.0834 23.5612 26.8998 22.8325 29.0769 22.8325C29.409 22.8325 29.7405 22.859 30.0684 22.9117C30.2566 22.4421 30.3963 21.9546 30.4853 21.4566C30.4858 21.4483 30.4858 21.4399 30.4853 21.4316C30.0194 21.3452 29.5466 21.302 29.0728 21.3024C24.0697 21.3024 24.3315 24.6802 21.0195 24.6802H19.7855C17.5124 24.6802 16.019 23.0559 16.019 20.978V19.2861C16.019 17.2082 17.5124 15.5847 19.7855 15.5847H21.0195C24.3315 15.5847 24.0714 18.9609 29.0728 18.9609C29.5466 18.9617 30.0195 18.9185 30.4853 18.8317C30.4853 18.8242 30.4853 18.8167 30.4853 18.8083C30.3956 18.31 30.256 17.8219 30.0684 17.3516Z"
        fill="#0AE8F0"
      />
      <path
        d="M30.0684 17.3516C29.7407 17.4061 29.4091 17.434 29.0769 17.435C26.8998 17.435 26.0834 16.7104 25.1379 15.8724C24.2257 15.0636 23.09 14.0571 21.0237 14.0571H19.7896C18.2954 14.0571 16.9379 14.6 15.9656 15.5839C15.0159 16.5453 14.4931 17.8611 14.4931 19.2895V20.978C14.4931 22.4064 15.0159 23.7222 15.9656 24.6836C16.9379 25.6675 18.2954 26.2095 19.7896 26.2095H21.0237C23.09 26.2095 24.2257 25.2039 25.1379 24.3951C26.0834 23.5612 26.8998 22.8325 29.0769 22.8325C29.409 22.8325 29.7405 22.859 30.0684 22.9117C30.2566 22.4421 30.3963 21.9546 30.4853 21.4566C30.4858 21.4483 30.4858 21.4399 30.4853 21.4316C30.0194 21.3452 29.5466 21.302 29.0728 21.3024C24.0697 21.3024 24.3315 24.6802 21.0195 24.6802H19.7855C17.5124 24.6802 16.019 23.0559 16.019 20.978V19.2861C16.019 17.2082 17.5124 15.5847 19.7855 15.5847H21.0195C24.3315 15.5847 24.0714 18.9609 29.0728 18.9609C29.5466 18.9617 30.0195 18.9185 30.4853 18.8317C30.4853 18.8242 30.4853 18.8167 30.4853 18.8083C30.3956 18.31 30.256 17.8219 30.0684 17.3516Z"
        fill="#0AE8F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_493_259">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Smartsheet = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_913_58)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M15.0711 17.6138C15.0711 17.6138 15.9899 16.3505 17.1767 16.3122C19.0526 16.2739 20.5457 19.6046 20.7754 20.1023C22.8427 15.5082 26.25 11.6033 29.0064 9H12.0467C12.0467 10.6079 12.0467 26.6871 12.0467 28.027C12.0467 29.0607 11.8936 29.8263 11.817 30.1326C12.5827 30.0177 15.4157 29.5201 18.3252 28.4864C23.4935 26.6488 25.4843 24.658 25.5226 24.658L25.6374 24.5432L25.714 24.6963C25.714 24.6963 26.3648 26.1128 27.0156 26.8785C27.743 27.7207 28.1259 27.7973 28.3556 27.759C28.6618 27.6824 28.8533 27.1848 28.9298 26.4191C29.0064 25.6534 29.083 23.9306 29.083 21.825C29.083 18.035 29.083 13.0198 29.083 10.4931C24.0678 16.6185 20.3926 25.8065 20.3926 25.8065C20.3926 25.8065 17.9807 17.5755 15.0711 17.6138Z"
        fill="#0E2947"
      />
    </g>
    <defs>
      <clipPath id="clip0_913_58">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RedditAds = ({ ...props }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_984_33)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M20 6C12.8199 6 7 11.8199 7 19C7 22.5894 8.45528 25.8394 10.8073 28.1927L8.3313 30.6687C7.84019 31.1598 8.18806 32 8.88259 32H20C27.1801 32 33 26.1801 33 19C33 11.8199 27.1801 6 20 6Z"
        fill="#FF4500"
      />
      <g clipPath="url(#clip1_984_33)">
        <path
          d="M27.3696 21.9118C29.0461 21.9118 30.4053 20.5526 30.4053 18.876C30.4053 17.1994 29.0461 15.8403 27.3696 15.8403C25.693 15.8403 24.3338 17.1994 24.3338 18.876C24.3338 20.5526 25.693 21.9118 27.3696 21.9118Z"
          fill="url(#paint0_radial_984_33)"
        />
        <path
          d="M12.6309 21.9118C14.3075 21.9118 15.6667 20.5526 15.6667 18.876C15.6667 17.1994 14.3075 15.8403 12.6309 15.8403C10.9543 15.8403 9.59518 17.1994 9.59518 18.876C9.59518 20.5526 10.9543 21.9118 12.6309 21.9118Z"
          fill="url(#paint1_radial_984_33)"
        />
        <path
          d="M20.0077 27.9842C24.7942 27.9842 28.6744 25.0741 28.6744 21.4842C28.6744 17.8944 24.7942 14.9842 20.0077 14.9842C15.2212 14.9842 11.341 17.8944 11.341 21.4842C11.341 25.0741 15.2212 27.9842 20.0077 27.9842Z"
          fill="url(#paint2_radial_984_33)"
        />
        <path
          d="M17.4453 20.852C17.3947 21.9532 16.6638 22.3528 15.8126 22.3528C14.9613 22.3528 14.3127 21.789 14.3638 20.6878C14.4143 19.5867 15.1452 18.8577 15.9965 18.8577C16.8477 18.8577 17.4963 19.7504 17.4453 20.852Z"
          fill="#842123"
        />
        <path
          d="M25.6516 20.6878C25.7022 21.789 25.0536 22.3528 24.2029 22.3528C23.3521 22.3528 22.6212 21.9532 22.5701 20.852C22.5196 19.7509 23.1681 18.8577 24.0189 18.8577C24.8697 18.8577 25.6006 19.5862 25.6516 20.6878Z"
          fill="#842123"
        />
        <path
          d="M17.4457 20.9483C17.3981 21.9792 16.7144 22.3528 15.918 22.3528C15.1216 22.3528 14.5145 21.7928 14.5621 20.7625C14.6098 19.7316 15.2935 19.0575 16.0899 19.0575C16.8863 19.0575 17.4934 19.9175 17.4457 20.9483Z"
          fill="url(#paint3_radial_984_33)"
        />
        <path
          d="M22.5697 20.9483C22.6173 21.9792 23.301 22.3528 24.0974 22.3528C24.8938 22.3528 25.5009 21.7928 25.4533 20.7625C25.4056 19.7316 24.7219 19.0575 23.9255 19.0575C23.1291 19.0575 22.522 19.9175 22.5697 20.9483Z"
          fill="url(#paint4_radial_984_33)"
        />
        <path
          d="M16.5858 20.3749C16.772 20.3749 16.9229 20.2102 16.9229 20.007C16.9229 19.8039 16.772 19.6392 16.5858 19.6392C16.3997 19.6392 16.2488 19.8039 16.2488 20.007C16.2488 20.2102 16.3997 20.3749 16.5858 20.3749Z"
          fill="#FFC49C"
        />
        <path
          d="M24.6001 20.3749C24.7862 20.3749 24.9371 20.2102 24.9371 20.007C24.9371 19.8039 24.7862 19.6392 24.6001 19.6392C24.4139 19.6392 24.263 19.8039 24.263 20.007C24.263 20.2102 24.4139 20.3749 24.6001 20.3749Z"
          fill="#FFC49C"
        />
        <path
          d="M20.0077 23.0875C18.933 23.0875 17.9031 23.1395 16.9508 23.2339C16.788 23.2503 16.685 23.4159 16.7481 23.5642C17.2816 24.8146 18.5401 25.6928 20.0077 25.6928C21.4753 25.6928 22.7339 24.8146 23.2673 23.5642C23.3304 23.4159 23.2274 23.2503 23.0646 23.2339C22.1123 23.1391 21.0824 23.0875 20.0077 23.0875Z"
          fill="#BBCFDA"
        />
        <path
          d="M20.0077 23.3264C18.9364 23.3264 17.9099 23.3788 16.9604 23.4751C16.7981 23.4915 16.6951 23.66 16.7582 23.8107C17.2902 25.0809 18.5445 25.9731 20.0077 25.9731C21.4709 25.9731 22.7252 25.0809 23.2572 23.8107C23.3203 23.6605 23.2173 23.492 23.055 23.4751C22.1055 23.3788 21.079 23.3264 20.0077 23.3264Z"
          fill="white"
        />
        <path
          d="M20.0077 23.2021C18.9533 23.2021 17.9426 23.2541 17.0081 23.3485C16.8482 23.3649 16.7471 23.5305 16.8092 23.6788C17.3326 24.9292 18.5676 25.8074 20.0082 25.8074C21.4488 25.8074 22.6833 24.9292 23.2071 23.6788C23.2693 23.5305 23.1681 23.3649 23.0083 23.3485C22.0737 23.2537 21.0631 23.2021 20.0082 23.2021H20.0077Z"
          fill="url(#paint5_radial_984_33)"
        />
        <path
          d="M24.7541 14.1002C25.9423 14.1002 26.9054 13.1371 26.9054 11.9489C26.9054 10.7608 25.9423 9.79768 24.7541 9.79768C23.566 9.79768 22.6029 10.7608 22.6029 11.9489C22.6029 13.1371 23.566 14.1002 24.7541 14.1002Z"
          fill="url(#paint6_radial_984_33)"
        />
        <path
          d="M19.9769 15.2582C19.7193 15.2582 19.5103 15.1503 19.5103 14.9842C19.5103 13.0568 21.078 11.4891 23.0054 11.4891C23.263 11.4891 23.472 11.6981 23.472 11.9557C23.472 12.2133 23.263 12.4222 23.0054 12.4222C21.5927 12.4222 20.443 13.5715 20.443 14.9847C20.443 15.1508 20.234 15.2587 19.9764 15.2587L19.9769 15.2582Z"
          fill="url(#paint7_radial_984_33)"
        />
        <path
          d="M16.8795 21.4582C16.8795 21.8569 16.4553 22.036 15.9315 22.036C15.4076 22.036 14.9834 21.8569 14.9834 21.4582C14.9834 21.0595 15.4076 20.736 15.9315 20.736C16.4553 20.736 16.8795 21.0595 16.8795 21.4582Z"
          fill="#FF6101"
        />
        <path
          d="M25.0315 21.4582C25.0315 21.8569 24.6073 22.036 24.0834 22.036C23.5596 22.036 23.1354 21.8569 23.1354 21.4582C23.1354 21.0595 23.5596 20.736 24.0834 20.736C24.6073 20.736 25.0315 21.0595 25.0315 21.4582Z"
          fill="#FF6101"
        />
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_984_33"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(27.4336 17.0687) scale(6.13648 5.33874)"
      >
        <stop stopColor="#FEFFFF" />
        <stop offset="0.4" stopColor="#FEFFFF" />
        <stop offset="0.51" stopColor="#F9FCFC" />
        <stop offset="0.62" stopColor="#EDF3F5" />
        <stop offset="0.7" stopColor="#DEE9EC" />
        <stop offset="0.72" stopColor="#D8E4E8" />
        <stop offset="0.76" stopColor="#CCD8DF" />
        <stop offset="0.8" stopColor="#C8D5DD" />
        <stop offset="0.83" stopColor="#CCD6DE" />
        <stop offset="0.85" stopColor="#D8DBE2" />
        <stop offset="0.88" stopColor="#EDE3E9" />
        <stop offset="0.9" stopColor="#FFEBEF" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_984_33"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.695 10.7397) scale(6.13648 5.33874)"
      >
        <stop stopColor="#FEFFFF" />
        <stop offset="0.4" stopColor="#FEFFFF" />
        <stop offset="0.51" stopColor="#F9FCFC" />
        <stop offset="0.62" stopColor="#EDF3F5" />
        <stop offset="0.7" stopColor="#DEE9EC" />
        <stop offset="0.72" stopColor="#D8E4E8" />
        <stop offset="0.76" stopColor="#CCD8DF" />
        <stop offset="0.8" stopColor="#C8D5DD" />
        <stop offset="0.83" stopColor="#CCD6DE" />
        <stop offset="0.85" stopColor="#D8DBE2" />
        <stop offset="0.88" stopColor="#EDE3E9" />
        <stop offset="0.9" stopColor="#FFEBEF" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_984_33"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.1945 16.2932) scale(18.5101 12.9571)"
      >
        <stop stopColor="#FEFFFF" />
        <stop offset="0.4" stopColor="#FEFFFF" />
        <stop offset="0.51" stopColor="#F9FCFC" />
        <stop offset="0.62" stopColor="#EDF3F5" />
        <stop offset="0.7" stopColor="#DEE9EC" />
        <stop offset="0.72" stopColor="#D8E4E8" />
        <stop offset="0.76" stopColor="#CCD8DF" />
        <stop offset="0.8" stopColor="#C8D5DD" />
        <stop offset="0.83" stopColor="#CCD6DE" />
        <stop offset="0.85" stopColor="#D8DBE2" />
        <stop offset="0.88" stopColor="#EDE3E9" />
        <stop offset="0.9" stopColor="#FFEBEF" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_984_33"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.0807 21.4043) scale(1.54652 2.25792)"
      >
        <stop stopColor="#FF6600" />
        <stop offset="0.5" stopColor="#FF4500" />
        <stop offset="0.7" stopColor="#FC4301" />
        <stop offset="0.82" stopColor="#F43F07" />
        <stop offset="0.92" stopColor="#E53812" />
        <stop offset="1" stopColor="#D4301F" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_984_33"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.9347 21.4043) rotate(180) scale(1.54652 2.25792)"
      >
        <stop stopColor="#FF6600" />
        <stop offset="0.5" stopColor="#FF4500" />
        <stop offset="0.7" stopColor="#FC4301" />
        <stop offset="0.82" stopColor="#F43F07" />
        <stop offset="0.92" stopColor="#E53812" />
        <stop offset="1" stopColor="#D4301F" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_984_33"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.9918 26.1591) scale(5.45326 3.59915)"
      >
        <stop stopColor="#172E35" />
        <stop offset="0.29" stopColor="#0E1C21" />
        <stop offset="0.73" stopColor="#030708" />
        <stop offset="1" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_984_33"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.8008 9.96431) scale(4.78689 4.69115)"
      >
        <stop stopColor="#FEFFFF" />
        <stop offset="0.4" stopColor="#FEFFFF" />
        <stop offset="0.51" stopColor="#F9FCFC" />
        <stop offset="0.62" stopColor="#EDF3F5" />
        <stop offset="0.7" stopColor="#DEE9EC" />
        <stop offset="0.72" stopColor="#D8E4E8" />
        <stop offset="0.76" stopColor="#CCD8DF" />
        <stop offset="0.8" stopColor="#C8D5DD" />
        <stop offset="0.83" stopColor="#CCD6DE" />
        <stop offset="0.85" stopColor="#D8DBE2" />
        <stop offset="0.88" stopColor="#EDE3E9" />
        <stop offset="0.9" stopColor="#FFEBEF" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_984_33"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.8061 14.7964) scale(3.92359)"
      >
        <stop offset="0.48" stopColor="#7A9299" />
        <stop offset="0.67" stopColor="#172E35" />
        <stop offset="0.75" />
        <stop offset="0.82" stopColor="#172E35" />
      </radialGradient>
      <clipPath id="clip0_984_33">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_984_33">
        <rect
          width="20.8101"
          height="18.1865"
          fill="white"
          transform="translate(9.59518 9.79768)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SurveyMonkey = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1002_149)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M32.2273 18.5573C31.9228 18.5588 31.6197 18.5963 31.3243 18.669C30.7735 16.5325 29.611 14.5974 27.9754 13.0946C26.3398 11.5917 24.3002 10.5845 22.0999 10.1932C21.8993 10.1581 21.718 10.1326 21.5141 10.107C21.5465 9.02205 21.5983 7.76791 23.2198 6.63824L22.9641 6C22.9641 6 19.8084 6.95735 19.4427 9.62837C19.2841 8.90397 17.8244 7.99768 17.0864 7.82536L16.7239 8.40296C17.0463 8.59484 17.3212 8.85503 17.5289 9.16468C17.7366 9.47432 17.8718 9.82566 17.9247 10.1932C15.7243 10.5837 13.6843 11.5902 12.0481 13.0925C10.4119 14.5948 9.24867 16.5295 8.69714 18.6658C8.11932 18.5234 7.51554 18.5176 6.93502 18.6489C6.3545 18.7802 5.81366 19.0449 5.35658 19.4214C4.89951 19.798 4.53913 20.2756 4.30482 20.8155C4.07051 21.3554 3.9689 21.9422 4.00827 22.5282C4.04764 23.1142 4.22688 23.6827 4.53137 24.1874C4.83587 24.6921 5.257 25.1187 5.76046 25.4325C6.26391 25.7462 6.83544 25.9383 7.42846 25.9929C8.02147 26.0476 8.6192 25.9633 9.17292 25.747C9.49502 26.5409 9.90648 27.2966 10.3996 28L13.5359 25.9162L13.51 25.8811C12.6348 24.6651 12.1407 23.2227 12.0891 21.7325C11.9952 20.0348 12.4128 18.3467 13.5165 17.3542C15.7821 15.4395 18.2548 16.3171 19.8019 18.1424H20.2195C21.7666 16.3171 24.2361 15.4491 26.505 17.3542C27.6054 18.3467 28.0262 20.0348 27.9323 21.7325C27.8807 23.2227 27.3867 24.6651 26.5114 25.8811L26.4856 25.9162L29.6218 28C30.1149 27.2966 30.5264 26.5409 30.8485 25.747C31.3654 25.9461 31.9205 26.0305 32.4742 25.9941C33.0279 25.9577 33.5667 25.8014 34.0522 25.5364C34.5377 25.2714 34.958 24.9042 35.2833 24.4609C35.6085 24.0175 35.8307 23.509 35.934 22.9714C36.0373 22.4338 36.0192 21.8803 35.8809 21.3504C35.7427 20.8205 35.4877 20.3272 35.1341 19.9055C34.7805 19.4837 34.3371 19.144 33.8352 18.9104C33.3334 18.6769 32.7855 18.5552 32.2305 18.5541L32.2273 18.5573ZM7.71969 23.3824C7.43435 23.3672 7.16578 23.2448 6.96924 23.0403C6.77269 22.8357 6.66315 22.5647 6.66315 22.283C6.66315 22.0013 6.77269 21.7302 6.96924 21.5257C7.16578 21.3212 7.43435 21.1988 7.71969 21.1836C7.94256 21.1849 8.16001 21.2516 8.34435 21.3751C8.35399 21.9522 8.39396 22.5285 8.46411 23.1015C8.25945 23.2822 7.99441 23.3822 7.71969 23.3824ZM32.3017 23.3824C32.027 23.3822 31.762 23.2822 31.5573 23.1015C31.6275 22.5285 31.6674 21.9522 31.6771 21.3751C31.8448 21.263 32.0403 21.1982 32.2426 21.1876C32.4449 21.177 32.6463 21.221 32.8251 21.3149C33.0039 21.4088 33.1534 21.549 33.2573 21.7204C33.3613 21.8919 33.4159 22.088 33.4151 22.2878C33.4147 22.4319 33.3855 22.5746 33.3291 22.7076C33.2728 22.8407 33.1904 22.9614 33.0867 23.0631C32.983 23.1647 32.8601 23.2452 32.7248 23.3C32.5896 23.3548 32.4447 23.3828 32.2985 23.3824H32.3017Z"
        fill="#00BF6F"
      />
    </g>
    <defs>
      <clipPath id="clip0_1002_149">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ActiveCampaign = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1261_45)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M27.9733 19.9477L14.9081 28.9639C14.3029 29.3832 14 30.0645 14 30.746V33L29.8398 22.2017C30.5459 21.6775 31 20.8387 31 19.9477C31 19.0565 30.5965 18.2177 29.8398 17.6935L14 7V9.0967C14 9.83073 14.3532 10.512 14.9081 10.879L27.9733 19.9477Z"
        fill="#004CFF"
      />
      <path
        d="M20.4022 20.6514C21.1429 21.1162 22.0954 21.1162 22.8361 20.6514L24 19.8766L15.3228 14.1429C14.7937 13.7812 14 14.1429 14 14.8143V16.5189L18.4973 19.4633L20.4022 20.6514Z"
        fill="#004CFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1261_45">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Basecamp = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1312_68)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_1312_68)">
        <path
          d="M20.7085 11.1511C15.2498 11.1511 11.1424 14.9139 8.49327 22.2888C8.22577 22.9115 7.51285 23.2214 6.86598 22.9963C6.21911 22.7711 5.86172 22.0886 6.05023 21.4384C9.10403 12.9196 14.0359 8.60001 20.7085 8.60001C21.3114 8.60001 21.3114 11.1511 20.7085 11.1511Z"
          fill="#1D2D35"
        />
        <path
          d="M14.9481 38.3L6.30435 17.2781L10.2267 15.6722L28.168 8.29999L36.7391 29.2489L14.9481 38.3Z"
          fill="#FFE200"
        />
        <path
          d="M12.7604 37.1L8.13043 14.41L12.0254 13.5916L31.5005 9.5L36.1304 32.19L12.7604 37.1Z"
          fill="#FFE200"
        />
        <path
          d="M20.7085 32.5987C16.1563 32.6578 11.8023 30.7659 8.77575 27.4136C8.45249 27.0597 8.35542 26.5581 8.52381 26.1117C9.3407 23.9444 11.5776 18.9024 14.3718 18.8873C15.7918 18.8873 16.853 20.0011 17.7081 20.8891C17.9917 21.1989 18.2951 21.4905 18.6166 21.762C19.8164 20.2659 20.8171 18.6246 21.5941 16.878C21.9162 16.2747 22.6618 16.0264 23.2891 16.3135C23.9165 16.6006 24.2052 17.3222 23.9455 17.9541C20.8917 24.4035 19.2579 24.4035 18.7235 24.4035C17.5325 24.4035 16.6698 23.5004 15.8377 22.635C15.4636 22.2436 14.6849 21.4309 14.3871 21.4309C13.7229 21.5438 12.28 23.7939 11.2417 26.2622C13.7435 28.7383 17.164 30.0979 20.7085 30.0249C25.8312 30.0249 29.6562 28.6478 31.3052 26.2622C30.7403 19.8882 27.152 11.1511 20.7085 11.1511C20.1055 11.1511 20.1055 8.60001 20.7085 8.60001C29.4194 8.60001 33.4581 19.5721 33.9239 26.4955C33.9434 26.7571 33.885 27.0187 33.7559 27.2481C31.7251 30.6872 27.0909 32.5987 20.7085 32.5987Z"
          fill="#1D2D35"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1312_68">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_1312_68">
        <rect width="28" height="24" fill="white" transform="translate(6 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const ZohoCrm = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1609_76)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M15.0658 28.0962C17.2013 28.0962 19.2134 27.2667 20.7312 25.7665L25.1612 21.3365C25.673 20.8159 25.9643 20.1364 25.9554 19.4039C25.9554 18.6715 25.6642 17.992 25.1436 17.4801C24.0846 16.43 22.3638 16.4388 21.3048 17.489L17.2455 21.5483C16.7689 22.0248 15.9924 22.0248 15.5158 21.5571C15.2864 21.3277 15.154 21.0188 15.154 20.6923C15.154 20.3658 15.2776 20.0569 15.5158 19.8187L19.9458 15.3887C21.1813 14.162 22.8227 13.4914 24.57 13.5002C26.3437 13.509 28.0028 14.2062 29.2382 15.4681C30.4737 16.73 31.1355 18.4067 31.1002 20.1893C31.0296 23.728 28.091 26.6137 24.5523 26.6137C23.9169 26.6137 23.2904 26.5254 22.6903 26.3489C22.2932 26.2342 21.8784 26.4548 21.7637 26.8519C21.649 27.2491 21.8696 27.6638 22.2667 27.7874C23.008 28.008 23.7757 28.1139 24.5523 28.1139C28.9029 28.1139 32.5122 24.5752 32.6004 20.2246C32.6445 18.0361 31.8327 15.9799 30.306 14.4268C28.7882 12.8736 26.7497 12.0176 24.5611 12.0088C22.4256 12 20.4047 12.8295 18.878 14.3385L14.448 18.7685C13.9274 19.2892 13.645 19.9687 13.645 20.7011C13.645 21.4336 13.9362 22.1219 14.4569 22.6337C15.5158 23.6839 17.2455 23.6839 18.3044 22.6249L22.3638 18.5656C22.8403 18.089 23.6081 18.089 24.0846 18.5567C24.314 18.7862 24.4464 19.095 24.4464 19.4216C24.4464 19.7481 24.3229 20.0569 24.0846 20.2864L19.6546 24.7164C18.4191 25.9342 16.7866 26.6049 15.0481 26.6049C11.4388 26.6049 8.5002 23.6662 8.5002 20.0569C8.5002 18.3097 9.1797 16.6594 10.4152 15.424C11.6506 14.1797 13.3008 13.5002 15.0481 13.5002C15.6041 13.5002 16.16 13.5708 16.6895 13.712C16.7689 13.7296 16.8484 13.7561 16.919 13.7738C17.3161 13.8885 17.7308 13.6679 17.8544 13.2708C17.9691 12.8736 17.7485 12.4589 17.3514 12.3353C17.2543 12.3089 17.166 12.2824 17.069 12.2559C16.4159 12.0882 15.7364 12 15.0481 12C12.8949 12 10.874 12.8383 9.35619 14.365C7.83835 15.8917 7 17.9125 7 20.0658C7.02647 24.4958 10.6358 28.0962 15.0658 28.0962Z"
        fill="#226DB4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1609_76">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Bigin = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1609_96)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M18.7656 33.9857C17.8563 33.9857 17.1288 33.25 17.1288 32.3489V27.4551C17.1288 27.4137 17.1206 27.3724 17.0958 27.3393L8.52325 12.4759C8.22565 11.9634 8.22565 11.3351 8.52325 10.8308C8.81258 10.3183 9.35818 10.0042 9.94511 10.0124L25.7261 10.0207C26.3131 10.0207 26.8587 10.3348 27.148 10.8391C27.4456 11.3434 27.4456 11.9716 27.148 12.4759L25.9659 14.526H28.3632C29.2725 14.526 30 15.2617 30 16.1711C30 16.4604 29.9256 16.7415 29.7768 16.9895L23.7917 27.3724C23.7752 27.4055 23.7587 27.4468 23.7587 27.4881V31.1254C23.7587 31.8116 23.3288 32.4316 22.684 32.663L19.336 33.8865C19.1459 33.9526 18.9558 33.9857 18.7656 33.9857ZM9.94511 11.4178C9.81285 11.4178 9.71365 11.5252 9.71365 11.6492C9.71365 11.6906 9.72191 11.7319 9.74671 11.765L18.311 26.6284C18.4515 26.8764 18.5342 27.1575 18.5342 27.4468V32.3406C18.5342 32.4729 18.6416 32.5721 18.7656 32.5721C18.7904 32.5721 18.8235 32.5638 18.8483 32.5556L22.1963 31.3404C22.2872 31.3073 22.3534 31.2164 22.3534 31.1172V27.4799C22.3534 27.1905 22.4278 26.9095 22.5766 26.6615L28.5781 16.2785C28.6443 16.1628 28.6029 16.0223 28.4955 15.9561C28.4624 15.9396 28.4211 15.9231 28.3797 15.9231H24.8085C24.7755 15.9231 24.7424 15.9231 24.7176 15.9231H17.3603L20.452 21.2716L22.6096 17.5185C22.7997 17.1796 23.2379 17.0639 23.5685 17.2623C23.9075 17.4524 24.0232 17.8905 23.8248 18.2212L21.444 22.3463C21.2374 22.71 20.8488 22.9332 20.4272 22.9332C20.0056 22.9332 19.6171 22.71 19.4104 22.3463L15.9136 16.2868C15.5912 15.7247 15.7814 15.0137 16.3435 14.6831C16.5254 14.5839 16.7238 14.526 16.9304 14.526H24.3373L25.9245 11.7732C25.9907 11.6575 25.9493 11.517 25.8419 11.4508C25.8088 11.4343 25.7675 11.4178 25.7261 11.4178H9.94511Z"
        fill="#089949"
      />
    </g>
    <defs>
      <clipPath id="clip0_1609_96">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Jotform = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1312_52)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M15.7955 30.0083C16.2329 30.3722 15.9225 30.9999 15.3016 30.9999H11.3933C11.0291 31.004 10.6778 30.8836 10.4166 30.6653C10.1554 30.447 10.0056 30.1486 10 29.8354V26.5846C10 26.063 10.7513 25.8053 11.1923 26.1722L15.7955 30.0083Z"
        fill="#0A1551"
      />
      <path
        d="M20.8579 30.2261C20.586 29.9817 20.3703 29.6909 20.223 29.3706C20.0758 29.0503 20 28.7068 20 28.3599C20 28.013 20.0758 27.6694 20.223 27.3491C20.3703 27.0289 20.586 26.7381 20.8579 26.4937L24.993 22.7739C25.5447 22.2782 26.2904 22 27.0676 22C27.8447 22 28.5904 22.2782 29.1421 22.7739C29.414 23.0183 29.6297 23.3091 29.777 23.6294C29.9242 23.9496 30 24.2932 30 24.6401C30 24.987 29.9242 25.3306 29.777 25.6509C29.6297 25.9711 29.414 26.2619 29.1421 26.5063L25.007 30.2261C24.4553 30.7218 23.7096 31 22.9324 31C22.1553 31 21.4096 30.7218 20.8579 30.2261Z"
        fill="#FFB629"
      />
      <path
        d="M10.8697 20.1971C10.5941 19.943 10.3754 19.6407 10.2261 19.3077C10.0768 18.9747 10 18.6176 10 18.2569C10 17.8962 10.0768 17.5391 10.2261 17.2061C10.3754 16.8732 10.5941 16.5709 10.8697 16.3168L17.924 9.80453C18.4833 9.28918 19.2393 9 20.0272 9C20.815 9 21.571 9.28918 22.1303 9.80453C22.4059 10.0587 22.6246 10.3609 22.7739 10.6939C22.9232 11.0269 23 11.384 23 11.7447C23 12.1054 22.9232 12.4625 22.7739 12.7955C22.6246 13.1285 22.4059 13.4307 22.1303 13.6849L15.0725 20.1971C14.5133 20.7115 13.7581 21 12.9711 21C12.1841 21 11.4289 20.7115 10.8697 20.1971Z"
        fill="#0099FF"
      />
      <path
        d="M16.7868 25.2115C16.5374 24.9624 16.3396 24.6662 16.2045 24.3398C16.0695 24.0135 16 23.6634 16 23.3099C16 22.9564 16.0695 22.6064 16.2045 22.2801C16.3396 21.9537 16.5374 21.6575 16.7868 21.4084L25.408 12.7885C25.914 12.2834 26.5979 12 27.3106 12C28.0234 12 28.7072 12.2834 29.2132 12.7885C29.4626 13.0376 29.6604 13.3338 29.7955 13.6602C29.9305 13.9865 30 14.3365 30 14.6901C30 15.0436 29.9305 15.3936 29.7955 15.7199C29.6604 16.0463 29.4626 16.3425 29.2132 16.5916L20.592 25.2115C20.086 25.7166 19.4021 26 18.6894 26C17.9766 26 17.2928 25.7166 16.7868 25.2115Z"
        fill="#FF6100"
      />
    </g>
    <defs>
      <clipPath id="clip0_1312_52">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Zohobooks = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1312_58)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_1312_58)">
        <path
          d="M24.1016 10.3711H10.957C10.6445 10.3711 10.3945 10.625 10.3945 10.9336V15.7109C10.3945 16.7539 11.0586 17.6836 12.043 18.0234L26.6133 23.0234C27.7461 23.4141 28.5117 24.4805 28.5117 25.6797C28.5117 27.2266 27.25 28.4883 25.7031 28.4883H11.5234V19.1875C11.5234 18.875 11.2695 18.625 10.9609 18.625C10.6523 18.625 10.3906 18.8711 10.3906 19.1836V29.0508C10.3906 29.3633 10.6445 29.6133 10.9531 29.6133H25.6992C27.8711 29.6133 29.6367 27.8477 29.6367 25.6758C29.6367 23.9961 28.5703 22.5 26.9766 21.9531L12.4063 16.9531C12.1472 16.8635 11.9225 16.6953 11.7635 16.472C11.6046 16.2486 11.5193 15.9812 11.5195 15.707V11.4961H24.1016C25.2773 11.4961 26.3867 11.9531 27.2188 12.7852C27.6292 13.1936 27.9545 13.6794 28.1758 14.2145C28.3971 14.7496 28.5099 15.3233 28.5078 15.9023C28.5078 16.7344 28.2734 17.5469 27.8281 18.25C27.389 18.9443 26.7656 19.5029 26.0273 19.8633C25.9605 19.8955 25.9007 19.9405 25.8514 19.9959C25.802 20.0512 25.7641 20.1158 25.7398 20.1858C25.7155 20.2559 25.7052 20.3301 25.7097 20.4041C25.7141 20.4781 25.7331 20.5505 25.7656 20.6172C25.9023 20.8984 26.2383 21.0156 26.5195 20.8789C27.4492 20.4297 28.2305 19.7266 28.7852 18.8516C29.3438 17.9687 29.6367 16.9453 29.6367 15.8984C29.6367 14.4219 29.0625 13.0312 28.0156 11.9844C27.5016 11.471 26.8912 11.0642 26.2195 10.7874C25.5478 10.5105 24.8281 10.3691 24.1016 10.3711Z"
          fill="#408DFB"
        />
        <path
          d="M16.7344 21.7227C15.4922 21.7227 14.4805 22.7344 14.4805 23.9766C14.4805 25.2188 15.4922 26.2305 16.7344 26.2305C17.9766 26.2305 18.9883 25.2188 18.9883 23.9766C18.9883 22.7344 17.9766 21.7227 16.7344 21.7227ZM16.7344 25.1055C16.1133 25.1055 15.6055 24.5977 15.6055 23.9766C15.6055 23.3555 16.1133 22.8477 16.7344 22.8477C17.3555 22.8477 17.8633 23.3555 17.8633 23.9766C17.8633 24.5977 17.3555 25.1055 16.7344 25.1055ZM22.3867 13.7617C21.1445 13.7617 20.1328 14.7734 20.1328 16.0156C20.1328 17.2578 21.1445 18.2695 22.3867 18.2695C23.6289 18.2695 24.6406 17.2578 24.6406 16.0156C24.6406 14.7734 23.6328 13.7617 22.3867 13.7617ZM22.3867 17.1445C21.7656 17.1445 21.2578 16.6367 21.2578 16.0156C21.2578 15.3945 21.7656 14.8867 22.3867 14.8867C23.0078 14.8867 23.5156 15.3945 23.5156 16.0156C23.5156 16.6367 23.0117 17.1445 22.3867 17.1445Z"
          fill="#408DFB"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1312_58">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_1312_58">
        <rect width="20" height="20" fill="white" transform="matrix(1 0 0 -1 10 30)" />
      </clipPath>
    </defs>
  </svg>
);

export const Gusto = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1213_15)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M27.9994 8.3293H23.9886L24.0018 9.74787C22.7028 8.45368 21.1027 8 19.4566 8C17.2138 8 15.0628 8.87636 13.4769 10.4363C11.891 11.9962 11 14.112 11 16.318C11 18.5241 11.891 20.6398 13.4769 22.1998C15.0628 23.7597 17.2138 24.6361 19.4566 24.6361C21.4032 24.6361 23.069 23.7877 23.9272 22.7084C23.9272 22.7739 23.9214 23.5583 23.9192 23.6431C23.9031 24.1795 23.8241 25.0387 23.3103 25.9166C23.0091 26.4173 22.609 26.8536 22.1336 27.1998C21.6582 27.546 21.1171 27.795 20.5423 27.9322C19.9675 28.0694 19.3706 28.0919 18.7868 27.9985C18.2029 27.9051 17.6441 27.6977 17.1431 27.3884L15.1483 30.8036C16.4587 31.5854 17.9619 31.9992 19.4946 32C21.7138 32 24.4813 31.1372 26.4439 28.4618C28.0762 26.2387 27.9994 24.1385 27.9994 22.1052V8.3293ZM19.4566 20.6902C18.5774 20.6902 17.7179 20.4338 16.9868 19.9534C16.2557 19.4729 15.6859 18.7901 15.3494 17.9911C15.0129 17.1921 14.9247 16.313 15.0961 15.4647C15.2676 14.6165 15.6908 13.8373 16.3124 13.2257C16.9341 12.6141 17.7261 12.1975 18.5884 12.0286C19.4507 11.8597 20.3445 11.9461 21.1569 12.2769C21.9693 12.6076 22.6637 13.1679 23.1524 13.8868C23.6411 14.6057 23.9021 15.4511 23.9023 16.3159C23.9016 17.4755 23.433 18.5875 22.5994 19.4077C21.7659 20.2278 20.6356 20.6891 19.4566 20.6902Z"
        fill="#F45D48"
      />
    </g>
    <defs>
      <clipPath id="clip0_1213_15">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const QUORA_ADS = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_984_101)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_984_101)">
        <path
          d="M21.3728 28.5271C20.4084 28.7775 19.4144 28.9054 18.4158 28.9076C12.649 28.9116 7 24.4581 7 17.9863C7 11.4495 12.649 7 18.4158 7C24.2773 7 29.8632 11.423 29.8632 17.9863C29.8784 19.6369 29.4964 21.2682 28.7474 22.7513C27.9984 24.2343 26.9029 25.5285 25.5476 26.5313C26.3362 27.7296 27.2301 28.5271 28.412 28.5271C29.7055 28.5271 30.225 27.5587 30.3175 26.7998H32V27.3857C31.8759 28.8974 30.9232 32.0081 26.8683 32.0081C24.0144 32.0081 22.5043 30.407 21.3728 28.5312V28.5271ZM20.3002 26.4926C19.4085 24.7897 18.3569 23.0726 16.3022 23.0726C15.898 23.0617 15.4957 23.131 15.1202 23.276L14.422 21.9333C15.2632 21.2273 16.6429 20.6739 18.3654 20.6739C21.0994 20.6739 22.5106 21.9516 23.6232 23.5833C24.2857 22.1917 24.5991 20.3118 24.5991 17.9782C24.5991 12.1595 22.721 9.20744 18.3254 9.20744C13.9971 9.20744 12.1317 12.1982 12.1317 17.9863C12.1317 23.7745 14.0056 26.7347 18.3338 26.7347C18.9731 26.7434 19.6105 26.6639 20.2266 26.4987H20.3087L20.3002 26.4926Z"
          fill="#B72C27"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_984_101">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_984_101">
        <rect width="25" height="25" fill="white" transform="translate(7 7)" />
      </clipPath>
    </defs>
  </svg>
);

export const Podio = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1036_12)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M18.5249 19.0449C18.2127 18.7327 18.0017 18.3327 17.9174 17.899C17.833 17.4653 17.8819 17.0165 18.0558 16.6098C18.2296 16.2031 18.5215 15.8588 18.8928 15.6175C19.264 15.3779 19.6994 15.253 20.1415 15.2614C20.4335 15.2614 20.7221 15.3171 20.9921 15.4302C21.2621 15.5415 21.5051 15.7069 21.7093 15.9145C21.9945 16.198 22.1953 16.5541 22.2932 16.9422C22.3893 17.332 22.3792 17.7404 22.2594 18.1235C22.1868 18.3226 22.1548 18.5352 22.1666 18.7462C22.1784 18.9571 22.2341 19.1647 22.3286 19.3537C22.4231 19.5427 22.5564 19.7114 22.7184 19.8481C22.8804 19.9848 23.0694 20.0861 23.2736 20.1468C23.4778 20.2076 23.6904 20.2261 23.9014 20.2025C24.1123 20.1789 24.3165 20.1114 24.5004 20.0051C24.6844 19.8988 24.8447 19.757 24.973 19.5866C25.0995 19.4161 25.1906 19.2221 25.2396 19.0162C25.4775 18.223 25.5282 17.3843 25.3847 16.5676C25.2413 15.7508 24.9105 14.9796 24.4161 14.313C23.9216 13.6464 23.2787 13.1047 22.5378 12.7301C21.797 12.3555 20.9786 12.158 20.1483 12.1547C19.448 12.1496 18.7527 12.2829 18.1047 12.5479C17.4567 12.8145 16.8677 13.206 16.375 13.7021C15.3759 14.7012 14.814 16.0546 14.814 17.467C14.814 18.8795 15.3759 20.2329 16.375 21.2319L23.3158 28.1896C23.4592 28.3348 23.6297 28.4495 23.8187 28.5271C24.0077 28.6064 24.2085 28.6469 24.4127 28.6469C24.6169 28.6469 24.8194 28.6081 25.0084 28.5305C25.1974 28.4529 25.3695 28.3398 25.5147 28.1964C25.6598 28.0529 25.7745 27.8825 25.8538 27.6952C25.9332 27.5079 25.9737 27.3054 25.9737 27.1028C25.9737 26.8987 25.9349 26.6978 25.8572 26.5088C25.7796 26.3198 25.6665 26.1494 25.5214 26.0043L18.5232 19.0381L18.5249 19.0449Z"
        fill="#0045DB"
      />
      <path
        d="M12.0026 9.27403L11.9536 9.32972C9.78345 11.4881 8.5583 14.4176 8.54986 17.4738C8.54143 20.5316 9.74801 23.4679 11.9064 25.6381L18.8472 32.6042C19.1442 32.8691 19.5307 33.0109 19.9289 33.0008C20.3272 32.9906 20.7052 32.8286 20.9887 32.5468C21.2705 32.2667 21.4342 31.8887 21.446 31.4921C21.4578 31.0955 21.3178 30.7074 21.0528 30.4104L14.1035 23.4206C12.5291 21.8411 11.6448 19.703 11.6448 17.4755C11.6448 15.2479 12.5291 13.1098 14.1035 11.5303C15.6949 9.95749 17.8465 9.07659 20.0875 9.08503C22.3286 9.09178 24.4734 9.98617 26.0547 11.5708C27.376 13.0102 28.1776 14.8463 28.3345 16.792C28.4915 18.736 27.9936 20.6784 26.9204 22.3086C26.7196 22.6545 26.6605 23.0646 26.7533 23.4527C26.8478 23.8408 27.0874 24.1783 27.4249 24.396C27.7624 24.612 28.1691 24.6914 28.5623 24.6171C28.9555 24.5428 29.3049 24.3184 29.5394 23.9944C31.011 21.7719 31.686 19.1174 31.4548 16.4646C31.2236 13.8118 30.098 11.3143 28.2636 9.37866C26.1087 7.2338 23.196 6.02047 20.1534 6.00022C17.1107 5.98165 14.1829 7.15618 12.0026 9.27403Z"
        fill="#0045DB"
      />
    </g>
    <defs>
      <clipPath id="clip0_1036_12">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Intercom = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1145_268)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_1145_268)">
        <path
          d="M28.0177 21.0008C28.0177 21.1953 27.941 21.3817 27.8046 21.5191C27.6682 21.6566 27.4834 21.7339 27.2904 21.7339C27.0976 21.7339 26.9126 21.6566 26.7762 21.5191C26.6398 21.3817 26.5632 21.1953 26.5632 21.0008V14.4522C26.5632 14.2578 26.6398 14.0714 26.7762 13.9339C26.9126 13.7964 27.0976 13.7192 27.2904 13.7192C27.4834 13.7192 27.6682 13.7964 27.8046 13.9339C27.941 14.0714 28.0177 14.2578 28.0177 14.4522V21.0008ZM27.7652 25.5383C27.6691 25.6352 24.9645 27.9069 20.0061 27.9069C15.0478 27.9069 12.3613 25.6473 12.2471 25.5503C12.1751 25.4892 12.1158 25.4143 12.0726 25.33C12.0295 25.2457 12.0032 25.1536 11.9954 25.059C11.9876 24.9645 11.9983 24.8694 12.0271 24.779C12.0559 24.6887 12.102 24.6049 12.1629 24.5326C12.2885 24.3862 12.4663 24.2958 12.6577 24.281C12.8491 24.2663 13.0385 24.3285 13.1847 24.4539C13.2267 24.4842 15.6428 26.459 20.0002 26.459C24.3575 26.459 26.7916 24.472 26.8156 24.4539C26.9634 24.3295 27.1534 24.2682 27.3453 24.2829C27.5373 24.2977 27.716 24.3872 27.8434 24.5326C27.966 24.6768 28.0272 24.864 28.0136 25.0534C28.0002 25.2428 27.913 25.4193 27.7713 25.5443L27.7652 25.5383ZM11.9886 14.4522C11.9995 14.2572 12.0865 14.0744 12.2307 13.9439C12.3748 13.8133 12.5644 13.7456 12.7579 13.7555C12.9374 13.7658 13.1067 13.8427 13.2332 13.9713C13.3597 14.1 13.4345 14.2713 13.4431 14.4522V20.9888C13.4431 21.1831 13.3665 21.3695 13.2301 21.507C13.0937 21.6445 12.9087 21.7217 12.7159 21.7217C12.523 21.7217 12.338 21.6445 12.2016 21.507C12.0653 21.3695 11.9886 21.1831 11.9886 20.9888V14.4522ZM15.6368 12.9983C15.6477 12.8033 15.7347 12.6205 15.8788 12.49C16.023 12.3594 16.2126 12.2917 16.4061 12.3016C16.5855 12.3119 16.7548 12.3888 16.8813 12.5174C17.0078 12.6461 17.0826 12.8174 17.0913 12.9983V22.691C17.0913 22.8854 17.0146 23.0719 16.8783 23.2093C16.7419 23.3468 16.5569 23.424 16.364 23.424C16.1712 23.424 15.9862 23.3468 15.8498 23.2093C15.7134 23.0719 15.6368 22.8854 15.6368 22.691V12.9983ZM19.303 12.6348C19.303 12.4404 19.3796 12.254 19.516 12.1165C19.6524 11.979 19.8373 11.9018 20.0302 11.9018C20.2231 11.9018 20.4081 11.979 20.5445 12.1165C20.6809 12.254 20.7575 12.4404 20.7575 12.6348V23.1757C20.7575 23.37 20.6809 23.5564 20.5445 23.694C20.4081 23.8314 20.2231 23.9086 20.0302 23.9086C19.8373 23.9086 19.6524 23.8314 19.516 23.694C19.3796 23.5564 19.303 23.37 19.303 23.1757V12.6348ZM22.9091 12.9983C22.9091 12.8039 22.9857 12.6175 23.1221 12.48C23.2584 12.3425 23.4434 12.2653 23.6363 12.2653C23.8292 12.2653 24.0141 12.3425 24.1505 12.48C24.2868 12.6175 24.3635 12.8039 24.3635 12.9983V22.691C24.3635 22.8854 24.2868 23.0719 24.1505 23.2093C24.0141 23.3468 23.8292 23.424 23.6363 23.424C23.4434 23.424 23.2584 23.3468 23.1221 23.2093C22.9857 23.0719 22.9091 22.8854 22.9091 22.691V12.9983ZM28.216 9.00006H11.8204C11.4631 8.99767 11.1089 9.06632 10.778 9.2021C10.4471 9.33788 10.1461 9.53811 9.89204 9.79133C9.63803 10.0446 9.43606 10.3458 9.29771 10.6778C9.15935 11.0098 9.08733 11.366 9.08575 11.7261V28.0826C9.08733 28.4426 9.15935 28.7989 9.29771 29.131C9.43606 29.4629 9.63803 29.7642 9.89204 30.0174C10.1461 30.2706 10.4471 30.4709 10.778 30.6066C11.1089 30.7424 11.4631 30.811 11.8204 30.8086H28.216C28.5727 30.811 28.9265 30.7426 29.2569 30.6072C29.5875 30.4718 29.8882 30.2721 30.1422 30.0195C30.3962 29.7669 30.5983 29.4664 30.737 29.1351C30.8757 28.8038 30.9483 28.4482 30.9506 28.0886V11.7261C30.949 11.3665 30.8772 11.0108 30.7393 10.6792C30.6012 10.3476 30.3998 10.0466 30.1464 9.79348C29.8931 9.54034 29.5927 9.33998 29.2625 9.20385C28.9323 9.06771 28.5788 8.99847 28.222 9.00006"
          fill="black"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1145_268">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_1145_268">
        <rect width="22" height="22" fill="white" transform="translate(9 9)" />
      </clipPath>
    </defs>
  </svg>
);

export const Etsy = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1145_261)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_1145_261)">
        <path
          d="M17.0294 11.1021V18.8745C17.0294 18.8745 19.694 18.8745 21.121 18.7634C22.2421 18.5618 22.45 18.4507 22.6563 17.2971L23.0687 15.6086H24.2879L24.0817 19.2983L24.1898 23.0786H22.959L22.6546 21.6021C22.3502 20.551 21.9377 20.3391 21.1194 20.2366C20.0965 20.1255 17.0277 20.1255 17.0277 20.1255V26.6436C17.0277 27.8962 17.6465 28.4329 19.0736 28.4329H23.3715C24.7004 28.4329 26.0261 28.3218 26.8544 26.3308L27.9654 23.8049H28.9983C28.8902 24.3296 28.3796 28.9592 28.2815 30C28.2815 30 24.396 29.8992 22.7627 29.8992H15.3944L11 30V28.8584L12.4271 28.5354C13.46 28.3235 13.7644 28.0107 13.7644 27.1699C13.7644 27.1699 13.8725 24.3313 13.8725 19.5991C13.8725 14.8806 13.7644 12.0386 13.7644 12.0386C13.7644 11.0986 13.46 10.8867 12.4271 10.6731L11 10.3638V9.21191L15.2979 9.30249H23.4812C25.1146 9.30249 27.8673 9 27.8673 9C27.8673 9 27.7692 10.7791 27.6611 14.9832H26.54L26.1275 13.5066C25.7233 11.6165 25.1129 10.6765 23.9819 10.6765H17.55C17.0294 10.6782 17.0294 10.7791 17.0294 11.1021Z"
          fill="#F45800"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1145_261">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_1145_261">
        <rect width="18" height="21" fill="white" transform="translate(11 9)" />
      </clipPath>
    </defs>
  </svg>
);

export const Pinterest = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1208_293)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_1208_293)">
        <path
          d="M14.8083 32.9733C14.6333 31.3867 14.7617 29.8583 15.1 28.3883L16.5 22.3567C16.2472 21.5762 16.1135 20.762 16.1033 19.9417C16.1033 17.9817 17.0367 16.5817 18.53 16.5817C19.5567 16.5817 20.315 17.305 20.315 18.6817C20.315 19.125 20.2294 19.6228 20.0583 20.175L19.44 22.1933C19.3233 22.5822 19.265 22.9361 19.265 23.255C19.265 24.655 20.3383 25.4483 21.7033 25.4483C24.13 25.4483 25.8683 22.9283 25.8683 19.6617C25.8683 16.0217 23.4883 13.7 19.965 13.7C16.045 13.7 13.56 16.255 13.56 19.8017C13.56 21.2367 14.0033 22.5667 14.855 23.4767C14.575 23.9433 14.2717 24.0367 13.8283 24.0367C12.4283 24.0367 11.0983 22.0533 11.0983 19.37C11.0983 14.715 14.8317 11.0167 20.0583 11.0167C25.5417 11.0167 28.995 14.8433 28.995 19.5683C28.995 24.3167 25.635 27.8867 22.0183 27.8867C21.3291 27.8989 20.6465 27.7503 20.0247 27.4526C19.403 27.1549 18.8592 26.7163 18.4367 26.1717L17.725 29.0883C17.34 30.5817 16.7567 32.005 15.835 33.37C17.9319 34.0234 20.1532 34.1743 22.3192 33.8105C24.4852 33.4466 26.5352 32.5783 28.3036 31.2756C30.0719 29.9729 31.5089 28.2724 32.4985 26.3116C33.4881 24.3508 34.0024 22.1847 34 19.9883C34.003 17.4448 33.3131 14.9485 32.0042 12.7675C30.6954 10.5866 28.8171 8.80337 26.5712 7.60951C24.3252 6.41565 21.7964 5.85622 19.2565 5.9913C16.7165 6.12639 14.2613 6.9509 12.1547 8.37625C10.048 9.80161 8.36948 11.774 7.29935 14.0814C6.22922 16.3889 5.80795 18.9443 6.08078 21.4732C6.3536 24.0021 7.31022 26.4089 8.84788 28.435C10.3855 30.4611 12.4461 32.0301 14.8083 32.9733Z"
          fill="#E60022"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1208_293">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_1208_293">
        <rect width="28" height="28" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);

export const Coda = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1261_30)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M26.477 10H12.5216C12.119 10.0008 11.733 10.1676 11.448 10.4642C11.1629 10.7608 11.0018 11.163 11 11.583V27.4165C11.0018 27.8368 11.163 28.2391 11.4483 28.5358C11.7335 28.8325 12.1197 28.9994 12.5226 29H26.4779C26.8807 28.9994 27.2668 28.8325 27.552 28.5358C27.8372 28.2391 27.9983 27.8367 28 27.4165V26.678C27.9745 25.7277 27.949 23.7486 27.949 22.8514C27.949 22.3499 27.5939 21.9277 27.1372 21.9277C26.6295 21.9277 26.2999 22.2444 26.0463 22.508C25.285 23.2209 24.143 23.353 23.1532 23.1682C22.697 23.0623 22.2653 22.9307 21.9107 22.6933C20.8193 22.0331 20.109 20.793 20.109 19.4736C20.109 18.1543 20.8193 16.9403 21.9102 16.254C22.2908 16.0165 22.7225 15.8845 23.1537 15.7791C24.118 15.5943 25.285 15.7259 26.0463 16.4388C26.3254 16.7028 26.655 17.0191 27.1372 17.0191C27.5939 17.0191 27.949 16.5969 27.949 16.0954C27.949 15.2248 27.9745 13.2191 28 12.2693V11.583C28 10.7124 27.3143 10 26.477 10Z"
        fill="#F46A54"
      />
    </g>
    <defs>
      <clipPath id="clip0_1261_30">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Square = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1312_63)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M27.3035 9H12.6722C10.6439 9 9 10.6439 9 12.6722V27.3035C9 29.3318 10.6439 30.9757 12.6722 30.9757H27.3035C29.3318 30.9757 30.9757 29.3318 30.9757 27.3035V12.6722C30.9757 10.6439 29.3318 9 27.3035 9ZM26.9809 25.8209C26.9809 26.4617 26.4617 26.9809 25.8209 26.9809H14.1548C13.514 26.9809 12.9948 26.4617 12.9948 25.8209V14.1548C12.9948 13.514 13.514 12.9948 14.1548 12.9948H25.8209C26.4617 12.9948 26.9809 13.514 26.9809 14.1548V25.8209ZM17.6568 22.9707C17.2878 22.9707 16.9918 22.6724 16.9918 22.3034V17.6458C16.9918 17.2768 17.2878 16.9763 17.6568 16.9763H22.3211C22.6879 16.9763 22.9861 17.2746 22.9861 17.6458V22.3012C22.9861 22.6702 22.6879 22.9685 22.3211 22.9685H17.6568V22.9707Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1312_63">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Zoom = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1490_19)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M11.0825 22.9125H5.92265C5.58158 22.9125 5.25799 22.7493 5.10057 22.4708C4.92129 22.1525 4.98688 21.7706 5.26236 21.5199L8.8524 18.2533H6.28122C5.57283 18.2533 5 17.7321 5 17.0875H9.75319C10.0943 17.0875 10.4178 17.2507 10.5753 17.5292C10.7546 17.8475 10.689 18.2294 10.4135 18.4801L6.82344 21.7467H9.80129C10.5097 21.7467 11.0825 22.2679 11.0825 22.9125ZM31.5034 17C30.7644 17 30.0996 17.2904 29.6448 17.756C29.1858 17.2904 28.5211 17 27.7865 17C26.4134 17 25.294 18.0663 25.294 19.3117V22.9125C26.0024 22.9125 26.5752 22.3912 26.5752 21.7467V19.2997C26.5752 18.6989 27.0868 18.1897 27.7427 18.1658C28.4336 18.1419 29.0065 18.6472 29.0065 19.2719V21.7467C29.0065 22.3912 29.5793 22.9125 30.2876 22.9125V19.2997C30.2876 18.6989 30.7993 18.1897 31.4551 18.1658C32.1461 18.1419 32.719 18.6472 32.719 19.2719V21.7467C32.719 22.3912 33.2918 22.9125 34 22.9125V19.3117C33.9956 18.0663 32.8763 17 31.5034 17ZM17.5454 20C17.5454 21.6552 16.0675 23 14.2484 23C12.4293 23 10.9513 21.6552 10.9513 20C10.9513 18.3448 12.4337 17 14.2484 17C16.0631 17 17.5454 18.3448 17.5454 20ZM16.2642 20C16.2642 18.9894 15.3591 18.1658 14.2484 18.1658C13.1377 18.1658 12.2325 18.9894 12.2325 20C12.2325 21.0106 13.1377 21.8342 14.2484 21.8342C15.3591 21.8342 16.2642 21.0106 16.2642 20ZM24.6512 20C24.6512 21.6552 23.1732 23 21.3542 23C19.535 23 18.057 21.6552 18.057 20C18.057 18.3448 19.5395 17 21.3542 17C23.1688 17 24.6512 18.3448 24.6512 20ZM23.37 20C23.37 18.9894 22.4649 18.1658 21.3542 18.1658C20.2435 18.1658 19.3383 18.9894 19.3383 20C19.3383 21.0106 20.2435 21.8342 21.3542 21.8342C22.4649 21.8342 23.37 21.0106 23.37 20Z"
        fill="#0B5CFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1490_19">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Webflow = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1510_38)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35 12L26.3846 28H18.2923L21.8979 21.3689H21.7361C18.7616 25.0372 14.3235 27.452 8 28V21.4607C8 21.4607 12.0453 21.2337 14.4235 18.8584H8V12.0001H15.2193V17.641L15.3813 17.6404L18.3314 12.0001H23.7911V17.6052L23.9532 17.605L27.0138 12H35Z"
        fill="#146EF5"
      />
    </g>
    <defs>
      <clipPath id="clip0_1510_38">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Lever = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1617_134)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M31.7904 29.7366L27.5092 25.2182C27.374 25.0784 27.1922 25 27.0028 25C26.8135 25 26.6317 25.0784 26.4965 25.2182L22.2153 29.7366C22.1132 29.8393 22.0432 29.9724 22.0145 30.1181C21.9858 30.2639 21.9999 30.4154 22.0548 30.5525C22.1098 30.6896 22.203 30.8058 22.322 30.8856C22.4411 30.9655 22.5804 31.0052 22.7213 30.9995H31.2844C31.4245 31.0031 31.5625 30.9622 31.6803 30.882C31.7981 30.8018 31.8903 30.6861 31.9449 30.5498C31.9995 30.4136 32.0139 30.2631 31.9864 30.1181C31.9588 29.973 31.8905 29.8401 31.7904 29.7366Z"
        fill="#C3C6CC"
      />
      <path
        d="M31.9244 13.6715L30.4989 9.50965C30.4346 9.32143 30.332 9.14804 30.1975 9L8 30.8295C8.13027 30.9442 8.30043 31.0051 8.47516 30.9997H14.78C14.9562 31.0005 15.1308 30.9671 15.2939 30.9015C15.457 30.8358 15.6053 30.7392 15.7303 30.6171L31.6222 14.988C31.7949 14.8197 31.9152 14.6064 31.9687 14.3732C32.0222 14.1399 32.0069 13.8965 31.9244 13.6715Z"
        fill="#E1E3E6"
      />
      <path
        d="M29.4896 8.50034L25.3279 7.0756C25.1029 6.99314 24.8595 6.97777 24.6263 7.0313C24.393 7.08484 24.1797 7.20505 24.0114 7.37777L8.38219 23.2697C8.13633 23.5227 7.99903 23.8644 8.00034 24.22V30.5248C7.99488 30.6996 8.0558 30.8697 8.17046 31L30 8.80329C29.8518 8.66828 29.6781 8.56522 29.4896 8.50034Z"
        fill="#C3C6CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_1617_134">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Salesloft = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 791.7566 176.0657" {...props}>
    <g id="full-rgb">
      <g>
        <path
          id="fullLogo"
          d="M428.3232,104.9877,414.8349,96.95c-15.3473-8.5243-23.1419-14.1282-23.1419-24.3574,0-7.5519,6.8894-13.6942,15.6591-13.6942,17.8709,0,26.1474,13.8972,28.3811,31.5167l3.1258.0106,7.0019-37.8393a71.15,71.15,0,0,0-24.6931-4.3853c-32.6413,0-48.9637,17.569-48.9637,37.5443,0,17.0517,14.1275,25.8223,24.8466,31.9124L415.8994,128.13c12.18,6.5763,18.27,12.9126,18.27,21.9231,0,7.27-5.6778,15.7558-18.367,15.7558-17.2055,0-31.552-15.92-37.0117-38.2543h-2.5462l-7.1455,9.6644c-9.3458,11.1345-19.8825,20.1429-36.9688,20.1429-26.3084,0-38.5272-19.3659-38.5272-46.0406h64.5891V93.7831c0-24.1143-11.9344-45.5514-40.9225-45.5514-34.104,0-50.4228,30.6939-50.4228,65.04,0,15.1094,3.7325,28.1434,10.1214,38.3529-4.1768,4.5385-10.37,9.6742-18.1707,9.6742-8.6587,0-12.9023-8.2316-12.9023-20.4634V0q-1.2013.5873-2.3926,1.1532a168.3732,168.3732,0,0,1-28.544,10.784q.5282,1.1577.9923,2.36c4.1876,10.8272,4.6119,24.24,4.6119,38.0771v83.7939a62.7773,62.7773,0,0,0,1.9719,16.3462c-3.3307,4.8-8.1368,9.71-14.4868,9.71-8.0872,0-14.3217-6.1835-14.3217-18.9874V94.48c0-21.1907-4.1063-46.2792-39.4292-46.2792-30.9366,0-43.6032,19.5169-43.6032,38.7629l23.4507,8.7674s-2.9894-39.0029,18.2339-39.0029c17.052,0,16.5337,19.0308,16.5337,35.5932v6.09c0,3.8991-8.768,8.77-25.82,15.3469-14.86,6.09-37.5124,13.6421-37.5124,35.079,0,15.59,11.4477,27.2284,28.4988,27.2284,13.6427,0,26.7951-7.7424,35.0791-19.68.4867,5.847,9.5535,19.68,24.2525,19.68,14.93,0,24.9839-8.8216,31.3321-17.2821,5.411,11.9111,15.4945,17.2821,26.7851,17.2821,12.3407,0,22.138-10.4932,28.6027-19.8978a49.78,49.78,0,0,0,39.9393,19.8889c20.1272,0,33.9135-13.2937,42.2372-25.7691,4.9713,6.6294,21.25,25.778,46.665,25.778,21.3551,0,41.5176-14.009,41.5176-38.4363C450.4892,119.116,438.0663,110.3486,428.3232,104.9877ZM168.9121,150.5422c-5.6006,4.139-12.1773,7.9856-19.4862,7.9856-12.18,0-18.2708-8.9612-18.2708-19.68,0-13.8851,7.066-20.2183,29.2328-20.2183,7.7947,0,8.5242.9756,8.5242,5.6039Zm124.36-49.2073c0-28.7427,6.9451-44.09,20.344-44.09,10.962,0,18.5137,10.9616,18.5137,36.2946,0,9.7429-1.4618,10.9615-9.0144,10.9615H293.36Z"
          fill="#064b2e"
        />
        <path
          id="fullLogo-2"
          data-name="fullLogo"
          d="M494.1358,136.1678V0a172.2,172.2,0,0,1-30.9367,11.9372c5.114,11.2047,5.6034,25.5761,5.6034,40.4367v83.7939c0,13.1557-.7323,23.3849-5.8462,36.7838h40.3519S494.1358,160.8182,494.1358,136.1678Z"
          fill="#064b2e"
        />
        <path
          id="fullLogo-3"
          data-name="fullLogo"
          d="M561.0268,48.2007c-29.9615,0-50.4228,25.4371-50.4228,64.4121,0,36.5376,18.5137,63.4529,48.4743,63.4529,30.208,0,50.4264-24.9641,50.4264-63.696C609.5047,75.8289,590.7481,48.2007,561.0268,48.2007Zm.9751,118.3652c-16.5653,0-23.8706-29.5925-23.8706-61.7481,0-29.9613,6.5757-47.36,19.729-47.36,16.8082,0,23.8742,31.038,23.8742,62.95C581.7345,151.1016,574.6685,166.5659,562.0019,166.5659Z"
          fill="#064b2e"
        />
        <path
          id="fullLogo-4"
          data-name="fullLogo"
          d="M718.5224,57.2557h34.8939V50.4362H718.5224V16.5655a141.8058,141.8058,0,0,1-26.5513,13.1528c.7114,9.029.96,14.3586,1.1972,20.7179H651.137c-3.32-10.2614-5.4526-18.8717-5.4526-25.3464,0-8.2812,2.9236-13.1526,9.7458-13.1526,6.787,0,13.5813,8.3225,19.5024,29.8444h3.1153l7.0368-38.1272A29.36,29.36,0,0,0,670.531,0C639.5348,0,627.08,23.5923,626.9341,50.4362H613.0459v6.8195h13.8819v75.9917c0,13.1526-.4867,25.576-5.8444,39.7042h37.0239c-5.3578-14.1282-5.8435-26.5516-5.8435-39.7042V58.464l-.1562-1.2083h41.0788V142.501c0,22.1694,8.7706,33.5647,23.8742,33.5647,17.5386,0,29.7186-14.3187,29.7186-28.2039-6.09,4.3853-10.7191,7.01-15.8331,7.01-12.4237,0-12.4237-13.5862-12.4237-18.947V57.2557Z"
          fill="#064b2e"
        />
        <path
          id="fullLogo-5"
          data-name="fullLogo"
          d="M27.1653,44.3272c0-11.1359,10.5133-20.0318,23.9985-20.0318,17.6,0,27.9209,8.2288,33.8645,50.2855h3.6573L94.17,17.21C55.3143,3.4959,6.6292,17.6669,5.9436,59.0383c0,44.5709,70.9887,44.5467,70.9887,85.2564,0,11.8855-10.5146,20.1139-22.3992,20.1139-31.3349,0-38.7618-26.2856-40.3611-53.714H10.2853L0,162.3515s23.3142,13.7142,48.457,13.7142c30.1715-.4571,50.2858-22.6282,50.742-45.9424C99.199,85.3236,27.1653,76.0986,27.1653,44.3272Z"
          fill="#064b2e"
        />
        <path
          id="fullLogo-6"
          data-name="fullLogo"
          d="M759.7971,160.1677a15.98,15.98,0,1,1,16.0979,15.8615A15.71,15.71,0,0,1,759.7971,160.1677Z"
          fill="#b3d334"
        />
      </g>
    </g>
  </svg>
);

export const WooCommerce = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1694_8)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_1694_8)">
        <path
          d="M8.5059 13H30.4835C31.8743 13 33.0003 14.1163 33.0003 15.4955V23.8136C33.0003 25.1926 31.8744 26.3091 30.4835 26.3091H22.6021L23.6839 28.9358L18.9263 26.3091H8.51708C7.12626 26.3091 6.00028 25.1927 6.00028 23.8136V15.4955C5.98924 14.1273 7.11508 13 8.5059 13Z"
          fill="#7F54B3"
        />
        <path
          d="M7.53752 15.2745C7.69118 15.0677 7.92167 14.9589 8.22899 14.9371C8.78874 14.8936 9.10704 15.1548 9.18387 15.7207C9.52411 17.9952 9.89728 19.9214 10.2925 21.4994L12.6961 16.9614C12.9156 16.5478 13.19 16.3302 13.5193 16.3084C14.0022 16.2758 14.2985 16.5805 14.4193 17.2226C14.6936 18.67 15.0449 19.8997 15.4619 20.9444C15.7473 18.1802 16.2302 16.1887 16.9108 14.9589C17.0754 14.6542 17.3169 14.5019 17.6352 14.4801C17.8876 14.4583 18.1181 14.5345 18.3266 14.6977C18.5352 14.861 18.6449 15.0677 18.6669 15.318C18.6778 15.5139 18.6449 15.6772 18.5571 15.8404C18.1291 16.624 17.7778 17.9408 17.4925 19.769C17.2181 21.5429 17.1193 22.925 17.1852 23.9153C17.2071 24.1873 17.1632 24.4268 17.0535 24.6335C16.9218 24.873 16.7242 25.0035 16.4718 25.0253C16.1864 25.0471 15.8901 24.9165 15.6047 24.6227C14.584 23.5888 13.7718 22.0435 13.1791 19.9866C12.4657 21.3796 11.9389 22.4244 11.5987 23.1208C10.9511 24.3505 10.4024 24.9818 9.94135 25.0144C9.645 25.0362 9.39256 24.7859 9.17305 24.2635C8.6133 22.8378 8.00962 20.0846 7.36205 16.0036C7.31814 15.7207 7.384 15.4704 7.53765 15.2745L7.53752 15.2745ZM31.1246 16.983C30.7294 16.2974 30.1477 15.8839 29.3685 15.7206C29.16 15.6771 28.9624 15.6553 28.7758 15.6553C27.7222 15.6553 26.8661 16.1995 26.1966 17.2877C25.6258 18.2128 25.3405 19.2358 25.3405 20.3566C25.3405 21.1946 25.5161 21.9128 25.8673 22.5114C26.2624 23.197 26.8441 23.6106 27.6234 23.7738C27.8319 23.8173 28.0295 23.8391 28.216 23.8391C29.2806 23.8391 30.1367 23.295 30.7953 22.2067C31.366 21.2708 31.6514 20.2478 31.6514 19.1269C31.6624 18.2781 31.4758 17.5708 31.1246 16.983ZM29.7417 19.9975C29.588 20.7158 29.3136 21.249 28.9075 21.6082C28.5892 21.8911 28.2929 22.0109 28.0185 21.9564C27.7551 21.902 27.5356 21.6735 27.3709 21.2491C27.2392 20.9117 27.1734 20.5744 27.1734 20.2588C27.1734 19.9867 27.1953 19.7146 27.2502 19.4643C27.349 19.0181 27.5356 18.5828 27.8319 18.1693C28.1941 17.636 28.5782 17.4184 28.9734 17.4946C29.2368 17.549 29.4563 17.7775 29.6209 18.2019C29.7526 18.5393 29.8185 18.8766 29.8185 19.1922C29.8185 19.4752 29.7965 19.7472 29.7417 19.9975ZM24.2538 16.983C23.8587 16.2974 23.266 15.8839 22.4977 15.7206C22.2892 15.6771 22.0916 15.6553 21.9051 15.6553C20.8514 15.6553 19.9953 16.1995 19.3258 17.2877C18.7551 18.2128 18.4697 19.2358 18.4697 20.3566C18.4697 21.1946 18.6453 21.9128 18.9965 22.5114C19.3917 23.197 19.9734 23.6106 20.7526 23.7738C20.9611 23.8173 21.1587 23.8391 21.3453 23.8391C22.4099 23.8391 23.266 23.295 23.9245 22.2067C24.4953 21.2708 24.7806 20.2478 24.7806 19.1269C24.7806 18.2781 24.605 17.5708 24.2538 16.983ZM22.8599 19.9975C22.7063 20.7158 22.4319 21.249 22.0258 21.6082C21.7075 21.8911 21.4111 22.0109 21.1368 21.9564C20.8733 21.902 20.6538 21.6735 20.4892 21.2491C20.3575 20.9117 20.2916 20.5744 20.2916 20.2588C20.2916 19.9867 20.3136 19.7146 20.3685 19.4643C20.4672 19.0181 20.6538 18.5828 20.9502 18.1693C21.3124 17.636 21.6965 17.4184 22.0916 17.4946C22.3551 17.549 22.5746 17.7775 22.7392 18.2019C22.8709 18.5393 22.9368 18.8766 22.9368 19.1922C22.9477 19.4752 22.9148 19.7472 22.8599 19.9975Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1694_8">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_1694_8">
        <rect width="27" height="16" fill="white" transform="translate(6 13)" />
      </clipPath>
    </defs>
  </svg>
);

export const WordPress = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1694_2)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_1694_2)">
        <path
          d="M19.6052 6.92353C22.1432 6.92353 24.6137 7.67953 26.7062 9.09703C28.7447 10.474 30.3512 12.418 31.3097 14.686C32.9837 18.6415 32.5382 23.164 30.1352 26.7145C28.7582 28.753 26.8142 30.3595 24.5462 31.318C20.5907 32.992 16.0682 32.5465 12.5177 30.1435C10.4792 28.7665 8.87272 26.8225 7.91422 24.5545C6.24022 20.599 6.68572 16.0765 9.08872 12.526C10.4657 10.4875 12.4097 8.88103 14.6777 7.92253C16.2302 7.26103 17.9177 6.92353 19.6052 6.92353ZM19.6052 6.11353C12.1532 6.11353 6.10522 12.1615 6.10522 19.6135C6.10522 27.0655 12.1532 33.1135 19.6052 33.1135C27.0572 33.1135 33.1052 27.0655 33.1052 19.6135C33.1052 12.1615 27.0572 6.11353 19.6052 6.11353Z"
          fill="black"
        />
        <path
          d="M8.36011 19.6133C8.36011 23.9198 10.8171 27.8618 14.7051 29.7383L9.33211 15.0368C8.68411 16.4813 8.36011 18.0338 8.36011 19.6133ZM27.2061 19.0463C27.2061 17.6558 26.7066 16.6973 26.2746 15.9413C25.8426 15.1853 25.1676 14.2268 25.1676 13.3088C25.1676 12.3908 25.9506 11.3108 27.0576 11.3108H27.2061C22.6296 7.11234 15.5151 7.42284 11.3166 12.0128C10.9116 12.4583 10.5336 12.9308 10.2096 13.4303H10.9386C12.1131 13.4303 13.9356 13.2818 13.9356 13.2818C14.5431 13.2413 14.6106 14.1323 14.0031 14.2133C14.0031 14.2133 13.3956 14.2808 12.7206 14.3213L16.8111 26.5118L19.2681 19.1273L17.5131 14.3213C16.9056 14.2808 16.3386 14.2133 16.3386 14.2133C15.7311 14.1728 15.7986 13.2548 16.4061 13.2818C16.4061 13.2818 18.2691 13.4303 19.3626 13.4303C20.4561 13.4303 22.3596 13.2818 22.3596 13.2818C22.9671 13.2413 23.0346 14.1323 22.4271 14.2133C22.4271 14.2133 21.8196 14.2808 21.1446 14.3213L25.2081 26.4173L26.3691 22.7453C26.8821 21.1388 27.1926 20.0048 27.1926 19.0328L27.2061 19.0463ZM19.7946 20.5853L16.4196 30.3998C18.6876 31.0613 21.1041 31.0073 23.3316 30.2243L23.2506 30.0758L19.7946 20.5853ZM29.4741 14.2133C29.5281 14.5913 29.5551 14.9828 29.5551 15.3743C29.5551 16.5218 29.3391 17.8043 28.7046 19.3973L25.2621 29.3333C30.5271 26.2688 32.4036 19.5593 29.4741 14.2133Z"
          fill="black"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1694_2">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_1694_2">
        <rect width="28" height="28" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);

export const BigCommerce = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1983_14)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M19.5913 20.525H22.3661C23.1553 20.525 23.6549 20.0905 23.6549 19.3929C23.6549 18.7356 23.1553 18.2617 22.3661 18.2617H19.5913C19.4996 18.2617 19.4199 18.3405 19.4199 18.4194V20.3673C19.4336 20.459 19.4987 20.525 19.5913 20.525ZM19.5913 25.0132H22.4586C23.3396 25.0132 23.8657 24.5658 23.8657 23.7756C23.8657 23.0918 23.3661 22.5381 22.4586 22.5381H19.5913C19.4996 22.5381 19.4199 22.6178 19.4199 22.6967V24.8417C19.4336 24.9472 19.4987 25.0132 19.5913 25.0132ZM29.7434 8.04877L21.5365 16.2349H22.8785C24.9694 16.2349 26.206 17.5503 26.206 18.985C26.206 20.1171 25.4433 20.9467 24.6275 21.3143C24.4964 21.3675 24.4964 21.5517 24.6403 21.604C25.5872 21.9725 26.2582 22.9607 26.2582 24.1176C26.2582 25.7493 25.1674 27.0528 23.0499 27.0528H17.2364C17.1447 27.0528 17.065 26.974 17.065 26.8951V20.6964L8.05688 29.6709C7.93771 29.7901 8.01746 30 8.18796 30H29.8497C29.888 29.9995 29.9246 29.9841 29.9516 29.9571C29.9787 29.93 29.9941 29.8934 29.9946 29.8552V8.16702C30.034 8.02218 29.8497 7.94335 29.7443 8.04785L29.7434 8.04877Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1983_14">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Smartlead = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2302_40)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M7 20.1205C7 16.9258 9.57998 14.3359 12.7626 14.3359H13.094C14.4402 14.3359 15.5316 15.4314 15.5316 16.7828V23.4582C15.5316 24.8096 14.4402 25.9051 13.094 25.9051H12.7625C9.57997 25.9051 7 23.3153 7 20.1205Z"
        fill="#6E58F1"
      />
      <path
        d="M16.8389 15.3489C16.8389 14.7285 17.2019 14.166 17.7659 13.9123L26.1545 10.1394C27.192 9.67276 28.364 10.4348 28.364 11.576V28.773C28.364 29.9216 27.1782 30.6835 26.1391 30.2026L17.7505 26.3204C17.1948 26.0632 16.8389 25.505 16.8389 24.8907V24.0946C16.8389 23.4396 17.2429 22.8531 17.8533 22.6218L22.5288 20.8503C23.2051 20.594 23.2051 19.6337 22.5288 19.3774L17.8533 17.6059C17.2429 17.3746 16.8389 16.7881 16.8389 16.1331V15.3489Z"
        fill="#6E58F1"
      />
      <path
        d="M33.338 21.4853V21.1347C33.338 19.1985 31.7744 17.6289 29.8455 17.6289C29.7491 17.6289 29.6709 17.7074 29.6709 17.8042V24.8158C29.6709 24.9126 29.7491 24.9911 29.8455 24.9911C31.7744 24.9911 33.338 23.4215 33.338 21.4853Z"
        fill="#6E58F1"
      />
    </g>
    <defs>
      <clipPath id="clip0_2302_40">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Affinity = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2346_13)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.2731 20.5031C29.2728 20.6887 29.2494 20.8735 29.2035 21.0533L30.3501 22.2067C32.5619 24.4539 32.5463 28.0613 30.315 30.2893C28.0837 32.5173 24.471 32.5329 22.2205 30.3244L21.0835 29.189C20.7102 29.2879 20.3174 29.2879 19.9441 29.189L18.8143 30.3184C16.5693 32.5603 12.9294 32.5606 10.6841 30.3189C8.43886 28.0773 8.43859 24.4426 10.6835 22.2007L11.9538 20.9311C11.897 20.6461 11.897 20.3528 11.9538 20.0679L10.6847 18.7994C9.23251 17.3491 8.66547 15.2354 9.1972 13.2545C9.72893 11.2735 11.2786 9.72628 13.2626 9.19562C15.2465 8.66496 17.3633 9.23148 18.8155 10.6818L19.8108 11.6757C20.2681 11.5267 20.7614 11.5297 21.2168 11.684L22.2217 10.6806C24.4723 8.472 28.085 8.48764 30.3162 10.7156C32.5475 12.9436 32.5632 16.551 30.3513 18.7983L29.2011 19.9468C29.2489 20.1284 29.2731 20.3153 29.2731 20.5031ZM23.7751 12.2402L22.6945 13.3192C22.7308 13.4797 22.7493 13.6437 22.7497 13.8083C22.7499 14.0429 22.7126 14.276 22.6392 14.4989L26.4789 18.3293C26.6585 18.2829 26.8433 18.2596 27.0288 18.2598C27.2501 18.2595 27.4702 18.2918 27.6819 18.3557L28.7902 17.2479C30.1357 15.8585 30.1172 13.6485 28.7485 12.2818C27.3798 10.9151 25.1665 10.8966 23.7751 12.2402ZM22.6779 26.4613L26.4683 22.6752C26.8683 22.7797 27.2897 22.7701 27.6846 22.6477L28.794 23.7555C30.1395 25.1449 30.121 27.3549 28.7523 28.7216C27.3836 30.0883 25.1703 30.1068 23.7789 28.7632L22.6599 27.6446C22.7193 27.4405 22.7496 27.229 22.7499 27.0165C22.7499 26.8291 22.7257 26.6425 22.6779 26.4613ZM21.1539 24.8716L24.876 21.1551L24.8771 21.1575C24.7467 20.7308 24.7467 20.275 24.8771 19.8483L21.0171 15.9939C20.687 16.0732 20.3431 16.0753 20.0121 15.9999L16.2697 19.7344C16.4506 20.2296 16.4506 20.7726 16.2697 21.2678L19.8716 24.8645C20.2906 24.7422 20.7363 24.7447 21.1539 24.8716ZM18.3742 14.5232L18.3724 14.525C18.2383 14.1294 18.2189 13.704 18.3166 13.2979L17.2564 12.2393C15.8649 10.8957 13.6516 10.9142 12.2829 12.2809C10.9143 13.6476 10.8957 15.8576 12.2413 17.2471L13.3951 18.398C13.7789 18.2564 14.1943 18.2232 14.5958 18.3021L18.3724 14.525L18.373 14.5268L18.3742 14.5232ZM14.5957 22.7044C14.1945 22.7831 13.7793 22.7508 13.3951 22.6108L12.2413 23.7558C10.8957 25.1452 10.9143 27.3552 12.2829 28.7219C13.6516 30.0886 15.8649 30.1071 17.2564 28.7635L18.3514 27.669C18.2874 27.4575 18.255 27.2377 18.2553 27.0167C18.2551 26.8208 18.281 26.6257 18.3322 26.4365L14.5957 22.7044Z"
        fill="#2665F1"
      />
    </g>
    <defs>
      <clipPath id="clip0_2346_13">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Shiprocket = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2578_240)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7823 25.0404L24.5254 21.1476C25.4173 20.6324 25.4173 19.3465 24.5254 18.8326L17.9276 15.0232C16.7412 14.3385 15.8104 15.2384 15.8104 16.1168V23.8634C15.8104 24.7969 16.7937 25.5475 17.7823 25.0404ZM18.9257 13.3701L27.5802 18.3672C28.125 18.682 28.7976 18.682 29.3423 18.3672L29.4015 18.3322C30.2934 17.8184 30.2934 16.5311 29.4015 16.0173L17.9263 9.39252C16.8905 8.72802 15.809 9.50551 15.809 10.4861V10.6152C15.809 10.8547 15.5508 11.004 15.3436 10.8843L14.0913 10.1619C13.9756 10.096 13.9151 9.96285 13.9406 9.83237C14.3684 7.64251 16.9013 6.48166 18.9243 7.73936L30.3673 14.3466C32.537 15.5989 32.5437 18.7277 30.3902 19.9935V19.9948L16.7493 27.8692C16.1668 28.2055 15.8077 28.8269 15.8077 29.4995C15.8077 30.4801 16.8892 31.2589 17.9249 30.5931L29.4002 23.9683C30.292 23.4545 30.292 22.1672 29.4002 21.6533L29.2885 21.5888C29.0814 21.4691 29.0814 21.1704 29.2885 21.0507L30.5382 20.3284C30.6538 20.2625 30.7991 20.2759 30.8987 20.3634C32.5236 21.7879 32.346 24.4969 30.366 25.6403L18.923 32.2462C16.7156 33.6196 13.8976 32.1104 13.8774 29.5277L13.8761 29.5291V13.6431C13.8761 13.0499 13.56 12.5024 13.0475 12.2065C12.0117 11.542 10.9303 12.3195 10.9303 13.3001V26.6787C10.9303 27.6593 12.0117 28.4382 13.0475 27.7723C13.2546 27.6526 13.5129 27.8019 13.5129 28.0413V29.4793C13.5129 29.6138 13.4282 29.7322 13.3004 29.7752C11.2437 30.4572 9 28.995 9 26.6787V13.3001C9 10.7645 11.6889 9.25262 13.8774 10.4538C15.5615 11.4263 17.2429 12.3975 18.9257 13.3701Z"
        fill="#46237A"
      />
      <path
        d="M17.5846 22.4214C17.5846 22.7833 17.9828 23.0698 18.3648 22.825L22.5952 20.3835C22.9234 20.1939 22.9234 19.7191 22.5952 19.5294L18.3648 17.088C17.9828 16.8432 17.5846 17.1297 17.5846 17.4915V22.4214Z"
        fill="#18F040"
      />
    </g>
    <defs>
      <clipPath id="clip0_2578_240">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowFlightSQL = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20" cy="20" r="20" fill="#F7F7F7" />
    <polygon points="8,8 20.5,20 8,32 8,26.75 15.25,20 8,13.25" fill="#000000" />
    <polygon points="15.75,8 28.25,20 15.75,32 15.75,26.75 23,20 15.75,13.25" fill="#000000" />
    <polygon points="23.5,8 36,20 23.5,32 23.5,26.75 30.75,20 23.5,13.25" fill="#000000" />
  </svg>
);

export const Databricks = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2588_20)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M30.0053 17.8973L20.108 23.4831L9.50973 17.515L9 17.7911V22.1238L20.108 28.3681L30.0053 22.8035V25.0973L20.108 30.6831L9.50973 24.715L9 24.9911V25.7345L20.108 31.9787L31.1947 25.7345V21.4017L30.685 21.1256L20.108 27.0725L10.1894 21.5079V19.2141L20.108 24.7787L31.1947 18.5345V14.2654L30.6425 13.9468L20.108 19.8725L10.6991 14.6052L20.108 9.31675L27.8389 13.6707L28.5186 13.2884V12.7575L20.108 8.02118L9 14.2654V14.9451L20.108 21.1893L30.0053 15.6035V17.8973Z"
        fill="#EE3D2C"
      />
    </g>
    <defs>
      <clipPath id="clip0_2588_20">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Rippling = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3129_1073)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M10.878 15.99C10.878 14.01 9.875 12.374 8 11H12.358C13.1262 11.5851 13.7487 12.34 14.1767 13.2057C14.6046 14.0714 14.8265 15.0243 14.825 15.99C14.8265 16.9557 14.6046 17.9086 14.1767 18.7743C13.7487 19.64 13.1262 20.3949 12.358 20.98C13.773 21.57 14.578 23.01 14.578 25.071V28.998H10.632V25.071C10.632 23.108 9.695 21.734 8.001 20.981C9.876 19.606 10.879 17.971 10.879 15.991L10.878 15.99ZM19.43 15.99C19.43 14.01 18.427 12.374 16.552 11H20.911C21.6791 11.5852 22.3013 12.3402 22.7291 13.2058C23.1569 14.0715 23.3787 15.0244 23.377 15.99C23.3787 16.9556 23.1569 17.9085 22.7291 18.7742C22.3013 19.6398 21.6791 20.3948 20.911 20.98C22.325 21.57 23.131 23.01 23.131 25.071V28.998H19.184V25.071C19.184 23.108 18.246 21.734 16.552 20.981C18.427 19.606 19.43 17.971 19.43 15.991V15.99ZM27.984 15.99C27.984 14.01 26.981 12.374 25.106 11H29.464C30.2322 11.5851 30.8547 12.34 31.2827 13.2057C31.7106 14.0714 31.9325 15.0243 31.931 15.99C31.9325 16.9557 31.7106 17.9086 31.2827 18.7743C30.8547 19.64 30.2322 20.3949 29.464 20.98C30.879 21.57 31.684 23.01 31.684 25.071V28.998H27.737V25.071C27.737 23.108 26.8 21.734 25.106 20.981C26.981 19.606 27.984 17.971 27.984 15.991V15.99Z"
        fill="#4B2C3A"
      />
    </g>
    <defs>
      <clipPath id="clip0_3129_1073">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Apollo = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3408_18)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path d="M27 14H24L25.5574 16L27 14Z" fill="black" />
      <path
        d="M20.059 11L9 28.9604H14.9227C15.7138 28.9604 16.4913 28.7649 17.1765 28.3979C17.9179 28.0001 18.4791 27.4222 18.9163 26.7212C19.4279 25.9015 19.926 25.073 20.4286 24.2489L21.7177 22.1393L20.0544 19.4232L19.3174 20.579C18.4768 21.9481 17.6813 23.3501 16.8114 24.7016C16.3741 25.3784 15.8017 26.0202 14.9588 26.185C14.8326 26.2091 14.7019 26.2223 14.5712 26.2267C14.3976 26.2334 14.2241 26.229 14.0506 26.229L20.059 16.2609L27.7689 29H30V27.1278L29.9482 27.0442L20.059 11Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_3408_18">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Sage = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3413_5)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path
        d="M8.26483 12C6.40964 12 5 13.3918 5 15.1781C5 17.1361 6.40964 17.8922 7.97267 18.3562C9.45171 18.8201 10.1529 19.3352 10.1529 20.3507C10.1529 21.3808 9.37867 22.1041 8.36708 22.1041C7.35184 22.1041 6.47538 21.3808 6.47538 20.2667C6.47538 19.6493 6.76753 19.4922 6.76753 19.1489C6.76753 18.7543 6.49364 18.4621 6.04445 18.4621C5.53318 18.4621 5 19.2366 5 20.3361C5 22.1078 6.53016 23.4119 8.36708 23.4119C10.2223 23.4119 11.6319 22.0201 11.6319 20.2338C11.6319 18.2904 10.2223 17.5196 8.64463 17.0557C7.18386 16.6101 6.47903 16.0767 6.47903 15.0612C6.47903 14.0493 7.23498 13.326 8.24657 13.326C9.29467 13.326 10.1383 14.0639 10.1529 15.0795C10.1712 15.5434 10.4962 15.8174 10.876 15.8174C11.2704 15.8174 11.6319 15.5434 11.6136 15.0429C11.5808 13.2712 10.0871 12 8.26483 12ZM15.7221 23.3936C16.5474 23.3936 17.1829 23.1196 17.1829 22.5681C17.1829 22.1553 16.8396 21.8813 16.5109 21.8813C16.2699 21.8813 16.0982 21.9836 15.7038 21.9836C14.6375 21.9836 13.7975 21.074 13.7975 20.0073C13.7975 18.8566 14.6557 17.9434 15.7403 17.9434C16.9601 17.9434 17.7343 18.8712 17.7343 20.2119V22.6703C17.7343 23.1014 18.0776 23.3936 18.4902 23.3936C18.8846 23.3936 19.2279 23.1014 19.2279 22.6703V20.1607C19.2279 18.1005 17.8037 16.5881 15.7732 16.5881C13.8815 16.5881 12.3185 18.0493 12.3185 20.0073C12.3185 21.8995 13.8669 23.3936 15.7221 23.3936ZM23.2816 28C25.1368 28 26.5464 26.6082 26.5464 24.822C26.5464 22.864 25.1367 22.1078 23.5591 21.6439C22.0983 21.1799 21.3935 20.6649 21.3935 19.6493C21.3935 18.6338 22.1677 17.8959 23.1611 17.8959C24.1763 17.8959 25.0674 18.6192 25.0674 19.7333C25.0674 20.3544 24.7752 20.5078 24.7752 20.8511C24.7752 21.2457 25.0491 21.5379 25.4801 21.5379C26.0132 21.5379 26.5464 20.7635 26.5464 19.6639C26.5464 17.8922 25.0017 16.5881 23.1611 16.5881C21.3059 16.5881 19.9145 17.9799 19.9145 19.7662C19.9145 21.7096 21.3059 22.4804 22.8872 22.9443C24.3662 23.39 25.0674 23.9233 25.0674 24.9388C25.0674 25.969 24.2931 26.674 23.2998 26.674C22.2335 26.674 21.4082 25.9544 21.3935 24.9206C21.3753 24.4566 21.032 24.1973 20.6704 24.1973C20.276 24.1973 19.9145 24.4566 19.9328 24.9534C19.9474 26.747 21.441 28 23.2816 28ZM30.7388 23.3936C31.6993 23.3936 32.4589 23.1196 32.9884 22.7909C33.5033 22.4658 33.7079 22.1881 33.7079 21.8813C33.7079 21.5562 33.4668 21.264 33.0213 21.264C32.4881 21.264 32.0608 22.053 30.7534 22.053C29.6031 22.053 28.6901 21.1434 28.6901 19.9927C28.6901 18.8566 29.5666 17.9288 30.6658 17.9288C31.8527 17.9288 32.4881 18.7032 32.4881 19.2C32.4881 19.3388 32.3859 19.4082 32.2471 19.4082H30.8046C30.4102 19.4082 30.118 19.6676 30.118 20.011C30.118 20.3872 30.4102 20.6649 30.8046 20.6649H32.7803C33.5362 20.6649 34 20.2703 34 19.5982C34 17.9141 32.5575 16.5918 30.6476 16.5918C28.7558 16.5918 27.2293 18.1041 27.2293 19.9927C27.2293 21.8813 28.8142 23.3936 30.7388 23.3936Z"
        fill="#00D639"
      />
    </g>
    <defs>
      <clipPath id="clip0_3413_5">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AwsBilling = ({ ...props }) => (
  <svg
    width="300"
    height="300"
    viewBox="0 0 304 182"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        fill="#252F3E"
        d="M86.4,66.4c0,3.7,0.4,6.7,1.1,8.9c0.8,2.2,1.8,4.6,3.2,7.2c0.5,0.8,0.7,1.6,0.7,2.3c0,1-0.6,2-1.9,3l-6.3,4.2
    		c-0.9,0.6-1.8,0.9-2.6,0.9c-1,0-2-0.5-3-1.4C76.2,90,75,88.4,74,86.8c-1-1.7-2-3.6-3.1-5.9c-7.8,9.2-17.6,13.8-29.4,13.8
    		c-8.4,0-15.1-2.4-20-7.2c-4.9-4.8-7.4-11.2-7.4-19.2c0-8.5,3-15.4,9.1-20.6c6.1-5.2,14.2-7.8,24.5-7.8c3.4,0,6.9,0.3,10.6,0.8
    		c3.7,0.5,7.5,1.3,11.5,2.2v-7.3c0-7.6-1.6-12.9-4.7-16c-3.2-3.1-8.6-4.6-16.3-4.6c-3.5,0-7.1,0.4-10.8,1.3c-3.7,0.9-7.3,2-10.8,3.4
    		c-1.6,0.7-2.8,1.1-3.5,1.3c-0.7,0.2-1.2,0.3-1.6,0.3c-1.4,0-2.1-1-2.1-3.1v-4.9c0-1.6,0.2-2.8,0.7-3.5c0.5-0.7,1.4-1.4,2.8-2.1
    		c3.5-1.8,7.7-3.3,12.6-4.5c4.9-1.3,10.1-1.9,15.6-1.9c11.9,0,20.6,2.7,26.2,8.1c5.5,5.4,8.3,13.6,8.3,24.6V66.4z M45.8,81.6
    		c3.3,0,6.7-0.6,10.3-1.8c3.6-1.2,6.8-3.4,9.5-6.4c1.6-1.9,2.8-4,3.4-6.4c0.6-2.4,1-5.3,1-8.7v-4.2c-2.9-0.7-6-1.3-9.2-1.7
    		c-3.2-0.4-6.3-0.6-9.4-0.6c-6.7,0-11.6,1.3-14.9,4c-3.3,2.7-4.9,6.5-4.9,11.5c0,4.7,1.2,8.2,3.7,10.6
    		C37.7,80.4,41.2,81.6,45.8,81.6z M126.1,92.4c-1.8,0-3-0.3-3.8-1c-0.8-0.6-1.5-2-2.1-3.9L96.7,10.2c-0.6-2-0.9-3.3-0.9-4
    		c0-1.6,0.8-2.5,2.4-2.5h9.8c1.9,0,3.2,0.3,3.9,1c0.8,0.6,1.4,2,2,3.9l16.8,66.2l15.6-66.2c0.5-2,1.1-3.3,1.9-3.9c0.8-0.6,2.2-1,4-1
    		h8c1.9,0,3.2,0.3,4,1c0.8,0.6,1.5,2,1.9,3.9l15.8,67l17.3-67c0.6-2,1.3-3.3,2-3.9c0.8-0.6,2.1-1,3.9-1h9.3c1.6,0,2.5,0.8,2.5,2.5
    		c0,0.5-0.1,1-0.2,1.6c-0.1,0.6-0.3,1.4-0.7,2.5l-24.1,77.3c-0.6,2-1.3,3.3-2.1,3.9c-0.8,0.6-2.1,1-3.8,1h-8.6c-1.9,0-3.2-0.3-4-1
    		c-0.8-0.7-1.5-2-1.9-4L156,23l-15.4,64.4c-0.5,2-1.1,3.3-1.9,4c-0.8,0.7-2.2,1-4,1H126.1z M254.6,95.1c-5.2,0-10.4-0.6-15.4-1.8
    		c-5-1.2-8.9-2.5-11.5-4c-1.6-0.9-2.7-1.9-3.1-2.8c-0.4-0.9-0.6-1.9-0.6-2.8v-5.1c0-2.1,0.8-3.1,2.3-3.1c0.6,0,1.2,0.1,1.8,0.3
    		c0.6,0.2,1.5,0.6,2.5,1c3.4,1.5,7.1,2.7,11,3.5c4,0.8,7.9,1.2,11.9,1.2c6.3,0,11.2-1.1,14.6-3.3c3.4-2.2,5.2-5.4,5.2-9.5
    		c0-2.8-0.9-5.1-2.7-7c-1.8-1.9-5.2-3.6-10.1-5.2L246,52c-7.3-2.3-12.7-5.7-16-10.2c-3.3-4.4-5-9.3-5-14.5c0-4.2,0.9-7.9,2.7-11.1
    		c1.8-3.2,4.2-6,7.2-8.2c3-2.3,6.4-4,10.4-5.2c4-1.2,8.2-1.7,12.6-1.7c2.2,0,4.5,0.1,6.7,0.4c2.3,0.3,4.4,0.7,6.5,1.1
    		c2,0.5,3.9,1,5.7,1.6c1.8,0.6,3.2,1.2,4.2,1.8c1.4,0.8,2.4,1.6,3,2.5c0.6,0.8,0.9,1.9,0.9,3.3v4.7c0,2.1-0.8,3.2-2.3,3.2
    		c-0.8,0-2.1-0.4-3.8-1.2c-5.7-2.6-12.1-3.9-19.2-3.9c-5.7,0-10.2,0.9-13.3,2.8c-3.1,1.9-4.7,4.8-4.7,8.9c0,2.8,1,5.2,3,7.1
    		c2,1.9,5.7,3.8,11,5.5l14.2,4.5c7.2,2.3,12.4,5.5,15.5,9.6c3.1,4.1,4.6,8.8,4.6,14c0,4.3-0.9,8.2-2.6,11.6
    		c-1.8,3.4-4.2,6.4-7.3,8.8c-3.1,2.5-6.8,4.3-11.1,5.6C264.4,94.4,259.7,95.1,254.6,95.1z"
      />
      <g>
        <path
          fillRule="evenodd"
          fill="#FF9900"
          clipRule="evenodd"
          d="M273.5,143.7c-32.9,24.3-80.7,37.2-121.8,37.2c-57.6,0-109.5-21.3-148.7-56.7c-3.1-2.8-0.3-6.6,3.4-4.4
    			c42.4,24.6,94.7,39.5,148.8,39.5c36.5,0,76.6-7.6,113.5-23.2C274.2,133.6,278.9,139.7,273.5,143.7z"
        />
        <path
          fillRule="evenodd"
          fill="#FF9900"
          clipRule="evenodd"
          d="M287.2,128.1c-4.2-5.4-27.8-2.6-38.5-1.3c-3.2,0.4-3.7-2.4-0.8-4.5c18.8-13.2,49.7-9.4,53.3-5
    			c3.6,4.5-1,35.4-18.6,50.2c-2.7,2.3-5.3,1.1-4.1-1.9C282.5,155.7,291.4,133.4,287.2,128.1z"
        />
      </g>
    </g>
  </svg>
);

export const SharePoint = ({ ...props }) => (
  <Svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3974_403)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_3974_403)">
        <path
          d="M20 16.7456L32 14V8.9504C32 8.4224 31.5776 8 31.0496 8H14L8 14L20 16.7456Z"
          fill="#FEE200"
        />
        <path d="M14 14H8V22.8896L15.4304 19.8176L14 14Z" fill="url(#paint0_linear_3974_403)" />
        <path
          d="M22.1792 21.6032L14 20.144V14H32V20.0672L22.1792 21.6032Z"
          fill="url(#paint1_linear_3974_403)"
        />
        <path
          d="M24.5696 27.1424L12.6848 26.0384V20H32V26L24.5696 27.1424Z"
          fill="url(#paint2_linear_3974_403)"
        />
        <path d="M14 20H8V27.9968L14 26V20Z" fill="url(#paint3_linear_3974_403)" />
        <path d="M32 26L26 32H14L13.0784 28.8608L14 26H32Z" fill="url(#paint4_linear_3974_403)" />
        <path
          d="M8 26V30.6752C8 31.4048 8.5952 31.9904 9.3248 31.9904H14V25.9904H8V26Z"
          fill="url(#paint5_linear_3974_403)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3974_403"
        x1="11.7152"
        y1="14"
        x2="11.7152"
        y2="19.7987"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DE4A01" />
        <stop offset="1" stopColor="#E15900" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3974_403"
        x1="23"
        y1="19.3906"
        x2="23"
        y2="14.5455"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F08B09" />
        <stop offset="1" stopColor="#EB770A" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3974_403"
        x1="22.3424"
        y1="27.1424"
        x2="22.3424"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D73A00" />
        <stop offset="1" stopColor="#CD2901" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3974_403"
        x1="11"
        y1="25.6066"
        x2="11"
        y2="20.3447"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BE3106" />
        <stop offset="1" stopColor="#AD3007" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3974_403"
        x1="22.5392"
        y1="32"
        x2="22.5392"
        y2="26"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#844980" />
        <stop offset="1" stopColor="#703F6C" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3974_403"
        x1="11"
        y1="31.9904"
        x2="11"
        y2="25.9904"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6F3C6D" />
        <stop offset="1" stopColor="#663764" />
      </linearGradient>
      <clipPath id="clip0_3974_403">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_3974_403">
        <rect width="24" height="24" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </Svg>
);

export const GoogleClassroom = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3343_613)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F7F7F7"
      />
      <path d="M11.0757 12.3826H29.0076V27.3258H11.0757V12.3826Z" fill="#0F9D58" />
      <path
        d="M24.0265 20.3523C24.2482 20.3523 24.4649 20.2865 24.6492 20.1634C24.8335 20.0402 24.9772 19.8652 25.0619 19.6604C25.1468 19.4556 25.169 19.2303 25.1257 19.0129C25.0825 18.7955 24.9757 18.5958 24.819 18.439C24.6623 18.2823 24.4626 18.1755 24.2452 18.1323C24.0278 18.089 23.8024 18.1113 23.5977 18.1961C23.3929 18.2809 23.2178 18.4245 23.0947 18.6088C22.9715 18.7931 22.9058 19.0098 22.9058 19.2315C22.9058 19.5288 23.0239 19.8139 23.2341 20.024C23.4442 20.2342 23.7293 20.3523 24.0265 20.3523ZM24.0265 21.0994C22.8261 21.0994 21.536 21.7357 21.536 22.5228V23.3409H26.5171V22.5228C26.5171 21.7357 25.227 21.0994 24.0265 21.0994ZM16.0568 20.3523C16.2785 20.3523 16.4952 20.2865 16.6795 20.1634C16.8638 20.0402 17.0074 19.8652 17.0923 19.6604C17.177 19.4556 17.1992 19.2303 17.156 19.0129C17.1128 18.7955 17.0061 18.5958 16.8493 18.439C16.6926 18.2823 16.4929 18.1755 16.2755 18.1323C16.0581 18.089 15.8327 18.1113 15.6279 18.1961C15.4231 18.2809 15.2481 18.4245 15.125 18.6088C15.0018 18.7931 14.9361 19.0098 14.9361 19.2315C14.9361 19.5288 15.0542 19.8139 15.2643 20.024C15.4745 20.2342 15.7596 20.3523 16.0568 20.3523ZM16.0568 21.0994C14.8564 21.0994 13.5663 21.7357 13.5663 22.5228V23.3409H18.5474V22.5228C18.5474 21.7357 17.2572 21.0994 16.0568 21.0994Z"
        fill="#57BB8A"
      />
      <path
        d="M20.0417 19.356C20.3372 19.356 20.6261 19.2684 20.8719 19.1042C21.1176 18.94 21.3092 18.7067 21.4223 18.4336C21.5353 18.1605 21.5649 17.8601 21.5073 17.5702C21.4496 17.2804 21.3073 17.0141 21.0984 16.8051C20.8893 16.5961 20.6231 16.4538 20.3332 16.3962C20.0433 16.3385 19.7429 16.3681 19.4698 16.4812C19.1968 16.5943 18.9634 16.7858 18.7992 17.0315C18.635 17.2773 18.5474 17.5662 18.5474 17.8617C18.5474 18.2581 18.7048 18.6381 18.9851 18.9184C19.2653 19.1986 19.6454 19.356 20.0417 19.356ZM20.0417 20.3523C18.3606 20.3523 16.5549 21.2439 16.5549 22.3447V23.3409H23.5284V22.3447C23.5284 21.2439 21.7228 20.3523 20.0417 20.3523Z"
        fill="#F7F7F7"
      />
      <path d="M27.3838 25.5824H21.287V28.1028H27.3838V25.5824Z" fill="url(#pattern0_3343_613)" />
      <path d="M22.0341 26.3296H26.5171V27.3258H22.0341V26.3296Z" fill="#F1F1F1" />
      <path
        d="M29.5057 10.3901H10.5776C10.1813 10.3901 9.80123 10.5476 9.52099 10.8278C9.24075 11.108 9.08331 11.4881 9.08331 11.8845V27.8239C9.08331 28.2202 9.24075 28.6003 9.52099 28.8806C9.80123 29.1608 10.1813 29.3182 10.5776 29.3182H29.5057C29.902 29.3182 30.2821 29.1608 30.5623 28.8806C30.8426 28.6003 31 28.2202 31 27.8239V11.8845C31 11.4881 30.8426 11.108 30.5623 10.8278C30.2821 10.5476 29.902 10.3901 29.5057 10.3901ZM29.0076 27.3258H11.0757V12.3826H29.0076V27.3258Z"
        fill="#F4B400"
      />
      <path
        opacity="0.2"
        d="M29.5057 10.3901H10.5776C10.1813 10.3901 9.80123 10.5476 9.52099 10.8278C9.24075 11.108 9.08331 11.4881 9.08331 11.8845V12.009C9.08331 11.6127 9.24075 11.2326 9.52099 10.9523C9.80123 10.6721 10.1813 10.5147 10.5776 10.5147H29.5057C29.902 10.5147 30.2821 10.6721 30.5623 10.9523C30.8426 11.2326 31 11.6127 31 12.009V11.8845C31 11.4881 30.8426 11.108 30.5623 10.8278C30.2821 10.5476 29.902 10.3901 29.5057 10.3901Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M29.5057 29.1937H10.5776C10.1813 29.1937 9.80123 29.0362 9.52099 28.756C9.24075 28.4757 9.08331 28.0957 9.08331 27.6994V27.8239C9.08331 28.2202 9.24075 28.6003 9.52099 28.8806C9.80123 29.1608 10.1813 29.3182 10.5776 29.3182H29.5057C29.902 29.3182 30.2821 29.1608 30.5623 28.8806C30.8426 28.6003 31 28.2202 31 27.8239V27.6994C31 28.0957 30.8426 28.4757 30.5623 28.756C30.2821 29.0362 29.902 29.1937 29.5057 29.1937Z"
        fill="#BF360C"
      />
      <path
        d="M26.5096 27.3258H22.0266L24.0191 29.3182H28.502L26.5096 27.3258Z"
        fill="url(#paint0_linear_3343_613)"
      />
      <path opacity="0.2" d="M11.0757 12.258H29.0076V12.3826H11.0757V12.258Z" fill="#263238" />
      <path opacity="0.2" d="M11.0757 27.3258H29.0076V27.4503H11.0757V27.3258Z" fill="white" />
      <path
        d="M29.5057 10.3901H10.5776C10.1813 10.3901 9.80123 10.5476 9.52099 10.8278C9.24075 11.108 9.08331 11.4881 9.08331 11.8845V27.8239C9.08331 28.2202 9.24075 28.6003 9.52099 28.8806C9.80123 29.1608 10.1813 29.3182 10.5776 29.3182H29.5057C29.902 29.3182 30.2821 29.1608 30.5623 28.8806C30.8426 28.6003 31 28.2202 31 27.8239V11.8845C31 11.4881 30.8426 11.108 30.5623 10.8278C30.2821 10.5476 29.902 10.3901 29.5057 10.3901Z"
        fill="url(#paint1_radial_3343_613)"
      />
    </g>
    <defs>
      <pattern id="pattern0_3343_613" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use transform="scale(0.00490196 0.0116279)" />
      </pattern>
      <linearGradient
        id="paint0_linear_3343_613"
        x1="25.2624"
        y1="27.3532"
        x2="25.2624"
        y2="29.3387"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BF360C" stopOpacity="0.2" />
        <stop offset="1" stopColor="#BF360C" stopOpacity="0.02" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_3343_613"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.83047 10.8341) scale(26.1761)"
      >
        <stop stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_3343_613">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <image id="image0_3343_613" width="204" height="86" />
    </defs>
  </svg>
);

export const Metabase = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_metabase_webapp)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0816 29.7856C23.8765 29.7856 25.3316 28.3306 25.3316 26.5356C25.3316 24.7407 23.8765 23.2856 22.0816 23.2856C20.2866 23.2856 18.8315 24.7407 18.8315 26.5356C18.8315 28.3306 20.2866 29.7856 22.0816 29.7856Z"
        fill="#509EE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0816 38.1428C23.8765 38.1428 25.3316 36.8956 25.3316 35.3571C25.3316 33.8186 23.8765 32.5714 22.0816 32.5714C20.2866 32.5714 18.8315 33.8186 18.8315 35.3571C18.8315 36.8956 20.2866 38.1428 22.0816 38.1428Z"
        fill="#509EE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3672 38.1428C33.1621 38.1428 34.6172 36.8956 34.6172 35.3571C34.6172 33.8186 33.1621 32.5714 31.3672 32.5714C29.5723 32.5714 28.1172 33.8186 28.1172 35.3571C28.1172 36.8956 29.5723 38.1428 31.3672 38.1428Z"
        fill="#509EE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.296 29.7856C60.0909 29.7856 61.5459 28.3306 61.5459 26.5356C61.5459 24.7407 60.0909 23.2856 58.296 23.2856C56.5011 23.2856 55.0459 24.7407 55.0459 26.5356C55.0459 28.3306 56.5011 29.7856 58.296 29.7856Z"
        fill="#509EE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.4744 38.1428C51.013 38.1428 52.2602 36.8956 52.2602 35.3571C52.2602 33.8186 51.013 32.5714 49.4744 32.5714C47.9359 32.5714 46.6887 33.8186 46.6887 35.3571C46.6887 36.8956 47.9359 38.1428 49.4744 38.1428Z"
        fill="#509EE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.6532 47.4285C42.4481 47.4285 43.9031 45.9735 43.9031 44.1785C43.9031 42.3836 42.4481 40.9285 40.6532 40.9285C38.8583 40.9285 37.4031 42.3836 37.4031 44.1785C37.4031 45.9735 38.8583 47.4285 40.6532 47.4285Z"
        fill="#509EE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.296 38.1428C60.0909 38.1428 61.5459 36.8956 61.5459 35.3571C61.5459 33.8186 60.0909 32.5714 58.296 32.5714C56.5011 32.5714 55.0459 33.8186 55.0459 35.3571C55.0459 36.8956 56.5011 38.1428 58.296 38.1428Z"
        fill="#509EE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0816 47.4285C23.8765 47.4285 25.3316 45.9735 25.3316 44.1785C25.3316 42.3836 23.8765 40.9285 22.0816 40.9285C20.2866 40.9285 18.8315 42.3836 18.8315 44.1785C18.8315 45.9735 20.2866 47.4285 22.0816 47.4285Z"
        fill="#509EE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.296 47.4285C60.0909 47.4285 61.5459 45.9735 61.5459 44.1785C61.5459 42.3836 60.0909 40.9285 58.296 40.9285C56.5011 40.9285 55.0459 42.3836 55.0459 44.1785C55.0459 45.9735 56.5011 47.4285 58.296 47.4285Z"
        fill="#509EE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0816 56.7143C23.8765 56.7143 25.3316 55.2593 25.3316 53.4643C25.3316 51.6694 23.8765 50.2143 22.0816 50.2143C20.2866 50.2143 18.8315 51.6694 18.8315 53.4643C18.8315 55.2593 20.2866 56.7143 22.0816 56.7143Z"
        fill="#509EE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.296 56.7143C60.0909 56.7143 61.5459 55.2593 61.5459 53.4643C61.5459 51.6694 60.0909 50.2143 58.296 50.2143C56.5011 50.2143 55.0459 51.6694 55.0459 53.4643C55.0459 55.2593 56.5011 56.7143 58.296 56.7143Z"
        fill="#509EE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3672 29.7856C33.1621 29.7856 34.6172 28.3306 34.6172 26.5356C34.6172 24.7407 33.1621 23.2856 31.3672 23.2856C29.5723 23.2856 28.1172 24.7407 28.1172 26.5356C28.1172 28.3306 29.5723 29.7856 31.3672 29.7856Z"
        fill="#C2DAF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.6532 29.7856C42.4481 29.7856 43.9031 28.3306 43.9031 26.5356C43.9031 24.7407 42.4481 23.2856 40.6532 23.2856C38.8583 23.2856 37.4031 24.7407 37.4031 26.5356C37.4031 28.3306 38.8583 29.7856 40.6532 29.7856Z"
        fill="#C2DAF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.6532 20.4999C42.4481 20.4999 43.9031 19.0448 43.9031 17.2499C43.9031 15.455 42.4481 13.9999 40.6532 13.9999C38.8583 13.9999 37.4031 15.455 37.4031 17.2499C37.4031 19.0448 38.8583 20.4999 40.6532 20.4999Z"
        fill="#C2DAF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.6532 38.1428C42.4481 38.1428 43.9031 36.8956 43.9031 35.3571C43.9031 33.8186 42.4481 32.5714 40.6532 32.5714C38.8583 32.5714 37.4031 33.8186 37.4031 35.3571C37.4031 36.8956 38.8583 38.1428 40.6532 38.1428Z"
        fill="#C2DAF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.4744 29.7856C51.013 29.7856 52.2602 28.3306 52.2602 26.5356C52.2602 24.7407 51.013 23.2856 49.4744 23.2856C47.9359 23.2856 46.6887 24.7407 46.6887 26.5356C46.6887 28.3306 47.9359 29.7856 49.4744 29.7856Z"
        fill="#C2DAF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3672 47.4285C33.1621 47.4285 34.6172 45.9735 34.6172 44.1785C34.6172 42.3836 33.1621 40.9285 31.3672 40.9285C29.5723 40.9285 28.1172 42.3836 28.1172 44.1785C28.1172 45.9735 29.5723 47.4285 31.3672 47.4285Z"
        fill="#C2DAF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.4744 47.4285C51.013 47.4285 52.2602 45.9735 52.2602 44.1785C52.2602 42.3836 51.013 40.9285 49.4744 40.9285C47.9359 40.9285 46.6887 42.3836 46.6887 44.1785C46.6887 45.9735 47.9359 47.4285 49.4744 47.4285Z"
        fill="#C2DAF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3672 56.7143C33.1621 56.7143 34.6172 55.2593 34.6172 53.4643C34.6172 51.6694 33.1621 50.2143 31.3672 50.2143C29.5723 50.2143 28.1172 51.6694 28.1172 53.4643C28.1172 55.2593 29.5723 56.7143 31.3672 56.7143Z"
        fill="#C2DAF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.6532 56.7143C42.4481 56.7143 43.9031 55.2593 43.9031 53.4643C43.9031 51.6694 42.4481 50.2143 40.6532 50.2143C38.8583 50.2143 37.4031 51.6694 37.4031 53.4643C37.4031 55.2593 38.8583 56.7143 40.6532 56.7143Z"
        fill="#C2DAF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.6532 66C42.4481 66 43.9031 64.5449 43.9031 62.75C43.9031 60.955 42.4481 59.5 40.6532 59.5C38.8583 59.5 37.4031 60.955 37.4031 62.75C37.4031 64.5449 38.8583 66 40.6532 66Z"
        fill="#C2DAF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.4744 56.7143C51.013 56.7143 52.2602 55.2593 52.2602 53.4643C52.2602 51.6694 51.013 50.2143 49.4744 50.2143C47.9359 50.2143 46.6887 51.6694 46.6887 53.4643C46.6887 55.2593 47.9359 56.7143 49.4744 56.7143Z"
        fill="#C2DAF0"
      />
    </g>
    <defs>
      <clipPath id="clip0_metabase_webapp">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Teamwork = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M33.1147 33.9479C35.7819 33.9479 37.3177 32.5165 37.3177 30.0512C37.3985 27.9836 35.7819 26.2341 33.6804 26.1545C33.5188 26.1545 33.3571 26.1545 33.2763 26.1545H27.2143V21.7807C27.3759 19.3155 25.4361 17.0888 22.8496 17.0093C20.344 16.8502 18.0808 18.7588 18 21.3036C18 21.4626 18 21.7012 18 21.8602V52.2384C18 59.5547 20.9906 62.8151 27.6184 62.8151C30.1241 62.8947 32.6297 62.2585 34.812 61.0656C35.8628 60.4294 36.5094 59.2366 36.4286 58.0437C36.4286 56.0556 35.0545 53.9084 33.1955 53.9084C32.953 53.9084 32.6297 53.988 32.3872 54.0675L32.0639 54.2265C31.4173 54.5446 30.609 54.7832 29.8816 54.7832C28.6692 54.7832 27.2951 54.3856 27.2951 51.1251V33.9479H33.1147Z"
      fill="#1D1C39"
    />
    <path
      d="M52.9173 46.7513C48.4718 46.7513 44.8346 50.3299 44.8346 54.7037C44.8346 59.0775 48.4718 62.6561 52.9173 62.6561C57.3628 62.6561 61 59.0775 61 54.7037C61 50.3299 57.3628 46.7513 52.9173 46.7513Z"
      fill="#FF22B1"
    />
  </svg>
);

export const Nutshell = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M43.279 27.5087C43.1045 27.5011 42.9337 27.4562 42.7781 27.3769C42.6225 27.2977 42.4857 27.186 42.3769 27.0494C42.2682 26.9127 42.19 26.7544 42.1476 26.5849C42.1053 26.4155 42.0998 26.239 42.1315 26.0672L42.9692 21.6685C42.9833 21.6016 42.9909 21.5336 42.9917 21.4652C42.9917 20.5345 41.689 20.4152 40 20.4152C38.311 20.4152 37.0082 20.5367 37.0082 21.4652C37.0091 21.5336 37.0166 21.6016 37.0307 21.6685L37.8625 26.038C37.8946 26.2118 37.8885 26.3906 37.8448 26.5618C37.801 26.7331 37.7206 26.8928 37.609 27.03C37.4975 27.1671 37.3575 27.2784 37.1987 27.3562C37.04 27.4339 36.8662 27.4762 36.6895 27.4803C28.6142 27.7638 22.9172 30.4053 22.9172 35.2315V37.0855C22.917 37.2022 22.9399 37.3179 22.9844 37.4258C23.0289 37.5337 23.0943 37.6318 23.1768 37.7144C23.2593 37.797 23.3572 37.8625 23.4651 37.9073C23.5729 37.952 23.6885 37.975 23.8052 37.975H38.5C39.082 37.975 39.388 38.4032 39.388 38.8622C39.3913 39.062 39.3215 39.256 39.1918 39.4079C39.0622 39.5598 38.8815 39.6591 38.6837 39.6872L27.7847 41.8C27.3565 41.8615 27.0812 42.2282 27.0812 42.6572V46.3923C27.0812 53.5555 32.6837 59.587 40 59.587C47.164 59.587 52.9502 53.77 52.9502 46.6367V38.8308C52.951 38.7159 52.9747 38.6024 53.0199 38.4968C53.0652 38.3913 53.1311 38.2958 53.2137 38.2161C53.2964 38.1364 53.3941 38.074 53.5013 38.0326C53.6084 37.9912 53.7227 37.9716 53.8375 37.975H56.1947C56.4303 37.975 56.6561 37.8814 56.8226 37.7149C56.9892 37.5484 57.0827 37.3225 57.0827 37.087V35.2315C57.0827 30.3955 51.3842 27.9415 43.279 27.5087Z"
      fill="#FE5800"
    />
  </svg>
);

export const CatsAts = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <defs>
      <linearGradient
        id="catsAts-linearGradient-0"
        x1="22.1985"
        y1="12.3506"
        x2="87.7552"
        y2="53.3139"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.04" stopColor="#50BFEE" />
        <stop offset="0.9" stopColor="#4C2B6E" />
      </linearGradient>
      <linearGradient
        id="catsAts-linearGradient-1"
        x1="14.7749"
        y1="24.2291"
        x2="80.3279"
        y2="65.1961"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.04" stopColor="#50BFEE" />
        <stop offset="0.9" stopColor="#4C2B6E" />
      </linearGradient>
      <linearGradient
        id="catsAts-linearGradient-2"
        x1="7.34757"
        y1="36.1113"
        x2="72.9042"
        y2="77.0747"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.04" stopColor="#50BFEE" />
        <stop offset="0.9" stopColor="#4C2B6E" />
      </linearGradient>
    </defs>
    <path
      d="M66.8207 41.4974C65.7508 39.7958 63.9542 38.6857 61.9532 38.4849C59.8572 38.2658 57.8123 36.188 56.5927 34.2563L56.0632 33.4165L52.8498 28.2751L52.3276 27.4315C51.1263 25.4889 50.155 22.7393 50.878 20.7601C51.5754 18.8759 51.3636 16.7726 50.3047 15.0637C49.4466 13.6615 48.0809 12.6427 46.4924 12.2191H46.4815C46.3865 12.1935 46.2916 12.1716 46.193 12.1497C45.7439 12.0511 45.2838 12 44.8237 12C44.1299 12 43.4434 12.1132 42.7897 12.3359L42.7678 12.3432C42.6838 12.3725 42.5999 12.4017 42.5195 12.4345C42.4574 12.4564 42.399 12.4857 42.3369 12.5112L42.2895 12.5331C42.2237 12.5623 42.158 12.5916 42.0923 12.6244L42.074 12.6354C41.9316 12.7048 41.7892 12.7778 41.6504 12.8581C41.592 12.891 41.5336 12.9275 41.4788 12.9604L41.4533 12.975L41.3912 13.0151C41.3437 13.0443 41.2999 13.0736 41.2524 13.1028C41.1246 13.1904 41.0005 13.2817 40.88 13.3766L40.8435 13.4059C40.7923 13.446 40.7412 13.4898 40.6901 13.53L40.6244 13.5848C40.5842 13.6213 40.5404 13.6578 40.5002 13.6943C40.4308 13.7564 40.3651 13.8221 40.2994 13.8879C39.8064 14.3845 39.4011 14.9541 39.0943 15.5822C38.8935 15.9948 38.7365 16.433 38.6269 16.8785C38.6014 16.9771 38.5831 17.0757 38.5612 17.1779C38.2435 18.7956 38.5612 20.4716 39.4486 21.8556C40.5185 23.5572 42.315 24.6673 44.3161 24.8681C46.4121 25.0872 48.457 27.165 49.6766 29.0967L50.2061 29.9365L53.4158 35.0743L53.938 35.9178C55.1394 37.8604 56.1107 40.6101 55.3877 42.5892C54.6902 44.4734 54.902 46.5767 55.961 48.2857C56.8191 49.6879 58.1848 50.7067 59.7732 51.1302H59.7769C59.8754 51.1558 59.974 51.1814 60.0726 51.2033C60.5218 51.3019 60.9819 51.353 61.442 51.353C62.1394 51.353 62.8296 51.2361 63.4905 51.0134C63.5781 50.9805 63.6658 50.9513 63.7498 50.9185C63.8009 50.9002 63.852 50.8783 63.9031 50.8564L63.9835 50.8235C64.0455 50.798 64.104 50.7687 64.1624 50.7432L64.2062 50.7213C64.345 50.6555 64.4837 50.5825 64.6188 50.5058C64.6663 50.4766 64.7138 50.451 64.7576 50.4218L64.8197 50.3853L64.8452 50.3707C64.9037 50.3342 64.9584 50.2977 65.0132 50.2612C65.1483 50.1699 65.2761 50.0749 65.4003 49.9763L65.4185 49.9617C65.4733 49.9179 65.5317 49.8704 65.5865 49.823L65.6267 49.7901C65.6778 49.7463 65.7253 49.7025 65.7727 49.6587C65.8385 49.6002 65.9005 49.5382 65.9626 49.4761L65.9809 49.4578C66.4702 48.9649 66.8719 48.3989 67.1749 47.7744C67.3758 47.3618 67.5328 46.9236 67.6423 46.4781C67.6642 46.3832 67.6862 46.2846 67.7044 46.1897V46.1787C68.0221 44.5647 67.7044 42.8886 66.8171 41.5047L66.8207 41.4974Z"
      fill="url(#catsAts-linearGradient-0)"
    />
    <path
      d="M58.7544 58.0025C57.6845 56.3009 55.8879 55.1908 53.8869 54.99C51.7909 54.7709 49.746 52.6931 48.5264 50.7614L47.9969 49.9216L34.4788 28.2897L33.9566 27.4462C32.7552 25.5035 31.7839 22.7539 32.5069 20.7747C33.2044 18.8905 32.9926 16.7872 31.9336 15.0783C31.0755 13.6761 29.7098 12.6573 28.1214 12.2337H28.1104C28.0155 12.2081 27.9205 12.1862 27.8219 12.1643C27.3728 12.0657 26.9127 12.0146 26.4526 12.0146C25.7588 12.0146 25.0723 12.1278 24.4187 12.3506L24.3968 12.3579C24.3128 12.3871 24.2288 12.4163 24.1485 12.4491C24.0864 12.4711 24.028 12.5003 23.9659 12.5258L23.9184 12.5477C23.8527 12.577 23.787 12.6062 23.7212 12.639L23.703 12.65C23.5606 12.7194 23.4181 12.7924 23.2794 12.8727C23.221 12.9056 23.1625 12.9421 23.1078 12.975L23.0822 12.9896L23.0201 13.0297C22.9727 13.059 22.9288 13.0882 22.8814 13.1174C22.7536 13.205 22.6294 13.2963 22.5089 13.3913L22.4724 13.4205C22.4213 13.4606 22.3701 13.5045 22.319 13.5446L22.2533 13.5994C22.2131 13.6359 22.1693 13.6724 22.1291 13.7089C22.0598 13.771 21.994 13.8367 21.9283 13.9025C21.4353 14.3991 21.03 14.9687 20.7233 15.5968C20.5225 16.0094 20.3654 16.4476 20.2559 16.8931C20.2303 16.9917 20.2121 17.0903 20.1902 17.1925C19.8725 18.8102 20.1902 20.4863 21.0775 21.8702C22.1474 23.5718 23.944 24.6819 25.945 24.8828C28.041 25.1018 30.0859 27.1796 31.3055 29.1113L31.835 29.9511L45.3495 51.5794L45.8717 52.4229C47.073 54.3655 48.0443 57.1152 47.3213 59.0943C46.6239 60.9785 46.8357 63.0818 47.8946 64.7908C48.7528 66.193 50.1184 67.2118 51.7069 67.6354H51.7105C51.8091 67.6609 51.9077 67.6865 52.0063 67.7084C52.4554 67.807 52.9155 67.8581 53.3756 67.8581C54.0731 67.8581 54.7632 67.7412 55.4242 67.5185C55.5118 67.4856 55.5995 67.4564 55.6834 67.4236C55.7346 67.4053 55.7857 67.3834 55.8368 67.3615L55.9171 67.3286C55.9792 67.3031 56.0376 67.2738 56.0961 67.2483L56.1399 67.2264C56.2786 67.1606 56.4174 67.0876 56.5525 67.0109C56.6 66.9817 56.6475 66.9562 56.6913 66.9269L56.7533 66.8904L56.7789 66.8758C56.8373 66.8393 56.8921 66.8028 56.9469 66.7663C57.082 66.675 57.2098 66.5801 57.3339 66.4815L57.3522 66.4668C57.407 66.423 57.4654 66.3756 57.5202 66.3281L57.5603 66.2952C57.6115 66.2514 57.6589 66.2076 57.7064 66.1638C57.7721 66.1053 57.8342 66.0433 57.8963 65.9812L57.9145 65.9629C58.4039 65.47 58.8055 64.904 59.1086 64.2796C59.3094 63.8669 59.4665 63.4287 59.576 62.9833C59.5979 62.8883 59.6198 62.7897 59.6381 62.6948V62.6838C59.9558 61.0698 59.6381 59.3938 58.7508 58.0098L58.7544 58.0025Z"
      fill="url(#catsAts-linearGradient-1)"
    />
    <path
      d="M40.3797 58.0208C39.3098 56.3191 37.5132 55.2091 35.5122 55.0082C33.4161 54.7891 31.3713 52.7114 30.1516 50.7797L29.6222 49.9398L26.4088 44.7984L25.8866 43.9549C24.6852 42.0123 23.7139 39.2626 24.4369 37.2835C25.1344 35.3993 24.9226 33.296 23.8636 31.587C23.0055 30.1848 21.6398 29.166 20.0514 28.7425H20.0404C19.9455 28.7169 19.8506 28.695 19.752 28.6731C19.3028 28.5745 18.8427 28.5234 18.3826 28.5234C17.6888 28.5234 17.0023 28.6366 16.3487 28.8593L16.3268 28.8666C16.2428 28.8958 16.1588 28.925 16.0785 28.9579C16.0164 28.9798 15.958 29.009 15.8959 29.0346L15.8484 29.0565C15.7827 29.0857 15.717 29.1149 15.6513 29.1478L15.633 29.1587C15.4906 29.2281 15.3482 29.3011 15.2094 29.3815C15.151 29.4143 15.0926 29.4509 15.0378 29.4837L15.0122 29.4983L14.9501 29.5385C14.9027 29.5677 14.8589 29.5969 14.8114 29.6261C14.6836 29.7138 14.5594 29.8051 14.4389 29.9L14.4024 29.9292C14.3513 29.9694 14.3002 30.0132 14.249 30.0534L14.1833 30.1118C14.1432 30.1483 14.0993 30.1848 14.0592 30.2213C13.9898 30.2834 13.9241 30.3491 13.8583 30.4149C13.3654 30.9115 12.96 31.4811 12.6533 32.1092C12.4525 32.5218 12.2955 32.96 12.1859 33.4055C12.1603 33.5041 12.1421 33.6027 12.1202 33.7049C11.8025 35.3226 12.1202 36.9987 13.0075 38.3826C14.0774 40.0842 15.874 41.1943 17.8751 41.3952C19.9711 41.6142 22.0159 43.692 23.2356 45.6237L23.765 46.4635L26.9748 51.6013L27.497 52.4448C28.6983 54.3874 29.6696 57.1371 28.9466 59.1162C28.2492 61.0004 28.461 63.1038 29.5199 64.8127C30.378 66.2149 31.7437 67.2337 33.3322 67.6573H33.3358C33.4344 67.6828 33.533 67.7084 33.6316 67.7303C34.0807 67.8289 34.5408 67.88 35.0009 67.88C35.6984 67.88 36.3885 67.7632 37.0495 67.5404C37.1371 67.5075 37.2247 67.4783 37.3087 67.4455C37.3598 67.4272 37.411 67.4053 37.4621 67.3834L37.5424 67.3505C37.6045 67.325 37.6629 67.2958 37.7213 67.2702L37.7652 67.2483C37.9039 67.1826 38.0427 67.1095 38.1778 67.0328C38.2253 67.0036 38.2727 66.9781 38.3166 66.9489L38.3786 66.9123L38.4042 66.8977C38.4626 66.8612 38.5174 66.8247 38.5722 66.7882C38.7073 66.6969 38.8351 66.602 38.9592 66.5034L38.9775 66.4888C39.0323 66.4449 39.0907 66.3975 39.1455 66.35L39.1856 66.3171C39.2368 66.2733 39.2842 66.2295 39.3317 66.1857C39.3974 66.1273 39.4595 66.0652 39.5216 66.0031L39.5398 65.9848C40.0291 65.4919 40.4308 64.9259 40.7339 64.3015C40.9347 63.8888 41.0918 63.4507 41.2013 63.0052C41.2232 62.9102 41.2451 62.8116 41.2634 62.7167V62.7057C41.5811 61.0917 41.2634 59.4157 40.376 58.0317L40.3797 58.0208Z"
      fill="url(#catsAts-linearGradient-2)"
    />
  </svg>
);

export const Pipeliner = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M25.6515 40.7035C25.6515 36.3622 26.5545 32.1947 28.1521 28.4438C26.485 29.6941 24.6444 31.7084 23.2204 33.7575C21.6576 36.1191 20.442 38.7933 19.7127 41.6759C17.6984 49.4206 19.1223 57.4085 23.4635 62.4443L23.7414 62.7569C26.5545 62.3749 29.576 61.6455 32.7711 60.4995C28.291 55.1511 25.6515 48.2398 25.6515 40.7035Z"
      fill="#F26648"
    />
    <path
      d="M41.523 25.3876C42.426 28.1313 40.5158 35.0772 28.7772 40.9466C31.4861 40.5298 34.6465 39.4879 37.9806 37.8209C47.4965 33.0282 54.8592 24.8667 54.4425 19.5877C54.0257 14.3088 46.0031 13.8573 36.5219 18.65C30.7915 21.5673 25.8599 24.9361 21.4839 28.8953C12.35 36.9874 6.48063 46.4686 7.0363 53.7271C7.48779 59.4576 11.8637 62.618 18.4624 63C14.4685 56.7139 13.8086 47.441 17.4205 38.7933C18.775 35.5982 20.5462 32.7851 22.63 30.4582C24.8527 28.0618 27.4227 26.1169 29.4718 25.0056C35.4453 21.9146 40.4811 22.1578 41.523 25.3876Z"
      fill="#005895"
    />
    <path
      d="M69.4805 22.3314C68.9595 15.5938 63.0208 12.3987 54.4425 13.0933C58.6795 13.7184 61.4232 16.0106 61.701 19.935C62.3262 28.0618 52.2892 39.9394 39.3003 46.4686C36.4177 47.9273 33.6046 48.9692 30.9999 49.6638C32.4238 53.0673 34.4034 56.1582 36.8692 58.8324C37.8069 58.4157 38.7793 57.9642 39.7518 57.478C57.0125 48.865 70.314 33.0976 69.4805 22.3314Z"
      fill="#005895"
    />
  </svg>
);

export const Salesflare = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.3096 24C33.972 24 30.4557 27.4698 30.4557 31.75C30.4557 33.9356 28.9386 36.9167 26.7237 36.9167H23.1628C18.1023 36.9167 14 40.9647 14 45.9583C14 50.952 18.1023 55 23.1628 55H43.0144C48.0748 55 52.1772 50.952 52.1772 45.9583C52.1772 43.3271 54.0513 39.5 56.7178 39.5H58.1462C62.4837 39.5 66 36.0302 66 31.75C66 27.4698 62.4837 24 58.1462 24H38.3096Z"
      fill="#0053FF"
    />
  </svg>
);

export const VtigerCrm = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M26.8685 31C21.9675 31 18 34.9708 18 39.8772C18 44.7837 21.9675 48.7545 26.8685 48.7545C27.3936 48.7545 27.8953 48.7088 28.3971 48.6175C30.1241 52.942 34.3483 56 39.2843 56C43.8936 56 47.8727 53.3414 49.7864 49.4733C48.8062 49.2793 47.8727 48.9484 46.9975 48.4692C45.5039 51.2077 42.61 53.0675 39.2843 53.0675C35.6319 53.0675 32.4813 50.8197 31.1627 47.6362C30.8826 46.9744 30.6959 46.267 30.5909 45.5367C30.5909 45.5367 30.5909 45.5367 30.5909 45.5253C30.5325 45.2287 30.2758 45.0119 29.9607 45.0119C29.8791 45.0119 29.8091 45.0233 29.739 45.0575C29.6807 45.0917 29.634 45.1146 29.5757 45.1488C28.9806 45.4569 28.3388 45.6623 27.6503 45.7535C27.3936 45.7878 27.1252 45.8106 26.8568 45.8106C23.5778 45.8106 20.9173 43.1406 20.9173 39.8658C20.9173 36.5911 23.5778 33.921 26.8568 33.921C27.1252 33.921 27.3936 33.9439 27.6503 33.9781C28.7122 34.1264 29.6807 34.5486 30.4859 35.1762C30.7309 35.3587 30.9526 35.5755 31.1627 35.7923C31.6411 36.2944 32.0145 36.8763 32.2946 37.5153C32.3062 37.5381 32.3179 37.5723 32.3296 37.5952C32.4346 37.8005 32.6446 37.9489 32.9013 37.9489C33.0764 37.9489 33.2397 37.8804 33.3564 37.7663C33.8699 37.2871 34.4417 36.8763 35.0718 36.534C36.3204 35.8494 37.7557 35.4614 39.2726 35.4614C40.7896 35.4614 42.2249 35.8494 43.4735 36.534C44.407 37.0361 45.2238 37.7093 45.9123 38.508C46.274 38.9302 46.6008 39.3752 46.8808 39.8658C47.476 40.8813 47.861 42.0338 48.0011 43.2547C48.0127 43.2661 48.0244 43.2889 48.0477 43.3003C48.2228 43.4943 48.4211 43.6654 48.6195 43.8252C49.308 44.3615 50.1132 44.7038 50.9767 44.8293C50.9883 44.6467 51 44.4528 51 44.2702C51 42.7184 50.6966 41.2351 50.1482 39.8772C49.6347 38.6107 48.9112 37.4582 48.0127 36.4541C47.8144 36.2259 47.6043 36.0091 47.3826 35.8037C46.6708 35.1191 45.8773 34.5372 45.0138 34.0466C43.3218 33.0881 41.3614 32.5518 39.2843 32.5518C37.1955 32.5518 35.2468 33.0995 33.5548 34.0466C32.878 33.2707 32.0728 32.6203 31.1627 32.1182C30.3108 31.6504 29.389 31.3195 28.3971 31.1369C27.907 31.0571 27.3936 31 26.8685 31Z"
      fill="url(#vtiger_webapp_paint0)"
    />
    <path
      d="M39.7198 24C35.1089 24 31.1284 26.6598 29.214 30.5297C30.1946 30.7237 31.1284 31.0548 32.0039 31.5342C33.4981 28.7945 36.393 26.9338 39.7198 26.9338C43.3735 26.9338 46.5253 29.1826 47.8444 32.3676C48.1245 33.0297 48.3113 33.7374 48.4163 34.468C48.4747 34.7648 48.7315 34.9817 49.0467 34.9817C49.1284 34.9817 49.1984 34.9703 49.2685 34.9361C49.3268 34.9018 49.3735 34.879 49.4319 34.8447C50.0272 34.5365 50.6693 34.3311 51.358 34.2397C51.6148 34.2055 51.8833 34.1826 52.1517 34.1826C55.4319 34.1826 58.0934 36.8539 58.0934 40.1301C58.0934 43.4064 55.4319 46.0776 52.1517 46.0776C51.8833 46.0776 51.6148 46.0548 51.358 46.0205C50.2957 45.8721 49.3268 45.4498 48.5214 44.8219C48.2763 44.6279 48.0545 44.4224 47.8444 44.2055C47.3658 43.7032 46.9922 43.121 46.7121 42.4817C46.7004 42.4589 46.6887 42.4247 46.677 42.4018C46.572 42.1963 46.3619 42.0479 46.1051 42.0479C45.93 42.0479 45.7665 42.1164 45.6498 42.2306C45.1362 42.71 44.5642 43.121 43.9339 43.4635C42.6848 44.1484 41.249 44.5365 39.7315 44.5365C38.214 44.5365 36.7782 44.1484 35.5292 43.4635C34.5953 42.9612 33.7782 42.2877 33.0895 41.4886C32.7276 41.0662 32.4008 40.621 32.1206 40.1301C31.5253 39.1142 31.1401 37.9612 31 36.7397C30.9883 36.7283 30.9767 36.7055 30.9533 36.6941C30.7782 36.5 30.5798 36.3288 30.3813 36.169C29.6926 35.6324 28.8872 35.29 28.0233 35.1644C28.0117 35.347 28 35.5411 28 35.7237C28 37.2763 28.3035 38.7603 28.8521 40.1187C29.3658 41.3858 30.0895 42.5388 30.9883 43.5434C31.1868 43.7717 31.3969 43.9886 31.6187 44.1941C32.3307 44.879 33.1245 45.4726 33.9883 45.9521C35.6809 46.911 37.642 47.4475 39.7198 47.4475C41.8093 47.4475 43.7588 46.8995 45.4514 45.9521C46.1284 46.7283 46.9339 47.379 47.8327 47.8813C48.6848 48.3493 49.607 48.6918 50.5992 48.863C51.1012 48.9543 51.6031 49 52.1284 49C57.0311 49 61 45.0274 61 40.1187C61 35.2215 57.0311 31.2374 52.1284 31.2374C51.6031 31.2374 51.0895 31.2831 50.5992 31.3744C48.8949 27.0594 44.6693 24 39.7198 24Z"
      fill="url(#vtiger_webapp_paint1)"
    />
    <defs>
      <linearGradient
        id="vtiger_webapp_paint0"
        x1="17.9999"
        y1="43.5029"
        x2="51.0093"
        y2="43.5029"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="5.32779e-08" stopColor="#0658D4" />
        <stop offset="1" stopColor="#2C7EF9" />
      </linearGradient>
      <linearGradient
        id="vtiger_webapp_paint1"
        x1="65.3316"
        y1="46.4621"
        x2="37.9304"
        y2="34.4538"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1.11884e-07" stopColor="#198852" />
        <stop offset="1" stopColor="#43B476" />
      </linearGradient>
    </defs>
  </svg>
);

export const Freshservice = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M19.2631 43.1127C19.8768 47.5846 21.9812 51.618 25.1378 54.8622L32.2401 47.7599C32.2401 40.2192 36.1858 33.38 42.6743 29.5219L19.2631 43.1127Z"
      fill="#9B65C3"
    />
    <path
      d="M32.3278 47.6722C28.6451 47.6722 25.0501 46.7077 21.8935 44.8664C21.0167 44.3403 20.1399 43.7265 19.2631 43.1127C19.8768 47.5845 21.9812 51.618 25.1378 54.8622L32.3278 47.6722Z"
      fill="#9B65C3"
    />
    <path
      d="M32.3278 47.6722L25.1378 54.8622C28.3821 58.1065 32.4155 60.1232 36.7996 60.7369L50.3904 37.238C46.7078 43.6388 39.7808 47.6722 32.3278 47.6722Z"
      fill="#BE63C5"
    />
    <path
      d="M35.1336 58.1942C33.2923 54.9499 32.3278 51.4426 32.3278 47.7599L25.1378 54.8622C28.3821 58.1065 32.4155 60.1232 36.7996 60.737C36.2735 59.8601 35.6597 59.071 35.1336 58.1942Z"
      fill="#BF63C6"
    />
    <path
      d="M59.071 20.1399L42.762 29.4342C36.2735 33.1169 28.382 33.1169 21.8058 29.4342C19.9645 32.6785 19 36.3612 19 40.0438C19 41.0084 19.0877 42.1482 19.263 43.1127C20.1399 43.7265 21.0167 44.3403 21.8935 44.8664C25.1378 46.7077 28.6451 47.6722 32.3278 47.6722L59.4217 20.5783C59.2463 20.4906 59.1587 20.3152 59.071 20.1399Z"
      fill="#3278B1"
    />
    <path
      d="M21.8059 44.8664C25.0501 46.7077 28.5574 47.6722 32.2401 47.6722C32.2401 40.1315 36.1858 33.2923 42.6743 29.4342L19.2631 43.025C20.1399 43.7265 20.929 44.3403 21.8059 44.8664Z"
      fill="#3278B2"
    />
    <path
      d="M21.8058 29.4342C19.9645 32.6785 19 36.3612 19 40.0438C19 41.0083 19.0877 42.1482 19.263 43.1127L42.762 29.4342C36.3612 33.2923 28.382 33.2923 21.8058 29.4342Z"
      fill="#45A4EC"
    />
    <path
      d="M59.4217 20.5783C59.071 20.2276 58.8079 19.9645 58.4572 19.7015C57.6681 19.263 56.7035 19 55.8267 19H39.9562C32.4154 19 25.4885 23.0334 21.8058 29.4342C28.2944 33.1169 36.1858 33.1169 42.762 29.4342C36.2735 33.1169 32.3278 40.1315 32.3278 47.6722C39.8685 47.6722 46.7077 43.7265 50.5658 37.238L59.8601 20.929C59.6848 20.8413 59.5094 20.7537 59.4217 20.5783Z"
      fill="#19BB7D"
    />
    <path
      d="M42.762 29.4342L59.071 20.1399C58.8079 20.0522 58.7202 19.7891 58.4572 19.6138L21.8058 29.4342C28.382 33.2923 36.3612 33.2923 42.762 29.4342Z"
      fill="#08C7FB"
    />
    <path
      d="M55.739 19H39.9562C32.4154 19 25.4885 23.0334 21.8058 29.4342L58.4572 19.6138C57.5804 19.263 56.7036 19 55.739 19Z"
      fill="#59F2F6"
    />
    <path
      d="M50.5658 37.238L59.8601 20.929C59.7725 20.8413 59.5971 20.666 59.5094 20.4029L32.4155 47.5845C32.4155 51.2672 33.38 54.8622 35.2213 58.0188C35.7474 58.8956 36.3612 59.7724 36.975 60.6493C37.9395 60.737 38.904 60.9123 39.9562 60.9123C43.6388 60.9123 47.2338 59.9478 50.3904 58.1065C46.7077 51.618 46.7077 43.6388 50.5658 37.238Z"
      fill="#DA3757"
    />
    <path
      d="M32.3278 47.6722C32.3278 51.3549 33.2923 54.9499 35.1336 58.1065C35.6597 58.9833 36.2735 59.8601 36.8873 60.7369L50.4781 37.238C46.7077 43.6388 39.7808 47.6722 32.3278 47.6722Z"
      fill="#D33C4E"
    />
    <path
      d="M50.5658 37.238L36.975 60.7369C37.9395 60.8246 38.904 61 40.0439 61C43.7265 61 47.3215 60.0355 50.4781 58.1941C46.7078 51.6179 46.7078 43.6388 50.5658 37.238Z"
      fill="#EE5A24"
    />
    <path
      d="M60.2985 21.6305C59.9478 21.0167 59.5971 20.4906 59.071 20.1399L42.762 29.4342C36.2735 33.1169 32.3278 40.1315 32.3278 47.6722C39.8685 47.6722 46.7077 43.7265 50.5658 37.238C46.8831 43.7265 46.8831 51.618 50.5658 58.1942C56.9666 54.5115 61 47.5846 61 40.2192V24.261C61 23.2965 60.7369 22.4196 60.2985 21.6305Z"
      fill="#8BDF55"
    />
    <path
      d="M59.071 20.1399L42.762 29.4342C36.2735 33.1169 32.3278 40.1315 32.3278 47.6722L59.4217 20.5783C59.2463 20.4906 59.1587 20.2276 59.071 20.1399Z"
      fill="#25C16F"
    />
    <path
      d="M32.3278 47.6722C39.8685 47.6722 46.7077 43.7265 50.5658 37.238L59.8601 20.929C59.7724 20.8413 59.5971 20.666 59.5094 20.4029L32.3278 47.6722Z"
      fill="#8BDF55"
    />
    <path
      d="M59.8601 20.929L50.5658 37.238C46.8831 43.7265 46.8831 51.6179 50.5658 58.1941L60.3862 21.6305C60.1232 21.3674 60.0355 21.1921 59.8601 20.929Z"
      fill="#FFBB00"
    />
    <path
      d="M50.5657 58.1942C57.0543 54.5115 61 47.5846 61 40.0438V24.261C61 23.2965 60.7369 22.4196 60.2985 21.5428L50.5657 58.1942Z"
      fill="#FFA800"
    />
  </svg>
);

export const Aircall = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M49.3113 22.7525C47.3425 22.2975 44.1076 22 40.4501 22C36.7926 22 33.5569 22.2975 31.589 22.7525C27.6638 23.5785 24.5741 26.6777 23.7508 30.6135C23.2958 32.5875 23 35.832 23 39.5C23 43.168 23.2966 46.4125 23.7508 48.3865C24.5741 52.3223 27.6646 55.4215 31.589 56.2475C33.5578 56.7025 36.7926 57 40.4501 57C44.1076 57 47.3434 56.7025 49.3113 56.2475C53.2356 55.4215 56.3261 52.3223 57.1495 48.3865C57.6045 46.4125 57.9003 43.168 57.9003 39.5C57.9003 35.832 57.6036 32.5875 57.1495 30.6135C56.3261 26.6777 53.2356 23.5785 49.3113 22.7525Z"
      fill="#00BD82"
    />
    <path
      d="M44.6432 48.8669C44.4782 48.4725 44.2201 48.124 43.8909 47.8512C43.5618 47.5785 43.1714 47.3895 42.7532 47.3006C42.2422 47.1825 41.4005 47.1055 40.4502 47.1055C39.4991 47.1055 38.6574 47.1825 38.1464 47.3015C37.2976 47.48 36.5976 48.068 36.2642 48.8502C36.1479 49.1215 35.8705 49.2869 35.5765 49.2597C35.5138 49.2541 35.451 49.2483 35.3884 49.2422C34.0199 49.1049 32.9445 48.9141 32.3197 48.6919C32.0843 48.6042 31.8856 48.4393 31.7559 48.2241C31.6262 48.009 31.5733 47.7562 31.6057 47.5071C31.7116 46.0791 32.577 42.7349 33.8685 38.9181C35.3455 34.5545 36.8907 31.0221 37.5872 30.3335C37.7525 30.1605 37.9568 30.0297 38.1831 29.952C38.6407 29.7971 39.4842 29.693 40.4494 29.693C41.4154 29.693 42.2589 29.7971 42.7156 29.952L42.7235 29.9546C42.9473 30.0325 43.1494 30.1623 43.3132 30.3335C44.0097 31.0221 45.5541 34.5545 47.0311 38.9172C48.3235 42.7349 49.188 46.0791 49.2947 47.5071C49.2947 47.5185 49.2947 47.5307 49.2965 47.543L49.2982 47.5561C49.2997 47.5876 49.3008 47.6191 49.3017 47.6506C49.3019 47.8769 49.2329 48.0979 49.1041 48.284C48.9752 48.4701 48.7926 48.6124 48.5807 48.6919C47.956 48.9141 46.8815 49.1049 45.5147 49.2414L45.2995 49.2615C45.1625 49.2741 45.025 49.2427 44.907 49.1719C44.789 49.1011 44.6966 48.9937 44.6432 48.8669Z"
      fill="white"
    />
  </svg>
);

export const NimbleCrm = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#0393CF"
    />
    <path
      d="M42.1397 34.9535L32.3522 31.1362C32.3522 31.1362 30.9406 32.1604 30.2818 33.7431C29.623 35.3259 29.9054 36.9086 29.9054 36.9086L42.1397 41.6569L33.1051 54.319C33.1051 54.319 33.858 55.9948 35.2697 56.9259C36.6813 57.8569 38.2812 57.95 38.2812 57.95L47.3158 45.1948L56.4445 57.95C56.4445 57.95 58.2326 57.7638 59.456 56.9259C60.6795 55.9948 61.5265 54.319 61.5265 54.319L52.4919 41.6569L64.8203 36.8155C64.8203 36.8155 65.0085 34.7673 64.3498 33.3707C63.7851 32.0673 62.3735 30.95 62.3735 30.95L52.3977 34.9535"
      stroke="white"
      strokeWidth="2.4272"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.8452 29.95V22.8614C43.8452 22.8614 44.9945 21.95 47.1885 21.95C49.3825 21.95 50.8452 22.9627 50.8452 22.9627V29.8487"
      stroke="white"
      strokeWidth="2.4272"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.7723 31.9813L25.2922 30.95C25.2922 30.95 23.9143 31.9813 23.2713 33.575C22.6283 35.1688 22.9039 36.7625 22.9039 36.7625L34.8452 41.5438L26.027 54.2938C26.027 54.2938 26.7619 55.9813 28.1397 56.9188C29.5176 57.8563 31.0791 57.95 31.0791 57.95"
      stroke="#FAA51A"
      strokeWidth="1.1638"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.8452 28.95V22.8014C36.8452 22.8014 37.7814 21.95 39.5686 21.95C40.4197 21.95 40.8452 22.1392 40.8452 22.1392"
      stroke="#FAA51A"
      strokeWidth="1.1638"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.8452 28.95V22.8765C29.8452 22.8765 30.7814 21.95 32.5686 21.95C33.4197 21.95 33.8452 22.1559 33.8452 22.1559"
      stroke="#FAA51A"
      strokeWidth="1.1638"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5886 31.8875L18.2922 30.95C18.2922 30.95 16.9143 31.9813 16.2713 33.575C15.6283 35.1688 15.9039 36.7625 15.9039 36.7625L27.8452 41.5438L18.9352 54.2938C18.9352 54.2938 19.67 55.9813 21.0479 56.9188C22.4257 57.8563 23.9873 57.95 23.9873 57.95"
      stroke="#FAA51A"
      strokeWidth="1.1638"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Hive = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M43.7874 55H50.1425C51.8499 55 53.25 53.3124 53.25 51.2499C53.25 49.1875 51.8499 47.5 50.1425 47.5H30.1075C28.4 47.5 27 49.1875 27 51.2499C27 53.3124 28.4 55 30.1075 55H36.7125C36.9701 54.2675 37.4489 53.6331 38.0826 53.1843C38.7162 52.7354 39.4735 52.4943 40.2499 52.4943C41.0265 52.4943 41.7838 52.7354 42.4174 53.1843C43.0511 53.6331 43.5297 54.2675 43.7874 55ZM50.1425 32.5H30.1075C28.4 32.5 27 30.8125 27 28.75C27 26.6875 28.4 25 30.1075 25H50.1425C51.8499 25 53.25 26.6875 53.25 28.75C53.25 30.8125 51.8499 32.5 50.1425 32.5ZM23.5125 43.75C21.58 43.75 20 42.0625 20 40C20 37.9375 21.58 36.25 23.5125 36.25H56.4999C58.42 36.25 59.9999 37.9375 59.9999 40C59.9999 42.0625 58.42 43.75 56.4999 43.75H23.5125Z"
      fill="url(#hive_paint0_webapp)"
    />
    <defs>
      <linearGradient
        id="hive_paint0_webapp"
        x1="20.05"
        y1="39.95"
        x2="60.05"
        y2="39.95"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBC67A" />
        <stop offset="1" stopColor="#FFA561" />
      </linearGradient>
    </defs>
  </svg>
);

export const Drip = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M55.6192 43.8745H50.9874C50.9874 44.046 50.9874 44.2176 50.9874 44.3891C50.9874 51.2511 45.3264 55.3682 40.1799 55.3682C35.0335 55.3682 29.3724 51.2511 29.3724 44.3891C29.3724 44.2176 29.3724 44.046 29.3724 43.8745H24.7406C24.7406 44.046 24.7406 44.2176 24.7406 44.3891C24.7406 53.8243 32.4603 60 40.1799 60C47.8996 60 55.6192 53.8243 55.6192 44.3891C55.6192 44.2176 55.6192 44.046 55.6192 43.8745Z"
      fill="black"
    />
    <path
      d="M40.1799 24.8326L43.4393 29.2929H49.272C46.5272 25.6904 43.6109 22.0879 40.1799 19C36.749 22.0879 33.8326 25.6904 31.0879 29.2929H36.9205L40.1799 24.8326Z"
      fill="black"
    />
    <path
      d="M30.9163 39.7573C32.6217 39.7573 34.0042 38.3749 34.0042 36.6695C34.0042 34.9641 32.6217 33.5816 30.9163 33.5816C29.2109 33.5816 27.8285 34.9641 27.8285 36.6695C27.8285 38.3749 29.2109 39.7573 30.9163 39.7573Z"
      fill="black"
    />
    <path
      d="M40.1799 39.7574C41.8853 39.7574 43.2678 38.3749 43.2678 36.6695C43.2678 34.9641 41.8853 33.5816 40.1799 33.5816C38.4745 33.5816 37.092 34.9641 37.092 36.6695C37.092 38.3749 38.4745 39.7574 40.1799 39.7574Z"
      fill="black"
    />
    <path
      d="M49.4435 39.7574C51.1489 39.7574 52.5314 38.3749 52.5314 36.6695C52.5314 34.9641 51.1489 33.5816 49.4435 33.5816C47.7381 33.5816 46.3557 34.9641 46.3557 36.6695C46.3557 38.3749 47.7381 39.7574 49.4435 39.7574Z"
      fill="black"
    />
  </svg>
);

export const Checkout = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M53.5489 22H26.3516C23.9582 22 22 23.9091 22 26.2424V52.7576C22 55.0909 23.9582 57 26.3516 57H53.5489C55.9423 57 57.9004 55.0909 57.9004 52.7576V26.2424C57.9004 23.9091 55.9423 22 53.5489 22Z"
      fill="#006CFF"
    />
    <path
      d="M43.3226 39.7652C43.1928 39.5111 43.1854 39.3455 43.3226 39.0757L48.7621 30.0076C49.0342 29.5303 48.7078 28.8409 48.055 28.8409H35.9794C35.7075 28.8409 35.4767 28.971 35.3267 29.2121L29.2345 39.0227C29.0891 39.2654 29.0944 39.5763 29.2345 39.8182L35.3267 49.6287C35.4608 49.8705 35.684 49.9999 35.9794 49.9999H48.055C48.6533 49.9999 49.0342 49.3637 48.7621 48.8333L43.3226 39.7652ZM45.9881 30.8561L42.0172 37.4849L38.0464 30.8561H45.9881ZM31.4103 39.5L36.0882 31.8636L40.6574 39.5L36.0882 47.1364L31.4103 39.5ZM38.1008 48.1439L42.0717 41.5152L46.0424 48.1439H38.1008Z"
      fill="white"
    />
  </svg>
);

export const Paddle = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.7605 34.4459C40.2787 34.4459 41.6236 35.2058 42.4688 36.4033V30H44.198V44.2502H42.4688V42.5968C41.6236 43.7966 40.2787 44.5541 38.7605 44.5541C35.9169 44.5541 33.5154 42.3312 33.5154 39.5003C33.5154 36.6695 35.9169 34.4459 38.7605 34.4459ZM38.7605 43.0339C41.0084 43.0339 42.4688 41.533 42.4688 39.5003C42.4688 37.4676 41.0084 35.9662 38.7605 35.9662C36.7627 35.9662 35.2445 37.391 35.2445 39.5003C35.2445 41.6096 36.7627 43.0339 38.7605 43.0339ZM30.6337 36.4032C29.7885 35.2057 28.4436 34.4459 26.9259 34.4459C24.0818 34.4459 21.6802 36.6694 21.6802 39.5003C21.6802 42.3311 24.0818 44.5541 26.9259 44.5541C28.4245 44.5541 29.7671 43.7965 30.6337 42.5968V44.2502H32.3628V34.7498H30.6337V36.4032ZM30.6337 39.5003C30.6337 41.5142 29.1542 43.0338 26.9259 43.0338C24.9276 43.0338 23.4093 41.6096 23.4093 39.5003C23.4093 37.391 24.9276 35.9661 26.9259 35.9661C29.1738 35.9661 30.6337 37.467 30.6337 39.5003ZM9 39.2517V39.7659C9.31565 39.766 9.62819 39.8276 9.91975 39.9472C10.2113 40.0668 10.4762 40.242 10.6992 40.4629C10.9223 40.6838 11.0991 40.946 11.2196 41.2345C11.3401 41.523 11.4019 41.8321 11.4016 42.1443H11.8822C11.8824 41.5145 12.1355 40.9105 12.5858 40.4651C13.0361 40.0197 13.6469 39.7695 14.2838 39.7694V39.2552C13.9681 39.2551 13.6556 39.1935 13.364 39.0739C13.0725 38.9543 12.8076 38.7791 12.5846 38.5582C12.3615 38.3373 12.1847 38.0751 12.0642 37.7866C11.9437 37.4981 11.8819 37.189 11.8822 36.8768H11.4016C11.4014 37.5066 11.1483 38.1106 10.698 38.556C10.2476 39.0013 9.63689 39.2516 9 39.2517ZM15.5322 35.985H11.4016V34.4647H15.5322C18.4335 34.4647 20.7202 36.7266 20.7202 39.5003C20.7202 42.274 18.4335 44.5352 15.5322 44.5352H13.1307V49H11.4016V43.015H15.5322C17.5502 43.015 18.991 41.5907 18.991 39.5003C18.991 37.4098 17.5497 35.985 15.5322 35.985ZM54.4971 36.4033C53.6514 35.2058 52.3064 34.4459 50.7888 34.4459C47.9452 34.4459 45.5437 36.6695 45.5437 39.5003C45.5437 42.3312 47.9452 44.5541 50.7888 44.5541C52.3064 44.5541 53.6514 43.7966 54.4971 42.5968V44.2502H56.2263V30H54.4971V36.4033ZM54.4971 39.5003C54.4971 41.533 53.0367 43.0339 50.7888 43.0339C48.7904 43.0339 47.2728 41.6096 47.2728 39.5003C47.2728 37.391 48.7904 35.9662 50.7888 35.9662C53.0367 35.9662 54.4971 37.4676 54.4971 39.5003ZM57.9533 44.2502V30H59.683V44.2502H57.9533ZM71 40.1659C71 37.0305 69.4053 34.4653 66.082 34.4653C63.1807 34.4653 60.9328 36.7654 60.9328 39.5009C60.9328 42.2363 63.1807 44.5358 66.082 44.5358C68.3876 44.5358 70.0968 43.0915 70.7502 41.6284H68.8867C68.1952 42.6733 67.2732 43.2058 66.082 43.2058C64.3528 43.2058 62.9692 42.0083 62.7006 40.1659H71ZM66.082 35.7953C67.926 35.7953 69.2712 37.2773 69.2712 38.8359H62.7006C62.9692 36.995 64.3528 35.7953 66.082 35.7953Z"
      fill="black"
    />
  </svg>
);

export const AgileCrm = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M36.2157 22.1142C38.3459 21.9715 40.4976 21.9465 42.6243 22.132C48.1586 23.2239 52.7688 27.7806 54.1176 33.2329C54.6243 35.0848 54.6351 37.026 54.4566 38.9243C56.7154 38.646 59.0668 39.0563 60.9687 40.348C63.6306 42.0715 65.2542 45.2758 65.0009 48.448C64.9402 53.0332 60.7403 57.1795 56.123 56.994C46.7206 56.9869 37.3183 56.9904 27.9159 56.9904C26.0568 56.9869 24.1371 57.101 22.3636 56.4445C18.8989 55.2991 16.0193 52.5408 14.7097 49.1367C13.7927 46.9886 13.9747 44.5836 14.1174 42.307C14.9595 37.0438 19.6553 32.8547 24.8971 32.2302C26.5599 27.199 30.9774 23.099 36.2157 22.1142ZM28.3441 32.4051C31.7803 33.0045 34.7063 35.0313 37.7964 36.5193C37.2933 37.4685 36.7901 38.4176 36.2692 39.3561C34.5243 38.3427 32.6759 37.5291 30.8954 36.5835C28.8222 35.5095 26.3815 35.0527 24.0978 35.6522C19.8801 36.6335 16.7258 40.8761 17.0719 45.2044C17.2824 49.8789 21.4894 53.9039 26.1674 53.9039C36.0408 53.9146 45.9106 53.9003 55.7805 53.911C58.214 53.9752 60.5441 52.3909 61.4504 50.1465C62.3675 47.9092 61.7216 45.1652 59.9018 43.5773C58.239 41.9645 55.5878 41.6469 53.5039 42.5497C52.8438 44.1054 52.0052 45.5934 50.8919 46.8673C50.0962 46.1643 49.2898 45.4685 48.4798 44.7798C49.9713 42.9921 50.9954 40.8012 51.2844 38.4818C52.0623 33.108 48.6796 27.5415 43.5734 25.7217C37.8107 23.3881 30.4386 26.5067 28.3441 32.4051Z"
      fill="#409DE4"
    />
  </svg>
);

export const CapsuleCrm = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.3486 41.2355C71.7871 42.1362 70.6647 42.6453 69.4553 42.6453C67.7498 42.6453 66.4323 41.6858 66.1949 40.1587H74.3782C74.4 39.9627 74.4 39.669 74.4 39.4537C74.4 36.5557 72.2622 34.7152 69.3906 34.7152C66.5191 34.7152 64.2303 36.5557 64.2303 39.4537C64.2303 42.3516 66.5191 44.2507 69.3906 44.2507C71.1653 44.2507 72.8479 43.5629 73.7844 42.221L72.3486 41.2355ZM69.3906 36.3207C71.0105 36.3207 72.2193 37.2411 72.4568 38.7682H66.1949C66.4323 37.2411 67.7281 36.3207 69.3906 36.3207Z"
      fill="#111111"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.7766 44.0551H62.7415V29.9375H60.7766V44.0551Z"
      fill="#111111"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.7788 42.6846C57.3037 42.6846 57.1164 40.0813 57.1164 40.0813V34.9122H59.0813V40.0813C59.0813 40.0813 59.0853 40.1409 59.0843 40.2454C59.0779 41.0187 58.9905 44.2631 54.8435 44.2631H54.7138C50.5671 44.2631 50.4798 41.0187 50.4733 40.2454C50.4723 40.1409 50.4764 40.0813 50.4764 40.0813V34.9122H52.4413V40.0813C52.4413 40.0813 52.254 42.6846 54.7788 42.6846Z"
      fill="#111111"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.1011 38.5427C43.4191 38.3107 42.7551 37.9715 42.8218 37.3552C42.937 36.2892 44.3459 36.1688 45.2441 36.2299C46.9694 36.3467 47.333 37.7107 47.3513 37.8637L49.0448 37.7175C48.9456 36.7411 48.0814 34.8487 45.5208 34.673C44.1237 34.5778 42.9069 34.8608 42.0932 35.4711C41.4722 35.9372 40.9565 36.6426 40.8962 37.3783C40.7045 39.7113 43.2453 40.052 44.824 40.2658C46.8292 40.5377 47.2974 40.7564 47.2503 41.4716C47.228 41.8114 47.0342 42.1419 46.7415 42.3582C46.3142 42.674 45.4639 42.7671 44.6529 42.6888C42.7589 42.5063 42.5928 41.4117 42.5813 41.2052L40.8962 41.2326C40.9142 42.1607 41.5883 43.9698 44.4554 44.2644C45.9972 44.4226 47.2612 44.0153 47.9065 43.5923C48.656 43.1007 49.0645 42.2169 49.1136 41.443C49.2657 39.0422 46.7086 38.7641 45.1011 38.5427Z"
      fill="#111111"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.8732 34.715C33.4696 34.715 32.0228 35.3025 31.3537 36.3405V34.9112H29.3887V48.5H31.3537V42.6845C32.0228 43.742 33.4696 44.2509 34.8732 44.2509C37.637 44.2509 39.9258 42.4104 39.9258 39.5125C39.9258 36.6146 37.637 34.715 34.8732 34.715ZM34.6788 42.6129C33.0595 42.6129 31.2921 41.5656 31.2921 39.6074C31.2921 37.6689 32.9802 36.3928 34.7506 36.3928C36.5643 36.3928 38.0251 37.633 38.0251 39.4542C38.0251 41.2751 36.4925 42.6129 34.6788 42.6129Z"
      fill="#111111"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.8057 34.6469C23.7576 34.6469 23.7108 34.6504 23.6631 34.6514L23.6594 34.6516V34.6488C23.6594 34.6488 21.9818 34.6537 20.3658 35.247L20.9478 36.6539C21.5173 36.4387 22.4519 36.1781 23.6594 36.1579C23.7085 36.157 23.7559 36.1545 23.8057 36.1545C25.9545 36.1545 25.9935 37.951 25.9935 37.9542V38.4196L22.6047 38.3963C22.3859 38.3953 21.0105 38.3925 20.0551 39.2276C19.8257 39.4281 19.6435 39.6619 19.505 39.9212C19.3064 40.2935 19.201 40.7202 19.201 41.1885C19.201 41.793 19.3677 42.3396 19.6815 42.8056C19.8245 43.0185 19.9956 43.216 20.2005 43.3918C20.855 43.9533 21.7927 44.2658 22.8039 44.2658C22.8866 44.2658 22.97 44.264 23.0536 44.2597C24.2146 44.2006 25.293 43.7853 25.9908 42.7629L25.9905 44.0554H27.7382V38.2705C27.7382 36.7824 26.7087 34.6469 23.8057 34.6469ZM22.956 42.8302C22.3286 42.8615 20.9488 42.565 20.9488 41.1885C20.9488 40.8272 21.3242 39.904 22.556 39.904C23.7877 39.904 25.9298 39.9135 25.9298 39.9135C25.9298 41.6075 24.8437 42.7347 22.956 42.8302Z"
      fill="#111111"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5358 42.4887C10.4264 42.4887 8.00793 40.1979 8.00793 37.3389C8.00793 34.4804 10.4264 32.1698 13.5358 32.1698C15.0233 32.1698 16.332 32.7179 17.3198 33.5639L18.5066 32.1163C17.2216 31.0513 15.4898 30.4076 13.5358 30.4076C9.32542 30.4076 6 33.5013 6 37.3389C6 41.1573 9.32542 44.2509 13.5358 44.2509C15.2496 44.2509 16.7961 43.7544 18.0184 42.9152L17.368 41.2497C16.3293 41.9917 14.8691 42.4887 13.5358 42.4887Z"
      fill="#111111"
    />
  </svg>
);

export const Bitbucket = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M16 28C16 21.3726 21.3726 16 28 16H52C58.6274 16 64 21.3726 64 28V52C64 58.6274 58.6274 64 52 64H28C21.3726 64 16 58.6274 16 52V28Z"
      fill="#94C748"
    />
    <path
      d="M51.6853 39.5267L49.713 51.5747C49.5844 52.3036 49.0698 52.7323 48.341 52.7323H31.6195C30.8907 52.7323 30.3762 52.3036 30.2475 51.5747L26.7746 30.0941C26.646 29.3652 27.0319 28.8936 27.7179 28.8936H52.2426C52.9286 28.8936 53.3145 29.3652 53.1859 30.0941L52.2426 35.7536C52.114 36.5683 51.6424 36.9113 50.8706 36.9113H36.1215C35.9071 36.9113 35.7785 37.0399 35.8213 37.2971L36.979 44.4145C37.0218 44.586 37.1505 44.7146 37.322 44.7146H42.6385C42.81 44.7146 42.9387 44.586 42.9815 44.4145L43.7962 39.2694C43.8819 38.6263 44.3107 38.369 44.9109 38.369H50.6991C51.5566 38.369 51.8139 38.7978 51.6853 39.5267Z"
      fill="#101214"
    />
  </svg>
);

export const HelpScoutAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.5638 30.6912C41.4582 27.7389 41.4582 22.9523 38.5638 20L25.1708 33.6609C22.2764 36.6133 22.2764 41.3998 25.1708 44.3521L38.5638 30.6912ZM25.2001 59.893C22.3057 56.9407 22.3057 52.1541 25.2001 49.2019L53.8292 20C56.7236 22.9523 56.7236 27.7389 53.8292 30.6912L25.2001 59.893ZM40.4349 60C37.5405 57.0478 37.5405 52.2611 40.4349 49.3089L53.8278 35.6479C56.7222 38.6003 56.7222 43.3868 53.8278 46.3391L40.4349 60Z"
      fill="#304DDB"
    />
  </svg>
);

export const GitLabAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M65.0448 34.4032L64.975 34.2208L58.0471 16.1455C57.9087 15.7914 57.6597 15.4931 57.3356 15.287C57.0126 15.0799 56.6338 14.9823 56.2496 15.0026C55.8676 15.023 55.5006 15.1625 55.2012 15.4008C54.904 15.6411 54.6894 15.9663 54.5885 16.3333L49.9108 30.6495H30.9857L26.308 16.3333C26.2071 15.9663 25.9925 15.6411 25.6953 15.4008C25.3959 15.1625 25.0289 15.023 24.6469 15.0026C24.2627 14.9823 23.8839 15.0799 23.5609 15.287C23.2368 15.4931 22.9878 15.7914 22.8494 16.1455L15.9215 34.2219L15.8517 34.4032C13.7989 39.758 15.548 45.8114 20.1195 49.2689C20.128 49.2743 20.1355 49.2807 20.1441 49.2871L20.2053 49.3333L30.7582 57.2334L35.9777 61.1846L39.1541 63.5862C39.9192 64.1657 40.9773 64.1657 41.7424 63.5862L44.9188 61.1846L50.1373 57.2334L60.7524 49.2871C60.762 49.2796 60.7706 49.2732 60.7803 49.2657C65.3485 45.8081 67.0966 39.7569 65.0448 34.4032Z"
      fill="#E24329"
    />
    <path
      d="M65.0444 34.4034L64.9746 34.221C61.5375 34.9271 58.3718 36.3811 55.6612 38.4093C55.6172 38.4415 47.424 44.6376 40.4478 49.9119C45.6277 53.8287 50.1368 57.2336 50.1368 57.2336L60.752 49.2873C60.7616 49.2798 60.7702 49.2734 60.7799 49.2658C65.3481 45.8083 67.0961 39.7571 65.0444 34.4034Z"
      fill="#FC6D26"
    />
    <path
      d="M30.7581 57.2332L35.9776 61.1843L39.154 63.5859C39.9191 64.1654 40.9772 64.1654 41.7423 63.5859L44.9187 61.1843L50.1372 57.2332C50.1372 57.2332 45.628 53.8282 40.4482 49.9114C35.2672 53.8282 30.7581 57.2332 30.7581 57.2332Z"
      fill="#FCA326"
    />
    <path
      d="M25.2338 38.4089C22.5242 36.3818 19.3596 34.9267 15.9214 34.2216L15.8517 34.403C13.7988 39.7578 15.548 45.8111 20.1194 49.2686C20.128 49.274 20.1355 49.2805 20.1441 49.2869L20.2052 49.333L30.7581 57.2332C30.7581 57.2332 35.2673 53.8283 40.4482 49.9114C33.472 44.6371 25.2778 38.4411 25.2338 38.4089Z"
      fill="#FC6D26"
    />
  </svg>
);

export const FrontAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path d="M20 59.2155H33.1863V33.1323H59.4771V20H20V59.2155Z" fill="#A857F1" />
    <path
      d="M48.1052 60C54.6749 60 60.0006 54.6742 60.0006 48.1046C60.0006 41.5349 54.6749 36.2092 48.1052 36.2092C41.5356 36.2092 36.2098 41.5349 36.2098 48.1046C36.2098 54.6742 41.5356 60 48.1052 60Z"
      fill="#A857F1"
    />
  </svg>
);

export const WrikeAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M26.0982 35.9717C28.5956 35.9717 29.7725 36.3958 31.5809 38.0654L41.2833 47.023C41.5702 47.288 41.6277 47.394 41.6851 47.5529C41.7138 47.6059 41.7138 47.6854 41.7138 47.7384C41.7138 47.7914 41.7138 47.8709 41.6851 47.924C41.6277 48.083 41.5702 48.189 41.2833 48.454L34.6523 54.6024C34.3653 54.8675 34.2505 54.9205 34.0782 54.9735C34.0208 55 33.9347 55 33.8773 55C33.82 55 33.7337 55 33.6764 54.9735C33.5041 54.9205 33.3894 54.8675 33.1023 54.6024L14.3003 37.2438C13.7549 36.7403 13.9559 35.9717 14.8744 35.9717H26.0982Z"
      fill="#00E05C"
    />
    <path
      d="M53.4835 25.0265C50.9861 25.0265 49.8092 25.4506 48.0007 27.1202L38.2983 36.0777C38.0113 36.3428 37.9538 36.4488 37.8965 36.6077C37.8677 36.6607 37.8677 36.7402 37.8677 36.7932C37.8677 36.8462 37.8677 36.9257 37.8965 36.9787C37.9538 37.1378 38.0113 37.2438 38.2983 37.5088L44.9293 43.6307C45.2164 43.8958 45.3311 43.9488 45.5034 44.0018C45.5607 44.0283 45.647 44.0283 45.7043 44.0283C45.7617 44.0283 45.8478 44.0283 45.9052 44.0018C46.0774 43.9488 46.1923 43.8958 46.4793 43.6307L65.2812 26.2721C65.8267 25.7686 65.6257 25 64.7071 25H53.4835V25.0265Z"
      fill="#00E05C"
    />
  </svg>
);

export const BambooHr = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M51.2472 32.3048C58.6202 32.3048 65 38.6286 65 45.9429C65 53.8667 58.8876 60 50.7888 60C43.4539 60 37.0742 54.8952 37.0742 46.6667V20H41.3146V36.3048L41.8112 35.7714C43.6831 33.981 46.3191 32.3048 51.2472 32.3048ZM50.827 56.1524C56.8629 56.1524 60.6831 51.9238 60.6831 46.3238C60.6831 41.181 57.0539 36.2667 50.9416 36.2667C44.791 36.2667 41.009 40.8381 41.009 46.4381C40.9708 52 45.4787 56.1524 50.827 56.1524ZM28.5933 23.2381C31.764 26.5524 32.1079 28.381 33.2157 31.619L35.0876 37.7143C35.0876 37.7143 33.2157 37.3714 31.6876 37.1429C29.9303 36.8762 29.1281 36.6095 26.8742 35.6952C24.6202 34.781 22.5955 32.5714 20.609 30.0952C18.6607 27.6571 14 23.7714 14 23.7714C14 23.7714 15.4517 23.8476 16.9034 24.2286C18.0876 24.5333 21.2202 25.5238 24.4292 27.1619C25.1551 27.5429 25.5371 27.7714 26.2247 28.1905C27.2944 28.8381 28.4022 29.8286 29.4719 30.8952C30.7326 32.1524 31.8404 33.181 32.7955 34.3238C31.764 32.4571 29.0899 25.7143 23.8944 20.1524C23.3978 19.581 27.4854 22.0952 28.5933 23.2381Z"
      fill="#73C41D"
    />
  </svg>
);

export const DeelAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M34.9373 49.988C33.4201 49.988 32.0675 49.6956 30.8793 49.1107C29.6912 48.5258 28.7498 47.6757 28.0552 46.5607C27.3789 45.4274 27.0407 44.084 27.0407 42.5302C27.0407 40.9034 27.3697 39.4685 28.0278 38.2255C28.6859 36.9826 29.5998 36.0229 30.7697 35.3466C31.9578 34.652 33.3195 34.3047 34.855 34.3047C36.4453 34.3047 37.7796 34.652 38.8581 35.3466C39.9366 36.0229 40.7408 37.0008 41.2709 38.2804C41.8193 39.5599 42.0844 41.077 42.066 42.8318H28.5487V40.2819H39.9548L38.3371 41.4883C38.3371 40.5926 38.2092 39.8067 37.9533 39.1304C37.7157 38.454 37.3318 37.9148 36.8017 37.5126C36.2899 37.1105 35.641 36.9094 34.855 36.9094C34.0507 36.9094 33.3469 37.1288 32.7438 37.5675C32.1406 38.0062 31.6745 38.6459 31.3454 39.4868C31.0164 40.3276 30.8519 41.3147 30.8519 42.448C30.8519 43.4533 31.0256 44.3216 31.3728 45.0527C31.7385 45.7839 32.232 46.3414 32.8534 46.7252C33.4932 47.0908 34.197 47.2736 34.9647 47.2736C36.0248 47.2736 36.9023 46.9903 37.5968 46.4237C38.3097 45.8387 38.8306 45.1076 39.1597 44.2302L42.258 46.0946C41.3806 47.4107 40.3112 48.3886 39.05 49.0284C37.8071 49.6682 36.4361 49.988 34.9373 49.988Z"
      fill="#1B1B1B"
    />
    <path
      d="M51.0467 49.988C49.5295 49.988 48.1769 49.6956 46.9888 49.1107C45.8006 48.5258 44.8593 47.6757 44.1646 46.5607C43.4883 45.4274 43.1501 44.084 43.1501 42.5302C43.1501 40.9034 43.4792 39.4685 44.1372 38.2255C44.7953 36.9826 45.7092 36.0229 46.879 35.3466C48.0672 34.652 49.429 34.3047 50.9645 34.3047C52.5547 34.3047 53.8891 34.652 54.9675 35.3466C56.046 36.0229 56.8503 37.0008 57.3804 38.2804C57.9287 39.5599 58.1938 41.077 58.1755 42.8318H44.6582V40.2819H56.0642L54.4466 41.4883C54.4466 40.5926 54.3186 39.8067 54.0627 39.1304C53.8251 38.454 53.4412 37.9148 52.9112 37.5126C52.3993 37.1105 51.7504 36.9094 50.9645 36.9094C50.1602 36.9094 49.4564 37.1288 48.8532 37.5675C48.25 38.0062 47.7839 38.6459 47.4549 39.4868C47.1258 40.3276 46.9614 41.3147 46.9614 42.448C46.9614 43.4533 47.135 44.3216 47.4823 45.0527C47.8479 45.7839 48.3414 46.3414 48.9629 46.7252C49.6026 47.0908 50.3064 47.2736 51.0741 47.2736C52.1343 47.2736 53.0116 46.9903 53.7063 46.4237C54.4192 45.8387 54.9401 45.1076 55.2691 44.2302L58.3674 46.0946C57.49 47.4107 56.4207 48.3886 55.1595 49.0284C53.9165 49.6682 52.5455 49.988 51.0467 49.988Z"
      fill="#1B1B1B"
    />
    <path
      d="M59.3967 30H63.0707V46.0398C63.0707 47.3376 63.1347 48.5258 63.2626 49.6042H59.3967V30Z"
      fill="#1B1B1B"
    />
    <path
      d="M10 42.1568C10 36.7266 13.4663 34.3136 17.2672 34.3136C20.7361 34.3136 22.1989 36.5177 22.1989 36.5177V30.0073H25.9561V46.0514C25.9561 47.3685 26.0014 48.5568 26.0933 49.6165H22.2001V47.8157C22.2001 47.8157 20.7094 50 17.2684 50C13.6001 50 10 47.895 10 42.1568ZM18.2268 47.1171C20.8877 47.1171 22.6082 45.0918 22.6082 42.1568C22.6082 39.1191 20.8865 37.1964 18.2268 37.1964C15.5671 37.1964 13.909 39.0241 13.909 42.1568C13.909 45.2894 15.6369 47.1171 18.2268 47.1171Z"
      fill="#1B1B1B"
    />
    <path d="M65.4457 46.0947H69.0649V49.6043H65.4457V46.0947Z" fill="#1B1B1B" />
  </svg>
);

export const ConfluenceAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M20 30C20 24.4771 24.4771 20 30 20H50C55.5228 20 60 24.4771 60 30V50C60 55.5228 55.5228 60 50 60H30C24.4771 60 20 55.5228 20 50V30Z"
      fill="#1868DB"
    />
    <path
      d="M49.3143 43.6188C43.142 40.6343 41.3389 40.1884 38.7383 40.1884C35.6868 40.1884 33.0861 41.4577 30.7628 45.0253L30.3814 45.6085C30.0693 46.0887 30 46.2602 30 46.4661C30 46.6719 30.104 46.8434 30.4854 47.0836L34.4038 49.5192C34.6118 49.6564 34.7853 49.725 34.9586 49.725C35.1667 49.725 35.3053 49.6221 35.5134 49.3133L36.1376 48.3528C37.1085 46.8777 37.9753 46.3975 39.085 46.3975C40.0559 46.3975 41.2002 46.6719 42.6218 47.358L46.7136 49.2791C47.1297 49.4848 47.5804 49.3819 47.7885 48.9017L49.7303 44.6479C49.9384 44.1677 49.7997 43.8589 49.3143 43.6188ZM31.3177 36.1062C37.4899 39.0907 39.293 39.5366 41.8937 39.5366C44.9451 39.5366 47.5458 38.2673 49.869 34.6997L50.2505 34.1165C50.5626 33.6363 50.6319 33.4647 50.6319 33.2589C50.6319 33.0531 50.5278 32.8816 50.1464 32.6414L46.2281 30.2058C46.0201 30.0686 45.8467 30 45.6733 30C45.4653 30 45.3266 30.1029 45.1185 30.4117L44.4943 31.3722C43.5234 32.8472 42.6566 33.3275 41.5469 33.3275C40.576 33.3275 39.4318 33.0531 38.01 32.367L33.9183 30.4459C33.5022 30.2402 33.0514 30.3431 32.8434 30.8233L30.9016 35.0771C30.6935 35.5573 30.8322 35.8661 31.3177 36.1062Z"
      fill="white"
    />
  </svg>
);

export const Teamleader = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path d="M39.0533 57.3995L28.7145 40.644H39.0533V57.3995Z" fill="#00B2B2" />
    <path d="M39.0533 39.356H14.5L39.0533 22.6005V39.356Z" fill="#00B2B2" />
    <path d="M55.4574 47.0892L40.3466 57.4006V22.6005L55.4574 47.0892Z" fill="#00B2B2" />
    <path d="M52.9979 40.644L56.5243 46.36L64.8999 40.644H52.9979Z" fill="#00B2B2" />
  </svg>
);

export const MiroAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M20 30C20 24.477 24.436 20 29.91 20H49.727C55.2 20 59.637 24.477 59.637 30V50C59.637 55.523 55.2 60 49.727 60H29.91C24.436 60 20 55.523 20 50V30Z"
      fill="#FFDD33"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.35 27.625H42.752L45.75 32.942L39.154 27.625H35.556L38.854 34.123L31.958 27.625H28.359L31.957 35.896L28.36 52.438H31.958L38.855 34.715L35.557 52.438H39.155L45.751 33.533L42.753 52.438H46.351L52.947 31.76L46.35 27.625Z"
      fill="#1C1C1E"
    />
  </svg>
);

export const OmnisendAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M50.4632 24H29.5454C28.8176 23.9989 28.0967 24.1412 27.4239 24.419C26.7512 24.6967 26.1398 25.1044 25.6247 25.6187C25.1097 26.1329 24.7011 26.7437 24.4223 27.416C24.1435 28.0883 24 28.809 24 29.5368V50.4546C24 51.1824 24.1435 51.9031 24.4223 52.5754C24.7011 53.2478 25.1097 53.8585 25.6247 54.3727C26.1398 54.887 26.7512 55.2946 27.4239 55.5724C28.0967 55.8502 28.8176 55.9925 29.5454 55.9914H39.0715V51.4089C39.0715 46.9897 38.5212 43.6023 35.237 42.6223V39.0027C40.576 39.4842 43.224 43.4561 43.224 49.9817V56H50.4632C51.9317 56 53.3399 55.4167 54.3782 54.3783C55.4167 53.3399 56 51.9317 56 50.4632V29.5368C56 28.0684 55.4167 26.66 54.3782 25.6217C53.3399 24.5833 51.9317 24 50.4632 24ZM40.1461 35.5551C39.5387 35.5568 38.9445 35.3782 38.4386 35.042C37.9327 34.7058 37.5379 34.227 37.3043 33.6663C37.0707 33.1056 37.0087 32.4882 37.1261 31.8923C37.2436 31.2963 37.5352 30.7486 37.9642 30.3185C38.3931 29.8884 38.9399 29.5952 39.5356 29.4761C40.1312 29.3569 40.7487 29.4172 41.3101 29.6493C41.8715 29.8813 42.3513 30.2747 42.689 30.7797C43.0266 31.2846 43.2068 31.8783 43.2068 32.4857C43.2068 33.2983 42.8846 34.0777 42.3109 34.6531C41.7371 35.2284 40.9587 35.5528 40.1461 35.5551Z"
      fill="#1E2423"
    />
  </svg>
);

export const CreatioAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M9.76904 46.61C9.19546 46.1007 8.7298 45.4825 8.39939 44.7915C8.06899 44.1006 7.88048 43.3509 7.84495 42.5865C7.80942 41.822 7.92756 41.0582 8.19246 40.3398C8.45736 39.6215 8.86367 38.963 9.38755 38.4031C9.91143 37.8432 10.5423 37.3932 11.2432 37.0794C11.9441 36.7656 12.7009 36.5944 13.4692 36.5758C14.2374 36.5572 15.0016 36.6915 15.717 36.971C16.4324 37.2505 17.0845 37.6695 17.6351 38.2033H20.0586C20.0352 38.1667 20.0084 38.13 19.9849 38.09C19.0695 36.7381 17.7423 35.7146 16.1989 35.1702C14.6555 34.6258 12.9773 34.5892 11.4115 35.0659C9.84563 35.5425 8.47481 36.5072 7.50083 37.8179C6.52685 39.1286 6.00116 40.7161 6.00116 42.3467C6.00116 43.9772 6.52685 45.5647 7.50083 46.8754C8.47481 48.1861 9.84563 49.1508 11.4115 49.6275C12.9773 50.1041 14.6555 50.0675 16.1989 49.5231C17.7423 48.9787 19.0695 47.9552 19.9849 46.6033L20.1222 46.3967H17.8527C16.8021 47.48 15.3665 48.1093 13.8547 48.1492C12.3429 48.1891 10.8758 47.6364 9.76904 46.61Z"
      fill="#EF4724"
    />
    <path
      d="M73.528 41.7267C73.0146 40.5107 72.1085 39.5001 70.9533 38.8549C69.798 38.2096 68.4596 37.9666 67.15 38.1642C65.8404 38.3619 64.6344 38.989 63.723 39.9462C62.8117 40.9034 62.247 42.136 62.1185 43.4488C61.99 44.7617 62.3049 46.0797 63.0134 47.1941C63.7219 48.3086 64.7835 49.1559 66.0301 49.6018C67.2767 50.0476 68.6371 50.0666 69.8957 49.6558C71.1544 49.2449 72.2395 48.4276 72.9791 47.3333C73.5314 46.5179 73.8708 45.5782 73.9666 44.5992C74.0625 43.6203 73.9117 42.633 73.528 41.7267ZM68.0352 48.15C67.214 48.1507 66.411 47.9087 65.7279 47.4548C65.0448 47.0009 64.5123 46.3554 64.1978 45.6C63.8832 44.8446 63.8007 44.0132 63.9608 43.2111C64.1208 42.409 64.5162 41.6722 65.0969 41.094C65.6775 40.5157 66.4174 40.122 67.2229 39.9626C68.0283 39.8032 68.8632 39.8854 69.6217 40.1986C70.3803 40.5119 71.0285 41.0422 71.4843 41.7224C71.9401 42.4026 72.1831 43.2022 72.1824 44.02C72.1807 45.1148 71.7431 46.1643 70.9658 46.9384C70.1884 47.7126 69.1345 48.1482 68.0352 48.15Z"
      fill="#EF4724"
    />
    <path
      d="M32.3364 38.11C30.8187 38.0733 29.3484 38.6378 28.2483 39.6796C27.1481 40.7214 26.5081 42.1554 26.4686 43.6667C26.4686 43.79 26.4686 43.9133 26.4686 44.0367C26.472 47.51 28.9858 50 32.7582 50C33.6187 50.0412 34.4777 49.8933 35.2743 49.5666C36.0709 49.24 36.7855 48.7427 37.3674 48.11L36.2025 46.75C35.776 47.2137 35.2533 47.5794 34.6707 47.8217C34.088 48.064 33.4594 48.1772 32.8285 48.1533C30.5121 48.1533 28.8552 46.7933 28.5908 44.75H38.0736C38.105 44.5367 38.1251 44.322 38.1339 44.1067C38.1339 40.5267 35.7138 38.11 32.3364 38.11ZM28.5908 43.2267C28.6941 42.3085 29.1335 41.4603 29.8251 40.8444C30.5167 40.2285 31.4119 39.888 32.3398 39.888C33.2676 39.888 34.1628 40.2285 34.8544 40.8444C35.546 41.4603 35.9855 42.3085 36.0887 43.2267H28.5908Z"
      fill="#EF4724"
    />
    <path
      d="M26.7766 38.11C24.7247 38.11 23.2686 38.8133 22.5188 40.1733V38.22H20.4904V49.86H22.6092V44.0633C22.6092 41.5133 24.0184 40.13 26.2912 40.13C26.4533 40.1278 26.6154 40.1356 26.7766 40.1533V38.11Z"
      fill="#EF4724"
    />
    <path
      d="M56.3833 48.2133C55.2151 48.2133 54.8435 47.51 54.8435 46.26V39.9567H58.1908V38.22H54.8435V34.8067H52.728V38.22H52.0017V39.9567H52.728V46.3333C52.728 48.6833 53.7824 49.9767 56.1423 49.9767C56.9761 50.0089 57.7898 49.7173 58.4117 49.1633L57.7423 47.65C57.5651 47.8296 57.3535 47.972 57.1201 48.0687C56.8866 48.1655 56.6361 48.2147 56.3833 48.2133Z"
      fill="#EF4724"
    />
    <path d="M61.3071 38.22H59.1883V49.86H61.3071V38.22Z" fill="#EF4724" />
    <path
      d="M48.9322 39.84C48.6635 39.5742 48.371 39.3332 48.0586 39.12C47.1231 38.4895 46.0269 38.137 44.8979 38.1035C43.7688 38.0701 42.6535 38.3571 41.6821 38.9311C40.7107 39.5051 39.9232 40.3424 39.4117 41.3453C38.9001 42.3482 38.6856 43.4753 38.793 44.595C38.9005 45.7148 39.3255 46.781 40.0186 47.6693C40.7116 48.5575 41.6441 49.2311 42.7071 49.6115C43.7701 49.9919 44.9198 50.0634 46.0221 49.8176C47.1243 49.5718 48.1336 49.0188 48.9322 48.2233V49.86H50.7598V38.22H48.9322V39.84ZM44.718 48.15C43.8969 48.15 43.0943 47.9075 42.4117 47.4532C41.729 46.9988 41.197 46.3531 40.883 45.5976C40.5689 44.8422 40.4869 44.0109 40.6474 43.2091C40.8078 42.4072 41.2034 41.6707 41.7842 41.0928C42.3651 40.5148 43.1049 40.1215 43.9103 39.9623C44.7157 39.8032 45.5503 39.8856 46.3087 40.1989C47.0671 40.5123 47.7151 41.0426 48.1707 41.7227C48.6264 42.4029 48.8693 43.2024 48.8686 44.02C48.8669 45.1154 48.4289 46.1653 47.6508 46.9396C46.8727 47.7138 45.818 48.1491 44.718 48.15Z"
      fill="#EF4724"
    />
    <path
      d="M65.0259 34.72L56.8318 36.6133L59.272 34.72L49.2736 30L65.0259 34.72Z"
      fill="#0D2E4E"
    />
    <path d="M65.0259 34.72H59.272L49.2736 30L65.0259 34.72Z" fill="#1B4680" />
  </svg>
);

export const FreeAgentAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M48.3489 44.1577L49.281 37.2264H55.3761C58.5056 37.2264 61.0917 35.9272 60.9842 31.7994H44.074L40.4201 58.9713H46.357L47.6646 49.2475H52.5401C55.8497 49.2475 57.6803 47.2101 57.5648 44.1577H48.3489Z"
      fill="#0069BF"
    />
    <path
      d="M27.6353 29.8762H32.6339C36.9393 29.8762 39.727 31.5484 41.2899 34.0125C41.4521 30.9098 39.7557 28.6066 36.0955 26.9145L27.4551 22.9362C25.5018 22.0368 23.9363 21.0054 23.5928 20.0561C21.6403 22.7302 22.4148 27.3516 27.6353 29.8762Z"
      fill="#0069BF"
    />
    <path
      d="M32.6339 31.7994H22.7511C20.8609 31.7994 18.8237 31.6046 18.0369 30.8052C17.4932 33.9537 19.5217 37.4885 25.5082 37.4885H32.0344C34.7591 37.4885 36.5011 38.5342 36.834 39.9375C36.1323 39.5866 34.3972 39.4111 32.7642 39.4111H25.8417C26.7617 42.4176 29.02 44.1577 32.7643 44.1577H36.5724C38.6615 44.1577 39.7928 44.3831 40.4835 45.0848C42.2381 36.5678 39.5 31.7994 32.6339 31.7994Z"
      fill="#0069BF"
    />
  </svg>
);

export const MoneybirdAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.5289 51.6322C29.5719 50.8674 26.3377 45.4089 25.4349 41.6326C25.4349 41.6326 27.3817 42.1592 29.925 42.5073C29.9322 42.5084 30.6126 42.603 30.6264 42.4218C30.6531 42.0731 24.8938 40.3786 22.1033 35.5977C19.9257 31.8669 19.7925 28.2895 19.7925 28.2895C25.6356 29.417 29.2264 30.8296 47.6094 30.3717C53.3019 30.3717 55.8415 31.5486 55.8415 38.5215C55.8415 43.3907 53.7109 51.5377 39.5289 51.6322ZM65 38.2611C65 37.3486 64.0325 36.7634 62.8362 36.3877L62.86 36.3633C62.86 36.3633 62.7885 36.3575 62.6752 36.3389C62.4828 36.2826 62.2857 36.2309 62.0864 36.1844C61.8171 36.0851 61.5287 35.933 61.3124 35.6995C61.0623 35.4297 60.9114 35.0863 60.8204 34.7928C60.0616 29.7348 57.1924 25.1075 47.6094 25.1075H30.965C30.4015 25.0886 28.8719 25.0005 25.2479 24.6041C21.7332 24.2197 18.5886 23.1126 18.5594 23.1024L15.4743 22L15.0913 25.2755C15.0447 25.6734 14.0448 34.9125 19.9687 39.6013L19.9636 39.6555C19.7359 42.136 20.6853 47.5471 25.8316 51.9239C36.9871 61.4118 52.1489 55.4562 56.0275 51.2827C58.4548 48.6702 60.1959 45.585 60.7977 41.8821C60.8857 41.5741 61.041 41.194 61.3124 40.9008C61.4301 40.7739 61.5695 40.6721 61.7149 40.5884C62.1045 40.4884 62.4929 40.3724 62.8593 40.2371C64.0448 39.8003 65 39.1674 65 38.2611ZM50.4114 33.5308C49.1202 33.5308 48.2509 34.3317 48.2509 35.8083C48.2509 37.1845 49.1202 37.9607 50.4114 37.9607C51.6789 37.9607 52.598 37.1347 52.598 35.7832C52.598 34.3066 51.8276 33.5308 50.4114 33.5308Z"
      fill="#0073E6"
    />
  </svg>
);

export const AcceloAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M15.1856 63.3032C14.0415 63.3032 12.9363 62.6825 12.3662 61.5961C11.5483 60.0362 12.1465 58.1068 13.7019 57.2865L62.3367 31.6466C63.8921 30.8263 65.8159 31.4262 66.6338 32.9862C67.4517 34.5461 66.8535 36.4755 65.2981 37.2958L16.6633 62.9357C16.1911 63.185 15.6847 63.3032 15.1856 63.3032Z"
      fill="#060087"
    />
    <path
      d="M52.6941 63.3019C52.2701 63.3019 51.8401 63.2165 51.4267 63.0358C49.8151 62.3331 49.0776 60.4527 49.7782 58.8371L60.8998 33.1984C61.6005 31.5821 63.4754 30.8424 65.0864 31.5451C66.6981 32.2478 67.4356 34.1282 66.7349 35.7439L55.6133 61.3825C55.0922 62.5837 53.922 63.3019 52.6941 63.3019Z"
      fill="#0046BF"
    />
    <path
      d="M52.6981 63.3019C51.4937 63.3019 50.3416 62.6125 49.805 61.443L31.0484 20.5249C30.3143 18.9233 31.0136 17.0289 32.6105 16.2926C34.2075 15.5563 36.0964 16.2576 36.8306 17.8592L55.5872 58.7766C56.3214 60.3782 55.622 62.2726 54.0251 63.0089C53.5944 63.2078 53.1429 63.3019 52.6981 63.3019Z"
      fill="#F6511D"
    />
    <path
      d="M15.1809 63.3033C14.7362 63.3033 14.2847 63.2093 13.854 63.0111C12.257 62.2748 11.5584 60.3804 12.2919 58.7788L31.0484 17.8607C31.7826 16.2598 33.6716 15.5578 35.2686 16.2941C36.8654 17.0303 37.5641 18.9248 36.8307 20.5264L18.074 61.4445C17.5382 62.6141 16.3854 63.3033 15.1809 63.3033Z"
      fill="#FA7921"
    />
  </svg>
);

export const AttioAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M60.5533 46.3925L56.9612 40.6934C56.9612 40.6934 56.9481 40.6695 56.9398 40.6588L56.6561 40.2115C56.3937 39.7935 56.0294 39.4491 55.5974 39.2108C55.1654 38.9726 54.68 38.8482 54.1867 38.8493L48.4017 38.8315L47.9965 39.472L41.084 50.4396L40.7027 51.0468L43.5987 55.6342C43.861 56.0542 44.2265 56.4 44.6603 56.6384C45.094 56.8769 45.5816 57.0001 46.0765 56.9964H54.1843C55.1843 56.9964 56.1305 56.474 56.6597 55.6366L56.9457 55.1834C56.9457 55.1834 56.9565 55.1714 56.9577 55.1655L60.5569 49.4592C60.8464 49 61 48.4682 61 47.9253C61 47.3823 60.8464 46.8505 60.5569 46.3913L60.5533 46.3925ZM59.4569 48.7781L55.86 54.4844C55.8433 54.5098 55.8266 54.5329 55.8099 54.5536C55.7591 54.6096 55.6959 54.653 55.6254 54.6804C55.5548 54.7079 55.4789 54.7185 55.4036 54.7116C55.3283 54.7047 55.2556 54.6803 55.1912 54.6405C55.1269 54.6006 55.0727 54.5464 55.0329 54.482L51.4336 48.7757C51.3529 48.6486 51.2911 48.5104 51.2501 48.3654C51.1699 48.0779 51.1699 47.7738 51.2501 47.4863C51.2906 47.3456 51.3514 47.2048 51.4313 47.0784L55.0234 41.3769L55.0317 41.3649C55.0633 41.3134 55.1049 41.2686 55.154 41.2334C55.2031 41.1982 55.2588 41.1731 55.3177 41.1598C55.3547 41.149 55.3869 41.1467 55.4131 41.1419H55.4536C55.537 41.1419 55.7432 41.1681 55.8707 41.3745L59.4628 47.0724C59.6238 47.3277 59.7092 47.6234 59.7092 47.9253C59.7092 48.2271 59.6238 48.5228 59.4628 48.7781H59.4569ZM49.9236 32.6039C50.2117 32.1443 50.3646 31.6126 50.3646 31.07C50.3646 30.5274 50.2117 29.9957 49.9236 29.5361L46.3315 23.8381L46.0324 23.3586C45.7688 22.9401 45.403 22.5957 44.9694 22.358C44.5359 22.1202 44.049 21.9971 43.5546 22.0001H35.448C34.435 22.0001 33.5101 22.5082 32.969 23.3622L18.4505 46.3949C18.1578 46.853 18.0016 47.3851 18 47.9288C18 48.4692 18.1549 49.0023 18.4457 49.4604L22.3405 55.6402C22.6037 56.0585 22.9689 56.4028 23.4017 56.6407C23.8346 56.8786 24.3209 57.0022 24.8147 57H32.9238C33.9416 57 34.8664 56.4906 35.4015 55.6378L35.6971 55.1714V55.1655C35.6971 55.1655 35.703 55.1583 35.703 55.1559L38.5979 50.5673L47.1765 36.9588L49.9177 32.6063L49.9236 32.6039ZM49.0775 31.07C49.0775 31.3646 48.994 31.6616 48.8248 31.9228L34.6018 54.488C34.5573 54.5581 34.4956 54.6157 34.4226 54.6554C34.3496 54.695 34.2677 54.7154 34.1847 54.7146C34.1013 54.7146 33.8987 54.6907 33.7676 54.488L30.1731 48.7793C30.014 48.5238 29.9296 48.2287 29.9296 47.9276C29.9296 47.6266 30.014 47.3315 30.1731 47.076L44.3984 24.5168C44.4426 24.446 44.5041 24.3877 44.5771 24.3474C44.6501 24.3071 44.7322 24.2862 44.8156 24.2866C44.8978 24.2866 45.104 24.3105 45.2351 24.5192L48.826 30.2172C48.9952 30.4796 49.0775 30.7766 49.0775 31.07Z"
      fill="black"
    />
  </svg>
);

export const AlowareAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_aloware_wb)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.8135 17H39.0536C39.6048 17 40.0519 17.4387 40.0519 17.9787V39.4986H35.8138V17.9787C35.8138 17.4387 36.2637 17 36.8135 17ZM28.3358 27.5673H30.5744C31.127 27.5673 31.5742 28.006 31.5742 28.5446V39.5H27.336V28.546C27.336 28.006 27.7846 27.5673 28.3358 27.5673ZM44.2915 39.4494V23.6919C44.2915 23.152 44.7401 22.7132 45.2913 22.7132H47.5299C48.0825 22.7132 48.5311 23.152 48.5311 23.6919V39.5H44.2915V39.4494ZM53.769 27.5673H56.0076C56.5589 27.5673 57.0074 28.006 57.0074 28.5446V39.5H52.7692V28.546C52.7692 28.006 53.2178 27.5673 53.769 27.5673ZM14.9998 35.3546H22.0967C22.6493 35.3546 23.0965 35.7933 23.0965 36.3319V39.5H14.9998C14.7377 39.5026 14.4853 39.4012 14.2979 39.218C14.1105 39.0348 14.0033 38.7848 14 38.5227V36.3319C14 35.7933 14.4486 35.3546 14.9998 35.3546ZM57.0074 39.5H65.1055C65.6567 39.5 66.1039 39.9387 66.1039 40.4787V42.6681C66.1005 42.9299 65.9936 43.1797 65.8065 43.3629C65.6194 43.546 65.3673 43.6476 65.1055 43.6453H58.0086C57.7463 43.6483 57.4935 43.5471 57.3058 43.3639C57.1181 43.1806 57.0108 42.9304 57.0074 42.6681V39.5Z"
        fill="#009C4F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.0979 39.4999H27.3361V50.4539C27.3331 50.7162 27.2262 50.9666 27.0387 51.1501C26.8513 51.3336 26.5986 51.4352 26.3363 51.4326H24.0963C23.8345 51.4349 23.5824 51.3333 23.3953 51.1501C23.2082 50.967 23.1013 50.7172 23.0979 50.4553V39.4999ZM48.5298 39.4999H52.7693V50.4539C52.7679 50.5839 52.7408 50.7124 52.6897 50.8319C52.6386 50.9515 52.5644 51.0598 52.4715 51.1506C52.3785 51.2415 52.2685 51.3132 52.1478 51.3616C52.0272 51.41 51.8981 51.4341 51.7681 51.4326H49.5295C49.2677 51.4349 49.0157 51.3333 48.8285 51.1501C48.6414 50.967 48.5345 50.7172 48.5312 50.4553V39.4985L48.5298 39.4999ZM40.052 39.4999H44.2916V61.0212C44.2886 61.2835 44.1817 61.5339 43.9942 61.7174C43.8067 61.9009 43.5541 62.0025 43.2918 61.9999H41.0518C40.7897 62.0022 40.5375 61.9004 40.3503 61.7169C40.1632 61.5335 40.0564 61.2833 40.0534 61.0212V39.5013L40.052 39.4999ZM31.5743 39.4999H35.8138V55.5161C35.8124 55.6461 35.7853 55.7746 35.7342 55.8941C35.6831 56.0136 35.6089 56.1219 35.516 56.2128C35.423 56.3037 35.313 56.3754 35.1924 56.4238C35.0717 56.4721 34.9427 56.4963 34.8127 56.4948H32.5755C32.3132 56.4974 32.0605 56.3958 31.8731 56.2123C31.6856 56.0288 31.5786 55.7784 31.5757 55.5161V39.4985L31.5743 39.4999Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_aloware_wb">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ApplicantstackAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M42.0251 52.5867C40.7924 52.5867 39.683 52.5867 38.4349 52.5867C37.572 50.0289 36.6937 47.4325 35.8077 44.8131C32.8801 44.8131 30.0218 44.8131 27.071 44.8131C26.2235 47.394 25.3761 49.975 24.5286 52.5559C23.3421 52.5559 22.2173 52.5559 21 52.5559C21.0616 52.24 21.077 52.0397 21.1464 51.8471C23.6272 44.5742 26.108 37.3013 28.5888 30.0285C28.8045 29.3967 29.0279 28.765 29.1897 28.1178C29.3284 27.5862 29.6443 27.3474 30.1604 27.3474C31.1235 27.3319 32.0942 27.2934 33.0573 27.3628C33.3038 27.3782 33.6582 27.7095 33.7507 27.9714C34.9525 31.4384 36.1159 34.913 37.3024 38.3877C38.7893 42.7714 40.2916 47.1552 41.7786 51.5467C41.8787 51.8394 41.9327 52.1707 42.0251 52.5867ZM27.8723 42.001C30.2914 42.001 32.6104 42.001 35.0142 42.001C33.7815 38.2336 32.5796 34.5663 31.4163 31.03C30.2606 34.5894 29.0895 38.2259 27.8723 42.001Z"
      fill="#243445"
    />
    <path
      d="M58.3814 28.3797C58.0732 29.2811 57.7805 30.1286 57.4954 30.9684C56.4553 30.6217 55.5462 30.2211 54.5909 30.0285C53.1579 29.7357 51.7172 29.7896 50.3227 30.3289C47.5106 31.3998 47.3488 34.9438 49.5523 36.4847C50.5461 37.1781 51.7095 37.648 52.7958 38.2105C54.0054 38.8345 55.2843 39.3507 56.4245 40.0826C59.329 41.9625 59.7913 45.0519 59.0748 47.7176C58.443 50.0751 56.7712 51.4619 54.5832 52.2786C52.033 53.2339 49.4444 53.18 46.848 52.4712C46.1546 52.2786 45.4535 52.0551 44.8141 51.7316C44.5521 51.6006 44.2363 51.146 44.2748 50.8995C44.3981 50.1522 44.6908 49.428 44.9451 48.5805C45.5383 48.827 46.0006 49.0196 46.4551 49.2199C48.5276 50.1059 50.6386 50.5451 52.8651 49.8517C54.5524 49.3278 55.6233 48.2107 55.9237 46.4618C56.2165 44.7668 55.4615 43.4417 54.1055 42.5326C53.1348 41.8854 52.0176 41.4617 50.9776 40.9147C49.6755 40.2367 48.3196 39.6281 47.1023 38.8191C43.6738 36.5386 43.9204 30.7373 47.395 28.5723C50.8004 26.4536 54.3135 26.6848 57.8883 28.033C58.0424 28.0947 58.158 28.2179 58.3814 28.3797Z"
      fill="#63BBEA"
    />
  </svg>
);

export const StackbyAi = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#stackby_clip0)">
      <mask
        id="stackby_mask0"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#stackby_mask0)">
        <path
          d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
          fill="#F7F7F7"
        />
      </g>
      <path
        opacity="0.984314"
        d="M46.6202 12H46.7596V12.1394H46.899V12.4181H47.0383V12.5575H47.1777V12.6969H47.3171V12.8362H47.4565V12.9756H47.5958V13.2544H47.7352V13.3937H47.8746V13.5331H48.0139V13.6725H48.1533V13.8118H48.2927V14.0906H48.4321V14.23H48.5714V14.3693H48.7108V14.5087H48.8502V14.6481H48.9896V14.7875H49.1289V15.0662H49.2683V15.2056H49.4077V15.3449H49.547V15.4843H49.6864V15.6237H49.8258V15.9024H49.9652V16.0418H50.1045V16.1812H50.2439V16.3206H50.3833V16.4599H50.5227V16.7387H50.662V16.878H50.8014V17.0174H50.9408V17.1568H51.0801V17.2962H51.2195V17.5749H51.3589V17.7143H51.2195V17.8537H51.0801V17.993H50.8014V18.1324H50.662V18.2718H50.5227V18.4111H50.3833V18.5505H50.2439V18.6899H49.9652V18.8293H49.8258V18.9686H49.6864V19.108H49.547V19.2474H49.4077V19.3868H49.2683V19.5261H48.9896V19.6655H48.8502V19.8049H48.7108V19.9443H48.5714V20.0836H48.4321V20.223H48.1533V20.3624H48.0139V20.5017H47.8746V20.6411H47.7352V20.7805H47.5958V20.9199H47.3171V21.0592H47.1777V21.1986H47.0383V21.338H46.899V21.4774H46.7596V21.6167H46.4808V21.7561H46.3415V21.8955H46.2021V22.0348H46.0627V22.1742H45.9234V22.3136H45.6446V22.453H45.5052V22.5923H45.3659V22.7317H45.2265V22.8711H45.0871V23.0105H44.9477V23.1498H44.669V23.2892H44.5296V23.4286H44.3903V23.5679H44.2509V23.7073H44.1115V23.8467H43.8328V23.9861H43.6934V24.1254H43.554V24.2648H43.4146V24.4042H43.2753V24.5436H42.9965V24.6829H42.8572V24.8223H42.7178V24.9617H42.5784V25.101H42.439V25.2404H42.1603V25.3798H42.0209V25.5192H41.8815V25.6585H41.7422V25.7979H41.6028V25.9373H41.4634V26.0767H41.1847V26.216H41.0453V26.3554H40.9059V26.4948H40.7666V26.6341H40.6272V26.7735H40.3484V26.9129H40.2091V27.0523H40.0697V27.1916H39.9303V27.331H39.7909V27.4704H39.5122V27.6098H39.3728V27.7491H39.2335V27.8885H39.0941V28.0279H38.9547V28.1672H38.676V28.3066H38.5366V28.446H38.3972V28.5854H38.2578V28.7247H38.1185V28.8641H37.8397V29.0035H37.7004V29.1429H37.561V29.2822H37.4216V29.4216H37.2822V29.561H37.1429V29.7003H36.8641V29.8397H36.7247V29.9791H36.5854V30.1185H36.446V30.2578H36.3066V30.3972H36.0279V30.5366H35.8885V30.676H35.7491V30.8153H35.6098V30.9547H35.4704V31.0941H35.1916V31.2334H35.0523V31.3728H34.9129V31.5122H34.7735V31.6516H34.6342V31.7909H34.3554V31.9303H34.216V32.0697H34.0767V32.2091H33.9373V32.3484H33.7979V32.4878H33.5192V32.6272H33.3798V32.7666H33.2404V32.9059H33.1011V33.0453H32.9617V33.1847H32.8223V33.324H32.5436V33.4634H32.4042V33.6028H32.2648V33.7422H32.1254V33.8815H31.9861V34.0209H31.7073V34.1603H31.568V34.2997H31.4286V34.439H31.2892V34.5784H31.1498V34.7178H30.8711V34.8571H30.7317V34.9965H30.5923V35.1359H30.453V35.2753H30.3136V35.4146H30.0349V35.554H29.8955V35.6934H29.7561V35.8328H29.6167V35.9721H29.4774V36.1115H29.338V36.2509H29.0592V36.3902H28.9199V36.5296H28.7805V36.669H28.6411V36.8084H28.5017V36.9477H28.223V37.0871H28.0836V37.2265H27.9443V37.3659H27.8049V37.5052H27.6655V37.6446H27.3868V37.784H27.2474V37.9233H27.108V38.0627H26.9686V38.2021H26.8293V38.3415H26.5505V38.4808H26.4112V38.6202H26.2718V38.7596H26.1324V38.899H25.993V39.0383H25.9582H25.6098H25.5749V38.899H25.4355V38.6202H25.2962V38.4808H25.1568V38.3415H25.0174V38.2021H24.8781V38.0627H24.7387V37.784H24.5993V37.6446H24.4599V37.5052H24.3206V37.3659H24.1812V37.2265H24.0418V36.9477H23.9024V36.8084H23.7631V36.669H23.6237V36.5296H23.4843V36.3902H23.345V36.1115H23.2056V35.9721H23.0662V35.8328H22.9268V35.6934H22.7875V35.554H22.6481V35.4146H22.5087V35.1359H22.3693V34.9965H22.23V34.8571H22.0906V34.7178H21.9512V34.5784H21.8119V34.2997H21.6725V34.1603H21.5331V34.0209H21.3937V33.8815H21.2544V33.7422H21.115V33.4634H21.2544V33.324H21.3937V33.1847H21.5331V33.0453H21.6725V32.9059H21.8119V32.7666H22.0906V32.6272H22.23V32.4878H22.3693V32.3484H22.5087V32.2091H22.6481V32.0697H22.9268V31.9303H23.0662V31.7909H23.2056V31.6516H23.345V31.5122H23.4843V31.3728H23.7631V31.2334H23.9024V31.0941H24.0418V30.9547H24.1812V30.8153H24.3206V30.676H24.5993V30.5366H24.7387V30.3972H24.8781V30.2578H25.0174V30.1185H25.1568V29.9791H25.2962V29.8397H25.5749V29.7003H25.7143V29.561H25.8537V29.4216H25.993V29.2822H26.1324V29.1429H26.4112V29.0035H26.5505V28.8641H26.6899V28.7247H26.8293V28.5854H26.9686V28.446H27.2474V28.3066H27.3868V28.1672H27.5261V28.0279H27.6655V27.8885H27.8049V27.7491H28.0836V27.6098H28.223V27.4704H28.3624V27.331H28.5017V27.1916H28.6411V27.0523H28.9199V26.9129H29.0592V26.7735H29.1986V26.6341H29.338V26.4948H29.4774V26.3554H29.6167V26.216H29.8955V26.0767H30.0349V25.9373H30.1742V25.7979H30.3136V25.6585H30.453V25.5192H30.7317V25.3798H30.8711V25.2404H31.0105V25.101H31.1498V24.9617H31.2892V24.8223H31.568V24.6829H31.7073V24.5436H31.8467V24.4042H31.9861V24.2648H32.1254V24.1254H32.4042V23.9861H32.5436V23.8467H32.6829V23.7073H32.8223V23.5679H32.9617V23.4286H33.1011V23.2892H33.3798V23.1498H33.5192V23.0105H33.6585V22.8711H33.7979V22.7317H33.9373V22.5923H34.216V22.453H34.3554V22.3136H34.4948V22.1742H34.6342V22.0348H34.7735V21.8955H35.0523V21.7561H35.1916V21.6167H35.331V21.4774H35.4704V21.338H35.6098V21.1986H35.8885V21.0592H36.0279V20.9199H36.1673V20.7805H36.3066V20.6411H36.446V20.5017H36.7247V20.3624H36.8641V20.223H37.0035V20.0836H37.1429V19.9443H37.2822V19.8049H37.4216V19.6655H37.7004V19.5261H37.8397V19.3868H37.9791V19.2474H38.1185V19.108H38.2578V18.9686H38.5366V18.8293H38.676V18.6899H38.8153V18.5505H38.9547V18.4111H39.0941V18.2718H39.3728V18.1324H39.5122V17.993H39.6516V17.8537H39.7909V17.7143H39.9303V17.5749H40.2091V17.4355H40.3484V17.2962H40.4878V17.1568H40.6272V17.0174H40.7666V16.878H41.0453V16.7387H41.1847V16.5993H41.324V16.4599H41.4634V16.3206H41.6028V16.1812H41.7422V16.0418H42.0209V15.9024H42.1603V15.7631H42.2997V15.6237H42.439V15.4843H42.5784V15.3449H42.8572V15.2056H42.9965V15.0662H43.1359V14.9268H43.2753V14.7875H43.4146V14.6481H43.6934V14.5087H43.8328V14.3693H43.9721V14.23H44.1115V14.0906H44.2509V13.9512H44.5296V13.8118H44.669V13.6725H44.8084V13.5331H44.9477V13.3937H45.0871V13.2544H45.2265V13.115H45.5052V12.9756H45.6446V12.8362H45.784V12.6969H45.9234V12.5575H46.0627V12.4181H46.3415V12.2787H46.4808V12.1394H46.6202V12Z"
        fill="#008DD2"
      />
      <path
        opacity="0.984314"
        d="M45.3659 25.2404H45.6446V25.3798H45.784V25.5192H45.9233V25.6585H46.0627V25.7979H46.2021V26.0767H46.3415V26.216H46.4808V26.3554H46.6202V26.4948H46.7596V26.6341H46.899V26.7735H47.0383V27.0523H47.1777V27.1916H47.3171V27.331H47.4564V27.4704H47.5958V27.6098H47.7352V27.8885H47.8746V28.0279H48.0139V28.1672H48.1533V28.3066H48.2927V28.446H48.4321V28.7247H48.5714V28.8641H48.7108V29.0035H48.8502V29.1429H48.9895V29.2822H49.1289V29.561H49.2683V29.7003H49.4077V29.8397H49.547V29.9791H49.6864V30.1185H49.8258V30.2578H49.9652V30.5366H50.1045V30.676H50.2439V30.8153H50.1045V30.9547H49.9652V31.0941H49.8258V31.2334H49.6864V31.3728H49.547V31.5122H49.2683V31.6516H49.1289V31.7909H48.9895V31.9303H48.8502V32.0697H48.7108V32.2091H48.5714V32.3484H48.2927V32.4878H48.1533V32.6272H48.0139V32.7666H47.8746V32.9059H47.7352V33.0453H47.4564V33.1847H47.3171V33.324H47.1777V33.4634H47.0383V33.6028H46.899V33.7422H46.6202V33.8815H46.4808V34.0209H46.3415V34.1603H46.2021V34.2997H46.0627V34.439H45.784V34.5784H45.6446V34.7178H45.5052V34.8571H45.3659V34.9965H45.2265V35.1359H44.9477V35.2753H44.8084V35.4146H44.669V35.554H44.5296V35.6934H44.3902V35.8328H44.2509V35.9721H43.9721V36.1115H43.8328V36.2509H43.6934V36.3902H43.554V36.5296H43.4146V36.669H43.1359V36.8084H42.9965V36.9477H42.8571V37.0871H42.7178V37.2265H42.5784V37.3659H42.2997V37.5052H42.1603V37.6446H42.0209V37.784H41.8815V37.9233H41.7422V38.0627H41.4634V38.2021H41.324V38.3415H41.1847V38.4808H41.0453V38.6202H40.9059V38.7596H40.7666V38.899H40.4878V39.0383H40.3484V39.1777H40.2091V39.3171H40.0697V39.4564H39.9303V39.5958H39.6516V39.7352H39.5122V39.8746H39.3728V40.0139H39.2334V40.1533H39.0941V40.2927H38.8153V40.4321H38.676V40.5714H38.5366V40.7108H38.3972V40.8502H38.2578V40.9895H37.9791V41.1289H37.8397V41.2683H37.7003V41.4077H37.561V41.547H37.4216V41.6864H37.1429V41.8258H37.0035V41.9652H36.8641V42.1045H36.7247V42.2439H36.5854V42.3833H36.446V42.5226H36.1672V42.662H36.0279V42.8014H35.8885V42.9408H35.7491V43.0801H35.6098V43.2195H35.331V43.3589H35.1916V43.4983H35.0523V43.6376H34.9129V43.777H34.7735V43.9164H34.4948V44.0557H34.3554V44.1951H34.216V44.3345H34.0767V44.4739H33.9373V44.6132H33.6585V44.7526H33.5192V44.892H33.3798V45.0314H33.2404V45.1707H33.101V45.3101H32.8223V45.4495H32.6829V45.5889H32.5436V45.7282H32.4042V45.8676H32.2648V46.007H32.1254V46.1463H31.8467V46.2857H31.7073V46.4251H31.5679V46.5645H31.4286V46.7038H31.2892V46.8432H31.0105V46.9826H30.8711V47.122H30.7317V47.2613H30.5923V47.4007H30.453V47.5401H30.1742V47.6794H30.0348V47.8188H29.8955V47.9582H29.7561V48.0976H29.6167V48.2369H29.338V48.3763H29.1986V48.5157H29.0592V48.6551H28.9199V48.7944H28.7805V48.9338H28.6411V49.0732H28.3624V49.2125H28.223V49.3519H28.0836V49.4913H27.9443V49.6307H27.8049V49.77H27.5261V49.9094H27.3868V50.0488H27.2474V50.1882H27.108V50.3275H26.9686V50.4669H26.6899V50.6063H26.5505V50.7456H26.4111V50.885H26.2718V51.0244H26.1324V51.1638H25.8537V51.3031H25.7143V51.4425H25.5749V51.5819H25.4355V51.7213H25.2962V51.8606H25.0174V52H24.878V52.1394H24.7387V52.2787H24.5993V52.1394H24.4599V52H24.3206V51.8606H24.1812V51.7213H24.0418V51.5819H23.9024V51.4425H23.7631V51.1638H23.6237V51.0244H23.4843V50.885H23.3449V50.7456H23.2056V50.6063H23.0662V50.3275H22.9268V50.1882H22.7875V50.0488H22.6481V49.9094H22.5087V49.77H22.3693V49.4913H22.23V49.3519H22.0906V49.2125H21.9512V49.0732H21.8118V48.9338H21.6725V48.6551H21.5331V48.5157H21.3937V48.3763H21.2544V48.2369H21.115V48.0976H20.9756V47.9582H20.8362V47.6794H20.6969V47.5401H20.5575V47.4007H20.4181V47.2613H20.2787V47.122H20.1394C20.1394 47.0871 20.1394 47.0058 20.1394 46.878V46.8432H20V46.5645H20.1394V46.4251H20.2787V46.2857H20.4181V46.1463H20.5575V46.007H20.8362V45.8676H20.9756V45.7282H21.115V45.5889H21.2544V45.4495H21.3937V45.3101H21.6725V45.1707H21.8118V45.0314H21.9512V44.892H22.0906V44.7526H22.23V44.6132H22.5087V44.4739H22.6481V44.3345H22.7875V44.1951H22.9268V44.0557H23.0662V43.9164H23.3449V43.777H23.4843V43.6376H23.6237V43.4983H23.7631V43.3589H23.9024V43.2195H24.1812V43.0801H24.3206V42.9408H24.4599V42.8014H24.5993V42.662H24.7387V42.5226H24.878V42.3833H25.1568V42.2439H25.2962V42.1045H25.4355V41.9652H25.5749V41.8258H25.7143V41.6864H25.993V41.547H26.1324V41.4077H26.2718V41.2683H26.4111V41.1289H26.5505V40.9895H26.8293V40.8502H26.9686V40.7108H27.108V40.5714H27.2474V40.4321H27.3868V40.2927H27.6655V40.1533H27.8049V40.0139H27.9443V39.8746H28.0836V39.7352H28.223V39.5958H28.3624V39.4564H28.6411V39.3171H28.7805V39.1777H28.9199V39.0383H29.0592V38.899H29.1986V38.7596H29.4774V38.6202H29.6167V38.4808H29.7561V38.3415H29.8955V38.2021H30.0348V38.0627H30.3136V37.9233H30.453V37.784H30.5923V37.6446H30.7317V37.5052H30.8711V37.3659H31.1498V37.2265H31.2892V37.0871H31.4286V36.9477H31.5679V36.8084H31.7073V36.669H31.9861V36.5296H32.1254V36.3902H32.2648V36.2509H32.4042V36.1115H32.5436V35.9721H32.6829V35.8328H32.9617V35.6934H33.101V35.554H33.2404V35.4146H33.3798V35.2753H33.5192V35.1359H33.7979V34.9965H33.9373V34.8571H34.0767V34.7178H34.216V34.5784H34.3554V34.439H34.6341V34.2997H34.7735V34.1603H34.9129V34.0209H35.0523V33.8815H35.1916V33.7422H35.4704V33.6028H35.6098V33.4634H35.7491V33.324H35.8885V33.1847H36.0279V33.0453H36.1672V32.9059H36.446V32.7666H36.5854V32.6272H36.7247V32.4878H36.8641V32.3484H37.0035V32.2091H37.2822V32.0697H37.4216V31.9303H37.561V31.7909H37.7003V31.6516H37.8397V31.5122H38.1185V31.3728H38.2578V31.2334H38.3972V31.0941H38.5366V30.9547H38.676V30.8153H38.9547V30.676H39.0941V30.5366H39.2334V30.3972H39.3728V30.2578H39.5122V30.1185H39.7909V29.9791H39.9303V29.8397H40.0697V29.7003H40.2091V29.561H40.3484V29.4216H40.4878V29.2822H40.7666V29.1429H40.9059V29.0035H41.0453V28.8641H41.1847V28.7247H41.324V28.5854H41.6028V28.446H41.7422V28.3066H41.8815V28.1672H42.0209V28.0279H42.1603V27.8885H42.439V27.7491H42.5784V27.6098H42.7178V27.4704H42.8571V27.331H42.9965V27.1916H43.2753V27.0523H43.4146V26.9129H43.554V26.7735H43.6934V26.6341H43.8328V26.4948H44.1115V26.3554H44.2509V26.216H44.3902V26.0767H44.5296V25.9373H44.669V25.7979H44.8084V25.6585H45.0871V25.5192H45.2265V25.3798H45.3659V25.2404Z"
        fill="#E74337"
      />
      <path
        opacity="0.984314"
        d="M55.1219 29.2822H55.4007V29.4216H55.54V29.561H55.6794V29.8397H55.8188V29.9791H55.9582V30.1185H56.0975V30.2578H56.2369V30.3972H56.3763V30.676H56.5157V30.8153H56.655V30.9547H56.7944V31.0941H56.9338V31.2334H57.0731V31.3728H57.2125V31.6516H57.3519V31.7909H57.4913V31.9303H57.6306V32.0697H57.77V32.2091H57.9094V32.4878H58.0488V32.6272H58.1881V32.7665H58.3275V32.9059H58.4669V33.0453H58.6062V33.324H58.7456V33.4634H58.885V33.6028H59.0244V33.7422H59.1637V33.8815H59.3031V34.1603H59.4425V34.2996H59.5819V34.439H59.7212V34.5784H59.8606V34.7178H60V34.9965H59.7212V35.1359H59.5819V35.2753H59.4425V35.4146H59.3031V35.554H59.1637V35.6934H58.885V35.8327H58.7456V35.9721H58.6062V36.1115H58.4669V36.2509H58.3275V36.3902H58.1881V36.5296H57.9094V36.669H57.77V36.8084H57.6306V36.9477H57.4913V37.0871H57.3519V37.2265H57.0731V37.3659H56.9338V37.5052H56.7944V37.6446H56.655V37.784H56.5157V37.9233H56.2369V38.0627H56.0975V38.2021H55.9582V38.3415H55.8188V38.4808H55.6794V38.6202H55.4007V38.7596H55.2613V38.899H55.1219V39.0383H54.9826V39.1777H54.8432V39.3171H54.5644V39.4564H54.4251V39.5958H54.2857V39.7352H54.1463V39.8746H54.0069V40.0139H53.8676V40.1533H53.5888V40.2927H53.4495V40.4321H53.3101V40.5714H53.1707V40.7108H53.0313V40.8502H52.7526V40.9895H52.6132V41.1289H52.4738V41.2683H52.3345V41.4077H52.1951V41.547H51.9164V41.6864H51.777V41.8258H51.6376V41.9652H51.4982V42.1045H51.3589V42.2439H51.0801V42.3833H50.9407V42.5226H50.8014V42.662H50.662V42.8014H50.5226V42.9408H50.3833V43.0801H50.1045V43.2195H49.9651V43.3589H49.8258V43.4983H49.6864V43.6376H49.547V43.777H49.2683V43.9164H49.1289V44.0557H48.9895V44.1951H48.8501V44.3345H48.7108V44.4739H48.432V44.6132H48.2927V44.7526H48.1533V44.892H48.0139V45.0314H47.8745V45.1707H47.5958V45.3101H47.4564V45.4495H47.317V45.5888H47.1777V45.7282H47.0383V45.8676H46.7596V46.007H46.6202V46.1463H46.4808V46.2857H46.3414V46.4251H46.2021V46.5645H46.0627V46.7038H45.7839V46.8432H45.6446V46.9826H45.5052V47.1219H45.3658V47.2613H45.2265V47.4007H44.9477V47.5401H44.8083V47.6794H44.669V47.8188H44.5296V47.9582H44.3902V48.0976H44.1115V48.2369H43.9721V48.3763H43.8327V48.5157H43.6934V48.655H43.554V48.7944H43.2752V48.9338H43.1359V49.0732H42.9965V49.2125H42.8571V49.3519H42.7177V49.4913H42.439V49.6307H42.2996V49.77H42.1603V49.9094H42.0209V50.0488H41.8815V50.1882H41.7421V50.3275H41.4634V50.4669H41.324V50.6063H41.1846V50.7456H41.0453V50.885H40.9059V51.0244H40.6272V51.1638H40.4878V51.3031H40.3484V51.4425H40.209V51.5819H40.0697V51.7213H39.7909V51.8606H39.6515V52H39.5122V52.1394H39.3728V52.2787H39.2334V52.4181H38.9547V52.5575H38.8153V52.6969H38.6759V52.8362H38.5366V52.9756H38.3972V53.115H38.2578V53.2544H37.9791V53.3937H37.8397V53.5331H37.7003V53.6725H37.561V53.8118H37.4216V53.9512H37.1428V54.0906H37.0035V54.23H36.8641V54.3693H36.7247V54.5087H36.5853V54.6481H36.3066V54.7875H36.1672V54.9268H36.0278V55.0662H35.8885V55.2056H35.7491V55.3449H35.4704V55.4843H35.331V55.6237H35.1916V55.7631H35.0522V55.9024H34.9129V56.0418H34.6341V56.1812H34.4947V56.3206H34.216V56.1812H34.0766V56.0418H33.9373V55.9024H33.7979V55.7631H33.6585V55.6237H33.5191V55.3449H33.3798V55.2056H33.2404V55.0662H33.101V54.9268H32.9616V54.7875H32.8223V54.5087H32.6829V54.3693H32.5435V54.23H32.4042V54.0906H32.2648V53.9512H32.1254V53.6725H31.986V53.5331H31.8467V53.3937H31.7073V53.2544H31.5679V53.115H31.4285V52.9756H31.2892V52.6969H31.1498V52.5575H31.0104V52.4181H30.8711V52.2787H30.7317V52.1394H30.5923V51.8606H30.4529V51.7213H30.3136V51.5819H30.1742V51.4425H30.0348V51.3031H29.8954V51.0244H29.7561V50.885H29.6167V50.6063H29.7561V50.4669H30.0348V50.3275H30.1742V50.1882H30.3136V50.0488H30.4529V49.9094H30.5923V49.77H30.8711V49.6307H31.0104V49.4913H31.1498V49.3519H31.2892V49.2125H31.4285V49.0732H31.7073V48.9338H31.8467V48.7944H31.986V48.655H32.1254V48.5157H32.2648V48.3763H32.5435V48.2369H32.6829V48.0976H32.8223V47.9582H32.9616V47.8188H33.101V47.6794H33.2404V47.5401H33.5191V47.4007H33.6585V47.2613H33.7979V47.1219H33.9373V46.9826H34.0766V46.8432H34.3554V46.7038H34.4947V46.5645H34.6341V46.4251H34.7735V46.2857H34.9129V46.1463H35.1916V46.007H35.331V45.8676H35.4704V45.7282H35.6097V45.5888H35.7491V45.4495H36.0278V45.3101H36.1672V45.1707H36.3066V45.0314H36.446V44.892H36.5853V44.7526H36.8641V44.6132H37.0035V44.4739H37.1428V44.3345H37.2822V44.1951H37.4216V44.0557H37.561V43.9164H37.8397V43.777H37.9791V43.6376H38.1184V43.4983H38.2578V43.3589H38.3972V43.2195H38.6759V43.0801H38.8153V42.9408H38.9547V42.8014H39.0941V42.662H39.2334V42.5226H39.5122V42.3833H39.6515V42.2439H39.7909V42.1045H39.9303V41.9652H40.0697V41.8258H40.3484V41.6864H40.4878V41.547H40.6272V41.4077H40.7665V41.2683H40.9059V41.1289H41.0453V40.9895H41.324V40.8502H41.4634V40.7108H41.6028V40.5714H41.7421V40.4321H41.8815V40.2927H42.1603V40.1533H42.2996V40.0139H42.439V39.8746H42.5784V39.7352H42.7177V39.5958H42.9965V39.4564H43.1359V39.3171H43.2752V39.1777H43.4146V39.0383H43.554V38.899H43.8327V38.7596H43.9721V38.6202H44.1115V38.4808H44.2508V38.3415H44.3902V38.2021H44.669V38.0627H44.8083V37.9233H44.9477V37.784H45.0871V37.6446H45.2265V37.5052H45.3658V37.3659H45.6446V37.2265H45.7839V37.0871H45.9233V36.9477H46.0627V36.8084H46.2021V36.669H46.4808V36.5296H46.6202V36.3902H46.7596V36.2509H46.8989V36.1115H47.0383V35.9721H47.317V35.8327H47.4564V35.6934H47.5958V35.554H47.7352V35.4146H47.8745V35.2753H48.1533V35.1359H48.2927V34.9965H48.432V34.8571H48.5714V34.7178H48.7108V34.5784H48.9895V34.439H49.1289V34.2996H49.2683V34.1603H49.4076V34.0209H49.547V33.8815H49.6864V33.7422H49.9651V33.6028H50.1045V33.4634H50.2439V33.324H50.3833V33.1847H50.5226V33.0453H50.8014V32.9059H50.9407V32.7665H51.0801V32.6272H51.2195V32.4878H51.3589V32.3484H51.6376V32.2091H51.777V32.0697H51.9164V31.9303H52.0557V31.7909H52.1951V31.6516H52.4738V31.5122H52.6132V31.3728H52.7526V31.2334H52.892V31.0941H53.0313V30.9547H53.1707V30.8153H53.4495V30.676H53.5888V30.5366H53.7282V30.3972H53.8676V30.2578H54.0069V30.1185H54.2857V29.9791H54.4251V29.8397H54.5644V29.7003H54.7038V29.561H54.8432V29.4216H55.1219V29.2822Z"
        fill="#FCC411"
      />
      <path
        opacity="0.984314"
        d="M54.9826 41.5471H55.0174H55.3658H55.4007V41.6864H55.54V41.8258H55.6794V41.9652H55.8188V42.1045H55.9582V42.3833H56.0975V42.5227H56.2369V42.662H56.3763V42.8014H56.5157V42.9408H56.655V43.2195H56.7944V43.3589H56.9338V43.4983H57.0731V43.6377H57.2125V43.777H57.3519V43.9164H57.4913V44.1951H57.6306V44.3345H57.77V44.4739H57.9094V44.6133H58.0488V44.7526H58.1881V45.0314H58.3275V45.1708H58.4669V45.3101H58.6062V45.4495H58.7456V45.5889H58.885V45.8676H59.0244V46.007H59.1637V46.1464H59.3031V46.2857H59.4425V46.4251H59.5819V46.5645H59.7212V46.8432H59.8606V46.9826H60V47.122H59.8606V47.2613H59.7212V47.4007H59.5819V47.5401H59.3031V47.6795H59.1637V47.8188H59.0244V47.9582H58.885V48.0976H58.7456V48.237H58.4669V48.3763H58.3275V48.5157H58.1881V48.6551H58.0488V48.7944H57.9094V48.9338H57.6306V49.0732H57.4913V49.2126H57.3519V49.3519H57.2125V49.4913H57.0731V49.6307H56.9338V49.7701H56.655V49.9094H56.5157V50.0488H56.3763V50.1882H56.2369V50.3275H56.0975V50.4669H55.8188V50.6063H55.6794V50.7457H55.54V50.885H55.4007V51.0244H55.2613V51.1638H54.9826V51.3032H54.8432V51.4425H54.7038V51.5819H54.5644V51.7213H54.4251V51.8606H54.1463V52H54.0069V52.1394H53.8676V52.2788H53.7282V52.4181H53.5888V52.5575H53.3101V52.6969H53.1707V52.8363H53.0313V52.9756H52.892V53.115H52.7526V53.2544H52.6132V53.3937H52.3345V53.5331H52.1951V53.6725H52.0557V53.8119H51.9164V53.9512H51.777V54.0906H51.4982V54.23H51.3589V54.3694H51.2195V54.5087H51.0801V54.6481H50.9407V54.7875H50.662V54.9268H50.5226V55.0662H50.3833V55.2056H50.2439V55.345H50.1045V55.4843H49.8258V55.6237H49.6864V55.7631H49.547V55.9025H49.4076V56.0418H49.2683V56.1812H48.9895V56.3206H48.8501V56.46H48.7108V56.5993H48.5714V56.7387H48.432V56.8781H48.2927V57.0174H48.0139V57.1568H47.8745V57.2962H47.7352V57.4356H47.5958V57.5749H47.4564V57.7143H47.1777V57.8537H47.0383V57.9931H46.8989V58.1324H46.7596V58.2718H46.6202V58.4112H46.3414V58.5505H46.2021V58.6899H46.0627V58.8293H45.9233V58.9687H45.7839V59.108H45.5052V59.2474H45.3658V59.3868H45.2265V59.5262H45.0871V59.6655H44.9477V59.8049H44.8083V59.9443H44.5296V60.0836H44.3902V60.223H44.2508V60.3624H44.1115V60.5018H43.9721V60.6411H43.6934V60.7805H43.554V60.9199H43.4146V61.0593H43.2752V61.1986H43.1359V61.338H42.8571V61.4774H42.7177V61.6167H42.5784V61.7561H42.439V61.8955H42.2996V62.0349H42.1603V62.1742H41.8815V62.3136H41.7421V62.453H41.6028V62.5924H41.4634V62.7317H41.324V62.8711H41.0453V63.0105H40.9059V63.1498H40.7665V63.2892H40.6272V63.4286H40.4878V63.568H40.209V63.7073H40.0697V63.8467H39.9303V63.9861H39.7909V64.1255H39.6515V64.2648H39.3728V64.4042H39.2334V64.5436H39.0941V64.6829H38.9547V64.8223H38.8153V64.9617H38.5366V65.1011H38.3972V65.2404H38.2578V65.3798H38.1184V65.5192H37.9791V65.6586H37.7003V65.7979H37.561V65.9373H37.4216V66.0767H37.2822V66.216H37.1428V66.3554H36.8641V66.4948H36.7247V66.6342H36.5853V66.7735H36.446V66.9129H36.3066V67.0523H36.1672V67.1917H35.8885V67.331H35.7491V67.4704H35.6097V67.6098H35.4704V67.7491H35.331V67.8885H35.0522V68.0279H34.9129V68.1673H34.7735V68.3066H34.6341V68.446H34.4947V68.5854H34.216V68.446H34.0766V68.1673H33.9373V68.0279H33.7979V67.8885H33.6585V67.7491H33.5191V67.6098H33.3798V67.331H33.2404V67.1917H33.101V67.0523H32.9616V66.9129H32.8223V66.7735H32.6829V66.4948H32.5435V66.3554H32.4042V66.216H32.2648V66.0767H32.1254V65.9373H31.986V65.6586H31.8467V65.5192H31.7073V65.3798H31.5679V65.2404H31.4285V65.1011H31.2892V64.9617H31.1498V64.6829H31.0104V64.5436H30.8711V64.4042H30.7317V64.2648H30.5923V64.1255H30.4529V63.8467H30.3136V63.7073H30.1742V63.568H30.0348V63.4286H29.8954V63.2892H29.7561V63.0105H29.6167V62.8711H29.7561V62.7317H29.8954V62.5924H30.1742V62.453H30.3136V62.3136H30.4529V62.1742H30.5923V62.0349H30.7317V61.8955H31.0104V61.7561H31.1498V61.6167H31.2892V61.4774H31.4285V61.338H31.5679V61.1986H31.8467V61.0593H31.986V60.9199H32.1254V60.7805H32.2648V60.6411H32.4042V60.5018H32.5435V60.3624H32.8223V60.223H32.9616V60.0836H33.101V59.9443H33.2404V59.8049H33.3798V59.6655H33.6585V59.5262H33.7979V59.3868H33.9373V59.2474H34.0766V59.108H34.216V58.9687H34.4947V58.8293H34.6341V58.6899H34.7735V58.5505H34.9129V58.4112H35.0522V58.2718H35.331V58.1324H35.4704V57.9931H35.6097V57.8537H35.7491V57.7143H35.8885V57.5749H36.1672V57.4356H36.3066V57.2962H36.446V57.1568H36.5853V57.0174H36.7247V56.8781H36.8641V56.7387H37.1428V56.5993H37.2822V56.46H37.4216V56.3206H37.561V56.1812H37.7003V56.0418H37.9791V55.9025H38.1184V55.7631H38.2578V55.6237H38.3972V55.4843H38.5366V55.345H38.8153V55.2056H38.9547V55.0662H39.0941V54.9268H39.2334V54.7875H39.3728V54.6481H39.6515V54.5087H39.7909V54.3694H39.9303V54.23H40.0697V54.0906H40.209V53.9512H40.4878V53.8119H40.6272V53.6725H40.7665V53.5331H40.9059V53.3937H41.0453V53.2544H41.1846V53.115H41.4634V52.9756H41.6028V52.8363H41.7421V52.6969H41.8815V52.5575H42.0209V52.4181H42.2996V52.2788H42.439V52.1394H42.5784V52H42.7177V51.8606H42.8571V51.7213H43.1359V51.5819H43.2752V51.4425H43.4146V51.3032H43.554V51.1638H43.6934V51.0244H43.9721V50.885H44.1115V50.7457H44.2508V50.6063H44.3902V50.4669H44.5296V50.3275H44.669V50.1882H44.9477V50.0488H45.0871V49.9094H45.2265V49.7701H45.3658V49.6307H45.5052V49.4913H45.7839V49.3519H45.9233V49.2126H46.0627V49.0732H46.2021V48.9338H46.3414V48.7944H46.6202V48.6551H46.7596V48.5157H46.8989V48.3763H47.0383V48.237H47.1777V48.0976H47.317V47.9582H47.5958V47.8188H47.7352V47.6795H47.8745V47.5401H48.0139V47.4007H48.1533V47.2613H48.432V47.122H48.5714V46.9826H48.7108V46.8432H48.8501V46.7039H48.9895V46.5645H49.2683V46.4251H49.4076V46.2857H49.547V46.1464H49.6864V46.007H49.8258V45.8676H50.1045V45.7282H50.2439V45.5889H50.3833V45.4495H50.5226V45.3101H50.662V45.1708H50.9407V45.0314H51.0801V44.892H51.2195V44.7526H51.3589V44.6133H51.4982V44.4739H51.777V44.3345H51.9164V44.1951H52.0557V44.0558H52.1951V43.9164H52.3345V43.777H52.6132V43.6377H52.7526V43.4983H52.892V43.3589H53.0313V43.2195H53.1707V43.0802H53.3101V42.9408H53.5888V42.8014H53.7282V42.662H53.8676V42.5227H54.0069V42.3833H54.1463V42.2439H54.4251V42.1045H54.5644V41.9652H54.7038V41.8258H54.8432V41.6864H54.9826V41.5471Z"
        fill="#51AB39"
      />
    </g>
    <defs>
      <clipPath id="stackby_clip0">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ClickhouseAi = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clickhouse_clip0)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      <path
        d="M25.4798 22H22.4091C22.1831 22 22 22.1831 22 22.4091V56.5909C22 56.8169 22.1831 57 22.4091 57H25.4798C25.7057 57 25.8889 56.8169 25.8889 56.5909V22.4091C25.8889 22.1831 25.7057 22 25.4798 22Z"
        fill="black"
      />
      <path
        d="M33.2581 22H30.1873C29.9614 22 29.7783 22.1831 29.7783 22.4091V56.5909C29.7783 56.8169 29.9614 57 30.1873 57H33.2581C33.484 57 33.6671 56.8169 33.6671 56.5909V22.4091C33.6671 22.1831 33.484 22 33.2581 22Z"
        fill="black"
      />
      <path
        d="M41.0363 22H37.9655C37.7396 22 37.5565 22.1831 37.5565 22.4091V56.5909C37.5565 56.8169 37.7396 57 37.9655 57H41.0363C41.2622 57 41.4453 56.8169 41.4453 56.5909V22.4091C41.4453 22.1831 41.2622 22 41.0363 22Z"
        fill="black"
      />
      <path
        d="M48.8126 22H45.7418C45.5159 22 45.3328 22.1831 45.3328 22.4091V56.5909C45.3328 56.8169 45.5159 57 45.7418 57H48.8126C49.0385 57 49.2216 56.8169 49.2216 56.5909V22.4091C49.2216 22.1831 49.0385 22 48.8126 22Z"
        fill="black"
      />
      <path
        d="M56.5927 35.6119H53.5219C53.296 35.6119 53.1129 35.795 53.1129 36.0209V42.9806C53.1129 43.2065 53.296 43.3897 53.5219 43.3897H56.5927C56.8186 43.3897 57.0018 43.2065 57.0018 42.9806V36.0209C57.0018 35.795 56.8186 35.6119 56.5927 35.6119Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clickhouse_clip0">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FloatAi = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#float_clip0)">
      <circle cx="40" cy="40" r="40" fill="#F7F7F7" />
      <g clipPath="url(#float_clip1)">
        <path
          d="M26.4548 29.7923L40.4041 42.7777C42.2232 44.4711 45.0766 44.3748 46.7775 42.5627C48.4783 40.7506 48.3825 37.9088 46.5634 36.2154L32.6142 23.2301C30.7951 21.5367 27.9416 21.633 26.2408 23.4451C24.5399 25.2572 24.6358 28.0989 26.4548 29.7923Z"
          fill="#86BFF4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.5 22C27.0147 22 25 24.0147 25 26.5C25 28.9853 27.0147 31 29.5 31H59.5C61.9852 31 64 28.9853 64 26.5C64 24.0147 61.9852 22 59.5 22H29.5ZM20.4 39.5C20.4 37.0147 22.4147 35 24.9 35H43.5C45.9852 35 48 37.0147 48 39.5C48 41.9853 45.9852 44 43.5 44H24.9C22.4147 44 20.4 41.9853 20.4 39.5ZM16 52.5C16 50.0148 18.0147 48 20.5 48H27.5C29.9853 48 32 50.0148 32 52.5C32 54.9852 29.9853 57 27.5 57H20.5C18.0147 57 16 54.9852 16 52.5Z"
          fill="#2E5FE8"
        />
      </g>
    </g>
    <defs>
      <clipPath id="float_clip0">
        <rect width="80" height="80" fill="white" />
      </clipPath>
      <clipPath id="float_clip1">
        <rect width="48" height="35" fill="white" transform="translate(16 22)" />
      </clipPath>
    </defs>
  </svg>
);

export const AppsflyerAi = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_appsflyer)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      <path
        d="M22.1792 32.7036L28.281 44.0069C28.6811 44.8071 29.6814 45.4073 30.5816 45.4073H42.9852C43.7854 45.4073 44.1855 44.8071 43.7854 44.0069L37.6837 32.7036C37.2835 31.9034 36.2833 31.3032 35.383 31.3032H22.8794H22.7794C22.0792 31.3032 21.7791 31.9034 22.1792 32.7036Z"
        fill="#7AD143"
      />
      <path
        d="M45.6859 45.8074L49.387 52.5093C49.587 53.0095 50.1872 53.3096 50.7874 53.3096L58.0895 53.2095C58.5896 53.2095 58.7897 52.8094 58.5896 52.4093L54.8886 45.7074C54.6885 45.2073 54.0883 44.9072 53.4882 44.9072L46.086 45.0072C45.6859 45.0072 45.3858 45.4073 45.6859 45.8074Z"
        fill="#7AD143"
      />
      <path
        d="M45.6859 20.4001L38.3838 29.6028C37.8837 30.2029 37.8837 31.4033 38.2838 32.1035L44.3856 43.3067C44.7857 44.1069 45.4859 44.2069 46.086 43.5067L53.4882 34.3041C53.9883 33.7039 53.9883 32.5036 53.5882 31.8034L47.3864 20.7002C47.1864 20.3001 46.7862 20 46.3861 20C46.1861 20 45.986 20.1 45.6859 20.4001Z"
        fill="#00C2FF"
      />
      <path
        d="M43.9855 45.9074L39.5842 51.409C39.2841 51.8091 39.1841 52.4092 39.4842 52.9094L43.1852 59.6113C43.3853 60.1115 43.8854 60.1115 44.1855 59.7113L48.5868 54.2098C48.8869 53.8096 48.9869 53.2095 48.6868 52.7093L45.0858 46.0074C44.9857 45.8074 44.6857 45.6073 44.5856 45.6073C44.2855 45.7073 44.1855 45.7073 43.9855 45.9074Z"
        fill="#00C2FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_appsflyer">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MariaDB = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_mariadb)">
      <mask
        id="mask0_mariadb"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_mariadb)">
        <path
          d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
          fill="#F7F7F7"
        />
      </g>
      <g clipPath="url(#clip1_mariadb)">
        <path
          d="M21.9677 54.1279L23.9662 61.8825H22.4576L21.1264 56.2967L18.6168 61.8825H17.3424L14.8469 56.3287L13.4767 61.8825H12L13.9808 54.1279H15.2871L17.9849 60.1321L20.6721 54.1279H21.9677Z"
          fill="#003545"
        />
        <path
          d="M29.6654 57.1246V56.2219H31.1226V61.8825H29.6654V60.9708C29.2802 61.6261 28.4887 62.0018 27.5249 62.0018C25.5104 62.0018 24.3869 60.5773 24.3869 58.9391C24.3869 57.3597 25.4518 56.0901 27.3101 56.0901C28.3697 56.1026 29.2483 56.4587 29.6654 57.1246ZM25.9381 59.0157C25.9381 60.0573 26.5913 60.9494 27.855 60.9494C29.0744 60.9494 29.7382 60.0787 29.7382 59.0477C29.7382 58.0167 29.0531 57.1353 27.7858 57.1353C26.5718 57.1353 25.9399 58.0149 25.9399 59.0157H25.9381Z"
          fill="#003545"
        />
        <path
          d="M34.4079 61.8825H32.9525V56.2218H34.4079V57.4897C34.5743 57.0841 34.8558 56.7364 35.2173 56.4898C35.5789 56.2432 36.0047 56.1086 36.4419 56.1025C36.7518 56.0983 37.06 56.1489 37.3524 56.2521L37.0418 57.3205C36.7903 57.2535 36.5316 57.2177 36.2715 57.2137C35.2208 57.2137 34.4079 58.0078 34.4079 59.1723V61.8825Z"
          fill="#003545"
        />
        <path
          d="M38.0801 54.7279C38.0772 54.6252 38.0956 54.5231 38.1342 54.4279C38.1727 54.3327 38.2305 54.2466 38.3039 54.1749C38.3773 54.1033 38.4647 54.0477 38.5606 54.0117C38.6565 53.9757 38.7588 53.9601 38.861 53.9658C38.9652 53.9624 39.069 53.9803 39.1661 54.0184C39.2632 54.0566 39.3515 54.1141 39.4258 54.1876C39.5 54.261 39.5585 54.3488 39.5978 54.4457C39.6371 54.5426 39.6564 54.6465 39.6544 54.7511C39.6564 54.8541 39.637 54.9565 39.5972 55.0516C39.5575 55.1466 39.4983 55.2323 39.4236 55.3031C39.3489 55.3738 39.2602 55.4281 39.1634 55.4625C39.0665 55.4968 38.9635 55.5105 38.861 55.5025C38.758 55.507 38.6553 55.49 38.5591 55.4528C38.4629 55.4156 38.3754 55.3588 38.3021 55.2861C38.2288 55.2134 38.1713 55.1263 38.1331 55.0303C38.0948 54.9342 38.0768 54.8313 38.0801 54.7279ZM38.144 56.2219H39.6012V60.3583C39.6012 60.6147 39.6544 60.7981 39.8674 60.7981C39.961 60.7957 40.0543 60.785 40.1461 60.766L40.3715 61.8344C40.0647 61.9557 39.7374 62.0162 39.4077 62.0125C38.7971 62.0125 38.144 61.8344 38.144 60.4437V56.2219Z"
          fill="#003545"
        />
        <path
          d="M46.1097 57.1246V56.2219H47.5722V61.8825H46.115V60.9708C45.7298 61.6261 44.9382 62.0018 43.9745 62.0018C41.9618 62.0018 40.8365 60.5773 40.8365 58.9391C40.8365 57.3597 41.9014 56.0901 43.7597 56.0901C44.814 56.1026 45.6926 56.4587 46.1097 57.1246ZM42.3824 59.0157C42.3824 60.0573 43.0356 60.9494 44.2993 60.9494C45.5204 60.9494 46.1842 60.0787 46.1842 59.0477C46.1842 58.0167 45.4973 57.1353 44.2318 57.1353C43.016 57.1353 42.3842 58.0149 42.3842 59.0157H42.3824Z"
          fill="#003545"
        />
        <path
          d="M49.8032 54.1279H53.2944C56.2282 54.1279 57.6943 55.75 57.673 58.0043C57.6943 60.3476 56.0756 61.8825 53.5517 61.8825H49.8032V54.1279ZM50.7669 54.8152V61.2059H53.4292C55.7632 61.2059 56.6524 59.6264 56.6524 57.9829C56.6524 56.1257 55.5396 54.8152 53.4292 54.8152H50.7669Z"
          fill="#003545"
        />
        <path
          d="M63.626 61.8825H59.1888V54.1279H63.1911C64.7211 54.1279 66.1783 54.4163 66.157 56.1364C66.157 57.349 65.4062 57.6838 64.6146 57.812C65.7381 57.9081 66.4143 58.6275 66.4143 59.7885C66.4214 61.5282 64.9003 61.8825 63.626 61.8825ZM63.2941 57.5111C64.8258 57.5111 65.1684 56.9199 65.1684 56.1685C65.1684 55.0395 64.4832 54.7831 63.2941 54.7831H60.1135V57.5111H63.2941ZM63.3367 58.1663H60.1135V61.2272H63.4751C64.4176 61.2272 65.4133 60.9156 65.4133 59.7244C65.4133 58.3497 64.2685 58.1663 63.3367 58.1663Z"
          fill="#003545"
        />
        <path
          d="M66.7551 17.1692C66.6136 17.0523 66.4341 16.992 66.251 17C65.7487 17 65.0991 17.3419 64.7495 17.5253L64.611 17.5965C64.0245 17.8814 63.386 18.0426 62.735 18.0702C62.0676 18.0915 61.4926 18.1307 60.7436 18.209C56.3064 18.6667 54.3274 22.0784 52.4211 25.3779C51.3828 27.1727 50.3108 29.037 48.8412 30.4615C48.5371 30.7573 48.214 31.0327 47.8739 31.286C46.3528 32.4202 44.443 33.2304 42.9575 33.8038C41.5269 34.3522 39.965 34.8454 38.4564 35.3227C37.0737 35.7589 35.7692 36.172 34.5694 36.619C34.0281 36.8202 33.5684 36.9751 33.1619 37.1104C32.0686 37.4665 31.2805 37.739 30.1286 38.5349C29.6796 38.843 29.2288 39.1759 28.9235 39.4252C28.0091 40.1572 27.1998 41.0122 26.5185 41.9662C25.9327 42.8462 25.2556 43.6615 24.4987 44.3985C24.2556 44.6371 23.8243 44.7546 23.1782 44.7546C22.4221 44.7546 21.5045 44.5979 20.5336 44.4323C19.5326 44.2543 18.4978 44.0851 17.6104 44.0851C16.8898 44.0851 16.3378 44.2026 15.926 44.4412C15.926 44.4412 15.2321 44.8472 14.9392 45.3725L15.2267 45.5025C15.6726 45.745 16.0854 46.0443 16.455 46.3928C16.8405 46.7501 17.2699 47.0564 17.7329 47.3045C17.8806 47.3589 18.015 47.4445 18.1269 47.5556C18.0062 47.7336 17.8287 47.9633 17.6424 48.2091C16.6182 49.5534 16.0201 50.4028 16.3627 50.8657C16.5268 50.9513 16.7102 50.993 16.8951 50.9868C19.1279 50.9868 20.3277 50.4046 21.8453 49.6674C22.2854 49.4537 22.7327 49.2347 23.2652 49.0086C24.1526 48.6222 25.1075 48.0061 26.121 47.3543C27.4468 46.4872 28.833 45.5969 30.1783 45.1677C31.284 44.8295 32.4357 44.6673 33.5914 44.687C35.0113 44.687 36.5058 44.8775 37.947 45.0627C39.0208 45.2016 40.1336 45.344 41.2252 45.4099C41.6494 45.4348 42.0416 45.4473 42.4232 45.4473C42.9337 45.4488 43.4439 45.4221 43.9514 45.3672L44.0739 45.3244C44.8388 44.8526 45.1974 43.8394 45.5453 42.86C45.7689 42.2297 45.957 41.6635 46.2552 41.3038C46.2728 41.2862 46.2918 41.2701 46.312 41.2557C46.326 41.2479 46.3422 41.2451 46.358 41.2477C46.3737 41.2502 46.3882 41.2581 46.399 41.2699C46.399 41.2699 46.399 41.2789 46.399 41.2984C46.2215 45.1286 44.6844 47.5609 43.1296 49.7226L42.0913 50.839C42.0913 50.839 43.545 50.839 44.3721 50.5185C47.3894 49.614 49.6665 47.6197 51.3243 44.4395C51.7331 43.6231 52.0986 42.7856 52.4194 41.9306C52.4478 41.8593 52.7087 41.7276 52.6838 42.0962C52.6749 42.2048 52.6678 42.3259 52.659 42.4523C52.659 42.5271 52.659 42.6036 52.6448 42.6802C52.6022 43.2144 52.4762 44.3433 52.4762 44.3433L53.408 43.843C55.655 42.4185 57.3873 39.5445 58.7007 35.0734C59.2473 33.2108 59.6485 31.3608 60.0017 29.7315C60.4241 27.7728 60.7879 26.0937 61.205 25.442C61.8599 24.4199 62.8592 23.729 63.8265 23.0577C63.9579 22.9669 64.091 22.8796 64.2205 22.7835C65.4363 21.927 66.645 20.9388 66.9113 19.0958V19.0548C67.1047 17.6802 66.9414 17.3294 66.7551 17.1692Z"
          fill="#003545"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_mariadb">
        <rect width="80" height="80" fill="white" />
      </clipPath>
      <clipPath id="clip1_mariadb">
        <rect width="55" height="45" fill="white" transform="translate(12 17)" />
      </clipPath>
    </defs>
  </svg>
);

export const LaunchDarkly = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M40.439 65C40.0556 65 39.6704 64.7792 39.4507 64.3915C39.2861 64.0055 39.2861 63.6186 39.561 63.2874L51.2642 47.1L30.7694 55.498C30.6048 55.5527 30.4945 55.6075 30.3299 55.6075C29.8353 55.6075 29.3959 55.2771 29.2856 54.8338C29.121 54.3921 29.3407 53.8949 29.725 53.6193L47.7477 42.9558L16.0435 41.1328C15.3843 41.078 15 40.5807 15 40.0287C15 39.5305 15.3292 38.9785 16.0435 38.9229L47.7477 37.0998L29.725 26.4372C29.3407 26.1608 29.121 25.6635 29.2856 25.2219C29.451 24.7794 29.8353 24.4481 30.3299 24.4481C30.4945 24.4481 30.6048 24.5029 30.7694 24.5585L51.2642 32.9565L39.561 16.7135C39.3413 16.3823 39.2852 15.9398 39.4507 15.6085C39.6153 15.2217 40.0004 15 40.4399 15C40.7148 15 40.9896 15.1113 41.2093 15.3321L64.5054 38.7021C64.8354 39.0333 65 39.5305 65 39.973C65 40.4147 64.8354 40.8563 64.5054 41.2432L41.2093 64.6696C41.1091 64.7733 40.9895 64.8559 40.8574 64.9126C40.7253 64.9693 40.5826 64.999 40.439 65Z"
      fill="black"
    />
  </svg>
);

export const PostHog = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M16 46.6689C16.2901 46.7197 17.9053 46.6001 17.9746 46.6689L17.9873 46.7216C18.0023 46.9247 17.929 47.6051 17.9746 47.6513C18.0271 47.702 18.9088 47.5991 18.9629 47.6513C19.0155 47.7039 18.9085 48.5859 18.9629 48.6367C19.0196 48.6869 19.8987 48.5823 19.9512 48.6367C20.0031 48.6938 19.8969 49.5704 19.9512 49.621C20.0074 49.6714 20.8869 49.5667 20.9394 49.621C20.9915 49.6776 20.8851 50.5547 20.9394 50.6054C20.9952 50.6559 21.8752 50.5511 21.9277 50.6054C21.98 50.6614 21.8734 51.5391 21.9277 51.5898C21.972 51.6332 22.733 51.559 22.916 51.5898V53.5576H16V46.6689ZM16.0039 36.8271C16.2952 36.8776 17.9064 36.7586 17.9775 36.8271H17.9746C18.0249 36.8799 17.9221 37.7608 17.9746 37.8115C18.0282 37.862 18.9103 37.7589 18.9629 37.8115C19.0151 37.8654 18.9085 38.7451 18.9629 38.7958C19.0178 38.8465 19.8986 38.7415 19.9512 38.7958C20.0036 38.851 19.8968 39.7295 19.9512 39.7802C20.0054 39.8308 20.8814 39.7269 20.9385 39.7802C20.991 39.8346 20.8843 40.714 20.9385 40.7656C20.9929 40.8163 21.874 40.7112 21.9268 40.7656C21.9793 40.8199 21.8727 41.6979 21.9268 41.7499C21.9811 41.8007 22.8617 41.6957 22.915 41.7499C22.9676 41.8043 22.8611 42.6817 22.915 42.7343C22.9694 42.785 23.8494 42.6802 23.9033 42.7343C23.9558 42.7886 23.8495 43.6656 23.9033 43.7187C23.9576 43.7694 24.8371 43.6647 24.8916 43.7187C24.9441 43.773 24.8379 44.6494 24.8916 44.7031C24.9459 44.7538 25.8249 44.6492 25.8799 44.7031C25.9325 44.7575 25.8255 45.6377 25.8799 45.6884C25.8804 45.7448 25.9397 52.6163 25.8857 52.5781C25.8314 52.5273 24.9505 52.6324 24.8975 52.5781C24.8449 52.5237 24.9515 51.6459 24.8975 51.5937C24.8431 51.543 23.9628 51.6479 23.9092 51.5937C23.8567 51.5394 23.9631 50.6621 23.9092 50.6093C23.8548 50.5586 22.975 50.6634 22.9209 50.6093C22.8684 50.555 22.9747 49.6783 22.9209 49.6249C22.8666 49.5742 21.9873 49.6789 21.9326 49.6249C21.88 49.5705 21.987 48.6904 21.9326 48.6396C21.8765 48.5892 20.9969 48.6939 20.9443 48.6396C20.8923 48.583 20.9987 47.7059 20.9443 47.6552C20.8887 47.6047 20.0086 47.7096 19.956 47.6552C19.9038 47.5992 20.0104 46.7216 19.956 46.6708C19.9009 46.6202 19.0203 46.7252 18.9678 46.6708C18.9154 46.6154 19.0221 45.7372 18.9678 45.6865C18.9132 45.6357 18.0321 45.7409 17.9795 45.6865C17.927 45.6316 18.0338 44.7532 17.9795 44.7021C17.9251 44.6513 17.0439 44.7565 16.9912 44.7021C16.9386 44.6477 17.0456 43.7675 16.9912 43.7167C16.9437 43.6741 16.1872 43.7473 16.0039 43.7167V36.8271ZM16.0039 26.9843C16.2946 27.0348 17.903 26.9163 17.9775 26.9843H17.9746C18.0254 27.0351 17.922 27.9189 17.9746 27.9697C18.0306 28.0197 18.9104 27.9172 18.9629 27.9697C19.0146 28.0261 18.9086 28.9034 18.9629 28.954C19.0202 29.0042 19.8987 28.8997 19.9512 28.954C20.003 29.0116 19.8969 29.8877 19.9512 29.9384C20.0079 29.9886 20.8838 29.8846 20.9385 29.9384C20.991 29.9927 20.8848 30.8689 20.9385 30.9228C20.9928 30.9735 21.8715 30.869 21.9268 30.9228C21.9792 30.9771 21.8732 31.8527 21.9268 31.9072C21.9811 31.9578 22.8593 31.8535 22.915 31.9072C22.9676 31.9616 22.8606 32.8417 22.915 32.8925C22.9699 32.9432 23.8507 32.8381 23.9033 32.8925C23.9556 32.9481 23.849 33.8262 23.9033 33.8769C23.9577 33.9277 24.839 33.8225 24.8916 33.8769C24.944 33.9318 24.8373 34.81 24.8916 34.8613C24.946 34.912 25.8273 34.8069 25.8799 34.8613C25.9324 34.9156 25.8257 35.7939 25.8799 35.8456C25.8799 35.8456 25.9395 42.7545 25.8857 42.7363C25.8314 42.6856 24.9529 42.79 24.8975 42.7363C24.8449 42.6819 24.9519 41.8017 24.8975 41.7509C24.8422 41.7003 23.9617 41.8053 23.9092 41.7509C23.857 41.695 23.9635 40.8173 23.9092 40.7665C23.8544 40.7159 22.9735 40.8209 22.9209 40.7665C22.8685 40.7112 22.9752 39.833 22.9209 39.7822C22.8665 39.7314 21.9852 39.8366 21.9326 39.7822C21.8801 39.7275 21.9869 38.8492 21.9326 38.7978C21.8782 38.747 20.9972 38.8521 20.9443 38.7978C20.8918 38.7434 20.9985 37.8654 20.9443 37.8134C20.89 37.7627 20.0094 37.8676 19.956 37.8134C19.9035 37.759 20.0104 36.8788 19.956 36.8281C19.8987 36.778 19.0203 36.8824 18.9678 36.8281C18.916 36.7702 19.0221 35.8944 18.9678 35.8437C18.9108 35.7935 18.032 35.898 17.9795 35.8437C17.9276 35.7864 18.0338 34.91 17.9795 34.8593C17.923 34.809 17.0437 34.9136 16.9912 34.8593C16.9392 34.8026 17.0455 33.9256 16.9912 33.8749C16.9461 33.8318 16.1877 33.9055 16.0039 33.8749V26.9843Z"
      fill="black"
    />
    <path
      d="M36.7507 46.6756C36.8051 46.7264 37.6858 46.6214 37.739 46.6756C37.7915 46.73 37.6846 47.6102 37.739 47.661C37.7966 47.711 38.6748 47.6067 38.7272 47.661C38.779 47.7191 38.673 48.5947 38.7272 48.6453C38.7844 48.6955 39.663 48.591 39.7155 48.6453C39.7674 48.7029 39.6612 49.5791 39.7155 49.6297C39.7722 49.68 40.6513 49.5754 40.7038 49.6297C40.7558 49.6866 40.6495 50.5634 40.7038 50.6141C40.7599 50.6644 41.6358 50.5604 41.6911 50.6141C41.7436 50.6684 41.6376 51.544 41.6911 51.5985C41.7346 51.642 42.4955 51.5678 42.6794 51.5985V53.5662H36.7507C36.7507 53.5662 36.6964 46.6317 36.7507 46.6756ZM36.7429 35.8455C36.7429 35.8455 37.6754 35.7917 37.7311 35.8455C37.7837 35.8999 37.6768 36.7801 37.7311 36.8309C37.7863 36.8815 38.6669 36.7765 38.7194 36.8309C38.7717 36.8867 38.6651 37.7645 38.7194 37.8153C38.7741 37.866 39.6551 37.7609 39.7077 37.8153C39.7601 37.8704 39.6534 38.7486 39.7077 38.7996C39.7621 38.8504 40.6434 38.7452 40.696 38.7996C40.7485 38.8542 40.6418 39.7325 40.696 39.784C40.7504 39.8348 41.6313 39.7297 41.6843 39.784C41.7368 39.8384 41.6302 40.7163 41.6843 40.7684C41.7386 40.8191 42.619 40.7142 42.6726 40.7684C42.7251 40.8228 42.6182 41.703 42.6726 41.7537C42.7298 41.8039 43.6083 41.6994 43.6608 41.7537C43.7126 41.8115 43.6066 42.6875 43.6608 42.7381C43.7177 42.7883 44.5966 42.6838 44.6491 42.7381C44.701 42.7953 44.5948 43.6718 44.6491 43.7225C44.6947 43.7656 45.4545 43.6917 45.6374 43.7225V51.5955H43.6628C43.632 51.4147 43.7055 50.6585 43.6628 50.6112C43.6103 50.5587 42.7303 50.663 42.6745 50.6112C42.6219 50.5586 42.7289 49.6766 42.6745 49.6258C42.6196 49.5752 41.7388 49.6802 41.6862 49.6258C41.6339 49.5703 41.7406 48.6922 41.6862 48.6414C41.6318 48.5907 40.7505 48.6958 40.6979 48.6414C40.6455 48.5865 40.7522 47.7083 40.6979 47.6571C40.6436 47.6063 39.7623 47.7115 39.7097 47.6571C39.6571 47.6027 39.7638 46.7245 39.7097 46.6727C39.6553 46.6219 38.7746 46.7269 38.7214 46.6727C38.6689 46.6183 38.7754 45.7406 38.7214 45.6883C38.667 45.6376 37.7868 45.7424 37.7331 45.6883C37.6805 45.6339 37.7875 44.7537 37.7331 44.703C37.676 44.6528 36.7973 44.7573 36.7448 44.703C36.6929 44.6177 36.7972 35.8962 36.7429 35.8455ZM36.7341 26.9842C37.0239 27.0349 38.6366 26.9158 38.7087 26.9842H38.7106C38.7614 27.035 38.6581 27.9188 38.7106 27.9696C38.7656 28.0198 39.6464 27.9171 39.6989 27.9696C39.7508 28.025 39.6446 28.9033 39.6989 28.9539C39.7551 29.0043 40.6347 28.8996 40.6872 28.9539C40.7393 29.0106 40.6329 29.8876 40.6872 29.9383C40.7429 29.9888 41.6229 29.884 41.6755 29.9383C41.7277 29.9943 41.6211 30.872 41.6755 30.9227C41.7307 30.9733 42.6112 30.8683 42.6638 30.9227C42.7161 30.9781 42.6094 31.8563 42.6638 31.9071C42.7185 31.9578 43.5995 31.8527 43.652 31.9071C43.7045 31.962 43.5977 32.8417 43.652 32.8924C43.7109 32.9422 44.5869 32.8382 44.6394 32.8924C44.6919 32.9469 44.5852 33.825 44.6394 33.8768C44.6828 33.9203 45.444 33.8461 45.6276 33.8768V41.7498H44.6394C44.6067 41.5685 44.6847 40.808 44.6394 40.7645C44.5825 40.7129 43.7046 40.8187 43.652 40.7645C43.5995 40.7101 43.7062 39.8321 43.652 39.7801C43.5977 39.7294 42.717 39.8343 42.6638 39.7801C42.6112 39.7258 42.7178 38.8483 42.6638 38.7957C42.6094 38.745 41.7293 38.8498 41.6755 38.7957C41.623 38.7414 41.7293 37.8644 41.6755 37.8114C41.6211 37.7607 40.7416 37.8653 40.6872 37.8114C40.6347 37.7571 40.7409 36.8806 40.6872 36.827C40.6329 36.7763 39.7539 36.8808 39.6989 36.827C39.6463 36.7726 39.7533 35.8924 39.6989 35.8416C39.6431 35.7912 38.7632 35.896 38.7106 35.8416C38.6585 35.7853 38.765 34.908 38.7106 34.8573C38.6553 34.8067 37.7749 34.9116 37.7224 34.8573C37.6701 34.8015 37.7767 33.9236 37.7224 33.8729C37.6784 33.8295 36.9172 33.9037 36.7341 33.8729V26.9842Z"
      fill="black"
    />
    <path
      d="M25.8796 35.8457C25.9357 35.8961 26.8154 35.7914 26.8679 35.8457C26.92 35.9022 26.8136 36.7794 26.8679 36.8301C26.9235 36.8806 27.8037 36.7757 27.8562 36.8301C27.9084 36.886 27.8019 37.7637 27.8562 37.8145C27.9113 37.8651 28.7919 37.7601 28.8445 37.8145C28.8968 37.8698 28.7901 38.7481 28.8445 38.7988C28.8991 38.8496 29.7802 38.7444 29.8328 38.7988C29.8853 38.8536 29.7784 39.7334 29.8328 39.7842C29.8915 39.834 30.7676 39.7299 30.8201 39.7842C30.8726 39.8385 30.7659 40.7166 30.8201 40.7686C30.8744 40.8193 31.7552 40.7143 31.8084 40.7686C31.8609 40.8229 31.7543 41.7005 31.8084 41.7529C31.8627 41.8037 32.7429 41.6988 32.7966 41.7529C32.8491 41.8073 32.7428 42.6844 32.7966 42.7373C32.851 42.788 33.7306 42.6833 33.7849 42.7373C33.8374 42.7916 33.7312 43.6682 33.7849 43.7217C33.8392 43.7724 34.7184 43.6678 34.7732 43.7217C34.8258 43.7761 34.7188 44.6563 34.7732 44.707C34.8291 44.7575 35.7089 44.6527 35.7615 44.707C35.8136 44.7635 35.7072 45.6407 35.7615 45.6914C35.8169 45.742 36.6972 45.637 36.7498 45.6914C36.8019 45.7601 36.7502 53.4962 36.7498 53.5654H35.7673C35.7367 53.3835 35.8107 52.625 35.7673 52.5811C35.7148 52.5285 34.8317 52.6336 34.7791 52.5811C34.7265 52.5285 34.8332 51.6485 34.7791 51.5967C34.7247 51.5459 33.8439 51.6509 33.7908 51.5967C33.7382 51.5423 33.8448 50.6647 33.7908 50.6123C33.7364 50.5616 32.8562 50.6664 32.8025 50.6123C32.75 50.558 32.8564 49.6809 32.8025 49.6279C32.7482 49.5772 31.8685 49.6819 31.8142 49.6279C31.7616 49.5735 31.8686 48.6934 31.8142 48.6426C31.7578 48.5923 30.8784 48.6969 30.8259 48.6426C30.774 48.5856 30.8802 47.7089 30.8259 47.6582C30.77 47.6078 29.8902 47.7126 29.8377 47.6582C29.7855 47.6018 29.892 46.7245 29.8377 46.6738C29.7822 46.6233 28.9019 46.7282 28.8494 46.6738C28.7971 46.618 28.9037 45.7402 28.8494 45.6895C28.7944 45.6388 27.9137 45.7438 27.8611 45.6895C27.8087 45.6342 27.9155 44.7558 27.8611 44.7051C27.8066 44.6543 26.9254 44.7595 26.8728 44.7051C26.8203 44.6504 26.9272 43.7705 26.8728 43.7197H25.8796C25.8792 43.6503 25.8255 35.7952 25.8796 35.8457ZM25.8796 45.6856C25.934 45.7363 26.8134 45.6316 26.8679 45.6856C26.9205 45.7399 26.8135 46.6201 26.8679 46.6709C26.9242 46.7212 27.8037 46.6166 27.8562 46.6709C27.9082 46.7276 27.8019 47.6046 27.8562 47.6553C27.912 47.7057 28.792 47.6009 28.8445 47.6553C28.8967 47.7114 28.7902 48.5889 28.8445 48.6397C28.8998 48.6902 29.7802 48.5853 29.8328 48.6397C29.8851 48.6952 29.7784 49.5733 29.8328 49.624C29.8876 49.6747 30.7685 49.5696 30.8211 49.624C30.8735 49.679 30.7667 50.5575 30.8211 50.6084C30.8753 50.659 31.7511 50.5551 31.8084 50.6084C31.8609 50.6628 31.7542 51.542 31.8084 51.5938C31.8518 51.6372 32.6129 51.5631 32.7966 51.5938V53.5606H25.8796C25.8793 53.5161 25.8257 45.6542 25.8796 45.6856ZM27.8484 26.9844C28.0295 27.0152 28.7897 26.9394 28.8367 26.9844C28.8892 27.0369 28.7829 27.9153 28.8367 27.9688C28.891 28.0195 29.7702 27.9149 29.825 27.9688C29.8775 28.0231 29.7706 28.9033 29.825 28.9541C29.8809 29.0045 30.7607 28.8998 30.8132 28.9541C30.8653 29.0106 30.7589 29.8878 30.8132 29.9385C30.8687 29.989 31.749 29.8841 31.8015 29.9385C31.8537 29.9944 31.7472 30.8721 31.8015 30.9229C31.8565 30.9735 32.7372 30.8685 32.7898 30.9229C32.8422 30.9782 32.7354 31.8565 32.7898 31.9072C32.8443 31.958 33.7255 31.8528 33.7781 31.9072C33.8306 31.962 33.7238 32.8404 33.7781 32.8916C33.8325 32.9424 34.7136 32.8372 34.7664 32.8916C34.8189 32.946 34.712 33.8262 34.7664 33.877C34.8245 33.9269 35.7022 33.8227 35.7546 33.877C35.8063 33.9354 35.7004 34.8107 35.7546 34.8613C35.8123 34.9113 36.6883 34.8073 36.7419 34.8613C36.7945 34.9157 36.6881 35.7927 36.7419 35.8457C36.7419 35.8457 36.7983 43.7695 36.7439 43.7188C36.6885 43.6682 35.8082 43.7731 35.7556 43.7188C35.7033 43.6631 35.81 42.7851 35.7556 42.7344C35.7007 42.6837 34.8199 42.7888 34.7673 42.7344C34.7149 42.6793 34.8217 41.7998 34.7673 41.749C34.7083 41.6993 33.8325 41.8033 33.78 41.749C33.7276 41.6943 33.8342 40.8162 33.78 40.7647C33.7256 40.7139 32.8446 40.819 32.7918 40.7647C32.7392 40.7103 32.8458 39.8324 32.7918 39.7803C32.7374 39.7295 31.8569 39.8345 31.8035 39.7803C31.751 39.7259 31.8574 38.8485 31.8035 38.7959C31.7491 38.7452 30.8692 38.85 30.8152 38.7959C30.7627 38.7416 30.869 37.8647 30.8152 37.8115C30.7609 37.7608 29.8814 37.8655 29.8269 37.8115C29.7743 37.7571 29.8813 36.8769 29.8269 36.8262C29.7707 36.7758 28.8912 36.8805 28.8386 36.8262C28.7866 36.7694 28.8929 35.8925 28.8386 35.8418C28.7829 35.7913 27.9029 35.8962 27.8503 35.8418C27.7982 35.7856 27.9047 34.9081 27.8503 34.8574C27.7951 34.8068 26.9146 34.9118 26.8621 34.8574C26.8098 34.8018 26.9164 33.9238 26.8621 33.873C26.8165 33.8278 26.0569 33.9057 25.8738 33.873V26H27.8484V26.9844Z"
      fill="black"
    />
    <path
      d="M49.5733 37.8093C49.6241 37.8601 49.5207 38.7431 49.5733 38.7939C49.6259 38.8446 50.5089 38.7413 50.5615 38.7939C50.6141 38.8464 50.5071 39.7277 50.5615 39.7784C50.6159 39.8292 51.4971 39.724 51.5497 39.7784C51.6023 39.8328 51.4953 40.7122 51.5497 40.763C51.6041 40.8138 52.4853 40.7086 52.5379 40.763C52.5905 40.8174 52.4835 41.6968 52.5379 41.7476C52.5923 41.7983 53.4735 41.6932 53.5261 41.7476C53.5787 41.802 53.4717 42.6814 53.5261 42.7321C53.5805 42.7829 54.4617 42.6777 54.5143 42.7321C54.5669 42.7865 54.4599 43.6659 54.5143 43.7167C54.5687 43.7675 55.4499 43.6623 55.5025 43.7167C55.555 43.7711 55.4481 44.6505 55.5025 44.7013C55.5569 44.752 56.4381 44.6469 56.4907 44.7013C56.5432 44.7557 56.4363 45.6351 56.4907 45.6858C56.5451 45.7366 57.4263 45.6314 57.4789 45.6858C57.5314 45.7402 57.4245 46.6196 57.4789 46.6704C57.5333 46.7212 58.4145 46.616 58.4671 46.6704C58.5196 46.7248 58.4127 47.6042 58.4671 47.655C58.5215 47.7058 59.4027 47.6006 59.4553 47.655C59.5078 47.7094 59.4009 48.5888 59.4553 48.6396C59.5097 48.6903 60.3909 48.587 60.4435 48.6396C60.487 48.6831 60.4126 49.4428 60.4435 49.6241H63.4062C63.4371 49.8054 63.3627 50.5652 63.4062 50.6087C63.4497 50.6522 64.2113 50.5779 64.3944 50.6087V52.576C64.2113 52.6069 63.4497 52.5325 63.4062 52.576C63.3627 52.6195 63.4371 53.3793 63.4062 53.5606H48.5942C48.5633 53.3793 48.6377 52.6195 48.5942 52.576C48.5506 52.5325 47.7891 52.6069 47.606 52.576V37.8147C47.8961 37.8655 49.5116 37.7458 49.5805 37.8147L49.5733 37.8093ZM53.5224 46.6668C53.4517 46.5979 51.838 46.7176 51.5479 46.6668C51.517 46.8481 51.5914 47.6078 51.5479 47.6514C51.5043 47.6949 50.7428 47.6205 50.5597 47.6514V49.6187C50.7428 49.6495 51.5043 49.5752 51.5479 49.6187C51.5914 49.6622 51.517 50.4219 51.5479 50.6033H53.5224C53.5533 50.4219 53.4789 49.6622 53.5224 49.6187C53.566 49.5752 54.3275 49.6495 54.5106 49.6187V47.6514C54.3275 47.6205 53.566 47.6949 53.5224 47.6514C53.4717 47.6006 53.575 46.7176 53.5224 46.6668Z"
      fill="black"
    />
  </svg>
);

export const Shipstation = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M63.9849 36.3203C60.5275 36.3203 57.7245 33.5165 57.7245 30.0583C57.7245 28.3302 58.4257 26.7646 59.5561 25.6321L54.3553 20.4301C53.2231 21.5626 51.6581 22.2621 49.9305 22.2621C46.4731 22.2621 43.6701 19.4582 43.6701 16H36.3167C36.3167 19.4602 33.5137 22.264 30.0564 22.264C28.3287 22.264 26.7637 21.5626 25.6315 20.432L20.4308 25.6341C21.563 26.7666 22.2623 28.3321 22.2623 30.0603C22.2623 33.5185 19.4593 36.3223 16.002 36.3223L16 43.6797C19.4573 43.6797 22.2623 46.4835 22.2623 49.9417C22.2623 51.6699 21.5611 53.2355 20.4308 54.3679L25.6315 59.5699C26.7637 58.4375 28.3287 57.7379 30.0564 57.7379C33.5137 57.7379 36.3167 60.5419 36.3167 64.0001H43.6701C43.6701 60.5399 46.4731 57.7361 49.9305 57.7361C51.6581 57.7361 53.2231 58.4355 54.3553 59.5681L59.5561 54.3659C58.4239 53.2335 57.7245 51.6679 57.7245 49.9397C57.7245 46.4815 60.5275 43.6777 63.9849 43.6777V36.3203ZM52.0421 46.9597L39.9915 53.9193L27.9409 46.9597V33.0404L39.9915 26.0808L52.0421 33.0404V46.9597Z"
      fill="#003311"
    />
  </svg>
);

export const Mindbody = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_mindbody_wb)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#0F0F0F"
      />
      <path
        d="M60.6648 56.3446C57.0609 57.8937 53.51 55.7711 51.9866 52.3238C51.2196 50.5886 49.2428 44.9509 47.3826 39.927C46.8466 38.4795 44.7046 38.8646 44.7046 40.4137C44.7046 45.2281 44.6919 50.2224 44.6601 50.652C44.5987 51.5218 44.4864 55.9383 39.4629 56.7679C34.4458 57.5975 33.2297 54.0866 32.6873 52.8994C32.0665 51.5387 29.8144 45.5329 27.6575 39.9355C27.094 38.4604 24.7613 38.8879 24.9138 40.4581C25.9817 55.9806 20.5111 57.9213 17.439 56.698C13.8521 55.2695 15.0407 51.09 16.7356 48.0406C17.1445 47.3041 19.9561 42.7394 21.0853 35.0766C21.3396 33.3751 22.0599 26.0361 29.0326 25.0944C37.4523 23.9558 39.8104 32.626 40.2532 33.9338C40.8464 35.7157 43.0668 35.4131 43.0668 33.5381C43.0668 33.5381 43.0011 30.2706 43.1474 28.876C43.4291 26.1779 45.3911 22.667 49.2916 22.0914C53.1921 21.5179 55.7939 23.7019 57.2325 26.9693C57.6329 27.8772 59.3787 31.8599 60.9063 36.1686C62.6076 40.9703 64.0716 46.1338 64.3196 47.175C64.7899 49.1537 65.5928 54.2348 60.6711 56.3573L60.6648 56.3425V56.3446Z"
        fill="#AAFFD8"
      />
    </g>
    <defs>
      <clipPath id="clip0_mindbody_wb">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Statsig = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      d="M55.6193 28.9789L42.9396 47.936L36.8403 38.845L22.7125 59.9057L22.7746 60H48.196C48.6263 60.0005 49.05 59.895 49.4298 59.693C49.8097 59.4909 50.1339 59.1985 50.3739 58.8414L62.0432 41.4371C62.3285 41.0114 62.4808 40.5105 62.4808 39.998C62.4808 39.4855 62.3285 38.9846 62.0432 38.5589L55.6157 28.9753L55.6193 28.9789Z"
      fill="black"
    />
    <path
      d="M36.8403 31.3539L42.9325 40.4378L56.6043 20H31.285C30.8547 19.9995 30.431 20.1049 30.0512 20.3069C29.6713 20.509 29.3471 20.8015 29.1071 21.1586L17.4378 38.5586C17.1524 38.9843 17 39.4853 17 39.9978C17 40.5104 17.1524 41.0114 17.4378 41.4371L23.7557 50.8578L36.8403 31.3539Z"
      fill="black"
    />
  </svg>
);

export const Airwallex = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.022 25.0971C31.2832 24.7029 33.5167 25.5233 34.9969 27.2946L45.1193 39.4106L54.43 35.612C56.4994 34.7682 58.7768 35.2203 60.3753 36.7926C61.9731 38.3647 62.4808 40.6519 61.6997 42.7623L58.7591 50.7428C57.9867 52.8393 56.2279 54.4596 54.053 54.8832C53.6493 54.9616 53.2452 55 52.8465 55C51.0346 55 49.3238 54.2061 48.1227 52.768L30.489 31.6617C30.2972 31.4323 29.9314 31.496 29.827 31.7774L24.0871 47.2803C23.9684 47.6006 24.2839 47.9108 24.5978 47.7828L31.6388 44.9101C33.2993 44.2331 35.1979 45.1024 35.7686 46.8462C36.2895 48.4387 35.4142 50.1597 33.8749 50.7875L24.6766 54.5404C22.9737 55.235 21.017 55.1115 19.4842 54.0901C17.2969 52.6332 16.4636 49.8923 17.3479 47.5045L24.1273 29.1958C24.9308 27.025 26.7607 25.493 29.022 25.0971ZM55.0052 42.8776C55.1231 42.5573 54.8076 42.2474 54.4937 42.3756L49.3498 44.4742L52.4356 48.1677C52.6279 48.3975 52.9947 48.3332 53.0984 48.0509L55.0052 42.8776Z"
      fill="url(#paint0_linear_airwallex)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_airwallex"
        x1="17"
        y1="39.9999"
        x2="62.0605"
        y2="39.9999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4F42" />
        <stop offset="1" stopColor="#FF8E3C" />
      </linearGradient>
    </defs>
  </svg>
);

export const ModernTreasury = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#F7F7F7"
    />
    <path d="M40 32.8125L60 26.25V20H20V26.25L40 32.8125Z" fill="black" />
    <path d="M20 32.1875V60H29.375V35.3125L20 32.1875Z" fill="black" />
    <path d="M60 32.1875V60H50.625V35.3125L60 32.1875Z" fill="black" />
    <path
      d="M44.6876 37.1875L42.5298 37.9067C41.5912 38.2196 41.1218 38.376 40.6418 38.4382C40.2156 38.4933 39.7843 38.4933 39.3583 38.4382C38.8781 38.376 38.4088 38.2196 37.4702 37.9067L35.3125 37.1875V60H44.6876V37.1875Z"
      fill="black"
    />
  </svg>
);

export const RudderStack = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#rds_clip0_297_454)">
      <mask
        id="rds_mask0_297_454"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#rds_mask0_297_454)">
        <mask
          id="rds_mask1_297_454"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#rds_mask1_297_454)">
          <mask
            id="rds_mask2_297_454"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#rds_mask2_297_454)">
            <mask
              id="rds_mask3_297_454"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#rds_mask3_297_454)">
              <mask
                id="rds_mask4_297_454"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#rds_mask4_297_454)">
                <mask
                  id="rds_mask5_297_454"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#rds_mask5_297_454)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="rds_mask6_297_454"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#rds_mask6_297_454)">
                  <mask
                    id="rds_mask7_297_454"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#rds_mask7_297_454)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="rds_mask8_297_454"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#rds_mask8_297_454)">
                    <mask
                      id="rds_mask9_297_454"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#rds_mask9_297_454)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M20 21.9049C20 21.3997 20.2007 20.9151 20.5579 20.5579C20.9151 20.2007 21.3997 20 21.9049 20H58.8571C59.1602 20 59.4509 20.1204 59.6653 20.3347C59.8796 20.5491 60 20.8398 60 21.1429V58.0951C60 58.6003 59.7993 59.0849 59.4421 59.4421C59.0849 59.7993 58.6003 60 58.0951 60C37.0557 60 20 42.9443 20 21.9049Z"
        fill="#105ED5"
      />
    </g>
    <defs>
      <clipPath id="rds_clip0_297_454">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BrightData = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#bd_clip0_297_366)">
      <mask
        id="bd_mask0_297_366"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#bd_mask0_297_366)">
        <mask
          id="bd_mask1_297_366"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#bd_mask1_297_366)">
          <mask
            id="bd_mask2_297_366"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#bd_mask2_297_366)">
            <mask
              id="bd_mask3_297_366"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#bd_mask3_297_366)">
              <mask
                id="bd_mask4_297_366"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#bd_mask4_297_366)">
                <mask
                  id="bd_mask5_297_366"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#bd_mask5_297_366)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="bd_mask6_297_366"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#bd_mask6_297_366)">
                  <mask
                    id="bd_mask7_297_366"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#bd_mask7_297_366)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="bd_mask8_297_366"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#bd_mask8_297_366)">
                    <mask
                      id="bd_mask9_297_366"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#bd_mask9_297_366)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M32.1551 15.012C33.0664 16.7435 32.6108 18.2015 31.9728 19.7507C30.9707 22.3023 31.2439 24.7628 33.0664 26.8587C34.8889 29.0458 37.4403 29.3192 40.0832 28.7724C43.7282 27.9522 45.824 24.4894 45.2775 20.662C45.0043 18.8395 43.9106 17.0169 44.9127 15.012C44.0015 15.4677 44.0015 15.4677 42.9078 17.2903C41.9057 16.1056 40.9945 14.8298 39.9008 13.554C38.9896 12.5516 38.0783 11.6403 38.6248 10C37.5318 10.5468 36.9847 11.2758 36.6206 12.1871C36.3466 13.0984 36.165 14.0096 35.9826 14.9209C35.8002 15.8322 35.3445 16.6524 34.4333 17.1991C33.8861 16.1967 33.3396 15.4677 32.1551 15.012Z"
        fill="#3D7FFC"
      />
      <path
        d="M30 70V65.543L34.8288 64.9152V39.4286L30.376 37.9848V33.0255L42.5424 31.3934L45.114 31.1392V32.8372V64.8524L49.8799 65.543V70H30Z"
        fill="#3D7FFC"
      />
    </g>
    <defs>
      <clipPath id="bd_clip0_297_366">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Vwo = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#vwo_clip0_297_630)">
      <mask
        id="vwo_mask0_297_630"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#vwo_mask0_297_630)">
        <mask
          id="vwo_mask1_297_630"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#vwo_mask1_297_630)">
          <mask
            id="vwo_mask2_297_630"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#vwo_mask2_297_630)">
            <mask
              id="vwo_mask3_297_630"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#vwo_mask3_297_630)">
              <mask
                id="vwo_mask4_297_630"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#vwo_mask4_297_630)">
                <mask
                  id="vwo_mask5_297_630"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#vwo_mask5_297_630)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="vwo_mask6_297_630"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#vwo_mask6_297_630)">
                  <mask
                    id="vwo_mask7_297_630"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#vwo_mask7_297_630)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="vwo_mask8_297_630"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#vwo_mask8_297_630)">
                    <mask
                      id="vwo_mask9_297_630"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#vwo_mask9_297_630)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M60.6057 30C60.2336 30 59.7871 30 59.415 30.0741L57.2568 33.8519C58.2243 33.2593 59.415 32.963 60.6057 32.963C64.4755 32.963 67.6756 36.1481 67.6756 40C67.6756 43.8519 64.4755 47.037 60.6057 47.037C56.7358 47.037 53.6102 43.9259 53.5358 40.0741L51.3032 43.8519C52.7916 47.4815 56.4382 50 60.5313 50C66.0384 50 70.578 45.4815 70.578 40C70.6524 34.5185 66.1128 30 60.6057 30Z"
        fill="#BF3078"
      />
      <path
        d="M30.2423 40.4444L31.9539 37.4815L35.8238 44.0741L40.289 36.4444L44.7542 44.0741L52.4195 31.1111C52.7916 30.4444 53.5358 30 54.3544 30H56.5126L44.7542 50L40.289 42.3704L35.8238 50L30.2423 40.4444Z"
        fill="#802050"
      />
      <path
        d="M33.4423 30L21.684 50L10 30H12.1582C12.9768 30 13.721 30.4444 14.0931 31.1111L21.684 44.1481L29.3492 31.1111C29.7214 30.4444 30.4655 30 31.2842 30H33.4423Z"
        fill="#26134D"
      />
    </g>
    <defs>
      <clipPath id="vwo_clip0_297_630">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Partnerize = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#pz_clip0_297_542)">
      <mask
        id="pz_mask0_297_542"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#pz_mask0_297_542)">
        <mask
          id="pz_mask1_297_542"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#pz_mask1_297_542)">
          <mask
            id="pz_mask2_297_542"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#pz_mask2_297_542)">
            <mask
              id="pz_mask3_297_542"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#pz_mask3_297_542)">
              <mask
                id="pz_mask4_297_542"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#pz_mask4_297_542)">
                <mask
                  id="pz_mask5_297_542"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#pz_mask5_297_542)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="pz_mask6_297_542"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#pz_mask6_297_542)">
                  <mask
                    id="pz_mask7_297_542"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#pz_mask7_297_542)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="pz_mask8_297_542"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#pz_mask8_297_542)">
                    <mask
                      id="pz_mask9_297_542"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#pz_mask9_297_542)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M48.967 16.7991C53.1547 19.3684 57.2538 23.6982 58.4344 28.5387C59.5121 33.9166 59.5065 38.938 56.748 43.8137C53.0829 49.037 48.8658 52.2879 42.5292 53.5326C38.1449 53.9385 34.4026 53.0327 30.4109 51.2604C28.8962 49.7456 28.8962 49.7456 28.7068 47.8521C28.8962 45.9586 28.8962 45.9586 30.4109 44.4439C32.554 44.7186 34.4182 45.2747 36.4701 45.9586C40.5559 46.4417 43.9655 46.2442 47.4463 43.9291C49.9936 41.6985 51.2987 39.3018 51.9315 35.9824C52.1918 32.0098 51.2528 29.2422 48.9493 26.0121C46.4084 23.1486 43.6746 22.3552 39.973 22.1008C36.0782 22.2456 33.2916 23.6847 30.4109 26.2665C28.4035 29.3446 27.5917 32.5874 26.624 36.1126C25.8666 36.87 25.8666 36.87 23.9731 36.9646C22.0796 36.87 22.0796 36.87 21.3222 36.1126C20.6994 31.6977 20.8062 27.9694 23.2157 24.1363C29.2217 16.1902 39.4492 12.5377 48.967 16.7991Z"
        fill="#212322"
      />
      <path
        d="M44.044 27.024C46.0298 28.297 46.8192 29.2091 47.4996 31.4678C47.9782 34.11 47.9877 35.7207 46.9789 38.2428C44.7282 40.8686 42.9225 42.0544 39.4523 42.4085C37.2099 42.1699 36.0133 41.9716 34.1979 40.657C32.4628 38.4882 31.9486 37.0273 31.547 34.2665C32.0524 30.6656 33.1322 29.5444 35.7127 27.024C38.6323 26.0508 41.1083 26.2782 44.044 27.024Z"
        fill="#3786F0"
      />
      <path
        d="M23.9258 38.1954C24.8865 38.2892 24.8865 38.2892 25.8666 38.3848C27.7096 41.1494 27.5765 42.5038 27.5825 45.796C27.584 46.2935 27.5854 46.791 27.5869 47.3036C27.588 48.3534 27.5852 49.4032 27.5788 50.4529C27.5707 52.062 27.5788 53.6705 27.5885 55.2796C27.5875 56.2998 27.5855 57.32 27.5825 58.3403C27.5808 59.2698 27.5791 60.1993 27.5774 61.157C27.3814 63.3787 27.3814 63.3787 25.8666 64.8935C23.9258 65.0355 23.9258 65.0355 22.0796 64.8935C20.7883 63.6022 21.2253 61.981 21.217 60.259C21.2185 59.7185 21.2201 59.1781 21.2216 58.6213C21.2209 58.0694 21.2202 57.5175 21.2194 56.9489C21.2189 55.7799 21.2203 54.611 21.2235 53.442C21.2275 51.6467 21.2235 49.8516 21.2187 48.0563C21.2192 46.9232 21.2202 45.7901 21.2216 44.6569C21.2201 44.1165 21.2186 43.5761 21.217 43.0193C21.2388 38.471 21.2388 38.471 23.9258 38.1954Z"
        fill="#212322"
      />
    </g>
    <defs>
      <clipPath id="pz_clip0_297_542">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Rillet = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#rl_clip0_297_410)">
      <mask
        id="rl_mask0_297_410"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#rl_mask0_297_410)">
        <mask
          id="rl_mask1_297_410"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#rl_mask1_297_410)">
          <mask
            id="rl_mask2_297_410"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#rl_mask2_297_410)">
            <mask
              id="rl_mask3_297_410"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#rl_mask3_297_410)">
              <mask
                id="rl_mask4_297_410"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#rl_mask4_297_410)">
                <mask
                  id="rl_mask5_297_410"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#rl_mask5_297_410)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="rl_mask6_297_410"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#rl_mask6_297_410)">
                  <mask
                    id="rl_mask7_297_410"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#rl_mask7_297_410)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="rl_mask8_297_410"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#rl_mask8_297_410)">
                    <mask
                      id="rl_mask9_297_410"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#rl_mask9_297_410)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M49.1945 33.7939C48.4729 33.7939 47.8646 33.5671 47.3698 33.1135C46.8955 32.6392 46.6584 32.0619 46.6584 31.3815C46.6584 30.7011 46.8955 30.134 47.3698 29.6804C47.8646 29.2268 48.4729 29 49.1945 29C49.9368 29 50.5451 29.2268 51.0193 29.6804C51.5142 30.134 51.7616 30.7011 51.7616 31.3815C51.7616 32.0619 51.5142 32.6392 51.0193 33.1135C50.5451 33.5671 49.9368 33.7939 49.1945 33.7939ZM43.0398 51.4849V48.6395H47.8646V40.0105C47.8646 39.3301 47.5347 38.9899 46.8749 38.9899H43.4728V36.1444H47.4625C48.7409 36.1444 49.6688 36.4434 50.2461 37.0414C50.844 37.6187 51.143 38.5465 51.143 39.8249V48.6395H55.9678V51.4849H43.0398Z"
        fill="#240257"
      />
      <path
        d="M24 51.4848V29.835H31.0826C32.7733 29.835 34.1651 30.1236 35.2579 30.701C36.3713 31.2783 37.1961 32.0618 37.7322 33.0515C38.2889 34.0206 38.5672 35.1237 38.5672 36.3608C38.5672 37.7629 38.2064 39.0104 37.4848 40.1032C36.7837 41.1754 35.7012 41.9589 34.2373 42.4537L38.7837 51.4848H34.9796L30.8352 42.9177H27.2784V51.4848H24ZM27.2784 39.9485H30.897C32.3816 39.9485 33.4641 39.6186 34.1445 38.9588C34.8455 38.299 35.1961 37.433 35.1961 36.3608C35.1961 35.268 34.8558 34.402 34.1754 33.7629C33.495 33.1031 32.3919 32.7732 30.8661 32.7732H27.2784V39.9485Z"
        fill="#240257"
      />
    </g>
    <defs>
      <clipPath id="rl_clip0_297_410">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Trolley = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#tr_clip0_297_322)">
      <mask
        id="tr_mask0_297_322"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#tr_mask0_297_322)">
        <mask
          id="tr_mask1_297_322"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#tr_mask1_297_322)">
          <mask
            id="tr_mask2_297_322"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#tr_mask2_297_322)">
            <mask
              id="tr_mask3_297_322"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#tr_mask3_297_322)">
              <mask
                id="tr_mask4_297_322"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#tr_mask4_297_322)">
                <mask
                  id="tr_mask5_297_322"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#tr_mask5_297_322)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#0092FF"
                  />
                </g>
                <mask
                  id="tr_mask6_297_322"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#tr_mask6_297_322)">
                  <mask
                    id="tr_mask7_297_322"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#tr_mask7_297_322)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#0092FF"
                    />
                  </g>
                  <mask
                    id="tr_mask8_297_322"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#tr_mask8_297_322)">
                    <mask
                      id="tr_mask9_297_322"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#tr_mask9_297_322)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#0092FF"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path d="M52.7903 60.9834H27V67H52.7903V60.9834Z" fill="white" />
      <path
        d="M50.4288 28.9047H43.1929V42.2235C43.1929 45.6809 45.69 45.7452 50.4288 45.489V52.9811C39.0948 54.2617 34.9325 50.9962 34.9325 42.2235V28.9047H29.3618V20.9646H34.9325V14.4971L43.1929 12V20.9646H50.4288L50.4288 28.9047Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="tr_clip0_297_322">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Scalefusion = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#sf_clip0_297_56)">
      <mask
        id="sf_mask0_297_56"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#sf_mask0_297_56)">
        <mask
          id="sf_mask1_297_56"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#sf_mask1_297_56)">
          <mask
            id="sf_mask2_297_56"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#sf_mask2_297_56)">
            <mask
              id="sf_mask3_297_56"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#sf_mask3_297_56)">
              <mask
                id="sf_mask4_297_56"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#sf_mask4_297_56)">
                <mask
                  id="sf_mask5_297_56"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#sf_mask5_297_56)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="sf_mask6_297_56"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#sf_mask6_297_56)">
                  <mask
                    id="sf_mask7_297_56"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#sf_mask7_297_56)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="sf_mask8_297_56"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#sf_mask8_297_56)">
                    <mask
                      id="sf_mask9_297_56"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#sf_mask9_297_56)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9833 30.7152C24.0008 31.6977 21.8949 33.8032 19.6433 36.0548C18.0538 37.6443 16.3919 39.3066 15 40.6981C23.2408 46.439 30.6675 46.8914 34.2792 43.2801C35.7164 41.8424 38.1066 39.4524 40.6604 36.8981C43.0276 34.5309 47.3835 30.1754 51.6399 25.9193C51.6399 25.9193 45.9353 27.1333 39.2766 27.1333C33.324 27.1333 27.4382 28.2603 24.9833 30.7152Z"
        fill="#F4B400"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.5205 16.5762C38.7916 16.5762 31.1496 18.0393 27.9618 21.2271C25.7855 23.4031 19.3656 29.823 15 34.1886C16.3576 35.1349 17.6988 35.9697 19.0141 36.6978C21.2658 34.4462 23.3713 32.3407 24.3542 31.3582C26.8086 28.9033 32.6945 27.7763 38.6471 27.7763C45.3057 27.7763 51.0106 26.5623 51.0106 26.5623C56.8864 20.6862 62.573 15 62.573 15C62.573 15 55.166 16.5762 46.5205 16.5762Z"
        fill="#003580"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.8682 40.7089C52.8682 34.0502 54.0821 28.3459 54.0821 28.3459C49.8262 32.602 45.4703 36.9579 43.1032 39.325L36.7215 45.7067C33.1099 49.318 33.5623 56.7447 39.3036 64.9852L43.9468 60.3421L49.2865 55.0025C51.7414 52.5475 52.8682 46.6615 52.8682 40.7089Z"
        fill="#F4B400"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.0403 28.9893C53.0403 28.9893 51.8264 34.6936 51.8264 41.3522C51.8264 47.3048 50.6999 53.1907 48.2447 55.6458L42.905 60.9853C43.6332 62.3011 44.468 63.6418 45.4142 65C49.7798 60.6335 56.1996 54.2141 58.3762 52.0381C61.5635 48.8505 63.0273 41.2077 63.0273 33.4788C63.0273 24.8334 64.6033 17.4265 64.6033 17.4265C64.6033 17.4265 58.9174 23.1131 53.0403 28.9893Z"
        fill="#003580"
      />
    </g>
    <defs>
      <clipPath id="sf_clip0_297_56">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Baremetrics = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#bm_clip0_297_586)">
      <mask
        id="bm_mask0_297_586"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#bm_mask0_297_586)">
        <mask
          id="bm_mask1_297_586"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#bm_mask1_297_586)">
          <mask
            id="bm_mask2_297_586"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#bm_mask2_297_586)">
            <mask
              id="bm_mask3_297_586"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#bm_mask3_297_586)">
              <mask
                id="bm_mask4_297_586"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#bm_mask4_297_586)">
                <mask
                  id="bm_mask5_297_586"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#bm_mask5_297_586)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="bm_mask6_297_586"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#bm_mask6_297_586)">
                  <mask
                    id="bm_mask7_297_586"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#bm_mask7_297_586)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="bm_mask8_297_586"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#bm_mask8_297_586)">
                    <mask
                      id="bm_mask9_297_586"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#bm_mask9_297_586)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.4795 32.77L61.1323 37.17C61.6082 38.0713 61.857 39.0751 61.857 40.0943C61.857 41.1135 61.6082 42.1173 61.1323 43.0186L53.0866 56.7986C52.0423 58.7714 50.028 60 47.838 60H32.9809C30.7909 60 28.7766 58.7714 27.7309 56.7986L24.9537 52.0986L35.9152 41.9286L43.8566 46.5329C44.6866 47.1014 45.7995 46.95 46.4566 46.1786L58.4795 32.77ZM34.568 33.8914L22.5537 47.4114L19.7252 43.08C19.249 42.1804 19 41.1779 19 40.16C19 39.1421 19.249 38.1396 19.7252 37.24L28.2109 23.1971C28.7131 22.2371 29.4676 21.4321 30.3931 20.8688C31.3187 20.3055 32.3803 20.0051 33.4637 20H47.7637C49.9566 20 51.9723 21.2271 53.018 23.1971L55.9038 28.0571L45.1595 38.0429L37.2452 33.4471C36.8279 33.1617 36.3165 33.0484 35.8177 33.1309C35.3189 33.2134 34.8712 33.4854 34.568 33.89V33.8914Z"
        fill="#5386FF"
      />
    </g>
    <defs>
      <clipPath id="bm_clip0_297_586">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Todoist = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#td_clip0_209_220)">
      <mask
        id="td_mask0_209_220"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#td_mask0_209_220)">
        <mask
          id="td_mask1_209_220"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#td_mask1_209_220)">
          <mask
            id="td_mask2_209_220"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#td_mask2_209_220)">
            <mask
              id="td_mask3_209_220"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#td_mask3_209_220)">
              <mask
                id="td_mask4_209_220"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#td_mask4_209_220)">
                <mask
                  id="td_mask5_209_220"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#td_mask5_209_220)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="td_mask6_209_220"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#td_mask6_209_220)">
                  <mask
                    id="td_mask7_209_220"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#td_mask7_209_220)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="td_mask8_209_220"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#td_mask8_209_220)">
                    <mask
                      id="td_mask9_209_220"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#td_mask9_209_220)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.99 20H54.9238C57.6675 20 59.9113 22.25 59.9113 25V55C59.9113 57.75 57.6675 60 54.9238 60H24.9887C22.245 60 20.0012 57.75 20.0012 55V48.2825L20.0712 48.3238C22.3045 49.6311 24.542 50.9311 26.7838 52.2237C27.38 52.5612 27.9513 52.5538 28.5263 52.2213L36.3062 47.7338L36.4512 47.65L36.455 47.6475L36.4775 47.635L36.5587 47.5875L44.6788 42.905C45.0238 42.705 45.0412 42.0913 44.6537 41.8688L44.3825 41.715L44.3813 41.7138C43.9863 41.4888 43.4763 41.1975 43.2588 41.0687C43.0674 40.9648 42.8526 40.9117 42.6349 40.9143C42.4172 40.9169 42.2038 40.9753 42.015 41.0838C41.8213 41.1963 28.9163 48.6325 28.485 48.8775C28.231 49.0236 27.943 49.1005 27.65 49.1005C27.357 49.1005 27.069 49.0236 26.815 48.8775L20 44.9088V41.5425L20.0712 41.5838C21.7737 42.5775 25.7975 44.9262 26.7838 45.4837C27.38 45.8212 27.9513 45.8138 28.5263 45.4813L36.4675 40.9013L36.4975 40.8838L36.5025 40.8812C40.4875 38.5812 44.5025 36.2675 44.6775 36.165C45.0238 35.965 45.0412 35.3513 44.6537 35.13L44.3825 34.975C43.9888 34.75 43.4763 34.4575 43.2575 34.3288C43.0663 34.2251 42.8518 34.172 42.6343 34.1746C42.4168 34.1773 42.2036 34.2355 42.015 34.3438C41.8213 34.4563 28.9163 41.8925 28.485 42.1375C28.231 42.2836 27.943 42.3605 27.65 42.3605C27.357 42.3605 27.069 42.2836 26.815 42.1375L20 38.17V34.8038L20.07 34.8438C21.7712 35.8375 25.7975 38.1862 26.7825 38.7437C27.38 39.0812 27.9513 39.0738 28.5263 38.7413L36.4762 34.1562L36.4862 34.15H36.4887L36.5887 34.0912L44.6775 29.425C45.0225 29.225 45.04 28.6125 44.6525 28.39L44.3813 28.235C43.9863 28.01 43.475 27.7175 43.2563 27.59C43.0651 27.4863 42.8505 27.4333 42.633 27.4359C42.4156 27.4385 42.2024 27.4967 42.0138 27.605C41.82 27.7163 28.915 35.1525 28.4838 35.3988C28.2297 35.5448 27.9418 35.6217 27.6487 35.6217C27.3557 35.6217 27.0678 35.5448 26.8138 35.3988L20 31.4287V25C20 22.25 22.245 20 24.9887 20"
        fill="#E44232"
      />
      <path
        d="M28.5263 38.7412L36.4762 34.1562L36.4862 34.15C40.4762 31.85 44.5013 29.5275 44.6775 29.425C45.0238 29.225 45.04 28.6125 44.6537 28.39L44.3825 28.235C43.9875 28.01 43.4763 27.7175 43.2575 27.59C43.0662 27.4861 42.8514 27.4329 42.6337 27.4355C42.416 27.4381 42.2025 27.4965 42.0138 27.605C41.8213 27.7162 28.9163 35.1525 28.485 35.3987C28.231 35.5448 27.943 35.6217 27.65 35.6217C27.357 35.6217 27.069 35.5448 26.815 35.3987L20 31.4287V34.8012L20.07 34.8425C21.7712 35.8362 25.7975 38.185 26.7825 38.7425C27.38 39.08 27.9513 39.0725 28.5263 38.74"
        fill="white"
      />
      <path
        d="M28.5263 45.4812L36.4662 40.9012L36.4962 40.8837L44.6775 36.165C45.0238 35.965 45.04 35.3512 44.6537 35.13L44.3825 34.975C43.9875 34.75 43.4763 34.4575 43.2575 34.3287C43.0662 34.2248 42.8514 34.1717 42.6337 34.1743C42.416 34.1769 42.2025 34.2353 42.0138 34.3437C41.8213 34.4562 28.9163 41.8925 28.485 42.1375C28.231 42.2836 27.943 42.3605 27.65 42.3605C27.357 42.3605 27.069 42.2836 26.815 42.1375L20 38.17V41.5425L20.0712 41.5837C21.7737 42.5775 25.7975 44.9262 26.7838 45.4837C27.38 45.8212 27.9513 45.8137 28.5263 45.4812Z"
        fill="white"
      />
      <path
        d="M36.4775 47.635L28.5263 52.2213C27.9513 52.5525 27.38 52.5613 26.7838 52.2238C24.542 50.9311 22.3045 49.6311 20.0712 48.3238L20 48.2825V44.9088L26.815 48.8775C27.33 49.1763 27.9688 49.1713 28.485 48.8775C28.9163 48.6325 41.8213 41.195 42.0138 41.0838C42.4788 40.8163 42.98 40.9063 43.2575 41.0688C43.4763 41.1975 43.9875 41.4888 44.3825 41.715L44.6537 41.8688C45.0412 42.0913 45.0238 42.705 44.6788 42.905L36.4775 47.635Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="td_clip0_209_220">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Workable = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#wk_clip0_209_132)">
      <mask
        id="wk_mask0_209_132"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#wk_mask0_209_132)">
        <mask
          id="wk_mask1_209_132"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#wk_mask1_209_132)">
          <mask
            id="wk_mask2_209_132"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#wk_mask2_209_132)">
            <mask
              id="wk_mask3_209_132"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#wk_mask3_209_132)">
              <mask
                id="wk_mask4_209_132"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#wk_mask4_209_132)">
                <mask
                  id="wk_mask5_209_132"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#wk_mask5_209_132)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="wk_mask6_209_132"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#wk_mask6_209_132)">
                  <mask
                    id="wk_mask7_209_132"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#wk_mask7_209_132)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="wk_mask8_209_132"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#wk_mask8_209_132)">
                    <mask
                      id="wk_mask9_209_132"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#wk_mask9_209_132)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M47.8061 41.3694C49.6545 38.1473 50.5963 35.281 50.5596 33.067C50.5152 30.3471 49.4218 28.3215 47.8061 26.9806C42.9479 22.9483 33.3797 25.0995 33.5087 33.1926C33.5568 36.2472 35.0588 40.2015 38.9619 44.968C38.9619 44.968 41.1378 43.045 41.6173 41.318C31.2519 27.4028 53.0396 26.6458 42.1988 42.0731C42.1988 42.0731 40.9472 44.0854 39.3509 45.4359C35.9715 48.5838 32.9117 49.5785 30.241 49.1468C20.9751 47.6461 19.4963 33.9876 18.8088 25.8679H12.0058C12.0019 25.9535 12.0019 26.0448 12 26.1361V27.6558C12.3562 43.7697 23.9001 66.1869 42.3509 48.5533C44.1783 46.7445 45.2181 45.3047 45.2181 45.3047C46.2174 43.9504 47.0801 42.6323 47.8061 41.3694Z"
        fill="#00544C"
      />
      <path
        d="M63.6191 33.71C63.5593 33.9154 63.5148 34.1341 63.484 34.3643C62.2401 43.8268 56.6928 51.8229 48.3221 47.4197C48.1566 47.6461 47.9834 47.8667 47.8042 48.0797C46.9666 49.0745 46.0057 49.919 45.1257 50.5885C45.1045 50.5752 45.0776 50.5638 45.0506 50.5581C45.973 51.1287 46.8915 51.5833 47.8042 51.9313C58.1367 55.878 67.5662 46.1226 68.4731 33.9268L63.6191 33.71Z"
        fill="#00544C"
      />
    </g>
    <defs>
      <clipPath id="wk_clip0_209_132">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Plausible = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#pl_clip0_192_9315)">
      <mask
        id="pl_mask0_192_9315"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#pl_mask0_192_9315)">
        <mask
          id="pl_mask1_192_9315"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#pl_mask1_192_9315)">
          <mask
            id="pl_mask2_192_9315"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#pl_mask2_192_9315)">
            <mask
              id="pl_mask3_192_9315"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#pl_mask3_192_9315)">
              <mask
                id="pl_mask4_192_9315"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#pl_mask4_192_9315)">
                <mask
                  id="pl_mask5_192_9315"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#pl_mask5_192_9315)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="pl_mask6_192_9315"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#pl_mask6_192_9315)">
                  <mask
                    id="pl_mask7_192_9315"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#pl_mask7_192_9315)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="pl_mask8_192_9315"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#pl_mask8_192_9315)">
                    <mask
                      id="pl_mask9_192_9315"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#pl_mask9_192_9315)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M55.1637 35.0685C54.4363 42.039 48.3419 47.22 41.3335 47.22H38.635V53.6C38.635 57.1346 35.7696 60 32.235 60H27.24C26.0029 60 25 58.9971 25 57.76V44.625L28.3587 39.9126C28.9666 39.0597 30.084 38.7415 31.05 39.1461L32.9605 39.9463C33.9235 40.3496 35.0374 40.0326 35.6437 39.1826L40.1218 32.9045C40.7266 32.0567 41.8381 31.7411 42.7981 32.1447L46.478 33.6916C47.4401 34.096 48.5539 33.7796 49.1596 32.9298L53.4659 26.8881C54.8157 29.2613 55.4755 32.0806 55.1637 35.0685Z"
        fill="url(#pl_paint0_linear_192_9315)"
      />
      <path
        d="M27.1947 39.2484C27.7436 38.4783 28.542 37.8861 29.4706 37.7075C30.1947 37.5682 30.9086 37.6413 31.5688 37.9178L33.4788 38.7178C33.5889 38.7639 33.7047 38.7872 33.8231 38.7872C34.1142 38.7872 34.389 38.6456 34.5582 38.4083L38.9544 32.2451C39.5031 31.4758 40.3013 30.8845 41.2294 30.7062C41.9508 30.5677 42.6603 30.6403 43.3149 30.9155L46.9947 32.4624C47.1058 32.5091 47.2226 32.5328 47.3419 32.5328C47.632 32.5328 47.9056 32.3919 48.0738 32.1559L52.6867 25.684C50.2181 22.243 46.1868 20 41.63 20H27.24C26.0029 20 25 21.0029 25 22.24V42.3277L27.1947 39.2484Z"
        fill="url(#pl_paint1_linear_192_9315)"
      />
    </g>
    <defs>
      <linearGradient
        id="pl_paint0_linear_192_9315"
        x1="34.8942"
        y1="35.0291"
        x2="43.3154"
        y2="49.7662"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#909CF7" />
        <stop offset="1" stopColor="#4B38D8" />
      </linearGradient>
      <linearGradient
        id="pl_paint1_linear_192_9315"
        x1="30.3225"
        y1="19.0945"
        x2="39.0006"
        y2="34.2812"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#909CF7" />
        <stop offset="1" stopColor="#4B38D8" />
      </linearGradient>
      <clipPath id="pl_clip0_192_9315">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Apify = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#ap_clip0_192_9227)">
      <mask
        id="ap_mask0_192_9227"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#ap_mask0_192_9227)">
        <mask
          id="ap_mask1_192_9227"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#ap_mask1_192_9227)">
          <mask
            id="ap_mask2_192_9227"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#ap_mask2_192_9227)">
            <mask
              id="ap_mask3_192_9227"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#ap_mask3_192_9227)">
              <mask
                id="ap_mask4_192_9227"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#ap_mask4_192_9227)">
                <mask
                  id="ap_mask5_192_9227"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#ap_mask5_192_9227)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="ap_mask6_192_9227"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#ap_mask6_192_9227)">
                  <mask
                    id="ap_mask7_192_9227"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#ap_mask7_192_9227)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="ap_mask8_192_9227"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#ap_mask8_192_9227)">
                    <mask
                      id="ap_mask9_192_9227"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#ap_mask9_192_9227)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M42.939 20H59.3939C59.7286 20 60 20.2713 60 20.6061V45.7532C60 46.3555 59.2166 46.589 58.8868 46.085L42.4319 20.9379C42.1681 20.5348 42.4573 20 42.939 20Z"
        fill="#246DFF"
      />
      <path
        d="M37.061 20H20.6061C20.2713 20 20 20.2713 20 20.6061V45.7532C20 46.3555 20.7834 46.589 21.1132 46.085L37.5681 20.9379C37.8319 20.5348 37.5427 20 37.061 20Z"
        fill="#20A34E"
      />
      <path
        d="M39.7181 40.1337L21.0253 58.9671C20.6457 59.3495 20.9166 60 21.4554 60H58.56C59.0966 60 59.3685 59.354 58.9933 58.9703L40.5816 40.137C40.3451 39.8951 39.9564 39.8936 39.7181 40.1337Z"
        fill="#F86606"
      />
    </g>
    <defs>
      <clipPath id="ap_clip0_192_9227">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DataScope = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#ds_clip0_209_3081)">
      <mask
        id="ds_mask0_209_3081"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#ds_mask0_209_3081)">
        <mask
          id="ds_mask1_209_3081"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#ds_mask1_209_3081)">
          <mask
            id="ds_mask2_209_3081"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#ds_mask2_209_3081)">
            <mask
              id="ds_mask3_209_3081"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#ds_mask3_209_3081)">
              <mask
                id="ds_mask4_209_3081"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#ds_mask4_209_3081)">
                <mask
                  id="ds_mask5_209_3081"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#ds_mask5_209_3081)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="ds_mask6_209_3081"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#ds_mask6_209_3081)">
                  <mask
                    id="ds_mask7_209_3081"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#ds_mask7_209_3081)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="ds_mask8_209_3081"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#ds_mask8_209_3081)">
                    <mask
                      id="ds_mask9_209_3081"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#ds_mask9_209_3081)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M38.9523 33.69C37.6834 33.8172 36.4807 34.3174 35.4958 35.1275C34.511 35.9376 33.788 37.0212 33.4184 38.2417C33.0487 39.4622 33.0488 40.7648 33.4187 41.9852C33.7886 43.2057 34.5116 44.2892 35.4966 45.0992C36.4815 45.9091 37.6844 46.4092 38.9532 46.5362C40.2221 46.6633 41.5002 46.4117 42.6263 45.8132C43.7523 45.2147 44.6759 44.296 45.2804 43.1732C45.885 42.0503 46.1433 40.7736 46.0231 39.504C45.8554 37.7958 45.0166 36.224 43.6908 35.1338C42.365 34.0437 40.6607 33.5244 38.9523 33.69ZM39.8689 43.0674C39.2888 43.1241 38.7048 43.0076 38.1909 42.7325C37.6769 42.4574 37.2561 42.0361 36.9815 41.5219C36.707 41.0077 36.591 40.4236 36.6484 39.8435C36.7057 39.2633 36.9337 38.7133 37.3036 38.2628C37.6736 37.8122 38.1688 37.4815 38.7267 37.3123C39.2845 37.1432 39.88 37.1432 40.4378 37.3125C40.9957 37.4817 41.4908 37.8126 41.8607 38.2632C42.2305 38.7138 42.4584 39.2639 42.5157 39.844C42.5537 40.2295 42.5154 40.6187 42.4029 40.9893C42.2905 41.36 42.1061 41.7048 41.8603 42.0041C41.6145 42.3035 41.3121 42.5515 40.9704 42.7339C40.6287 42.9164 40.2545 43.0297 39.8689 43.0674ZM36.3272 29.6834C36.6628 29.6226 36.9936 29.5377 37.317 29.4294C36.9827 29.4963 36.6523 29.5811 36.3272 29.6834Z"
        fill="black"
      />
      <path
        d="M41.9906 24.8118C41.9925 24.8203 41.9925 24.8291 41.9906 24.8376C41.6988 25.6671 41.2616 26.438 40.6996 27.1142C39.821 28.1876 38.6553 28.9891 37.3385 29.4252C37.0042 29.4921 36.6739 29.5768 36.3487 29.6791C34.2198 30.348 32.346 31.6512 30.9782 33.4143C29.6103 35.1774 28.8137 37.3162 28.6948 39.5445C28.5759 41.7729 29.1405 43.9843 30.313 45.8829C31.4855 47.7815 33.2099 49.2767 35.2556 50.1683H35.2814L35.432 50.2372C35.9412 50.4985 36.3329 50.9423 36.5291 51.4799C36.7252 52.0175 36.7113 52.6093 36.4901 53.1371C36.2689 53.6649 35.8567 54.0898 35.3358 54.3268C34.8149 54.5639 34.2238 54.5957 33.6805 54.4159L33.5471 54.3642L33.3792 54.2868C30.9316 53.2044 28.8062 51.5064 27.2099 49.3583C25.6137 47.2102 24.6011 44.6852 24.2708 42.0294C23.9406 39.3736 24.3039 36.6776 25.3255 34.204C26.347 31.7303 27.992 29.5635 30.0999 27.9147C31.8618 26.5375 33.9034 25.5622 36.0819 25.0571H36.1722C36.7384 24.9396 37.2376 24.6087 37.5664 24.133C37.8951 23.6573 38.0281 23.0734 37.9379 22.5022C37.8477 21.9311 37.5411 21.4165 37.0818 21.0653C36.6224 20.7141 36.0456 20.5532 35.4708 20.6159C35.4171 20.6199 35.3638 20.6286 35.3115 20.6417H35.2771H35.1996C35.1398 20.6515 35.0808 20.6659 35.0232 20.6847C32.4294 21.2889 29.9847 22.4117 27.8363 23.9855H27.8105C24.7645 26.2152 22.4126 29.2622 21.0272 32.7736C19.6418 36.285 19.2797 40.1171 19.9827 43.8259C20.6857 47.5347 22.4251 50.9684 24.9995 53.7292C27.5738 56.49 30.8777 58.4649 34.5283 59.425H34.6273L34.8812 59.4939C35.5626 59.7173 36.1335 60.1915 36.4781 60.8203C36.8227 61.449 36.9151 62.1853 36.7366 62.8799C36.558 63.5745 36.1219 64.1749 35.5168 64.5596C34.9116 64.9439 34.1828 65.0842 33.4782 64.9508C33.3763 64.9314 33.2757 64.9052 33.177 64.8733C27.78 63.473 22.9876 60.349 19.5275 55.9768C16.0675 51.6044 14.1289 46.2223 14.0062 40.6479C13.8835 35.0735 15.5834 29.6113 18.8477 25.0909C22.112 20.5705 26.7624 17.239 32.0925 15.6022C32.8198 15.3828 33.5643 15.1719 34.3175 15.0342C36.0059 14.871 37.6989 15.2957 39.1103 16.2367C40.5217 17.1776 41.565 18.5771 42.0638 20.1984C42.0658 20.2156 42.0658 20.2329 42.0638 20.2501C42.507 21.7226 42.4768 23.2971 41.9777 24.7516"
        fill="black"
      />
      <path
        d="M65.0663 37.6493C65.6081 43.2309 64.3041 48.8362 61.354 53.6054C58.4039 58.3745 53.9707 62.0442 48.7344 64.0513C48.4331 64.1718 48.1319 64.2794 47.822 64.3827C45.9871 64.9108 44.0187 64.7029 42.3348 63.803C40.6508 62.9036 39.3839 61.3827 38.803 59.564C38.2221 57.7451 38.3731 55.7715 39.2238 54.0622C40.0745 52.3529 41.558 51.0425 43.3592 50.4093C45.2861 49.7037 46.9758 48.4705 48.2355 46.8506C49.4951 45.2307 50.274 43.2893 50.4831 41.2479C50.6922 39.2066 50.3232 37.1475 49.4181 35.3059C48.5131 33.4642 47.1085 31.9141 45.3646 30.8324L45.3001 30.7937H45.2657C45.2285 30.7683 45.1897 30.7452 45.1495 30.7248C44.9988 30.6345 44.8482 30.5527 44.6933 30.4667C44.3302 30.1863 44.0599 29.8032 43.9175 29.3672C43.7751 28.9312 43.7672 28.4624 43.8949 28.0218C44.0226 27.5812 44.2798 27.1893 44.6333 26.8969C44.9868 26.6045 45.4201 26.4253 45.8768 26.3826C46.2377 26.3448 46.6024 26.395 46.9397 26.5289L47.4605 26.8173C50.0823 28.3683 52.1888 30.6579 53.5164 33.3997C54.8439 36.1415 55.3338 39.2138 54.9246 42.2325C54.5154 45.2512 53.2253 48.0823 51.2157 50.3717C49.2061 52.6612 46.5662 54.3073 43.6261 55.1044C43.519 55.122 43.4138 55.1494 43.3118 55.1862C42.7888 55.3645 42.3491 55.728 42.0754 56.2081C41.8019 56.6882 41.7133 57.2519 41.8266 57.7927C41.9399 58.3337 42.2471 58.8144 42.6903 59.1444C43.1336 59.4745 43.6822 59.6307 44.2328 59.5843H44.2629C44.5019 59.5606 44.7356 59.4995 44.9558 59.4035C49.0281 58.2747 52.6376 55.8836 55.2655 52.5742C57.8935 49.2648 59.4045 45.2074 59.5814 40.9853C59.7583 36.763 58.592 32.5935 56.2503 29.0758C53.9085 25.5581 50.5117 22.8735 46.5481 21.4077L46.2512 21.3001C45.6488 21.0354 45.1579 20.5686 44.8631 19.9803C44.5683 19.3921 44.4883 18.7193 44.6368 18.0784C44.7853 17.4374 45.153 16.8684 45.6765 16.4697C46.1999 16.0711 46.8461 15.8677 47.5035 15.8949C47.7344 15.9027 47.9631 15.9418 48.1835 16.011C48.2566 16.011 48.3255 16.0584 48.39 16.0842L48.489 16.1186C53.0077 17.7826 56.9657 20.687 59.9085 24.4984C62.8517 28.3098 64.66 32.8738 65.1265 37.6664"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="ds_clip0_209_3081">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Gorgias = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#gg_clip0_209_3213)">
      <mask
        id="gg_mask0_209_3213"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#gg_mask0_209_3213)">
        <mask
          id="gg_mask1_209_3213"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#gg_mask1_209_3213)">
          <mask
            id="gg_mask2_209_3213"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#gg_mask2_209_3213)">
            <mask
              id="gg_mask3_209_3213"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#gg_mask3_209_3213)">
              <mask
                id="gg_mask4_209_3213"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#gg_mask4_209_3213)">
                <mask
                  id="gg_mask5_209_3213"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#gg_mask5_209_3213)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="gg_mask6_209_3213"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#gg_mask6_209_3213)">
                  <mask
                    id="gg_mask7_209_3213"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#gg_mask7_209_3213)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="gg_mask8_209_3213"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#gg_mask8_209_3213)">
                    <mask
                      id="gg_mask9_209_3213"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#gg_mask9_209_3213)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M56.444 27.2678H49.7509V20.5625C49.7509 18.5943 48.1595 17 46.1949 17H22.5559C20.5914 17 19 18.5943 19 20.5625V54.5126C19 56.4808 20.5914 58.0751 22.5559 58.0751H53.1661L56.4783 61.3935C56.8666 61.7825 57.3882 62 57.9364 62C59.0748 62 60 61.0769 60 59.9326V30.8303C60 28.8622 58.4085 27.2678 56.444 27.2678ZM56.5848 54.65H22.4151V20.4213H46.332V27.2678H32.8049C30.8405 27.2678 29.249 28.8622 29.249 30.8303V44.2449C29.249 46.213 30.8405 47.8073 32.8049 47.8073H46.1949C48.1595 47.8073 49.7509 46.213 49.7509 44.2449V30.693H56.5848V54.6538V54.65ZM46.3359 30.6892V44.3821H32.6679V30.6892H46.3359Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="gg_clip0_209_3213">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Everhour = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#eh_clip0_184_3197)">
      <mask
        id="eh_mask0_184_3197"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#eh_mask0_184_3197)">
        <mask
          id="eh_mask1_184_3197"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#eh_mask1_184_3197)">
          <mask
            id="eh_mask2_184_3197"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#eh_mask2_184_3197)">
            <mask
              id="eh_mask3_184_3197"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#eh_mask3_184_3197)">
              <mask
                id="eh_mask4_184_3197"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#eh_mask4_184_3197)">
                <mask
                  id="eh_mask5_184_3197"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#eh_mask5_184_3197)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="eh_mask6_184_3197"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#eh_mask6_184_3197)">
                  <mask
                    id="eh_mask7_184_3197"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#eh_mask7_184_3197)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="eh_mask8_184_3197"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#eh_mask8_184_3197)">
                    <mask
                      id="eh_mask9_184_3197"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#eh_mask9_184_3197)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M37.781 64.8428C35.0255 64.4589 34.0369 64.2572 32.4798 63.761C9.40796 56.4083 9.09546 24.2233 32.0197 16.3741C54.7939 8.57633 74.2763 35.6614 59.7404 54.9122C54.6594 61.6411 45.2722 65.8863 37.781 64.8428ZM44.0188 61.3541C57.9171 58.6938 65.615 43.2102 59.371 30.4747C51.4125 14.2422 28.2448 14.2422 20.2863 30.4747C12.423 46.5129 26.4185 64.723 44.0188 61.3541ZM38.5218 54.6275C36.8681 53.6192 36.9355 51.1229 38.6402 50.2413C39.836 49.623 41.2847 50.0246 41.9817 51.1676C43.3412 53.3973 40.7514 55.9871 38.5218 54.6275ZM29.6631 50.9761C27.9147 49.891 28.2387 47.1292 30.1943 46.4476C32.1482 45.7666 34.0557 47.674 33.3747 49.628C32.866 51.0874 30.9587 51.7802 29.6631 50.9761ZM47.2192 50.8593C44.8515 49.2687 46.7646 45.5071 49.4629 46.4476C51.4357 47.1352 51.7431 49.9331 49.9616 50.9855C49.1845 51.4445 48.0099 51.3904 47.2192 50.8593ZM26.0409 42.1467C24.3872 41.1384 24.4546 38.642 26.1594 37.7605C27.3552 37.1421 28.8038 37.5437 29.5008 38.6868C30.8603 40.9165 28.2706 43.5062 26.0409 42.1467ZM38.5218 42.1467C37.4241 41.4774 36.9964 40.079 37.5306 38.9065C38.2382 37.3535 48.536 29.6356 49.264 30.1126C50.4792 30.9089 50.4859 30.8966 45.4749 37.0751C40.8264 42.8066 40.2698 43.2125 38.5218 42.1467ZM51.0026 42.1467C49.8097 41.4193 49.432 39.8749 50.1564 38.6868C51.1426 37.0695 53.4764 37.0695 54.4625 38.6868C55.822 40.9165 53.2323 43.5062 51.0026 42.1467ZM29.9355 33.4641C28.188 32.7044 28.0415 29.979 29.6957 29.0018C31.865 27.7204 34.4907 30.223 33.1992 32.3412C32.4394 33.5874 31.2001 34.0138 29.9355 33.4641ZM38.5218 29.6658C37.3289 28.9385 36.9511 27.394 37.6756 26.2059C38.6617 24.5886 40.9955 24.5886 41.9817 26.2059C43.3412 28.4356 40.7514 31.0254 38.5218 29.6658Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="eh_clip0_184_3197">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ExchangeRates = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#xr_clip0_184_337)">
      <mask
        id="xr_mask0_184_337"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#xr_mask0_184_337)">
        <mask
          id="xr_mask1_184_337"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#xr_mask1_184_337)">
          <mask
            id="xr_mask2_184_337"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#xr_mask2_184_337)">
            <mask
              id="xr_mask3_184_337"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#xr_mask3_184_337)">
              <mask
                id="xr_mask4_184_337"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#xr_mask4_184_337)">
                <mask
                  id="xr_mask5_184_337"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#xr_mask5_184_337)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="xr_mask6_184_337"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#xr_mask6_184_337)">
                  <mask
                    id="xr_mask7_184_337"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#xr_mask7_184_337)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="xr_mask8_184_337"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#xr_mask8_184_337)">
                    <mask
                      id="xr_mask9_184_337"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#xr_mask9_184_337)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M40 19C28.402 19 19 28.402 19 40C19 45.6549 21.2392 50.7845 24.8746 54.5597L40 39.4348L54.5597 24.8746C50.7845 21.2392 45.6549 19 40 19ZM60.9857 39.4348H40V61C51.5979 61 61 51.5979 61 40C61 39.8104 60.9905 39.6232 60.9857 39.4348Z"
        fill="#27344A"
      />
    </g>
    <defs>
      <clipPath id="xr_clip0_184_337">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FastBill = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#fb_clip0_184_3241)">
      <mask
        id="fb_mask0_184_3241"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#fb_mask0_184_3241)">
        <mask
          id="fb_mask1_184_3241"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#fb_mask1_184_3241)">
          <mask
            id="fb_mask2_184_3241"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#fb_mask2_184_3241)">
            <mask
              id="fb_mask3_184_3241"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#fb_mask3_184_3241)">
              <mask
                id="fb_mask4_184_3241"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#fb_mask4_184_3241)">
                <mask
                  id="fb_mask5_184_3241"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#fb_mask5_184_3241)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="fb_mask6_184_3241"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#fb_mask6_184_3241)">
                  <mask
                    id="fb_mask7_184_3241"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#fb_mask7_184_3241)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="fb_mask8_184_3241"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#fb_mask8_184_3241)">
                    <mask
                      id="fb_mask9_184_3241"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#fb_mask9_184_3241)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.02 40.3172C67.3512 29.5026 60.0112 21 48.9025 21H40.6287C40.0858 21 39.5471 21.2186 39.1171 21.5734C38.6849 21.9264 38.3614 22.4154 38.2466 22.9553C38.0152 24.0355 38.7074 24.9133 39.7928 24.9133H48.067C57.6599 24.9133 63.8063 32.6842 61.7664 42.2356L61.1766 44.9943L61.2051 44.9415C61.0332 45.9796 61.7172 46.8089 62.7738 46.8089C63.7571 46.8089 64.7259 46.0912 65.0741 45.1569L65.205 44.538L65.6965 42.2356C65.8357 41.5884 65.9423 40.9499 66.02 40.3172Z"
        fill="#84BF41"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.2314 28.8243H31.3224C30.2389 28.8243 29.1719 29.6998 28.9426 30.7797C28.713 31.8484 29.3891 32.7177 30.4539 32.7356H46.3959C51.6572 32.7356 55.0283 36.9976 53.9102 42.2355L52.1059 50.6825C51.8763 51.7627 52.5686 52.6379 53.654 52.6379C54.7375 52.6379 55.8046 51.7627 56.0361 50.6825L57.8382 42.2355C59.4173 34.8408 54.6576 28.8243 47.2314 28.8243Z"
        fill="#84BF41"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.8282 53.0115C42.6481 53.8557 41.7795 54.5694 40.9316 54.5694H20.2918C19.4438 54.5694 18.8826 53.8557 19.0627 53.0115L21.2767 42.6351C21.4571 41.7911 22.3253 41.079 23.171 41.079H43.8134C44.6591 41.079 45.2223 41.7911 45.0422 42.6351L42.8282 53.0115ZM45.5622 36.6467H23.3144C21.7723 36.6467 20.2343 37.2756 19.0015 38.2884C17.7686 39.3019 16.8385 40.6975 16.511 42.2356L14.1251 53.4111C13.4696 56.4844 15.4563 59 18.5426 59H40.7905C42.3347 59 43.8708 58.3712 45.1037 57.3574C46.3385 56.3449 47.2682 54.9468 47.5961 53.4111L49.982 42.2356C50.6374 39.1622 48.6486 36.6467 45.5622 36.6467Z"
        fill="#84BF41"
      />
    </g>
    <defs>
      <clipPath id="fb_clip0_184_3241">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GlassFrog = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#gf_clip0_184_3153)">
      <mask
        id="gf_mask0_184_3153"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#gf_mask0_184_3153)">
        <mask
          id="gf_mask1_184_3153"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#gf_mask1_184_3153)">
          <mask
            id="gf_mask2_184_3153"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#gf_mask2_184_3153)">
            <mask
              id="gf_mask3_184_3153"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#gf_mask3_184_3153)">
              <mask
                id="gf_mask4_184_3153"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#gf_mask4_184_3153)">
                <mask
                  id="gf_mask5_184_3153"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#gf_mask5_184_3153)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="gf_mask6_184_3153"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#gf_mask6_184_3153)">
                  <mask
                    id="gf_mask7_184_3153"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#gf_mask7_184_3153)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="gf_mask8_184_3153"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#gf_mask8_184_3153)">
                    <mask
                      id="gf_mask9_184_3153"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#gf_mask9_184_3153)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clipPath="url(#gf_clip1_184_3153)">
        <path
          d="M52.7813 50.8223C53.45 50.3848 53.9428 49.723 54.172 48.9546C54.2733 48.6245 54.4343 48.316 54.6469 48.0447C55.2594 47.3552 55.0627 46.6714 54.6722 46.0074C54.0304 44.9396 53.3248 43.912 52.5593 42.9303C52.2277 42.4809 52.0098 41.9573 51.9243 41.4044C51.9023 41.3086 51.908 41.2084 51.9409 41.1157C51.9738 41.0231 52.0324 40.9418 52.1098 40.8817C52.8037 40.2628 54.0934 40.5991 54.2479 41.5118C54.4249 42.5573 55.0065 43.388 55.4589 44.2894C55.5994 44.572 55.8213 44.9676 56.1416 44.8941C56.4619 44.8206 56.5406 44.3798 56.5546 44.0238C56.5855 43.0744 56.7878 42.1362 56.7569 41.1783C56.7401 40.7008 56.7064 40.2289 56.667 39.7655C56.6136 39.1382 56.9002 38.7624 57.4622 38.6663C57.7151 38.6382 57.9702 38.6943 58.1885 38.826C58.4067 38.9576 58.576 39.1577 58.6703 39.3954C58.781 39.6797 58.8271 39.9854 58.8053 40.2899C58.7834 40.5945 58.6941 40.8903 58.5439 41.1557C58.3814 41.442 58.2989 41.7671 58.3051 42.0967C58.3051 42.9161 58.3781 43.7384 58.2376 44.555C58.2126 44.6432 58.2154 44.737 58.2456 44.8235C58.2758 44.9101 58.3319 44.9851 58.4062 45.0382C58.572 45.1484 58.7265 45.0552 58.8614 44.9647C59.6031 44.4589 60.3758 43.9871 60.9827 43.3089C61.1134 43.1276 61.2994 42.9942 61.5124 42.929C61.7253 42.8637 61.9537 42.8701 62.1627 42.9472C62.389 43.0265 62.5883 43.1686 62.7375 43.3572C62.8867 43.5457 62.9796 43.7729 63.0056 44.0125C63.0871 44.4646 62.4746 45.2388 61.9211 45.2982C60.9742 45.3999 60.2774 45.982 59.5245 46.4567C57.7431 47.5869 56.5378 49.2004 55.4898 50.9777C55.1245 51.6022 54.5766 52.108 54.1973 52.7579C53.5848 53.7836 52.9302 54.7839 52.2868 55.7898C51.8204 56.5188 51.3062 57.2027 50.3621 57.3242C49.7665 57.4061 49.5642 57.2846 49.3816 56.711C48.9742 55.4366 49.1006 54.1481 49.2551 52.8568C49.3535 51.978 49.4265 51.0964 49.5024 50.2148C49.5164 50.0368 49.5389 49.822 49.3394 49.7344C49.1399 49.6468 49.0191 49.8305 48.9124 49.9718C48.0695 51.0795 47.0777 52.0939 46.7405 53.4982C46.5494 54.3007 46.1533 55.0184 45.9116 55.7983C45.5408 57.002 44.6922 57.3355 43.5909 56.7279C42.6974 56.2363 41.995 55.4875 41.2055 54.8545C40.5564 54.3346 39.9355 53.7751 39.3146 53.2241C38.6936 52.6731 37.8844 52.529 37.1315 52.2747C37.0106 52.2323 36.8505 52.2012 36.7887 52.3567C36.7269 52.5121 36.8786 52.546 36.9629 52.6166C37.6901 53.273 38.3362 54.0149 38.8875 54.8263C39.6027 55.7627 40.1852 56.7945 40.6182 57.8921C40.6548 57.9825 40.7025 58.0701 40.7391 58.1747C41.1577 59.24 40.6941 59.9633 39.5478 60.0114C38.4486 60.0303 37.3637 59.7594 36.4009 59.2258C35.1675 58.5929 33.9846 57.8582 32.65 57.4287C32.3562 57.3277 32.0795 57.1819 31.8296 56.9964C31.0289 56.4312 30.1242 56.0385 29.2813 55.5412C28.7193 55.2162 28.0534 55.2219 27.4213 55.1908C26.1991 55.1314 24.9769 55.1201 23.7547 55.0947C23.473 55.0853 23.1911 55.0995 22.9118 55.1371C22.6882 55.1789 22.4583 55.1703 22.2385 55.112C22.0186 55.0536 21.8144 54.947 21.6405 54.7997C21.4666 54.6524 21.3274 54.4681 21.2329 54.2601C21.1384 54.0522 21.0909 53.8257 21.0939 53.5971C21.0714 52.5997 21.4788 52.2493 22.451 52.4273C22.9034 52.4916 23.3366 52.6536 23.7209 52.902C23.9187 53.0629 24.15 53.1768 24.3977 53.235C24.6453 53.2932 24.9029 53.2943 25.1511 53.2383C25.5444 53.1337 25.6147 52.9274 25.432 52.5884C25.0591 52.0099 24.5828 51.5059 24.0272 51.1021C23.1197 50.3533 22.3133 49.5253 22.3611 48.2029C22.3462 48.0388 22.3792 47.8739 22.456 47.7284C22.5329 47.5829 22.6502 47.463 22.7938 47.3835C22.9367 47.3208 23.0949 47.3021 23.2484 47.3298C23.402 47.3575 23.5439 47.4302 23.6563 47.5389C24.1339 47.8641 24.4968 48.3329 24.6931 48.8783C24.9359 49.5457 25.3887 50.1152 25.9827 50.5002C26.3424 50.7545 26.6683 51.0653 27.0251 51.314C27.3819 51.5626 27.6994 51.4722 27.75 50.9777C27.8174 50.325 27.5983 49.7118 27.4494 49.093C27.3932 48.8528 27.3005 48.624 27.2443 48.3838C27.1846 48.1835 27.1716 47.9721 27.2064 47.766C27.2412 47.5599 27.3228 47.3646 27.4448 47.1954C27.5669 47.0262 27.7261 46.8875 27.9101 46.7903C28.0941 46.693 28.298 46.6398 28.5058 46.6347C28.6358 46.6083 28.7699 46.6099 28.8993 46.6393C29.0287 46.6687 29.1504 46.7253 29.2566 46.8053C29.3627 46.8854 29.4508 46.9871 29.5151 47.1038C29.5794 47.2204 29.6184 47.3495 29.6297 47.4824C29.7182 47.8665 29.7259 48.265 29.6521 48.6522C29.5369 49.1326 29.7477 49.5903 29.8011 50.065C29.8938 50.8788 29.9528 51.6954 30.0146 52.5121C30.0088 52.6615 30.0468 52.8094 30.1237 52.9375C30.2005 53.0655 30.3131 53.1681 30.4473 53.2326C31.3829 53.6169 32.2258 54.2046 33.1867 54.5352C33.3328 54.5861 33.507 54.7104 33.639 54.5352C33.7711 54.36 33.639 54.1905 33.5463 54.0436C32.7905 52.9529 31.942 51.9328 31.1975 50.8336C30.6889 50.082 30.1579 49.3332 29.9275 48.4629C29.6465 47.4315 29.7336 46.7195 31.0823 46.7308C32.8748 46.7477 34.5129 47.4372 36.1705 48.0871C36.1874 47.7789 36.0869 47.4758 35.8896 47.2394C35.2377 46.3154 34.5662 45.4055 33.9481 44.4589C33.4452 43.7356 33.3721 42.8681 33.2569 42.0402C33.094 40.8704 32.976 39.6977 32.8439 38.5251C32.8214 38.316 32.7652 38.1153 32.532 38.0843C32.3925 38.0673 32.2511 38.093 32.1264 38.158C32.0016 38.2231 31.8992 38.3244 31.8324 38.4488C31.5515 38.9235 31.2902 39.4236 30.9895 39.8899C30.4557 40.7149 30.1466 41.6615 29.5847 42.4725C29.2026 43.015 28.7587 43.2411 28.1321 43.1309C27.7566 43.0874 27.3981 42.9494 27.0897 42.7296C26.0558 41.8989 24.842 41.3168 23.8727 40.4098C23.1646 39.7599 22.2908 39.4151 21.4395 39.0676C19.9757 38.4714 18.5175 37.8413 16.944 37.5417C16.6397 37.4873 16.3693 37.3136 16.1922 37.0587C16.0152 36.8038 15.9461 36.4887 16 36.1826C16.059 35.7107 16.8626 35.3349 17.4048 35.5553C17.7864 35.7118 18.1382 35.9336 18.4444 36.2108C18.9606 36.7208 19.6307 37.0438 20.3494 37.1292C20.4599 37.1583 20.5761 37.1574 20.6861 37.1266C20.7962 37.0959 20.8962 37.0363 20.9759 36.954C21.1501 36.7195 20.9759 36.5047 20.8495 36.3295C20.5082 35.8281 20.1396 35.346 19.7453 34.8856C19.1833 34.2583 18.7956 33.5123 18.3208 32.8285C18.2432 32.7264 18.1886 32.6086 18.1606 32.4833C18.1326 32.3579 18.1319 32.2279 18.1586 32.1023C18.1853 31.9767 18.2388 31.8583 18.3153 31.7554C18.3917 31.6525 18.4895 31.5674 18.6017 31.5061C18.6813 31.4484 18.7648 31.3964 18.8518 31.3507C19.8324 30.8619 20.5741 31.2744 20.5741 32.3736C20.5785 33.2123 20.7797 34.0381 21.1613 34.7839C21.37 35.2157 21.7203 35.5619 22.1532 35.7644C22.6561 36.0046 22.9961 35.7474 22.9314 35.1851C22.9213 35.004 22.8794 34.8261 22.8078 34.6596C22.3892 33.8345 22.3723 32.9133 22.156 32.043C22.0464 31.5937 22.2431 31.3705 22.6448 31.232C23.4231 30.9664 24.0272 31.0879 24.4177 31.605C24.5751 31.8141 24.6818 32.0628 24.5189 32.286C24.0918 32.8766 24.1986 33.5463 24.2379 34.1905C24.3121 35.3198 24.5157 36.4368 24.8448 37.5191C25.0471 38.2453 25.5922 38.7426 26.0867 39.2597C26.4071 39.5586 26.7541 39.8273 27.1234 40.0622C27.5758 40.3843 27.868 40.3052 28.0787 39.7797C28.2476 39.3529 28.3958 38.9182 28.5227 38.477C28.9947 36.906 29.8601 35.527 30.6833 34.134C31.0008 33.5238 31.2759 32.8921 31.5065 32.2436C31.6695 31.8565 31.4138 31.444 31.3773 31.0371C31.3256 30.3995 31.2223 29.7673 31.0682 29.1467C30.9588 28.5983 30.6933 28.0937 30.304 27.6943C29.6606 27.0783 29.7083 25.4338 30.2422 24.8008C31.0991 23.7893 31.529 22.5544 31.9842 21.3225C32.5152 19.9096 33.1389 19.6892 34.3696 20.373C34.9591 20.6962 35.517 21.0746 36.0357 21.5033C36.5976 21.9667 37.2635 22.0939 37.9491 22.1673C39.2022 22.303 40.4103 23.5802 39.9495 24.976C39.6011 26.0159 39.913 26.7816 40.5845 27.5474C41.256 28.3131 41.6522 29.2428 42.4305 29.8983C42.8487 30.288 43.3141 30.6231 43.8156 30.8958C45.6841 31.8113 47.3642 33.0405 49.1175 34.1425C49.8367 34.5946 50.2413 34.4533 50.4408 33.6112C50.674 32.6223 50.5813 31.6333 50.5335 30.6217C50.5236 30.422 50.4647 30.2278 50.3621 30.0566C49.5192 28.6918 48.9573 27.1659 47.9739 25.8774C47.7385 25.565 47.5927 25.1936 47.5525 24.8037C47.5257 24.6986 47.5243 24.5886 47.5484 24.4828C47.5724 24.3771 47.6213 24.2786 47.6908 24.1957C47.7604 24.1128 47.8486 24.0477 47.9482 24.006C48.0478 23.9643 48.1558 23.9472 48.2633 23.956C48.9882 23.9051 49.4237 24.1933 49.6934 24.8941C49.907 25.4592 49.9407 26.047 50.1823 26.5895C50.367 27.0461 50.6148 27.4741 50.9185 27.861C51.0337 27.9995 51.1573 28.1634 51.3652 28.0786C51.4518 28.0453 51.5256 27.9852 51.5761 27.907C51.6266 27.8288 51.6511 27.7365 51.6462 27.6435C51.6462 27.2846 51.5843 26.9257 51.5703 26.5669C51.531 25.4366 51.6462 24.3064 51.3877 23.1761C51.2837 22.7296 51.2781 22.238 51.7164 21.865C52.343 21.3281 53.1353 21.4214 53.5427 22.1475C53.6844 22.4062 53.7966 22.6801 53.877 22.9642C53.9256 23.0856 53.9352 23.2193 53.9045 23.3464C53.8737 23.4736 53.8042 23.5879 53.7056 23.6734C53.214 24.0379 53.1212 24.5494 53.1212 25.106C53.1285 25.6313 53.0975 26.1564 53.0285 26.6771C52.9998 26.8896 53.0064 27.1054 53.0482 27.3157C53.1128 27.6463 53.0959 28.0701 53.4753 28.1973C53.8546 28.3244 54.0091 27.9373 54.2058 27.7254C54.8464 27.0275 55.4645 26.3126 56.0826 25.5892C56.4282 25.1851 56.7569 25.1258 57.302 25.3971C57.892 25.6796 58.3303 26.2815 58.1674 26.6799C57.976 27.1043 57.6255 27.4354 57.1924 27.6011C56.8497 27.7508 56.5041 27.9062 56.15 28.0249C55.6426 28.2114 55.1936 28.5303 54.8492 28.9489C54.1603 29.7159 53.5212 30.5266 52.9358 31.3761C52.5766 31.9285 52.3665 32.5654 52.3261 33.2241C52.2264 34.6224 51.85 35.9865 51.2191 37.2366C50.8398 37.9515 50.4268 38.1436 49.6906 37.8017C48.2547 37.1658 46.8484 36.4643 45.4761 35.6994C45.2304 35.5131 44.9535 35.3724 44.6585 35.284C44.5884 35.2602 44.5132 35.2554 44.4406 35.2703C44.3681 35.2852 44.3008 35.3192 44.2455 35.3688C44.1219 35.5129 44.2287 35.6514 44.3017 35.7729C44.5827 36.2024 44.8777 36.6206 45.1249 37.0529C45.6026 37.9006 46.0465 38.7907 46.5045 39.6581C47.0664 40.7432 47.0861 41.8932 46.8922 43.0489C46.7589 43.975 46.71 44.9113 46.7461 45.8463C46.7461 45.9904 46.7208 46.1713 46.895 46.2278C46.9759 46.2475 47.0609 46.2399 47.1371 46.2062C47.2133 46.1725 47.2763 46.1146 47.3165 46.0413C47.5328 45.7135 47.7154 45.3631 47.9234 45.0297C48.5162 44.0718 49.0135 43.0518 49.8901 42.2945C50.5532 41.7294 51.2275 41.8169 51.6602 42.6025C52.0929 43.388 52.298 44.3205 52.5228 45.2106C52.992 47.0642 52.947 48.9263 52.7813 50.8223Z"
          fill="#14B2C7"
        />
      </g>
    </g>
    <defs>
      <clipPath id="gf_clip0_184_3153">
        <rect width="80" height="80" fill="white" />
      </clipPath>
      <clipPath id="gf_clip1_184_3153">
        <rect width="47" height="40" fill="white" transform="translate(16 20)" />
      </clipPath>
    </defs>
  </svg>
);

export const Hubplanner = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#hp_clip0_192_7863)">
      <mask
        id="hp_mask0_192_7863"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#hp_mask0_192_7863)">
        <mask
          id="hp_mask1_192_7863"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#hp_mask1_192_7863)">
          <mask
            id="hp_mask2_192_7863"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#hp_mask2_192_7863)">
            <mask
              id="hp_mask3_192_7863"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#hp_mask3_192_7863)">
              <mask
                id="hp_mask4_192_7863"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#hp_mask4_192_7863)">
                <mask
                  id="hp_mask5_192_7863"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#hp_mask5_192_7863)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#4B26AA"
                  />
                </g>
                <mask
                  id="hp_mask6_192_7863"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#hp_mask6_192_7863)">
                  <mask
                    id="hp_mask7_192_7863"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#hp_mask7_192_7863)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#4B26AA"
                    />
                  </g>
                  <mask
                    id="hp_mask8_192_7863"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#hp_mask8_192_7863)">
                    <mask
                      id="hp_mask9_192_7863"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#hp_mask9_192_7863)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#4B26AA"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M40.5005 48C34.9494 48 32.2885 43.5602 29.9346 39.6383C27.4467 35.4979 25.574 32.7838 22.2437 32.7838C18.9135 32.7838 17.0278 35.4506 14.5529 39.5119C12.203 43.3649 9.53705 47.7213 4 47.7213V44.9409C7.33023 44.9409 9.21593 42.2741 11.6908 38.2129C14.0447 34.3589 16.7047 30 22.2437 30C27.7828 30 30.4558 34.4398 32.8107 38.3617C35.2986 42.5021 37.1713 45.2162 40.5015 45.2162C43.8317 45.2162 45.7034 42.5021 48.1923 38.3617C50.5442 34.4398 53.2062 30 58.7563 30C64.3063 30 66.9593 34.3589 69.3092 38.212C71.7971 42.2724 73.6698 44.9401 77 44.9401V47.7213C71.463 47.7213 68.797 43.3624 66.4471 39.5093C63.9592 35.4489 62.0865 32.7812 58.7563 32.7812C55.426 32.7812 53.5543 35.4953 51.0654 39.6357C48.7115 43.5576 46.0496 47.9974 40.4995 47.9974L40.5005 48Z"
        fill="#F4F4F4"
      />
    </g>
    <defs>
      <clipPath id="hp_clip0_192_7863">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Katana = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#kt_clip0_192_6499)">
      <mask
        id="kt_mask0_192_6499"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#kt_mask0_192_6499)">
        <mask
          id="kt_mask1_192_6499"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#kt_mask1_192_6499)">
          <mask
            id="kt_mask2_192_6499"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#kt_mask2_192_6499)">
            <mask
              id="kt_mask3_192_6499"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#kt_mask3_192_6499)">
              <mask
                id="kt_mask4_192_6499"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#kt_mask4_192_6499)">
                <mask
                  id="kt_mask5_192_6499"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#kt_mask5_192_6499)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#EEFF38"
                  />
                </g>
                <mask
                  id="kt_mask6_192_6499"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#kt_mask6_192_6499)">
                  <mask
                    id="kt_mask7_192_6499"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#kt_mask7_192_6499)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#EEFF38"
                    />
                  </g>
                  <mask
                    id="kt_mask8_192_6499"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#kt_mask8_192_6499)">
                    <mask
                      id="kt_mask9_192_6499"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#kt_mask9_192_6499)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#EEFF38"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clipPath="url(#kt_clip1_192_6499)">
        <path
          d="M16.581 33.5903H12.568L7.87115 38.2418V33.5903H5V44.2669H7.87172V42.1886L9.94418 40.1298L12.949 44.2858H16.5431L12.0551 38.0703L16.581 33.5903Z"
          fill="#092332"
        />
        <path
          d="M24.9758 35.1726C24.2529 34.2194 23.0548 33.5897 21.0771 33.5897C16.5707 33.5897 16.095 37.384 16.095 38.9474C16.095 40.3771 16.5896 44.2857 21.0581 44.2857C23.0738 44.2857 24.2907 43.7326 25.0137 42.7989H25.1089V44.2857H27.999V33.5903H25.1084V35.1726H24.9758ZM21.9142 41.8069C19.1566 41.8069 18.8525 39.7097 18.8525 38.9474C18.8525 38.1086 19.1377 36.0874 21.9142 36.0874C24.4049 36.0874 24.9184 37.4989 24.9184 38.9474C24.9184 40.568 24.4049 41.8069 21.9142 41.8069ZM33.3833 36.0686H36.8443V33.6286H29.0662V36.0686H30.4737V40.3583C30.4737 41.9029 30.4737 44.2857 33.3827 44.2857C36.2734 44.2857 36.8443 44.0949 36.8443 44.0949V41.2732C34.0672 41.4257 33.3833 41.6354 33.3833 40.0914V36.0686ZM46.2943 35.1726C45.5713 34.2194 44.3733 33.5897 42.3961 33.5897C37.8891 33.5897 37.4134 37.384 37.4134 38.9474C37.4134 40.3771 37.908 44.2857 42.3766 44.2857C44.3928 44.2857 45.6098 43.7326 46.3321 42.7989H46.4274V44.2857H49.318V33.5903H46.4274V35.1726H46.2943ZM43.2326 41.8069C40.4751 41.8069 40.171 39.7097 40.171 38.9474C40.171 38.1086 40.4562 36.0874 43.2326 36.0874C45.7234 36.0874 46.2369 37.4989 46.2369 38.9474C46.2369 40.568 45.7234 41.8069 43.2326 41.8069ZM57.3554 33.5903C55.4344 33.5903 54.4648 34.2189 53.7802 35.1726H53.6471V33.5897H50.7565V44.2857H53.6471V39.1383C53.6471 37.6891 54.0086 36.0874 56.5183 36.0874C59.2758 36.0874 59.1048 38.1086 59.1048 38.9474V44.2857H61.9754V38.9474C61.9754 37.384 61.8618 33.5903 57.3554 33.5903ZM71.9762 35.1726C71.2539 34.2194 70.0558 33.5897 68.078 33.5897C63.5711 33.5897 63.096 37.384 63.096 38.9474C63.096 40.3771 63.59 44.2857 68.0591 44.2857C70.0748 44.2857 71.2917 43.7326 72.0147 42.7989H72.1093V44.2857H75V33.5903H72.1093V35.1726H71.9762ZM68.9146 41.8069C66.1576 41.8069 65.853 39.7097 65.853 38.9474C65.853 38.1086 66.1387 36.0874 68.9146 36.0874C71.4059 36.0874 71.9194 37.4989 71.9194 38.9474C71.9194 40.568 71.4059 41.8069 68.9146 41.8069Z"
          fill="#092332"
        />
        <path
          d="M30.4857 30V33.7234C30.4857 33.7234 31.6976 33.3617 32.6207 32.2343C33.5451 31.1063 33.455 30 33.455 30H30.4857Z"
          fill="#092332"
        />
      </g>
    </g>
    <defs>
      <clipPath id="kt_clip0_192_6499">
        <rect width="80" height="80" fill="white" />
      </clipPath>
      <clipPath id="kt_clip1_192_6499">
        <rect width="70" height="20" fill="white" transform="translate(5 30)" />
      </clipPath>
    </defs>
  </svg>
);

export const MyHours = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#mh_clip0_192_6455)">
      <mask
        id="mh_mask0_192_6455"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#mh_mask0_192_6455)">
        <mask
          id="mh_mask1_192_6455"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#mh_mask1_192_6455)">
          <mask
            id="mh_mask2_192_6455"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#mh_mask2_192_6455)">
            <mask
              id="mh_mask3_192_6455"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#mh_mask3_192_6455)">
              <mask
                id="mh_mask4_192_6455"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#mh_mask4_192_6455)">
                <mask
                  id="mh_mask5_192_6455"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#mh_mask5_192_6455)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="mh_mask6_192_6455"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#mh_mask6_192_6455)">
                  <mask
                    id="mh_mask7_192_6455"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mh_mask7_192_6455)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="mh_mask8_192_6455"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mh_mask8_192_6455)">
                    <mask
                      id="mh_mask9_192_6455"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mh_mask9_192_6455)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M65 40C65 35.0553 63.5336 30.2217 60.7865 26.1104C58.0392 21.9991 54.1345 18.7948 49.5661 16.9027C44.9978 15.0106 39.9709 14.5157 35.1214 15.4807C30.2717 16.4456 25.8172 18.827 22.321 22.3237C18.8249 25.8204 16.4441 30.2753 15.4799 35.125C14.5157 39.9748 15.0113 45.0017 16.9041 49.5696C18.7969 54.1377 22.0018 58.0419 26.1135 60.7885C30.2252 63.5352 35.059 65.0008 40.0038 65C43.2867 65.0004 46.5376 64.3542 49.5709 63.0979C52.604 61.8417 55.36 60.0002 57.6812 57.6785C60.0023 55.3569 61.8434 52.6006 63.0993 49.5673C64.355 46.534 65.001 43.2829 65 40ZM40.0038 20.5788C41.6679 20.5786 43.3254 20.7909 44.9357 21.2108L41.8884 28.3862C36.8591 26.5166 31.9608 25.4472 27.8814 25.3575H27.2682C30.7934 22.2728 35.3195 20.5745 40.0038 20.5788ZM40.0038 59.4212C38.3279 59.426 36.6587 59.2123 35.0381 58.7854L37.2816 53.4983C36.4217 53.1794 35.5591 52.8365 34.6941 52.47C33.8267 52.0962 32.9779 51.7223 32.1515 51.3221L29.908 56.6019C27.207 54.9542 24.948 52.6733 23.3264 49.9567C21.7048 47.2398 20.7695 44.169 20.6013 41.0096L21.0425 41.4621C24.4414 44.8273 29.5715 48.0654 35.4943 50.5781C41.4171 53.0908 47.3137 54.5379 52.0961 54.6425H52.758C49.2311 57.7369 44.6954 59.4362 40.0038 59.4212ZM46.6108 36.6123C50.032 38.4221 52.9301 40.4525 55.009 42.5127C57.3983 44.8833 58.135 46.8015 57.8057 47.5756C57.4767 48.3496 55.5847 49.1535 52.2195 49.0712C48.1289 48.9815 42.9652 47.699 37.678 45.4517C32.3908 43.2044 27.8777 40.389 24.9648 37.506C22.5755 35.1316 21.8427 33.2172 22.1717 32.4432C22.5008 31.6692 24.3853 30.8652 27.7543 30.9475C31.1232 31.0298 35.3373 31.9346 39.7195 33.5387L35.943 42.4342C35.931 42.4502 35.9208 42.4679 35.9132 42.4865C36.7356 42.8829 37.5845 43.2717 38.452 43.6419C39.3195 44.0121 40.187 44.3485 41.0469 44.6665L44.8423 35.6925L47.0221 30.5549L50.0769 23.3869C51.4101 24.197 52.6416 25.1636 53.7451 26.2661C57.1508 29.6584 59.1671 34.2002 59.3987 39.0017C59.2492 38.8446 59.0959 38.6912 58.9351 38.5269C56.3962 36.0104 52.8852 33.5649 48.7946 31.4411L46.6108 36.6123Z"
        fill="#2DB67E"
      />
    </g>
    <defs>
      <clipPath id="mh_clip0_192_6455">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Railz = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#rz_clip0_192_10679)">
      <mask
        id="rz_mask0_192_10679"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#rz_mask0_192_10679)">
        <mask
          id="rz_mask1_192_10679"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#rz_mask1_192_10679)">
          <mask
            id="rz_mask2_192_10679"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#rz_mask2_192_10679)">
            <mask
              id="rz_mask3_192_10679"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#rz_mask3_192_10679)">
              <mask
                id="rz_mask4_192_10679"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#rz_mask4_192_10679)">
                <mask
                  id="rz_mask5_192_10679"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#rz_mask5_192_10679)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="rz_mask6_192_10679"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#rz_mask6_192_10679)">
                  <mask
                    id="rz_mask7_192_10679"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#rz_mask7_192_10679)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="rz_mask8_192_10679"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#rz_mask8_192_10679)">
                    <mask
                      id="rz_mask9_192_10679"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#rz_mask9_192_10679)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clipPath="url(#rz_clip1_192_10679)">
        <path
          d="M67.3282 36.7567C67.3282 36.0495 66.773 35.4886 66.0704 35.4886H51.5351C48.8732 35.4886 46.7391 37.5526 46.7391 40.2361C46.7391 42.9197 48.9029 44.9537 51.5351 44.9537H63.204C64.3442 44.9537 65.2513 46.0156 65.2513 47.1351C65.2513 48.2845 64.3156 49.3165 63.204 49.3165H48.6687C47.9672 49.3165 47.4108 49.8762 47.4108 50.5845C47.4108 51.2929 47.9661 51.8526 48.6687 51.8526H63.204C65.8659 51.8526 68 49.7887 68 47.1351C68 44.4515 65.8362 42.4175 63.204 42.4175H51.5351C50.3949 42.4175 49.4878 41.3556 49.4878 40.2361C49.4878 39.0867 50.4235 38.0547 51.5351 38.0547H66.0704C66.7718 38.0547 67.3282 37.465 67.3282 36.7579V36.7567Z"
          fill="#4BCD3E"
        />
        <path
          d="M41.7077 29.8578C41.7077 28.8258 40.8886 28 39.865 28C38.8414 28 38.0222 28.8258 38.0222 29.8578C38.0222 30.8897 38.8414 31.7155 39.865 31.7155C40.8886 31.6856 41.7077 30.8609 41.7077 29.8578Z"
          fill="#4BCD3E"
        />
        <path
          d="M35.8584 29.8578C35.8584 28.8258 35.0393 28 34.0157 28C32.992 28 32.1729 28.8258 32.1729 29.8578C32.1729 30.8897 32.992 31.7155 34.0157 31.7155C35.0393 31.6856 35.8584 30.8609 35.8584 29.8578Z"
          fill="#4BCD3E"
          fillOpacity="0.8"
        />
        <path
          d="M30.0091 29.8578C30.0091 28.8258 29.19 28 28.1664 28C27.1427 28 26.3236 28.8258 26.3236 29.8578C26.3236 30.8897 27.1427 31.7155 28.1664 31.7155C29.19 31.6856 30.0091 30.8609 30.0091 29.8578Z"
          fill="#4BCD3E"
          fillOpacity="0.6"
        />
        <path
          d="M24.1896 29.8578C24.1896 28.8258 23.3704 28 22.3468 28C21.3232 28 20.504 28.8258 20.504 29.8578C20.504 30.8897 21.3232 31.7155 22.3468 31.7155C23.3704 31.6856 24.1896 30.8609 24.1896 29.8578Z"
          fill="#4BCD3E"
          fillOpacity="0.4"
        />
        <path
          d="M18.3402 29.8578C18.3402 28.8258 17.5211 28 16.4974 28C15.4738 28 14.6547 28.8258 14.6547 29.8578C14.6547 30.8897 15.4738 31.7155 16.4974 31.7155C17.5211 31.6856 18.3402 30.8609 18.3402 29.8578Z"
          fill="#4BCD3E"
          fillOpacity="0.2"
        />
        <path
          d="M31.7354 35.4886C31.7057 35.4886 31.6474 35.4886 31.6188 35.4886H19.2473C14.3337 35.4886 11 38.732 11 43.6856V50.6145C11 51.3815 11.6146 52 12.3744 52C13.1341 52 13.7487 51.3804 13.7487 50.6145V43.6856C13.7487 40.2649 15.796 38.0248 19.2473 38.0248H31.6188C31.6485 38.0248 31.7068 38.0248 31.7354 38.0248C32.4368 38.0248 32.9932 37.465 32.9932 36.7567C32.9932 36.0783 32.438 35.4886 31.7354 35.4886Z"
          fill="#4BCD3E"
        />
        <path
          d="M15.1517 43.6855C15.1517 44.3927 15.7069 44.9536 16.4095 44.9536H29.0152C29.7167 44.9536 30.2731 44.3939 30.2731 43.6855C30.2731 42.9772 29.7178 42.4175 29.0152 42.4175H16.4095C15.708 42.4175 15.1517 43.0072 15.1517 43.6855Z"
          fill="#4BCD3E"
        />
        <path
          d="M38.4907 36.7566V50.6144C38.4907 51.3815 39.1053 51.9999 39.865 51.9999C40.6248 51.9999 41.2394 51.3803 41.2394 50.6144V36.7566C41.2394 35.9896 40.6248 35.3711 39.865 35.3711C39.1042 35.401 38.4907 36.0195 38.4907 36.7566Z"
          fill="#4BCD3E"
        />
      </g>
    </g>
    <defs>
      <clipPath id="rz_clip0_192_10679">
        <rect width="80" height="80" fill="white" />
      </clipPath>
      <clipPath id="rz_clip1_192_10679">
        <rect width="57" height="24" fill="white" transform="translate(11 28)" />
      </clipPath>
    </defs>
  </svg>
);

export const Tellent = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#tl_clip0_209_88)">
      <mask
        id="tl_mask0_209_88"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#tl_mask0_209_88)">
        <mask
          id="tl_mask1_209_88"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#tl_mask1_209_88)">
          <mask
            id="tl_mask2_209_88"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#tl_mask2_209_88)">
            <mask
              id="tl_mask3_209_88"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#tl_mask3_209_88)">
              <mask
                id="tl_mask4_209_88"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#tl_mask4_209_88)">
                <mask
                  id="tl_mask5_209_88"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#tl_mask5_209_88)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#591CB7"
                  />
                </g>
                <mask
                  id="tl_mask6_209_88"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#tl_mask6_209_88)">
                  <mask
                    id="tl_mask7_209_88"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#tl_mask7_209_88)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#591CB7"
                    />
                  </g>
                  <mask
                    id="tl_mask8_209_88"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#tl_mask8_209_88)">
                    <mask
                      id="tl_mask9_209_88"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#tl_mask9_209_88)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#591CB7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M45.2219 47.5285C45.2219 48.9635 45.0035 49.9973 44.5641 50.6298C44.1246 51.2622 43.4457 51.5785 42.5274 51.5785C41.6091 51.5785 40.9933 51.2729 40.5539 50.6617C40.1145 50.0505 39.896 49.1522 39.896 47.9697V35.562H51.9214L53.3081 27.6481H39.8935V20L30.1153 24.0553V27.6508H25C25 31.0549 27.1314 33.9489 30.1153 35.0652V48.161C30.1153 50.6935 30.5864 52.8461 31.5257 54.6187C32.4651 56.3911 33.8334 57.7305 35.6306 58.6393C37.4279 59.5456 39.6619 60 42.3379 60C45.0141 60 47.1112 59.4924 49.0137 58.4799C50.9136 57.4674 52.387 56.043 53.4318 54.2067C54.4764 52.3705 55 50.2311 55 47.781V40H45.2219V47.5285Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="tl_clip0_209_88">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SimFin = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#sf125_clip0_209_176)">
      <mask
        id="sf125_mask0_209_176"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#sf125_mask0_209_176)">
        <mask
          id="sf125_mask1_209_176"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#sf125_mask1_209_176)">
          <mask
            id="sf125_mask2_209_176"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#sf125_mask2_209_176)">
            <mask
              id="sf125_mask3_209_176"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#sf125_mask3_209_176)">
              <mask
                id="sf125_mask4_209_176"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#sf125_mask4_209_176)">
                <mask
                  id="sf125_mask5_209_176"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#sf125_mask5_209_176)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="sf125_mask6_209_176"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#sf125_mask6_209_176)">
                  <mask
                    id="sf125_mask7_209_176"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#sf125_mask7_209_176)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="sf125_mask8_209_176"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#sf125_mask8_209_176)">
                    <mask
                      id="sf125_mask9_209_176"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#sf125_mask9_209_176)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.7997 26.7419C48.014 30.5779 50.7703 39.5139 46.9795 46.7312L40.7148 43.4001L40.7216 43.3871C42.6306 39.6514 41.1929 35.0592 37.4706 33.0801C33.711 31.081 29.0444 32.5049 27.0476 36.2605C25.0703 39.9794 26.4522 44.5901 30.1299 46.621L26.8028 52.8787L26.6648 52.8038C19.5892 48.8932 16.9312 40.0205 20.7365 32.8637C24.5801 25.6346 33.5627 22.8938 40.7997 26.7419Z"
        fill="#3399FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.5518 53.3776C31.2716 49.6679 28.3599 40.7816 32.0241 33.499L38.3463 36.7204L38.3394 36.7335C36.4959 40.5019 38.0136 45.0683 41.7697 46.9822C45.5638 48.9154 50.2048 47.4103 52.1357 43.6203C54.0479 39.8674 52.5857 35.2816 48.8731 33.3152L52.0905 27.0005L52.2298 27.0729C59.3724 30.8593 62.1851 39.6843 58.5053 46.9064C54.7883 54.2016 45.8549 57.0987 38.5518 53.3776Z"
        fill="#3399FF"
      />
    </g>
    <defs>
      <clipPath id="sf125_clip0_209_176">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Smartwaiver = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#sw_clip0_192_6411)">
      <mask
        id="sw_mask0_192_6411"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#sw_mask0_192_6411)">
        <mask
          id="sw_mask1_192_6411"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#sw_mask1_192_6411)">
          <mask
            id="sw_mask2_192_6411"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#sw_mask2_192_6411)">
            <mask
              id="sw_mask3_192_6411"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#sw_mask3_192_6411)">
              <mask
                id="sw_mask4_192_6411"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#sw_mask4_192_6411)">
                <mask
                  id="sw_mask5_192_6411"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#sw_mask5_192_6411)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="sw_mask6_192_6411"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#sw_mask6_192_6411)">
                  <mask
                    id="sw_mask7_192_6411"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#sw_mask7_192_6411)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="sw_mask8_192_6411"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#sw_mask8_192_6411)">
                    <mask
                      id="sw_mask9_192_6411"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#sw_mask9_192_6411)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M29.0136 41.404L19.7843 35.8041C19.53 35.6501 19.2445 35.5552 18.9487 35.5263C18.6528 35.4975 18.3542 35.5354 18.075 35.6373C17.7958 35.7392 17.543 35.9026 17.3354 36.1152C17.1277 36.3278 16.9704 36.5844 16.8751 36.8659C16.0567 39.2277 15.8075 41.7495 16.1479 44.2258C17.1515 51.8329 23.6462 57.6946 32.381 60C30.4458 57.9185 29.1751 55.3075 28.7307 52.5005C28.2864 49.6935 28.6887 46.8177 29.8864 44.2403C30.1119 43.7425 30.1477 43.1793 29.9871 42.6569C29.8262 42.1345 29.4801 41.6889 29.0136 41.404Z"
        fill="#6A8C40"
      />
      <path
        d="M40.2861 20.3353C31.7768 21.4916 24.5985 25.4915 20.293 30.7932C20.1189 31.0129 19.9938 31.2672 19.9263 31.5392C19.8587 31.8112 19.85 32.0944 19.901 32.3701C19.952 32.6456 20.0614 32.9071 20.2218 33.1368C20.3822 33.3666 20.59 33.5594 20.8311 33.7022L31.0131 39.8548C31.3743 40.0693 31.7942 40.1638 32.2123 40.1245C32.6305 40.0854 33.0254 39.9145 33.3405 39.6367C35.8267 37.4074 39.0146 36.1185 42.3517 35.9937C45.6887 35.8689 48.964 36.9159 51.6098 38.9531C51.9967 39.2443 52.4778 39.3816 52.9602 39.3386C53.4423 39.2957 53.8916 39.0754 54.2208 38.7203L63.5956 28.7279C63.781 28.5265 63.923 28.2889 64.0125 28.0302C64.1021 27.7716 64.1375 27.4971 64.1162 27.2243C64.0951 26.9513 64.018 26.6857 63.8896 26.4438C63.7613 26.202 63.5844 25.9893 63.3702 25.8188C57.7919 21.3607 49.3335 19.0989 40.2861 20.3353Z"
        fill="#99CC33"
      />
      <path
        d="M48.4537 42.5966H37.4425C35.8599 42.5966 34.5771 43.8795 34.5771 45.462V56.4726C34.5771 58.0552 35.8599 59.338 37.4425 59.338H48.4537C50.0363 59.338 51.3192 58.0552 51.3192 56.4726V45.462C51.3192 43.8795 50.0363 42.5966 48.4537 42.5966Z"
        fill="#9BCA3B"
      />
      <path
        d="M48.4537 42.5966H37.4425C35.8599 42.5966 34.5771 43.8795 34.5771 45.462V56.4726C34.5771 58.0552 35.8599 59.338 37.4425 59.338H48.4537C50.0363 59.338 51.3192 58.0552 51.3192 56.4726V45.462C51.3192 43.8795 50.0363 42.5966 48.4537 42.5966Z"
        fill="#6A8C41"
      />
    </g>
    <defs>
      <clipPath id="sw_clip0_192_6411">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Lokalise = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#lk_clip0_161_658)">
      <mask
        id="lk_mask0_161_658"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#lk_mask0_161_658)">
        <mask
          id="lk_mask1_161_658"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#lk_mask1_161_658)">
          <mask
            id="lk_mask2_161_658"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#lk_mask2_161_658)">
            <mask
              id="lk_mask3_161_658"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#lk_mask3_161_658)">
              <mask
                id="lk_mask4_161_658"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#lk_mask4_161_658)">
                <mask
                  id="lk_mask5_161_658"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#lk_mask5_161_658)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="lk_mask6_161_658"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#lk_mask6_161_658)">
                  <mask
                    id="lk_mask7_161_658"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#lk_mask7_161_658)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="lk_mask8_161_658"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#lk_mask8_161_658)">
                    <mask
                      id="lk_mask9_161_658"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#lk_mask9_161_658)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M49.092 20H30.9081C24.8837 20 20 24.8837 20 30.9081V49.092C20 55.1162 24.8837 60 30.9081 60H49.092C55.1162 60 60 55.1162 60 49.092V30.9081C60 24.8837 55.1162 20 49.092 20Z"
        fill="#FCB9B0"
      />
      <mask
        id="lk_mask10_161_658"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="28"
        y="27"
        width="24"
        height="28"
      >
        <path d="M51.6 27.7964H28.48V54.0096H51.6V27.7964Z" fill="white" />
      </mask>
      <g mask="url(#lk_mask10_161_658)">
        <path
          d="M51.6 44.1447H47.5107H44.7976H44.1248L40.0399 48.2295L35.9507 44.1447H35.2822H32.5648H28.4799V48.2295H34.2599L37.1477 51.1218L40.0399 54.0095L42.9277 51.1218L45.82 48.2295H51.6V44.1447Z"
          fill="#131E29"
        />
        <path d="M51.6 35.9706H28.4799V40.0555H51.6V35.9706Z" fill="#131E29" />
        <path d="M51.5999 27.7964H28.4798V31.8813H51.5999V27.7964Z" fill="#131E29" />
      </g>
    </g>
    <defs>
      <clipPath id="lk_clip0_161_658">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MailerLite = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#mll_clip0_161_7699)">
      <mask
        id="mll_mask0_161_7699"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#mll_mask0_161_7699)">
        <mask
          id="mll_mask1_161_7699"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#mll_mask1_161_7699)">
          <mask
            id="mll_mask2_161_7699"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#mll_mask2_161_7699)">
            <mask
              id="mll_mask3_161_7699"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#mll_mask3_161_7699)">
              <mask
                id="mll_mask4_161_7699"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#mll_mask4_161_7699)">
                <mask
                  id="mll_mask5_161_7699"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#mll_mask5_161_7699)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="mll_mask6_161_7699"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#mll_mask6_161_7699)">
                  <mask
                    id="mll_mask7_161_7699"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mll_mask7_161_7699)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="mll_mask8_161_7699"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mll_mask8_161_7699)">
                    <mask
                      id="mll_mask9_161_7699"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mll_mask9_161_7699)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M57.1326 22H22.8352C20.1919 22 18 24.1578 18 26.7597V42.6256V45.7353V57L24.6725 50.495H57.1648C59.8081 50.495 62 48.3373 62 45.7353V26.7597C61.9678 24.126 59.8081 22 57.1326 22Z"
        fill="#09C269"
      />
    </g>
    <defs>
      <clipPath id="mll_clip0_161_7699">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MailerSend = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#mls_clip0_161_6291)">
      <mask
        id="mls_mask0_161_6291"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#mls_mask0_161_6291)">
        <mask
          id="mls_mask1_161_6291"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#mls_mask1_161_6291)">
          <mask
            id="mls_mask2_161_6291"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#mls_mask2_161_6291)">
            <mask
              id="mls_mask3_161_6291"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#mls_mask3_161_6291)">
              <mask
                id="mls_mask4_161_6291"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#mls_mask4_161_6291)">
                <mask
                  id="mls_mask5_161_6291"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#mls_mask5_161_6291)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="mls_mask6_161_6291"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#mls_mask6_161_6291)">
                  <mask
                    id="mls_mask7_161_6291"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mls_mask7_161_6291)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="mls_mask8_161_6291"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mls_mask8_161_6291)">
                    <mask
                      id="mls_mask9_161_6291"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mls_mask9_161_6291)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.8041 32.3869C61.6277 32.1304 61.3343 31.9988 61.0385 31.9988H44.1924L52.5929 18.582C52.8092 18.2375 52.8213 17.7659 52.5587 17.3878C52.3806 17.131 52.0841 17 51.7871 17H37.2805C35.824 17 34.4631 17.7804 33.6472 19.0833L17.1608 45.4158C17.05 45.5968 16.9942 45.8062 17.0005 46.0183C17.0067 46.2305 17.0746 46.4362 17.1959 46.6104C17.372 46.8666 17.6654 46.9979 17.9615 46.9979H34.7991L26.3977 60.418C26.2465 60.66 26.2002 60.9646 26.2692 61.255C26.3753 61.7048 26.774 62 27.2039 62H41.702C43.1694 62 44.5406 61.2135 45.3622 59.901L53.4384 46.9979L61.8386 33.5811C62.0546 33.2366 62.0636 32.7644 61.8041 32.3869Z"
        fill="#4E48E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.4402 46.9949L45.3622 59.9007C44.5406 61.2135 43.1691 61.9997 41.702 61.9997H27.2039C26.774 61.9997 26.3753 61.7048 26.2692 61.255C26.2002 60.9646 26.2465 60.66 26.3977 60.418L34.8007 46.9949H53.4402Z"
        fill="#4E48E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.1815 31.9988H61.0385C61.3343 31.9988 61.6277 32.1304 61.8041 32.3866C62.0639 32.7644 62.0543 33.2363 61.8389 33.5811L53.439 46.9979H34.7922L44.1815 31.9988Z"
        fill="#1C81C1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9615 46.9979C17.6657 46.9979 17.3723 46.8666 17.1962 46.6104C16.9361 46.2323 16.9452 45.7607 17.1611 45.4161L33.6476 19.0833C34.4631 17.7804 35.8243 17 37.2805 17H51.7871C52.0841 17 52.3809 17.1313 52.559 17.3878C52.8213 17.7659 52.8092 18.2375 52.5932 18.5823L34.801 46.9979H17.9615Z"
        fill="#5CC4CD"
      />
    </g>
    <defs>
      <clipPath id="mls_clip0_161_6291">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OneSignal = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#os1_clip0_161_702)">
      <mask
        id="os1_mask0_161_702"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#os1_mask0_161_702)">
        <mask
          id="os1_mask1_161_702"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#os1_mask1_161_702)">
          <mask
            id="os1_mask2_161_702"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#os1_mask2_161_702)">
            <mask
              id="os1_mask3_161_702"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#os1_mask3_161_702)">
              <mask
                id="os1_mask4_161_702"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#os1_mask4_161_702)">
                <mask
                  id="os1_mask5_161_702"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#os1_mask5_161_702)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="os1_mask6_161_702"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#os1_mask6_161_702)">
                  <mask
                    id="os1_mask7_161_702"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#os1_mask7_161_702)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="os1_mask8_161_702"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#os1_mask8_161_702)">
                    <mask
                      id="os1_mask9_161_702"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#os1_mask9_161_702)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M39.4583 17C27.0435 17.0247 16.9305 27.2417 17.0004 39.6874C17.0322 45.2508 19.1139 50.6062 22.8453 54.7245C26.5768 58.8428 31.6948 61.4335 37.2158 61.9987C37.2519 62.0023 37.2884 61.9983 37.3228 61.9869C37.3572 61.9755 37.3888 61.957 37.4157 61.9325C37.4425 61.9081 37.4639 61.8783 37.4785 61.845C37.493 61.8117 37.5005 61.7757 37.5004 61.7394V39.5576H35.7518C35.6833 39.5576 35.6175 39.5304 35.5689 39.4818C35.5205 39.4331 35.4933 39.3672 35.4933 39.2985V35.7982C35.4933 35.7293 35.5205 35.6634 35.5689 35.6147C35.6175 35.5661 35.6833 35.5389 35.7518 35.5389H41.2403C41.3089 35.5389 41.3746 35.5661 41.4232 35.6147C41.4717 35.6634 41.499 35.7293 41.499 35.7982V61.7394C41.4987 61.7757 41.5061 61.8117 41.5207 61.845C41.5354 61.8783 41.5568 61.9081 41.5835 61.9325C41.6104 61.957 41.642 61.9755 41.6764 61.9869C41.711 61.9983 41.7473 62.0023 41.7834 61.9987C47.5269 61.4108 52.8251 58.6326 56.5824 54.2384C60.3396 49.8442 62.2686 44.1706 61.9698 38.3908C61.6711 32.611 59.1678 27.1673 54.9779 23.1859C50.7878 19.2044 45.2314 16.9898 39.4583 17ZM45.8531 56.9738C45.8141 56.9877 45.7723 56.992 45.7312 56.9864C45.69 56.9806 45.651 56.9652 45.6172 56.9412C45.5832 56.9171 45.5556 56.8852 45.5367 56.8482C45.5176 56.8113 45.5077 56.7703 45.5078 56.7287V53.0262C45.508 52.9525 45.529 52.8804 45.5683 52.8182C45.6077 52.756 45.6639 52.7064 45.7303 52.6748C48.718 51.2501 51.1296 48.8432 52.5639 45.8543C53.9984 42.8656 54.3695 39.4746 53.6155 36.2451C52.8615 33.0156 51.0278 30.142 48.4192 28.1017C45.8105 26.0615 42.5841 24.9776 39.276 25.0301C31.5787 25.148 25.2627 31.3708 25.0182 39.0845C24.9288 41.909 25.662 44.6986 27.1284 47.1121C28.5949 49.5257 30.7308 51.4586 33.2754 52.6748C33.3419 52.7064 33.398 52.756 33.4375 52.8182C33.4768 52.8804 33.4977 52.9525 33.4979 53.0262V56.7287C33.498 56.7703 33.4881 56.8113 33.4691 56.8482C33.4502 56.8852 33.4225 56.9171 33.3886 56.9412C33.3547 56.9652 33.3156 56.9806 33.2745 56.9864C33.2334 56.992 33.1916 56.9877 33.1525 56.9738C29.5668 55.6548 26.4755 53.257 24.3017 50.1087C22.1279 46.9603 20.9779 43.2154 21.0093 39.3866C21.0973 29.316 29.3065 21.0928 39.356 21.0189C49.6229 20.936 57.9951 29.2849 57.9951 39.5576C57.9951 47.5462 52.9334 54.3705 45.8531 56.9738Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="os1_clip0_161_702">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Postmark = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#pmk_clip0_161_6247)">
      <mask
        id="pmk_mask0_161_6247"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#pmk_mask0_161_6247)">
        <mask
          id="pmk_mask1_161_6247"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#pmk_mask1_161_6247)">
          <mask
            id="pmk_mask2_161_6247"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#pmk_mask2_161_6247)">
            <mask
              id="pmk_mask3_161_6247"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#pmk_mask3_161_6247)">
              <mask
                id="pmk_mask4_161_6247"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#pmk_mask4_161_6247)">
                <mask
                  id="pmk_mask5_161_6247"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#pmk_mask5_161_6247)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#FFDE00"
                  />
                </g>
                <mask
                  id="pmk_mask6_161_6247"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#pmk_mask6_161_6247)">
                  <mask
                    id="pmk_mask7_161_6247"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#pmk_mask7_161_6247)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#FFDE00"
                    />
                  </g>
                  <mask
                    id="pmk_mask8_161_6247"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#pmk_mask8_161_6247)">
                    <mask
                      id="pmk_mask9_161_6247"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#pmk_mask9_161_6247)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#FFDE00"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clipPath="url(#pmk_clip1_161_6247)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M65 60.7032V63.0468C63.9213 63.0468 63.0468 63.9213 63.0468 65H60.7032C60.7032 63.9213 59.8287 63.0468 58.75 63.0468C57.6713 63.0468 56.7968 63.9213 56.7968 65H54.4532C54.4532 63.9213 53.5787 63.0468 52.5 63.0468C51.4213 63.0468 50.5468 63.9213 50.5468 65H48.2032C48.2032 63.9213 47.3287 63.0468 46.25 63.0468C45.1713 63.0468 44.2968 63.9213 44.2968 65H41.9532C41.9532 63.9213 41.0787 63.0468 40 63.0468C38.9213 63.0468 38.0468 63.9213 38.0468 65H35.7032C35.7032 63.9213 34.8287 63.0468 33.75 63.0468C32.6713 63.0468 31.7968 63.9213 31.7968 65H29.4531C29.4531 63.9213 28.5787 63.0468 27.5 63.0468C26.4213 63.0468 25.5469 63.9213 25.5469 65H23.2031C23.2031 64.3022 22.8309 63.6575 22.2266 63.3085C21.6223 62.9597 20.8777 62.9597 20.2734 63.3085C19.6691 63.6575 19.2969 64.3022 19.2969 65H16.9531C16.9531 63.9213 16.0787 63.0468 15 63.0468V60.7032C16.0787 60.7032 16.9531 59.8287 16.9531 58.75C16.9531 57.6713 16.0787 56.7968 15 56.7968V54.4532C16.0787 54.4532 16.9531 53.5787 16.9531 52.5C16.9531 51.4213 16.0787 50.5468 15 50.5468V48.2032C16.0787 48.2032 16.9531 47.3287 16.9531 46.25C16.9531 45.1713 16.0787 44.2968 15 44.2968V41.9532C16.0787 41.9532 16.9531 41.0787 16.9531 40C16.9531 38.9213 16.0787 38.0468 15 38.0468V35.7032C16.0787 35.7032 16.9531 34.8287 16.9531 33.75C16.9531 32.6713 16.0787 31.7968 15 31.7968V29.4531C16.0787 29.4531 16.9531 28.5787 16.9531 27.5C16.9531 26.4213 16.0787 25.5469 15 25.5469V23.2031C16.0787 23.2031 16.9531 22.3287 16.9531 21.25C16.9531 20.1713 16.0787 19.2969 15 19.2969V16.9531C16.0787 16.9531 16.9531 16.0787 16.9531 15H19.2969C19.2969 16.0787 20.1713 16.9531 21.25 16.9531C22.3287 16.9531 23.2031 16.0787 23.2031 15H25.5469C25.5469 16.0787 26.4213 16.9531 27.5 16.9531C28.5787 16.9531 29.4531 16.0787 29.4531 15H31.7968C31.7968 16.0787 32.6713 16.9531 33.75 16.9531C34.8287 16.9531 35.7032 16.0787 35.7032 15H38.0468C38.0468 16.0787 38.9213 16.9531 40 16.9531C41.0787 16.9531 41.9532 16.0787 41.9532 15H44.2968C44.2968 16.0787 45.1713 16.9531 46.25 16.9531C47.3287 16.9531 48.2032 16.0787 48.2032 15H50.5468C50.5468 16.0787 51.4213 16.9531 52.5 16.9531C53.5787 16.9531 54.4532 16.0787 54.4532 15H56.7968C56.7968 16.0787 57.6713 16.9531 58.75 16.9531C59.8287 16.9531 60.7032 16.0787 60.7032 15H63.0468C63.0468 16.0787 63.9213 16.9531 65 16.9531V19.2969C63.9213 19.2969 63.0468 20.1713 63.0468 21.25C63.0468 22.3287 63.9213 23.2031 65 23.2031V25.5469C63.9213 25.5469 63.0468 26.4213 63.0468 27.5C63.0468 28.5787 63.9213 29.4531 65 29.4531V31.7968C63.9213 31.7968 63.0468 32.6713 63.0468 33.75C63.0468 34.8287 63.9213 35.7032 65 35.7032V38.0468C64.3022 38.0468 63.6575 38.4192 63.3085 39.0235C62.9597 39.6277 62.9597 40.3723 63.3085 40.9765C63.6575 41.5808 64.3022 41.9532 65 41.9532V44.2968C63.9213 44.2968 63.0468 45.1713 63.0468 46.25C63.0468 47.3287 63.9213 48.2032 65 48.2032V50.5468C63.9213 50.5468 63.0468 51.4213 63.0468 52.5C63.0468 53.5787 63.9213 54.4532 65 54.4532V56.7968C63.9213 56.7968 63.0468 57.6713 63.0468 58.75C63.0468 59.8287 63.9213 60.7032 65 60.7032Z"
          fill="#FFDE00"
        />
        <path
          d="M29.5052 50.634H31.0641C31.8647 50.634 32.3702 50.1175 32.3702 49.2997V31.0481C32.3702 30.2302 31.8647 29.7137 31.0641 29.7137H29.5052V25.6674H40.7967C46.8637 25.6674 51.6667 28.8097 51.6667 34.7932C51.6667 40.8195 46.8637 43.962 40.7967 43.962H36.9205V49.2997C36.9205 50.1175 37.426 50.634 38.2687 50.634H41.4285V54.7235H29.5052V50.634ZM40.4595 39.7434C44.4622 39.7434 46.7793 38.0215 46.7793 34.8792C46.7793 31.6508 44.4622 30.015 40.4595 30.015H36.9205V39.7865H40.4595V39.7434Z"
          fill="black"
        />
      </g>
    </g>
    <defs>
      <clipPath id="pmk_clip0_161_6247">
        <rect width="80" height="80" fill="white" />
      </clipPath>
      <clipPath id="pmk_clip1_161_6247">
        <rect width="50" height="50" fill="white" transform="translate(15 15)" />
      </clipPath>
    </defs>
  </svg>
);

export const ShortIo = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#shio_clip0_161_6335)">
      <mask
        id="shio_mask0_161_6335"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#shio_mask0_161_6335)">
        <mask
          id="shio_mask1_161_6335"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#shio_mask1_161_6335)">
          <mask
            id="shio_mask2_161_6335"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#shio_mask2_161_6335)">
            <mask
              id="shio_mask3_161_6335"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#shio_mask3_161_6335)">
              <mask
                id="shio_mask4_161_6335"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#shio_mask4_161_6335)">
                <mask
                  id="shio_mask5_161_6335"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#shio_mask5_161_6335)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="shio_mask6_161_6335"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#shio_mask6_161_6335)">
                  <mask
                    id="shio_mask7_161_6335"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#shio_mask7_161_6335)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="shio_mask8_161_6335"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#shio_mask8_161_6335)">
                    <mask
                      id="shio_mask9_161_6335"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#shio_mask9_161_6335)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M46.7636 49.9828C46.7636 51.3825 46.2038 52.4323 45.014 53.2021C43.8943 53.902 42.3546 54.3219 40.465 54.3219C38.0855 54.3219 36.266 53.762 34.8663 52.7122C33.4666 51.5925 32.7667 50.1928 32.6268 48.4432L21.2193 48.1632C21.2193 51.0326 22.0591 53.622 23.7387 55.9315C25.5014 58.3261 27.8682 60.2099 30.5972 61.3903C32.1369 62.0902 33.7465 62.58 35.4961 62.93L35.7761 63H18V18.1399H35.4261C31.1092 18.8897 27.2212 21.2075 24.5086 24.6485C22.9689 26.748 22.1991 29.1275 22.1991 31.7869C22.1991 34.7262 22.8289 37.1057 24.0187 38.8553C25.2084 40.6049 26.818 41.9346 28.7776 42.8444C30.7372 43.7542 33.1866 44.4541 36.196 45.0839C39.2753 45.7138 41.4448 46.2037 42.8445 46.6236C44.1742 46.9735 45.154 47.3934 45.8538 47.9533C46.4137 48.3732 46.7636 49.073 46.7636 49.9828Z"
        fill="#0BB07D"
      />
      <path
        d="M62.7901 62.93H44.6641C46.3815 62.6399 48.0525 62.1221 49.633 61.3904C52.2609 60.2357 54.5321 58.3993 56.2115 56.0716C57.7512 53.8321 58.591 51.3126 58.591 48.5132C58.6962 46.0952 58.0614 43.7026 56.7714 41.6548C55.5817 39.9751 53.972 38.6454 51.9425 37.8056C49.5047 36.8235 46.9717 36.0964 44.3842 35.6361C41.3748 35.0762 39.2753 34.5863 37.9456 34.1664C36.8942 33.9387 35.8963 33.511 35.0062 32.9067C34.3764 32.4168 34.0964 31.717 34.0964 30.8072C34.0964 29.4775 34.5863 28.4977 35.6361 27.7978C36.6859 27.098 38.0156 26.7481 39.6952 26.7481C41.5848 26.7481 43.1244 27.238 44.2442 28.2177C44.7945 28.6905 45.245 29.2682 45.5694 29.9171C45.8939 30.566 46.0857 31.273 46.1338 31.9969H57.6112C57.6112 29.3375 56.8414 26.888 55.3017 24.6485C53.6621 22.4009 51.4679 20.6166 48.9331 19.4697C47.4635 18.7698 45.8538 18.2799 44.1742 18H62.7901V62.93Z"
        fill="#3C3C3C"
      />
    </g>
    <defs>
      <clipPath id="shio_clip0_161_6335">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Yotpo = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#ytp_clip0_135_10717)">
      <mask
        id="ytp_mask0_135_10717"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#ytp_mask0_135_10717)">
        <mask
          id="ytp_mask1_135_10717"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#ytp_mask1_135_10717)">
          <mask
            id="ytp_mask2_135_10717"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#ytp_mask2_135_10717)">
            <mask
              id="ytp_mask3_135_10717"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#ytp_mask3_135_10717)">
              <mask
                id="ytp_mask4_135_10717"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#ytp_mask4_135_10717)">
                <mask
                  id="ytp_mask5_135_10717"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#ytp_mask5_135_10717)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#0042E4"
                  />
                </g>
                <mask
                  id="ytp_mask6_135_10717"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#ytp_mask6_135_10717)">
                  <mask
                    id="ytp_mask7_135_10717"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#ytp_mask7_135_10717)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#0042E4"
                    />
                  </g>
                  <mask
                    id="ytp_mask8_135_10717"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#ytp_mask8_135_10717)">
                    <mask
                      id="ytp_mask9_135_10717"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#ytp_mask9_135_10717)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#0042E4"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 25H34.5689L39.5 37.9554L44.6658 25H52L39.4589 55H32.2056L35.9149 45.7044L27 25Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="ytp_clip0_135_10717">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ChartMogul = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#cmg_clip0_161_4883)">
      <mask
        id="cmg_mask0_161_4883"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#cmg_mask0_161_4883)">
        <mask
          id="cmg_mask1_161_4883"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#cmg_mask1_161_4883)">
          <mask
            id="cmg_mask2_161_4883"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#cmg_mask2_161_4883)">
            <mask
              id="cmg_mask3_161_4883"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#cmg_mask3_161_4883)">
              <mask
                id="cmg_mask4_161_4883"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#cmg_mask4_161_4883)">
                <mask
                  id="cmg_mask5_161_4883"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#cmg_mask5_161_4883)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="cmg_mask6_161_4883"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#cmg_mask6_161_4883)">
                  <mask
                    id="cmg_mask7_161_4883"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#cmg_mask7_161_4883)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="cmg_mask8_161_4883"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#cmg_mask8_161_4883)">
                    <mask
                      id="cmg_mask9_161_4883"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#cmg_mask9_161_4883)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M37.1271 56.4375V33.2292L20.9729 56.4375H15V23.5625H20.7458V46.7125L36.9 23.5604H42.8729V46.7688L59.0833 23.5625H65V56.4417H59.3125V33.2292L43.1562 56.4375H37.1271Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="cmg_clip0_161_4883">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ConfigCat = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#ccat_clip0_135_10761)">
      <mask
        id="ccat_mask0_135_10761"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#ccat_mask0_135_10761)">
        <mask
          id="ccat_mask1_135_10761"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#ccat_mask1_135_10761)">
          <mask
            id="ccat_mask2_135_10761"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#ccat_mask2_135_10761)">
            <mask
              id="ccat_mask3_135_10761"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#ccat_mask3_135_10761)">
              <mask
                id="ccat_mask4_135_10761"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#ccat_mask4_135_10761)">
                <mask
                  id="ccat_mask5_135_10761"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#ccat_mask5_135_10761)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="ccat_mask6_135_10761"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#ccat_mask6_135_10761)">
                  <mask
                    id="ccat_mask7_135_10761"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#ccat_mask7_135_10761)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="ccat_mask8_135_10761"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#ccat_mask8_135_10761)">
                    <mask
                      id="ccat_mask9_135_10761"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#ccat_mask9_135_10761)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M49.5615 29.7948V17L36.7089 29.7948H26.0196L17.4474 21.2225V49.0794C17.4474 50.7682 17.7802 52.4405 18.4268 54.0006C19.0735 55.5607 20.0212 56.9781 21.2159 58.1717C22.4106 59.3653 23.8288 60.3118 25.3895 60.957C26.9502 61.6022 28.6228 61.9336 30.3116 61.932H49.5962V29.7948H49.5615Z"
        fill="#ED1C24"
      />
      <path
        d="M40.3646 34.1792H26.6791C23.7273 34.1792 21.3344 36.5721 21.3344 39.5238V39.9172C21.3344 42.8689 23.7273 45.2618 26.6791 45.2618H40.3646C43.3164 45.2618 45.7092 42.8689 45.7092 39.9172V39.5238C45.7092 36.5721 43.3164 34.1792 40.3646 34.1792Z"
        fill="white"
      />
      <path
        d="M39.7051 44.0008C42.0691 44.0008 43.9855 42.0844 43.9855 39.7204C43.9855 37.3564 42.0691 35.4401 39.7051 35.4401C37.3412 35.4401 35.4248 37.3564 35.4248 39.7204C35.4248 42.0844 37.3412 44.0008 39.7051 44.0008Z"
        fill="black"
      />
      <path
        d="M27.2691 36.3541C27.9555 36.3541 28.6265 36.5577 29.1972 36.939C29.7679 37.3204 30.2127 37.8624 30.4754 38.4966C30.7381 39.1307 30.8068 39.8285 30.6729 40.5018C30.539 41.175 30.2085 41.7934 29.7231 42.2787C29.2377 42.7641 28.6193 43.0946 27.9461 43.2285C27.2729 43.3625 26.5751 43.2937 25.9409 43.031C25.3068 42.7684 24.7647 42.3235 24.3834 41.7528C24.0021 41.1821 23.7985 40.5111 23.7985 39.8247C23.7985 38.9042 24.1642 38.0215 24.815 37.3706C25.4659 36.7198 26.3486 36.3541 27.2691 36.3541ZM27.2691 35.4981C26.4197 35.4958 25.5888 35.7455 24.8815 36.2157C24.1741 36.686 23.6222 37.3555 23.2956 38.1395C22.969 38.9235 22.8823 39.7869 23.0466 40.6202C23.2109 41.4535 23.6188 42.2193 24.2186 42.8207C24.8183 43.4221 25.5831 43.832 26.4159 43.9986C27.2488 44.1651 28.1123 44.0808 28.8973 43.7563C29.6822 43.4318 30.3532 42.8817 30.8253 42.1756C31.2974 41.4696 31.5494 40.6393 31.5494 39.79C31.5463 38.6557 31.0944 37.5687 30.2923 36.7667C29.4903 35.9646 28.4033 35.5127 27.2691 35.5096V35.4981Z"
        fill="#ED1C24"
      />
      <path
        d="M35.448 48.5241C35.4081 48.4832 35.3604 48.4507 35.3077 48.4285C35.2551 48.4063 35.1985 48.3948 35.1414 48.3948C35.0842 48.3948 35.0277 48.4063 34.975 48.4285C34.9224 48.4507 34.8747 48.4832 34.8348 48.5241L33.5276 49.8314L32.2088 48.5241C32.1712 48.4771 32.1241 48.4385 32.0706 48.4108C32.017 48.3832 31.9583 48.3672 31.8981 48.3638C31.838 48.3605 31.7778 48.3698 31.7216 48.3913C31.6653 48.4128 31.6142 48.4459 31.5716 48.4885C31.529 48.5311 31.4959 48.5822 31.4744 48.6385C31.4529 48.6948 31.4435 48.7549 31.4469 48.8151C31.4503 48.8752 31.4663 48.934 31.4939 48.9875C31.5215 49.041 31.5601 49.0881 31.6072 49.1257L33.0995 50.618V53.5333C33.0995 53.6468 33.1446 53.7557 33.2249 53.836C33.3052 53.9162 33.4141 53.9613 33.5276 53.9613C33.6402 53.9584 33.7474 53.9124 33.827 53.8327C33.9067 53.7531 33.9527 53.6459 33.9556 53.5333V50.618L35.448 49.1257C35.5271 49.0456 35.5714 48.9375 35.5714 48.8249C35.5714 48.7123 35.5271 48.6043 35.448 48.5241Z"
        fill="white"
      />
      <path
        d="M15.9667 50.1669H24.643C24.7289 50.1669 24.8113 50.1327 24.8721 50.072C24.9328 50.0112 24.967 49.9288 24.967 49.8429C24.9686 49.8 24.9613 49.7571 24.9456 49.7171C24.9299 49.6771 24.9061 49.6407 24.8757 49.6103C24.8453 49.5799 24.8089 49.5561 24.7689 49.5404C24.7289 49.5247 24.686 49.5174 24.643 49.519H15.9667C15.9237 49.5174 15.8808 49.5247 15.8408 49.5404C15.8008 49.5561 15.7644 49.5799 15.734 49.6103C15.7036 49.6407 15.6798 49.6771 15.6641 49.7171C15.6484 49.7571 15.6411 49.8 15.6427 49.8429C15.6427 49.9288 15.6769 50.0112 15.7376 50.072C15.7984 50.1327 15.8808 50.1669 15.9667 50.1669Z"
        fill="white"
      />
      <path
        d="M26.2857 51.0692H14.3239C14.238 51.0692 14.1556 51.1033 14.0949 51.1641C14.0341 51.2248 14 51.3072 14 51.3931C14.0029 51.4781 14.0379 51.5588 14.0981 51.619C14.1582 51.6791 14.2389 51.7142 14.3239 51.717H26.2857C26.3707 51.7142 26.4515 51.6791 26.5116 51.619C26.5717 51.5588 26.6068 51.4781 26.6097 51.3931C26.6097 51.3072 26.5755 51.2248 26.5148 51.1641C26.454 51.1033 26.3717 51.0692 26.2857 51.0692Z"
        fill="white"
      />
      <path
        d="M24.643 52.6194H15.9667C15.9237 52.6177 15.8808 52.625 15.8408 52.6407C15.8008 52.6564 15.7644 52.6802 15.734 52.7106C15.7036 52.741 15.6798 52.7774 15.6641 52.8174C15.6484 52.8575 15.6411 52.9003 15.6427 52.9433C15.6427 53.0292 15.6769 53.1116 15.7376 53.1723C15.7984 53.2331 15.8808 53.2672 15.9667 53.2672H24.643C24.7289 53.2672 24.8113 53.2331 24.8721 53.1723C24.9328 53.1116 24.967 53.0292 24.967 52.9433C24.9686 52.9003 24.9613 52.8575 24.9456 52.8174C24.9299 52.7774 24.9061 52.741 24.8757 52.7106C24.8453 52.6802 24.8089 52.6564 24.7689 52.6407C24.7289 52.625 24.686 52.6177 24.643 52.6194Z"
        fill="white"
      />
      <path
        d="M42.4702 49.8429H51.1581C51.244 49.8429 51.3264 49.8088 51.3871 49.748C51.4479 49.6873 51.482 49.6049 51.482 49.519C51.482 49.4331 51.4479 49.3507 51.3871 49.2899C51.3264 49.2292 51.244 49.1951 51.1581 49.1951H42.4702C42.3842 49.1951 42.3019 49.2292 42.2411 49.2899C42.1804 49.3507 42.1462 49.4331 42.1462 49.519C42.1462 49.6049 42.1804 49.6873 42.2411 49.748C42.3019 49.8088 42.3842 49.8429 42.4702 49.8429Z"
        fill="white"
      />
      <path
        d="M52.7891 50.7452H40.8388C40.7529 50.7452 40.6705 50.7794 40.6098 50.8401C40.549 50.9009 40.5149 50.9832 40.5149 51.0692C40.5149 51.1551 40.549 51.2375 40.6098 51.2982C40.6705 51.3589 40.7529 51.3931 40.8388 51.3931H52.7891C52.875 51.3931 52.9574 51.3589 53.0181 51.2982C53.0789 51.2375 53.113 51.1551 53.113 51.0692C53.113 50.9832 53.0789 50.9009 53.0181 50.8401C52.9574 50.7794 52.875 50.7452 52.7891 50.7452Z"
        fill="white"
      />
      <path
        d="M51.1581 52.2955H42.4702C42.3842 52.2955 42.3019 52.3297 42.2411 52.3904C42.1804 52.4512 42.1462 52.5335 42.1462 52.6195C42.1462 52.7054 42.1804 52.7877 42.2411 52.8485C42.3019 52.9092 42.3842 52.9434 42.4702 52.9434H51.1581C51.244 52.9434 51.3264 52.9092 51.3871 52.8485C51.4479 52.7877 51.482 52.7054 51.482 52.6195C51.482 52.5335 51.4479 52.4512 51.3871 52.3904C51.3264 52.3297 51.244 52.2955 51.1581 52.2955Z"
        fill="white"
      />
      <path
        d="M65.3641 38.286C65.0141 37.3345 64.3411 36.5361 63.4625 36.0302C62.5839 35.5243 61.5556 35.343 60.557 35.5179C59.5583 35.6928 58.6529 36.2129 57.9986 36.9873C57.3443 37.7617 56.9827 38.7413 56.977 39.7552C56.9782 40.3432 57.0961 40.9252 57.324 41.4673C57.8706 42.9808 58.1486 44.5781 58.1454 46.1872C58.1439 48.0361 57.7782 49.8666 57.0693 51.5741C56.3603 53.2817 55.322 54.8328 54.0136 56.1391C52.7052 57.4454 51.1523 58.4811 49.4436 59.1873C47.7349 59.8934 45.9038 60.2561 44.0549 60.2545C42.8067 60.2638 41.5625 60.1121 40.353 59.8034C43.4968 61.5414 47.0972 62.2756 50.6705 61.9073C54.2438 61.539 57.6188 60.0858 60.3419 57.7431C63.0651 55.4003 65.0059 52.2802 65.9037 48.8019C66.8015 45.3237 66.6132 41.654 65.3641 38.286Z"
        fill="#ED1C24"
      />
    </g>
    <defs>
      <clipPath id="ccat_clip0_135_10761">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Pingdom = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#pgd_clip0_161_3475)">
      <mask
        id="pgd_mask0_161_3475"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#pgd_mask0_161_3475)">
        <mask
          id="pgd_mask1_161_3475"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#pgd_mask1_161_3475)">
          <mask
            id="pgd_mask2_161_3475"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#pgd_mask2_161_3475)">
            <mask
              id="pgd_mask3_161_3475"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#pgd_mask3_161_3475)">
              <mask
                id="pgd_mask4_161_3475"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#pgd_mask4_161_3475)">
                <mask
                  id="pgd_mask5_161_3475"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#pgd_mask5_161_3475)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="pgd_mask6_161_3475"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#pgd_mask6_161_3475)">
                  <mask
                    id="pgd_mask7_161_3475"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#pgd_mask7_161_3475)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="pgd_mask8_161_3475"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#pgd_mask8_161_3475)">
                    <mask
                      id="pgd_mask9_161_3475"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#pgd_mask9_161_3475)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M38.7977 38.7571L38.802 38.7814C36.5208 39.3814 34.2138 39.8843 31.9512 40.58C27.2402 36.35 21.3075 33.7101 15 33.0371C24.3185 26.3697 35.4951 22.7653 46.9699 22.7271L43.0273 26.3243C43.0273 26.3243 59.7331 25.7286 63.9455 20C63.8343 20.5979 63.6523 21.1806 63.4032 21.7357C62.2338 25.1033 60.1246 28.0691 57.3228 30.2857C54.6853 32.3302 51.7658 33.9857 48.6542 35.2014C45.5865 36.5342 42.4406 37.6811 39.2339 38.6357L38.7977 38.7557V38.7571ZM65 38.1914C58.9455 39.0314 47.2783 44.9943 38.8623 49.6643C37.4953 46.9072 35.7129 44.3746 33.5768 42.1543C49.5839 36.9929 65 38.1914 65 38.1914ZM39.9154 52.0571L56.495 44.9714L41.8221 60C41.5537 57.278 40.9131 54.6054 39.9154 52.0571Z"
        fill="#FFA100"
      />
    </g>
    <defs>
      <clipPath id="pgd_clip0_161_3475">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Retently = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#rtl_clip0_135_7901)">
      <mask
        id="rtl_mask0_135_7901"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#rtl_mask0_135_7901)">
        <mask
          id="rtl_mask1_135_7901"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#rtl_mask1_135_7901)">
          <mask
            id="rtl_mask2_135_7901"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#rtl_mask2_135_7901)">
            <mask
              id="rtl_mask3_135_7901"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#rtl_mask3_135_7901)">
              <mask
                id="rtl_mask4_135_7901"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#rtl_mask4_135_7901)">
                <mask
                  id="rtl_mask5_135_7901"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#rtl_mask5_135_7901)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="rtl_mask6_135_7901"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#rtl_mask6_135_7901)">
                  <mask
                    id="rtl_mask7_135_7901"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#rtl_mask7_135_7901)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="rtl_mask8_135_7901"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#rtl_mask8_135_7901)">
                    <mask
                      id="rtl_mask9_135_7901"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#rtl_mask9_135_7901)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.8336 24.2735C55.1323 24.4391 53.4794 25.1418 52.0382 26.1735C48.4106 21.777 43.0873 19 37.1514 19C26.2221 19 17.362 28.4101 17.362 40.0189C17.362 40.7217 17.3986 41.4151 17.4629 42.0998C16.7779 44.1379 16.8492 46.098 17.703 46.5743C17.9036 46.6862 18.1312 46.707 18.3728 46.6497C20.9874 55.0074 28.4044 61.0382 37.1514 61.0382C48.0807 61.0382 56.9408 51.6281 56.9408 40.0193C56.9408 39.5178 56.9193 39.0218 56.8868 38.5298C59.3159 37.2089 61.4798 34.8989 62.42 32.0536C63.9939 27.2906 61.1613 23.8532 56.8336 24.2735ZM37.0106 21.3936C42.276 21.3936 46.9934 23.8799 50.1829 27.8055C49.0742 28.994 48.2078 30.38 47.7157 31.804C47.3348 32.9063 47.1911 33.994 47.2709 34.9954L37.1499 43.0298C36.8451 42.6174 36.4768 42.296 36.0556 42.0873C36.1964 41.06 36.2946 39.9703 36.3116 38.8653C36.3674 35.2991 35.5317 31.9504 33.0383 30.6221C33.6206 28.2669 32.956 26.5925 31.4745 26.7366C30.0964 26.8708 28.4328 28.5585 27.4479 30.6653C24.7853 31.8385 22.8553 34.3907 21.6273 36.3421C21.2072 37.0096 20.8252 37.6822 20.486 38.3234C20.223 38.3406 19.9407 38.4615 19.6526 38.6702C20.2348 29.025 27.7833 21.3936 37.0106 21.3936ZM35.2122 48.676C34.6377 50.3072 33.3346 51.2498 32.3512 50.7919C31.4113 50.3539 31.1132 48.7867 31.6481 47.2854C32.1816 45.788 33.3801 44.8176 34.3587 45.1291C35.3821 45.4556 35.7848 47.0503 35.2122 48.676ZM31.0855 31.5223C30.6259 32.7893 29.6476 33.7782 28.9297 33.7252C28.237 33.6746 28.0453 32.6657 28.479 31.4783C28.9124 30.2937 29.8293 29.3115 30.5475 29.284C31.2905 29.2566 31.5436 30.2587 31.0855 31.5223ZM18.5269 44.3534C18.0924 44.1509 18.0588 43.1542 18.4404 42.1288C18.8206 41.1051 19.4897 40.3889 19.9437 40.5341C20.4118 40.6832 20.4787 41.6866 20.0785 42.7685C19.677 43.8531 18.975 44.5621 18.5269 44.3534ZM37.0106 58.3448C29.048 58.3448 22.3362 52.6613 20.2718 44.9059C20.584 44.4083 20.8718 43.8232 21.1119 43.1722C21.7281 41.5014 21.8242 39.9467 21.4743 39.0658C21.7215 38.6169 21.9904 38.1566 22.2827 37.699C23.6075 35.6268 25.0387 34.1623 26.6458 33.4564C26.498 35.0072 26.9639 36.1636 27.9877 36.3096C29.086 36.4665 30.5091 35.4361 31.6104 33.808C32.9508 34.8192 33.7185 36.7922 33.6224 39.9667C33.5999 40.7076 33.5312 41.4437 33.4373 42.1512C31.9666 42.8309 30.5834 44.4785 29.8312 46.5759C28.7195 49.6763 29.2519 53.0172 31.1808 54.0935C33.3058 55.2794 36.2636 53.3001 37.56 49.5927C37.9501 48.4771 38.1238 47.3898 38.1175 46.3986L48.858 38.4383C49.5574 39.0752 50.478 39.5155 51.6141 39.6771C52.4997 39.8031 53.4454 39.7372 54.4001 39.5049C54.4023 39.6265 54.406 39.747 54.406 39.869C54.4056 50.0726 46.6177 58.3448 37.0106 58.3448ZM57.7971 31.9747C57.0989 34.0572 54.9121 35.6389 53.0291 35.5004C51.2513 35.3698 50.4008 33.7366 51.0426 31.8605C51.6824 29.9915 53.618 28.4235 55.4508 28.3548C57.3908 28.2822 58.4921 29.9009 57.7971 31.9747Z"
        fill="#1E2336"
      />
    </g>
    <defs>
      <clipPath id="rtl_clip0_135_7901">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CoinMarketCap = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#cmc_clip0_184_4605)">
      <mask
        id="cmc_mask0_184_4605"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#cmc_mask0_184_4605)">
        <mask
          id="cmc_mask1_184_4605"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#cmc_mask1_184_4605)">
          <mask
            id="cmc_mask2_184_4605"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#cmc_mask2_184_4605)">
            <mask
              id="cmc_mask3_184_4605"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#cmc_mask3_184_4605)">
              <mask
                id="cmc_mask4_184_4605"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#cmc_mask4_184_4605)">
                <mask
                  id="cmc_mask5_184_4605"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#cmc_mask5_184_4605)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="cmc_mask6_184_4605"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#cmc_mask6_184_4605)">
                  <mask
                    id="cmc_mask7_184_4605"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#cmc_mask7_184_4605)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="cmc_mask8_184_4605"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#cmc_mask8_184_4605)">
                    <mask
                      id="cmc_mask9_184_4605"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#cmc_mask9_184_4605)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M58.9866 40.0083V39.9307C58.9482 28.9563 50.2001 20 39.4933 20C28.7864 20 20 28.9563 20 40.0083C20 51.0617 28.7467 60 39.4933 60C44.4245 60.0033 49.1673 58.0853 52.7346 54.6451C53.0859 54.3207 53.2954 53.8685 53.3169 53.388C53.3384 52.9077 53.1701 52.4383 52.8491 52.0832C52.528 51.7282 52.0806 51.5166 51.6051 51.4948C51.1298 51.4731 50.6652 51.6432 50.3139 51.9676L50.2755 52.0064C48.7363 53.485 46.9172 54.6341 44.9276 55.3847C42.9379 56.1352 40.8186 56.4718 38.697 56.3741C36.5755 56.2765 34.4953 55.7465 32.5814 54.8163C30.6676 53.886 28.9594 52.5746 27.5596 50.9606L35.8869 37.4666V43.7108C35.8869 46.6944 37.0383 47.6653 38.006 47.9368C38.9738 48.2083 40.4254 48.0116 41.9976 45.4921L46.5663 37.9957C46.6883 37.7769 46.8295 37.5691 46.9857 37.3738V41.176C46.9857 43.967 48.0988 46.2165 50.0164 47.3011C50.9017 47.7881 51.9009 48.0238 52.908 47.9831C53.9152 47.9424 54.8927 47.6267 55.7365 47.0697C57.9516 45.6167 59.1415 43.0722 58.9866 40.0083ZM53.9203 43.9352C53.6127 44.1493 53.254 44.2765 52.8814 44.3035C52.5089 44.3305 52.1359 44.2564 51.8011 44.0889C51.0335 43.6249 50.5716 42.5791 50.5716 41.1441V36.7491C50.5716 34.6575 49.7656 33.1436 48.3853 32.7585C46.0427 32.0438 44.2799 34.9678 43.6261 36.0537L39.4933 42.7606V34.5024C39.4549 32.6034 38.8394 31.4786 37.688 31.1282C36.9204 30.8969 35.769 31.0146 34.6573 32.7211L25.4089 47.6875C24.1786 45.3185 23.5338 42.6837 23.5297 40.0083C23.5297 30.9731 30.7041 23.6443 39.4933 23.6443C48.2825 23.6443 55.4569 30.9731 55.4569 40.0083V40.0873C55.5487 41.8298 54.995 43.2288 53.9217 43.9241L53.9203 43.9352Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="cmc_clip0_184_4605">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Softr = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#sfr_clip0_135_5084)">
      <mask
        id="sfr_mask0_135_5084"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#sfr_mask0_135_5084)">
        <mask
          id="sfr_mask1_135_5084"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#sfr_mask1_135_5084)">
          <mask
            id="sfr_mask2_135_5084"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#sfr_mask2_135_5084)">
            <mask
              id="sfr_mask3_135_5084"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#sfr_mask3_135_5084)">
              <mask
                id="sfr_mask4_135_5084"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#sfr_mask4_135_5084)">
                <mask
                  id="sfr_mask5_135_5084"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#sfr_mask5_135_5084)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="sfr_mask6_135_5084"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#sfr_mask6_135_5084)">
                  <mask
                    id="sfr_mask7_135_5084"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#sfr_mask7_135_5084)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="sfr_mask8_135_5084"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#sfr_mask8_135_5084)">
                    <mask
                      id="sfr_mask9_135_5084"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#sfr_mask9_135_5084)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M42.5177 48.8486C42.5177 46.3562 42.5177 45.1099 43.0027 44.1579C43.4294 43.3206 44.1102 42.6398 44.9476 42.213C45.8996 41.728 47.1458 41.728 49.6381 41.728H54.256C56.7484 41.728 57.9946 41.728 58.9465 42.213C59.784 42.6398 60.4648 43.3206 60.8914 44.1579C61.3766 45.1099 61.3766 46.3562 61.3766 48.8486V53.4663C61.3766 55.9587 61.3766 57.205 60.8914 58.157C60.4648 58.9943 59.784 59.6751 58.9465 60.1019C57.9946 60.5869 56.7484 60.5869 54.256 60.5869H49.6381C47.1458 60.5869 45.8996 60.5869 44.9476 60.1019C44.1102 59.6751 43.4294 58.9943 43.0027 58.157C42.5177 57.205 42.5177 55.9587 42.5177 53.4663V48.8486Z"
        fill="#386AF5"
      />
      <path
        d="M19.1988 51.1575C19.1988 45.9497 23.4205 41.728 28.6282 41.728C33.836 41.728 38.0576 45.9497 38.0576 51.1575C38.0576 56.3652 33.836 60.5869 28.6282 60.5869C23.4205 60.5869 19.1988 56.3652 19.1988 51.1575Z"
        fill="#F53878"
      />
      <path
        d="M19.1988 25.5335C19.1988 23.0411 19.1988 21.7949 19.6838 20.8429C20.1105 20.0055 20.7913 19.3247 21.6287 18.898C22.5807 18.413 23.8269 18.413 26.3193 18.413H54.256C56.7484 18.413 57.9947 18.413 58.9465 18.898C59.784 19.3247 60.4648 20.0055 60.8914 20.8429C61.3766 21.7949 61.3766 23.0411 61.3766 25.5335V30.1512C61.3766 32.6437 61.3766 33.8899 60.8914 34.842C60.4648 35.6793 59.784 36.3601 58.9465 36.7868C57.9947 37.2719 56.7484 37.2719 54.256 37.2719H26.3193C23.8269 37.2719 22.5807 37.2719 21.6287 36.7868C20.7913 36.3601 20.1105 35.6793 19.6838 34.842C19.1988 33.8899 19.1988 32.6437 19.1988 30.1512V25.5335Z"
        fill="#FCB500"
      />
    </g>
    <defs>
      <clipPath id="sfr_clip0_135_5084">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EmailOctopus = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#eoct_clip0_135_9309)">
      <mask
        id="eoct_mask0_135_9309"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#eoct_mask0_135_9309)">
        <mask
          id="eoct_mask1_135_9309"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#eoct_mask1_135_9309)">
          <mask
            id="eoct_mask2_135_9309"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#eoct_mask2_135_9309)">
            <mask
              id="eoct_mask3_135_9309"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#eoct_mask3_135_9309)">
              <mask
                id="eoct_mask4_135_9309"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#eoct_mask4_135_9309)">
                <mask
                  id="eoct_mask5_135_9309"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#eoct_mask5_135_9309)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="eoct_mask6_135_9309"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#eoct_mask6_135_9309)">
                  <mask
                    id="eoct_mask7_135_9309"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#eoct_mask7_135_9309)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="eoct_mask8_135_9309"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#eoct_mask8_135_9309)">
                    <mask
                      id="eoct_mask9_135_9309"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#eoct_mask9_135_9309)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M59.035 44.4486C58.0433 43.7964 56.7068 44.0661 56.0502 45.0514C55.5495 45.8024 54.639 46.6984 53.1452 46.7035C52.3278 46.7061 51.3668 46.3485 50.6436 45.5709C50.484 45.3995 50.4838 45.1351 50.6467 44.9668C54.2888 41.2032 56.2273 35.8827 55.4629 30.3082C54.1365 20.6355 45.1756 13.8593 35.44 15.1599C25.7773 16.4507 18.9192 25.3009 20.1409 34.9096C20.9547 41.31 25.1058 46.4637 30.627 48.8879C30.8099 48.9682 30.9152 49.163 30.8816 49.3588C30.8138 49.7539 30.6823 50.1402 30.4852 50.5005C30.1199 51.1679 29.2076 52.2982 27.204 52.3735C26.0144 52.4176 25.0879 53.4109 25.1326 54.5917C25.1772 55.7725 26.177 56.6937 27.3656 56.6494C27.6771 56.6377 27.9829 56.6115 28.283 56.5708C30.8934 56.2176 33.0443 54.7831 34.2696 52.5444C34.4162 52.2765 34.5459 52.0018 34.6593 51.722C34.6951 51.6335 34.7876 51.5811 34.8822 51.598C34.9912 51.6175 35.0649 51.7208 35.0454 51.8291C34.5574 54.5467 33.2832 57.2379 31.4291 59.2816C30.6475 60.143 30.6677 61.4805 31.5093 62.284C32.0056 62.7578 32.6667 62.9473 33.2947 62.8623C33.7796 62.7967 34.245 62.5674 34.5991 62.1788C36.3754 60.2309 37.7672 57.8094 38.6242 55.1759C39.0273 53.9368 39.3038 52.6799 39.4501 51.4372C39.4602 51.3516 39.5284 51.2846 39.6148 51.2759C39.7096 51.2666 39.7968 51.3305 39.815 51.4234C40.5151 55.0037 39.9089 58.3456 37.952 61.8143C37.3705 62.845 37.7402 64.1489 38.778 64.7266C39.2022 64.9628 39.6724 65.0409 40.12 64.9804C40.7667 64.8929 41.366 64.5154 41.7097 63.9061C44.0827 59.7001 44.8818 55.4804 44.129 51.0779C44.1105 50.9695 44.1792 50.8651 44.287 50.8398C44.3858 50.8166 44.4878 50.8665 44.5278 50.9592C45.5481 53.3284 46.1143 56.6183 45.4097 59.9741C45.1668 61.1308 45.9139 62.2641 47.0783 62.5054C47.3257 62.5567 47.572 62.5635 47.8089 62.5315C48.6869 62.4126 49.4352 61.7588 49.6265 60.8478C50.4559 56.898 49.9199 53.0344 48.7746 50.0048C48.7096 49.8329 48.9021 49.6789 49.0578 49.7779C50.2742 50.551 51.6902 50.9872 53.1592 50.9825C53.5037 50.9814 53.8438 50.9578 54.1782 50.9126C56.3807 50.6146 58.3342 49.3755 59.6418 47.4137C60.2984 46.4285 60.0269 45.101 59.035 44.4486ZM31.7716 36.362C30.5536 36.5268 29.431 35.6746 29.2642 34.4583C29.0974 33.2421 29.9496 32.1227 31.1676 31.9578C32.3857 31.793 33.5083 32.6453 33.6751 33.8615C33.8418 35.0777 32.9896 36.1972 31.7716 36.362ZM47.0967 32.0453C45.8787 32.2102 44.7562 31.3579 44.5894 30.1417C44.4226 28.9256 45.2749 27.806 46.4929 27.6412C47.7109 27.4765 48.8335 28.3287 49.0002 29.5449C49.167 30.7611 48.3148 31.8806 47.0967 32.0453Z"
        fill="#6E54D7"
      />
    </g>
    <defs>
      <clipPath id="eoct_clip0_135_9309">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Gridly = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#grd_clip0_135_7945)">
      <mask
        id="grd_mask0_135_7945"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#grd_mask0_135_7945)">
        <mask
          id="grd_mask1_135_7945"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#grd_mask1_135_7945)">
          <mask
            id="grd_mask2_135_7945"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#grd_mask2_135_7945)">
            <mask
              id="grd_mask3_135_7945"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#grd_mask3_135_7945)">
              <mask
                id="grd_mask4_135_7945"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#grd_mask4_135_7945)">
                <mask
                  id="grd_mask5_135_7945"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#grd_mask5_135_7945)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="grd_mask6_135_7945"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#grd_mask6_135_7945)">
                  <mask
                    id="grd_mask7_135_7945"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#grd_mask7_135_7945)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="grd_mask8_135_7945"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#grd_mask8_135_7945)">
                    <mask
                      id="grd_mask9_135_7945"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#grd_mask9_135_7945)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.661 33.5932L51.2877 24.0897L45.561 27.6142V27.6209C44.0372 28.5064 43.0118 30.1563 43.0118 32.0467C43.0118 33.9933 44.0982 35.6855 45.6972 36.5503L48.2337 38.101L60.9996 46.0958L66.5858 42.6324C68.2222 41.7793 69.3402 40.0676 69.3402 38.0935C69.3402 36.1494 68.2566 34.4589 66.661 33.5932Z"
        fill="#FBAF17"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.9996 46.0957L48.2337 38.1008L39.7175 43.3355V57C39.723 57 39.728 57 39.7332 57C42.3393 57 44.7639 56.2273 46.7957 54.9023"
        fill="#E53182"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.6944 43.3498L33.2703 39.3871L18.1751 30.1428C16.2509 31.3474 14.3075 32.5263 12.4017 33.7603C10.9279 34.7144 10 36.3223 10 38.0933C10 40.0469 11.0946 41.7442 12.7033 42.6058C12.7033 42.6058 32.6589 54.896 32.6598 54.8951C34.69 56.2219 37.1128 56.9968 39.7176 56.9998V43.3354"
        fill="#9643DC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1751 30.1428L33.2711 39.3875L31.0757 38.0332L37.3101 34.2882V34.2843C38.7472 33.3787 39.7027 31.778 39.7027 29.9531C39.7027 28.128 38.7472 26.5275 37.3101 25.6219L31.412 22L18.2292 30.109L18.1751 30.1428Z"
        fill="#17C0FF"
      />
    </g>
    <defs>
      <clipPath id="grd_clip0_135_7945">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Mixmax = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#mxm_clip0_76_2800)">
      <mask
        id="mxm_mask0_76_2800"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#mxm_mask0_76_2800)">
        <mask
          id="mxm_mask1_76_2800"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#mxm_mask1_76_2800)">
          <mask
            id="mxm_mask2_76_2800"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#mxm_mask2_76_2800)">
            <mask
              id="mxm_mask3_76_2800"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#mxm_mask3_76_2800)">
              <mask
                id="mxm_mask4_76_2800"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#mxm_mask4_76_2800)">
                <mask
                  id="mxm_mask5_76_2800"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#mxm_mask5_76_2800)">
                  <mask
                    id="mxm_mask6_76_2800"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mxm_mask6_76_2800)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="mxm_mask7_76_2800"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mxm_mask7_76_2800)">
                    <mask
                      id="mxm_mask8_76_2800"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mxm_mask8_76_2800)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                    <mask
                      id="mxm_mask9_76_2800"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mxm_mask9_76_2800)">
                      <mask
                        id="mxm_mask10_76_2800"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="80"
                        height="80"
                      >
                        <path d="M80 0H0V80H80V0Z" fill="white" />
                      </mask>
                      <g mask="url(#mxm_mask10_76_2800)">
                        <path
                          d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                          fill="#F7F7F7"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1632 59.9999H15V20H25.1632V59.9999Z"
        fill="#C53FDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1632 59.9999H15L35.2677 20H45.4309L25.1632 59.9999Z"
        fill="#971AAE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.4314 60H35.2683V20.0002H45.4314V60Z"
        fill="#C53FDF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.4314 60H35.2683L55.536 20.0002H65.6991L45.4314 60Z"
        fill="#971AAE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.6986 60H55.5355V20.0002H65.6986V60Z"
        fill="#C53FDF"
      />
    </g>
    <defs>
      <clipPath id="mxm_clip0_76_2800">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ReplyIo = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#rpl_clip0_76_1736)">
      <mask
        id="rpl_mask0_76_1736"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#rpl_mask0_76_1736)">
        <mask
          id="rpl_mask1_76_1736"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#rpl_mask1_76_1736)">
          <mask
            id="rpl_mask2_76_1736"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#rpl_mask2_76_1736)">
            <mask
              id="rpl_mask3_76_1736"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#rpl_mask3_76_1736)">
              <mask
                id="rpl_mask4_76_1736"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#rpl_mask4_76_1736)">
                <mask
                  id="rpl_mask5_76_1736"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#rpl_mask5_76_1736)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="rpl_mask6_76_1736"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#rpl_mask6_76_1736)">
                  <mask
                    id="rpl_mask7_76_1736"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#rpl_mask7_76_1736)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="rpl_mask8_76_1736"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#rpl_mask8_76_1736)">
                    <mask
                      id="rpl_mask9_76_1736"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#rpl_mask9_76_1736)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M57.5654 41.2173C57.5654 44.348 57.2141 47.1304 56.5123 50.261C55.4588 54.7827 52.2992 57.9131 47.7352 58.9565C41.7668 60.3478 35.4474 60.3478 29.4791 58.9565C25.2662 57.9131 21.7554 54.4348 21.0532 50.261C20.3511 47.1304 20 44 20 41.2173C20 38.087 20.3511 35.3044 21.0532 32.1739C22.1065 27.6522 25.2662 24.5217 29.8302 23.4782C32.6388 22.7826 35.7985 22.4348 38.9582 22.4348C42.1178 22.4348 44.9265 22.7826 48.0861 23.4782C52.6501 24.5217 55.8101 27.6522 56.8632 32.1739C57.2141 34.9565 57.5654 38.087 57.5654 41.2173Z"
        fill="#80ADFD"
      />
      <path
        d="M50.4348 39.1305C55.7175 39.1305 60 34.848 60 29.5652C60 24.2825 55.7175 20 50.4348 20C45.1521 20 40.8696 24.2825 40.8696 29.5652C40.8696 34.848 45.1521 39.1305 50.4348 39.1305Z"
        fill="#005AFF"
      />
    </g>
    <defs>
      <clipPath id="rpl_clip0_76_1736">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LessAnnoyingCrm = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#lac_clip0_76_1516)">
      <mask
        id="lac_mask0_76_1516"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#lac_mask0_76_1516)">
        <mask
          id="lac_mask1_76_1516"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#lac_mask1_76_1516)">
          <mask
            id="lac_mask2_76_1516"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#lac_mask2_76_1516)">
            <mask
              id="lac_mask3_76_1516"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#lac_mask3_76_1516)">
              <mask
                id="lac_mask4_76_1516"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#lac_mask4_76_1516)">
                <mask
                  id="lac_mask5_76_1516"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#lac_mask5_76_1516)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="lac_mask6_76_1516"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#lac_mask6_76_1516)">
                  <mask
                    id="lac_mask7_76_1516"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#lac_mask7_76_1516)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="lac_mask8_76_1516"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#lac_mask8_76_1516)">
                    <mask
                      id="lac_mask9_76_1516"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#lac_mask9_76_1516)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.5276 25.5453C50.5875 25.604 50.6351 25.674 50.6676 25.7511C50.7001 25.8281 50.7168 25.9108 50.7168 25.9944C50.7168 26.0779 50.7001 26.1606 50.6676 26.2377C50.6351 26.3148 50.5875 26.3848 50.5276 26.4435L49.1671 27.775C49.0477 27.8919 48.8867 27.9575 48.7189 27.9575C48.5511 27.9575 48.39 27.8919 48.2707 27.775L40.7935 20.4604C40.5815 20.2551 40.2969 20.1402 40.0004 20.1402C39.704 20.1402 39.4193 20.2551 39.2073 20.4604L20.5362 38.7243C20.4321 38.8255 20.3494 38.9462 20.2929 39.0794C20.2365 39.2125 20.2074 39.3555 20.2074 39.5C20.2074 39.6445 20.2365 39.7875 20.2929 39.9207C20.3494 40.0538 20.4321 40.1745 20.5362 40.2757L39.2073 58.5409C39.6447 58.9704 40.3549 58.9704 40.7935 58.5409L59.4634 40.2757L59.4966 40.2428L61.8364 37.9524C62.1322 37.6631 62.6269 37.7288 62.7634 38.1179C63.0282 38.8695 63.0718 39.6802 62.8889 40.4553C62.706 41.2305 62.3042 41.938 61.7305 42.4954L43.0632 60.7593C42.2463 61.5545 41.1469 62 40.0017 62C38.8565 62 37.7571 61.5545 36.9402 60.7593L18.2678 42.4966C17.8663 42.1059 17.5474 41.6398 17.3298 41.1256C17.1121 40.6115 17 40.0595 17 39.5019C17 38.9443 17.1121 38.3923 17.3298 37.8782C17.5474 37.364 17.8663 36.8979 18.2678 36.5072L36.9389 18.2407C37.7558 17.4455 38.8552 17 40.0004 17C41.1456 17 42.245 17.4455 43.0619 18.2407L50.5276 25.5453ZM61.728 30.3548C61.7973 30.4223 61.8524 30.5028 61.89 30.5916C61.9276 30.6804 61.947 30.7758 61.947 30.8721C61.947 30.9684 61.9276 31.0638 61.89 31.1526C61.8524 31.2414 61.7973 31.3219 61.728 31.3894L40.7196 51.9413C40.5787 52.0794 40.3886 52.1568 40.1904 52.1568C39.9923 52.1568 39.8021 52.0794 39.6613 51.9413L36.3409 48.6932C36.2738 48.6267 36.2197 48.5483 36.1815 48.4621L27.4063 39.8777C27.337 39.8102 27.2819 39.7297 27.2443 39.6409C27.2067 39.5521 27.1873 39.4567 27.1873 39.3604C27.1873 39.2641 27.2067 39.1687 27.2443 39.0799C27.2819 38.9911 27.337 38.9106 27.4063 38.8431L30.728 35.5951C30.8688 35.4573 31.0586 35.3801 31.2565 35.3801C31.4543 35.3801 31.6442 35.4573 31.785 35.5951L40.2287 43.856L57.3493 27.1067C57.4902 26.9687 57.6803 26.8912 57.8785 26.8912C58.0766 26.8912 58.2668 26.9687 58.4076 27.1067L61.728 30.3548Z"
        fill="#486581"
      />
    </g>
    <defs>
      <clipPath id="lac_clip0_76_1516">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SnovIo = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#snv_clip0_76_2512)">
      <mask
        id="snv_mask0_76_2512"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#snv_mask0_76_2512)">
        <mask
          id="snv_mask1_76_2512"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#snv_mask1_76_2512)">
          <mask
            id="snv_mask2_76_2512"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#snv_mask2_76_2512)">
            <mask
              id="snv_mask3_76_2512"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#snv_mask3_76_2512)">
              <mask
                id="snv_mask4_76_2512"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#snv_mask4_76_2512)">
                <mask
                  id="snv_mask5_76_2512"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#snv_mask5_76_2512)">
                  <mask
                    id="snv_mask6_76_2512"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#snv_mask6_76_2512)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#856AEC"
                    />
                  </g>
                  <mask
                    id="snv_mask7_76_2512"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#snv_mask7_76_2512)">
                    <mask
                      id="snv_mask8_76_2512"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#snv_mask8_76_2512)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#856AEC"
                      />
                    </g>
                    <mask
                      id="snv_mask9_76_2512"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#snv_mask9_76_2512)">
                      <mask
                        id="snv_mask10_76_2512"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="80"
                        height="80"
                      >
                        <path d="M80 0H0V80H80V0Z" fill="white" />
                      </mask>
                      <g mask="url(#snv_mask10_76_2512)">
                        <path
                          d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                          fill="#856AEC"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M24 62.0455V52.5001C29.9429 55.2273 34.9714 56.591 38.6286 56.591C43.4285 56.591 45.7142 54.7728 45.7142 51.3637C45.7142 49.5456 44.5714 48.1819 42.5143 46.5909C41.6 45.9092 39.5429 44.7728 36.3428 43.4091C33.1428 42.0456 30.8571 40.6819 29.4857 39.3181C26.2857 36.5909 24.4571 32.9546 24.4571 28.8637C24.4571 24.7727 25.8286 21.3637 28.8 18.8636C31.7714 16.3636 35.8856 15 41.1428 15C45.4857 15 50.2857 16.1364 55.7715 18.4091L52.3429 26.3637C47.5428 24.5455 44.1142 23.4091 41.6 23.4091C39.0857 23.6364 37.2572 24.0909 36.3428 25C35.2 25.9091 34.7429 26.8182 34.7429 27.9546C34.7429 29.0909 34.9714 30 35.4286 30.6818C35.8856 31.3637 36.5715 32.0454 37.4857 32.7273C38.4001 33.4091 40.9143 34.5455 44.8001 36.5909C48.9143 38.4092 51.6571 40.4546 53.4858 42.7272C55.3143 45.0001 56 47.5 56 50.6818C56 55 54.4 58.6364 51.2 61.1363C48 63.6365 43.6572 65 38.1714 65C32.6857 65 28.1143 64.091 24 62.0455Z"
        fill="#F5F5FE"
      />
    </g>
    <defs>
      <clipPath id="snv_clip0_76_2512">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OnePageCrm = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#opc_clip0_76_1648)">
      <mask
        id="opc_mask0_76_1648"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#opc_mask0_76_1648)">
        <mask
          id="opc_mask1_76_1648"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#opc_mask1_76_1648)">
          <mask
            id="opc_mask2_76_1648"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#opc_mask2_76_1648)">
            <mask
              id="opc_mask3_76_1648"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#opc_mask3_76_1648)">
              <mask
                id="opc_mask4_76_1648"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#opc_mask4_76_1648)">
                <mask
                  id="opc_mask5_76_1648"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#opc_mask5_76_1648)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="opc_mask6_76_1648"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#opc_mask6_76_1648)">
                  <mask
                    id="opc_mask7_76_1648"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#opc_mask7_76_1648)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="opc_mask8_76_1648"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#opc_mask8_76_1648)">
                    <mask
                      id="opc_mask9_76_1648"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#opc_mask9_76_1648)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M20.8124 28.319C21.3537 24.4308 24.4231 21.3564 28.3043 20.8136C36.338 19.7288 44.4618 19.7288 52.4955 20.8136C56.377 21.3564 59.4459 24.4308 59.9876 28.319C61.0708 36.3664 61.0708 44.5042 59.9876 52.5518C59.4459 56.4402 56.377 59.5142 52.4955 60.0567C44.4618 61.1418 36.338 61.1418 28.3043 60.0567C24.4231 59.5142 21.354 56.4402 20.8124 52.5518C19.7292 44.4138 19.7292 36.3664 20.8124 28.319Z"
        fill="#FF9200"
      />
      <path
        d="M28.7043 44.7558C28.7043 45.1176 28.8848 45.4794 29.2458 45.5699L38.2722 49.3673C38.5432 49.4578 38.9041 49.4578 39.0847 49.277C39.2654 49.096 39.4457 48.8249 39.4457 48.5537V46.926C39.4457 46.5643 39.2654 46.2025 38.9043 46.112L29.8777 42.3146C29.6068 42.2241 29.2459 42.2241 29.0652 42.4048C28.8848 42.5858 28.7043 42.857 28.7043 43.1283V44.7558ZM28.7043 39.3306C28.7043 39.6923 28.8848 40.054 29.2458 40.1446L38.2722 43.9422C38.5432 44.0325 38.9041 44.0325 39.0847 43.8517C39.2654 43.6709 39.4457 43.3995 39.4457 43.1283V41.5005C39.4457 41.1389 39.2654 40.7772 38.9043 40.6869L29.8777 36.8893C29.6068 36.7987 29.2459 36.7987 29.0652 36.9796C28.8848 37.1604 28.7043 37.4317 28.7043 37.7031V39.3306ZM28.7043 33.9053C28.7043 34.267 28.8848 34.6288 29.2458 34.7191L38.2722 38.5168C38.5432 38.6072 38.9041 38.6072 39.0847 38.4263C39.2654 38.2456 39.4457 37.9743 39.4457 37.7031V36.0753C39.4457 35.7137 39.2654 35.3519 38.9043 35.2615L29.8777 31.4638C29.6068 31.3735 29.2459 31.3735 29.0652 31.5543C28.8848 31.735 28.7043 32.0064 28.7043 32.2776V33.9053ZM52.1733 44.7558C52.1733 45.1176 51.9927 45.4794 51.6315 45.5699L42.6051 49.3673C42.3341 49.4578 41.9732 49.4578 41.7927 49.277C41.6121 49.096 41.4316 48.8249 41.4316 48.5537V36.0753C41.4316 35.7137 41.6121 35.3519 41.9732 35.2615L50.9997 31.4638C51.2706 31.3735 51.6315 31.3735 51.8121 31.5543C51.9927 31.735 52.1733 32.0064 52.1733 32.2776V44.7558Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="opc_clip0_76_1648">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Lemlist = ({ ...props }) => (
  <svg
    {...props}
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#lml_clip0_161_2066)">
      <mask
        id="lml_mask0_161_2066"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#lml_mask0_161_2066)">
        <mask
          id="lml_mask1_161_2066"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="80"
          height="80"
        >
          <path d="M80 0H0V80H80V0Z" fill="white" />
        </mask>
        <g mask="url(#lml_mask1_161_2066)">
          <mask
            id="lml_mask2_161_2066"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            <path d="M80 0H0V80H80V0Z" fill="white" />
          </mask>
          <g mask="url(#lml_mask2_161_2066)">
            <mask
              id="lml_mask3_161_2066"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="80"
              height="80"
            >
              <path d="M80 0H0V80H80V0Z" fill="white" />
            </mask>
            <g mask="url(#lml_mask3_161_2066)">
              <mask
                id="lml_mask4_161_2066"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="80"
                height="80"
              >
                <path d="M80 0H0V80H80V0Z" fill="white" />
              </mask>
              <g mask="url(#lml_mask4_161_2066)">
                <mask
                  id="lml_mask5_161_2066"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#lml_mask5_161_2066)">
                  <path
                    d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                    fill="#F7F7F7"
                  />
                </g>
                <mask
                  id="lml_mask6_161_2066"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="80"
                  height="80"
                >
                  <path d="M80 0H0V80H80V0Z" fill="white" />
                </mask>
                <g mask="url(#lml_mask6_161_2066)">
                  <mask
                    id="lml_mask7_161_2066"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#lml_mask7_161_2066)">
                    <path
                      d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                      fill="#F7F7F7"
                    />
                  </g>
                  <mask
                    id="lml_mask8_161_2066"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="80"
                    height="80"
                  >
                    <path d="M80 0H0V80H80V0Z" fill="white" />
                  </mask>
                  <g mask="url(#lml_mask8_161_2066)">
                    <mask
                      id="lml_mask9_161_2066"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="80"
                      height="80"
                    >
                      <path d="M80 0H0V80H80V0Z" fill="white" />
                    </mask>
                    <g mask="url(#lml_mask9_161_2066)">
                      <path
                        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
                        fill="#F7F7F7"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <path
        d="M38.9072 38.2151H46.5693C47.1491 38.2151 47.6191 38.6852 47.6191 39.265V40.7366C47.6191 41.3165 47.1491 41.7866 46.5693 41.7866H38.9072C38.3274 41.7866 37.8573 41.3165 37.8573 40.7366V39.265C37.8573 38.6852 38.3274 38.2151 38.9072 38.2151Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.1228 20H52.8773C56.8111 20 60 23.189 60 27.1227V52.8771C60 56.8111 56.8111 60 52.8773 60H27.1228C23.189 60 20 56.8111 20 52.8771V27.1227C20 23.189 23.189 20 27.1228 20ZM46.5693 38.2151H38.9072C38.3274 38.2151 37.8573 38.6852 37.8573 39.265V40.7366C37.8573 41.3165 38.3274 41.7866 38.9072 41.7866H46.5693C47.1491 41.7866 47.6191 41.3165 47.6191 40.7366V39.265C47.6191 38.6852 47.1491 38.2151 46.5693 38.2151ZM38.9072 30.7144H48.2358C48.8155 30.7144 49.2855 31.1844 49.2855 31.7643V33.2359C49.2855 33.8158 48.8155 34.2858 48.2358 34.2858H38.9072C38.3274 34.2858 37.8573 33.8158 37.8573 33.2359V31.7643C37.8573 31.1844 38.3274 30.7144 38.9072 30.7144ZM49.2855 48.2358V46.764C49.2855 46.1845 48.8153 45.7142 48.2358 45.7142H37.0157C35.5071 45.7142 34.2858 44.4929 34.2858 42.9842V31.7643C34.2858 31.1847 33.8155 30.7144 33.2359 30.7144H31.7643C31.1848 30.7144 30.7144 31.1847 30.7144 31.7643V45.1731C30.8555 47.3807 32.6194 49.1445 34.8268 49.2856H48.2358C48.8153 49.2856 49.2855 48.8153 49.2855 48.2358Z"
        fill="#316BFF"
      />
      <path
        d="M38.9072 30.7144H48.2358C48.8155 30.7144 49.2855 31.1844 49.2855 31.7643V33.2359C49.2855 33.8158 48.8155 34.2858 48.2358 34.2858H38.9072C38.3274 34.2858 37.8573 33.8158 37.8573 33.2359V31.7643C37.8573 31.1844 38.3274 30.7144 38.9072 30.7144Z"
        fill="white"
      />
      <path
        d="M49.2855 46.764V48.2358C49.2855 48.8153 48.8153 49.2855 48.2357 49.2855H34.8268C32.6194 49.1444 30.8555 47.3807 30.7144 45.1731V31.7643C30.7144 31.1847 31.1847 30.7144 31.7643 30.7144H33.2359C33.8155 30.7144 34.2858 31.1847 34.2858 31.7643V42.9842C34.2858 44.4929 35.5071 45.7142 37.0157 45.7142H48.2357C48.8153 45.7142 49.2855 46.1844 49.2855 46.764Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="lml_clip0_161_2066">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AmazonSellerCentral = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_amazon_sc_webapp)">
      <mask
        id="mask0_amazon_sc_webapp"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M80 0H0V80H80V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_amazon_sc_webapp)">
        <path
          d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
          fill="#F7F7F7"
        />
        <path
          d="M29.4974 38.6043C29.4974 36.5802 30.0023 34.8495 31.012 33.4122C32.0216 31.9749 33.4026 30.8898 35.1547 30.1564C36.7582 29.4817 38.7333 28.998 41.0796 28.7042C41.8811 28.6163 43.1879 28.4989 44.9995 28.352V27.6041C44.9995 25.7268 44.7917 24.4656 44.3758 23.82C43.7521 22.9397 42.7724 22.5001 41.4357 22.5001H41.0796C40.0994 22.588 39.2529 22.896 38.5403 23.4238C37.8277 23.952 37.3671 24.685 37.1593 25.624C37.0405 26.2105 36.7438 26.5477 36.2685 26.6359L31.1455 26.0199C30.6407 25.9025 30.3883 25.6386 30.3883 25.2278C30.3883 25.1399 30.403 25.0371 30.4325 24.9201C30.9374 22.3095 32.1771 20.3736 34.1522 19.112C36.1269 17.8512 38.4362 17.1469 41.0796 17H42.1934C45.5781 17 48.2215 17.8654 50.1228 19.5961C50.4203 19.8907 50.6963 20.2066 50.9467 20.5418C51.1983 20.8789 51.3993 21.1799 51.5472 21.4438C51.696 21.7077 51.8299 22.0893 51.9484 22.5876C52.0676 23.0866 52.1561 23.4313 52.2163 23.6215C52.2754 23.8122 52.32 24.223 52.3495 24.854C52.379 25.4846 52.3938 25.8584 52.3938 25.9757V36.6239C52.3938 37.3865 52.5051 38.0832 52.728 38.7138C52.9509 39.3448 53.1666 39.7994 53.3736 40.0779C53.5813 40.3563 53.9235 40.8042 54.3984 41.4194C54.5766 41.6841 54.6656 41.9189 54.6656 42.1241C54.6656 42.3588 54.5471 42.5632 54.3087 42.7397C51.8443 44.8521 50.508 45.9963 50.2999 46.1724C49.9438 46.4363 49.5131 46.4654 49.0079 46.2602C48.5928 45.9077 48.2291 45.5709 47.9169 45.2479C47.6054 44.9257 47.3825 44.691 47.2485 44.5441C47.1153 44.3979 46.8996 44.1116 46.6029 43.6862C46.3062 43.2608 46.0973 42.9744 45.9792 42.8283C44.3164 44.6177 42.683 45.7324 41.0796 46.1724C40.0695 46.4654 38.8222 46.6123 37.3376 46.6123C35.0507 46.6123 33.1725 45.9152 31.7026 44.522C30.2324 43.1285 29.4974 41.1559 29.4974 38.6043ZM37.1593 37.724C37.1593 38.8682 37.4492 39.7848 38.0278 40.4741C38.6073 41.1634 39.3864 41.508 40.3666 41.508C40.4559 41.508 40.5819 41.4935 40.7454 41.4643C40.9081 41.4344 41.0198 41.4198 41.0796 41.4198C42.3265 41.0976 43.2916 40.3059 43.9746 39.0443C44.3016 38.487 44.5465 37.8784 44.71 37.2183C44.8735 36.5585 44.9624 36.0229 44.9771 35.612C44.9919 35.2016 44.9999 34.5269 44.9999 33.5883V32.4882C43.2772 32.4882 41.9708 32.6055 41.08 32.8403C38.4657 33.5733 37.1593 35.2012 37.1593 37.724Z"
          fill="black"
        />
        <path
          d="M55.8683 51.8923C55.9281 51.7745 56.017 51.6576 56.1362 51.5398C56.8783 51.0411 57.5909 50.7044 58.274 50.5283C59.4025 50.2353 60.5015 50.0738 61.5702 50.0442C61.8677 50.0143 62.1496 50.0296 62.4168 50.0879C63.7535 50.2049 64.5546 50.4255 64.8225 50.7481C64.941 50.9242 65 51.1881 65 51.5398V51.8482C65 52.8743 64.7181 54.0846 64.1542 55.4778C63.5896 56.871 62.8028 57.9935 61.7927 58.8443C61.6448 58.9613 61.5108 59.0196 61.3924 59.0196C61.3325 59.0196 61.2731 59.005 61.2141 58.9759C61.0359 58.888 60.9912 58.7265 61.0801 58.4918C62.1791 55.9398 62.7282 54.1654 62.7282 53.1673C62.7282 52.8451 62.6692 52.6104 62.5508 52.4634C62.2533 52.1117 61.4223 51.9356 60.0561 51.9356C59.5505 51.9356 58.9571 51.9648 58.274 52.0235C57.5319 52.1121 56.8488 52.1995 56.2248 52.2882C56.0465 52.2882 55.9281 52.2582 55.8679 52.1995C55.8088 52.1412 55.7937 52.0826 55.8236 52.0235C55.8236 51.9947 55.8383 51.9506 55.8683 51.8923ZM16.0889 51.1447C16.2377 50.91 16.4749 50.8954 16.8019 51.1002C24.2261 55.3537 32.304 57.4807 41.0345 57.4807C46.8557 57.4807 52.602 56.4097 58.274 54.2682C58.422 54.2099 58.6377 54.1221 58.9196 54.0043C59.2023 53.8873 59.4025 53.7991 59.521 53.7404C59.9664 53.5643 60.3153 53.6526 60.5677 54.0043C60.8209 54.3568 60.7392 54.679 60.3233 54.9721C59.7881 55.3537 59.105 55.7937 58.274 56.2924C55.7203 57.7887 52.8687 58.9471 49.7209 59.7687C46.5734 60.5904 43.4993 61.0004 40.5002 61.0004C35.8673 61.0004 31.4869 60.2012 27.3593 58.6025C23.2312 57.0037 19.5339 54.7519 16.2672 51.8486C16.0889 51.7017 16 51.5548 16 51.4082C16 51.32 16.0295 51.2322 16.0889 51.1447Z"
          fill="#FF9900"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_amazon_sc_webapp">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Groww = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_groww_developer_webapp)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      <path
        d="M44.6688 61.3909C56.7618 58.5349 64.2498 46.4209 61.3938 34.3309C58.5378 22.2409 46.4208 14.7529 34.3308 17.6059C22.2408 20.4619 14.7528 32.5789 17.6058 44.6689C20.4618 56.7589 32.5788 64.2469 44.6658 61.3909H44.6688Z"
        fill="#4E68FF"
      />
      <path
        d="M61.394 34.331C60.986 32.6 60.389 30.968 59.63 29.441L59.624 29.447L45.458 42.542C44.573 43.361 43.256 43.502 42.215 42.893L36.194 39.368C35.219 38.801 33.998 38.885 33.116 39.584C29.387 42.536 19.838 50.087 19.703 50.198C24.413 58.931 34.547 63.785 44.669 61.391C56.762 58.535 64.25 46.421 61.394 34.331Z"
        fill="#00F6B6"
      />
    </g>
    <defs>
      <clipPath id="clip0_groww_developer_webapp">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Dovetail = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_dovetail)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0754 45.0439C20.0525 45.0572 20.0334 45.0762 20.0202 45.0991C20.007 45.122 20 45.148 20 45.1744C20 45.2009 20.007 45.2269 20.0202 45.2498C20.0334 45.2727 20.0525 45.2917 20.0754 45.3049L29.4889 50.734C29.5346 50.7599 29.5726 50.7975 29.5987 50.8431C29.6249 50.8886 29.6383 50.9403 29.6376 50.9928V61.8487C29.6376 61.9657 29.7637 62.0377 29.8628 61.9792L39.2763 56.5501C39.3224 56.5241 39.3606 56.4861 39.3868 56.4401C39.413 56.3942 39.4262 56.342 39.425 56.2891V45.3499C39.4258 45.2974 39.4124 45.2457 39.3862 45.2002C39.36 45.1547 39.3221 45.117 39.2763 45.0912L29.6376 39.5338L20.0754 45.0439ZM20.0754 22.468C20.053 22.4814 20.0344 22.5004 20.0216 22.523C20.0087 22.5457 20.0019 22.5713 20.0019 22.5974C20.0019 22.6235 20.0087 22.6491 20.0216 22.6718C20.0344 22.6944 20.053 22.7134 20.0754 22.7268L29.4889 28.1559C29.535 28.1819 29.5731 28.2199 29.5993 28.2659C29.6255 28.3118 29.6387 28.364 29.6376 28.4169V39.5316L39.425 33.8842V22.7695C39.4258 22.717 39.4124 22.6653 39.3862 22.6198C39.36 22.5743 39.3221 22.5366 39.2763 22.5108L29.7885 17.0412C29.7432 17.0142 29.6914 17 29.6387 17C29.586 17 29.5342 17.0142 29.4889 17.0412L20.0754 22.468ZM39.425 33.8842L49.0638 39.4438C49.1099 39.4699 49.1481 39.5079 49.1742 39.5538C49.2004 39.5998 49.2136 39.652 49.2125 39.7048V50.5608C49.2125 50.6755 49.3386 50.7475 49.4377 50.6913L58.8513 45.2599C58.897 45.2341 58.9349 45.1964 58.9611 45.1509C58.9873 45.1054 59.0007 45.0537 58.9999 45.0012V34.0597C59.0011 34.0069 58.9879 33.9547 58.9617 33.9087C58.9355 33.8628 58.8973 33.8247 58.8513 33.7987L49.3634 28.3314C49.3181 28.3044 49.2663 28.2902 49.2136 28.2902C49.1609 28.2902 49.1091 28.3044 49.0638 28.3314L39.425 33.8842Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_dovetail">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// Refresh arrow with a dotted tail (from Figma). Uses `currentColor` so it inherits the
// caller's text color — e.g. blue on a subdued button, white on a solid primary button.
export const RefreshDotted = ({ ...props }) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M22.2892 8.51219L19.9122 12.6293C19.7795 12.8592 19.5609 13.027 19.3045 13.0957C19.0481 13.1644 18.7749 13.1284 18.545 12.9957L14.4279 10.6186L15.4287 8.8851L17.6108 10.1449C17.3358 8.96559 16.6795 7.90984 15.7437 7.14124C14.8079 6.37264 13.6448 5.93407 12.4345 5.89347C11.2242 5.85287 10.0342 6.21251 9.04904 6.91668C8.06383 7.62084 7.33831 8.63023 6.98488 9.7885L5.21667 8.76762C5.77164 7.28403 6.78171 6.01401 8.10232 5.13935C9.42293 4.26468 10.9864 3.83019 12.5689 3.89806C14.1515 3.96593 15.672 4.53268 16.9129 5.5172C18.1537 6.50173 19.0514 7.85355 19.4773 9.37921L20.5557 7.51133L22.2892 8.51219Z"
      fill="currentColor"
    />
    <path
      d="M9.43306 17.2687C9.91176 17.545 10.0758 18.1572 9.7994 18.6359C9.52302 19.1146 8.9109 19.2786 8.4322 19.0022C7.9535 18.7258 7.78948 18.1137 8.06586 17.635C8.34224 17.1563 8.95435 16.9923 9.43306 17.2687Z"
      fill="currentColor"
    />
    <path
      d="M12.9678 18.1532C13.4465 18.4295 13.6106 19.0416 13.3342 19.5204C13.0578 19.9991 12.4457 20.1631 11.967 19.8867C11.4883 19.6103 11.3243 18.9982 11.6006 18.5195C11.877 18.0408 12.4891 17.8768 12.9678 18.1532Z"
      fill="currentColor"
    />
    <path
      d="M6.48255 12.1C6.48255 12.6528 6.03445 13.1009 5.48169 13.1009C4.92893 13.1009 4.48084 12.6528 4.48084 12.1C4.48084 11.5473 4.92893 11.0992 5.48169 11.0992C6.03445 11.0992 6.48255 11.5473 6.48255 12.1Z"
      fill="currentColor"
    />
    <path
      d="M16.8843 18.1032C16.8843 18.6559 16.4362 19.104 15.8834 19.104C15.3307 19.104 14.8826 18.6559 14.8826 18.1032C14.8826 17.5504 15.3307 17.1023 15.8834 17.1023C16.4362 17.1023 16.8843 17.5504 16.8843 18.1032Z"
      fill="currentColor"
    />
    <path
      d="M7.26436 15.017C7.54074 15.4957 7.37672 16.1079 6.89802 16.3842C6.41932 16.6606 5.8072 16.4966 5.53082 16.0179C5.25445 15.5392 5.41846 14.9271 5.89716 14.6507C6.37587 14.3743 6.98798 14.5383 7.26436 15.017Z"
      fill="currentColor"
    />
  </Svg>
);

export const Motherduck = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_motherduck)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      <g clipPath="url(#clip1_motherduck)">
        <path
          d="M13.9157 47.7404C13.9157 47.7404 29.2646 58.4879 30.1978 59.0238C31.0988 59.5595 32.4181 59.6856 33.5765 59.2443C34.7348 58.8031 35.6037 57.7946 35.8611 56.7859C36.1508 55.7774 39.6581 37.6232 39.6581 37.6232C39.6903 37.371 39.7868 36.6461 39.4007 35.9527C38.8536 35.0072 37.6309 34.5029 36.5369 34.8181C35.6681 35.0702 35.2175 35.7006 35.0888 35.9212C34.8957 36.2679 34.5419 36.8352 33.8983 37.3395C33.4156 37.7177 32.9329 37.9384 32.7076 38.0329C30.7448 38.8208 28.5567 38.159 27.3018 36.5831C26.5294 35.606 25.1458 35.2279 23.9231 35.7006C22.7003 36.1734 21.9924 37.4026 22.0889 38.6318C22.3142 40.5858 21.1879 42.54 19.1929 43.3279C18.131 43.7376 17.0048 43.7376 16.0073 43.4225C15.782 43.3594 14.9776 43.1702 14.1731 43.6115C13.1756 44.1159 12.6608 45.3135 12.9182 46.3851C13.1113 47.11 13.6905 47.5828 13.9157 47.7404Z"
          fill="#FF9538"
        />
        <path
          d="M39.4974 24.1966C39.4974 24.1966 44.9677 41.9095 45.3538 42.8551C45.74 43.8321 46.7053 44.7146 47.8959 45.0613C49.0865 45.408 50.4057 45.1243 51.2424 44.4941C52.0791 43.8637 66.2052 31.6033 66.2052 31.6033C66.3983 31.4456 66.9131 30.9098 67.0418 30.1219C67.2027 29.0503 66.527 27.9157 65.4973 27.506C64.6606 27.1908 63.8884 27.4114 63.6631 27.506C63.3092 27.6636 62.6656 27.8842 61.8612 27.9157C61.2176 27.9472 60.7349 27.8211 60.4774 27.7581C58.4502 27.1908 57.0988 25.3628 57.0988 23.3771C57.0666 22.148 56.2299 21.0133 54.975 20.6666C53.6879 20.3199 52.3686 20.8557 51.6929 21.8958C50.631 23.5978 48.5394 24.4487 46.48 23.8814C45.386 23.5662 44.485 22.9044 43.9058 22.0534C43.7449 21.8643 43.2301 21.2339 42.329 21.0763C41.235 20.8872 40.0444 21.5176 39.594 22.4946C39.24 23.2511 39.4331 23.9445 39.4974 24.1966Z"
          fill="#FF9538"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_motherduck">
        <rect width="80" height="80" fill="white" />
      </clipPath>
      <clipPath id="clip1_motherduck">
        <rect width="56" height="40" fill="white" transform="translate(12 20)" />
      </clipPath>
    </defs>
  </svg>
);

export const Aurora = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Flattened from the export: it nested ten luminance masks that were all the full 80x80
        square (so no-ops) and painted the plate three times. Ids are namespaced because SVG ids
        are document-global once rendered. */}
    <g clipPath="url(#clip0_aurora)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.0378 22.924H41.6521V21.3544H44.0378V19H45.6282V21.3544H48.0139V22.924H45.6282V25.2784H44.0378V22.924ZM53.5805 31.5568H51.1948V29.9872H53.5805V27.6328H55.171V29.9872H57.5567V31.5568H55.171V33.9112H53.5805V31.5568ZM49.439 56.3595C47.9201 52.5752 44.4147 49.1158 40.5785 47.6161C44.4147 46.1171 47.9201 42.6577 49.439 38.8726C50.9579 42.6577 54.4632 46.1171 58.2986 47.6161C54.4632 49.1158 50.9579 52.5752 49.439 56.3595ZM62.2048 46.8313C56.6111 46.8313 50.2342 40.538 50.2342 35.0177C50.2342 34.5845 49.8787 34.2329 49.439 34.2329C48.9992 34.2329 48.6437 34.5845 48.6437 35.0177C48.6437 40.538 42.266 46.8313 36.6724 46.8313C36.2334 46.8313 35.8771 47.1829 35.8771 47.6161C35.8771 48.0501 36.2334 48.4009 36.6724 48.4009C42.266 48.4009 48.6437 54.6942 48.6437 60.2152C48.6437 60.6484 48.9992 61 49.439 61C49.8787 61 50.2342 60.6484 50.2342 60.2152C50.2342 54.6942 56.6111 48.4009 62.2048 48.4009C62.6437 48.4009 63 48.0501 63 47.6161C63 47.1829 62.6437 46.8313 62.2048 46.8313ZM18.5905 31.3692C20.9062 33.0314 25.4056 33.9112 29.7237 33.9112C34.0417 33.9112 38.5412 33.0314 40.8569 31.3692V38.886C39.7109 40.3897 35.497 41.8714 29.8827 41.8714C23.4199 41.8714 18.5905 39.878 18.5905 38.0957V31.3692ZM29.7237 25.2784C36.6215 25.2784 40.8569 27.3353 40.8569 28.81C40.8569 30.2846 36.6215 32.3416 29.7237 32.3416C22.8258 32.3416 18.5905 30.2846 18.5905 28.81C18.5905 27.3353 22.8258 25.2784 29.7237 25.2784ZM40.8569 54.7326C40.8569 56.5416 36.0942 58.5656 29.7197 58.5656C23.3499 58.5656 18.5905 56.5416 18.5905 54.7326V49.7178C20.9348 51.4726 25.5241 52.4018 29.928 52.4018C32.9905 52.4018 35.9519 51.9748 38.2636 51.1994L37.7531 49.713C35.6012 50.4343 32.8219 50.8322 29.928 50.8322C23.439 50.8322 18.5905 48.8388 18.5905 47.0565V40.7616C20.9284 42.5133 25.4978 43.4409 29.8827 43.4409C34.5809 43.4409 38.6103 42.4858 40.8569 40.9735V43.3287H42.4473V28.81C42.4473 25.4966 35.8922 23.7088 29.7237 23.7088C23.8064 23.7088 17.5487 25.3584 17.0493 28.4176H17V54.7326C17 58.2414 23.5535 60.1352 29.7197 60.1352C35.8899 60.1352 42.4473 58.2414 42.4473 54.7326V51.9615H40.8569V54.7326Z"
        fill="#4052D5"
      />
    </g>
    <defs>
      <clipPath id="clip0_aurora">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CloudSql = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_cloudsql)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      {/* Google ships this as a bare 512x512 mark with no plate. The art is centred on
          (256, 256.5) with a half-extent of 202, so recentre and scale it to sit inside the
          plate. Paths are painted in source order -- they overlap deliberately, so reordering
          them changes the artwork. */}
      <g transform="translate(40, 40) scale(0.1188) translate(-256, -256.5)">
        <path
          fill="#FBBC04"
          d="M447.5,123.7l-186-68.7c-3.6-1.3-7.5-1.3-11.1,0l-40.7,15-145.2,53.5c-6.3,2.3-10.5,8.3-10.5,15s4.2,12.7,10.5,15l145.1,53.4s0,0,0,0l40.8,15c1.8.6,3.7,1,5.5,1s3.7-.3,5.5-1l185.9-68.2c6.3-2.3,10.5-8.3,10.5-15,0-6.7-4.2-12.7-10.5-15h0ZM256,189.9l-139.6-51.4,139.6-51.4,139.7,51.6-139.6,51.2Z"
        />
        <path
          fill="#34A853"
          d="M447.5,388.8l-185.9,68.2c-1.8.6-3.6,1-5.5,1s-3.7-.3-5.5-1l-40.8-15h0l-145.1-53.4c-8.3-3-12.5-12.2-9.5-20.5,3-8.3,12.2-12.5,20.5-9.5l180.4,66.4,180.4-66.2c8.3-3,17.5,1.2,20.5,9.5,3,8.3-1.2,17.5-9.5,20.5h0Z"
        />
        <path
          fill="#34A853"
          d="M447.5,310.4l-185.9,68.2c-1.8.6-3.6,1-5.5,1s-3.7-.3-5.5-1l-40.8-15h0l-145.1-53.4c-8.3-3-12.5-12.2-9.5-20.5,3-8.3,12.2-12.5,20.5-9.5l180.4,66.4,180.4-66.2c8.3-3,17.5,1.2,20.5,9.5,3,8.3-1.2,17.5-9.5,20.5h0Z"
        />
        <path
          fill="#34A853"
          d="M447.5,232.1l-185.9,68.2c-1.8.7-3.6,1-5.5,1s-3.7-.3-5.5-1l-40.8-15h0l-145.1-53.4c-8.3-3.1-12.5-12.2-9.5-20.5,3-8.3,12.2-12.5,20.5-9.5l180.4,66.4,180.4-66.2c8.3-3,17.5,1.2,20.5,9.5,3,8.3-1.2,17.5-9.5,20.5h0Z"
        />
        <path
          fill="#EA4335"
          d="M458,138.7c0,6.7-4.2,12.7-10.5,15l-186,68.2c-1.8.7-3.6,1-5.5,1s-3.7-.3-5.5-1l-40.8-15h0s46.4-17,46.4-17l139.6-51.2-139.7-51.6-46.2-17.1,40.7-15c3.6-1.3,7.5-1.3,11.1,0l186,68.7c6.3,2.3,10.5,8.3,10.5,15h0Z"
        />
        <path
          fill="#4285F4"
          d="M447.5,388.8l-185.9,68.2c-1.8.6-3.6,1-5.5,1s-3.7-.3-5.5-1l-40.8-15,46.4-17,180.4-66.2c8.3-3,17.5,1.2,20.5,9.5,3,8.3-1.2,17.5-9.5,20.5h0Z"
        />
        <path
          fill="#4285F4"
          d="M447.5,310.4l-185.9,68.2c-1.8.6-3.6,1-5.5,1s-3.7-.3-5.5-1l-40.8-15h0l46.4-17,180.4-66.2c8.3-3,17.5,1.2,20.5,9.5,3,8.3-1.2,17.5-9.5,20.5Z"
        />
        <path
          fill="#4285F4"
          d="M447.5,232.1l-185.9,68.2c-1.8.7-3.6,1-5.5,1s-3.7-.3-5.5-1l-40.8-15h0l46.4-17,180.4-66.2c8.3-3,17.5,1.2,20.5,9.5,3,8.3-1.2,17.5-9.5,20.5h0Z"
        />
        <path
          fill="#FBBC04"
          d="M302.4,206.9l-186-68.5-51.8-15c-6.3,2.3-10.5,8.3-10.5,15s4.2,12.7,10.5,15l145.1,53.4s0,0,0,0l40.8,15c1.8.6,3.7,1,5.5,1s3.7-.3,5.5-1l40.9-15h0Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_cloudsql">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Supabase = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      {/* Ids namespaced: SVG ids are document-global once rendered. */}
      <linearGradient
        id="supabase_fill"
        x1="53.9738"
        y1="54.974"
        x2="94.1635"
        y2="71.8295"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#249361" />
        <stop offset="1" stopColor="#3ECF8E" />
      </linearGradient>
      <linearGradient
        id="supabase_shadow"
        x1="36.1558"
        y1="30.578"
        x2="54.4844"
        y2="65.0806"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
    </defs>
    <g clipPath="url(#clip0_supabase)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      <g transform="translate(40, 40) scale(0.425) translate(-54.5, -56.5)">
        <path
          d="M63.7076 110.284C60.8481 113.885 55.0502 111.912 54.9813 107.314L53.9738 40.0627L99.1935 40.0627C107.384 40.0627 111.952 49.5228 106.859 55.9374L63.7076 110.284Z"
          fill="url(#supabase_fill)"
        />
        <path
          d="M63.7076 110.284C60.8481 113.885 55.0502 111.912 54.9813 107.314L53.9738 40.0627L99.1935 40.0627C107.384 40.0627 111.952 49.5228 106.859 55.9374L63.7076 110.284Z"
          fill="url(#supabase_shadow)"
          fillOpacity="0.2"
        />
        <path
          d="M45.317 2.07103C48.1765 -1.53037 53.9745 0.442937 54.0434 5.041L54.4849 72.2922H9.83113C1.64038 72.2922 -2.92775 62.8321 2.1655 56.4175L45.317 2.07103Z"
          fill="#3ECF8E"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_supabase">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Neon = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <linearGradient id="neon_glow" x1="100%" x2="12.069%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#62F755" />
        <stop offset="100%" stopColor="#8FF986" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="neon_shade" x1="100%" x2="40.603%" y1="100%" y2="76.897%">
        <stop offset="0%" stopOpacity=".9" />
        <stop offset="100%" stopColor="#1A1A1A" stopOpacity="0" />
      </linearGradient>
    </defs>
    <g clipPath="url(#clip0_neon)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      <g transform="translate(40, 40) scale(0.1875) translate(-128, -128)">
        <path
          d="M0 44.139C0 19.762 19.762 0 44.139 0H211.86C236.238 0 256 19.762 256 44.139v142.649c0 25.216-31.915 36.16-47.388 16.256l-48.392-62.251v75.484c0 21.939-17.784 39.723-39.722 39.723h-76.36C19.763 256 0 236.238 0 211.861V44.14Zm44.139-8.825c-4.879 0-8.825 3.946-8.825 8.818v167.73c0 4.878 3.946 8.831 8.818 8.831h77.688c2.44 0 3.087-1.977 3.087-4.416v-101.22c0-25.222 31.914-36.166 47.395-16.255l48.391 62.243V44.14c0-4.879.455-8.825-4.416-8.825H44.14Z"
          fill="#00E0D9"
        />
        <path
          d="M0 44.139C0 19.762 19.762 0 44.139 0H211.86C236.238 0 256 19.762 256 44.139v142.649c0 25.216-31.915 36.16-47.388 16.256l-48.392-62.251v75.484c0 21.939-17.784 39.723-39.722 39.723h-76.36C19.763 256 0 236.238 0 211.861V44.14Zm44.139-8.825c-4.879 0-8.825 3.946-8.825 8.818v167.73c0 4.878 3.946 8.831 8.818 8.831h77.688c2.44 0 3.087-1.977 3.087-4.416v-101.22c0-25.222 31.914-36.166 47.395-16.255l48.391 62.243V44.14c0-4.879.455-8.825-4.416-8.825H44.14Z"
          fill="url(#neon_glow)"
        />
        <path
          d="M0 44.139C0 19.762 19.762 0 44.139 0H211.86C236.238 0 256 19.762 256 44.139v142.649c0 25.216-31.915 36.16-47.388 16.256l-48.392-62.251v75.484c0 21.939-17.784 39.723-39.722 39.723h-76.36C19.763 256 0 236.238 0 211.861V44.14Zm44.139-8.825c-4.879 0-8.825 3.946-8.825 8.818v167.73c0 4.878 3.946 8.831 8.818 8.831h77.688c2.44 0 3.087-1.977 3.087-4.416v-101.22c0-25.222 31.914-36.166 47.395-16.255l48.391 62.243V44.14c0-4.879.455-8.825-4.416-8.825H44.14Z"
          fill="url(#neon_shade)"
          fillOpacity=".4"
        />
        <path
          d="M211.861 0C236.238 0 256 19.762 256 44.139v142.649c0 25.216-31.915 36.16-47.388 16.256l-48.392-62.251v75.484c0 21.939-17.784 39.723-39.722 39.723a4.409 4.409 0 0 0 4.409-4.409V115.058c0-25.223 31.914-36.167 47.395-16.256l48.391 62.243V8.825c0-4.871-3.953-8.825-8.832-8.825Z"
          fill="#63F655"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_neon">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Timescaledb = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_timescaledb)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#F7F7F7"
      />
      <g transform="translate(40, 40) scale(2) translate(-12, -12)">
        <path
          d="M5.537.763c-1.167.7-2.21 1.582-3.08 2.61L3.79 4.836a10.422 10.422 0 013.627-2.881zm13.028.085l-1.991 1.12a10.381 10.381 0 013.762 3.07l1.18-1.654a12.371 12.371 0 00-2.95-2.536zm-6.564.752a9.788 9.788 0 00-4.131.91l.59 1.011a8.542 8.542 0 013.541-.762c1.261 0 2.457.274 3.534.76l.59-1.012a9.81 9.81 0 00-4.124-.907zM11.4 3.535l-.55 6.626h.003l-.002.04c.003.111.013.216.033.318.01.112.043.227.097.342.114.289.298.505.516.607.05.04.105.075.158.111a.98.98 0 01.033.02v.004l6.68 3.596.348-.476-6.058-4.6c-.007 0-.01-.005-.014-.008L12 3.535zm1.423.052c.19.234.361.523.502.855 3.155.604 5.54 3.325 5.54 6.596 0 .877-.176 1.712-.484 2.48a3.7 3.7 0 01.52.76 7.314 7.314 0 00.754-3.24c0-3.868-2.99-7.05-6.832-7.45zm-2.284.095c-3.527.667-6.19 3.708-6.19 7.356 0 2.584 1.335 4.863 3.367 6.21a9.84 9.84 0 01.295-.743c-1.74-1.219-2.874-3.214-2.874-5.467 0-3.054 2.082-5.632 4.932-6.45.128-.351.289-.656.47-.906zm9.15 1.675l-.801.893a8.101 8.101 0 011.551 4.777c0 2.916-1.542 5.481-3.872 6.952.104.388.188.792.251 1.209 2.87-1.632 4.802-4.677 4.802-8.16a9.224 9.224 0 00-1.93-5.67zm-15.38.007a9.25 9.25 0 00-1.93 5.665c0 3.507 1.954 6.567 4.858 8.19.063-.418.144-.822.248-1.206-2.36-1.468-3.923-4.045-3.923-6.984 0-1.777.573-3.422 1.549-4.772zm9.314.043c.044.203.08.416.107.64a5.332 5.332 0 013.213 2.912l.577-.148a5.942 5.942 0 00-3.897-3.404zm-3.816.187a5.939 5.939 0 00-3.319 3.198l.58.148A5.324 5.324 0 019.73 6.257c.017-.227.04-.45.077-.663zM6.733 9.672l-.62.63.315.614 1.727.618.942-.618-.312-.923zm10.615 0l-2.048.321-.315.923.942.618 1.73-.618.315-.614zM6.1 11.869A5.824 5.824 0 008.42 15.7c.1-.17.204-.335.315-.493a5.252 5.252 0 01-2.038-3.34zm11.206 0c-.03.18-.071.355-.118.529.174.138.338.272.493.41.097-.302.174-.617.22-.94zm-15.679.217L0 14.158c.966 3.661 3.638 6.65 7.132 8.111a9.399 9.399 0 01-.05-1.031c0-.375.017-.747.05-1.111-3.024-1.563-5.166-4.544-5.505-8.041zm20.707.055c-.352 3.45-2.464 6.394-5.441 7.957.033.374.05.755.053 1.136 0 .377-.017.71-.05 1.005 3.506-1.488 6.175-4.522 7.104-8.223zm-6.544 2.617a5.31 5.31 0 01-.486.42c.11.158.218.322.318.493.265-.2.513-.42.74-.66a10.61 10.61 0 01-.572-.253zm1.502.559a6.9 6.9 0 01-1.25 1.156c.106.236.207.485.294.741a7.667 7.667 0 001.857-1.772 3.554 3.554 0 01-.9-.125zm-2.988.63l-2.303.913-2.307-.91-.587 1.435 2.448.946c-.134.46-.568.798-1.08.798-.034 0-.07-.004-.104-.007l-.5.686c.188.063.39.096.6.096.621 0 1.17-.289 1.52-.738a1.924 1.924 0 002.183.62l-.49-.67a1.122 1.122 0 01-1.26-.805l2.47-.926zm1.156 4.775c-1.09.377-2.256.58-3.476.58-1.17 0-2.29-.186-3.34-.534.231.88.59 1.654 1.05 2.262.743.134 1.509.207 2.294.207.835 0 1.65-.082 2.437-.236.453-.61.807-1.39 1.035-2.28z"
          fill="#FDB515"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_timescaledb">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// PLACEHOLDER: the Azure "A" chevron in Azure blue. Replace with the official brand asset before
// launch. All three Azure connectors share one mark, the same way Aurora's Postgres and MySQL
// variants do. Gradient ids are file-global in SVG, so they are namespaced.
export const Azure = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <linearGradient
        id="coeff_azure_grad_a"
        x1="30"
        y1="14"
        x2="14"
        y2="60"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#114A8B" />
        <stop offset="1" stopColor="#0669BC" />
      </linearGradient>
      <linearGradient
        id="coeff_azure_grad_b"
        x1="47"
        y1="14"
        x2="66"
        y2="60"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3CCBF4" />
        <stop offset="1" stopColor="#2892DF" />
      </linearGradient>
    </defs>
    <path
      d="M32.4 14h14.2L31.9 57.4a2.3 2.3 0 0 1-2.2 1.6H12.6a2.3 2.3 0 0 1-2.1-3L30.2 15.6A2.3 2.3 0 0 1 32.4 14Z"
      fill="url(#coeff_azure_grad_a)"
    />
    <path
      d="M52.9 44.5H30.4a1.1 1.1 0 0 0-.7 1.8l14.4 13.5c.2.2.5.3.8.3h13.9L52.9 44.5Z"
      fill="#0078D4"
    />
    <path
      d="M47.6 14H32.2l-21.7 45a2.3 2.3 0 0 0 2.1 3.2h4.1l31.3-46.6A2.3 2.3 0 0 0 47.6 14Z"
      fill="url(#coeff_azure_grad_b)"
      opacity="0.6"
    />
    <path
      d="M49.8 15.6A2.3 2.3 0 0 0 47.6 14H32.6a2.3 2.3 0 0 1 2.2 1.6L54.5 56a2.3 2.3 0 0 1-2.1 3h16.9a2.3 2.3 0 0 0 2.1-3L49.8 15.6Z"
      fill="url(#coeff_azure_grad_b)"
    />
  </svg>
);

export const Clickhouse = ({ ...props }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_clickhouse)">
      {/* ClickHouse brand yellow rather than the neutral plate the other connectors use: the
          mark itself is near-black, and yellow is the brand's whole identity. */}
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#FAFF69"
      />
      {/* Extracted from the supplied wordmark, which was 585x103 and included the
          "ClickHouse" letterforms. Only the five bars of the mark are kept; they span
          x 31-130 / y 44-151, so recentre on (80.7, 97.3) and scale onto the plate. */}
      <g transform="translate(40, 40) scale(0.4499) translate(-80.7, -97.3)">
        <path
          fill="#1E1E1E"
          d="m32.2 48.8c0-.7.5-1.2 1.2-1.2h9c.7 0 1.2.5 1.2 1.2v100.7c0 .7-.5 1.2-1.2 1.2h-9c-.7 0-1.2-.5-1.2-1.2zm22.9 0c0-.7.5-1.2 1.2-1.2h9c.7 0 1.2.5 1.2 1.2v100.7c0 .7-.5 1.2-1.2 1.2h-9c-.7 0-1.2-.5-1.2-1.2zm22.9 0c0-.7.5-1.2 1.2-1.2h9c.7 0 1.2.5 1.2 1.2v100.7c0 .7-.5 1.2-1.2 1.2h-9c-.7 0-1.2-.5-1.2-1.2zm22.9 0c0-.7.5-1.2 1.2-1.2h9c.7 0 1.2.5 1.2 1.2v100.7c0 .7-.5 1.2-1.2 1.2h-9c-.7 0-1.2-.5-1.2-1.2zm22.9 40.1c0-.7.5-1.2 1.2-1.2h9c.7 0 1.2.5 1.2 1.2v20.5c0 .7-.5 1.2-1.2 1.2h-9c-.7 0-1.2-.5-1.2-1.2z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_clickhouse">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
